import * as i0 from '@angular/core';
import { Input, ViewEncapsulation, ChangeDetectionStrategy, Component, InjectionToken, Optional, Inject, Directive, EventEmitter, ContentChild, Output, ContentChildren, NgModule, ViewChild, Pipe, QueryList, HostListener, Self, forwardRef, inject, ChangeDetectorRef, HostBinding, input, model, Injector, numberAttribute, booleanAttribute, Injectable, ElementRef, ViewContainerRef, computed, TemplateRef, LOCALE_ID, ANIMATION_MODULE_TYPE as ANIMATION_MODULE_TYPE$1, ViewChildren, Renderer2 } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
export { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
export { MatSidenavModule } from '@angular/material/sidenav';
import { MatTableModule } from '@angular/material/table';
export { MatTableModule } from '@angular/material/table';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import * as i1 from '@angular/common';
import { CommonModule, DOCUMENT, getLocaleCurrencyCode, getLocaleCurrencyName, getLocaleCurrencySymbol, formatCurrency, DatePipe, ViewportScroller } from '@angular/common';
import { coerceNumberProperty, coerceElement, coerceBooleanProperty } from '@angular/cdk/coercion';
import { SPACE, ENTER, DOWN_ARROW, UP_ARROW, ESCAPE, LEFT_ARROW, RIGHT_ARROW, END, HOME } from '@angular/cdk/keycodes';
import * as i1$c from '@angular/animations';
import { trigger, state, transition, style, animate } from '@angular/animations';
import { ANIMATION_MODULE_TYPE } from '@angular/platform-browser/animations';
import * as i1$2 from '@angular/cdk/a11y';
import { isFakeMousedownFromScreenReader, A11yModule, CdkMonitorFocus } from '@angular/cdk/a11y';
import * as i1$1 from '@angular/cdk/platform';
import { normalizePassiveListenerOptions, PlatformModule } from '@angular/cdk/platform';
import * as i1$3 from '@ngx-translate/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { fromEvent, merge, Subject, filter as filter$1, take, BehaviorSubject, Subscription, tap, takeUntil as takeUntil$1, of, Observable, range, map as map$1 } from 'rxjs';
import { mapTo, switchMap, takeUntil, filter, take as take$1, tap as tap$1, startWith, debounceTime, map, toArray, delay } from 'rxjs/operators';
import * as i2 from '@angular/cdk/portal';
import { TemplatePortal, ComponentPortal, TemplatePortalDirective, PortalModule, CdkPortal, PortalInjector } from '@angular/cdk/portal';
import * as i1$4 from '@angular/forms';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormsModule, NgControl, FormControl, ReactiveFormsModule, UntypedFormGroup, UntypedFormControl, Validators, FormControlName, FormGroupDirective, NgModel, FormGroup } from '@angular/forms';
import * as i1$5 from '@angular/cdk/overlay';
import { OverlayModule, Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { Clipboard } from '@angular/cdk/clipboard';
import { __decorate, __param } from 'tslib';
import * as i1$9 from '@angular/cdk/scrolling';
import { CdkScrollableModule } from '@angular/cdk/scrolling';
import * as i5 from '@angular/cdk/drag-drop';
import { moveItemInArray, DragDropModule } from '@angular/cdk/drag-drop';
import * as uuid from 'uuid';
import * as i1$6 from '@angular-slider/ngx-slider';
import { NgxSliderModule, LabelType, Options } from '@angular-slider/ngx-slider';
import moment from 'moment';
import 'moment/locale/fr';
import * as _ from 'lodash';
import * as i1$7 from '@angular/common/http';
import * as i3 from 'ngx-image-cropper';
import { base64ToFile, ImageCropperModule } from 'ngx-image-cropper';
import * as i1$8 from '@angular/platform-browser';
import * as i1$a from '@angular/cdk/layout';
import { Breakpoints } from '@angular/cdk/layout';
import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';
import { CdkStepperNext, CdkStepperPrevious, CdkStepHeader, CdkStep, CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';
import { _RecycleViewRepeaterStrategy, _VIEW_REPEATER_STRATEGY, _DisposeViewRepeaterStrategy } from '@angular/cdk/collections';
export { SelectionModel } from '@angular/cdk/collections';
import * as i1$b from '@angular/cdk/table';
import { CdkTable, CDK_TABLE, _CoalescedStyleScheduler, _COALESCED_STYLE_SCHEDULER, CDK_TABLE_TEMPLATE, CdkRowDef, CdkRow, CDK_ROW_TEMPLATE, CdkFooterRowDef, CdkFooterRow, CdkHeaderRowDef, CdkHeaderRow, CdkCellDef, CdkCell, CdkColumnDef, CdkHeaderCellDef, CdkHeaderCell, CdkFooterCellDef, CdkFooterCell, CdkTableModule } from '@angular/cdk/table';
import * as i1$d from '@angular/router';

class CnetIconComponent {
    get name() { return this._name; }
    set name(value) {
        this._name = value;
    }
    get label() { return this._label; }
    set label(value) {
        this._label = value;
    }
    get size() { return this._size; }
    set size(value) {
        this._size = Math.max(1, Math.min(10, coerceNumberProperty(value)));
    }
    get color() { return this._color; }
    set color(value) {
        this._color = value;
    }
    get _className() {
        return `la-${this.name}`;
    }
    get _classSize() {
        if (this.size) {
            return `la-${this.size}x`;
        }
        else {
            return 'la-default-size';
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetIconComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetIconComponent, selector: "cnet-icon", inputs: { name: "name", label: "label", size: "size", color: "color" }, host: { attributes: { "role": "img" }, properties: { "attr.aria-label": "label", "attr.color": "color" }, classAttribute: "cnet-icon" }, exportAs: ["cnetIcon"], ngImport: i0, template: "<i class=\"la\" [ngClass]=\"[_className, _classSize]\"></i>\n", styles: [".cnet-icon{display:inline-flex}.cnet-icon[color=primary]{color:var(--cnet-primary-500, #82c14f)}.cnet-icon[color=secondary]{color:var(--cnet-secondary-500, #3d4155)}.cnet-icon[color=danger]{color:var(--cnet-danger-500, #ee4446)}.cnet-icon[color=success]{color:var(--cnet-success-500, #47ba65)}.cnet-icon[color=cancel]{color:var(--cnet-cancel-500, #9e9e9e)}.cnet-icon i.la-default-size{font-size:1.375rem}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-icon', exportAs: 'cnetIcon', host: {
                        class: 'cnet-icon',
                        role: 'img',
                        '[attr.aria-label]': 'label',
                        '[attr.color]': 'color'
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<i class=\"la\" [ngClass]=\"[_className, _classSize]\"></i>\n", styles: [".cnet-icon{display:inline-flex}.cnet-icon[color=primary]{color:var(--cnet-primary-500, #82c14f)}.cnet-icon[color=secondary]{color:var(--cnet-secondary-500, #3d4155)}.cnet-icon[color=danger]{color:var(--cnet-danger-500, #ee4446)}.cnet-icon[color=success]{color:var(--cnet-success-500, #47ba65)}.cnet-icon[color=cancel]{color:var(--cnet-cancel-500, #9e9e9e)}.cnet-icon i.la-default-size{font-size:1.375rem}\n"] }]
        }], propDecorators: { name: [{
                type: Input
            }], label: [{
                type: Input
            }], size: [{
                type: Input
            }], color: [{
                type: Input
            }] } });

/** The Cnet Accordion header is a header for accordion panels. */
class CnetAccordionPanelHeaderComponent {
    constructor() {
        this.showIcon = true;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAccordionPanelHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetAccordionPanelHeaderComponent, selector: "cnet-accordion-panel-header, [cnet-accordion-panel-header], [cnetAccordionPanelHeader]", host: { classAttribute: "cnet-accordion-panel-header" }, exportAs: ["cnetAccordionPanelHeader"], ngImport: i0, template: "<div class=\"cnet-accordion-header-content\">\n    <ng-content></ng-content>\n</div>\n<span class=\"cnet-accordion-indicator\" aria-hidden=\"true\" *ngIf=\"showIcon\">\n    <cnet-icon name=\"angle-down\" size=\"sm\"></cnet-icon>\n</span>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAccordionPanelHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-accordion-panel-header, [cnet-accordion-panel-header], [cnetAccordionPanelHeader]', exportAs: 'cnetAccordionPanelHeader', host: {
                        class: 'cnet-accordion-panel-header'
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<div class=\"cnet-accordion-header-content\">\n    <ng-content></ng-content>\n</div>\n<span class=\"cnet-accordion-indicator\" aria-hidden=\"true\" *ngIf=\"showIcon\">\n    <cnet-icon name=\"angle-down\" size=\"sm\"></cnet-icon>\n</span>\n" }]
        }] });

const accordionToggleAnimation = trigger('toggle', [
    state('true', style({ height: '*', margin: '*', paddingTop: '*', paddingBottom: '*', visibility: 'visible' })),
    state('false', style({ height: '0px', margin: '0', paddingTop: '0', paddingBottom: '0', visibility: 'hidden' })),
    transition('false <=> true', animate('250ms ease-out'))
]);

const stepTransitionAnimation = trigger('transition', [
    state('true', style({ height: '*', visibility: 'visible' })),
    state('false', style({ height: '0px', visibility: 'hidden' })),
    transition('false <=> true', animate('250ms ease-out'))
]);

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Reference to a previously launched ripple element.
 */
class RippleRef {
    constructor(_renderer, 
    /** Reference to the ripple HTML element. */
    element, 
    /** Ripple configuration used for the ripple. */
    config) {
        this._renderer = _renderer;
        this.element = element;
        this.config = config;
        /** Current state of the ripple. */
        this.state = 3 /* RippleState.HIDDEN */;
    }
    /** Fades out the ripple element. */
    fadeOut() {
        this._renderer.fadeOutRipple(this);
    }
}

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
class RippleConfig {
}
/**
 * Interface that describes the configuration for the animation of a ripple.
 * There are two animation phases with different durations for the ripples.
 */
class RippleAnimationConfig {
}
/**
 * Interface that describes the target for launching ripples.
 * It defines the ripple configuration and disabled state for interaction ripples.
 * @docs-private
 */
class RippleTarget {
}
/**
 * Default ripple animation configuration for ripples without an explicit
 * animation config specified.
 */
const defaultRippleAnimationConfig = {
    enterDuration: 450,
    exitDuration: 400
};
/**
 * Timeout for ignoring mouse events. Mouse events will be temporary ignored after touch
 * events to avoid synthetic mouse events.
 */
const ignoreMouseEventsTimeout = 800;
/** Options that apply to all the event listeners that are bound by the ripple renderer. */
const passiveEventOptions = normalizePassiveListenerOptions({ passive: true });
/**
 * Helper service that performs DOM manipulations. Not intended to be used outside this module.
 * The constructor takes a reference to the ripple directive's host element and a map of DOM
 * event handlers to be installed on the element that triggers ripple animations.
 * This will eventually become a custom renderer once Angular support exists.
 * @docs-private
 */
class RippleRenderer {
    constructor(_target, _ngZone, elementOrElementRef, platform) {
        this._target = _target;
        this._ngZone = _ngZone;
        /** Whether the pointer is currently down or not. */
        this._isPointerDown = false;
        /** Events to be registered on the trigger element. */
        this._triggerEvents = new Map();
        /** Set of currently active ripple references. */
        this._activeRipples = new Set();
        /** Function being called whenever the trigger is being pressed using mouse. */
        this._onMousedown = (event) => {
            // Screen readers will fire fake mouse events for space/enter. Skip launching a
            // ripple in this case for consistency with the non-screen-reader experience.
            const isFakeMousedown = isFakeMousedownFromScreenReader(event);
            const isSyntheticEvent = this._lastTouchStartEvent &&
                Date.now() < this._lastTouchStartEvent + ignoreMouseEventsTimeout;
            if (!this._target.rippleDisabled && !isFakeMousedown && !isSyntheticEvent) {
                this._isPointerDown = true;
                this.fadeInRipple(event.clientX, event.clientY, this._target.rippleConfig);
            }
        };
        /** Function being called whenever the trigger is being pressed using touch. */
        this._onTouchStart = (event) => {
            if (!this._target.rippleDisabled) {
                // Some browsers fire mouse events after a `touchstart` event. Those synthetic mouse
                // events will launch a second ripple if we don't ignore mouse events for a specific
                // time after a touchstart event.
                this._lastTouchStartEvent = Date.now();
                this._isPointerDown = true;
                // Use `changedTouches` so we skip any touches where the user put
                // their finger down, but used another finger to tap the element again.
                const touches = event.changedTouches;
                for (let i = 0; i < touches.length; i++) {
                    this.fadeInRipple(touches[i].clientX, touches[i].clientY, this._target.rippleConfig);
                }
            }
        };
        /** Function being called whenever the trigger is being released. */
        this._onPointerUp = () => {
            if (!this._isPointerDown) {
                return;
            }
            this._isPointerDown = false;
            // Fade-out all ripples that are visible and not persistent.
            this._activeRipples.forEach(ripple => {
                // By default, only ripples that are completely visible will fade out on pointer release.
                // If the `terminateOnPointerUp` option is set, ripples that still fade in will also fade out.
                const isVisible = ripple.state === 1 /* RippleState.VISIBLE */ ||
                    ripple.config.terminateOnPointerUp && ripple.state === 0 /* RippleState.FADING_IN */;
                if (!ripple.config.persistent && isVisible) {
                    ripple.fadeOut();
                }
            });
        };
        // Only do anything if we're on the browser.
        if (platform.isBrowser) {
            this._containerElement = coerceElement(elementOrElementRef);
            // Specify events which need to be registered on the trigger.
            this._triggerEvents
                .set('mousedown', this._onMousedown)
                .set('mouseup', this._onPointerUp)
                .set('mouseleave', this._onPointerUp)
                .set('touchstart', this._onTouchStart)
                .set('touchend', this._onPointerUp)
                .set('touchcancel', this._onPointerUp);
        }
    }
    /**
     * Fades in a ripple at the given coordinates.
     * param x Coordinate within the element, along the X axis at which to start the ripple.
     * param y Coordinate within the element, along the Y axis at which to start the ripple.
     * param config Extra ripple options.
     */
    fadeInRipple(x, y, config = {}) {
        const containerRect = this._containerRect =
            this._containerRect || this._containerElement.getBoundingClientRect();
        const animationConfig = { ...defaultRippleAnimationConfig, ...config.animation };
        if (config.centered) {
            x = containerRect.left + containerRect.width / 2;
            y = containerRect.top + containerRect.height / 2;
        }
        const radius = config.radius || distanceToFurthestCorner(x, y, containerRect);
        const offsetX = x - containerRect.left;
        const offsetY = y - containerRect.top;
        const duration = animationConfig.enterDuration;
        const ripple = document.createElement('div');
        ripple.classList.add('cnet-ripple-element');
        ripple.style.left = `${offsetX - radius}px`;
        ripple.style.top = `${offsetY - radius}px`;
        ripple.style.height = `${radius * 2}px`;
        ripple.style.width = `${radius * 2}px`;
        // If a custom color has been specified, set it as inline style. If no color is
        // set, the default color will be applied through the ripple theme styles.
        if (config.color != null) {
            ripple.style.backgroundColor = config.color;
        }
        ripple.style.transitionDuration = `${duration}ms`;
        this._containerElement.appendChild(ripple);
        // By default the browser does not recalculate the styles of dynamically created
        // ripple elements. This is critical because then the `scale` would not animate properly.
        enforceStyleRecalculation(ripple);
        ripple.style.transform = 'scale(1)';
        // Exposed reference to the ripple that will be returned.
        const rippleRef = new RippleRef(this, ripple, config);
        rippleRef.state = 0 /* RippleState.FADING_IN */;
        // Add the ripple reference to the list of all active ripples.
        this._activeRipples.add(rippleRef);
        if (!config.persistent) {
            this._mostRecentTransientRipple = rippleRef;
        }
        // Wait for the ripple element to be completely faded in.
        // Once it's faded in, the ripple can be hidden immediately if the mouse is released.
        this._runTimeoutOutsideZone(() => {
            const isMostRecentTransientRipple = rippleRef === this._mostRecentTransientRipple;
            rippleRef.state = 1 /* RippleState.VISIBLE */;
            // When the timer runs out while the user has kept their pointer down, we want to
            // keep only the persistent ripples and the latest transient ripple. We do this,
            // because we don't want stacked transient ripples to appear after their enter
            // animation has finished.
            if (!config.persistent && (!isMostRecentTransientRipple || !this._isPointerDown)) {
                rippleRef.fadeOut();
            }
        }, duration);
        return rippleRef;
    }
    /** Fades out a ripple reference. */
    fadeOutRipple(rippleRef) {
        const wasActive = this._activeRipples.delete(rippleRef);
        if (rippleRef === this._mostRecentTransientRipple) {
            this._mostRecentTransientRipple = null;
        }
        // Clear out the cached bounding rect if we have no more ripples.
        if (!this._activeRipples.size) {
            this._containerRect = null;
        }
        // For ripples that are not active anymore, don't re-run the fade-out animation.
        if (!wasActive) {
            return;
        }
        const rippleEl = rippleRef.element;
        const animationConfig = { ...defaultRippleAnimationConfig, ...rippleRef.config.animation };
        rippleEl.style.transitionDuration = `${animationConfig.exitDuration}ms`;
        rippleEl.style.opacity = '0';
        rippleRef.state = 2 /* RippleState.FADING_OUT */;
        // Once the ripple faded out, the ripple can be safely removed from the DOM.
        this._runTimeoutOutsideZone(() => {
            rippleRef.state = 3 /* RippleState.HIDDEN */;
            rippleEl.parentNode.removeChild(rippleEl);
        }, animationConfig.exitDuration);
    }
    /** Fades out all currently active ripples. */
    fadeOutAll() {
        this._activeRipples.forEach(ripple => ripple.fadeOut());
    }
    /** Sets up the trigger event listeners */
    setupTriggerEvents(elementOrElementRef) {
        const element = coerceElement(elementOrElementRef);
        if (!element || element === this._triggerElement) {
            return;
        }
        // Remove all previously registered event listeners from the trigger element.
        this._removeTriggerEvents();
        this._ngZone.runOutsideAngular(() => {
            this._triggerEvents.forEach((fn, type) => {
                element.addEventListener(type, fn, passiveEventOptions);
            });
        });
        this._triggerElement = element;
    }
    /** Runs a timeout outside of the Angular zone to avoid triggering the change detection. */
    _runTimeoutOutsideZone(fn, delay = 0) {
        this._ngZone.runOutsideAngular(() => setTimeout(fn, delay));
    }
    /** Removes previously registered event listeners from the trigger element. */
    _removeTriggerEvents() {
        if (this._triggerElement) {
            this._triggerEvents.forEach((fn, type) => {
                this._triggerElement.removeEventListener(type, fn, passiveEventOptions);
            });
        }
    }
}
/** Enforces a style recalculation of a DOM element by computing its styles. */
function enforceStyleRecalculation(element) {
    // Enforce a style recalculation by calling `getComputedStyle` and accessing any property.
    // Calling `getPropertyValue` is important to let optimizers know that this is not a noop.
    // See: https://gist.github.com/paulirish/5d52fb081b3570c81e3a
    window.getComputedStyle(element).getPropertyValue('opacity');
}
/**
 * Returns the distance from the point (x, y) to the furthest corner of a rectangle.
 */
function distanceToFurthestCorner(x, y, rect) {
    const distX = Math.max(Math.abs(x - rect.left), Math.abs(x - rect.right));
    const distY = Math.max(Math.abs(y - rect.top), Math.abs(y - rect.bottom));
    return Math.sqrt(distX * distX + distY * distY);
}

/** Injection token that can be used to specify the global ripple options. */
const CNET_RIPPLE_GLOBAL_OPTIONS = new InjectionToken('cnet-ripple-global-options');
class CnetRippleDirective {
    /**
     * Whether click events will not trigger the ripple. Ripples can be still launched manually
     * by using the `launch()` method.
     */
    get disabled() { return this._disabled; }
    set disabled(value) {
        this._disabled = value;
        this._setupTriggerEventsIfEnabled();
    }
    /**
     * The element that triggers the ripple when click events are received.
     * Defaults to the directive's host element.
     */
    get trigger() { return this._trigger || this._elementRef.nativeElement; }
    set trigger(trigger) {
        this._trigger = trigger;
        this._setupTriggerEventsIfEnabled();
    }
    constructor(_elementRef, ngZone, platform, globalOptions, animationMode) {
        this._elementRef = _elementRef;
        /**
         * If set, the radius in pixels of foreground ripples when fully expanded. If unset, the radius
         * will be the distance from the center of the ripple to the furthest corner of the host element's
         * bounding rectangle.
         */
        this.radius = 0;
        this._disabled = false;
        /** Whether ripple directive is initialized and the input bindings are set. */
        this._isInitialized = false;
        this._globalOptions = globalOptions || {};
        this._rippleRenderer = new RippleRenderer(this, ngZone, _elementRef, platform);
        if (animationMode === 'NoopAnimations') {
            this._globalOptions.animation = { enterDuration: 0, exitDuration: 0 };
        }
    }
    ngOnInit() {
        this._isInitialized = true;
        this._setupTriggerEventsIfEnabled();
    }
    ngOnDestroy() {
        this._rippleRenderer._removeTriggerEvents();
    }
    /** Fades out all currently showing ripple elements. */
    fadeOutAll() {
        this._rippleRenderer.fadeOutAll();
    }
    /**
     * Ripple configuration from the directive's input values.
     * @docs-private Implemented as part of RippleTarget
     */
    get rippleConfig() {
        return {
            centered: this.centered,
            radius: this.radius,
            color: this.color,
            animation: { ...this._globalOptions.animation, ...this.animation },
            terminateOnPointerUp: this._globalOptions.terminateOnPointerUp,
        };
    }
    /**
     * Whether ripples on pointer-down are disabled or not.
     * @docs-private Implemented as part of RippleTarget
     */
    get rippleDisabled() {
        return this.disabled || !!this._globalOptions.disabled;
    }
    /** Sets up the trigger event listeners if ripples are enabled. */
    _setupTriggerEventsIfEnabled() {
        if (!this.disabled && this._isInitialized) {
            this._rippleRenderer.setupTriggerEvents(this.trigger);
        }
    }
    /** Launches a manual ripple at the specified coordinated or just by the ripple config. */
    launch(configOrX, y = 0, config) {
        if (typeof configOrX === 'number') {
            return this._rippleRenderer.fadeInRipple(configOrX, y, { ...this.rippleConfig, ...config });
        }
        else {
            return this._rippleRenderer.fadeInRipple(0, 0, { ...this.rippleConfig, ...configOrX });
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetRippleDirective, deps: [{ token: i0.ElementRef }, { token: i0.NgZone }, { token: i1$1.Platform }, { token: CNET_RIPPLE_GLOBAL_OPTIONS, optional: true }, { token: ANIMATION_MODULE_TYPE, optional: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetRippleDirective, selector: "[cnet-ripple], [cnetRipple]", inputs: { color: ["cnetRippleColor", "color"], unbounded: ["cnetRippleUnbounded", "unbounded"], centered: ["cnetRippleCentered", "centered"], radius: ["cnetRippleRadius", "radius"], animation: ["cnetRippleAnimation", "animation"], disabled: ["cnetRippleDisabled", "disabled"], trigger: ["cnetRippleTrigger", "trigger"] }, host: { properties: { "class.cnet-ripple-unbounded": "unbounded" }, classAttribute: "cnet-ripple" }, exportAs: ["cnetRipple"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetRippleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnet-ripple], [cnetRipple]',
                    exportAs: 'cnetRipple',
                    host: {
                        class: 'cnet-ripple',
                        '[class.cnet-ripple-unbounded]': 'unbounded'
                    }
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.NgZone }, { type: i1$1.Platform }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [CNET_RIPPLE_GLOBAL_OPTIONS]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [ANIMATION_MODULE_TYPE]
                }] }], propDecorators: { color: [{
                type: Input,
                args: ['cnetRippleColor']
            }], unbounded: [{
                type: Input,
                args: ['cnetRippleUnbounded']
            }], centered: [{
                type: Input,
                args: ['cnetRippleCentered']
            }], radius: [{
                type: Input,
                args: ['cnetRippleRadius']
            }], animation: [{
                type: Input,
                args: ['cnetRippleAnimation']
            }], disabled: [{
                type: Input,
                args: ['cnetRippleDisabled']
            }], trigger: [{
                type: Input,
                args: ['cnetRippleTrigger']
            }] } });

let nextUniqueId$m = 0;
/** Cnet Accordion Panel is a collapsible content for Cnet Accordion. */
class CnetAccordionPanelComponent {
    get id() { return this._id; }
    set id(value) { this._id = value; }
    get isOpen() { return this._isOpen; }
    set isOpen(isOpen) {
        this._isOpen = isOpen;
        if (isOpen) {
            this.onToggle();
        }
    }
    constructor(cdr, elementRef) {
        this.cdr = cdr;
        this.elementRef = elementRef;
        /** @ignore */ this._id = `cnet-accordion-panel-${nextUniqueId$m++}`;
        /** Emits when the panel is clicked. */
        this.toggleEmitter = new EventEmitter();
        /** Whether the panel is expanded. */
        this.expanded = false;
        this._isOpen = false;
        this.istogglable = true;
    }
    ngAfterContentInit() {
        if (this.header) {
            this.header.showIcon = this.istogglable;
        }
    }
    /** @ignore */
    onToggle() {
        this.toggleEmitter.next(this);
    }
    /** @ignore */
    toggle() {
        if (this.isOpen && !this.expanded) {
            this.expanded = !this.expanded;
            this.cdr.markForCheck();
        }
        else {
            if (this.istogglable) {
                this.expanded = !this.expanded;
                this.cdr.markForCheck();
            }
        }
        // //se isOpen e expanded = está aberto
        // if (this.isCloseable && !(this.isOpen && this.expanded)) {
        // }
        // if (this.isCloseable) {
        //   this.expanded = !this.expanded;
        //   this.cdr.markForCheck();
        // }
        // this.expanded = !this.expanded;
        // this.cdr.markForCheck();
    }
    /** @ignore */
    close() {
        this.expanded = false;
        this.cdr.markForCheck();
    }
    /** @ignore */
    onKeyUp(event) {
        if (event.keyCode === SPACE || event.keyCode === ENTER) {
            event.preventDefault();
            this.onToggle();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAccordionPanelComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetAccordionPanelComponent, selector: "cnet-accordion-panel, [cnet-accordion-panel], [cnetAccordionPanel]", inputs: { id: "id", isOpen: "isOpen", istogglable: "istogglable" }, outputs: { toggleEmitter: "toggleEmitter" }, host: { properties: { "class.cnet-accordion-panel-expanded": "expanded" }, classAttribute: "cnet-accordion-panel" }, queries: [{ propertyName: "header", first: true, predicate: CnetAccordionPanelHeaderComponent, descendants: true }], exportAs: ["cnetAccordionPanel"], ngImport: i0, template: "<div role=\"button\" \n    tabindex=\"0\"\n    cnetRipple\n    cdkMonitorElementFocus\n    [attr.aria-expanded]=\"expanded\" \n    (click)=\"onToggle()\"\n    (keydown)=\"onKeyUp($event)\">\n    <ng-content select=\"cnet-accordion-panel-header, [cnet-accordion-panel-header], [cnetAccordionPanelHeader]\"></ng-content>\n</div>\n<div role=\"region\" class=\"cnet-accordion-panel-content\" [@toggle]=\"expanded\">\n    <ng-content></ng-content>\n</div>", dependencies: [{ kind: "directive", type: CnetRippleDirective, selector: "[cnet-ripple], [cnetRipple]", inputs: ["cnetRippleColor", "cnetRippleUnbounded", "cnetRippleCentered", "cnetRippleRadius", "cnetRippleAnimation", "cnetRippleDisabled", "cnetRippleTrigger"], exportAs: ["cnetRipple"] }, { kind: "directive", type: i1$2.CdkMonitorFocus, selector: "[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]", outputs: ["cdkFocusChange"], exportAs: ["cdkMonitorFocus"] }], animations: [accordionToggleAnimation], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAccordionPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-accordion-panel, [cnet-accordion-panel], [cnetAccordionPanel]', exportAs: 'cnetAccordionPanel', host: {
                        class: 'cnet-accordion-panel',
                        '[class.cnet-accordion-panel-expanded]': 'expanded'
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, animations: [accordionToggleAnimation], template: "<div role=\"button\" \n    tabindex=\"0\"\n    cnetRipple\n    cdkMonitorElementFocus\n    [attr.aria-expanded]=\"expanded\" \n    (click)=\"onToggle()\"\n    (keydown)=\"onKeyUp($event)\">\n    <ng-content select=\"cnet-accordion-panel-header, [cnet-accordion-panel-header], [cnetAccordionPanelHeader]\"></ng-content>\n</div>\n<div role=\"region\" class=\"cnet-accordion-panel-content\" [@toggle]=\"expanded\">\n    <ng-content></ng-content>\n</div>" }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }], propDecorators: { id: [{
                type: Input
            }], toggleEmitter: [{
                type: Output
            }], header: [{
                type: ContentChild,
                args: [CnetAccordionPanelHeaderComponent]
            }], isOpen: [{
                type: Input
            }], istogglable: [{
                type: Input
            }] } });

var CnetAccordionMode;
(function (CnetAccordionMode) {
    CnetAccordionMode["Single"] = "single";
    CnetAccordionMode["Multiple"] = "multiple";
})(CnetAccordionMode || (CnetAccordionMode = {}));
let nextUniqueId$l = 0;
/** Cnet Accordion is a collection of collapsible panels. */
class CnetAccordionComponent {
    get id() { return this._id; }
    set id(value) { this._id = value; }
    constructor(elementRef) {
        this.elementRef = elementRef;
        /** @ignore */ this._id = `cnet-accordion-${nextUniqueId$l++}`;
        /** Accordion mode ('single' or 'multiple') */
        this.mode = CnetAccordionMode.Single;
        /** Expanded panels */
        this.expandedPanels = [];
    }
    /** @ignore */
    ngAfterViewInit() {
        setTimeout(() => {
            this.items.forEach(item => {
                item.toggleEmitter.subscribe(accordionItem => {
                    this.toggle(accordionItem);
                });
            });
            this.items.forEach(item => {
                if (item.isOpen) {
                    item.onToggle();
                }
            });
        }, 0);
    }
    /** Expands or collapses a panel */
    toggle(panel) {
        if (this.mode === CnetAccordionMode.Single) {
            if (panel === this.expandedPanels[0]) {
                this.expandedPanels = [];
            }
            else {
                this.expandedPanels = [panel];
            }
            panel.toggle();
            this.items
                .filter(accordionItem => accordionItem !== this.expandedPanels[0])
                .map(accordionItem => accordionItem.close());
        }
        else {
            this.expandedPanels.push(panel);
            panel.toggle();
        }
    }
    collapseAllPanels() {
        this.items.forEach(panel => {
            if (panel.expanded) {
                this.toggle(panel);
            }
        });
    }
    expandAllPanels() {
        this.items.forEach(panel => {
            if (!panel.expanded) {
                this.toggle(panel);
            }
        });
    }
    hasOpenPanel() {
        if (this.items?.length) {
            return this.items.some(panel => panel.expanded);
        }
        else {
            return false;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAccordionComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetAccordionComponent, selector: "cnet-accordion, [cnet-accordion], [cnetAccordion]", inputs: { id: "id", mode: "mode", color: "color" }, host: { properties: { "class.cnet-accordion-primary": "color == \"primary\"", "class.cnet-accordion-secondary": "color == \"secondary\"", "class.cnet-accordion-danger": "color == \"danger\"", "class.cnet-accordion-default": "color == null" }, classAttribute: "cnet-accordion" }, queries: [{ propertyName: "items", predicate: CnetAccordionPanelComponent }], exportAs: ["cnetAccordion"], ngImport: i0, template: "<ng-content select=\"cnet-accordion-panel, [cnet-accordion-panel], [cnetAccordionPanel]\"></ng-content>", styles: [".cnet-accordion{overflow:hidden;display:block}.cnet-accordion-panel{display:flex;flex-direction:column;overflow:hidden;margin:4px 0}.cnet-accordion-panel-header{display:flex;align-items:center;justify-content:space-between;padding:.25rem 0;border-radius:.25rem;cursor:pointer;transition:background-color ease .2s}.cnet-accordion-panel-content{padding:1rem;color:#000000d9}.cnet-accordion-indicator{display:inline-flex;transition:transform ease-in-out .3s}.cnet-accordion-panel-expanded .cnet-accordion-indicator{transform:rotate(180deg)}.cnet-accordion-primary .cnet-accordion-panel-header{padding:.5rem .75rem;background-color:var(--cnet-primary-500, #82c14f);color:var(--cnet-primary-contrast-500, white)}.cnet-accordion-primary .cnet-accordion-panel-header:hover{background-color:var(--cnet-primary-600, #7abb48)}.cnet-accordion-secondary{color:var(--cnet-secondary-contrast-500, white)}.cnet-accordion-secondary .cnet-accordion-panel-header{padding:.5rem .75rem;background-color:var(--cnet-secondary-500, #3d4155)}.cnet-accordion-secondary .cnet-accordion-panel-header:hover{background-color:var(--cnet-secondary-600, #373b4e)}.cnet-accordion-danger .cnet-accordion-panel-header{padding:.5rem .75rem;background-color:var(--cnet-danger-500, #ee4446);color:var(--cnet-danger-contrast-500, white)}.cnet-accordion-danger .cnet-accordion-panel-header:hover{background-color:var(--cnet-danger-600, #ec3e3f)}.cnet-accordion-default .cnet-accordion-panel-header{padding:.5rem .75rem;background-color:var(--cnet-default-200, #eeeeee);color:var(--cnet-default-contrast-200, rgba(0, 0, 0, .85))}.cnet-accordion-default .cnet-accordion-panel-header:hover{background-color:var(--cnet-default-300, #e0e0e0)}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAccordionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-accordion, [cnet-accordion], [cnetAccordion]', exportAs: 'cnetAccordion', host: {
                        class: 'cnet-accordion',
                        '[class.cnet-accordion-primary]': 'color == "primary"',
                        '[class.cnet-accordion-secondary]': 'color == "secondary"',
                        '[class.cnet-accordion-danger]': 'color == "danger"',
                        '[class.cnet-accordion-default]': 'color == null'
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<ng-content select=\"cnet-accordion-panel, [cnet-accordion-panel], [cnetAccordionPanel]\"></ng-content>", styles: [".cnet-accordion{overflow:hidden;display:block}.cnet-accordion-panel{display:flex;flex-direction:column;overflow:hidden;margin:4px 0}.cnet-accordion-panel-header{display:flex;align-items:center;justify-content:space-between;padding:.25rem 0;border-radius:.25rem;cursor:pointer;transition:background-color ease .2s}.cnet-accordion-panel-content{padding:1rem;color:#000000d9}.cnet-accordion-indicator{display:inline-flex;transition:transform ease-in-out .3s}.cnet-accordion-panel-expanded .cnet-accordion-indicator{transform:rotate(180deg)}.cnet-accordion-primary .cnet-accordion-panel-header{padding:.5rem .75rem;background-color:var(--cnet-primary-500, #82c14f);color:var(--cnet-primary-contrast-500, white)}.cnet-accordion-primary .cnet-accordion-panel-header:hover{background-color:var(--cnet-primary-600, #7abb48)}.cnet-accordion-secondary{color:var(--cnet-secondary-contrast-500, white)}.cnet-accordion-secondary .cnet-accordion-panel-header{padding:.5rem .75rem;background-color:var(--cnet-secondary-500, #3d4155)}.cnet-accordion-secondary .cnet-accordion-panel-header:hover{background-color:var(--cnet-secondary-600, #373b4e)}.cnet-accordion-danger .cnet-accordion-panel-header{padding:.5rem .75rem;background-color:var(--cnet-danger-500, #ee4446);color:var(--cnet-danger-contrast-500, white)}.cnet-accordion-danger .cnet-accordion-panel-header:hover{background-color:var(--cnet-danger-600, #ec3e3f)}.cnet-accordion-default .cnet-accordion-panel-header{padding:.5rem .75rem;background-color:var(--cnet-default-200, #eeeeee);color:var(--cnet-default-contrast-200, rgba(0, 0, 0, .85))}.cnet-accordion-default .cnet-accordion-panel-header:hover{background-color:var(--cnet-default-300, #e0e0e0)}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { id: [{
                type: Input
            }], items: [{
                type: ContentChildren,
                args: [CnetAccordionPanelComponent]
            }], mode: [{
                type: Input
            }], color: [{
                type: Input
            }] } });

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
class CnetRippleModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetRippleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetRippleModule, declarations: [CnetRippleDirective], imports: [PlatformModule], exports: [CnetRippleDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetRippleModule, imports: [PlatformModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetRippleModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [PlatformModule],
                    exports: [CnetRippleDirective],
                    declarations: [CnetRippleDirective],
                }]
        }] });

class CnetDividerComponent {
    constructor() {
        this._vertical = false;
    }
    get vertical() { return this._vertical; }
    set vertical(value) { this._vertical = coerceBooleanProperty(value); }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDividerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetDividerComponent, selector: "cnet-divider, [cnet-divider], cnetDivider", inputs: { vertical: "vertical" }, host: { attributes: { "role": "separator" }, properties: { "class.cnet-divider-vertical": "vertical" }, classAttribute: "cnet-divider" }, exportAs: ["cnetDivider"], ngImport: i0, template: '', isInline: true, styles: [".cnet-divider{display:block;margin:0;border-top-width:1px;border-top-style:solid;border-color:#e0e0e0}.cnet-divider.cnet-divider-vertical{border-top:0;border-right-width:1px;border-right-style:solid}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDividerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-divider, [cnet-divider], cnetDivider', exportAs: 'cnetDivider', host: {
                        class: 'cnet-divider',
                        '[class.cnet-divider-vertical]': 'vertical',
                        'role': 'separator'
                    }, template: '', changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, styles: [".cnet-divider{display:block;margin:0;border-top-width:1px;border-top-style:solid;border-color:#e0e0e0}.cnet-divider.cnet-divider-vertical{border-top:0;border-right-width:1px;border-right-style:solid}\n"] }]
        }], propDecorators: { vertical: [{
                type: Input
            }] } });

class CnetDividerModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDividerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetDividerModule, declarations: [CnetDividerComponent], imports: [CommonModule], exports: [CnetDividerComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDividerModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDividerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetDividerComponent],
                    imports: [
                        CommonModule
                    ],
                    exports: [CnetDividerComponent]
                }]
        }] });

class CnetIconModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetIconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetIconModule, declarations: [CnetIconComponent], imports: [CommonModule], exports: [CnetIconComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetIconModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetIconModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnetIconComponent
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        CnetIconComponent
                    ]
                }]
        }] });

class CnetAccordionModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAccordionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetAccordionModule, declarations: [CnetAccordionComponent, CnetAccordionPanelComponent, CnetAccordionPanelHeaderComponent], imports: [CommonModule,
            CnetDividerModule,
            CnetIconModule,
            CnetRippleModule,
            A11yModule], exports: [CnetAccordionComponent, CnetAccordionPanelComponent, CnetAccordionPanelHeaderComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAccordionModule, imports: [CommonModule,
            CnetDividerModule,
            CnetIconModule,
            CnetRippleModule,
            A11yModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAccordionModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetAccordionComponent, CnetAccordionPanelComponent, CnetAccordionPanelHeaderComponent],
                    imports: [
                        CommonModule,
                        CnetDividerModule,
                        CnetIconModule,
                        CnetRippleModule,
                        A11yModule
                    ],
                    exports: [CnetAccordionComponent, CnetAccordionPanelComponent, CnetAccordionPanelHeaderComponent]
                }]
        }] });

class CnetActionsGroupDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetActionsGroupDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetActionsGroupDirective, selector: "cnet-actions-group, [CnetActionsGroup], [cnet-actions-group]", host: { attributes: { "role": "group" }, classAttribute: "cnet-actions-group" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetActionsGroupDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-actions-group, [CnetActionsGroup], [cnet-actions-group]',
                    host: {
                        class: 'cnet-actions-group',
                        role: 'group'
                    },
                }]
        }] });

class CnetActionsGroupModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetActionsGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetActionsGroupModule, declarations: [CnetActionsGroupDirective], imports: [CommonModule], exports: [CnetActionsGroupDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetActionsGroupModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetActionsGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetActionsGroupDirective],
                    imports: [
                        CommonModule
                    ],
                    exports: [CnetActionsGroupDirective]
                }]
        }] });

var CnetButtonSize;
(function (CnetButtonSize) {
    CnetButtonSize["Default"] = "default";
    CnetButtonSize["Small"] = "small";
    CnetButtonSize["Large"] = "large";
})(CnetButtonSize || (CnetButtonSize = {}));
class CnetButtonComponent {
    constructor(_elementRef, _focusMonitor) {
        this._elementRef = _elementRef;
        this._focusMonitor = _focusMonitor;
        this._size = CnetButtonSize.Default;
        this.isIconButton = this._hasHostAttributes('cnet-icon-button');
        this._focusMonitor.monitor(this._elementRef, true);
    }
    ngOnDestroy() {
        this._focusMonitor.stopMonitoring(this._elementRef);
    }
    focus(origin = 'program', options) {
        this._focusMonitor.focusVia(this._getHostElement(), origin, options);
    }
    get disabled() { return this._disabled; }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    get size() { return this._size; }
    set size(value) {
        this._size = value;
    }
    get color() { return this._color; }
    set color(value) { this._color = value; }
    _hasHostAttributes(...attributes) {
        return attributes.some(attribute => this._getHostElement().hasAttribute(attribute));
    }
    _getHostElement() {
        return this._elementRef.nativeElement;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetButtonComponent, deps: [{ token: i0.ElementRef }, { token: i1$2.FocusMonitor }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: { disabled: "disabled", size: "size", color: "color" }, host: { properties: { "class.cnet-color-success": "color == \"success\"", "class.cnet-color-cancel": "color == \"cancel\"", "class.cnet-color-primary": "color == \"primary\"", "class.cnet-color-secondary": "color == \"secondary\"", "class.cnet-color-danger": "color == \"danger\"", "class.cnet-button-small": "size === \"small\"", "class.cnet-button-large": "size === \"large\"", "attr.disabled": "disabled || null" }, classAttribute: "cnet-button" }, exportAs: ["cnetButton"], ngImport: i0, template: "<span class=\"cnet-button-wrapper\">\n  <ng-content></ng-content>\n</span>\n\n<span cnetRipple\n  class=\"cnet-button-ripple\"\n  [cnetRippleCentered]=\"isIconButton\"\n  [cnetRippleTrigger]=\"_getHostElement()\"\n  [cnetRippleDisabled]=\"disabled\">\n</span>\n\n<span class=\"cnet-button-overlay\"></span>\n", styles: [".cnet-button{box-sizing:border-box;border-radius:.25rem;border:none;cursor:pointer;position:relative;-webkit-user-select:none;user-select:none;outline:none;-webkit-tap-highlight-color:transparent;display:inline-flex;justify-content:center;align-items:center;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:4rem;font-size:1rem;background:transparent;overflow:hidden;color:#000000d9;text-transform:uppercase;color:currentColor}.cnet-button[disabled]{cursor:default}.cnet-button::-moz-focus-inner{border:0}.cnet-button[cnet-button]{padding:0 1rem;line-height:38px}.cnet-button[cnet-button][disabled]{color:var(--cnet--500, #9e9e9e)}.cnet-button[cnet-button].cnet-color-success{color:var(--cnet-success-500, #47ba65)}.cnet-button[cnet-button].cnet-color-cancel{color:var(--cnet-cancel-500, #9e9e9e)}.cnet-button[cnet-button].cnet-color-primary{color:var(--cnet-primary-500, #82c14f)}.cnet-button[cnet-button].cnet-color-secondary{color:var(--cnet-secondary-500, #3d4155)}.cnet-button[cnet-button].cnet-color-danger{color:var(--cnet-danger-500, #ee4446)}.cnet-button[cnet-filled-button]{padding:0 1rem;line-height:38px;background:#fff}.cnet-button[cnet-filled-button].cnet-color-success{background-color:var(--cnet-success-500, #47ba65)}.cnet-button[cnet-filled-button].cnet-color-cancel{background-color:var(--cnet-cancel-500, #9e9e9e)}.cnet-button[cnet-filled-button].cnet-color-primary{background-color:var(--cnet-primary-500, #82c14f)}.cnet-button[cnet-filled-button].cnet-color-secondary{background-color:var(--cnet-secondary-500, #3d4155)}.cnet-button[cnet-filled-button].cnet-color-danger{background-color:var(--cnet-danger-500, #ee4446)}.cnet-button[cnet-filled-button].cnet-color-success{color:var(--cnet-success-contrast-500, white)}.cnet-button[cnet-filled-button].cnet-color-cancel{color:var(--cnet-cancel-contrast-500, white)}.cnet-button[cnet-filled-button].cnet-color-primary{color:var(--cnet-primary-contrast-500, white)}.cnet-button[cnet-filled-button].cnet-color-secondary{color:var(--cnet-secondary-contrast-500, white)}.cnet-button[cnet-filled-button].cnet-color-danger{color:var(--cnet-danger-contrast-500, white)}.cnet-button[cnet-filled-button][disabled]{color:var(--cnet--500, #9e9e9e);background:var(--cnet--200, #eeeeee)}.cnet-button[cnet-stroked-button]{padding:0 .9375rem;line-height:36px;border-color:#4c4c4c;border-width:1px;border-style:solid;transition:background-color ease .3s,color ease .3s}.cnet-button[cnet-stroked-button].cnet-color-success{color:var(--cnet-success-500, #47ba65)}.cnet-button[cnet-stroked-button].cnet-color-cancel{color:var(--cnet-cancel-500, #9e9e9e)}.cnet-button[cnet-stroked-button].cnet-color-primary{color:var(--cnet-primary-500, #82c14f)}.cnet-button[cnet-stroked-button].cnet-color-secondary{color:var(--cnet-secondary-500, #3d4155)}.cnet-button[cnet-stroked-button].cnet-color-danger{color:var(--cnet-danger-500, #ee4446)}.cnet-button[cnet-stroked-button].cnet-color-success{border-color:var(--cnet-success-500, #47ba65)}.cnet-button[cnet-stroked-button].cnet-color-cancel{border-color:var(--cnet-cancel-500, #9e9e9e)}.cnet-button[cnet-stroked-button].cnet-color-primary{border-color:var(--cnet-primary-500, #82c14f)}.cnet-button[cnet-stroked-button].cnet-color-secondary{border-color:var(--cnet-secondary-500, #3d4155)}.cnet-button[cnet-stroked-button].cnet-color-danger{border-color:var(--cnet-danger-500, #ee4446)}.cnet-button[cnet-stroked-button]:hover:not([disabled]){background-color:#4c4c4c;color:#fff}.cnet-button[cnet-stroked-button]:hover:not([disabled]).cnet-color-success{background-color:var(--cnet-success-500, #47ba65)}.cnet-button[cnet-stroked-button]:hover:not([disabled]).cnet-color-cancel{background-color:var(--cnet-cancel-500, #9e9e9e)}.cnet-button[cnet-stroked-button]:hover:not([disabled]).cnet-color-primary{background-color:var(--cnet-primary-500, #82c14f)}.cnet-button[cnet-stroked-button]:hover:not([disabled]).cnet-color-secondary{background-color:var(--cnet-secondary-500, #3d4155)}.cnet-button[cnet-stroked-button]:hover:not([disabled]).cnet-color-danger{background-color:var(--cnet-danger-500, #ee4446)}.cnet-button[cnet-stroked-button]:hover:not([disabled]).cnet-color-success{color:var(--cnet-success-contrast-500, white)}.cnet-button[cnet-stroked-button]:hover:not([disabled]).cnet-color-cancel{color:var(--cnet-cancel-contrast-500, white)}.cnet-button[cnet-stroked-button]:hover:not([disabled]).cnet-color-primary{color:var(--cnet-primary-contrast-500, white)}.cnet-button[cnet-stroked-button]:hover:not([disabled]).cnet-color-secondary{color:var(--cnet-secondary-contrast-500, white)}.cnet-button[cnet-stroked-button]:hover:not([disabled]).cnet-color-danger{color:var(--cnet-danger-contrast-500, white)}.cnet-button[cnet-stroked-button][disabled]{color:var(--cnet--500, #9e9e9e);border-color:var(--cnet--500, #9e9e9e)}.cnet-button[cnet-stroked-button][cnet-icon-button]{border-radius:.25rem}.cnet-button[cnet-icon-button]{width:38px;height:38px;border-radius:50%;min-width:unset;padding:0}.cnet-button[cnet-icon-button].cnet-color-success{color:var(--cnet-success-500, #47ba65)}.cnet-button[cnet-icon-button].cnet-color-cancel{color:var(--cnet-cancel-500, #9e9e9e)}.cnet-button[cnet-icon-button].cnet-color-primary{color:var(--cnet-primary-500, #82c14f)}.cnet-button[cnet-icon-button].cnet-color-secondary{color:var(--cnet-secondary-500, #3d4155)}.cnet-button[cnet-icon-button].cnet-color-danger{color:var(--cnet-danger-500, #ee4446)}.cnet-button[cnet-icon-button][disabled]{color:var(--cnet--500, #9e9e9e)}.cnet-button.cnet-button-small{min-width:4rem;font-size:.875rem;padding:0 .75rem;line-height:30px}.cnet-button.cnet-button-small[cnet-stroked-button]{padding:0 .6875rem;line-height:28px}.cnet-button.cnet-button-small[cnet-icon-button]{min-width:30px;width:30px;height:30px}.cnet-button.cnet-button-small[cnet-icon-button] i{font-size:18px}.cnet-button.cnet-button-large{min-width:4rem;font-size:1.25rem;padding:0 1.25rem;line-height:48px}.cnet-button.cnet-button-large[cnet-stroked-button]{padding:0 1.1875rem;line-height:46px}.cnet-button.cnet-button-large[cnet-icon-button]{min-width:48px;width:48px;height:48px}.cnet-button.cnet-button-large[cnet-icon-button] i{font-size:28px}.cnet-button.cdk-keyboard-focused .cnet-button-overlay,.cnet-button.cdk-program-focused .cnet-button-overlay{opacity:.125!important}.cnet-button:hover:not(:disabled):not(:active):not([cnet-filled-button]) .cnet-button-overlay{opacity:.08!important}.cnet-button .cnet-button-wrapper{display:flex;align-items:center;justify-content:center;gap:.5rem}.cnet-button .cnet-button-ripple,.cnet-button .cnet-button-overlay{content:\"\";position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none}.cnet-button .cnet-button-ripple .cnet-ripple-element{opacity:.16}.cnet-button .cnet-button-overlay{background-color:currentColor;transition:opacity ease .3s;opacity:0}\n"], dependencies: [{ kind: "directive", type: CnetRippleDirective, selector: "[cnet-ripple], [cnetRipple]", inputs: ["cnetRippleColor", "cnetRippleUnbounded", "cnetRippleCentered", "cnetRippleRadius", "cnetRippleAnimation", "cnetRippleDisabled", "cnetRippleTrigger"], exportAs: ["cnetRipple"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: `button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],
  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]`, exportAs: 'cnetButton', host: {
                        class: 'cnet-button',
                        '[class.cnet-color-success]': 'color == "success"',
                        '[class.cnet-color-cancel]': 'color == "cancel"',
                        '[class.cnet-color-primary]': 'color == "primary"',
                        '[class.cnet-color-secondary]': 'color == "secondary"',
                        '[class.cnet-color-danger]': 'color == "danger"',
                        '[class.cnet-button-small]': 'size === "small"',
                        '[class.cnet-button-large]': 'size === "large"',
                        '[attr.disabled]': 'disabled || null'
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<span class=\"cnet-button-wrapper\">\n  <ng-content></ng-content>\n</span>\n\n<span cnetRipple\n  class=\"cnet-button-ripple\"\n  [cnetRippleCentered]=\"isIconButton\"\n  [cnetRippleTrigger]=\"_getHostElement()\"\n  [cnetRippleDisabled]=\"disabled\">\n</span>\n\n<span class=\"cnet-button-overlay\"></span>\n", styles: [".cnet-button{box-sizing:border-box;border-radius:.25rem;border:none;cursor:pointer;position:relative;-webkit-user-select:none;user-select:none;outline:none;-webkit-tap-highlight-color:transparent;display:inline-flex;justify-content:center;align-items:center;white-space:nowrap;text-decoration:none;vertical-align:baseline;text-align:center;margin:0;min-width:4rem;font-size:1rem;background:transparent;overflow:hidden;color:#000000d9;text-transform:uppercase;color:currentColor}.cnet-button[disabled]{cursor:default}.cnet-button::-moz-focus-inner{border:0}.cnet-button[cnet-button]{padding:0 1rem;line-height:38px}.cnet-button[cnet-button][disabled]{color:var(--cnet--500, #9e9e9e)}.cnet-button[cnet-button].cnet-color-success{color:var(--cnet-success-500, #47ba65)}.cnet-button[cnet-button].cnet-color-cancel{color:var(--cnet-cancel-500, #9e9e9e)}.cnet-button[cnet-button].cnet-color-primary{color:var(--cnet-primary-500, #82c14f)}.cnet-button[cnet-button].cnet-color-secondary{color:var(--cnet-secondary-500, #3d4155)}.cnet-button[cnet-button].cnet-color-danger{color:var(--cnet-danger-500, #ee4446)}.cnet-button[cnet-filled-button]{padding:0 1rem;line-height:38px;background:#fff}.cnet-button[cnet-filled-button].cnet-color-success{background-color:var(--cnet-success-500, #47ba65)}.cnet-button[cnet-filled-button].cnet-color-cancel{background-color:var(--cnet-cancel-500, #9e9e9e)}.cnet-button[cnet-filled-button].cnet-color-primary{background-color:var(--cnet-primary-500, #82c14f)}.cnet-button[cnet-filled-button].cnet-color-secondary{background-color:var(--cnet-secondary-500, #3d4155)}.cnet-button[cnet-filled-button].cnet-color-danger{background-color:var(--cnet-danger-500, #ee4446)}.cnet-button[cnet-filled-button].cnet-color-success{color:var(--cnet-success-contrast-500, white)}.cnet-button[cnet-filled-button].cnet-color-cancel{color:var(--cnet-cancel-contrast-500, white)}.cnet-button[cnet-filled-button].cnet-color-primary{color:var(--cnet-primary-contrast-500, white)}.cnet-button[cnet-filled-button].cnet-color-secondary{color:var(--cnet-secondary-contrast-500, white)}.cnet-button[cnet-filled-button].cnet-color-danger{color:var(--cnet-danger-contrast-500, white)}.cnet-button[cnet-filled-button][disabled]{color:var(--cnet--500, #9e9e9e);background:var(--cnet--200, #eeeeee)}.cnet-button[cnet-stroked-button]{padding:0 .9375rem;line-height:36px;border-color:#4c4c4c;border-width:1px;border-style:solid;transition:background-color ease .3s,color ease .3s}.cnet-button[cnet-stroked-button].cnet-color-success{color:var(--cnet-success-500, #47ba65)}.cnet-button[cnet-stroked-button].cnet-color-cancel{color:var(--cnet-cancel-500, #9e9e9e)}.cnet-button[cnet-stroked-button].cnet-color-primary{color:var(--cnet-primary-500, #82c14f)}.cnet-button[cnet-stroked-button].cnet-color-secondary{color:var(--cnet-secondary-500, #3d4155)}.cnet-button[cnet-stroked-button].cnet-color-danger{color:var(--cnet-danger-500, #ee4446)}.cnet-button[cnet-stroked-button].cnet-color-success{border-color:var(--cnet-success-500, #47ba65)}.cnet-button[cnet-stroked-button].cnet-color-cancel{border-color:var(--cnet-cancel-500, #9e9e9e)}.cnet-button[cnet-stroked-button].cnet-color-primary{border-color:var(--cnet-primary-500, #82c14f)}.cnet-button[cnet-stroked-button].cnet-color-secondary{border-color:var(--cnet-secondary-500, #3d4155)}.cnet-button[cnet-stroked-button].cnet-color-danger{border-color:var(--cnet-danger-500, #ee4446)}.cnet-button[cnet-stroked-button]:hover:not([disabled]){background-color:#4c4c4c;color:#fff}.cnet-button[cnet-stroked-button]:hover:not([disabled]).cnet-color-success{background-color:var(--cnet-success-500, #47ba65)}.cnet-button[cnet-stroked-button]:hover:not([disabled]).cnet-color-cancel{background-color:var(--cnet-cancel-500, #9e9e9e)}.cnet-button[cnet-stroked-button]:hover:not([disabled]).cnet-color-primary{background-color:var(--cnet-primary-500, #82c14f)}.cnet-button[cnet-stroked-button]:hover:not([disabled]).cnet-color-secondary{background-color:var(--cnet-secondary-500, #3d4155)}.cnet-button[cnet-stroked-button]:hover:not([disabled]).cnet-color-danger{background-color:var(--cnet-danger-500, #ee4446)}.cnet-button[cnet-stroked-button]:hover:not([disabled]).cnet-color-success{color:var(--cnet-success-contrast-500, white)}.cnet-button[cnet-stroked-button]:hover:not([disabled]).cnet-color-cancel{color:var(--cnet-cancel-contrast-500, white)}.cnet-button[cnet-stroked-button]:hover:not([disabled]).cnet-color-primary{color:var(--cnet-primary-contrast-500, white)}.cnet-button[cnet-stroked-button]:hover:not([disabled]).cnet-color-secondary{color:var(--cnet-secondary-contrast-500, white)}.cnet-button[cnet-stroked-button]:hover:not([disabled]).cnet-color-danger{color:var(--cnet-danger-contrast-500, white)}.cnet-button[cnet-stroked-button][disabled]{color:var(--cnet--500, #9e9e9e);border-color:var(--cnet--500, #9e9e9e)}.cnet-button[cnet-stroked-button][cnet-icon-button]{border-radius:.25rem}.cnet-button[cnet-icon-button]{width:38px;height:38px;border-radius:50%;min-width:unset;padding:0}.cnet-button[cnet-icon-button].cnet-color-success{color:var(--cnet-success-500, #47ba65)}.cnet-button[cnet-icon-button].cnet-color-cancel{color:var(--cnet-cancel-500, #9e9e9e)}.cnet-button[cnet-icon-button].cnet-color-primary{color:var(--cnet-primary-500, #82c14f)}.cnet-button[cnet-icon-button].cnet-color-secondary{color:var(--cnet-secondary-500, #3d4155)}.cnet-button[cnet-icon-button].cnet-color-danger{color:var(--cnet-danger-500, #ee4446)}.cnet-button[cnet-icon-button][disabled]{color:var(--cnet--500, #9e9e9e)}.cnet-button.cnet-button-small{min-width:4rem;font-size:.875rem;padding:0 .75rem;line-height:30px}.cnet-button.cnet-button-small[cnet-stroked-button]{padding:0 .6875rem;line-height:28px}.cnet-button.cnet-button-small[cnet-icon-button]{min-width:30px;width:30px;height:30px}.cnet-button.cnet-button-small[cnet-icon-button] i{font-size:18px}.cnet-button.cnet-button-large{min-width:4rem;font-size:1.25rem;padding:0 1.25rem;line-height:48px}.cnet-button.cnet-button-large[cnet-stroked-button]{padding:0 1.1875rem;line-height:46px}.cnet-button.cnet-button-large[cnet-icon-button]{min-width:48px;width:48px;height:48px}.cnet-button.cnet-button-large[cnet-icon-button] i{font-size:28px}.cnet-button.cdk-keyboard-focused .cnet-button-overlay,.cnet-button.cdk-program-focused .cnet-button-overlay{opacity:.125!important}.cnet-button:hover:not(:disabled):not(:active):not([cnet-filled-button]) .cnet-button-overlay{opacity:.08!important}.cnet-button .cnet-button-wrapper{display:flex;align-items:center;justify-content:center;gap:.5rem}.cnet-button .cnet-button-ripple,.cnet-button .cnet-button-overlay{content:\"\";position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none}.cnet-button .cnet-button-ripple .cnet-ripple-element{opacity:.16}.cnet-button .cnet-button-overlay{background-color:currentColor;transition:opacity ease .3s;opacity:0}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$2.FocusMonitor }], propDecorators: { disabled: [{
                type: Input
            }], size: [{
                type: Input
            }], color: [{
                type: Input
            }] } });

class CnetButtonModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetButtonModule, declarations: [CnetButtonComponent], imports: [CommonModule,
            CnetRippleModule], exports: [CnetButtonComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetButtonModule, imports: [CommonModule,
            CnetRippleModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetButtonComponent],
                    imports: [
                        CommonModule,
                        CnetRippleModule
                    ],
                    exports: [CnetButtonComponent]
                }]
        }] });

var CnetAlertType;
(function (CnetAlertType) {
    CnetAlertType["Success"] = "success";
    CnetAlertType["Info"] = "info";
    CnetAlertType["Danger"] = "danger";
    CnetAlertType["Warning"] = "warning";
    CnetAlertType["None"] = "none";
})(CnetAlertType || (CnetAlertType = {}));
class CnetAlertTitleDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAlertTitleDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetAlertTitleDirective, selector: "cnet-alert-title, [cnet-alert-title], [cnetAlertTitle]", host: { classAttribute: "cnet-alert-title" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAlertTitleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-alert-title, [cnet-alert-title], [cnetAlertTitle]',
                    host: { class: 'cnet-alert-title' }
                }]
        }] });
class CnetAlertMessageDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAlertMessageDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetAlertMessageDirective, selector: "cnet-alert-message, [cnet-alert-message], [cnetAlertmessage]", host: { classAttribute: "cnet-alert-message" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAlertMessageDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-alert-message, [cnet-alert-message], [cnetAlertmessage]',
                    host: { class: 'cnet-alert-message' }
                }]
        }] });
/** Cnet Alert is used to provide contextual feedback to the user. */
class CnetAlertComponent {
    constructor() {
        /** @ignore */ this.cnetAlertType = CnetAlertType;
        this.showIcon = true;
        this.dismiss = new EventEmitter();
    }
    /** @ignore */
    ngAfterViewInit() {
        if (this.timeout) {
            setTimeout(() => {
                this.dismissHandler();
            }, this.timeout);
        }
    }
    /** @ignore */
    dismissHandler() {
        this.dismiss.emit();
    }
    /** Whether the close button is visible */
    get dismissible() { return this._dismissible; }
    set dismissible(value) {
        this._dismissible = coerceBooleanProperty(value);
    }
    /** Type for the alert */
    get type() { return this._type; }
    set type(value) {
        this._type = value;
    }
    /** Title for or alert */
    get title() { return this._title; }
    set title(value) {
        this._title = value;
    }
    /** Alert message */
    get message() { return this._message; }
    set message(value) {
        this._message = value;
    }
    /** Time when the alert should remain visible */
    get timeout() { return this._timeout; }
    set timeout(value) {
        this._timeout = coerceNumberProperty(value);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAlertComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: CnetAlertComponent, selector: "cnet-alert", inputs: { showIcon: "showIcon", dismissible: "dismissible", type: "type", title: "title", message: "message", timeout: "timeout" }, outputs: { dismiss: "dismiss" }, host: { attributes: { "role": "alert" }, properties: { "class.success": "type === \"success\"", "class.info": "type === \"info\"", "class.warning": "type === \"warning\"", "class.danger": "type === \"danger\"" }, classAttribute: "cnet-alert" }, exportAs: ["cnetAlert"], ngImport: i0, template: "@if(showIcon){\n<div class=\"cnet-alert-icon\" aria-hidden=\"true\" *ngIf=\"type != cnetAlertType.None\" [ngSwitch]=\"type\">\n  <cnet-icon name=\"check-circle\" *ngSwitchCase=\"cnetAlertType.Success\"></cnet-icon>\n  <cnet-icon name=\"info-circle\" *ngSwitchCase=\"cnetAlertType.Info\"></cnet-icon>\n  <cnet-icon name=\"times-circle\" *ngSwitchCase=\"cnetAlertType.Danger\"></cnet-icon>\n  <cnet-icon name=\"exclamation-circle\" *ngSwitchCase=\"cnetAlertType.Warning\"></cnet-icon>\n</div>\n}\n<div class=\"cnet-alert-body\">\n  <ng-content select=\"cnet-alert-title, [cnet-alert-title], [cnetAlertTitle]\"></ng-content>\n  <ng-content select=\"cnet-alert-message, [cnet-alert-message], [cnetAlertMessage]\"></ng-content>\n</div>\n<div class=\"cnet-alert-close\" *ngIf=\"dismissible\">\n  <button cnet-icon-button [attr.aria-label]=\"'fechar' | translate\" size=\"small\" (click)=\"dismissHandler()\">\n    <cnet-icon name=\"close\" aria-hidden=\"true\"></cnet-icon>\n  </button>\n</div>\n", styles: [".cnet-alert{display:flex;min-height:48px;border-radius:.25rem;position:relative;padding:.75rem 40px .75rem .75rem;margin-bottom:1rem;color:var(--cnet--800, #424242);background-color:var(--cnet--100, #f5f5f5);font-size:.875rem;line-height:1.6}.cnet-alert.success{background-color:var(--cnet-success-100, #c8ead1)}.cnet-alert.info{background-color:var(--cnet-info-100, #ceecf5)}.cnet-alert.warning{background-color:var(--cnet-warning-100, #fcefca)}.cnet-alert.danger{background-color:var(--cnet-danger-100, #fac7c8)}.cnet-alert .cnet-alert-icon{display:flex;margin-right:.625rem}.cnet-alert .cnet-alert-body{flex:1;margin-right:1rem;display:flex;flex-direction:column;align-items:flex-start;justify-content:center}.cnet-alert .cnet-alert-body .cnet-alert-title{font-weight:700}.cnet-alert .cnet-alert-body .cnet-alert-title,.cnet-alert .cnet-alert-body .cnet-alert-message{margin:0}.cnet-alert .cnet-alert-close{display:flex;align-items:center;position:absolute;right:8px;top:8px}.cnet-alert .cnet-alert-close button[cnet-icon-button]{color:var(--cnet--800, #424242)}.cnet-alert .cnet-alert-close button[cnet-icon-button] i{font-size:1.125rem}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }, { kind: "pipe", type: i1$3.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-alert', exportAs: 'cnetAlert', host: {
                        class: 'cnet-alert',
                        role: 'alert',
                        '[class.success]': 'type === "success"',
                        '[class.info]': 'type === "info"',
                        '[class.warning]': 'type === "warning"',
                        '[class.danger]': 'type === "danger"'
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "@if(showIcon){\n<div class=\"cnet-alert-icon\" aria-hidden=\"true\" *ngIf=\"type != cnetAlertType.None\" [ngSwitch]=\"type\">\n  <cnet-icon name=\"check-circle\" *ngSwitchCase=\"cnetAlertType.Success\"></cnet-icon>\n  <cnet-icon name=\"info-circle\" *ngSwitchCase=\"cnetAlertType.Info\"></cnet-icon>\n  <cnet-icon name=\"times-circle\" *ngSwitchCase=\"cnetAlertType.Danger\"></cnet-icon>\n  <cnet-icon name=\"exclamation-circle\" *ngSwitchCase=\"cnetAlertType.Warning\"></cnet-icon>\n</div>\n}\n<div class=\"cnet-alert-body\">\n  <ng-content select=\"cnet-alert-title, [cnet-alert-title], [cnetAlertTitle]\"></ng-content>\n  <ng-content select=\"cnet-alert-message, [cnet-alert-message], [cnetAlertMessage]\"></ng-content>\n</div>\n<div class=\"cnet-alert-close\" *ngIf=\"dismissible\">\n  <button cnet-icon-button [attr.aria-label]=\"'fechar' | translate\" size=\"small\" (click)=\"dismissHandler()\">\n    <cnet-icon name=\"close\" aria-hidden=\"true\"></cnet-icon>\n  </button>\n</div>\n", styles: [".cnet-alert{display:flex;min-height:48px;border-radius:.25rem;position:relative;padding:.75rem 40px .75rem .75rem;margin-bottom:1rem;color:var(--cnet--800, #424242);background-color:var(--cnet--100, #f5f5f5);font-size:.875rem;line-height:1.6}.cnet-alert.success{background-color:var(--cnet-success-100, #c8ead1)}.cnet-alert.info{background-color:var(--cnet-info-100, #ceecf5)}.cnet-alert.warning{background-color:var(--cnet-warning-100, #fcefca)}.cnet-alert.danger{background-color:var(--cnet-danger-100, #fac7c8)}.cnet-alert .cnet-alert-icon{display:flex;margin-right:.625rem}.cnet-alert .cnet-alert-body{flex:1;margin-right:1rem;display:flex;flex-direction:column;align-items:flex-start;justify-content:center}.cnet-alert .cnet-alert-body .cnet-alert-title{font-weight:700}.cnet-alert .cnet-alert-body .cnet-alert-title,.cnet-alert .cnet-alert-body .cnet-alert-message{margin:0}.cnet-alert .cnet-alert-close{display:flex;align-items:center;position:absolute;right:8px;top:8px}.cnet-alert .cnet-alert-close button[cnet-icon-button]{color:var(--cnet--800, #424242)}.cnet-alert .cnet-alert-close button[cnet-icon-button] i{font-size:1.125rem}\n"] }]
        }], propDecorators: { showIcon: [{
                type: Input
            }], dismiss: [{
                type: Output
            }], dismissible: [{
                type: Input
            }], type: [{
                type: Input
            }], title: [{
                type: Input
            }], message: [{
                type: Input
            }], timeout: [{
                type: Input
            }] } });

class CnetAlertModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAlertModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetAlertModule, declarations: [CnetAlertComponent,
            CnetAlertTitleDirective,
            CnetAlertMessageDirective], imports: [CommonModule,
            CnetIconModule,
            CnetButtonModule,
            TranslateModule], exports: [CnetAlertComponent,
            CnetAlertTitleDirective,
            CnetAlertMessageDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAlertModule, imports: [CommonModule,
            CnetIconModule,
            CnetButtonModule,
            TranslateModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAlertModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnetAlertComponent,
                        CnetAlertTitleDirective,
                        CnetAlertMessageDirective
                    ],
                    imports: [
                        CommonModule,
                        CnetIconModule,
                        CnetButtonModule,
                        TranslateModule
                    ],
                    exports: [
                        CnetAlertComponent,
                        CnetAlertTitleDirective,
                        CnetAlertMessageDirective
                    ]
                }]
        }] });

class CnetAutocompleteOptionComponent {
    get element() { return this.host.nativeElement; }
    constructor(host) {
        this.host = host;
    }
    ngOnInit() {
        this.click$ = fromEvent(this.element, 'click').pipe(mapTo(this.value));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAutocompleteOptionComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetAutocompleteOptionComponent, selector: "cnet-autocomplete-option", inputs: { value: "value" }, host: { attributes: { "tabindex": "0", "role": "option" }, classAttribute: "cnet-autocomplete-option" }, ngImport: i0, template: `
    <div class="autocomplete-option" cnetRipple [cnetRippleTrigger]="element">
      <ng-content></ng-content>
    </div>
  `, isInline: true, styles: [".autocomplete-option:hover{cursor:pointer;background-color:#0000000a}.autocomplete-option{position:relative;display:block;width:100%;height:fit-content;margin:0;padding:.5rem .75rem;outline:none;cursor:pointer;-webkit-user-select:none;user-select:none}\n"], dependencies: [{ kind: "directive", type: CnetRippleDirective, selector: "[cnet-ripple], [cnetRipple]", inputs: ["cnetRippleColor", "cnetRippleUnbounded", "cnetRippleCentered", "cnetRippleRadius", "cnetRippleAnimation", "cnetRippleDisabled", "cnetRippleTrigger"], exportAs: ["cnetRipple"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAutocompleteOptionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-autocomplete-option', template: `
    <div class="autocomplete-option" cnetRipple [cnetRippleTrigger]="element">
      <ng-content></ng-content>
    </div>
  `, host: {
                        class: 'cnet-autocomplete-option',
                        tabindex: '0',
                        role: 'option',
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, styles: [".autocomplete-option:hover{cursor:pointer;background-color:#0000000a}.autocomplete-option{position:relative;display:block;width:100%;height:fit-content;margin:0;padding:.5rem .75rem;outline:none;cursor:pointer;-webkit-user-select:none;user-select:none}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { value: [{
                type: Input
            }] } });

class CnetAutocompleteContentDirective {
    constructor(tpl) {
        this.tpl = tpl;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAutocompleteContentDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetAutocompleteContentDirective, selector: "[cnetAutocompleteContent]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAutocompleteContentDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetAutocompleteContent]'
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }] });

class CnetAutocompleteComponent {
    constructor() { }
    optionsClick() {
        return this.options.changes.pipe(switchMap(options => {
            const clicks$ = options.map(option => option.click$);
            return merge(...clicks$);
        }));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAutocompleteComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetAutocompleteComponent, selector: "cnet-autocomplete", queries: [{ propertyName: "content", first: true, predicate: CnetAutocompleteContentDirective, descendants: true }, { propertyName: "options", predicate: CnetAutocompleteOptionComponent }], viewQueries: [{ propertyName: "rootTemplate", first: true, predicate: ["root"], descendants: true }], exportAs: ["cnetAutocomplete"], ngImport: i0, template: `
  <ng-template #root>
    <div class="autocomplete">
      <ng-container *ngTemplateOutlet="content.tpl"></ng-container>
    </div>
  </ng-template>`, isInline: true, styles: [".autocomplete{width:calc(100% + 2px);margin-top:1px;margin-left:-1px;transform-origin:left top;background:#fff;border-bottom-left-radius:.25rem;border-bottom-right-radius:.25rem;box-shadow:0 1px 4px -1px #0000001a,0 4px 5px #0000001a;overflow-y:auto}\n"], dependencies: [{ kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAutocompleteComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-autocomplete', template: `
  <ng-template #root>
    <div class="autocomplete">
      <ng-container *ngTemplateOutlet="content.tpl"></ng-container>
    </div>
  </ng-template>`, exportAs: 'cnetAutocomplete', styles: [".autocomplete{width:calc(100% + 2px);margin-top:1px;margin-left:-1px;transform-origin:left top;background:#fff;border-bottom-left-radius:.25rem;border-bottom-right-radius:.25rem;box-shadow:0 1px 4px -1px #0000001a,0 4px 5px #0000001a;overflow-y:auto}\n"] }]
        }], ctorParameters: () => [], propDecorators: { rootTemplate: [{
                type: ViewChild,
                args: ['root']
            }], content: [{
                type: ContentChild,
                args: [CnetAutocompleteContentDirective]
            }], options: [{
                type: ContentChildren,
                args: [CnetAutocompleteOptionComponent]
            }] } });

class CnetAutocompleteDirective {
    get control() {
        return this.ngControl.control;
    }
    get origin() {
        return this.host.nativeElement;
    }
    constructor(host, ngControl, vcr, overlay) {
        this.host = host;
        this.ngControl = ngControl;
        this.vcr = vcr;
        this.overlay = overlay;
        this._destroyed = new Subject();
    }
    ngOnInit() {
        fromEvent(this.origin, 'focus').pipe(
        // untilDestroyed(this)
        takeUntil(this._destroyed)).subscribe(() => {
            this.openDropdown();
            this.cnetAutocomplete.optionsClick()
                .pipe(takeUntil(this.overlayRef.detachments()))
                .subscribe((value) => {
                this.control.setValue(value);
                this.close();
            });
        });
    }
    ngOnDestroy() {
        this._destroyed.next();
        this._destroyed.complete();
    }
    openDropdown() {
        this.overlayRef = this.overlay.create({
            width: this.origin.offsetWidth,
            maxHeight: 40 * 3,
            backdropClass: '',
            scrollStrategy: this.overlay.scrollStrategies.reposition(),
            positionStrategy: this.getOverlayPosition()
        });
        const template = new TemplatePortal(this.cnetAutocomplete.rootTemplate, this.vcr);
        this.overlayRef.attach(template);
        overlayClickOutside(this.overlayRef, this.origin).subscribe(() => this.close());
    }
    close() {
        this.overlayRef.detach();
        this.overlayRef = null;
    }
    getOverlayPosition() {
        return this.overlay
            .position()
            .flexibleConnectedTo(this.origin)
            .withPositions([{
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top',
                offsetY: 4,
            }, {
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'bottom',
                offsetY: -4,
            }])
            .withFlexibleDimensions(false)
            .withPush(false);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAutocompleteDirective, deps: [{ token: i0.ElementRef }, { token: i1$4.NgControl }, { token: i0.ViewContainerRef }, { token: i1$5.Overlay }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetAutocompleteDirective, selector: "[cnetAutocomplete]", inputs: { cnetAutocomplete: "cnetAutocomplete" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAutocompleteDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetAutocomplete]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$4.NgControl }, { type: i0.ViewContainerRef }, { type: i1$5.Overlay }], propDecorators: { cnetAutocomplete: [{
                type: Input
            }] } });
function overlayClickOutside(overlayRef, origin) {
    return fromEvent(document, 'click')
        .pipe(filter(event => {
        const clickTarget = event.target;
        const notOrigin = clickTarget !== origin;
        const notOverlay = !!overlayRef && (overlayRef.overlayElement.contains(clickTarget) === false);
        return notOrigin && notOverlay;
    }), takeUntil(overlayRef.detachments()));
}

class NormalizeStringPipe {
    transform(value) {
        if (value) {
            return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        }
        return '';
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NormalizeStringPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: NormalizeStringPipe, name: "normalizeString" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NormalizeStringPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'normalizeString'
                }]
        }] });

class NormalizeStringModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NormalizeStringModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: NormalizeStringModule, declarations: [NormalizeStringPipe], imports: [CommonModule], exports: [NormalizeStringPipe] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NormalizeStringModule, providers: [NormalizeStringPipe], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: NormalizeStringModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NormalizeStringPipe],
                    exports: [NormalizeStringPipe],
                    providers: [NormalizeStringPipe],
                    imports: [
                        CommonModule
                    ]
                }]
        }] });

class CnetAutocompleteFilterPipe {
    constructor(normalizePipe) {
        this.normalizePipe = normalizePipe;
    }
    transform(items, searchTerm, labelKey) {
        if (!items || !searchTerm) {
            return items;
        }
        return items.filter(item => this.normalizePipe.transform(item[labelKey || 'label'])
            .toLowerCase()
            .includes(this.normalizePipe.transform(searchTerm.toLowerCase())));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAutocompleteFilterPipe, deps: [{ token: NormalizeStringPipe }], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetAutocompleteFilterPipe, name: "cnetAutocompleteFilter" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAutocompleteFilterPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'cnetAutocompleteFilter'
                }]
        }], ctorParameters: () => [{ type: NormalizeStringPipe }] });

class HighlighterPipe {
    transform(value, args, type) {
        if (!args)
            return value;
        if (type === 'full') {
            const re = new RegExp("\\b(" + args + "\\b)", 'igm');
            value = value.replace(re, '<mark class="highlight">$1</mark>');
        }
        else {
            const re = new RegExp(args, 'igm');
            value = value.replace(re, '<mark class="highlight">$&</mark>');
        }
        return value;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HighlighterPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: HighlighterPipe, name: "highlighter", pure: false }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HighlighterPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'highlighter',
                    pure: false
                }]
        }] });

class CnetAutocompleteModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAutocompleteModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetAutocompleteModule, declarations: [CnetAutocompleteComponent, CnetAutocompleteOptionComponent, CnetAutocompleteContentDirective, CnetAutocompleteDirective, CnetAutocompleteFilterPipe, HighlighterPipe], imports: [CommonModule,
            CnetRippleModule], exports: [CnetAutocompleteComponent, CnetAutocompleteOptionComponent, CnetAutocompleteContentDirective, CnetAutocompleteDirective, CnetAutocompleteFilterPipe, HighlighterPipe] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAutocompleteModule, imports: [CommonModule,
            CnetRippleModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAutocompleteModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetAutocompleteComponent, CnetAutocompleteOptionComponent, CnetAutocompleteContentDirective, CnetAutocompleteDirective, CnetAutocompleteFilterPipe, HighlighterPipe],
                    exports: [CnetAutocompleteComponent, CnetAutocompleteOptionComponent, CnetAutocompleteContentDirective, CnetAutocompleteDirective, CnetAutocompleteFilterPipe, HighlighterPipe],
                    imports: [
                        CommonModule,
                        CnetRippleModule
                    ]
                }]
        }] });

/**
 * Cnet Avatar is a component used to add images or initials representing people or objects in different shapes and sizes.
 *
 * @export
 */
class CnetAvatarComponent {
    constructor() {
        /** @ignore */ this._alt = "";
        /** @ignore */ this._text = "";
        /** @ignore */ this._defaultAvatar = "./assets/images/default-avatar.png";
        /** @ignore */ this._size = "large";
        /** @ignore */ this._style = "rounded";
    }
    /**
     * Returns the background-image.
     * If an error occurs while loading the image, returns the default avatar.
     *
     * @readonly
     * @memberof CnetAvatarComponent
     */
    get backgroundUrl() {
        if (this.showImage) {
            return `url(${this.src})`;
        }
        if (this.showDefault) {
            return `url(${this._defaultAvatar})`;
        }
        return;
    }
    ;
    /**
     * Path to the avatar image.
     *
     * @readonly
     * @memberof CnetAvatarComponent
     */
    get src() { return this._src; }
    set src(value) {
        this._src = value;
    }
    /**
     * Alternative text for the avatar.
     *
     * @readonly
     * @memberof CnetAvatarComponent
     */
    get alt() { return this._alt; }
    set alt(value) {
        this._alt = value;
    }
    /**
     * Initials or text for the avatar.
     *
     * @readonly
     * @memberof CnetAvatarComponent
     */
    get text() { return this._text; }
    set text(value) {
        this._text = value;
    }
    /**
     * The size of the avatar.
     *
     * @readonly
     * @memberof CnetAvatarComponent
     */
    get size() { return this._size; }
    set size(value) {
        this._size = value;
    }
    /**
     * The shape of the avatar.
     *
     * @readonly
     * @memberof CnetAvatarComponent
     */
    get style() { return this._style; }
    set style(value) {
        this._style = value;
    }
    /** @ignore */
    get srcError() { return this._srcError; }
    /** @ignore */
    get initials() {
        return this._text ? this._text.split(" ").map((n) => n[0]).join("") : "";
    }
    /** @ignore */
    get showImage() {
        return !this.srcError && !!this.src;
    }
    /** @ignore */
    get showInitials() {
        return this.initials && (this.srcError || !this.src);
    }
    /** @ignore */
    get showDefault() {
        return !this.showImage && !this.showInitials;
    }
    /** @ignore */
    _onSrcError() {
        this._srcError = true;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAvatarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetAvatarComponent, selector: "cnet-avatar", inputs: { src: "src", alt: "alt", text: "text", size: "size", style: "style" }, host: { properties: { "attr.role": "showImage ? \"img\" : \"\"", "attr.aria-label": "alt", "class.cnet-avatar-small": "size == \"small\"", "class.cnet-avatar-normal": "size == \"normal\"", "class.cnet-avatar-large": "size == \"large\"", "class.cnet-avatar-rounded": "style == \"rounded\"", "class.cnet-avatar-squared": "style == \"squared\"", "style.background-image": "backgroundUrl" }, classAttribute: "cnet-avatar" }, exportAs: ["cnetAvatar"], ngImport: i0, template: "<img *ngIf=\"showImage\" \n    class=\"cnet-avatar-image\"\n    [src]=\"src\"\n    [alt]=\"alt\"\n    (error)=\"_onSrcError()\">\n\n<span *ngIf=\"showInitials\" class=\"cnet-avatar-initials\">{{initials}}</span>", styles: [".cnet-avatar{display:flex;justify-content:center;align-items:center;overflow:hidden;background-color:#dbe3ea;background-size:cover;background-position:center}.cnet-avatar.cnet-avatar-rounded{border-radius:50%}.cnet-avatar.cnet-avatar-squared{border-radius:.25rem}.cnet-avatar.cnet-avatar-small{height:2rem;width:2rem;min-width:2rem;font-size:1rem}.cnet-avatar.cnet-avatar-normal{height:2.6rem;width:2.6rem;min-width:2.6rem;font-size:1.25rem}.cnet-avatar.cnet-avatar-large{height:4rem;width:4rem;min-width:4rem;font-size:1.625rem}.cnet-avatar-image{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;text-transform:none;width:1px}.cnet-avatar-default{width:2rem;fill:#000000d9}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAvatarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-avatar', exportAs: 'cnetAvatar', host: {
                        class: 'cnet-avatar',
                        '[attr.role]': 'showImage ? "img" : ""',
                        '[attr.aria-label]': 'alt',
                        '[class.cnet-avatar-small]': 'size == "small"',
                        '[class.cnet-avatar-normal]': 'size == "normal"',
                        '[class.cnet-avatar-large]': 'size == "large"',
                        '[class.cnet-avatar-rounded]': 'style == "rounded"',
                        '[class.cnet-avatar-squared]': 'style == "squared"',
                        '[style.background-image]': 'backgroundUrl'
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<img *ngIf=\"showImage\" \n    class=\"cnet-avatar-image\"\n    [src]=\"src\"\n    [alt]=\"alt\"\n    (error)=\"_onSrcError()\">\n\n<span *ngIf=\"showInitials\" class=\"cnet-avatar-initials\">{{initials}}</span>", styles: [".cnet-avatar{display:flex;justify-content:center;align-items:center;overflow:hidden;background-color:#dbe3ea;background-size:cover;background-position:center}.cnet-avatar.cnet-avatar-rounded{border-radius:50%}.cnet-avatar.cnet-avatar-squared{border-radius:.25rem}.cnet-avatar.cnet-avatar-small{height:2rem;width:2rem;min-width:2rem;font-size:1rem}.cnet-avatar.cnet-avatar-normal{height:2.6rem;width:2.6rem;min-width:2.6rem;font-size:1.25rem}.cnet-avatar.cnet-avatar-large{height:4rem;width:4rem;min-width:4rem;font-size:1.625rem}.cnet-avatar-image{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;text-transform:none;width:1px}.cnet-avatar-default{width:2rem;fill:#000000d9}\n"] }]
        }], propDecorators: { src: [{
                type: Input
            }], alt: [{
                type: Input
            }], text: [{
                type: Input
            }], size: [{
                type: Input
            }], style: [{
                type: Input
            }] } });

class CnetAvatarModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAvatarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetAvatarModule, declarations: [CnetAvatarComponent], imports: [CommonModule], exports: [CnetAvatarComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAvatarModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetAvatarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetAvatarComponent],
                    imports: [
                        CommonModule
                    ],
                    exports: [CnetAvatarComponent]
                }]
        }] });

class CnetBadgeDirective {
    get color() { return this._color; }
    set color(value) {
        this._color = value;
    }
    get content() { return this._content; }
    set content(value) {
        this._content = value;
    }
    get type() { return this._type; }
    set type(value) {
        this._type = value;
    }
    constructor(element) {
        this.element = element;
        this._color = 'default';
        this._type = 'flat';
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetBadgeDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetBadgeDirective, isStandalone: true, selector: "[cnet-badge], [cnetBadge]", inputs: { color: ["cnet-badge-color", "color"], content: ["cnet-badge-content", "content"], type: ["cnet-badge-type", "type"] }, host: { properties: { "class.cnet-badge-default": "color === \"default\"", "class.cnet-badge-success": "color === \"success\"", "class.cnet-badge-info": "color === \"info\"", "class.cnet-badge-warning": "color === \"warning\"", "class.cnet-badge-primary": "color === \"primary\"", "class.cnet-badge-secondary": "color === \"secondary\"", "class.cnet-badge-cnet-primary": "color === \"cnet-primary\"", "class.cnet-badge-danger": "color === \"danger\"", "class.cnet-badge-stroked": "type == \"stroked\"", "class.cnet-badge-flat": "type == \"flat\"" }, classAttribute: "cnet-badge" }, exportAs: ["cnetBadge"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetBadgeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnet-badge], [cnetBadge]',
                    exportAs: 'cnetBadge',
                    standalone: true,
                    host: {
                        class: 'cnet-badge',
                        '[class.cnet-badge-default]': 'color === "default"',
                        '[class.cnet-badge-success]': 'color === "success"',
                        '[class.cnet-badge-info]': 'color === "info"',
                        '[class.cnet-badge-warning]': 'color === "warning"',
                        '[class.cnet-badge-primary]': 'color === "primary"',
                        '[class.cnet-badge-secondary]': 'color === "secondary"',
                        '[class.cnet-badge-cnet-primary]': 'color === "cnet-primary"',
                        '[class.cnet-badge-danger]': 'color === "danger"',
                        '[class.cnet-badge-stroked]': 'type == "stroked"',
                        '[class.cnet-badge-flat]': 'type == "flat"'
                    },
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { color: [{
                type: Input,
                args: ['cnet-badge-color']
            }], content: [{
                type: Input,
                args: ['cnet-badge-content']
            }], type: [{
                type: Input,
                args: ['cnet-badge-type']
            }] } });

class BadgeListEllipsisComponent {
    constructor(el) {
        this.el = el;
        this.configCards = new QueryList();
        this.hiddenElements = [];
    }
    ngAfterContentInit() {
        this.hideElements();
    }
    onResize(event) {
        this.hideElements();
    }
    hideElements() {
        if (this.configCards?.length) {
            const totalWidth = this.el.nativeElement.offsetWidth;
            this.hiddenElements = [];
            const elements = this.configCards.toArray();
            elements.forEach(badge => badge.element.nativeElement.style.display = 'inline-block');
            let widthAux = 60;
            elements.forEach((badge, index) => {
                widthAux += badge.element.nativeElement.offsetWidth;
                if (widthAux > totalWidth) {
                    this.hiddenElements.push(index);
                    badge.element.nativeElement.style.display = 'none';
                }
            });
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BadgeListEllipsisComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: BadgeListEllipsisComponent, isStandalone: true, selector: "cnet-badge-list-ellipsis, [cnet-badge-list-ellipsis], [cnetBadgeListEllipsis]", host: { listeners: { "window:resize": "onResize($event)" } }, queries: [{ propertyName: "configCards", predicate: CnetBadgeDirective }], ngImport: i0, template: "<div>\n  <span #list style=\"width: calc(100% - 60px);\">\n    <ng-content></ng-content>\n  </span>\n  @if(hiddenElements?.length){\n  <span cnet-badge cnet-badge-type=\"stroked\" cnet-badge-color=\"default\" class=\"text-capitalize fit-content mr-1\">\n    ...\n  </span>\n  }\n</div>\n", styles: [":host{width:calc(100% - 60px)}\n"], dependencies: [{ kind: "directive", type: CnetBadgeDirective, selector: "[cnet-badge], [cnetBadge]", inputs: ["cnet-badge-color", "cnet-badge-content", "cnet-badge-type"], exportAs: ["cnetBadge"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: BadgeListEllipsisComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-badge-list-ellipsis, [cnet-badge-list-ellipsis], [cnetBadgeListEllipsis]', standalone: true, imports: [CnetBadgeDirective], template: "<div>\n  <span #list style=\"width: calc(100% - 60px);\">\n    <ng-content></ng-content>\n  </span>\n  @if(hiddenElements?.length){\n  <span cnet-badge cnet-badge-type=\"stroked\" cnet-badge-color=\"default\" class=\"text-capitalize fit-content mr-1\">\n    ...\n  </span>\n  }\n</div>\n", styles: [":host{width:calc(100% - 60px)}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { configCards: [{
                type: ContentChildren,
                args: [CnetBadgeDirective]
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });

class CnetBadgeModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetBadgeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetBadgeModule, imports: [CommonModule,
            CnetBadgeDirective,
            BadgeListEllipsisComponent], exports: [CnetBadgeDirective, BadgeListEllipsisComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetBadgeModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetBadgeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        CommonModule,
                        CnetBadgeDirective,
                        BadgeListEllipsisComponent
                    ],
                    exports: [CnetBadgeDirective, BadgeListEllipsisComponent]
                }]
        }] });

/**
 * Interface for Form Field Controls
 *
 * @export
 * @abstract
 * class CnetFormFieldControl
 * @template T
 */
class CnetFormFieldControl {
}

let nextUniqueId$k = 0;
/**
 * Directive for use inputs inside a form field
 *
 * @export
 * class CnetInputDirective
 */
class CnetInputDirective {
    constructor(ngControl, _elementRef) {
        this.ngControl = ngControl;
        this._elementRef = _elementRef;
        /** @ignore */ this._id = `cnet-input-${nextUniqueId$k++}`;
        /** @ignore */ this._required = false;
        /** @ignore */ this._disabled = false;
        /** @ignore */ this._focused = false;
        /** @ignore */ this._errorState = false;
        /**
         * Emits whenever the state of the control changes
         *
         * type {Observable<void>}
         * @memberof CnetInputDirective
         */
        this.stateChanges = new Subject();
        this._valueAcessor = this._elementRef.nativeElement;
        // this._valueAcessor = ngControl || this._elementRef.nativeElement;
    }
    /**
    * The element ID for this control.
    *
    * type {string}
    * @memberof CnetInputDirective
    */
    get id() { return this._id; }
    set id(value) { this._id = value; }
    /**
     * Whether the control is required.
     *
     * type {boolean}
     * @memberof CnetInputDirective
     */
    get required() { return this._required; }
    set required(value) { this._required = coerceBooleanProperty(value); }
    /**
     * Whether the control is disabled.
     *
     * type {boolean}
     * @memberof CnetInputDirective
     */
    get disabled() {
        if (this.ngControl && this.ngControl.disabled !== null) {
            return this.ngControl.disabled;
        }
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
        if (this.focused) {
            this.focused = false;
            this.stateChanges.next();
        }
    }
    /**
     * The value of the control
     *
     * type {(T | null)}
     * @memberof CnetInputDirective
     */
    get value() { return this._valueAcessor.value; }
    set value(value) {
        if (value !== this._valueAcessor.value) {
            this._valueAcessor.value = value;
            this.stateChanges.next();
        }
    }
    /**
     * Whether the control is focused
     *
     * type {boolean}
     * @memberof CnetInputDirective
     */
    get focused() { return this._focused; }
    set focused(value) { this._focused = coerceBooleanProperty(value); }
    /**
     * Whether the control is in an error state.
     *
     * type {boolean}
     * @memberof CnetInputDirective
     */
    get errorState() { return this._errorState; }
    set errorState(value) { this._errorState = coerceBooleanProperty(value); }
    /**
     * Error id for aria-describedby
     *
     * @readonly
     * type {string}
     * @memberof CnetInputDirective
     */
    get describedby() {
        return this.error?.id || null;
    }
    /** @ignore */
    ngDoCheck() {
        if (this.ngControl) {
            this.errorState = this.ngControl.errors !== null && (!!this.ngControl.touched || this.ngControl.dirty);
        }
        this.stateChanges.next();
    }
    /** @ignore */
    changeFocus(focused) {
        this.focused = focused;
        this.stateChanges.next();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetInputDirective, deps: [{ token: i1$4.NgControl, optional: true, self: true }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetInputDirective, selector: "cnet-input, [CnetInput], [cnet-input]", inputs: { id: "id", required: "required", disabled: "disabled", value: "value", focused: "focused", errorState: "errorState" }, host: { listeners: { "blur": "changeFocus(false)", "focus": "changeFocus(true)" }, properties: { "attr.id": "id", "attr.aria-invalid": "errorState", "attr.aria-required": "required", "attr.aria-describedby": "describedby", "disabled": "disabled", "required": "required" }, classAttribute: "cnet-input" }, providers: [{ provide: CnetFormFieldControl, useExisting: CnetInputDirective }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetInputDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-input, [CnetInput], [cnet-input]',
                    host: {
                        class: 'cnet-input',
                        '[attr.id]': 'id',
                        '[attr.aria-invalid]': 'errorState',
                        '[attr.aria-required]': 'required',
                        '[attr.aria-describedby]': 'describedby',
                        '[disabled]': 'disabled',
                        '[required]': 'required',
                        '(blur)': 'changeFocus(false)',
                        '(focus)': 'changeFocus(true)'
                    },
                    providers: [{ provide: CnetFormFieldControl, useExisting: CnetInputDirective }],
                }]
        }], ctorParameters: () => [{ type: i1$4.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ElementRef }], propDecorators: { id: [{
                type: Input
            }], required: [{
                type: Input
            }], disabled: [{
                type: Input
            }], value: [{
                type: Input
            }], focused: [{
                type: Input
            }], errorState: [{
                type: Input
            }] } });

class CnetInputModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetInputModule, declarations: [CnetInputDirective], imports: [CommonModule], exports: [CnetInputDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetInputModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetInputModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetInputDirective],
                    imports: [
                        CommonModule
                    ],
                    exports: [CnetInputDirective]
                }]
        }] });

let nextUniqueId$j = 0;
const TOGGLE_BUTTON_GROUP_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CnetButtonToggleGroupComponent),
    multi: true
};
const TOGGLE_BUTTON_GROUP_VALIDATORS = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => CnetButtonToggleGroupComponent),
    multi: true
};
class CnetButtonToggleGroupComponent extends CnetInputDirective {
    get disabled() {
        if (this.ngControl && this.ngControl.disabled !== null) {
            return this.ngControl.disabled;
        }
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
        if (this.focused) {
            this.focused = false;
            this.stateChanges.next();
        }
    }
    /**
      * The id of this option
      *
      * type {string}
      * @memberof CnetButtonToggleGroupComponent
      */
    get id() { return this._id; }
    set id(value) { this._id = value; }
    /**
   * The name of this option
   *
   * type {string}
   * @memberof CnetButtonToggleGroupComponent
   */
    get name() { return this._name; }
    set name(value) { this._name = value; }
    /**
     * Value for the button
     *
     * @readonly
     * type {boolean}
     * @memberof CnetButtonToggleGroupComponent
     */
    get value() { return this._value; }
    set value(value) {
        this._value = value;
    }
    get multiple() { return this._multiple; }
    set multiple(value) { this._multiple = coerceBooleanProperty(value); }
    /**
     * If the user interacts with the component, he isn't allowed to clear it.
     * that means once the component has an value, it can't be null or empty if user interatcs with it.
     * but it can be null or empty on form start. like: formBuilder.group({ buttonToggleControl: ['', []] });.
     * this option isn't the required validation!
     */
    get requireValueIfUserInteracts() { return this._requireValueIfUserInteracts; }
    set requireValueIfUserInteracts(value) {
        this._requireValueIfUserInteracts = !coerceBooleanProperty(value);
    }
    constructor(ngControl, elementRef) {
        super(ngControl, elementRef);
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        /** @ignore */ this._id = `cnet-button-toggle-group-${++nextUniqueId$j}`;
        /** @ignore */ this._name = this._id;
        /** @ignore */ this._value = '';
        /** @ignore */ this._disabled = false;
        this.selected = [];
        /** @ignore */ this._multiple = false;
        /** @ignore */ this._requireValueIfUserInteracts = true;
        this._buttons = new QueryList();
        this.cdr = inject(ChangeDetectorRef);
        //validaors functions
        this.onValidationChange = () => { };
        // Control Value Accessor functions
        this.onChangeCallback = (_) => { };
        /** @ignore */
        this.onTouchedCallback = () => { };
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }
    /**
  * Detects changes after view init to apply the initial configuration
  * @ignore
  * */
    ngAfterContentInit() {
        this._buttons.changes.subscribe((a) => {
            if (!(!this.multiple && Array.isArray(this.value))) {
                this._updateButtonTogges();
            }
        });
    }
    _updateButtonTogges() {
        if (this._buttons) {
            const valueAsJson = JSON.stringify(this.value);
            setTimeout(() => {
                this.selected = [];
                this._buttons.forEach(button => {
                    button.checked = valueAsJson.includes(JSON.stringify(button.value));
                    if (button.checked) {
                        this.selected.push(button);
                    }
                });
                this.cdr.markForCheck();
            }, 0);
        }
    }
    updateValueFromButtonToggle(clikedValue) {
        if (this._buttons) {
            if (!this.multiple) {
                this._buttons.forEach(b => {
                    if (b.value !== clikedValue) {
                        b.checked = false;
                    }
                });
            }
            this.selected = this._buttons.filter(button => button.checked);
            const valueAux = this._buttons.filter(button => button.checked).map(button => button.value);
            this.value = this.multiple ? valueAux : valueAux && valueAux.length ? valueAux[0] : null;
            this.onChangeCallback(this.value);
            this.onTouchedCallback();
        }
    }
    registerOnValidatorChange(fn) {
        this.onValidationChange = fn;
    }
    validate(control) {
        if (!this.multiple && Array.isArray(this.value)) {
            return { invalidForm: { valid: false, message: 'toggle button' } };
        }
        return null;
    }
    writeValue(obj) {
        if ((obj || (Array.isArray(obj) && obj.length > 0)) && JSON.stringify(this.value) !== JSON.stringify(obj)) {
            this.value = obj;
            if (!(!this.multiple && Array.isArray(obj))) {
                this._updateButtonTogges();
            }
        }
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    setDisabledState(isDisabled) {
        this._buttons.forEach(b => b.disabled = isDisabled);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetButtonToggleGroupComponent, deps: [{ token: i1$4.NgControl, optional: true, self: true }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetButtonToggleGroupComponent, selector: "cnet-button-toggle-group", inputs: { disabled: "disabled", id: "id", name: "name", value: "value", multiple: "multiple", requireValueIfUserInteracts: "requireValueIfUserInteracts" }, host: { attributes: { "role": "buttontogglegroup" }, properties: { "attr.id": "id", "attr.value": "value", "attr.name": "name" }, classAttribute: "cnet-button-toggle-group" }, queries: [{ propertyName: "_buttons", predicate: i0.forwardRef(() => CnetButtonToggleComponent), descendants: true }], usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetButtonToggleGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'cnet-button-toggle-group',
                    template: '<ng-content></ng-content>',
                    host: {
                        class: 'cnet-button-toggle-group',
                        role: 'buttontogglegroup',
                        '[attr.id]': 'id',
                        '[attr.value]': 'value',
                        '[attr.name]': 'name'
                    },
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None
                }]
        }], ctorParameters: () => [{ type: i1$4.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ElementRef }], propDecorators: { disabled: [{
                type: Input
            }], id: [{
                type: Input
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], multiple: [{
                type: Input
            }], requireValueIfUserInteracts: [{
                type: Input
            }], _buttons: [{
                type: ContentChildren,
                args: [forwardRef(() => CnetButtonToggleComponent), { descendants: true }]
            }] } });

let nextUniqueId$i = 0;
const TOGGLE_BUTTON_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CnetButtonToggleComponent),
    multi: true
};
class CnetButtonToggleComponent {
    /**
     * The id of this option
     *
     * type {string}
     * @memberof CnetButtonToggleComponent
     */
    get id() { return this._id; }
    set id(value) { this._id = value; }
    /**
     * The name of this option
     *
     * type {string}
     * @memberof CnetButtonToggleComponent
     */
    get name() { return this._name; }
    set name(value) { this._name = value; }
    /**
     * Value for the button
     *
     * @readonly
     * type {boolean}
     * @memberof CnetButtonToggleComponent
     */
    get value() { return this._value; }
    set value(value) {
        this._value = value;
    }
    /**
    * Whether this option is disabled
    *
    * @readonly
    * type boolean
    * @memberof CnetRadioComponent
    */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    constructor(buttonToggleGroup, cdr) {
        this.buttonToggleGroup = buttonToggleGroup;
        this.cdr = cdr;
        /** @ignore */ this._id = `cnet-button-toggle-${++nextUniqueId$i}`;
        /** @ignore */ this._name = this._id;
        /** @ignore */ this._value = '';
        /** @ignore */ this._disabled = false;
        /** @ignore */ this.checked = false;
        this.color = "primary";
        this.size = CnetButtonSize.Default;
        /**
         * Event emitted when the option value changes.
         *
         * @memberof CnetRadioComponent
         */
        this.change = new EventEmitter();
        // Control Value Accessor functions
        /** @ignore */
        this.onChangeCallback = (_) => { };
        /** @ignore */
        this.onTouchedCallback = () => { };
    }
    /**
   * Detects changes after view check to apply the initial configuration
   * @ignore
   * */
    ngAfterViewChecked() {
        this.cdr.detectChanges();
    }
    onButtonClick() {
        if (this.buttonToggleGroup) {
            if (!(!this.buttonToggleGroup.requireValueIfUserInteracts && this.checked && this.buttonToggleGroup.selected.length === 1)) {
                this.checkButton();
                this.buttonToggleGroup.updateValueFromButtonToggle(this.value);
            }
        }
        else {
            this.checkButton();
        }
    }
    checkButton() {
        this.checked = !this.checked;
        this.onTouchedCallback();
        if (this.checked) {
            this.onChangeCallback(this.value);
        }
        else {
            this.onChangeCallback('');
        }
    }
    writeValue(obj) {
        this.checked = JSON.stringify(this.value) === JSON.stringify(obj);
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetButtonToggleComponent, deps: [{ token: CnetButtonToggleGroupComponent, optional: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetButtonToggleComponent, selector: "cnet-button-toggle", inputs: { id: "id", name: "name", value: "value", disabled: "disabled", color: "color", size: "size" }, outputs: { change: "change" }, host: { properties: { "class.cnet-button-toggle-checked": "checked", "class.cnet-button-toggle-disabled": "disabled" }, classAttribute: "cnet-button-toggle" }, providers: [TOGGLE_BUTTON_VALUE_ACCESSOR], ngImport: i0, template: "<button cnet-filled-button type=\"button\" [color]=\"checked ? color: ''\" [size]=\"size\" [disabled]=\"disabled\" [id]=\"id\"\n  (click)=\"onButtonClick()\">\n  <ng-content></ng-content>\n</button>\n", styles: [".cnet-button-toggle-checked.cnet-button-toggle-disabled .cnet-button{background-color:var(--cnet-cancel-400, #bdbdbd)!important;color:var(--cnet-cancel-contrast-500, white)!important}\n"], dependencies: [{ kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetButtonToggleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-button-toggle', host: {
                        class: 'cnet-button-toggle',
                        '[class.cnet-button-toggle-checked]': 'checked',
                        '[class.cnet-button-toggle-disabled]': 'disabled',
                    }, providers: [TOGGLE_BUTTON_VALUE_ACCESSOR], changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<button cnet-filled-button type=\"button\" [color]=\"checked ? color: ''\" [size]=\"size\" [disabled]=\"disabled\" [id]=\"id\"\n  (click)=\"onButtonClick()\">\n  <ng-content></ng-content>\n</button>\n", styles: [".cnet-button-toggle-checked.cnet-button-toggle-disabled .cnet-button{background-color:var(--cnet-cancel-400, #bdbdbd)!important;color:var(--cnet-cancel-contrast-500, white)!important}\n"] }]
        }], ctorParameters: () => [{ type: CnetButtonToggleGroupComponent, decorators: [{
                    type: Optional
                }] }, { type: i0.ChangeDetectorRef }], propDecorators: { id: [{
                type: Input
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }], color: [{
                type: Input
            }], size: [{
                type: Input
            }], change: [{
                type: Output
            }] } });

class CnetButtonToggleModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetButtonToggleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetButtonToggleModule, declarations: [CnetButtonToggleComponent,
            CnetButtonToggleGroupComponent], imports: [CommonModule,
            CnetButtonModule], exports: [CnetButtonToggleComponent,
            CnetButtonToggleGroupComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetButtonToggleModule, imports: [CommonModule,
            CnetButtonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetButtonToggleModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnetButtonToggleComponent,
                        CnetButtonToggleGroupComponent
                    ],
                    exports: [
                        CnetButtonToggleComponent,
                        CnetButtonToggleGroupComponent
                    ],
                    imports: [
                        CommonModule,
                        CnetButtonModule
                    ]
                }]
        }] });

class CnetCardContentDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCardContentDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetCardContentDirective, selector: "cnet-card-content, [cnet-card-content], [cnetCardContent]", host: { classAttribute: "cnet-card-content" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCardContentDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-card-content, [cnet-card-content], [cnetCardContent]',
                    host: { class: 'cnet-card-content' }
                }]
        }] });
class CnetCardActionsDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCardActionsDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetCardActionsDirective, selector: "cnet-card-actions, [cnet-card-actions], [cnetCardActions]", host: { classAttribute: "cnet-card-actions" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCardActionsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-card-actions, [cnet-card-actions], [cnetCardActions]',
                    host: { class: 'cnet-card-actions' }
                }]
        }] });
class CnetCardComponent {
    constructor() { }
    ngOnInit() {
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetCardComponent, selector: "cnet-card", host: { classAttribute: "cnet-card" }, exportAs: ["cnetCard"], ngImport: i0, template: "<ng-content></ng-content>\n", styles: [".cnet-card{position:relative;display:block;min-width:0;background-color:#fff;background-clip:border-box;border:1px solid #eeeeee;border-radius:.25rem;overflow:hidden;padding:1rem;margin-bottom:1rem}.cnet-card .cnet-card-header{display:flex;margin:-1rem -1rem 1rem;padding:1rem;border-bottom:1px solid #eeeeee}.cnet-card .cnet-card-header .cnet-card-actions{margin-left:-.5rem}.cnet-card .cnet-card-header .cnet-card-actions .cnet-button{margin-left:.5rem}.cnet-card .cnet-card-title-wrap{flex:1;display:flex;flex-direction:column;justify-content:center;gap:.5rem}.cnet-card .cnet-card-title{font-weight:400;font-size:1.125rem;text-transform:uppercase;margin-top:.125rem;margin-bottom:0}.cnet-card .cnet-card-subtitle{color:#000000ab;font-weight:400;margin:0}.cnet-card .cnet-card-footer{display:block;padding:1rem;margin:1rem -1rem -1rem;border-top:1px solid #eeeeee;background:#fafafa}.cnet-card .cnet-card-footer .cnet-card-actions{margin-left:-1rem;margin-top:-1rem}.cnet-card .cnet-card-footer .cnet-card-actions .cnet-button{margin-top:1rem;margin-left:1rem}@media (max-width: 767.98px){.cnet-card .cnet-card-header{flex-direction:column}.cnet-card .cnet-card-header .cnet-card-actions .cnet-button{margin-top:.5rem!important}}@media (max-width: 575.98px){.cnet-card .cnet-card-footer .cnet-card-actions{display:flex;flex-direction:column-reverse}}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-card', exportAs: 'cnetCard', host: {
                        class: 'cnet-card',
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<ng-content></ng-content>\n", styles: [".cnet-card{position:relative;display:block;min-width:0;background-color:#fff;background-clip:border-box;border:1px solid #eeeeee;border-radius:.25rem;overflow:hidden;padding:1rem;margin-bottom:1rem}.cnet-card .cnet-card-header{display:flex;margin:-1rem -1rem 1rem;padding:1rem;border-bottom:1px solid #eeeeee}.cnet-card .cnet-card-header .cnet-card-actions{margin-left:-.5rem}.cnet-card .cnet-card-header .cnet-card-actions .cnet-button{margin-left:.5rem}.cnet-card .cnet-card-title-wrap{flex:1;display:flex;flex-direction:column;justify-content:center;gap:.5rem}.cnet-card .cnet-card-title{font-weight:400;font-size:1.125rem;text-transform:uppercase;margin-top:.125rem;margin-bottom:0}.cnet-card .cnet-card-subtitle{color:#000000ab;font-weight:400;margin:0}.cnet-card .cnet-card-footer{display:block;padding:1rem;margin:1rem -1rem -1rem;border-top:1px solid #eeeeee;background:#fafafa}.cnet-card .cnet-card-footer .cnet-card-actions{margin-left:-1rem;margin-top:-1rem}.cnet-card .cnet-card-footer .cnet-card-actions .cnet-button{margin-top:1rem;margin-left:1rem}@media (max-width: 767.98px){.cnet-card .cnet-card-header{flex-direction:column}.cnet-card .cnet-card-header .cnet-card-actions .cnet-button{margin-top:.5rem!important}}@media (max-width: 575.98px){.cnet-card .cnet-card-footer .cnet-card-actions{display:flex;flex-direction:column-reverse}}\n"] }]
        }], ctorParameters: () => [] });

class CnetCardTitleDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCardTitleDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetCardTitleDirective, selector: "cnet-card-title, [cnet-card-title], [cnetCardTitle]", host: { classAttribute: "cnet-card-title" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCardTitleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-card-title, [cnet-card-title], [cnetCardTitle]',
                    host: { class: 'cnet-card-title' }
                }]
        }] });
class CnetCardSubtitleDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCardSubtitleDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetCardSubtitleDirective, selector: "cnet-card-subtitle, [cnet-card-subtitle], [cnetCardSubTitle]", host: { classAttribute: "cnet-card-subtitle" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCardSubtitleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-card-subtitle, [cnet-card-subtitle], [cnetCardSubTitle]',
                    host: { class: 'cnet-card-subtitle' }
                }]
        }] });
class CardHeaderComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardHeaderComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CardHeaderComponent, selector: "cnet-card-header, [cnet-card-header], [cnetCardHeader]", host: { classAttribute: "cnet-card-header" }, exportAs: ["cnetCardHeader"], ngImport: i0, template: "<div class=\"cnet-card-title-wrap\">\n  <ng-content select=\"cnet-card-title, [cnet-card-title], [cnetCardTitle]\"></ng-content>\n  <ng-content select=\"cnet-card-subtitle, [cnet-card-subtitle], [cnetCardSubtitle]\"></ng-content>\n</div>\n<ng-content select=\"cnet-card-actions, [cnet-card-actions], [cnetCardActions]\"></ng-content>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-card-header, [cnet-card-header], [cnetCardHeader]', exportAs: 'cnetCardHeader', host: {
                        class: 'cnet-card-header',
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<div class=\"cnet-card-title-wrap\">\n  <ng-content select=\"cnet-card-title, [cnet-card-title], [cnetCardTitle]\"></ng-content>\n  <ng-content select=\"cnet-card-subtitle, [cnet-card-subtitle], [cnetCardSubtitle]\"></ng-content>\n</div>\n<ng-content select=\"cnet-card-actions, [cnet-card-actions], [cnetCardActions]\"></ng-content>\n" }]
        }] });

class CnetCardFooterComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCardFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetCardFooterComponent, selector: "cnet-card-footer, [cnet-card-footer], [cnetCardFooter]", host: { classAttribute: "cnet-card-footer" }, exportAs: ["cnetCardFooter"], ngImport: i0, template: "<ng-content select=\"cnet-card-actions, [cnet-card-actions], [cnetCardActions]\"></ng-content>\n<ng-content></ng-content>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCardFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-card-footer, [cnet-card-footer], [cnetCardFooter]', exportAs: 'cnetCardFooter', host: {
                        class: 'cnet-card-footer',
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<ng-content select=\"cnet-card-actions, [cnet-card-actions], [cnetCardActions]\"></ng-content>\n<ng-content></ng-content>\n" }]
        }] });

class CnetCardModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetCardModule, declarations: [CnetCardComponent,
            CardHeaderComponent,
            CnetCardTitleDirective,
            CnetCardSubtitleDirective,
            CnetCardContentDirective,
            CnetCardActionsDirective,
            CnetCardFooterComponent], imports: [CommonModule], exports: [CnetCardComponent,
            CardHeaderComponent,
            CnetCardTitleDirective,
            CnetCardSubtitleDirective,
            CnetCardContentDirective,
            CnetCardActionsDirective,
            CnetCardFooterComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCardModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnetCardComponent,
                        CardHeaderComponent,
                        CnetCardTitleDirective,
                        CnetCardSubtitleDirective,
                        CnetCardContentDirective,
                        CnetCardActionsDirective,
                        CnetCardFooterComponent,
                    ],
                    imports: [
                        CommonModule
                    ],
                    exports: [
                        CnetCardComponent,
                        CardHeaderComponent,
                        CnetCardTitleDirective,
                        CnetCardSubtitleDirective,
                        CnetCardContentDirective,
                        CnetCardActionsDirective,
                        CnetCardFooterComponent
                    ]
                }]
        }] });

const RADIOGROUP_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CnetRadioGroupComponent),
    multi: true
};
let nextUniqueId$h = 0;
/**
 * Cnet Radio Group is a container for one or more Cnet Radios
 *
 * @export
 * implements {ControlValueAccessor}
 */
class CnetRadioGroupComponent {
    constructor() {
        /** @ignore */ this._id = `cnet-radio-group-${++nextUniqueId$h}`;
        /** @ignore */ this._name = this._id;
        /** @ignore */ this._value = false;
        /** @ignore */ this._disabled = false;
        /** @ignore */ this._color = "primary";
        /** @ignore */
        this.onChangeCallback = (_) => { };
        /** @ignore */
        this.onTouchedCallback = () => { };
    }
    /**
     * The id of this group
     *
     * type {string}
     * @memberof CnetRadioGroupComponent
     */
    get id() { return this._id; }
    set id(value) { this._id = value; }
    /**
     * The name of this group
     *
     * type {string}
     * @memberof CnetRadioGroupComponent
     */
    get name() { return this._name; }
    set name(value) {
        if (this._name !== value) {
            this._updateRadioButtonNames();
        }
    }
    /**
     * Value for this group
     *
     * type {*}
     * @memberof CnetRadioGroupComponent
     */
    get value() { return this._value; }
    set value(value) {
        if (JSON.stringify(this._value) !== JSON.stringify(value)) {
            this._value = value;
            this._updateSelectedRadioFromValue();
            this.onChangeCallback(this._value);
        }
    }
    /**
     * Whether this group is disabled
     *
     * type {boolean}
     * @memberof CnetRadioGroupComponent
     */
    get disabled() { return this._disabled; }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * The color for the radio buttons
     *
     * type {CnetColorPalette}
     * @memberof CnetRadioGroupComponent
     */
    get color() { return this._color; }
    set color(value) { this._color = value; }
    /**
     * The selected Cnet Radio
     *
     * @readonly
     * type {CnetRadioComponent}
     * @memberof CnetRadioGroupComponent
     */
    get selected() { return this._selected; }
    /** @ignore */
    writeValue(value) {
        this.value = value;
    }
    /**
     * Registers a callback function that is called when the control's value changes in the UI.
     *
     * param  fn
     * @memberof CnetRadioGroupComponent
     */
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    /**
     * Registers a callback function is called by the forms API on initialization to update the form model on blur.
     *
     * param  fn
     * @memberof CnetRadioGroupComponent
     */
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    /** @ignore */
    _updateRadioButtonNames() {
        if (this._radios) {
            this._radios.forEach(radio => {
                radio.name = this.name;
            });
        }
    }
    /** @ignore */
    _updateSelectedRadioFromValue() {
        if (this._radios) {
            this._radios.forEach(radio => {
                radio.checked = JSON.stringify(this.value) == JSON.stringify(radio.value);
                if (radio.checked) {
                    this._selected = radio;
                }
            });
        }
    }
    setDisabledState(isDisabled) {
        // this.formulario.disable();
        this.disabled = isDisabled;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetRadioGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetRadioGroupComponent, selector: "cnet-radio-group", inputs: { id: "id", name: "name", value: "value", disabled: "disabled", color: "color" }, host: { attributes: { "role": "radiogroup" }, properties: { "class.cnet-color-primary": "color == \"primary\"", "class.cnet-color-secondary": "color == \"secondary\"", "class.cnet-color-danger": "color == \"danger\"", "attr.id": "id", "attr.value": "value", "attr.name": "name", "class.disabled": "this.disabled" }, classAttribute: "cnet-radio-group" }, providers: [RADIOGROUP_VALUE_ACCESSOR], queries: [{ propertyName: "_radios", predicate: i0.forwardRef(() => CnetRadioComponent), descendants: true }], exportAs: ["cnetRadioGroup"], ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetRadioGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'cnet-radio-group',
                    exportAs: 'cnetRadioGroup',
                    host: {
                        class: 'cnet-radio-group',
                        role: 'radiogroup',
                        '[class.cnet-color-primary]': 'color == "primary"',
                        '[class.cnet-color-secondary]': 'color == "secondary"',
                        '[class.cnet-color-danger]': 'color == "danger"',
                        '[attr.id]': 'id',
                        '[attr.value]': 'value',
                        '[attr.name]': 'name'
                    },
                    template: '<ng-content></ng-content>',
                    providers: [RADIOGROUP_VALUE_ACCESSOR],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None
                }]
        }], propDecorators: { id: [{
                type: Input
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.disabled']
            }], color: [{
                type: Input
            }], _radios: [{
                type: ContentChildren,
                args: [forwardRef(() => CnetRadioComponent), { descendants: true }]
            }] } });

let nextUniqueId$g = 0;
const RADIO_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CnetRadioComponent),
    multi: true
};
/**
 * The Radio Button allows the user to select a single option from an available set of options.
 *
 * @export
 * implements {OnInit}
 * implements {ControlValueAccessor}
 */
class CnetRadioComponent {
    /**
     * The id of this option
     *
     * type {string}
     * @memberof CnetRadioComponent
     */
    get id() { return this._id; }
    set id(value) { this._id = value; }
    /**
     * The name of this option
     *
     * type {string}
     * @memberof CnetRadioComponent
     */
    get name() { return this._name; }
    set name(value) { this._name = value; }
    /**
     * Whether this option is checked
     *
     * @readonly
     * type {boolean}
     * @memberof CnetRadioComponent
     */
    get checked() { return this._checked; }
    set checked(value) {
        value = coerceBooleanProperty(value);
        if (this._checked !== value) {
            this._checked = value;
            if (this._checked && this.radioGroup && JSON.stringify(this.radioGroup.value) !== JSON.stringify(this.value)) {
                this.radioGroup.value = this.value;
            }
            this.onChangeCallback(this._value);
        }
    }
    /**
     * Value for the radio button
     *
     * @readonly
     * type {boolean}
     * @memberof CnetRadioComponent
     */
    get value() { return this._value; }
    set value(value) {
        if (JSON.stringify(this.value) !== JSON.stringify(value)) {
            this._value = value;
            if (this.radioGroup) {
                this._checked = JSON.stringify(this.radioGroup.value) === JSON.stringify(this.value);
            }
            this.onChangeCallback(this._value);
        }
    }
    /**
     * Whether this option is disabled
     *
     * @readonly
     * type boolean
     * @memberof CnetRadioComponent
     */
    get disabled() {
        return this._disabled || (this.radioGroup != null && this.radioGroup.disabled);
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    constructor(radioGroup, cdr) {
        this.radioGroup = radioGroup;
        this.cdr = cdr;
        /** @ignore */ this._id = `cnet-radio-${++nextUniqueId$g}`;
        /** @ignore */ this._name = this._id;
        /** @ignore */ this._checked = false;
        /** @ignore */ this._value = false;
        /** @ignore */ this._disabled = false;
        this.enableUncheck = input(true);
        /**
         * Event emitted when the option value changes.
         *
         * @memberof CnetRadioComponent
         */
        this.change = new EventEmitter();
        /**
         * Event emitted when the option is no longer focused.
         *
         * @memberof CnetRadioComponent
         */
        this.blur = new EventEmitter();
        /**
         * Event emitted when the option receives focus.
         *
         * @memberof CnetRadioComponent
         */
        this.focus = new EventEmitter();
        /** @ignore */
        this.onChangeCallback = (_) => { };
        /** @ignore */
        this.onTouchedCallback = () => { };
        this.radioGroup = radioGroup;
    }
    /** @ignore */
    ngOnInit() {
        if (this.radioGroup) {
            this.checked = JSON.stringify(this.radioGroup.value) === JSON.stringify(this._value);
            this.name = this.radioGroup.name;
        }
    }
    /**
     * Detects changes after view check to apply the initial configuration
     * @ignore
     * */
    ngAfterViewChecked() {
        this.cdr.detectChanges();
    }
    /** @ignore */
    _onInputChange(event) {
        event.stopPropagation();
        this.change.emit(event);
        this.checked = true;
        if (this.radioGroup) {
            this.radioGroup.value = this.value;
        }
    }
    /** @ignore */
    writeValue(value) {
        this.value = value;
    }
    /**
     * Registers a callback function that is called when the control's value changes in the UI.
     *
     * @memberof CnetRadioComponent
     */
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    /**
     * Registers a callback function is called by the forms API on initialization to update the form model on blur.
     *
     * @memberof CnetRadioComponent
     */
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    radioClick(event) {
        event.stopPropagation();
        if (this.checked && this.enableUncheck()) {
            this.change.emit(event);
            this.checked = false;
            if (this.radioGroup) {
                this.radioGroup.value = '';
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetRadioComponent, deps: [{ token: CnetRadioGroupComponent, optional: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "17.3.12", type: CnetRadioComponent, selector: "cnet-radio", inputs: { id: { classPropertyName: "id", publicName: "id", isSignal: false, isRequired: false, transformFunction: null }, name: { classPropertyName: "name", publicName: "name", isSignal: false, isRequired: false, transformFunction: null }, checked: { classPropertyName: "checked", publicName: "checked", isSignal: false, isRequired: false, transformFunction: null }, value: { classPropertyName: "value", publicName: "value", isSignal: false, isRequired: false, transformFunction: null }, disabled: { classPropertyName: "disabled", publicName: "disabled", isSignal: false, isRequired: false, transformFunction: null }, enableUncheck: { classPropertyName: "enableUncheck", publicName: "enableUncheck", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { change: "change", blur: "blur", focus: "focus" }, host: { properties: { "class.cnet-radio-checked": "checked", "class.cnet-radio-disabled": "disabled", "class.disabled": "this.disabled" }, classAttribute: "cnet-radio" }, providers: [RADIO_VALUE_ACCESSOR], exportAs: ["cnetRadio"], ngImport: i0, template: "<label class=\"cnet-radio-label\" #label>\n    <input\n    type=\"radio\"\n    class=\"cnet-radio-input\"\n    [id]=\"id\"\n    [checked]=\"checked\"\n    [disabled]=\"disabled\"\n    [name]=\"name\"\n    (focus)=\"focus.emit($event)\"\n    (blur)=\"blur.emit($event)\"\n    (change)=\"_onInputChange($event)\"\n    (click)=\"radioClick($event)\"\n    tabindex=\"0\"/>\n\n    <div class=\"cnet-radio-check\" cnetRipple [cnetRippleDisabled]=\"disabled\" cnetRippleCentered=\"true\" [cnetRippleTrigger]=\"label\">\n        <div class=\"cnet-radio-check-overlay\"></div>\n        <div class=\"cnet-radio-check-icon\">\n            <i class=\"la la-check\"></i>\n        </div>\n    </div>\n\n    <div class=\"cnet-radio-content\">\n        <ng-content></ng-content>\n    </div>\n</label>\n", styles: [".cnet-radio-group{display:flex;flex-wrap:wrap;margin-bottom:.5rem}.cnet-radio{display:block;margin-right:1rem}.cnet-radio-label{display:flex;cursor:pointer;margin-bottom:0;-webkit-user-select:none;user-select:none;font-weight:500}.cnet-radio:not(.cnet-radio-disabled) .cnet-radio-label:hover:not(:active) .cnet-radio-check-overlay,.cnet-radio:not(.cnet-radio-disabled) .cnet-radio-input:focus~.cnet-radio-check:not(:active) .cnet-radio-check-overlay{opacity:1}.cnet-radio-input{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;outline:0;-webkit-appearance:none}.cnet-radio-check{display:flex;position:relative;height:36px;width:36px;min-width:36px;border-radius:50%;overflow:hidden;justify-content:center;align-items:center;margin-left:-.5rem}.cnet-radio-check .cnet-radio-check-icon{transition:all ease .3s;display:flex;justify-content:center;align-items:center;height:20px;width:20px;border-radius:50%;background-color:#fff;border-width:1px;border-style:solid;border-color:var(--cnet--300, #e0e0e0)}.cnet-radio-check .cnet-radio-check-icon i{color:#fff;visibility:hidden;opacity:0;font-size:.8rem}.cnet-radio-check-overlay{height:100%;width:100%;position:absolute;background:#0000000a;opacity:0;transition:all ease .3s}.cnet-radio-content{padding-top:9px}.cnet-radio-checked label{color:var(--cnet--700, #616161)!important}.cnet-radio-checked .cnet-radio-check .cnet-radio-check-icon i{visibility:visible;opacity:1}.cnet-radio-disabled .cnet-radio-label{cursor:default;color:#0000006b}.cnet-radio-disabled .cnet-radio-check .cnet-radio-check-icon{background-color:var(--cnet--200, #eeeeee)}.cnet-radio-disabled.cnet-radio-checked .cnet-radio-check .cnet-radio-check-icon{background-color:var(--cnet--400, #bdbdbd)}.cnet-radio-checked:not(.cnet-radio-disabled) .cnet-radio-check-icon{border-color:var(--cnet-primary-500, #82c14f);background-color:var(--cnet-primary-500, #82c14f)}.cnet-color-secondary .cnet-radio-checked:not(.cnet-radio-disabled) .cnet-radio-check-icon{border-color:var(--cnet-secondary-500, #3d4155);background-color:var(--cnet-secondary-500, #3d4155)}.cnet-color-danger .cnet-radio-checked:not(.cnet-radio-disabled) .cnet-radio-check-icon{border-color:var(--cnet-danger-500, #ee4446);background-color:var(--cnet-danger-500, #ee4446)}\n"], dependencies: [{ kind: "directive", type: CnetRippleDirective, selector: "[cnet-ripple], [cnetRipple]", inputs: ["cnetRippleColor", "cnetRippleUnbounded", "cnetRippleCentered", "cnetRippleRadius", "cnetRippleAnimation", "cnetRippleDisabled", "cnetRippleTrigger"], exportAs: ["cnetRipple"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetRadioComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-radio', exportAs: 'cnetRadio', host: {
                        class: 'cnet-radio',
                        '[class.cnet-radio-checked]': 'checked',
                        '[class.cnet-radio-disabled]': 'disabled'
                    }, providers: [RADIO_VALUE_ACCESSOR], changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<label class=\"cnet-radio-label\" #label>\n    <input\n    type=\"radio\"\n    class=\"cnet-radio-input\"\n    [id]=\"id\"\n    [checked]=\"checked\"\n    [disabled]=\"disabled\"\n    [name]=\"name\"\n    (focus)=\"focus.emit($event)\"\n    (blur)=\"blur.emit($event)\"\n    (change)=\"_onInputChange($event)\"\n    (click)=\"radioClick($event)\"\n    tabindex=\"0\"/>\n\n    <div class=\"cnet-radio-check\" cnetRipple [cnetRippleDisabled]=\"disabled\" cnetRippleCentered=\"true\" [cnetRippleTrigger]=\"label\">\n        <div class=\"cnet-radio-check-overlay\"></div>\n        <div class=\"cnet-radio-check-icon\">\n            <i class=\"la la-check\"></i>\n        </div>\n    </div>\n\n    <div class=\"cnet-radio-content\">\n        <ng-content></ng-content>\n    </div>\n</label>\n", styles: [".cnet-radio-group{display:flex;flex-wrap:wrap;margin-bottom:.5rem}.cnet-radio{display:block;margin-right:1rem}.cnet-radio-label{display:flex;cursor:pointer;margin-bottom:0;-webkit-user-select:none;user-select:none;font-weight:500}.cnet-radio:not(.cnet-radio-disabled) .cnet-radio-label:hover:not(:active) .cnet-radio-check-overlay,.cnet-radio:not(.cnet-radio-disabled) .cnet-radio-input:focus~.cnet-radio-check:not(:active) .cnet-radio-check-overlay{opacity:1}.cnet-radio-input{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;outline:0;-webkit-appearance:none}.cnet-radio-check{display:flex;position:relative;height:36px;width:36px;min-width:36px;border-radius:50%;overflow:hidden;justify-content:center;align-items:center;margin-left:-.5rem}.cnet-radio-check .cnet-radio-check-icon{transition:all ease .3s;display:flex;justify-content:center;align-items:center;height:20px;width:20px;border-radius:50%;background-color:#fff;border-width:1px;border-style:solid;border-color:var(--cnet--300, #e0e0e0)}.cnet-radio-check .cnet-radio-check-icon i{color:#fff;visibility:hidden;opacity:0;font-size:.8rem}.cnet-radio-check-overlay{height:100%;width:100%;position:absolute;background:#0000000a;opacity:0;transition:all ease .3s}.cnet-radio-content{padding-top:9px}.cnet-radio-checked label{color:var(--cnet--700, #616161)!important}.cnet-radio-checked .cnet-radio-check .cnet-radio-check-icon i{visibility:visible;opacity:1}.cnet-radio-disabled .cnet-radio-label{cursor:default;color:#0000006b}.cnet-radio-disabled .cnet-radio-check .cnet-radio-check-icon{background-color:var(--cnet--200, #eeeeee)}.cnet-radio-disabled.cnet-radio-checked .cnet-radio-check .cnet-radio-check-icon{background-color:var(--cnet--400, #bdbdbd)}.cnet-radio-checked:not(.cnet-radio-disabled) .cnet-radio-check-icon{border-color:var(--cnet-primary-500, #82c14f);background-color:var(--cnet-primary-500, #82c14f)}.cnet-color-secondary .cnet-radio-checked:not(.cnet-radio-disabled) .cnet-radio-check-icon{border-color:var(--cnet-secondary-500, #3d4155);background-color:var(--cnet-secondary-500, #3d4155)}.cnet-color-danger .cnet-radio-checked:not(.cnet-radio-disabled) .cnet-radio-check-icon{border-color:var(--cnet-danger-500, #ee4446);background-color:var(--cnet-danger-500, #ee4446)}\n"] }]
        }], ctorParameters: () => [{ type: CnetRadioGroupComponent, decorators: [{
                    type: Optional
                }] }, { type: i0.ChangeDetectorRef }], propDecorators: { id: [{
                type: Input
            }], name: [{
                type: Input
            }], checked: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.disabled']
            }], change: [{
                type: Output
            }], blur: [{
                type: Output
            }], focus: [{
                type: Output
            }] } });

class CnetRadioModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetRadioModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetRadioModule, declarations: [CnetRadioComponent,
            CnetRadioGroupComponent], imports: [CommonModule,
            FormsModule,
            CnetRippleModule], exports: [CnetRadioComponent,
            CnetRadioGroupComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetRadioModule, imports: [CommonModule,
            FormsModule,
            CnetRippleModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetRadioModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnetRadioComponent,
                        CnetRadioGroupComponent
                    ],
                    imports: [
                        CommonModule,
                        FormsModule,
                        CnetRippleModule
                    ],
                    exports: [
                        CnetRadioComponent,
                        CnetRadioGroupComponent
                    ]
                }]
        }] });

let nextUniqueId$f = 0;
const CNET_CARD_SELECT_GROUP = new InjectionToken('SelectCardGroupDirective');
class SelectCardGroupDirective {
    get selected() {
        return this._selected;
    }
    set selected(selected) {
        this._selected = selected;
        this.value = selected ? selected.value() : null;
    }
    constructor() {
        /** @ignore */ this._id = `cnet-card-select-group-${++nextUniqueId$f}`;
        /** @ignore */ this._name = this._id;
        this.name = input(this._id);
        this.id = input(this._id);
        this.ngControl = inject(NgControl, { optional: true });
        this.cdr = inject(ChangeDetectorRef);
        this.disabled = model(false);
        this._selected = null;
        this.onTouchedCallback = () => { };
        this.onChangeCallback = (_) => { };
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }
    _checkSelectedRadioButton() {
        if (this._selected && !this._selected.checked) {
            this._selected.checked.set(true);
        }
    }
    _updateSelectedRadioFromValue() {
        if (this._cardSelects) {
            this._cardSelects.forEach(cardSelect => {
                cardSelect.checked.set(this.value === cardSelect.value());
            });
        }
    }
    ngOnDestroy() {
        this._cardChanges?.unsubscribe();
    }
    change(selected) {
        if (!this.disabled()) {
            this.selected = selected;
            this._updateSelectedRadioFromValue();
            this.onChangeCallback(this.value ? this.value : null);
            this.cdr.detectChanges();
        }
    }
    writeValue(obj) {
        this.value = obj;
        setTimeout(() => {
            const selected = this._cardSelects.find(cs => cs.value() === obj);
            if (selected) {
                this.change(selected);
            }
        }, 0);
        this.cdr.markForCheck();
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled.set(isDisabled);
        setTimeout(() => {
            this._cardSelects.forEach(cs => {
                if (!cs.disabled()) {
                    cs.disabled.set(isDisabled);
                }
            });
        }, 0);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectCardGroupDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "17.1.0", version: "17.3.12", type: SelectCardGroupDirective, isStandalone: true, selector: "[cnetSelectCardGroup], cnet-select-card-group", inputs: { name: { classPropertyName: "name", publicName: "name", isSignal: true, isRequired: false, transformFunction: null }, id: { classPropertyName: "id", publicName: "id", isSignal: true, isRequired: false, transformFunction: null }, disabled: { classPropertyName: "disabled", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null }, selected: { classPropertyName: "selected", publicName: "selected", isSignal: false, isRequired: false, transformFunction: null } }, outputs: { disabled: "disabledChange" }, host: { attributes: { "role": "cnet-select-card-group" }, properties: { "attr.id": "id()" }, classAttribute: "cnet-select-card-group" }, providers: [
            { provide: CNET_CARD_SELECT_GROUP, useExisting: SelectCardGroupDirective },
        ], queries: [{ propertyName: "_cardSelects", predicate: i0.forwardRef(() => CardSelectComponent), descendants: true }], exportAs: ["cnetSelectCardGroup"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectCardGroupDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetSelectCardGroup], cnet-select-card-group',
                    standalone: true,
                    exportAs: 'cnetSelectCardGroup',
                    host: {
                        'role': 'cnet-select-card-group',
                        'class': 'cnet-select-card-group',
                        '[attr.id]': 'id()'
                    },
                    providers: [
                        { provide: CNET_CARD_SELECT_GROUP, useExisting: SelectCardGroupDirective },
                    ],
                }]
        }], ctorParameters: () => [], propDecorators: { selected: [{
                type: Input
            }], _cardSelects: [{
                type: ContentChildren,
                args: [forwardRef(() => CardSelectComponent), { descendants: true }]
            }] } });

let nextUniqueId$e = 0;
class CardSelectComponent {
    get focused() { return this._focused; }
    set focused(value) { this._focused = coerceBooleanProperty(value); }
    constructor(fm, elRef) {
        this.fm = fm;
        this.elRef = elRef;
        /** @ignore */ this._id = `cnet-card-select-${++nextUniqueId$e}`;
        /** @ignore */ this._name = this._id;
        this.selectedControl = new FormControl(false, []);
        this.name = input(this._id);
        this.id = input(this._id);
        this.value = input();
        this.checked = model(false);
        this.disabled = model(false);
        this._focused = false;
        this.ngControl = inject(NgControl, { optional: true });
        this.cdr = inject(ChangeDetectorRef);
        this.stateChanges = new Subject();
        this.onTouchedCallback = () => { };
        this.onChangeCallback = (_) => { };
        fm.monitor(elRef.nativeElement, true).subscribe(origin => {
            this.focused = !!origin;
            this.stateChanges.next();
        });
        const cardsGroups = inject(CNET_CARD_SELECT_GROUP, { optional: true });
        this.cardsGroup = cardsGroups;
        if (this.ngControl && !cardsGroups) {
            this.ngControl.valueAccessor = this;
        }
    }
    ngOnInit() {
    }
    ngAfterViewChecked() {
        this.cdr.detectChanges();
    }
    ngOnDestroy() {
        this.fm.stopMonitoring(this.elRef.nativeElement);
    }
    change() {
        if (!this.disabled()) {
            if (this.cardsGroup) {
                this.cardsGroup.change(this);
            }
            else {
                this.checked.set(!this.checked());
                this.onChangeCallback(this.checked() ? this.value() : null);
            }
        }
    }
    writeValue(obj) {
        this.checked.set(obj === this.value());
    }
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled.set(isDisabled);
    }
    /** @ignore */
    inputClick() {
        this.change();
    }
    onKeydownHandler(event) {
        if (event.key === 'Enter' || event.key === 'Spacebar' || event.key === ' ') {
            if (this.focused) {
                this.change();
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSelectComponent, deps: [{ token: i1$2.FocusMonitor }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "17.3.12", type: CardSelectComponent, isStandalone: true, selector: "cnet-card-select", inputs: { name: { classPropertyName: "name", publicName: "name", isSignal: true, isRequired: false, transformFunction: null }, id: { classPropertyName: "id", publicName: "id", isSignal: true, isRequired: false, transformFunction: null }, value: { classPropertyName: "value", publicName: "value", isSignal: true, isRequired: false, transformFunction: null }, checked: { classPropertyName: "checked", publicName: "checked", isSignal: true, isRequired: false, transformFunction: null }, disabled: { classPropertyName: "disabled", publicName: "disabled", isSignal: true, isRequired: false, transformFunction: null } }, outputs: { checked: "checkedChange", disabled: "disabledChange" }, host: { attributes: { "role": "card" }, listeners: { "click": "inputClick()", "document:keydown": "onKeydownHandler($event)" }, properties: { "attr.id": "id()", "class.checked": "checked() === true", "class.disabled": "disabled() === true" }, classAttribute: "cnet-card-select" }, exportAs: ["cnetCardSelect"], ngImport: i0, template: "<div class=\"cnet-select-card-radio\">\n  <ng-template *ngTemplateOutlet=\"cnetCardSelectRadio\" />\n</div>\n<div class=\"d-flex flex-column cnet-select-card-container\">\n  <header class=\"cnet-select-card-header\">\n    <div class=\"cnet-select-card-title-wrap\">\n      <ng-template *ngTemplateOutlet=\"cnetCardSelectTitleTpl\" />\n      <ng-template *ngTemplateOutlet=\"cnetCardSelectSubTitleTpl\" />\n      <cnet-divider></cnet-divider>\n    </div>\n  </header>\n\n  <div class=\"cnet-select-card-content\">\n    <ng-template *ngTemplateOutlet=\"cnetCardSelectContent\" />\n  </div>\n\n  <ng-template *ngTemplateOutlet=\"cnetCardSelectFooterTpl\" />\n</div>\n\n\n<ng-template #cnetCardSelectTitleTpl>\n  <ng-content select=\"cnet-card-select-title, [cnet-card-select-title], [cnetCardSelectTitle]\"></ng-content>\n</ng-template>\n\n<ng-template #cnetCardSelectSubTitleTpl>\n  <ng-content select=\"cnet-card-select-subtitle, [cnet-card-select-subtitle], [cnetCardSelectSubTitle]\"></ng-content>\n</ng-template>\n<ng-template #cnetCardSelectFooterTpl>\n  <ng-content select=\"cnet-card-select-footer, [cnet-card-select-footer],  [cnetCardSelectFooter]\"></ng-content>\n</ng-template>\n<ng-template #cnetCardSelectContent>\n  <ng-content></ng-content>\n</ng-template>\n<ng-template #cnetCardSelectRadio>\n  <cnet-radio [checked]=\"checked()\" tabindex=\"-1\" [enableUncheck]=\"false\" [disabled]=\"disabled()\" ></cnet-radio>\n</ng-template>\n", styles: [".cnet-select-card-group{display:grid;gap:.5rem;margin-bottom:.5rem;grid-template-columns:repeat(auto-fit,minmax(min(50%,422px),1fr));margin-bottom:1rem}.cnet-select-card-group .cnet-card-select{margin-bottom:0}@media (min-width: 1580px){.cnet-select-card-group:has(>*:only-child){grid-template-columns:50%}}:host ::ng-deep .cnet-card-select .cnet-select-card-radio{margin-top:26px}:host ::ng-deep .cnet-card-select .cnet-select-card-radio cnet-radio .cnet-ripple.cnet-radio-check{height:auto;width:auto;min-width:auto}.cnet-card-select.cdk-focused{box-shadow:0 0 999px 999px #ffffff80;z-index:999;border:1px solid var(--cnet-primary-500, #82c14f)}.cnet-card-select.cdk-focused.checked{border:2px solid var(--cnet-primary-500, #82c14f)}.cnet-card-select.cdk-focused.disabled{border:1px solid var(--cnet--500, #9e9e9e)}.cnet-card-select.cdk-focused.checked.disabled{border:2px solid var(--cnet--500, #9e9e9e)}.cnet-card-select:hover{box-shadow:0 0 999px 999px #ffffff80;z-index:999;border:1px solid var(--cnet-primary-500, #82c14f)}.cnet-card-select:hover.checked{border:2px solid var(--cnet-primary-500, #82c14f)}.cnet-card-select:hover.disabled{border:1px solid var(--cnet--500, #9e9e9e)}.cnet-card-select:hover.checked.disabled{border:2px solid var(--cnet--500, #9e9e9e)}.cnet-card-select{width:100%;position:relative;background-color:#fff;background-clip:border-box;border:1px solid #eeeeee;border-radius:.25rem;overflow:hidden;margin-bottom:1rem;cursor:pointer;display:flex;align-items:start;padding:0}.cnet-card-select.checked{padding:0;border:2px solid var(--cnet-primary-500, #82c14f)}.cnet-card-select.disabled{background-color:var(--cnet--100, #f5f5f5);cursor:default}.cnet-card-select.checked.disabled{border:2px solid var(--cnet--500, #9e9e9e)}.cnet-card-select .cnet-card-select-subtitle{margin-left:0!important}.cnet-card-select .cnet-select-card-container{width:calc(100% - 28px);height:100%}.cnet-card-select .cnet-select-card-radio{margin-top:7px;left:5px;display:block;padding-left:.75rem;position:relative;top:7px}.cnet-card-select .cnet-select-card-radio .cnet-radio{margin:-6px}.cnet-card-select .cnet-select-card-header{display:flex;align-items:center;padding:.75rem 1rem;padding-bottom:0}.cnet-card-select .cnet-select-card-title-radio-wrap{display:flex;flex-direction:row-reverse;gap:.5rem}.cnet-card-select .cnet-select-card-title-wrap{flex:1;display:flex;flex-direction:row;justify-content:flex-start;gap:.25rem;margin-bottom:.5rem;border-bottom:solid 1px #e0e0e0;padding-bottom:.5rem}.cnet-card-select .cnet-select-card-title-wrap .cnet-divider{margin:.5rem 0}@media (min-width: 768px) and (max-width: 992px){.cnet-card-select .cnet-card-select .cnet-select-card-title-wrap{flex-direction:column;border-bottom:none;padding-bottom:0}}@media (max-width: 576px){.cnet-card-select .cnet-card-select .cnet-select-card-title-wrap{flex-direction:column;border-bottom:none;padding-bottom:0}}.cnet-card-select .cnet-card-select-title{font-weight:700;font-size:.875rem;text-transform:uppercase;margin-top:.125rem;margin-bottom:0}.cnet-card-select .cnet-card-select-subtitle{color:#000000ab;font-size:.875rem;margin:0 0 0 37px}.cnet-card-select .cnet-select-card-content{width:100%;padding:0 1rem;padding-top:0;font-size:.875rem}.cnet-card-select .cnet-card-select-footer{width:50px;height:22px;display:flex;padding:.25rem 1rem 1rem;gap:.5rem;font-size:.75rem;width:100%;flex-wrap:wrap;height:100%;align-content:center;align-items:center}.cnet-card-select .cnet-card-select-footer .cnet-card-select-footer-item{height:auto;align-items:center;flex-direction:row;display:flex}.cnet-card-select .cnet-card-select-footer .cnet-card-select-footer-item p{margin:0;overflow:hidden;text-overflow:ellipsis}@media (max-width: 767.98px){.cnet-card-select .cnet-card-select-header{flex-direction:column}}\n"], dependencies: [{ kind: "ngmodule", type: CnetDividerModule }, { kind: "component", type: CnetDividerComponent, selector: "cnet-divider, [cnet-divider], cnetDivider", inputs: ["vertical"], exportAs: ["cnetDivider"] }, { kind: "ngmodule", type: CnetRadioModule }, { kind: "component", type: CnetRadioComponent, selector: "cnet-radio", inputs: ["id", "name", "checked", "value", "disabled", "enableUncheck"], outputs: ["change", "blur", "focus"], exportAs: ["cnetRadio"] }, { kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "ngmodule", type: ReactiveFormsModule }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-card-select', standalone: true, exportAs: 'cnetCardSelect', host: {
                        class: 'cnet-card-select',
                        role: 'card',
                        '[attr.id]': 'id()',
                        '[class.checked]': 'checked() === true',
                        '[class.disabled]': 'disabled() === true',
                    }, imports: [CnetDividerModule, CnetRadioModule, CommonModule, ReactiveFormsModule], changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<div class=\"cnet-select-card-radio\">\n  <ng-template *ngTemplateOutlet=\"cnetCardSelectRadio\" />\n</div>\n<div class=\"d-flex flex-column cnet-select-card-container\">\n  <header class=\"cnet-select-card-header\">\n    <div class=\"cnet-select-card-title-wrap\">\n      <ng-template *ngTemplateOutlet=\"cnetCardSelectTitleTpl\" />\n      <ng-template *ngTemplateOutlet=\"cnetCardSelectSubTitleTpl\" />\n      <cnet-divider></cnet-divider>\n    </div>\n  </header>\n\n  <div class=\"cnet-select-card-content\">\n    <ng-template *ngTemplateOutlet=\"cnetCardSelectContent\" />\n  </div>\n\n  <ng-template *ngTemplateOutlet=\"cnetCardSelectFooterTpl\" />\n</div>\n\n\n<ng-template #cnetCardSelectTitleTpl>\n  <ng-content select=\"cnet-card-select-title, [cnet-card-select-title], [cnetCardSelectTitle]\"></ng-content>\n</ng-template>\n\n<ng-template #cnetCardSelectSubTitleTpl>\n  <ng-content select=\"cnet-card-select-subtitle, [cnet-card-select-subtitle], [cnetCardSelectSubTitle]\"></ng-content>\n</ng-template>\n<ng-template #cnetCardSelectFooterTpl>\n  <ng-content select=\"cnet-card-select-footer, [cnet-card-select-footer],  [cnetCardSelectFooter]\"></ng-content>\n</ng-template>\n<ng-template #cnetCardSelectContent>\n  <ng-content></ng-content>\n</ng-template>\n<ng-template #cnetCardSelectRadio>\n  <cnet-radio [checked]=\"checked()\" tabindex=\"-1\" [enableUncheck]=\"false\" [disabled]=\"disabled()\" ></cnet-radio>\n</ng-template>\n", styles: [".cnet-select-card-group{display:grid;gap:.5rem;margin-bottom:.5rem;grid-template-columns:repeat(auto-fit,minmax(min(50%,422px),1fr));margin-bottom:1rem}.cnet-select-card-group .cnet-card-select{margin-bottom:0}@media (min-width: 1580px){.cnet-select-card-group:has(>*:only-child){grid-template-columns:50%}}:host ::ng-deep .cnet-card-select .cnet-select-card-radio{margin-top:26px}:host ::ng-deep .cnet-card-select .cnet-select-card-radio cnet-radio .cnet-ripple.cnet-radio-check{height:auto;width:auto;min-width:auto}.cnet-card-select.cdk-focused{box-shadow:0 0 999px 999px #ffffff80;z-index:999;border:1px solid var(--cnet-primary-500, #82c14f)}.cnet-card-select.cdk-focused.checked{border:2px solid var(--cnet-primary-500, #82c14f)}.cnet-card-select.cdk-focused.disabled{border:1px solid var(--cnet--500, #9e9e9e)}.cnet-card-select.cdk-focused.checked.disabled{border:2px solid var(--cnet--500, #9e9e9e)}.cnet-card-select:hover{box-shadow:0 0 999px 999px #ffffff80;z-index:999;border:1px solid var(--cnet-primary-500, #82c14f)}.cnet-card-select:hover.checked{border:2px solid var(--cnet-primary-500, #82c14f)}.cnet-card-select:hover.disabled{border:1px solid var(--cnet--500, #9e9e9e)}.cnet-card-select:hover.checked.disabled{border:2px solid var(--cnet--500, #9e9e9e)}.cnet-card-select{width:100%;position:relative;background-color:#fff;background-clip:border-box;border:1px solid #eeeeee;border-radius:.25rem;overflow:hidden;margin-bottom:1rem;cursor:pointer;display:flex;align-items:start;padding:0}.cnet-card-select.checked{padding:0;border:2px solid var(--cnet-primary-500, #82c14f)}.cnet-card-select.disabled{background-color:var(--cnet--100, #f5f5f5);cursor:default}.cnet-card-select.checked.disabled{border:2px solid var(--cnet--500, #9e9e9e)}.cnet-card-select .cnet-card-select-subtitle{margin-left:0!important}.cnet-card-select .cnet-select-card-container{width:calc(100% - 28px);height:100%}.cnet-card-select .cnet-select-card-radio{margin-top:7px;left:5px;display:block;padding-left:.75rem;position:relative;top:7px}.cnet-card-select .cnet-select-card-radio .cnet-radio{margin:-6px}.cnet-card-select .cnet-select-card-header{display:flex;align-items:center;padding:.75rem 1rem;padding-bottom:0}.cnet-card-select .cnet-select-card-title-radio-wrap{display:flex;flex-direction:row-reverse;gap:.5rem}.cnet-card-select .cnet-select-card-title-wrap{flex:1;display:flex;flex-direction:row;justify-content:flex-start;gap:.25rem;margin-bottom:.5rem;border-bottom:solid 1px #e0e0e0;padding-bottom:.5rem}.cnet-card-select .cnet-select-card-title-wrap .cnet-divider{margin:.5rem 0}@media (min-width: 768px) and (max-width: 992px){.cnet-card-select .cnet-card-select .cnet-select-card-title-wrap{flex-direction:column;border-bottom:none;padding-bottom:0}}@media (max-width: 576px){.cnet-card-select .cnet-card-select .cnet-select-card-title-wrap{flex-direction:column;border-bottom:none;padding-bottom:0}}.cnet-card-select .cnet-card-select-title{font-weight:700;font-size:.875rem;text-transform:uppercase;margin-top:.125rem;margin-bottom:0}.cnet-card-select .cnet-card-select-subtitle{color:#000000ab;font-size:.875rem;margin:0 0 0 37px}.cnet-card-select .cnet-select-card-content{width:100%;padding:0 1rem;padding-top:0;font-size:.875rem}.cnet-card-select .cnet-card-select-footer{width:50px;height:22px;display:flex;padding:.25rem 1rem 1rem;gap:.5rem;font-size:.75rem;width:100%;flex-wrap:wrap;height:100%;align-content:center;align-items:center}.cnet-card-select .cnet-card-select-footer .cnet-card-select-footer-item{height:auto;align-items:center;flex-direction:row;display:flex}.cnet-card-select .cnet-card-select-footer .cnet-card-select-footer-item p{margin:0;overflow:hidden;text-overflow:ellipsis}@media (max-width: 767.98px){.cnet-card-select .cnet-card-select-header{flex-direction:column}}\n"] }]
        }], ctorParameters: () => [{ type: i1$2.FocusMonitor }, { type: i0.ElementRef }], propDecorators: { inputClick: [{
                type: HostListener,
                args: ['click']
            }], onKeydownHandler: [{
                type: HostListener,
                args: ['document:keydown', ['$event']]
            }] } });

class CnetCardSelectTitleDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCardSelectTitleDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetCardSelectTitleDirective, isStandalone: true, selector: "cnet-card-select-title, [cnet-card-select-title], [cnetCardSelectTitle]", host: { classAttribute: "cnet-card-select-title" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCardSelectTitleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-card-select-title, [cnet-card-select-title], [cnetCardSelectTitle]',
                    standalone: true,
                    host: { class: 'cnet-card-select-title' }
                }]
        }] });
class CnetCardSelectSubtitleDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCardSelectSubtitleDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetCardSelectSubtitleDirective, isStandalone: true, selector: "cnet-card-select-subtitle, [cnet-card-select-subtitle], [cnetCardSelectSubTitle]", host: { classAttribute: "cnet-card-select-subtitle" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCardSelectSubtitleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-card-select-subtitle, [cnet-card-select-subtitle], [cnetCardSelectSubTitle]',
                    standalone: true,
                    host: { class: 'cnet-card-select-subtitle' }
                }]
        }] });

class CardSelectFooterDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSelectFooterDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CardSelectFooterDirective, isStandalone: true, selector: "cnet-card-select-footer, [cnet-card-select-footer],  [cnetCardSelectFooter]", host: { classAttribute: "cnet-card-select-footer" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSelectFooterDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-card-select-footer, [cnet-card-select-footer],  [cnetCardSelectFooter]',
                    host: { class: 'cnet-card-select-footer' },
                    standalone: true
                }]
        }] });
class CardSelectFooterItemDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSelectFooterItemDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CardSelectFooterItemDirective, isStandalone: true, selector: "cnet-card-select-footer-item, [cnet-card-select-footer-item],  [cnetCardSelectFooterItem]", host: { classAttribute: "cnet-card-select-footer-item" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSelectFooterItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-card-select-footer-item, [cnet-card-select-footer-item],  [cnetCardSelectFooterItem]',
                    host: { class: 'cnet-card-select-footer-item' },
                    standalone: true
                }]
        }] });

class CardSelectModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CardSelectModule, imports: [CommonModule,
            CardSelectComponent,
            CnetCardSelectTitleDirective,
            CnetCardSelectSubtitleDirective,
            CardSelectFooterDirective,
            SelectCardGroupDirective,
            CardSelectFooterItemDirective], exports: [CardSelectComponent,
            CnetCardSelectTitleDirective,
            CnetCardSelectSubtitleDirective,
            CardSelectFooterDirective,
            SelectCardGroupDirective,
            CardSelectFooterItemDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSelectModule, imports: [CommonModule,
            CardSelectComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CardSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        CommonModule,
                        CardSelectComponent,
                        CnetCardSelectTitleDirective,
                        CnetCardSelectSubtitleDirective,
                        CardSelectFooterDirective,
                        SelectCardGroupDirective,
                        CardSelectFooterItemDirective
                    ],
                    exports: [
                        CardSelectComponent,
                        CnetCardSelectTitleDirective,
                        CnetCardSelectSubtitleDirective,
                        CardSelectFooterDirective,
                        SelectCardGroupDirective,
                        CardSelectFooterItemDirective
                    ]
                }]
        }] });

const CHECKBOXGROUP_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CnetCheckboxGroupComponent),
    multi: true
};
let nextUniqueId$d = 0;
/**
 * Cnet Checkbox Group is a container for one or more Cnet Checkbox
 *
 * @export
 * implements {ControlValueAccessor}
 */
class CnetCheckboxGroupComponent {
    constructor() {
        /** @ignore */ this._id = `cnet-checkbox-group-${++nextUniqueId$d}`;
        /** @ignore */ this._name = this._id;
        /** @ignore */ this._value = [];
        /** @ignore */ this._disabled = false;
        /** @ignore */ this._color = "primary";
        /** @ignore */ this._selected = []; // TODO:mudar para lista
        /** @ignore */
        this.onChangeCallback = (_) => { };
        /** @ignore */
        this.onTouchedCallback = () => { };
    }
    /**
     * The id of this group
     *
     * type {string}
     * @memberof CnetCheckboxGroupComponent
     */
    get id() { return this._id; }
    set id(value) { this._id = value; }
    /**
     * The name of this group
     *
     * type {string}
     * @memberof CnetCheckboxGroupComponent
     */
    get name() { return this._name; }
    set name(value) {
        if (this._name !== value) {
            this._updateCheckboxButtonNames();
        }
    }
    /**
     * Value for this group
     *
     * type {*}
     * @memberof CnetCheckboxGroupComponent
     */
    get value() { return this._value; }
    set value(value) {
        if (value && Array.isArray(value)) {
            if (JSON.stringify(this._value) !== JSON.stringify(value)) {
                this._value = value;
                this._updateSelectedCheckboxFromValue(); //TODO: OLHAR
                this.onChangeCallback(this._value);
            }
        }
    }
    /**
     * Whether this group is disabled
     *
     * type {boolean}
     * @memberof CnetCheckboxGroupComponent
     */
    get disabled() { return this._disabled; }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * The color for the checkbox buttons
     *
     * type {CnetColorPalette}
     * @memberof CnetCheckboxGroupComponent
     */
    get color() { return this._color; }
    set color(value) { this._color = value; }
    /**
     * The selected Cnet checkbox
     *
     * @readonly
     * type {CnetCheckboxComponent}
     * @memberof CnetCheckboxGroupComponent
     */
    get selected() { return this._selected; } //TODO:OLHAR
    /** @ignore */
    writeValue(value) {
        this.value = value;
    }
    /**
     * Registers a callback function that is called when the control's value changes in the UI.
     *
     * param  fn
     * @memberof CnetCheckboxGroupComponent
     */
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    /**
     * Registers a callback function is called by the forms API on initialization to update the form model on blur.
     *
     * param  fn
     * @memberof CnetCheckboxGroupComponent
     */
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    /** @ignore */
    _updateCheckboxButtonNames() {
        if (this._checkboxs) {
            this._checkboxs.forEach(checkbox => {
                checkbox.name = this.name;
            });
        }
    }
    /** @ignore */
    _updateSelectedCheckboxFromValue() {
        if (this._checkboxs) {
            this._checkboxs.forEach(checkbox => {
                const valueAuxJson = this.value.map(v => JSON.stringify(v));
                checkbox.checked = valueAuxJson.includes(JSON.stringify(checkbox.value));
                if (checkbox.checked) {
                    // this._selected = checkbox;
                    this._selected.push(checkbox);
                }
            });
        }
    }
    updateValueFromCheckedCheckbox() {
        if (this._checkboxs) {
            const valueAux = [];
            this._checkboxs.forEach(checkbox => {
                if (checkbox.checked) {
                    valueAux.push(checkbox.value);
                }
                // const valueAuxJson = this.value.map(v => JSON.stringify(v));
                // checkbox.checked = valueAuxJson.includes(JSON.stringify(checkbox.value));
                // if (checkbox.checked) {
                //   // this._selected = checkbox;
                //   this._selected.push(checkbox);
                // }
            });
            this.value = valueAux;
        }
    }
    setDisabledState(isDisabled) {
        // this.formulario.disable();
        this.disabled = isDisabled;
        if (this._checkboxs) {
            this._checkboxs.forEach(checkbox => {
                checkbox.disabled = this.disabled;
            });
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCheckboxGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetCheckboxGroupComponent, selector: "cnet-checkbox-group", inputs: { id: "id", name: "name", value: "value", disabled: "disabled", color: "color" }, host: { attributes: { "role": "checkboxgroup" }, properties: { "class.cnet-color-primary": "color == \"primary\"", "class.cnet-color-secondary": "color == \"secondary\"", "class.cnet-color-danger": "color == \"danger\"", "attr.id": "id", "attr.value": "value", "attr.name": "name", "class.disabled": "this.disabled" }, classAttribute: "cnet-checkbox-group" }, providers: [CHECKBOXGROUP_VALUE_ACCESSOR], queries: [{ propertyName: "_checkboxs", predicate: i0.forwardRef(() => CnetCheckboxComponent), descendants: true }], exportAs: ["cnetCheckboxGroup"], ngImport: i0, template: '<ng-content></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCheckboxGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'cnet-checkbox-group',
                    exportAs: 'cnetCheckboxGroup',
                    host: {
                        class: 'cnet-checkbox-group',
                        role: 'checkboxgroup',
                        '[class.cnet-color-primary]': 'color == "primary"',
                        '[class.cnet-color-secondary]': 'color == "secondary"',
                        '[class.cnet-color-danger]': 'color == "danger"',
                        '[attr.id]': 'id',
                        '[attr.value]': 'value',
                        '[attr.name]': 'name'
                    },
                    template: '<ng-content></ng-content>',
                    providers: [CHECKBOXGROUP_VALUE_ACCESSOR],
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    encapsulation: ViewEncapsulation.None
                }]
        }], propDecorators: { id: [{
                type: Input
            }], name: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.disabled']
            }], color: [{
                type: Input
            }], _checkboxs: [{
                type: ContentChildren,
                args: [forwardRef(() => CnetCheckboxComponent), { descendants: true }]
            }] } });

let nextUniqueId$c = 0;
const CHECKBOX_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CnetCheckboxComponent),
    multi: true
};
/**
 * The Checkbox component allows the user to select one or more options from an available set of options.
 * The checkbox is usually used to make binary choices.
 *
 * @export
 * class CnetCheckboxComponent
 * implements {ControlValueAccessor}
 */
class CnetCheckboxComponent {
    /**
     * The id of this checkbox
     *
     * type {string}
     * @memberof CnetCheckboxComponent
     */
    get id() { return this._id; }
    set id(value) {
        this._id = value || `cnet-checkbox-${nextUniqueId$c}`;
    }
    /**
     * The name of this checkbox
     *
     * type {string}
     * @memberof CnetCheckboxComponent
     */
    get name() { return this._name; }
    set name(value) { this._name = value; }
    /**
     * Whether this checkbox is checked
     *
     * @readonly
     * type {boolean}
     * @memberof CnetCheckboxComponent
     */
    get checked() { return this._checked; }
    set checked(value) {
        value = coerceBooleanProperty(value);
        if (this._checked !== value) {
            this._checked = value;
            this.onChangeCallback(this._checked);
        }
    }
    /**
   * Value for the radio button
   *
   * @readonly
   * type {boolean}
   * @memberof CnetCheckboxComponent
   */
    get value() { return this._value; }
    set value(value) {
        if (JSON.stringify(this.value) !== JSON.stringify(value)) {
            this._value = value;
            if (this.checkboxGroup) {
                this._checked = JSON.stringify(this.checkboxGroup.value) === JSON.stringify(this.value);
            }
            this.onChangeCallback(this._value);
        }
    }
    /**
     * Whether this checkbox is disabled
     *
     * @readonly
     * type {boolean}
     * @memberof CnetCheckboxComponent
     */
    get disabled() {
        return this._disabled || (this.checkboxGroup != null && this.checkboxGroup.disabled);
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
    * The color for the checkbox
    *
    * type {CnetColorPalette}
    * @memberof CnetCheckboxComponent
    */
    get color() { return this._color; }
    set color(value) { this._color = value; }
    constructor(checkboxGroup, cdr) {
        this.checkboxGroup = checkboxGroup;
        this.cdr = cdr;
        /** @ignore */ this._id = `cnet-checkbox-${++nextUniqueId$c}`;
        /** @ignore */ this._name = this._id;
        /** @ignore */ this._checked = false;
        /** @ignore */ this._disabled = false;
        /** @ignore */ this._color = "primary";
        /** @ignore */ this._value = false;
        this.enableRiple = true;
        /**
         * Event emitted when the checkbox value changes.
         *
         * @memberof CnetCheckboxComponent
         */
        this.change = new EventEmitter();
        /**
         * Event emitted when the checkbox is no longer focused.
         *
         * @memberof CnetCheckboxComponent
         */
        this.blur = new EventEmitter();
        /**
         * Event emitted when the checkbox receives focus.
         *
         * @memberof CnetCheckboxComponent
         */
        this.focus = new EventEmitter();
        /** @ignore */
        this.onChangeCallback = (_) => { };
        /** @ignore */
        this.onTouchedCallback = () => { };
        this.checkboxGroup = checkboxGroup;
    }
    ngOnInit() {
        if (this.checkboxGroup) {
            const valueAuxJson = this.checkboxGroup.value.map(v => JSON.stringify(v));
            this.checked = valueAuxJson.includes(JSON.stringify(this._value));
        }
    }
    /**
     * Detects changes after view check to apply the initial configuration
     * @ignore
     * */
    ngAfterViewChecked() {
        this.cdr.detectChanges();
    }
    /** @ignore */
    _onInputChange(event) {
        event.stopPropagation();
        this.change.emit(event);
        this.checked = !this.checked;
        this.onTouchedCallback();
        if (this.checkboxGroup) {
            this.checkboxGroup.updateValueFromCheckedCheckbox();
        }
    }
    /** @ignore */
    writeValue(value) {
        this.checked = value;
    }
    /**
     * Registers a callback function that is called when the control's value changes in the UI.
     *
     * param {*} fn
     * @memberof CnetCheckboxComponent
     */
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    /**
     * Registers a callback function is called by the forms API on initialization to update the form model on blur.
     *
     * param {*} fn
     * @memberof CnetCheckboxComponent
     */
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCheckboxComponent, deps: [{ token: CnetCheckboxGroupComponent, optional: true }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetCheckboxComponent, selector: "cnet-checkbox", inputs: { id: "id", name: "name", checked: "checked", value: "value", disabled: "disabled", color: "color", enableRiple: "enableRiple" }, outputs: { change: "change", blur: "blur", focus: "focus" }, host: { properties: { "class.cnet-checkbox-checked": "checked", "class.cnet-checkbox-disabled": "disabled", "class.cnet-color-primary": "color == \"primary\"", "class.cnet-color-secondary": "color == \"secondary\"", "class.cnet-color-danger": "color == \"danger\"", "class.disabled": "this.disabled" }, classAttribute: "cnet-checkbox" }, providers: [CHECKBOX_VALUE_ACCESSOR], exportAs: ["cnetCheckbox"], ngImport: i0, template: "<label class=\"cnet-checkbox-label\" #label>\n    <input\n        type=\"checkbox\"\n        class=\"cnet-checkbox-input\"\n        tabindex=\"0\"\n        [id]=\"id\"\n        [checked]=\"checked\"\n        [disabled]=\"disabled\"\n        [name]=\"name\"\n        (focus)=\"focus.emit($event)\"\n        (blur)=\"blur.emit($event)\"\n        (change)=\"_onInputChange($event)\"/>\n\n    <div class=\"cnet-checkbox-check\" cnetRipple [cnetRippleDisabled]=\"disabled || !enableRiple\" cnetRippleCentered=\"true\" [cnetRippleTrigger]=\"label\">\n        <div class=\"cnet-checkbox-check-overlay\" *ngIf=\"enableRiple\"></div>\n        <div class=\"cnet-checkbox-check-icon\">\n            <i class=\"la la-check\"></i>\n        </div>\n    </div>\n\n    <div class=\"cnet-checkbox-content\">\n        <ng-content></ng-content>\n    </div>\n</label>\n", styles: [".cnet-checkbox-group{display:flex;flex-wrap:wrap}.cnet-checkbox-label{display:flex;cursor:pointer;margin-bottom:.5rem;-webkit-user-select:none;user-select:none;align-items:center}.cnet-checkbox:not(.cnet-checkbox-disabled) .cnet-checkbox-label:hover .cnet-checkbox-check-overlay,.cnet-checkbox:not(.cnet-checkbox-disabled) .cnet-checkbox-input:focus~.cnet-checkbox-check .cnet-checkbox-check-overlay{opacity:1}.cnet-checkbox-input{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;outline:0;-webkit-appearance:none}.cnet-checkbox-check{display:flex;position:relative;height:36px;width:36px;min-width:36px;border-radius:50%;overflow:hidden;justify-content:center;align-items:center;margin-left:-.5rem}.cnet-checkbox-check .cnet-checkbox-check-icon{transition:all ease .3s;display:flex;justify-content:center;align-items:center;height:20px;width:20px;border-radius:.25rem;background-color:#fff;border-width:1px;border-style:solid;border-color:var(--cnet--300, #e0e0e0)}.cnet-checkbox-check .cnet-checkbox-check-icon i{color:#fff;visibility:hidden;opacity:0;font-size:.8rem}.cnet-checkbox-check-overlay{height:100%;width:100%;position:absolute;background:#0000000a;opacity:0;transition:all ease .3s}.cnet-checkbox-checked .cnet-checkbox-check .cnet-checkbox-check-icon i{visibility:visible;opacity:1}.cnet-checkbox-disabled .cnet-checkbox-label{cursor:default;color:#0000006b}.cnet-checkbox-disabled .cnet-checkbox-check .cnet-checkbox-check-icon{background-color:var(--cnet--200, #eeeeee)}.cnet-checkbox-disabled.cnet-checkbox-checked .cnet-checkbox-check-icon{background-color:var(--cnet--400, #bdbdbd)}.cnet-checkbox-checked:not(.cnet-checkbox-disabled) .cnet-checkbox-check-icon{border-color:var(--cnet-primary-500, #82c14f);background-color:var(--cnet-primary-500, #82c14f)}.cnet-checkbox-checked:not(.cnet-checkbox-disabled).cnet-color-secondary .cnet-checkbox-check-icon{border-color:var(--cnet-secondary-500, #3d4155);background-color:var(--cnet-secondary-500, #3d4155)}.cnet-checkbox-checked:not(.cnet-checkbox-disabled).cnet-color-danger .cnet-checkbox-check-icon{border-color:var(--cnet-danger-500, #ee4446);background-color:var(--cnet-danger-500, #ee4446)}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: CnetRippleDirective, selector: "[cnet-ripple], [cnetRipple]", inputs: ["cnetRippleColor", "cnetRippleUnbounded", "cnetRippleCentered", "cnetRippleRadius", "cnetRippleAnimation", "cnetRippleDisabled", "cnetRippleTrigger"], exportAs: ["cnetRipple"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCheckboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-checkbox', exportAs: 'cnetCheckbox', host: {
                        class: 'cnet-checkbox',
                        '[class.cnet-checkbox-checked]': 'checked',
                        '[class.cnet-checkbox-disabled]': 'disabled',
                        '[class.cnet-color-primary]': 'color == "primary"',
                        '[class.cnet-color-secondary]': 'color == "secondary"',
                        '[class.cnet-color-danger]': 'color == "danger"',
                    }, providers: [CHECKBOX_VALUE_ACCESSOR], changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<label class=\"cnet-checkbox-label\" #label>\n    <input\n        type=\"checkbox\"\n        class=\"cnet-checkbox-input\"\n        tabindex=\"0\"\n        [id]=\"id\"\n        [checked]=\"checked\"\n        [disabled]=\"disabled\"\n        [name]=\"name\"\n        (focus)=\"focus.emit($event)\"\n        (blur)=\"blur.emit($event)\"\n        (change)=\"_onInputChange($event)\"/>\n\n    <div class=\"cnet-checkbox-check\" cnetRipple [cnetRippleDisabled]=\"disabled || !enableRiple\" cnetRippleCentered=\"true\" [cnetRippleTrigger]=\"label\">\n        <div class=\"cnet-checkbox-check-overlay\" *ngIf=\"enableRiple\"></div>\n        <div class=\"cnet-checkbox-check-icon\">\n            <i class=\"la la-check\"></i>\n        </div>\n    </div>\n\n    <div class=\"cnet-checkbox-content\">\n        <ng-content></ng-content>\n    </div>\n</label>\n", styles: [".cnet-checkbox-group{display:flex;flex-wrap:wrap}.cnet-checkbox-label{display:flex;cursor:pointer;margin-bottom:.5rem;-webkit-user-select:none;user-select:none;align-items:center}.cnet-checkbox:not(.cnet-checkbox-disabled) .cnet-checkbox-label:hover .cnet-checkbox-check-overlay,.cnet-checkbox:not(.cnet-checkbox-disabled) .cnet-checkbox-input:focus~.cnet-checkbox-check .cnet-checkbox-check-overlay{opacity:1}.cnet-checkbox-input{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;outline:0;-webkit-appearance:none}.cnet-checkbox-check{display:flex;position:relative;height:36px;width:36px;min-width:36px;border-radius:50%;overflow:hidden;justify-content:center;align-items:center;margin-left:-.5rem}.cnet-checkbox-check .cnet-checkbox-check-icon{transition:all ease .3s;display:flex;justify-content:center;align-items:center;height:20px;width:20px;border-radius:.25rem;background-color:#fff;border-width:1px;border-style:solid;border-color:var(--cnet--300, #e0e0e0)}.cnet-checkbox-check .cnet-checkbox-check-icon i{color:#fff;visibility:hidden;opacity:0;font-size:.8rem}.cnet-checkbox-check-overlay{height:100%;width:100%;position:absolute;background:#0000000a;opacity:0;transition:all ease .3s}.cnet-checkbox-checked .cnet-checkbox-check .cnet-checkbox-check-icon i{visibility:visible;opacity:1}.cnet-checkbox-disabled .cnet-checkbox-label{cursor:default;color:#0000006b}.cnet-checkbox-disabled .cnet-checkbox-check .cnet-checkbox-check-icon{background-color:var(--cnet--200, #eeeeee)}.cnet-checkbox-disabled.cnet-checkbox-checked .cnet-checkbox-check-icon{background-color:var(--cnet--400, #bdbdbd)}.cnet-checkbox-checked:not(.cnet-checkbox-disabled) .cnet-checkbox-check-icon{border-color:var(--cnet-primary-500, #82c14f);background-color:var(--cnet-primary-500, #82c14f)}.cnet-checkbox-checked:not(.cnet-checkbox-disabled).cnet-color-secondary .cnet-checkbox-check-icon{border-color:var(--cnet-secondary-500, #3d4155);background-color:var(--cnet-secondary-500, #3d4155)}.cnet-checkbox-checked:not(.cnet-checkbox-disabled).cnet-color-danger .cnet-checkbox-check-icon{border-color:var(--cnet-danger-500, #ee4446);background-color:var(--cnet-danger-500, #ee4446)}\n"] }]
        }], ctorParameters: () => [{ type: CnetCheckboxGroupComponent, decorators: [{
                    type: Optional
                }] }, { type: i0.ChangeDetectorRef }], propDecorators: { id: [{
                type: Input
            }], name: [{
                type: Input
            }], checked: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class.disabled']
            }], color: [{
                type: Input
            }], enableRiple: [{
                type: Input
            }], change: [{
                type: Output
            }], blur: [{
                type: Output
            }], focus: [{
                type: Output
            }] } });

class CnetCheckboxModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCheckboxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetCheckboxModule, declarations: [CnetCheckboxComponent, CnetCheckboxGroupComponent], imports: [CommonModule,
            CnetRippleModule], exports: [CnetCheckboxComponent, CnetCheckboxGroupComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCheckboxModule, imports: [CommonModule,
            CnetRippleModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCheckboxModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetCheckboxComponent, CnetCheckboxGroupComponent],
                    imports: [
                        CommonModule,
                        CnetRippleModule
                    ],
                    exports: [CnetCheckboxComponent, CnetCheckboxGroupComponent]
                }]
        }] });

let nextUniqueId$b = 0;
class CnetChipsComponent extends CnetInputDirective {
    get id() { return this._id; }
    set id(value) {
        this._id = value || `cnet-checkbox-${nextUniqueId$b}`;
    }
    constructor(document, cd, ngControl, elementRef, injector) {
        super(ngControl, elementRef);
        this.document = document;
        this.cd = cd;
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.injector = injector;
        this.items = [];
        this.placeholder = 'type...';
        this.removable = true;
        this.removableAll = true;
        this.separator = '';
        this.allowDuplicate = true;
        this.addOnBlur = true;
        this.caseSensitiveDuplication = true;
        this.onChange = () => { };
        this.onTouched = () => { };
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }
    ngAfterContentInit() {
        //Called after ngOnInit when the component's or directive's content has been initialized.
        //Add 'implements AfterContentInit' to the class.
        this.updateFilledState();
    }
    updateFilledState() {
        // if (!this.items || this.items.length === 0) {
        //     this.filled = this.inputViewChild && this.inputViewChild.nativeElement && this.inputViewChild.nativeElement.value != '';
        // } else {
        //     this.filled = true;
        // }
        if (!this.items?.length) {
            this.filled = this.inputViewChild && this.inputViewChild.nativeElement && this.inputViewChild.nativeElement.value != '';
        }
        else {
            this.filled = true;
        }
    }
    get focusedOptionId() {
        return this.focusedIndex ? `${this.id}_chips_item_${this.focusedIndex}` : null;
    }
    setDisabledState(val) {
        this.disabled = val;
        setTimeout(() => {
            this.cd.markForCheck();
        });
    }
    onChipBarClick() {
        if (!this.disabled) {
            this.inputViewChild?.nativeElement.focus();
        }
    }
    removeItem(event, index) {
        if (this.disabled) {
            return;
        }
        let removedItem = this.items[index];
        this.items = this.items.filter((val, i) => i != index);
        this.focusedIndex = null;
        this.inputViewChild.nativeElement.focus();
        this.triggerChange();
        // this.onRemove.emit({
        //     originalEvent: event,
        //     value: removedItem
        // });
        // this.updateFilledState()
        this.updateFilledState();
        ;
        this.updateMaxedOut();
    }
    removeAll() {
        if (!this.disabled) {
            this.items = [];
            this.updateFilledState();
            this.triggerChange();
            this.updateMaxedOut();
            // this.onRemove.emit({
            //     originalEvent: event,
            //     value: removedItem
            // });
        }
    }
    onPaste(event) {
        if (!this.disabled) {
            if (this.separator) {
                const pastedData = (event.clipboardData || this.document.defaultView['clipboardData']).getData('Text');
                pastedData.split(this.separator).forEach((val) => {
                    this.addItem(event, val, true);
                });
                this.inputViewChild.nativeElement.value = '';
            }
            this.updateFilledState();
        }
    }
    onKeyDown(event, value) {
        if (this.disabled) {
            return;
        }
        const inputValue = event.target.value;
        switch (event.code) {
            case 'Backspace':
                if (!inputValue?.length && this.items?.length) {
                    if (this.focusedIndex) {
                        this.removeItem(event, this.focusedIndex);
                    }
                    else {
                        this.removeItem(event, this.items.length - 1);
                    }
                }
                break;
            case 'Enter':
            case 'NumpadEnter':
                if (inputValue && inputValue.trim().length && !this.isMaxedOut) {
                    this.addItem(event, inputValue, true);
                }
                break;
            case 'Tab':
                if (this.addOnTab && inputValue && inputValue.trim().length && !this.isMaxedOut) {
                    this.addItem(event, inputValue, true);
                    event.preventDefault();
                }
                break;
            case 'ArrowLeft':
                if (inputValue.length === 0 && this.items && this.items.length > 0) {
                    this.containerViewChild?.nativeElement.focus();
                }
            case 'ArrowRight':
                event.stopPropagation();
                break;
            default:
                if (this.separator) {
                    if (this.separator === event.key || event.key.match(this.separator)) {
                        this.addItem(event, inputValue, true);
                    }
                }
                break;
        }
    }
    onInputFocus(event) {
        this.focused = true;
        this.focusedIndex = null;
        // this.onFocus.emit(event);
    }
    onInputBlur(event) {
        this.focused = false;
        this.focusedIndex = null;
        if (!this.disabled) {
            if (this.addOnBlur && this.inputViewChild.nativeElement.value) {
                this.addItem(event, this.inputViewChild.nativeElement.value, false);
            }
        }
        // this.onModelTouched();
        // this.onBlur.emit(event);
    }
    onContainerFocus() {
        this.focused = true;
    }
    onContainerBlur() {
        this.focusedIndex = -1;
        this.focused = false;
        // if (this.items && this.items.length) {
        //   this.focusedIndex = this.items.length - 1;
        // }
        // this.focusedIndex = -1;
        // this.focused = false;
    }
    onContainerKeyDown(event) {
        if (this.disabled) {
            return;
        }
        switch (event.code) {
            case 'ArrowLeft':
                this.onArrowLeftKeyOn();
                break;
            case 'ArrowRight':
                this.onArrowRightKeyOn();
                break;
            case 'Backspace':
                this.onBackspaceKeyOn(event);
                break;
            default:
                break;
        }
    }
    onArrowLeftKeyOn() {
        if (this.inputViewChild.nativeElement.value.length === 0 && this.items?.length) {
            this.focusedIndex = !this.focusedIndex ? this.items.length - 1 : this.focusedIndex - 1;
            if (this.focusedIndex < 0)
                this.focusedIndex = 0;
        }
    }
    onArrowRightKeyOn() {
        if (this.inputViewChild.nativeElement.value.length === 0 && this.items?.length) {
            if (this.focusedIndex === this.items.length - 1) {
                this.focusedIndex = null;
                this.inputViewChild?.nativeElement.focus();
            }
            else {
                this.focusedIndex++;
            }
        }
    }
    onBackspaceKeyOn(event) {
        if (this.focusedIndex) {
            this.removeItem(event, this.focusedIndex);
        }
    }
    onInput() {
        this.updateFilledState();
        this.focusedIndex = null;
    }
    get isMaxedOut() {
        return this.max && this.items && this.max === this.items.length;
    }
    addItem(event, item, preventDefault) {
        this.items = this.items || [];
        item = item.trim();
        if (item && item.trim().length) {
            const newItemIsDuplicate = this.caseSensitiveDuplication ? this.items.includes(item) : this.items.some((val) => val.toLowerCase() === item.toLowerCase());
            if ((this.allowDuplicate || !newItemIsDuplicate) && !this.isMaxedOut) {
                this.items = [...this.items, item];
                this.triggerChange();
                // this.onAdd.emit({
                //   originalEvent: event,
                //   value: item
                // });
            }
        }
        this.updateFilledState();
        this.updateMaxedOut();
        this.inputViewChild.nativeElement.value = '';
        if (preventDefault) {
            event.preventDefault();
        }
    }
    updateMaxedOut() {
        if (this.inputViewChild && this.inputViewChild.nativeElement) {
            if (this.isMaxedOut) {
                // Calling `blur` is necessary because firefox does not call `onfocus` events
                // for disabled inputs, unlike chromium browsers.
                this.inputViewChild.nativeElement.blur();
                this.inputViewChild.nativeElement.disabled = true;
            }
            else {
                if (this.disabled) {
                    this.inputViewChild.nativeElement.blur();
                }
                this.inputViewChild.nativeElement.disabled = this.disabled || false;
            }
        }
    }
    writeValue(value) {
        this.items = value;
        this.updateMaxedOut();
        this.updateFilledState();
        this.cd.markForCheck();
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    triggerChange() {
        this.onChange(this.items);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetChipsComponent, deps: [{ token: DOCUMENT }, { token: i0.ChangeDetectorRef }, { token: i1$4.NgControl, optional: true, self: true }, { token: i0.ElementRef }, { token: Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "16.1.0", version: "17.3.12", type: CnetChipsComponent, isStandalone: true, selector: "cnet-chips, [cnetChips], [cnet-chips]", inputs: { id: "id", placeholder: "placeholder", removable: ["removable", "removable", booleanAttribute], removableAll: ["removableAll", "removableAll", booleanAttribute], separator: "separator", allowDuplicate: ["allowDuplicate", "allowDuplicate", booleanAttribute], addOnBlur: ["addOnBlur", "addOnBlur", booleanAttribute], caseSensitiveDuplication: ["caseSensitiveDuplication", "caseSensitiveDuplication", booleanAttribute], addOnTab: ["addOnTab", "addOnTab", booleanAttribute], max: ["max", "max", numberAttribute], viewValueTpl: "viewValueTpl" }, host: { classAttribute: "cnet-chips" }, providers: [{
                provide: CnetFormFieldControl,
                useExisting: forwardRef((() => CnetChipsComponent)),
                multi: true
            }], viewQueries: [{ propertyName: "inputViewChild", first: true, predicate: ["inputtext"], descendants: true }, { propertyName: "containerViewChild", first: true, predicate: ["container"], descendants: true }], exportAs: ["cnetChips"], usesInheritance: true, ngImport: i0, template: "<div class=\"chips-container\" [class.cnet-select-disabled]=\"disabled\">\n\n  <div class=\"input-container\">\n\n    <ul #container class=\"chip-bar\" [attr.aria-activedescendant]=\"focused ? focusedOptionId : undefined\"\n      [attr.aria-orientation]=\"'horizontal'\" tabindex=\"-1\" (focus)=\"onContainerFocus()\" (input)=\"onInput()\"\n      (blur)=\"onContainerBlur()\" (click)=\"onChipBarClick()\" (keydown)=\"onContainerKeyDown($event)\">\n\n\n      <li #token class=\"chip\" [attr.id]=\"id + '_chips_item_' + i\" [class.focus]=\"focusedIndex === i\"\n        *ngFor=\"let item of items; let i = index\" [attr.aria-selected]=\"true\" [attr.aria-posinset]=\"i + 1\"\n        [attr.data-p-focused]=\"focusedIndex === i\">\n        <span class=\"chip-label\">\n          <ng-template [ngIf]=\"!viewValueTpl\">{{item}}</ng-template>\n          <ng-template *ngTemplateOutlet=\"viewValueTpl; context: {$implicit: item}\"></ng-template>\n        </span>\n\n        <ng-container *ngIf=\"!disabled\">\n          <cnet-icon cnetRipple class=\"remove\" name=\"close\" *ngIf=\"removable\" (click)=\"removeItem($event, i)\" />\n        </ng-container>\n\n\n      </li>\n      <li class=\"input-field\" *ngIf=\"!disabled\">\n        <input #inputtext [id]=\"id+'-input'\" type=\"text\" class=\"input\" autocomplete=\"off\" [placeholder]=\"placeholder\"\n          (paste)=\"onPaste($event)\" (focus)=\"onInputFocus($event)\" (blur)=\"onInputBlur($event)\"\n          (keydown)=\"onKeyDown($event, inputtext.value)\" (input)=\"onInput()\" (blur)=\"onInputBlur($event)\" pAutoFocus\n          [disabled]=\"disabled || isMaxedOut\">\n      </li>\n    </ul>\n    <div class=\"action-btn\" *ngIf=\"removable && removableAll\">\n      <ng-container *ngIf=\"!disabled\">\n        <cnet-icon cnetRipple class=\"clear\" name=\"close\" *ngIf=\"removable\" [id]=\"id+'-clear-all'\" (click)=\"removeAll()\" />\n      </ng-container>\n    </div>\n  </div>\n</div>\n", styles: [":host .chips-container{background-color:#fff;padding:0;border-radius:0;margin:0}:host .chips-container .input-container{display:flex;align-items:flex-center;justify-content:space-between;border-radius:0;margin:0}:host .chips-container .input-container .chip-bar{cursor:text;display:flex;align-items:center;flex-wrap:wrap;overflow:hidden;font-size:1rem;font-weight:500;padding:0;width:100%;margin:0}:host .chips-container .input-container .chip-bar .focus{border:1px solid red}:host .chips-container .input-container .chip-bar .chip{padding:0 .25rem;margin:.25rem .5rem .25rem 0;display:inline-flex;border-radius:.25rem;color:var(--cnet-primary-contrast-500, white);background-color:var(--cnet-primary-500, #82c14f)}:host .chips-container .input-container .chip-bar .chip cnet-icon{cursor:pointer;display:inline-flex;margin-left:6px;margin-right:4px;align-items:center}:host .chips-container .input-container .chip-bar .chip cnet-icon i{font-size:.875rem}:host .chips-container .input-container .chip-bar .input-field{cursor:default;list-style:none;flex:1 1 auto;display:inline-flex;margin:0;padding:0;border:.125rem solid transparent}:host .chips-container .input-container .chip-bar .input-field .input{outline:0;border:0;border-radius:0;field-sizing:content;flex:1;font-size:1rem}:host .chips-container .input-container .action-btn{padding:0;display:flex;align-items:center}:host .chips-container .input-container .action-btn .clear{cursor:pointer;padding:0;border-radius:0}:host .chips-container .chip-footer{letter-spacing:.011rem;font-size:.75rem;margin:.188rem 0;color:#606060}:host :host::ng-deep .chip cnet-icon i{font-size:.875rem}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "ngmodule", type: CnetRippleModule }, { kind: "directive", type: CnetRippleDirective, selector: "[cnet-ripple], [cnetRipple]", inputs: ["cnetRippleColor", "cnetRippleUnbounded", "cnetRippleCentered", "cnetRippleRadius", "cnetRippleAnimation", "cnetRippleDisabled", "cnetRippleTrigger"], exportAs: ["cnetRipple"] }, { kind: "ngmodule", type: CnetIconModule }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetChipsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-chips, [cnetChips], [cnet-chips]', exportAs: 'cnetChips', standalone: true, host: {
                        class: 'cnet-chips'
                    }, imports: [CommonModule, CnetRippleModule, CnetIconModule], providers: [{
                            provide: CnetFormFieldControl,
                            useExisting: forwardRef((() => CnetChipsComponent)),
                            multi: true
                        }], changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"chips-container\" [class.cnet-select-disabled]=\"disabled\">\n\n  <div class=\"input-container\">\n\n    <ul #container class=\"chip-bar\" [attr.aria-activedescendant]=\"focused ? focusedOptionId : undefined\"\n      [attr.aria-orientation]=\"'horizontal'\" tabindex=\"-1\" (focus)=\"onContainerFocus()\" (input)=\"onInput()\"\n      (blur)=\"onContainerBlur()\" (click)=\"onChipBarClick()\" (keydown)=\"onContainerKeyDown($event)\">\n\n\n      <li #token class=\"chip\" [attr.id]=\"id + '_chips_item_' + i\" [class.focus]=\"focusedIndex === i\"\n        *ngFor=\"let item of items; let i = index\" [attr.aria-selected]=\"true\" [attr.aria-posinset]=\"i + 1\"\n        [attr.data-p-focused]=\"focusedIndex === i\">\n        <span class=\"chip-label\">\n          <ng-template [ngIf]=\"!viewValueTpl\">{{item}}</ng-template>\n          <ng-template *ngTemplateOutlet=\"viewValueTpl; context: {$implicit: item}\"></ng-template>\n        </span>\n\n        <ng-container *ngIf=\"!disabled\">\n          <cnet-icon cnetRipple class=\"remove\" name=\"close\" *ngIf=\"removable\" (click)=\"removeItem($event, i)\" />\n        </ng-container>\n\n\n      </li>\n      <li class=\"input-field\" *ngIf=\"!disabled\">\n        <input #inputtext [id]=\"id+'-input'\" type=\"text\" class=\"input\" autocomplete=\"off\" [placeholder]=\"placeholder\"\n          (paste)=\"onPaste($event)\" (focus)=\"onInputFocus($event)\" (blur)=\"onInputBlur($event)\"\n          (keydown)=\"onKeyDown($event, inputtext.value)\" (input)=\"onInput()\" (blur)=\"onInputBlur($event)\" pAutoFocus\n          [disabled]=\"disabled || isMaxedOut\">\n      </li>\n    </ul>\n    <div class=\"action-btn\" *ngIf=\"removable && removableAll\">\n      <ng-container *ngIf=\"!disabled\">\n        <cnet-icon cnetRipple class=\"clear\" name=\"close\" *ngIf=\"removable\" [id]=\"id+'-clear-all'\" (click)=\"removeAll()\" />\n      </ng-container>\n    </div>\n  </div>\n</div>\n", styles: [":host .chips-container{background-color:#fff;padding:0;border-radius:0;margin:0}:host .chips-container .input-container{display:flex;align-items:flex-center;justify-content:space-between;border-radius:0;margin:0}:host .chips-container .input-container .chip-bar{cursor:text;display:flex;align-items:center;flex-wrap:wrap;overflow:hidden;font-size:1rem;font-weight:500;padding:0;width:100%;margin:0}:host .chips-container .input-container .chip-bar .focus{border:1px solid red}:host .chips-container .input-container .chip-bar .chip{padding:0 .25rem;margin:.25rem .5rem .25rem 0;display:inline-flex;border-radius:.25rem;color:var(--cnet-primary-contrast-500, white);background-color:var(--cnet-primary-500, #82c14f)}:host .chips-container .input-container .chip-bar .chip cnet-icon{cursor:pointer;display:inline-flex;margin-left:6px;margin-right:4px;align-items:center}:host .chips-container .input-container .chip-bar .chip cnet-icon i{font-size:.875rem}:host .chips-container .input-container .chip-bar .input-field{cursor:default;list-style:none;flex:1 1 auto;display:inline-flex;margin:0;padding:0;border:.125rem solid transparent}:host .chips-container .input-container .chip-bar .input-field .input{outline:0;border:0;border-radius:0;field-sizing:content;flex:1;font-size:1rem}:host .chips-container .input-container .action-btn{padding:0;display:flex;align-items:center}:host .chips-container .input-container .action-btn .clear{cursor:pointer;padding:0;border-radius:0}:host .chips-container .chip-footer{letter-spacing:.011rem;font-size:.75rem;margin:.188rem 0;color:#606060}:host :host::ng-deep .chip cnet-icon i{font-size:.875rem}\n"] }]
        }], ctorParameters: () => [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.ChangeDetectorRef }, { type: i1$4.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ElementRef }, { type: i0.Injector, decorators: [{
                    type: Inject,
                    args: [Injector]
                }] }], propDecorators: { id: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], removable: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], removableAll: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], separator: [{
                type: Input
            }], allowDuplicate: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], addOnBlur: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], caseSensitiveDuplication: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], addOnTab: [{
                type: Input,
                args: [{ transform: booleanAttribute }]
            }], max: [{
                type: Input,
                args: [{ transform: numberAttribute }]
            }], viewValueTpl: [{
                type: Input
            }], inputViewChild: [{
                type: ViewChild,
                args: ['inputtext']
            }], containerViewChild: [{
                type: ViewChild,
                args: ['container']
            }] } });

class CnetChipsModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetChipsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetChipsModule, imports: [CnetChipsComponent], exports: [CnetChipsComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetChipsModule, imports: [CnetChipsComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetChipsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [
                        CnetChipsComponent
                    ],
                    exports: [
                        CnetChipsComponent
                    ]
                }]
        }] });

// A service for copying text to the clipboard. extends the Clipboard from Materia cdk
// More on: https://v14.material.angular.io/cdk/clipboard/overview
class CnetClipboardService extends Clipboard {
    constructor(document) {
        super(document);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetClipboardService, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetClipboardService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetClipboardService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }] });

// Provides behavior for a button that when clicked copies content into user's clipboard.
class CnetClipboardDirective {
    constructor() {
        /** @ignore */ this._cdkClipboard = inject(CnetClipboardService);
        /**Output whith the string copied */
        this.stringCopied = new EventEmitter();
    }
    /** @ignore */
    inputClick() {
        if (this.stringToCopy) {
            this._cdkClipboard.copy(this.stringToCopy);
            this.stringCopied.emit(this.stringToCopy);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetClipboardDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetClipboardDirective, selector: "[cnetClipboard]", inputs: { stringToCopy: ["cnetClipboard", "stringToCopy"] }, outputs: { stringCopied: "stringCopied" }, host: { listeners: { "click": "inputClick()" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetClipboardDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetClipboard]'
                }]
        }], ctorParameters: () => [], propDecorators: { stringToCopy: [{
                type: Input,
                args: ['cnetClipboard']
            }], stringCopied: [{
                type: Output
            }], inputClick: [{
                type: HostListener,
                args: ['click']
            }] } });

/**
 * Container component for cnet-tooltip
 *
 * @export
 * class CnetTooltipComponent
 */
class CnetTooltipComponent {
    constructor() {
        /**
           * Tooltip description text
           *
           * type {string}
           * @memberof CnetTooltipComponent
           */
        this.text = '';
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTooltipComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetTooltipComponent, isStandalone: true, selector: "cnet-tooltip-content", host: { properties: { "attr.id": "id" } }, exportAs: ["cnetTooltipContent"], ngImport: i0, template: "<div class=\"cnet-tooltip-content\" @tooltip>\n    <p [innerHtml]=\"text\"></p>\n</div>\n", styles: [".cnet-tooltip-content{display:block;color:#fff;background-color:#000000b3;padding:.5rem;border-radius:.25rem;pointer-events:none}.cnet-tooltip-content p{margin-bottom:0}.cnet-tooltip-panel{pointer-events:none!important}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "ngmodule", type: OverlayModule }], animations: [
            trigger('tooltip', [
                transition(':enter', [
                    style({ opacity: 0 }),
                    animate(300, style({ opacity: 1 })),
                ]),
                transition(':leave', [
                    animate(300, style({ opacity: 0 })),
                ]),
            ]),
        ], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTooltipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-tooltip-content', standalone: true, exportAs: 'cnetTooltipContent', host: {
                        '[attr.id]': 'id'
                    }, imports: [
                        CommonModule,
                        OverlayModule
                    ], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, animations: [
                        trigger('tooltip', [
                            transition(':enter', [
                                style({ opacity: 0 }),
                                animate(300, style({ opacity: 1 })),
                            ]),
                            transition(':leave', [
                                animate(300, style({ opacity: 0 })),
                            ]),
                        ]),
                    ], template: "<div class=\"cnet-tooltip-content\" @tooltip>\n    <p [innerHtml]=\"text\"></p>\n</div>\n", styles: [".cnet-tooltip-content{display:block;color:#fff;background-color:#000000b3;padding:.5rem;border-radius:.25rem;pointer-events:none}.cnet-tooltip-content p{margin-bottom:0}.cnet-tooltip-panel{pointer-events:none!important}\n"] }]
        }] });

let nextUniqueId$a = 0;
/** @ignore baseado em https://codegen.studio/blog/xrwlgo/angular-tooltip/ */
/**
 * The Cnet Tooltip displays informational text when users hover over an element.
 *
 * @export
 * class CnetTooltipDirective
 * implements {OnInit}
*/
class CnetTooltipDirective {
    constructor() {
        /** @ignore */ this.id = `cnet-tooltip-${++nextUniqueId$a}`;
        /** @ignore */ this.overlayRef = null;
        this.element = inject(ElementRef);
        this.overlay = inject(Overlay);
        this.viewContainer = inject(ViewContainerRef);
        /**
       * Tooltip description text
       *
       * type {string}
       * @memberof CnetTooltipDirective
       */
        this.text = input.required({ alias: 'cnet-tooltip' });
        /**
         * Tooltip position
         *
         * type {('top' | 'bottom')}
         * @memberof CnetTooltipDirective
         */
        this.position = input('top');
        this.positionStrategy = computed(() => this.overlay
            .position()
            .flexibleConnectedTo(this.element)
            .withPositions([
            {
                originX: "center",
                originY: this.position(),
                overlayX: "center",
                overlayY: this.position() == 'top' ? 'bottom' : 'top',
                offsetY: this.position() == 'top' ? -8 : 8,
                panelClass: "top",
            },
            {
                originX: "center",
                originY: "bottom",
                overlayX: "center",
                overlayY: "top",
                panelClass: "bottom",
            },
        ]));
    }
    ngOnDestroy() {
        this.overlayRef?.dispose();
    }
    attachTooltip() {
        if (this.overlayRef === null) {
            this.overlayRef = this.overlay.create({ positionStrategy: this.positionStrategy() });
        }
        const component = new ComponentPortal(CnetTooltipComponent, this.viewContainer);
        const tooltipRef = this.overlayRef.attach(component);
        tooltipRef.instance.text = this.text();
    }
    /** @ignore */
    show() {
        if (this.overlayRef?.hasAttached() === true) {
            return;
        }
        this.attachTooltip();
    }
    /** @ignore */
    hide() {
        if (this.overlayRef?.hasAttached() === true) {
            this.overlayRef?.detach();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTooltipDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "17.1.0", version: "17.3.12", type: CnetTooltipDirective, isStandalone: true, selector: "[cnet-tooltip]", inputs: { text: { classPropertyName: "text", publicName: "cnet-tooltip", isSignal: true, isRequired: true, transformFunction: null }, position: { classPropertyName: "position", publicName: "position", isSignal: true, isRequired: false, transformFunction: null } }, host: { listeners: { "mouseenter": "show()", "focus": "show()", "mouseleave": "hide()", "blur": "hide()" }, properties: { "attr.aria-describedby": "id" } }, exportAs: ["cnetTooltip"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTooltipDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnet-tooltip]',
                    standalone: true,
                    host: {
                        '[attr.aria-describedby]': "id"
                    },
                    exportAs: 'cnetTooltip'
                }]
        }], propDecorators: { show: [{
                type: HostListener,
                args: ["mouseenter"]
            }, {
                type: HostListener,
                args: ["focus"]
            }], hide: [{
                type: HostListener,
                args: ["mouseleave"]
            }, {
                type: HostListener,
                args: ["blur"]
            }] } });

/** Clipboard component is used to highlight a content that user can copy to clipboard. */
class ClipboardComponent {
    constructor() {
        /** String that will be copied if user click on this component */
        this.stringToCopy = '';
        /** tooltip label that will be presented on hover. If empty or null, then the tooltip will not be presented */
        this.tooltipLabel = 'click to copy';
        /**Output whith the string copied */
        this.stringCopied = new EventEmitter();
    }
    copied(event) {
        this.stringCopied.emit(event);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClipboardComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ClipboardComponent, selector: "cnet-clipboard", inputs: { stringToCopy: "stringToCopy", tooltipLabel: "tooltipLabel" }, outputs: { stringCopied: "stringCopied" }, ngImport: i0, template: "<div class=\"clipboard\" [cnetClipboard]=\"stringToCopy\" (stringCopied)=\"copied($event)\" [cnet-tooltip]=\"tooltipLabel\"\n  cnet-tooltip-position=\"bottom\">\n  <div class=\"clipboard-content\">\n    <ng-content></ng-content>\n  </div>\n  <cnet-icon name=\"copy \"></cnet-icon>\n</div>\n", styles: [".clipboard{cursor:pointer;display:flex;flex-direction:row;align-items:center;justify-content:space-between;width:fit-content}.clipboard .clipboard-content{border:1px solid transparent;border-radius:.5rem;padding:.5rem;width:fit-content}.clipboard cnet-icon{border:1px solid transparent;padding:.5rem;opacity:0}.clipboard:hover{background:#f6f6f6;border:1px solid;border-radius:.5rem}.clipboard:hover cnet-icon{border-radius:0 .5rem .5rem 0;opacity:1;border-left:1px solid;background-color:#fff}\n"], dependencies: [{ kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "directive", type: CnetTooltipDirective, selector: "[cnet-tooltip]", inputs: ["cnet-tooltip", "position"], exportAs: ["cnetTooltip"] }, { kind: "directive", type: CnetClipboardDirective, selector: "[cnetClipboard]", inputs: ["cnetClipboard"], outputs: ["stringCopied"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClipboardComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-clipboard', template: "<div class=\"clipboard\" [cnetClipboard]=\"stringToCopy\" (stringCopied)=\"copied($event)\" [cnet-tooltip]=\"tooltipLabel\"\n  cnet-tooltip-position=\"bottom\">\n  <div class=\"clipboard-content\">\n    <ng-content></ng-content>\n  </div>\n  <cnet-icon name=\"copy \"></cnet-icon>\n</div>\n", styles: [".clipboard{cursor:pointer;display:flex;flex-direction:row;align-items:center;justify-content:space-between;width:fit-content}.clipboard .clipboard-content{border:1px solid transparent;border-radius:.5rem;padding:.5rem;width:fit-content}.clipboard cnet-icon{border:1px solid transparent;padding:.5rem;opacity:0}.clipboard:hover{background:#f6f6f6;border:1px solid;border-radius:.5rem}.clipboard:hover cnet-icon{border-radius:0 .5rem .5rem 0;opacity:1;border-left:1px solid;background-color:#fff}\n"] }]
        }], ctorParameters: () => [], propDecorators: { stringToCopy: [{
                type: Input
            }], tooltipLabel: [{
                type: Input
            }], stringCopied: [{
                type: Output
            }] } });

class CnetTooltipModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTooltipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetTooltipModule, imports: [CnetTooltipComponent, CnetTooltipDirective], exports: [CnetTooltipComponent, CnetTooltipDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTooltipModule, imports: [CnetTooltipComponent] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTooltipModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CnetTooltipComponent, CnetTooltipDirective],
                    exports: [CnetTooltipComponent, CnetTooltipDirective]
                }]
        }] });

class CnetClipboardModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetClipboardModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetClipboardModule, declarations: [CnetClipboardDirective, ClipboardComponent], imports: [CommonModule,
            CnetIconModule,
            CnetTooltipModule], exports: [CnetClipboardDirective, ClipboardComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetClipboardModule, imports: [CommonModule,
            CnetIconModule,
            CnetTooltipModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetClipboardModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetClipboardDirective, ClipboardComponent],
                    exports: [CnetClipboardDirective, ClipboardComponent],
                    imports: [
                        CommonModule,
                        CnetIconModule,
                        CnetTooltipModule
                    ]
                }]
        }] });

let nextUniqueId$9 = 0;
let CnetOffcanvasRef = class CnetOffcanvasRef {
    constructor(overlay, content, data, cnetOffcanvasService, closable = false, id = '') {
        this.overlay = overlay;
        this.content = content;
        this.data = data;
        this.cnetOffcanvasService = cnetOffcanvasService;
        this.closable = closable;
        this.id = id;
        this._beforeClose = new Subject();
        this._afterClosed = new Subject();
        this._id = `cnet-offcanvas-${nextUniqueId$9++}`;
        if (closable) {
            overlay.backdropClick().subscribe(() => this._close('backdropClick', null));
        }
        if (id) {
            this._id = id;
        }
    }
    /**
     * Responsible to deslocate offCanvas to occupy the rest of screen when it is behind another one
     */
    deslocateOnXAxis() {
        this.componentInstance.deslocateOnXAxis();
    }
    /**
     * Close offCanvas as an user action
     * @param data
     */
    close(data) {
        this._close('close', data);
    }
    /** @ignore */
    _close(type, data) {
        this.componentInstance.animationStateChanged.pipe(filter$1((event) => event.phaseName === 'visible'), take(1)).subscribe(() => {
            this._beforeClose.next();
            this._beforeClose.complete();
            this.overlay.detachBackdrop();
        });
        // Listen for animation 'start' events. This runs the desloacate animation on behind offcanvas
        this.componentInstance.animationStateChanged.pipe(filter$1(event => event.phaseName === 'start' && event.toState === 'hidden'))
            .subscribe(() => {
            this.cnetOffcanvasService.animateBehindOffcanvas();
        });
        // Listen for animation 'done' events
        this.componentInstance.animationStateChanged.pipe(filter$1(event => event.phaseName === 'done' && event.toState === 'hidden'), take(1)).subscribe(() => {
            this.cnetOffcanvasService.close(this._id);
            this._afterClosed.next({
                type,
                data
            });
            this._afterClosed.complete();
            // clear the reference to the component instance to avoid memory leaks
            this.componentInstance = null;
        });
        // Start exit animation
        this.componentInstance.startExitAnimation();
    }
    /**
     *Deliver afterClose subject as an Observable
     * @returns afterClose as Observable
     */
    afterClosed() {
        return this._afterClosed.asObservable();
    }
    /**
   *Deliver beforerClose subject as an Observable
   * @returns beforerClose as Observable
   */
    beforeClose() {
        return this._beforeClose.asObservable();
    }
};
CnetOffcanvasRef = __decorate([
    __param(4, Optional()),
    __param(5, Optional())
], CnetOffcanvasRef);

const offcanvasAnimation = trigger('offcanvasAnimation', [
    state('hidden', style({
        translate: '200%',
    })),
    state('visible', style({
        translate: '0',
    })),
    transition('hidden <=> visible', animate('0.4s ease-in-out')),
]);
const offcanvasAnimationBehind = trigger('offcanvasAnimationBehind', [
    state('normal', style({
        translate: '0',
    })),
    state('deslocated', style({
        translate: '-40vw',
    })),
    transition('normal <=> deslocated', animate('0.4s ease-in-out')),
]);

class CnetOffcanvasComponent {
    constructor() {
        // /** @ignore */ protected _id: string = `cnet-offcanvas-${nextUniqueId++}`;
        /** @ignore */ this._id = ``;
        this.deslocated = false;
        this.offcanvasAnimation = 'hidden';
        this.animationStateChanged = new EventEmitter();
        this.ref = inject(CnetOffcanvasRef);
        this.cdr = inject(ChangeDetectorRef);
    }
    done(event) {
        this.animationStateChanged.emit(event);
    }
    start(event) {
        this.animationStateChanged.emit(event);
    }
    /** @ignore */ ngOnInit() {
        this.content = this.ref.content;
        this._id = this.ref._id;
        if (typeof this.content === 'string') {
            this.contentType = 'string';
        }
        else if (this.content instanceof TemplateRef) {
            this.contentType = 'template';
            this.context = {
                close: this.ref.close.bind(this.ref)
            };
        }
        else {
            this.contentType = 'component';
        }
    }
    ngAfterViewInit() {
        this.offcanvasAnimation = 'visible';
        this.deslocated = false;
    }
    startExitAnimation() {
        this.offcanvasAnimation = 'hidden';
    }
    /**
     * /**
     * Responsible to deslocate offCanvas to occupy the rest of screen when it is behind another one
     */
    deslocateOnXAxis() {
        this.deslocated = !this.deslocated;
        this.cdr.markForCheck();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetOffcanvasComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: CnetOffcanvasComponent, isStandalone: true, selector: "ng-component", host: { attributes: { "role": "offcanvas" }, listeners: { "@offcanvasAnimation.done": "done($event)", "@offcanvasAnimation.start": "start($event)" }, properties: { "@offcanvasAnimation": "this.offcanvasAnimation" }, classAttribute: "cnet-offcanvas" }, ngImport: i0, template: "<div class=\"offcanvas-content\" cdkTrapFocus [cdkTrapFocusAutoCapture]=\"true\" [@offcanvasAnimationBehind]=\"deslocated? 'deslocated': 'normal'\">\n  @switch (contentType) {\n  @case('string'){\n  <div [innerHTML]=\"content\"></div>\n  }\n  @case('template'){\n  <ng-container *ngTemplateOutlet=\"content; context: context\"></ng-container>\n  }\n  @case('component'){\n  <ng-container *ngComponentOutlet=\"content\"></ng-container>\n  }\n  }\n</div>\n", styles: [".cnet-offcanvas{background-color:transparent;width:60vw;box-shadow:0 0 10px -5px #0003,0 0 24px 2px #00000024,0 0 30px 5px #0000001f}.offcanvas-content{width:100%;height:100%;overflow-y:auto;overflow-x:hidden}.offcanvas-content{background-color:transparent}@media (max-width: 767.98px){.cnet-offcanvas{width:100vw}}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgComponentOutlet, selector: "[ngComponentOutlet]", inputs: ["ngComponentOutlet", "ngComponentOutletInputs", "ngComponentOutletInjector", "ngComponentOutletContent", "ngComponentOutletNgModule", "ngComponentOutletNgModuleFactory"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "ngmodule", type: A11yModule }, { kind: "directive", type: i1$2.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }, { kind: "ngmodule", type: OverlayModule }, { kind: "ngmodule", type: CdkScrollableModule }], animations: [offcanvasAnimation, offcanvasAnimationBehind], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetOffcanvasComponent, decorators: [{
            type: Component,
            args: [{ host: {
                        class: 'cnet-offcanvas',
                        role: 'offcanvas'
                    }, standalone: true, imports: [CommonModule, A11yModule, OverlayModule, CdkScrollableModule], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, animations: [offcanvasAnimation, offcanvasAnimationBehind], template: "<div class=\"offcanvas-content\" cdkTrapFocus [cdkTrapFocusAutoCapture]=\"true\" [@offcanvasAnimationBehind]=\"deslocated? 'deslocated': 'normal'\">\n  @switch (contentType) {\n  @case('string'){\n  <div [innerHTML]=\"content\"></div>\n  }\n  @case('template'){\n  <ng-container *ngTemplateOutlet=\"content; context: context\"></ng-container>\n  }\n  @case('component'){\n  <ng-container *ngComponentOutlet=\"content\"></ng-container>\n  }\n  }\n</div>\n", styles: [".cnet-offcanvas{background-color:transparent;width:60vw;box-shadow:0 0 10px -5px #0003,0 0 24px 2px #00000024,0 0 30px 5px #0000001f}.offcanvas-content{width:100%;height:100%;overflow-y:auto;overflow-x:hidden}.offcanvas-content{background-color:transparent}@media (max-width: 767.98px){.cnet-offcanvas{width:100vw}}\n"] }]
        }], propDecorators: { offcanvasAnimation: [{
                type: HostBinding,
                args: ['@offcanvasAnimation']
            }], done: [{
                type: HostListener,
                args: ['@offcanvasAnimation.done', ['$event']]
            }], start: [{
                type: HostListener,
                args: ['@offcanvasAnimation.start', ['$event']]
            }] } });

class CnetOffcanvasService {
    constructor() {
        this.overlay = inject(Overlay);
        this.injector = inject(Injector);
        this.offCanvasList = [];
    }
    /**
     * Open a component, template, or text dialog inside of an offcanvas
     * @template R
     * @template T
     * param {(TemplateRef<any> | Type<any>)} content
     * param {T} data
     * param {boolean} [closable=false]
     * param {string} [id=null]
     * @returns {CnetOffcanvasRef<R>}
     * @memberof CnetOffCanvasCloseEvent
     */
    open(content, data, closable = false, id, hasBackdrop = true, disposeOnNavigation = true) {
        // add ltr or rtl
        let positionStrategy = this.overlay.position().global().top().right();
        const scrollStrategy = this.overlay.scrollStrategies.noop();
        if (this.offCanvasList?.length === 0) {
            document.body.style.overflow = 'hidden';
            document.getElementsByTagName('html')[0].style.overflow = "hidden";
        }
        const configs = new OverlayConfig({
            panelClass: ['cnet-offcanvas-panel'],
            backdropClass: 'cnet-offcanvas-backdrop',
            height: '100%',
            disposeOnNavigation,
            hasBackdrop,
            positionStrategy,
            scrollStrategy
        });
        const overlayRef = this.overlay.create(configs);
        const dialogRef = new CnetOffcanvasRef(overlayRef, content, data, this, closable, this.normalizeId(id));
        const injector = this.createInjector(dialogRef, this.injector);
        const containerRef = overlayRef.attach(new ComponentPortal(CnetOffcanvasComponent, null, injector));
        const overlayComponent = containerRef.instance;
        dialogRef.componentInstance = overlayComponent;
        if (this.offCanvasList.length) {
            const behindOffCanvas = this.offCanvasList[this.offCanvasList.length - 1];
            behindOffCanvas.dialogRef.deslocateOnXAxis();
        }
        this.offCanvasList.push({ overlayRef, dialogRef });
        return dialogRef;
    }
    /** @ignore */
    normalizeId(id) {
        if (id) {
            const regex = new RegExp(`^${id}(-\\d+)?$`);
            const offCanvasWithSameId = this.offCanvasList.filter(offCanvas => regex.test(offCanvas.dialogRef._id));
            if (offCanvasWithSameId?.length) {
                id = `${id}-${offCanvasWithSameId.length++}`;
            }
        }
        return id;
    }
    /** @ignore */
    createInjector(ref, inj) {
        return Injector.create({
            parent: inj,
            providers: [
                { provide: CnetOffcanvasRef, useValue: ref }
            ]
        });
    }
    /**
     * get the offCanvas before the top of stack and execute the deslocate animation
     */
    animateBehindOffcanvas() {
        if (this.offCanvasList?.length) {
            const behindOffCanvas = this.offCanvasList[this.offCanvasList.length - 2];
            if (behindOffCanvas) {
                behindOffCanvas.dialogRef.deslocateOnXAxis();
            }
        }
    }
    /**
     * Closes an offCanvas given an id
     * @param id
     */
    close(id) {
        if (this.offCanvasList?.length && id) {
            // const closingOffcanvas = id ? this.offCanvasList.find(offcanvas => offcanvas.dialogRef._id === id) : this.offCanvasList[this.offCanvasList.length - 1];
            const closingOffcanvas = this.offCanvasList.find(offcanvas => offcanvas.dialogRef._id === id);
            if (closingOffcanvas.dialogRef && closingOffcanvas.overlayRef) {
                closingOffcanvas.overlayRef.dispose();
                this.offCanvasList.pop();
                if (this.offCanvasList?.length === 0) {
                    document.body.style.overflow = 'auto';
                    document.getElementsByTagName('html')[0].style.overflow = "auto";
                }
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetOffcanvasService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetOffcanvasService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetOffcanvasService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class CnetOffcanvas {
    constructor() {
        this.ref = inject(CnetOffcanvasRef);
    }
    close() {
        this.ref.close({ ...this.ref.data, id: this.ref._id });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetOffcanvas, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetOffcanvas, isStandalone: true, selector: "[cnetOffcanvas]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetOffcanvas, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetOffcanvas]',
                    standalone: true
                }]
        }] });

class Confirmation {
    constructor() {
        this.header = '';
        this.translateHeader = true;
        this.messageParams = null;
        this.translateMessage = true;
        this.acceptLabel = 'Sim';
        this.rejectLabel = 'Não';
        this.rejectVisible = true;
    }
}

let CnetDialogRef = class CnetDialogRef {
    constructor(overlay, content, data, closable = false) {
        this.overlay = overlay;
        this.content = content;
        this.data = data;
        this.closable = closable;
        this.afterClosed = new Subject();
        if (closable) {
            overlay.backdropClick().subscribe(() => this._close('backdropClick', null));
        }
    }
    close(data) {
        this._close('close', data);
    }
    _close(type, data) {
        this.overlay.dispose();
        this.afterClosed.next({
            type,
            data
        });
        this.afterClosed.complete();
    }
};
CnetDialogRef = __decorate([
    __param(3, Optional())
], CnetDialogRef);

class ConfirmDialogComponent {
    constructor(ref) {
        this.ref = ref;
        this.data = new Confirmation();
    }
    ngOnInit() {
        this.data.message = this.ref.data.message;
        this.data.messageParams = this.ref.data.messageParams ?? null;
        if (this.ref.data.header) {
            this.data.header = this.ref.data.header;
        }
        if (typeof this.ref.data.translateHeader === "boolean") {
            this.data.translateHeader = this.ref.data.translateHeader;
        }
        else {
            this.data.translateHeader = true;
        }
        if (typeof this.ref.data.translateMessage === "boolean") {
            this.data.translateMessage = this.ref.data.translateMessage;
        }
        else {
            this.data.translateMessage = true;
        }
        if (this.ref.data.acceptLabel) {
            this.data.acceptLabel = this.ref.data.acceptLabel;
        }
        if (this.ref.data.rejectLabel) {
            this.data.rejectLabel = this.ref.data.rejectLabel;
        }
        if (this.ref.data.acceptIcon) {
            this.data.acceptIcon = this.ref.data.acceptIcon;
        }
        if (this.ref.data.rejectIcon) {
            this.data.rejectIcon = this.ref.data.rejectIcon;
        }
        this.data.rejectVisible = typeof this.ref.data.rejectVisible === 'boolean' ? this.ref.data.rejectVisible : true;
    }
    close(answer) {
        this.ref.close(answer);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ConfirmDialogComponent, deps: [{ token: CnetDialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ConfirmDialogComponent, selector: "confirm-dialog", ngImport: i0, template: "<cnet-card>\n\n  <header cnet-card-header *ngIf=\"data.header\">\n    <h2 cnet-card-title [innerHTML]=\"data.translateHeader ? (data.header | translate) : data.header\">\n    </h2>\n  </header>\n\n  <section class=\"message\" [innerHTML]=\"data.translateMessage? ( data.messageParams ? ( data.message | translate:data.messageParams ) : data.message | translate  ) : data.message\">\n  </section>\n\n  <footer cnet-card-footer class=\"confirmation-buttons\">\n    <button cnet-filled-button color=\"cancel\" (click)=\"close(false)\" *ngIf=\"data?.rejectVisible\" class=\"btn btn-cancel\"\n      name=\"reject\" id=\"reject\">{{data?.rejectLabel |\n      translate }}</button>\n    <button cnet-filled-button color=\"success\" (click)=\"close(true)\" class=\"btn btn-success\" name=\"accept\"\n      id=\"accept\">{{data?.acceptLabel |\n      translate }}</button>\n  </footer>\n</cnet-card>\n", styles: [".cnet-card-footer{display:flex;flex-direction:row;flex-wrap:wrap;align-content:center;justify-content:flex-end;align-items:center;padding:0rem}.cnet-card-footer button{margin:4px}section{overflow:auto;max-height:60vmax;max-width:1230px;font-weight:500;padding:1rem 0;font-size:1.125rem}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CnetCardComponent, selector: "cnet-card", exportAs: ["cnetCard"] }, { kind: "component", type: CardHeaderComponent, selector: "cnet-card-header, [cnet-card-header], [cnetCardHeader]", exportAs: ["cnetCardHeader"] }, { kind: "directive", type: CnetCardTitleDirective, selector: "cnet-card-title, [cnet-card-title], [cnetCardTitle]" }, { kind: "component", type: CnetCardFooterComponent, selector: "cnet-card-footer, [cnet-card-footer], [cnetCardFooter]", exportAs: ["cnetCardFooter"] }, { kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }, { kind: "pipe", type: i1$3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ConfirmDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'confirm-dialog', template: "<cnet-card>\n\n  <header cnet-card-header *ngIf=\"data.header\">\n    <h2 cnet-card-title [innerHTML]=\"data.translateHeader ? (data.header | translate) : data.header\">\n    </h2>\n  </header>\n\n  <section class=\"message\" [innerHTML]=\"data.translateMessage? ( data.messageParams ? ( data.message | translate:data.messageParams ) : data.message | translate  ) : data.message\">\n  </section>\n\n  <footer cnet-card-footer class=\"confirmation-buttons\">\n    <button cnet-filled-button color=\"cancel\" (click)=\"close(false)\" *ngIf=\"data?.rejectVisible\" class=\"btn btn-cancel\"\n      name=\"reject\" id=\"reject\">{{data?.rejectLabel |\n      translate }}</button>\n    <button cnet-filled-button color=\"success\" (click)=\"close(true)\" class=\"btn btn-success\" name=\"accept\"\n      id=\"accept\">{{data?.acceptLabel |\n      translate }}</button>\n  </footer>\n</cnet-card>\n", styles: [".cnet-card-footer{display:flex;flex-direction:row;flex-wrap:wrap;align-content:center;justify-content:flex-end;align-items:center;padding:0rem}.cnet-card-footer button{margin:4px}section{overflow:auto;max-height:60vmax;max-width:1230px;font-weight:500;padding:1rem 0;font-size:1.125rem}\n"] }]
        }], ctorParameters: () => [{ type: CnetDialogRef }] });

class ConfirmDialogModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ConfirmDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ConfirmDialogModule, declarations: [ConfirmDialogComponent], imports: [CommonModule,
            CnetCardModule,
            CnetButtonModule,
            TranslateModule,
            OverlayModule], exports: [ConfirmDialogComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ConfirmDialogModule, imports: [CommonModule,
            CnetCardModule,
            CnetButtonModule,
            TranslateModule,
            OverlayModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ConfirmDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ConfirmDialogComponent
                    ],
                    imports: [
                        CommonModule,
                        CnetCardModule,
                        CnetButtonModule,
                        TranslateModule,
                        OverlayModule
                    ],
                    exports: [
                        ConfirmDialogComponent
                    ],
                }]
        }] });

const modalAnimation = trigger('modalAnimation', [
    state('enter', style({ transform: 'translateY(0) scale(1)', opacity: 1 })),
    state('void', style({ transform: 'translateY(-32px) scale(.9)', opacity: 0 })),
    transition('* => void', animate('200ms ease-out')),
    transition('void => *', [style({ opacity: 0 }), animate('200ms')]),
]);

/**
 * Cnet Modal is a component created to facilitate the creation of modals
 *
 * @export
 * class CnetModalComponent
 * implements {OnInit}
 */
class CnetModalComponent {
    /**
    * Whether the modal will be closed when clicking on the backdrop
    *
    * type {boolean}
    * @memberof CnetModalComponent
    */
    get backdropClose() { return this._backdropClose; }
    set backdropClose(value) { this._backdropClose = coerceBooleanProperty(value); }
    constructor(overlay, cdr) {
        this.overlay = overlay;
        this.cdr = cdr;
        /** @ignore */ this._backdropClose = false;
        /** @ignore */ this.animationState = 'void';
        /**
         * Stream that emits the visibility of the modal.
         *
         * type {BehaviorSubject<boolean>}
         * @memberof CnetModalComponent
         */
        this.visibleStream = new BehaviorSubject(false);
        this.onClose = new EventEmitter();
    }
    /** @ignore */
    getOverlayCOnfig() {
        const positionStrategy = this.overlay.position().global().centerHorizontally().centerVertically();
        const scrollStrategy = this.overlay.scrollStrategies.noop();
        return new OverlayConfig({
            positionStrategy,
            scrollStrategy,
            hasBackdrop: true
        });
    }
    /**
     * Displays the modal content
     *
     * @memberof CnetModalComponent
     */
    show() {
        this._overlayRef = this.overlay.create(this.getOverlayCOnfig());
        this._overlayRef.attach(this._contentTemplate);
        if (this._backdropClose) {
            this._overlayRef.backdropClick().subscribe(() => this.hide());
        }
        this.animationState = 'enter';
        this.visibleStream.next(true);
    }
    /**
     * Hides modal content
     *
     * @memberof CnetModalComponent
     */
    hide() {
        this.animationState = 'void';
        this.onClose.emit(true);
        this.cdr.detectChanges();
    }
    /** @ignore */
    _onAnimationDone(event) {
        if (event.fromState === 'enter' && event.toState === 'void') {
            this._overlayRef.detach();
            this.visibleStream.next(false);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetModalComponent, deps: [{ token: i1$5.Overlay }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetModalComponent, selector: "cnet-modal", inputs: { backdropClose: ["backdrop-close", "backdropClose"] }, outputs: { onClose: "onClose" }, host: { attributes: { "role": "dialog" }, classAttribute: "cnet-modal" }, viewQueries: [{ propertyName: "_contentTemplate", first: true, predicate: TemplatePortalDirective, descendants: true }], exportAs: ["cnetModal"], ngImport: i0, template: "<ng-template cdk-portal>\n    <div [@modalAnimation]=\"animationState\" (@modalAnimation.done)=\"_onAnimationDone($event)\">\n        <div cdkTrapFocus class=\"modal-content\">\n            <ng-content></ng-content>\n        </div>\n    </div>\n</ng-template>\n", styles: [".modal-content{box-shadow:0 10px 30px -10px #000c}\n"], dependencies: [{ kind: "directive", type: i2.TemplatePortalDirective, selector: "[cdk-portal], [portal]", exportAs: ["cdkPortal"] }, { kind: "directive", type: i1$2.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }], animations: [modalAnimation], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-modal', exportAs: 'cnetModal', host: {
                        class: 'cnet-modal',
                        role: 'dialog'
                    }, encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, animations: [modalAnimation], template: "<ng-template cdk-portal>\n    <div [@modalAnimation]=\"animationState\" (@modalAnimation.done)=\"_onAnimationDone($event)\">\n        <div cdkTrapFocus class=\"modal-content\">\n            <ng-content></ng-content>\n        </div>\n    </div>\n</ng-template>\n", styles: [".modal-content{box-shadow:0 10px 30px -10px #000c}\n"] }]
        }], ctorParameters: () => [{ type: i1$5.Overlay }, { type: i0.ChangeDetectorRef }], propDecorators: { _contentTemplate: [{
                type: ViewChild,
                args: [TemplatePortalDirective]
            }], backdropClose: [{
                type: Input,
                args: ['backdrop-close']
            }], onClose: [{
                type: Output
            }] } });

/**
 * Directive to create elements to close the cnet-modal
 *
 * @export
 * class CnetModalCloseDirective
 */
class CnetModalCloseDirective {
    constructor(_modalComponent) {
        this._modalComponent = _modalComponent;
    }
    /**
     * Hides the modal
     *
     * @memberof CnetModalCloseDirective
     */
    hideModal() {
        this._modalComponent.hide();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetModalCloseDirective, deps: [{ token: CnetModalComponent, optional: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetModalCloseDirective, selector: "[CnetModalClose], [cnet-modal-close]", host: { listeners: { "click": "hideModal()" } }, exportAs: ["cnetModalClose"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetModalCloseDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[CnetModalClose], [cnet-modal-close]',
                    exportAs: 'cnetModalClose'
                }]
        }], ctorParameters: () => [{ type: CnetModalComponent, decorators: [{
                    type: Optional
                }] }], propDecorators: { hideModal: [{
                type: HostListener,
                args: ['click']
            }] } });

/**
 * Directive to create trigger elements to open the cnet-modal
 *
 * @export
 * class CnetModalTriggerDirective
 */
class CnetModalTriggerDirective {
    /**
     * The cnet-modal instance
     *
     * type {CnetModalComponent}
     * @memberof CnetModalTriggerDirective
     */
    get modal() { return this.modal; }
    set modal(value) {
        this._modal = value;
    }
    /**
     * Creates the cnet-modal panel connected to this element
     *
     * @memberof CnetModalTriggerDirective
     */
    showModal() {
        this._modal.show();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetModalTriggerDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetModalTriggerDirective, selector: "[CnetModalTrigger], [cnet-modal-trigger]", inputs: { modal: ["cnet-modal-trigger", "modal"] }, host: { listeners: { "click": "showModal($event)" } }, exportAs: ["cnetModalTrigger"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetModalTriggerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[CnetModalTrigger], [cnet-modal-trigger]',
                    exportAs: 'cnetModalTrigger'
                }]
        }], propDecorators: { modal: [{
                type: Input,
                args: ['cnet-modal-trigger']
            }], showModal: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class CnetModalModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetModalModule, declarations: [CnetModalComponent,
            CnetModalTriggerDirective,
            CnetModalCloseDirective], imports: [CommonModule,
            OverlayModule,
            PortalModule,
            A11yModule], exports: [CnetModalComponent,
            CnetModalTriggerDirective,
            CnetModalCloseDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetModalModule, imports: [CommonModule,
            OverlayModule,
            PortalModule,
            A11yModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetModalModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnetModalComponent,
                        CnetModalTriggerDirective,
                        CnetModalCloseDirective
                    ],
                    imports: [
                        CommonModule,
                        OverlayModule,
                        PortalModule,
                        A11yModule
                    ],
                    exports: [
                        CnetModalComponent,
                        CnetModalTriggerDirective,
                        CnetModalCloseDirective,
                    ]
                }]
        }] });

class CnetConfirmDialogService {
    constructor() {
        this.requireConfirmationSource = new Subject();
        this.requireConfirmation$ = this.requireConfirmationSource.asObservable();
    }
    confirm(confirmation) {
        this.requireConfirmationSource.next(confirmation);
        return this;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetConfirmDialogService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetConfirmDialogService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetConfirmDialogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class CnetConfirmDialogComponent {
    constructor(_cnetConfirmDialogService) {
        this._cnetConfirmDialogService = _cnetConfirmDialogService;
        this.confirmation = null;
        this._cnetConfirmDialogService.requireConfirmation$.subscribe(confirm => {
            if (confirm) {
                this.confirmation = confirm;
                if (this.confirmation.accept) {
                    this.confirmation.acceptEvent = new EventEmitter();
                    this.confirmation.acceptEvent.subscribe(this.confirmation.accept);
                }
                if (this.confirmation.reject) {
                    this.confirmation.rejectEvent = new EventEmitter();
                    this.confirmation.rejectEvent.subscribe(this.confirmation.accept);
                }
                this.confirmModal.show();
            }
        });
    }
    ngOnInit() {
    }
    accept() {
        if (this.confirmation && this.confirmation.acceptEvent) {
            this.confirmation.acceptEvent.emit();
        }
        this.hide();
    }
    reject() {
        if (this.confirmation && this.confirmation.rejectEvent) {
            this.confirmation.rejectEvent.emit();
        }
        this.hide();
    }
    hide() {
        this.confirmModal.hide();
        this.confirmation = null;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetConfirmDialogComponent, deps: [{ token: CnetConfirmDialogService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetConfirmDialogComponent, selector: "cnet-confirm-dialog", viewQueries: [{ propertyName: "confirmModal", first: true, predicate: CnetModalComponent, descendants: true }], ngImport: i0, template: "<cnet-modal backdrop-close>\n  <div class=\"modal\">\n    <!-- <div class=\"modal-header\">\n      <button cnet-icon-button cnet-modal-close>\n        <cnet-icon name=\"close\"></cnet-icon>\n      </button>\n    </div> -->\n\n    <div class=\"modal-body\">\n      <h3 cnet-card-title>{{confirmation?.message}}</h3>\n    </div>\n\n    <div class=\"modal-footer\">\n      <button cnet-filled-button color=\"primary\" cnet-modal-close class=\" btn-cancel\">{{confirmation?.rejectLabel ||\n        'Cancelar'}}</button>\n        <button cnet-filled-button color=\"primary\" (click)=\"accept()\" class=\" btn-save\">{{confirmation?.acceptLabel\n          || 'Salvar'}}</button>\n    </div>\n  </div>\n\n\n\n  <!-- <cnet-card class=\"dialog-card\"> -->\n  <!-- <cnet-card-header>\n      <div cnet-card-actions>\n        <button cnet-icon-button cnet-modal-close>\n          <cnet-icon name=\"close\"></cnet-icon>\n        </button>\n      </div>\n    </cnet-card-header> -->\n\n  <!-- <h3 cnet-card-title style=\"margin: 5px;\">{{confirmation?.message}}</h3>\n\n    <div style=\"display: flex; flex-direction: row; justify-content: flex-end;\">\n      <button cnet-filled-button (click)=\"accept()\">{{confirmation?.acceptLabel || 'Save'}}</button>\n      <button cnet-filled-button cnet-modal-close>{{confirmation?.rejectLabel || 'Cancel'}}</button>\n    </div> -->\n  <!-- <footer cnet-card-footer>\n      <div style=\"display: flex; flex-direction: row; justify-content: flex-end;\">\n        <button cnet-filled-button (click)=\"accept()\">{{confirmation?.acceptLabel || 'Save'}}</button>\n        <button cnet-filled-button cnet-modal-close>{{confirmation?.rejectLabel || 'Cancel'}}</button>\n      </div>\n    </footer> -->\n\n  <!--\n  </cnet-card> -->\n</cnet-modal>\n", styles: [".modal{background-color:#fff;width:28rem;border-radius:.25rem}.modal-header{color:#fff;background-color:var(--cnet-primary-400, #95ca69);display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:flex-end;align-items:center;border-radius:.25rem}.modal-body{background-color:#fff;padding:12px 28px;border-radius:.25rem}.modal-footer{display:flex;flex-direction:row;justify-content:flex-end;padding-bottom:12px;padding-right:12px}button{margin-left:12px}.btn-save{background-color:var(--cnet-success-500, #47ba65)!important}.btn-cancel{background-color:var(--cnet--500, #9e9e9e)!important}\n"], dependencies: [{ kind: "component", type: CnetModalComponent, selector: "cnet-modal", inputs: ["backdrop-close"], outputs: ["onClose"], exportAs: ["cnetModal"] }, { kind: "directive", type: CnetModalCloseDirective, selector: "[CnetModalClose], [cnet-modal-close]", exportAs: ["cnetModalClose"] }, { kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }, { kind: "directive", type: CnetCardTitleDirective, selector: "cnet-card-title, [cnet-card-title], [cnetCardTitle]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetConfirmDialogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-confirm-dialog', template: "<cnet-modal backdrop-close>\n  <div class=\"modal\">\n    <!-- <div class=\"modal-header\">\n      <button cnet-icon-button cnet-modal-close>\n        <cnet-icon name=\"close\"></cnet-icon>\n      </button>\n    </div> -->\n\n    <div class=\"modal-body\">\n      <h3 cnet-card-title>{{confirmation?.message}}</h3>\n    </div>\n\n    <div class=\"modal-footer\">\n      <button cnet-filled-button color=\"primary\" cnet-modal-close class=\" btn-cancel\">{{confirmation?.rejectLabel ||\n        'Cancelar'}}</button>\n        <button cnet-filled-button color=\"primary\" (click)=\"accept()\" class=\" btn-save\">{{confirmation?.acceptLabel\n          || 'Salvar'}}</button>\n    </div>\n  </div>\n\n\n\n  <!-- <cnet-card class=\"dialog-card\"> -->\n  <!-- <cnet-card-header>\n      <div cnet-card-actions>\n        <button cnet-icon-button cnet-modal-close>\n          <cnet-icon name=\"close\"></cnet-icon>\n        </button>\n      </div>\n    </cnet-card-header> -->\n\n  <!-- <h3 cnet-card-title style=\"margin: 5px;\">{{confirmation?.message}}</h3>\n\n    <div style=\"display: flex; flex-direction: row; justify-content: flex-end;\">\n      <button cnet-filled-button (click)=\"accept()\">{{confirmation?.acceptLabel || 'Save'}}</button>\n      <button cnet-filled-button cnet-modal-close>{{confirmation?.rejectLabel || 'Cancel'}}</button>\n    </div> -->\n  <!-- <footer cnet-card-footer>\n      <div style=\"display: flex; flex-direction: row; justify-content: flex-end;\">\n        <button cnet-filled-button (click)=\"accept()\">{{confirmation?.acceptLabel || 'Save'}}</button>\n        <button cnet-filled-button cnet-modal-close>{{confirmation?.rejectLabel || 'Cancel'}}</button>\n      </div>\n    </footer> -->\n\n  <!--\n  </cnet-card> -->\n</cnet-modal>\n", styles: [".modal{background-color:#fff;width:28rem;border-radius:.25rem}.modal-header{color:#fff;background-color:var(--cnet-primary-400, #95ca69);display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:flex-end;align-items:center;border-radius:.25rem}.modal-body{background-color:#fff;padding:12px 28px;border-radius:.25rem}.modal-footer{display:flex;flex-direction:row;justify-content:flex-end;padding-bottom:12px;padding-right:12px}button{margin-left:12px}.btn-save{background-color:var(--cnet-success-500, #47ba65)!important}.btn-cancel{background-color:var(--cnet--500, #9e9e9e)!important}\n"] }]
        }], ctorParameters: () => [{ type: CnetConfirmDialogService }], propDecorators: { confirmModal: [{
                type: ViewChild,
                args: [CnetModalComponent]
            }] } });

class CnetConfirmDialogModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetConfirmDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetConfirmDialogModule, declarations: [CnetConfirmDialogComponent], imports: [CommonModule,
            CnetModalModule,
            CnetButtonModule,
            CnetCardModule,
            CnetIconModule], exports: [CnetConfirmDialogComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetConfirmDialogModule, imports: [CommonModule,
            CnetModalModule,
            CnetButtonModule,
            CnetCardModule,
            CnetIconModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetConfirmDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetConfirmDialogComponent],
                    exports: [CnetConfirmDialogComponent],
                    imports: [
                        CommonModule,
                        CnetModalModule,
                        CnetButtonModule,
                        CnetCardModule,
                        CnetIconModule
                    ]
                }]
        }] });

var enumCompType;
(function (enumCompType) {
    enumCompType["radio"] = "radio";
    enumCompType["slider"] = "slider";
})(enumCompType || (enumCompType = {}));

class OptionService {
    constructor() {
        this.countOrder = 0;
    }
    exportOptionAsListOption(option, compType) {
        switch (compType) {
            case enumCompType.radio:
                return this.exportOptionAsListOptionForRadioComp(option);
            case enumCompType.slider:
                return this.exportOptionAsListOptionForSliderComp(option);
            default:
                return { id: option.id, label: option.optionForm.controls.label.value, order: option.order };
        }
    }
    exportOptionAsListOptionForRadioComp(option) {
        return { id: option.id, label: option.optionForm.controls.label.value, order: option.order, value: option.optionForm.controls.label.value };
    }
    exportOptionAsListOptionForSliderComp(option) {
        return { id: option.id, label: option.optionForm.controls.label.value, order: option.order, value: option.order };
    }
    addOption(optionRef, dynamicListInstance, option) {
        optionRef.instance.id = uuid.v4();
        optionRef.instance.dynamicListComponent = dynamicListInstance;
        optionRef.instance.order = option.order;
        if (option) {
            if (option.label) {
                optionRef.instance.optionForm.controls.label.setValue(option.label);
            }
        }
    }
    addInstanceDynamicListOnOption(optionRef, dynamicListInstance) {
        optionRef.instance.dynamicListComponent = dynamicListInstance;
    }
    addIdOnOption(optionRef) {
        optionRef.instance.id = uuid.v4();
    }
    addOrderOnOption(optionRef, order) {
        optionRef.instance.order = order;
    }
    getOrder(optionRef) {
        return optionRef.instance.order;
    }
    getId(optionRef) {
        return optionRef.instance.id;
    }
    isInvalid(optionRef) {
        return optionRef.instance.optionForm.invalid;
    }
    enableForm(optionRef) {
        return optionRef.instance.optionForm.enable();
    }
    disableForm(optionRef) {
        return optionRef.instance.optionForm.disable();
    }
    markTouched(optionRef) {
        optionRef.instance.optionForm.markAllAsTouched();
    }
    disableRemove(optionsReferences) {
        optionsReferences.forEach(ref => ref.instance.disableRemove());
    }
    enableRemove(optionsReferences) {
        optionsReferences.forEach(ref => ref.instance.enableRemove());
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OptionService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OptionService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OptionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

let nextUniqueId$8 = 0;
/**
 * Error message for a Form Field
 *
 * @export
 * class CnetFieldErrorDirective
 */
class CnetFieldErrorDirective {
    constructor() {
        this.id = `cnet-error-${nextUniqueId$8++}`;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFieldErrorDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetFieldErrorDirective, selector: "cnet-field-error, [cnetFieldError], [cnet-field-error]", inputs: { id: "id" }, host: { attributes: { "role": "alert" }, properties: { "attr.id": "id" }, classAttribute: "cnet-field-error" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFieldErrorDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-field-error, [cnetFieldError], [cnet-field-error]',
                    host: {
                        class: 'cnet-field-error',
                        role: 'alert',
                        '[attr.id]': 'id'
                    },
                }]
        }], propDecorators: { id: [{
                type: Input
            }] } });

/**
 * The form field component works like a container for form inputs
 *
 * @export
 * class CnetFormFieldComponent
 */
class CnetFormFieldComponent {
    constructor(cdr) {
        this.cdr = cdr;
        /**
         * Child control for the form field
         *
         * type {CnetFormFieldControl<any>}
         * @memberof CnetFormFieldComponent
         */
        this.hasMoreThanOneControl = false;
        this.showLabel = true;
    }
    /** @ignore */
    ngAfterContentInit() {
        if (this.hasMoreThanOneControl) {
            if (this.controls) {
                this.controls.forEach(control => {
                    control.stateChanges.subscribe(() => {
                        this.cdr.detectChanges();
                    });
                    control.error = this.error;
                });
            }
        }
        else {
            if (this.control) {
                this.control.stateChanges.subscribe(() => {
                    this.cdr.detectChanges();
                });
                this.control.error = this.error;
            }
        }
    }
    hasControlDisabled() {
        if (this.hasMoreThanOneControl) {
            if (this.controls) {
                // control?.focused
                return this.controls.some(control => control.disabled);
            }
            return false;
        }
        else {
            return this.control?.disabled;
        }
    }
    hasControlFocused() {
        // control?.focused
        if (this.hasMoreThanOneControl) {
            if (this.controls) {
                return this.controls.some(control => control.focused);
            }
            return false;
        }
        else {
            return this.control?.focused;
        }
    }
    hasControlWithErrorState() {
        if (this.hasMoreThanOneControl) {
            if (this.controls) {
                // control?.errorState
                return this.controls.some(control => control?.errorState);
            }
            return false;
        }
        else {
            return this.control?.errorState;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFormFieldComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetFormFieldComponent, selector: "cnet-form-field", inputs: { hasMoreThanOneControl: "hasMoreThanOneControl", showLabel: "showLabel" }, host: { properties: { "class.cnet-form-field-error": "hasControlWithErrorState()", "class.cnet-form-field-disabled": "hasControlDisabled()" }, classAttribute: "cnet-form-field" }, queries: [{ propertyName: "control", first: true, predicate: CnetFormFieldControl, descendants: true }, { propertyName: "error", first: true, predicate: CnetFieldErrorDirective, descendants: true }, { propertyName: "controls", predicate: CnetFormFieldControl }], viewQueries: [{ propertyName: "content", first: true, predicate: ["content"], descendants: true }], exportAs: ["cnetButton"], ngImport: i0, template: "<label [attr.for]=\"hasMoreThanOneControl? controls.toArray()[0].id : control?.id \" class=\"cnet-field-label\" *ngIf=\"showLabel\">\n    <ng-content select=\"cnet-field-label, [cnetFieldLabel], [cnet-field-label]\" ></ng-content>\n</label>\n\n<div class=\"cnet-form-field-wrap\" [ngClass]=\"{'cnet-input-focused': hasControlFocused()}\" #content>\n  <ng-content select=\"cnet-field-prefix, [cnetFieldPrefix], [cnet-field-prefix]\"></ng-content>\n  <ng-content></ng-content>\n  <ng-content select=\"cnet-field-suffix, [cnetFieldSuffix], [cnet-field-suffix]\"></ng-content>\n</div>\n\n<div class=\"cnet-field-error-div\" *ngIf=\"hasControlWithErrorState()\">\n  <ng-content select=\"cnet-field-error, [cnetFieldError], [cnet-field-error]\"></ng-content>\n</div>\n\n<ng-content select=\"cnet-field-description, [cnetFieldDescription], [cnet-field-description]\"></ng-content>\n", styles: [".cnet-form-field{display:block;width:100%;margin-bottom:.5rem}.cnet-form-field-disabled .cnet-form-field-wrap{background:var(--cnet--200, #eeeeee);opacity:.76}.cnet-form-field-disabled .cnet-input{background:transparent}.cnet-form-field:not(.cnet-form-field-disabled) .cnet-form-field-wrap:hover{border-color:var(--cnet--500, #9e9e9e)}.cnet-form-field:not(.cnet-form-field-disabled) .cnet-form-field-wrap.cnet-input-focused{border-color:var(--cnet-primary-500, #82c14f)}.cnet-form-field-wrap{padding:0;box-sizing:content-box;display:flex;align-items:center;flex:auto;overflow:hidden;border:1px solid var(--cnet--300, #e0e0e0);border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;background-color:#fff}.cnet-form-field-wrap:has(.cnet-button-toggle){background-color:transparent;width:fit-content}.cnet-form-field-wrap:has(.cnet-slider){border:none;background-color:transparent;overflow:visible}.cnet-form-field-wrap:has(.cnet-slider) .cnet-slider{width:100%}.cnet-form-field-wrap:has(.cnet-input-switch){background-color:transparent;border:none;width:fit-content}.cnet-form-field-wrap:has(.cnet-checkbox){background-color:transparent;width:fit-content;border:none!important}.cnet-form-field:has(.cnet-image-upload){width:fit-content}.cnet-form-field-wrap:has(.cnet-button-toggle-group){background-color:transparent;width:fit-content}.cnet-form-field-wrap:has(.cnet-upload){width:100%;height:auto!important}textarea{height:auto!important}.cnet-input:not(.cnet-button-toggle):not(.cnet-button-toggle-group):not(.cnet-select-multiple):not(.cnet-upload):not(.cnet-input-switch):not(.cnet-chips){height:2.25rem;padding:.5rem;outline:none;font-size:1rem;line-height:1.5;flex:auto;border:none;color:#000000d9}.cnet-input.cnet-button-toggle{width:fit-content}.cnet-input.cnet-chips,.cnet-input.cnet-select-multiple{padding:.5rem;width:100%}.cnet-input.cnet-select-multiple .cnet-select-content{min-height:auto}.cnet-input.cnet-checkbox{height:fit-content!important}.cnet-field-suffix,.cnet-field-prefix{height:100%;width:2.375rem;padding-right:.25rem;display:flex;justify-content:center;align-items:center}.cnet-field-description,.cnet-field-error{display:block;margin-top:.25rem;font-size:.8rem}.cnet-field-description{color:#000000ab}.cnet-field-error{color:var(--cnet-danger-500, #ee4446)}.cnet-form-field-error .cnet-form-field-wrap{border-color:var(--cnet-danger-500, #ee4446)}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFormFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-form-field', exportAs: 'cnetButton', host: {
                        class: 'cnet-form-field',
                        '[class.cnet-form-field-error]': 'hasControlWithErrorState()',
                        '[class.cnet-form-field-disabled]': 'hasControlDisabled()'
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<label [attr.for]=\"hasMoreThanOneControl? controls.toArray()[0].id : control?.id \" class=\"cnet-field-label\" *ngIf=\"showLabel\">\n    <ng-content select=\"cnet-field-label, [cnetFieldLabel], [cnet-field-label]\" ></ng-content>\n</label>\n\n<div class=\"cnet-form-field-wrap\" [ngClass]=\"{'cnet-input-focused': hasControlFocused()}\" #content>\n  <ng-content select=\"cnet-field-prefix, [cnetFieldPrefix], [cnet-field-prefix]\"></ng-content>\n  <ng-content></ng-content>\n  <ng-content select=\"cnet-field-suffix, [cnetFieldSuffix], [cnet-field-suffix]\"></ng-content>\n</div>\n\n<div class=\"cnet-field-error-div\" *ngIf=\"hasControlWithErrorState()\">\n  <ng-content select=\"cnet-field-error, [cnetFieldError], [cnet-field-error]\"></ng-content>\n</div>\n\n<ng-content select=\"cnet-field-description, [cnetFieldDescription], [cnet-field-description]\"></ng-content>\n", styles: [".cnet-form-field{display:block;width:100%;margin-bottom:.5rem}.cnet-form-field-disabled .cnet-form-field-wrap{background:var(--cnet--200, #eeeeee);opacity:.76}.cnet-form-field-disabled .cnet-input{background:transparent}.cnet-form-field:not(.cnet-form-field-disabled) .cnet-form-field-wrap:hover{border-color:var(--cnet--500, #9e9e9e)}.cnet-form-field:not(.cnet-form-field-disabled) .cnet-form-field-wrap.cnet-input-focused{border-color:var(--cnet-primary-500, #82c14f)}.cnet-form-field-wrap{padding:0;box-sizing:content-box;display:flex;align-items:center;flex:auto;overflow:hidden;border:1px solid var(--cnet--300, #e0e0e0);border-radius:.25rem;transition:border-color .15s ease-in-out,box-shadow .15s ease-in-out;background-color:#fff}.cnet-form-field-wrap:has(.cnet-button-toggle){background-color:transparent;width:fit-content}.cnet-form-field-wrap:has(.cnet-slider){border:none;background-color:transparent;overflow:visible}.cnet-form-field-wrap:has(.cnet-slider) .cnet-slider{width:100%}.cnet-form-field-wrap:has(.cnet-input-switch){background-color:transparent;border:none;width:fit-content}.cnet-form-field-wrap:has(.cnet-checkbox){background-color:transparent;width:fit-content;border:none!important}.cnet-form-field:has(.cnet-image-upload){width:fit-content}.cnet-form-field-wrap:has(.cnet-button-toggle-group){background-color:transparent;width:fit-content}.cnet-form-field-wrap:has(.cnet-upload){width:100%;height:auto!important}textarea{height:auto!important}.cnet-input:not(.cnet-button-toggle):not(.cnet-button-toggle-group):not(.cnet-select-multiple):not(.cnet-upload):not(.cnet-input-switch):not(.cnet-chips){height:2.25rem;padding:.5rem;outline:none;font-size:1rem;line-height:1.5;flex:auto;border:none;color:#000000d9}.cnet-input.cnet-button-toggle{width:fit-content}.cnet-input.cnet-chips,.cnet-input.cnet-select-multiple{padding:.5rem;width:100%}.cnet-input.cnet-select-multiple .cnet-select-content{min-height:auto}.cnet-input.cnet-checkbox{height:fit-content!important}.cnet-field-suffix,.cnet-field-prefix{height:100%;width:2.375rem;padding-right:.25rem;display:flex;justify-content:center;align-items:center}.cnet-field-description,.cnet-field-error{display:block;margin-top:.25rem;font-size:.8rem}.cnet-field-description{color:#000000ab}.cnet-field-error{color:var(--cnet-danger-500, #ee4446)}.cnet-form-field-error .cnet-form-field-wrap{border-color:var(--cnet-danger-500, #ee4446)}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { hasMoreThanOneControl: [{
                type: Input
            }], showLabel: [{
                type: Input
            }], control: [{
                type: ContentChild,
                args: [CnetFormFieldControl]
            }], controls: [{
                type: ContentChildren,
                args: [CnetFormFieldControl]
            }], error: [{
                type: ContentChild,
                args: [CnetFieldErrorDirective]
            }], content: [{
                type: ViewChild,
                args: ['content']
            }] } });

class AscIIToCharPipe {
    transform(value) {
        return String.fromCharCode(value);
        ;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AscIIToCharPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: AscIIToCharPipe, name: "ascIIToChar" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AscIIToCharPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'ascIIToChar'
                }]
        }] });

class OptionComponent {
    constructor(_optionService) {
        this._optionService = _optionService;
        this.id = uuid.v4();
        this.order = null;
        this.optionForm = new UntypedFormGroup({});
        this.removeDisabled = false;
        this.optionForm = new UntypedFormGroup({
            label: new UntypedFormControl('', [Validators.required])
        });
        this.optionForm.controls.label.valueChanges.subscribe(label => {
            this.dynamicListComponent.updateArrayOptionValue(this._optionService.exportOptionAsListOption(this, this.dynamicListComponent.getCompType()));
        });
    }
    ngOnInit() {
    }
    removeThisOption() {
        this.dynamicListComponent.removeOption(this.id);
    }
    emptyLabelValidator() {
        // TODO: write a fucking test your moron
        console.error('the option must not be empty');
    }
    disableRemove() {
        this.removeDisabled = true;
    }
    enableRemove() {
        this.removeDisabled = false;
    }
    validateUniqueValue() {
        this.optionForm.controls.label.setErrors({ 'valueAlredyExists': true });
        this.optionForm.controls.label.markAsTouched();
    }
    clearValidateUniqueValueError() {
        if (this.optionForm.controls.label.hasError('valueAlredyExists')) {
            this.optionForm.controls.label.setErrors({ 'valueAlredyExists': null });
            this.optionForm.controls.label.updateValueAndValidity();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OptionComponent, deps: [{ token: OptionService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: OptionComponent, selector: "cnet-option", ngImport: i0, template: "<form [formGroup]=\"optionForm\">\n  <div class=\"option\" cdkDrag cdkDragLockAxis=\"y\" [cdkDragDisabled]=\"optionForm.disabled\">\n    <div class=\"option-order\">\n      {{ order+64 | ascIIToChar }}\n    </div>\n    <cnet-form-field class=\"input-field\" style=\"width: 95%;\">\n      <input cnet-input id=\"option\" formControlName=\"label\" type=\"text\"\n        [placeholder]=\"'Adicone uma alternativa' | translate\" />\n      <cnet-field-error>\n        <div *ngIf=\"optionForm.controls.label.hasError('required')\">{{'Alternativa n\u00E3o pode ficar em branco.' |\n          translate}}</div>\n        <div *ngIf=\"optionForm.controls.label.hasError('valueAlredyExists')\">{{'Este Valor j\u00E1 existe.' | translate}}\n        </div>\n      </cnet-field-error>\n    </cnet-form-field>\n    <div *ngIf=\"!removeDisabled\" style=\"width: 5%;\">\n      <button cnet-icon-button type=\"button\" (click)=\"removeThisOption()\" class=\"remove-button\"\n        [disabled]=\"optionForm.disabled\" size=\"large\">\n        <cnet-icon name=\"trash-alt\" label=\"Remove\" color=\"danger\"></cnet-icon>\n      </button>\n    </div>\n  </div>\n</form>\n", styles: [".option{display:flex;flex-direction:row;justify-content:space-between}.option-order{font-size:small;margin:8px;padding:16px;width:16px;height:16px;border-radius:50%;display:flex;flex-direction:row;align-content:center;align-items:center;justify-content:center;background:#757575;color:#fff;cursor:grab}::ng-deep .option .cnet-field-label{display:none}.option:active,.option-order:active{cursor:grabbing}.option.cdk-drag-preview .option-order{pointer-events:all;cursor:grabbing;background-color:var(--cnet-primary-400, #95ca69)}.option.cdk-drag-preview{pointer-events:all;cursor:grabbing;background-color:var(--cnet--100, #f5f5f5)}.input-field{display:flex;align-content:center;margin:4px;flex-direction:column}.remove-button{display:none}.option:hover .remove-button{display:block}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "directive", type: CnetInputDirective, selector: "cnet-input, [CnetInput], [cnet-input]", inputs: ["id", "required", "disabled", "value", "focused", "errorState"] }, { kind: "directive", type: i5.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { kind: "component", type: CnetFormFieldComponent, selector: "cnet-form-field", inputs: ["hasMoreThanOneControl", "showLabel"], exportAs: ["cnetButton"] }, { kind: "directive", type: CnetFieldErrorDirective, selector: "cnet-field-error, [cnetFieldError], [cnet-field-error]", inputs: ["id"] }, { kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "pipe", type: AscIIToCharPipe, name: "ascIIToChar" }, { kind: "pipe", type: i1$3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OptionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-option', template: "<form [formGroup]=\"optionForm\">\n  <div class=\"option\" cdkDrag cdkDragLockAxis=\"y\" [cdkDragDisabled]=\"optionForm.disabled\">\n    <div class=\"option-order\">\n      {{ order+64 | ascIIToChar }}\n    </div>\n    <cnet-form-field class=\"input-field\" style=\"width: 95%;\">\n      <input cnet-input id=\"option\" formControlName=\"label\" type=\"text\"\n        [placeholder]=\"'Adicone uma alternativa' | translate\" />\n      <cnet-field-error>\n        <div *ngIf=\"optionForm.controls.label.hasError('required')\">{{'Alternativa n\u00E3o pode ficar em branco.' |\n          translate}}</div>\n        <div *ngIf=\"optionForm.controls.label.hasError('valueAlredyExists')\">{{'Este Valor j\u00E1 existe.' | translate}}\n        </div>\n      </cnet-field-error>\n    </cnet-form-field>\n    <div *ngIf=\"!removeDisabled\" style=\"width: 5%;\">\n      <button cnet-icon-button type=\"button\" (click)=\"removeThisOption()\" class=\"remove-button\"\n        [disabled]=\"optionForm.disabled\" size=\"large\">\n        <cnet-icon name=\"trash-alt\" label=\"Remove\" color=\"danger\"></cnet-icon>\n      </button>\n    </div>\n  </div>\n</form>\n", styles: [".option{display:flex;flex-direction:row;justify-content:space-between}.option-order{font-size:small;margin:8px;padding:16px;width:16px;height:16px;border-radius:50%;display:flex;flex-direction:row;align-content:center;align-items:center;justify-content:center;background:#757575;color:#fff;cursor:grab}::ng-deep .option .cnet-field-label{display:none}.option:active,.option-order:active{cursor:grabbing}.option.cdk-drag-preview .option-order{pointer-events:all;cursor:grabbing;background-color:var(--cnet-primary-400, #95ca69)}.option.cdk-drag-preview{pointer-events:all;cursor:grabbing;background-color:var(--cnet--100, #f5f5f5)}.input-field{display:flex;align-content:center;margin:4px;flex-direction:column}.remove-button{display:none}.option:hover .remove-button{display:block}\n"] }]
        }], ctorParameters: () => [{ type: OptionService }] });

class CnetDynamicListComponent {
    get value() {
        return this._value;
    }
    set value(val) {
        if (val && val.length && Array.isArray(val)) {
            this._value = val.sort((a, b) => a.order - b.order);
            this.onChange(val);
            this.onTouched();
        }
    }
    get invalid() {
        return this._invalid;
    }
    set invalid(invalid) {
        this._invalid = invalid;
    }
    constructor(injector, resolver, _optionService) {
        this.injector = injector;
        this.resolver = resolver;
        this._optionService = _optionService;
        this.arrayOptionValue = new BehaviorSubject([]);
        this.type = '';
        this.allowDuplicatedValues = true;
        this.optionsReferences = [];
        // ====================< VAR FOR VALUE ACESSOR >==========================
        this._value = [];
        this.onChange = () => { };
        this.onTouched = () => { };
        this._invalid = false;
        this.disabled = false;
    }
    ngOnInit() {
        this.arrayOptionValue.subscribe((arr) => {
            this.value = arr;
        });
        this.setComponentControl();
    }
    setComponentControl() {
        const injectedControl = this.injector.get(NgControl);
        switch (injectedControl.constructor) {
            case FormControlName: {
                this.control = this.injector.get(FormGroupDirective).getControl(injectedControl);
                this.control.statusChanges.subscribe(v => {
                    if (v === 'INVALID') {
                        this.optionsReferences.forEach(ref => {
                            if (this._optionService.isInvalid(ref)) {
                                this._optionService.markTouched(ref);
                            }
                        });
                    }
                });
                break;
            }
        }
    }
    addOption(option) {
        const factory = this.resolver.resolveComponentFactory(OptionComponent);
        const optionRef = this.vcr.createComponent(factory);
        this._optionService.addOption(optionRef, this, option ?? { label: '', order: this.getNextOrder() });
        this.optionsReferences.push(optionRef);
        this.validateIfHasAtLeast2Options();
    }
    removeOption(id) {
        if (this.vcr.length < 1) {
            console.error("None refereces created");
            return;
        }
        if (this.optionsReferences.length < 1) {
            console.error("empty refereces array");
            return;
        }
        const componentRef = this.optionsReferences.find(ref => this._optionService.getId(ref) === id);
        const vcrIndex = this.vcr.indexOf(componentRef.hostView);
        this.vcr.remove(vcrIndex);
        this.optionsReferences = this.optionsReferences.filter((ref) => this._optionService.getId(ref) !== id);
        this.updateReferences();
    }
    drop(event) {
        this.vcr.move(this.optionsReferences[event.previousIndex].hostView, event.currentIndex);
        moveItemInArray(this.optionsReferences, event.previousIndex, event.currentIndex);
        this.updateReferences();
    }
    updateReferences() {
        this.optionsReferences.forEach((ref, index) => this._optionService.addOrderOnOption(ref, ++index));
        const updatedArrayOptionValue = this.optionsReferences.filter(ref => !this._optionService.isInvalid(ref)).map(ref => { return this._optionService.exportOptionAsListOption(ref.instance, this.type); });
        this.arrayOptionValue.next(updatedArrayOptionValue);
        this.validateIfHasAtLeast2Options();
    }
    updateArrayOptionValue(option) {
        let oldArray = this.arrayOptionValue.getValue();
        const updateOption = oldArray.find(op => op.id === option.id);
        if (option.label) {
            // if label isn't empty, update or add option on arrayOptionValue
            if (updateOption) {
                updateOption.label = option.label;
                updateOption.value = option.value;
            }
            else {
                oldArray.push(option);
            }
        }
        else {
            // if label is empty, remove from arrayOptionValue
            if (updateOption) {
                oldArray = oldArray.filter(op => op.id !== updateOption.id);
            }
        }
        if (this.allowDuplicatedValues) {
            this.arrayOptionValue.next(oldArray);
        }
        else {
            // check if has duplicated values
            this.checkDuplicatedValuesOnList(oldArray);
        }
    }
    checkDuplicatedValuesOnList(oldArray) {
        const oldArrayLabels = oldArray.map(o => o.label);
        const hasDuplicated = oldArrayLabels.length !== new Set(oldArrayLabels).size;
        //so faço esse next se não tiver repetidos
        if (!hasDuplicated) {
            this.optionsReferences.forEach(op => op.instance.clearValidateUniqueValueError());
            this.invalid = false;
            this.arrayOptionValue.next(oldArray);
        }
        else {
            let duplicatedValue = [];
            oldArrayLabels.forEach(item => {
                if (oldArrayLabels.filter(a => a === item).length > 1) {
                    duplicatedValue.push(item);
                }
            });
            // achar os options q tem o valor fraco!
            const optionsWithDuplicated = this.optionsReferences.filter(or => duplicatedValue.includes(or.instance.optionForm.controls.label.value));
            const optionsNotDuplicated = this.optionsReferences.filter(or => !duplicatedValue.includes(or.instance.optionForm.controls.label.value));
            optionsNotDuplicated.forEach(op => op.instance.clearValidateUniqueValueError());
            optionsWithDuplicated.forEach(op => op.instance.validateUniqueValue());
            this.invalid = true;
            this.control.updateValueAndValidity();
        }
    }
    getNextOrder() {
        //TODO: Conferir se posso fazer this.optionsReferences?.length ? Math.max(...this.optionsReferences.map(o => o.instance.order)) : 0;
        let order = this.optionsReferences && this.optionsReferences.length ? Math.max(...this.optionsReferences.map(ref => this._optionService.getOrder(ref))) : 0;
        return ++order;
    }
    validateIfHasAtLeast2Options() {
        if (this.optionsReferences.length < 3) {
            this._optionService.disableRemove(this.optionsReferences);
        }
        else {
            this._optionService.enableRemove(this.optionsReferences);
        }
    }
    getCompType() {
        return this.type;
    }
    //====================< VALUE ACESSOR FUNCTIONS >============================
    writeValue(arrOptions) {
        if (arrOptions && arrOptions.length && Array.isArray(arrOptions)) {
            this.value = arrOptions;
            this.value.forEach(op => this.addOption(op));
            if (arrOptions.length === 1) {
                this.addOption();
            }
        }
        else {
            this.value = [];
            this.addOption();
            this.addOption();
        }
    }
    registerOnChange(fn) {
        this.onChange = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        this.optionsReferences.forEach(ref => {
            if (isDisabled) {
                this._optionService.disableForm(ref);
            }
            else {
                this._optionService.enableForm(ref);
            }
        });
    }
    //====================< VALIDATORS FUNCTIONS >============================
    //  VALIDATE SOBRESCREVE O VALIDARORS.REQUIRED
    validate(control) {
        const hasOptionInvalid = this.optionsReferences.some(or => or.instance.optionForm.invalid);
        if (this.invalid) {
            return { 'required': { message: 'this control must contain as value an array ', value: control.value } };
        }
        if ((!control.value || !control.value.length || !Array.isArray(control.value)) && hasOptionInvalid) {
            return { 'required': { message: 'this control must contain as value an array ', value: control.value } };
        }
        return null;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDynamicListComponent, deps: [{ token: Injector }, { token: i0.ComponentFactoryResolver }, { token: OptionService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetDynamicListComponent, selector: "cnet-dynamic-list", inputs: { type: "type", allowDuplicatedValues: "allowDuplicatedValues", value: "value", invalid: "invalid" }, providers: [
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: forwardRef((() => CnetDynamicListComponent)),
                multi: true
            },
            {
                provide: NG_VALIDATORS,
                useExisting: forwardRef((() => CnetDynamicListComponent)),
                multi: true,
            }
        ], viewQueries: [{ propertyName: "vcr", first: true, predicate: ["optionsContainer"], descendants: true, read: ViewContainerRef, static: true }], ngImport: i0, template: "<div cdkDropList (cdkDropListDropped)=\"drop($event)\">\n  <ng-container #optionsContainer></ng-container>\n</div>\n<div class=\"add-button\">\n  <button cnet-stroked-button type=\"button\"  [size]=\"'small'\" (click)=\"addOption()\" [disabled]=\"disabled\">\n    <cnet-icon name=\"plus\" label=\"Edit\"></cnet-icon>\n    <div>\n      {{'Adicionar op\u00E7\u00E3o'| translate}}\n    </div>\n  </button>\n</div>\n", styles: [":host{display:flex;flex-direction:column}.add-button{margin:16px 0;display:flex;flex-direction:row;justify-content:flex-start;line-height:normal;width:100vw}.cnet-button-wrapper{display:flex;align-items:center;justify-content:space-between;flex-direction:row;align-content:center;padding:6px 4px 4px}\n"], dependencies: [{ kind: "directive", type: i5.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "pipe", type: i1$3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDynamicListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-dynamic-list', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => CnetDynamicListComponent)),
                            multi: true
                        },
                        {
                            provide: NG_VALIDATORS,
                            useExisting: forwardRef((() => CnetDynamicListComponent)),
                            multi: true,
                        }
                    ], template: "<div cdkDropList (cdkDropListDropped)=\"drop($event)\">\n  <ng-container #optionsContainer></ng-container>\n</div>\n<div class=\"add-button\">\n  <button cnet-stroked-button type=\"button\"  [size]=\"'small'\" (click)=\"addOption()\" [disabled]=\"disabled\">\n    <cnet-icon name=\"plus\" label=\"Edit\"></cnet-icon>\n    <div>\n      {{'Adicionar op\u00E7\u00E3o'| translate}}\n    </div>\n  </button>\n</div>\n", styles: [":host{display:flex;flex-direction:column}.add-button{margin:16px 0;display:flex;flex-direction:row;justify-content:flex-start;line-height:normal;width:100vw}.cnet-button-wrapper{display:flex;align-items:center;justify-content:space-between;flex-direction:row;align-content:center;padding:6px 4px 4px}\n"] }]
        }], ctorParameters: () => [{ type: i0.Injector, decorators: [{
                    type: Inject,
                    args: [Injector]
                }] }, { type: i0.ComponentFactoryResolver }, { type: OptionService }], propDecorators: { type: [{
                type: Input
            }], allowDuplicatedValues: [{
                type: Input
            }], vcr: [{
                type: ViewChild,
                args: ["optionsContainer", { static: true, read: ViewContainerRef }]
            }], value: [{
                type: Input
            }], invalid: [{
                type: Input
            }] } });

class AscIIToCharModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AscIIToCharModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: AscIIToCharModule, declarations: [AscIIToCharPipe], imports: [CommonModule], exports: [AscIIToCharPipe] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AscIIToCharModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: AscIIToCharModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AscIIToCharPipe],
                    exports: [AscIIToCharPipe],
                    imports: [
                        CommonModule
                    ]
                }]
        }] });

/**
 * Description text for a Form Field
 *
 * @export
 * class CnetFieldDescriptionDirective
 */
class CnetFieldDescriptionDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFieldDescriptionDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetFieldDescriptionDirective, selector: "cnet-field-description, [cnetFieldDescription], [cnet-field-description]", host: { classAttribute: "cnet-field-description" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFieldDescriptionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-field-description, [cnetFieldDescription], [cnet-field-description]',
                    host: {
                        class: 'cnet-field-description'
                    },
                }]
        }] });

/**
 * Label for a Form Field
 *
 * @export
 * class CnetFieldLabelDirective
 */
class CnetFieldLabelDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFieldLabelDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetFieldLabelDirective, selector: "cnet-field-label, [cnetFieldLabel], [cnet-field-label]", ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFieldLabelDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-field-label, [cnetFieldLabel], [cnet-field-label]',
                }]
        }] });

/**
 * Content inserted after input
 *
 * @export
 * class CnetFieldSuffixDirective
 */
class CnetFieldSuffixDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFieldSuffixDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetFieldSuffixDirective, selector: "cnet-field-suffix, [cnetFieldSuffix], [cnet-field-suffix]", host: { classAttribute: "cnet-field-suffix" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFieldSuffixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-field-suffix, [cnetFieldSuffix], [cnet-field-suffix]',
                    host: {
                        class: 'cnet-field-suffix'
                    },
                }]
        }] });

/**
 * Content inserted after input
 *
 * @export
 * class CnetFieldPrefixDirective
 */
class CnetFieldPrefixDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFieldPrefixDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetFieldPrefixDirective, selector: "cnet-field-prefix, [cnetFieldPrefix], [cnet-field-prefix]", host: { classAttribute: "cnet-field-prefix" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFieldPrefixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-field-prefix, [cnetFieldPrefix], [cnet-field-prefix]',
                    host: {
                        class: 'cnet-field-prefix'
                    },
                }]
        }] });

class CnetFormFieldModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFormFieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetFormFieldModule, declarations: [CnetFormFieldComponent,
            CnetFieldDescriptionDirective,
            CnetFieldErrorDirective,
            CnetFieldLabelDirective,
            CnetFieldSuffixDirective,
            CnetFieldPrefixDirective], imports: [CommonModule,
            ReactiveFormsModule], exports: [CnetFormFieldComponent,
            CnetFieldDescriptionDirective,
            CnetFieldErrorDirective,
            CnetFieldLabelDirective,
            CnetFieldSuffixDirective,
            CnetFieldPrefixDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFormFieldModule, imports: [CommonModule,
            ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFormFieldModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnetFormFieldComponent,
                        CnetFieldDescriptionDirective,
                        CnetFieldErrorDirective,
                        CnetFieldLabelDirective,
                        CnetFieldSuffixDirective,
                        CnetFieldPrefixDirective,
                    ],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule
                    ],
                    exports: [
                        CnetFormFieldComponent,
                        CnetFieldDescriptionDirective,
                        CnetFieldErrorDirective,
                        CnetFieldLabelDirective,
                        CnetFieldSuffixDirective,
                        CnetFieldPrefixDirective,
                    ]
                }]
        }] });

class OptionModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OptionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: OptionModule, declarations: [OptionComponent], imports: [CommonModule,
            ReactiveFormsModule,
            FormsModule,
            CnetInputModule,
            DragDropModule,
            CnetFormFieldModule,
            CnetButtonModule,
            AscIIToCharModule,
            CnetIconModule,
            TranslateModule], exports: [OptionComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OptionModule, imports: [CommonModule,
            ReactiveFormsModule,
            FormsModule,
            CnetInputModule,
            DragDropModule,
            CnetFormFieldModule,
            CnetButtonModule,
            AscIIToCharModule,
            CnetIconModule,
            TranslateModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: OptionModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        OptionComponent
                    ],
                    exports: [
                        OptionComponent
                    ],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        FormsModule,
                        CnetInputModule,
                        DragDropModule,
                        CnetFormFieldModule,
                        CnetButtonModule,
                        AscIIToCharModule,
                        CnetIconModule,
                        TranslateModule
                    ]
                }]
        }] });

class CnetDynamicListModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDynamicListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetDynamicListModule, declarations: [CnetDynamicListComponent], imports: [CommonModule,
            DragDropModule,
            CnetButtonModule,
            CnetIconModule,
            OptionModule,
            TranslateModule], exports: [CnetDynamicListComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDynamicListModule, imports: [CommonModule,
            DragDropModule,
            CnetButtonModule,
            CnetIconModule,
            OptionModule,
            TranslateModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDynamicListModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetDynamicListComponent],
                    exports: [CnetDynamicListComponent],
                    imports: [
                        CommonModule,
                        DragDropModule,
                        CnetButtonModule,
                        CnetIconModule,
                        OptionModule,
                        TranslateModule
                    ]
                }]
        }] });

class SlidePanelComponent {
    constructor() {
        this.activePane = 'left';
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SlidePanelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: SlidePanelComponent, selector: "cnet-slide-panel", inputs: { activePane: "activePane" }, ngImport: i0, template: "<div class=\"panes\" [@slide]=\"activePane\">\n  <div style=\" display: flex; align-items: stretch;\">\n    <ng-content select=\"[leftPane]\"></ng-content>\n  </div>\n  <div style=\" display: flex; align-items: stretch;\">\n    <ng-content select=\"[rightPane]\"></ng-content>\n  </div>\n</div>\n", styles: [":host{width:200%;overflow:hidden}.panes{height:100%;width:200%;display:flex}.panes div{flex:1}@media (max-width: 1199.98px){.panes{width:100%}}\n"], animations: [
            trigger('slide', [
                state('left', style({ transform: 'translateX(0)' })),
                state('right', style({ transform: 'translateX(-50%)' })),
                transition('* => *', animate(300))
            ])
        ], changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SlidePanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-slide-panel', changeDetection: ChangeDetectionStrategy.OnPush, animations: [
                        trigger('slide', [
                            state('left', style({ transform: 'translateX(0)' })),
                            state('right', style({ transform: 'translateX(-50%)' })),
                            transition('* => *', animate(300))
                        ])
                    ], template: "<div class=\"panes\" [@slide]=\"activePane\">\n  <div style=\" display: flex; align-items: stretch;\">\n    <ng-content select=\"[leftPane]\"></ng-content>\n  </div>\n  <div style=\" display: flex; align-items: stretch;\">\n    <ng-content select=\"[rightPane]\"></ng-content>\n  </div>\n</div>\n", styles: [":host{width:200%;overflow:hidden}.panes{height:100%;width:200%;display:flex}.panes div{flex:1}@media (max-width: 1199.98px){.panes{width:100%}}\n"] }]
        }], ctorParameters: () => [], propDecorators: { activePane: [{
                type: Input
            }] } });

class SlidePanelModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SlidePanelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: SlidePanelModule, declarations: [SlidePanelComponent], imports: [CommonModule], exports: [SlidePanelComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SlidePanelModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SlidePanelModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SlidePanelComponent],
                    exports: [SlidePanelComponent
                    ],
                    imports: [
                        CommonModule
                    ]
                }]
        }] });

let nextUniqueId$7 = 0;
const SLIDER_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CnetSliderOldComponent),
    multi: true
};
class CnetSliderOldComponent {
    /**
   * The value of the slider
   *
   * type {(T | null)}
   * @memberof CnetSliderComponent
   */
    get value() { return this._valueAcessor.value; }
    set value(value) {
        if (value !== this._valueAcessor.value) {
            this._valueAcessor.value = value;
            this.onChange();
            this.onTouchedFn();
        }
    }
    /**
    * The id of this slider
    *
    * type {string}
    * @memberof CnetSliderComponent
    */
    get id() { return this._id; }
    set id(value) {
        this._id = value || `cnet-slider-old-${nextUniqueId$7}`;
    }
    /**
     * Whether the control is focused
     *
     * type {boolean}
     * @memberof CnetSliderComponent
     */
    get focused() { return this._focused; }
    set focused(value) { this._focused = coerceBooleanProperty(value); }
    /**
    * Whether the slider is disabled.
    *
    * type {boolean}
    * @memberof CnetSliderComponent
    */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
        if (this.focused) {
            this.focused = false;
        }
    }
    get steps() { return this._steps; }
    set steps(steps) {
        if (steps) {
            if (steps && steps.length && steps[0].text) {
                // instance of ArrayOptionDefault -> vindo do componente dinamico
                this._steps = steps.map(s => { return { label: s.text, order: s.order, value: s.order }; });
            }
            else {
                this._steps = steps;
            }
            this.createOptions();
        }
    }
    constructor(_elementRef) {
        this._elementRef = _elementRef;
        /** @ignore */ this._id = `cnet-slider-old-${nextUniqueId$7++}`;
        /** @ignore */ this._required = false;
        /** @ignore */ this._disabled = false;
        /** @ignore */ this._focused = false;
        /** @ignore */ this._errorState = false;
        // value acesssor methods
        /** @ignore */
        this.onChangeFn = (_) => { };
        /** @ignore */
        this.onTouchedFn = () => { };
        this._valueAcessor = this._elementRef.nativeElement;
        this.form = new UntypedFormGroup({
            slider: new UntypedFormControl()
        });
    }
    ngOnInit() {
        this.form.controls.slider.valueChanges.subscribe(value => {
            const step = this.steps.find(step => step.value === value);
            this.value = step?.label;
        });
    }
    createOptions() {
        const auxOptions = {
            showTicksValues: false,
            showTicks: true,
            vertical: false,
            hidePointerLabels: true,
            hideLimitLabels: true,
            showSelectionBar: true,
            animateOnMove: true,
        };
        auxOptions['stepsArray'] = this.steps?.map(step => { return { ...step, legend: step.label }; });
        this.sliderOptions = { ...auxOptions };
    }
    /** @ignore */
    onChange() {
        this.onChangeFn(this.value);
    }
    /** @ignore */
    writeValue(obj) {
        if (obj) {
            let valueAux = obj;
            if (typeof obj === 'string' || obj instanceof String) {
                valueAux = this.steps.find(s => s.label === obj);
            }
            setTimeout(() => {
                if (valueAux) {
                    this.form.controls.slider.setValue(valueAux.value);
                }
                else {
                    console.error("Não foi possivel determinar este valor");
                }
            }, 50);
        }
    }
    /**
     * Registers a callback function that is called when the control's value changes in the UI.
     *
     * param {*} fn
     * @memberof CnetSliderComponent
     */
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    /**
     * Registers a callback function is called by the forms API on initialization to update the form model on blur.
     *
     * param {*} fn
     * @memberof CnetSliderComponent
     */
    registerOnTouched(fn) {
        this.onTouchedFn = fn;
    }
    /**
     * Registers a callback function is called by the forms API on functions disable and enable.
     *
     * param {*} fn
     * @memberof CnetSliderComponent
     */
    setDisabledState(idDisabled) {
        this.disabled = idDisabled;
        if (idDisabled) {
            const optionsAux = { ...this.sliderOptions };
            optionsAux['readOnly'] = true;
            this.sliderOptions = { ...optionsAux };
            setTimeout(() => {
                this.form.disable();
            }, 100);
        }
        else {
            this.form.enable();
            const optionsAux = { ...this.sliderOptions };
            optionsAux['readOnly'] = false;
            this.sliderOptions = { ...optionsAux };
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSliderOldComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetSliderOldComponent, selector: "cnet-slider-old", inputs: { value: "value", id: "id", focused: "focused", disabled: "disabled", steps: "steps" }, providers: [
            SLIDER_VALUE_ACCESSOR
        ], ngImport: i0, template: "<form [formGroup]=\"form\">\n  <div class=\"custom-slider\">\n    <ngx-slider formControlName=\"slider\" [options]=\"sliderOptions\"></ngx-slider>\n  </div>\n</form>\n", styles: ["::ng-deep .custom-slider .ngx-slider .ngx-slider-bar{background:#ccc;height:4px}::ng-deep .ngx-slider.animate .ngx-slider-selection{height:6px;margin-top:-1px}::ng-deep .custom-slider .ngx-slider .ngx-slider-selection{background:var(--cnet-primary-500, #82c14f)}::ng-deep .custom-slider .ngx-slider .ngx-slider-pointer:active{cursor:grabbing}::ng-deep .custom-slider .ngx-slider .ngx-slider-pointer{cursor:grab;width:16px;height:16px;top:-6px;bottom:0;background-color:var(--cnet-primary-500, #82c14f)}::ng-deep .custom-slider .ngx-slider .ngx-slider-pointer:after{display:none}::ng-deep .custom-slider .ngx-slider .ngx-slider-bubble{bottom:14px}::ng-deep .custom-slider .ngx-slider .ngx-slider-limit{font-weight:700;color:var(--cnet-primary-500, #82c14f)}::ng-deep .custom-slider .ngx-slider .ngx-slider-tick{width:2px;height:12px;margin-left:4px;border-radius:0;background:var(--cnet-primary-500, #82c14f);top:-1px}::ng-deep .custom-slider .ngx-slider .ngx-slider-tick-legend{font-size:12px}::ng-deep .custom-slider .ngx-slider .ngx-slider-tick.ngx-slider-selected{background:var(--cnet-primary-500, #82c14f)}::ng-deep form{margin-bottom:24px}\n"], dependencies: [{ kind: "component", type: i1$6.SliderComponent, selector: "ngx-slider", inputs: ["value", "highValue", "options", "manualRefresh", "triggerFocus"], outputs: ["valueChange", "highValueChange", "userChangeStart", "userChange", "userChangeEnd"] }, { kind: "directive", type: i1$4.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSliderOldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-slider-old', providers: [
                        SLIDER_VALUE_ACCESSOR
                    ], template: "<form [formGroup]=\"form\">\n  <div class=\"custom-slider\">\n    <ngx-slider formControlName=\"slider\" [options]=\"sliderOptions\"></ngx-slider>\n  </div>\n</form>\n", styles: ["::ng-deep .custom-slider .ngx-slider .ngx-slider-bar{background:#ccc;height:4px}::ng-deep .ngx-slider.animate .ngx-slider-selection{height:6px;margin-top:-1px}::ng-deep .custom-slider .ngx-slider .ngx-slider-selection{background:var(--cnet-primary-500, #82c14f)}::ng-deep .custom-slider .ngx-slider .ngx-slider-pointer:active{cursor:grabbing}::ng-deep .custom-slider .ngx-slider .ngx-slider-pointer{cursor:grab;width:16px;height:16px;top:-6px;bottom:0;background-color:var(--cnet-primary-500, #82c14f)}::ng-deep .custom-slider .ngx-slider .ngx-slider-pointer:after{display:none}::ng-deep .custom-slider .ngx-slider .ngx-slider-bubble{bottom:14px}::ng-deep .custom-slider .ngx-slider .ngx-slider-limit{font-weight:700;color:var(--cnet-primary-500, #82c14f)}::ng-deep .custom-slider .ngx-slider .ngx-slider-tick{width:2px;height:12px;margin-left:4px;border-radius:0;background:var(--cnet-primary-500, #82c14f);top:-1px}::ng-deep .custom-slider .ngx-slider .ngx-slider-tick-legend{font-size:12px}::ng-deep .custom-slider .ngx-slider .ngx-slider-tick.ngx-slider-selected{background:var(--cnet-primary-500, #82c14f)}::ng-deep form{margin-bottom:24px}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { value: [{
                type: Input
            }], id: [{
                type: Input
            }], focused: [{
                type: Input
            }], disabled: [{
                type: Input
            }], steps: [{
                type: Input
            }] } });

class CnetSliderOldModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSliderOldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetSliderOldModule, declarations: [CnetSliderOldComponent], imports: [CommonModule,
            NgxSliderModule,
            ReactiveFormsModule], exports: [CnetSliderOldComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSliderOldModule, imports: [CommonModule,
            NgxSliderModule,
            ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSliderOldModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetSliderOldComponent],
                    exports: [CnetSliderOldComponent],
                    imports: [
                        CommonModule,
                        NgxSliderModule,
                        ReactiveFormsModule
                    ]
                }]
        }] });

let QuestionControlService$1 = class QuestionControlService {
    constructor() { }
    toFormGroup(questions) {
        const group = {};
        if (Array.isArray(questions) && questions.length) {
            questions.forEach(question => {
                group[question.key] = question.required ? new UntypedFormControl(question.value || '', Validators.required)
                    : new UntypedFormControl(question.value || '');
            });
            return new UntypedFormGroup(group);
        }
        else {
            console.error('must be a array of QuestionBase ');
        }
    }
    createControl(question) {
        const control = question.required ? new UntypedFormControl(question.value || '', Validators.required)
            : new UntypedFormControl(question.value || '');
        return control;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: QuestionControlService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: QuestionControlService, providedIn: 'root' }); }
};
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: QuestionControlService$1, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class DynamicFormQuestionComponent {
    get isValid() { return this.form?.controls[this.question?.key].valid; }
    get isDisabled() { return this.form?.controls[this.question?.key].disabled; }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DynamicFormQuestionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: DynamicFormQuestionComponent, selector: "cnet-form-question", inputs: { question: "question", form: "form" }, ngImport: i0, template: "<div [formGroup]=\"form\">\n  <label [attr.for]=\"question?.key\" style=\"font-size: 20px;\">{{question?.order+1}}. {{question?.label}} <span\n      *ngIf=\"question?.required\"> * </span> </label>\n\n  <div [ngSwitch]=\"question?.controlType\">\n\n    <div *ngSwitchCase=\"'textarea'\">\n      <textarea [formControlName]=\"question?.key\" [id]=\"question?.key\" [rows]=\"question['rows']\"></textarea>\n      <p class=\"carcter-counting\">{{form.value[question?.key].length}} caracteres</p>\n    </div>\n\n    <cnet-radio-group *ngSwitchCase=\"'radiobutton'\" [formControlName]=\"question?.key\" aria-labelledby=\"group-label\"\n      [color]=\"question['color']\" [id]=\"question?.key\" #selectedColor>\n      <cnet-radio *ngFor=\"let item of question['options']; let i = index \" [value]=\"item[question['optionValue']]\">\n        <ng-container>{{ i+65 | ascIIToChar }} - </ng-container>\n        {{ item[question['optionLabel']] }}\n      </cnet-radio>\n    </cnet-radio-group>\n\n    <cnet-slider-old *ngSwitchCase=\"'slider'\" [formControlName]=\"question?.key\" [steps]=\"question['steps']\"></cnet-slider-old>\n\n  </div>\n\n  <div class=\"errorMessage\" *ngIf=\"!isValid && !isDisabled\">{{question?.label}} is required</div>\n</div>\n", styles: ["textarea{width:100%;padding:8px 24px;border-color:#ccc;line-height:inherit;font-size:16px;border-radius:5px}textarea:focus-visible{border-color:#ccc}label span{color:red}cnet-radio{width:100%;font-size:16px}.carcter-counting{display:flex;width:100%;justify-content:flex-end}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: CnetRadioComponent, selector: "cnet-radio", inputs: ["id", "name", "checked", "value", "disabled", "enableUncheck"], outputs: ["change", "blur", "focus"], exportAs: ["cnetRadio"] }, { kind: "component", type: CnetRadioGroupComponent, selector: "cnet-radio-group", inputs: ["id", "name", "value", "disabled", "color"], exportAs: ["cnetRadioGroup"] }, { kind: "component", type: CnetSliderOldComponent, selector: "cnet-slider-old", inputs: ["value", "id", "focused", "disabled", "steps"] }, { kind: "pipe", type: AscIIToCharPipe, name: "ascIIToChar" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: DynamicFormQuestionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-form-question', template: "<div [formGroup]=\"form\">\n  <label [attr.for]=\"question?.key\" style=\"font-size: 20px;\">{{question?.order+1}}. {{question?.label}} <span\n      *ngIf=\"question?.required\"> * </span> </label>\n\n  <div [ngSwitch]=\"question?.controlType\">\n\n    <div *ngSwitchCase=\"'textarea'\">\n      <textarea [formControlName]=\"question?.key\" [id]=\"question?.key\" [rows]=\"question['rows']\"></textarea>\n      <p class=\"carcter-counting\">{{form.value[question?.key].length}} caracteres</p>\n    </div>\n\n    <cnet-radio-group *ngSwitchCase=\"'radiobutton'\" [formControlName]=\"question?.key\" aria-labelledby=\"group-label\"\n      [color]=\"question['color']\" [id]=\"question?.key\" #selectedColor>\n      <cnet-radio *ngFor=\"let item of question['options']; let i = index \" [value]=\"item[question['optionValue']]\">\n        <ng-container>{{ i+65 | ascIIToChar }} - </ng-container>\n        {{ item[question['optionLabel']] }}\n      </cnet-radio>\n    </cnet-radio-group>\n\n    <cnet-slider-old *ngSwitchCase=\"'slider'\" [formControlName]=\"question?.key\" [steps]=\"question['steps']\"></cnet-slider-old>\n\n  </div>\n\n  <div class=\"errorMessage\" *ngIf=\"!isValid && !isDisabled\">{{question?.label}} is required</div>\n</div>\n", styles: ["textarea{width:100%;padding:8px 24px;border-color:#ccc;line-height:inherit;font-size:16px;border-radius:5px}textarea:focus-visible{border-color:#ccc}label span{color:red}cnet-radio{width:100%;font-size:16px}.carcter-counting{display:flex;width:100%;justify-content:flex-end}\n"] }]
        }], propDecorators: { question: [{
                type: Input
            }], form: [{
                type: Input
            }] } });

class QuestionBaseOld {
    constructor(options = {}) {
        this.value = options.value;
        this.key = options.key || '';
        this.label = options.label || '';
        this.required = !!options.required;
        this.order = options.order === undefined ? 1 : options.order;
        this.controlType = options.controlType || '';
    }
}

class RadiobuttonQuestion extends QuestionBaseOld {
    constructor(options = {}) {
        super(options);
        this.controlType = 'radiobutton';
        this.color = 'primary';
        this.optionLabel = 'label';
        this.optionValue = 'value';
        this.color = options['color'] || 'primary';
        this.optionLabel = options['optionLabel'] || 'label';
        this.optionValue = options['optionValue'] || 'value';
        this.options = options['options'] || [];
    }
}

let SliderQuestion$1 = class SliderQuestion extends QuestionBaseOld {
    constructor(options = {}) {
        super(options);
        this.controlType = 'slider';
        this.steps = options['steps'];
    }
};

class TextareaQuestion extends QuestionBaseOld {
    constructor(options = {}) {
        super(options);
        this.controlType = 'textarea';
        this.rows = 5;
        this.type = options['type'] || '';
        this.rows = options['rows'] || 5;
    }
}

class RequiredMarkDirective {
    set show(show) {
        this._show = show;
        this.addRequiriment();
    }
    get show() {
        return this._show;
    }
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this._show = true;
    }
    ngOnInit() {
        this.addRequiriment();
    }
    addRequiriment() {
        const hastMark = this.elementRef.nativeElement.lastChild.id === 'requiredMark';
        if (hastMark) {
            this.elementRef.nativeElement.removeChild(this.elementRef.nativeElement.lastChild);
        }
        if (this.show) {
            const child = document.createElement('div');
            child.id = 'requiredMark';
            child.style.color = 'red';
            child.style.margin = '0px 4px';
            child.style.float = 'inline-end';
            child.style.width = 'fit-content';
            child.appendChild(document.createTextNode('*'));
            this.renderer.appendChild(this.elementRef.nativeElement, child);
            this.elementRef.nativeElement.style.display = 'table-cell';
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RequiredMarkDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: RequiredMarkDirective, selector: "[cnetRequiredMark]", inputs: { show: "show" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RequiredMarkDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetRequiredMark]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }], propDecorators: { show: [{
                type: Input
            }] } });

class CreateUpdateQuestionComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.isCreate = false;
        this.question = null;
        this.submitQuestion = new EventEmitter();
        this.cancel = new EventEmitter();
        this.onDirty = new EventEmitter();
    }
    ngOnInit() {
        this.createForm();
        if (this.question) {
            // update
            this.setForm();
        }
        else {
            // creation
            this.form.controls.key.setValue(uuid.v4());
            // create a key with uuid
            // order = ultima possivel
        }
    }
    createForm() {
        this.form = this.formBuilder.group({
            key: ['',
                Validators.compose([
                    Validators.required
                ])],
            label: ['',
                Validators.compose([
                    Validators.required
                ])],
            type: ['',
                Validators.compose([
                    Validators.required,
                ])],
            isRequired: [false,
                Validators.compose([])],
            options: [[],
                Validators.compose([
                    Validators.required,
                    Validators.minLength(2)
                ])],
            steps: [[],
                Validators.compose([
                    Validators.required,
                    Validators.minLength(2)
                ])],
            order: ['',
                Validators.compose([])],
        });
        this.form.controls.options.disable();
        this.form.controls.steps.disable();
        this.form.controls.type.valueChanges.subscribe(value => {
            if (value === 'radio') {
                this.form.controls.options.enable();
            }
            else {
                this.form.controls.options.disable();
            }
            if (value === 'slider') {
                this.form.controls.steps.enable();
            }
            else {
                this.form.controls.steps.disable();
            }
        });
        this.form.valueChanges.subscribe(value => {
            this.onDirty.emit(this.form.dirty);
        });
    }
    onSubmit() {
        if (this.form.invalid) {
            this.form.markAllAsTouched();
            this.form.updateValueAndValidity();
            if (this.form.controls.options.enabled) {
                this.form.controls.options.updateValueAndValidity();
            }
            if (this.form.controls.steps.enabled) {
                this.form.controls.steps.updateValueAndValidity();
            }
            return;
        }
        let newQuestion;
        if (this.form.value.type === 'radio') {
            newQuestion = new RadiobuttonQuestion({
                key: this.form.value.key,
                label: this.form.value.label,
                optionLabel: 'label',
                required: this.form.value.isRequired,
                options: this.form.value.options,
                order: this.form.value.order,
            });
            this.submitQuestion.emit(newQuestion);
        }
        else if (this.form.value.type === 'textarea') {
            newQuestion = new TextareaQuestion({
                key: this.form.value.key,
                label: this.form.value.label,
                required: this.form.value.isRequired,
                type: 'textarea',
                order: this.form.value.order,
            });
            this.submitQuestion.emit(newQuestion);
        }
        else if (this.form.value.type === 'slider') {
            newQuestion = new SliderQuestion$1({
                key: this.form.value.key,
                label: this.form.value.label,
                required: this.form.value.isRequired,
                order: this.form.value.order,
                steps: this.form.value.steps
            });
            this.submitQuestion.emit(newQuestion);
        }
        else {
            console.error("coudn't find a type");
        }
    }
    onCancel() {
        this.cancel.emit(true);
    }
    setForm() {
        // const type = this.question instanceof RadiobuttonQuestion ? 'radio' :
        //   this.question instanceof TextareaQuestion ? 'textArea' : ''
        const type = this.question.controlType === 'radiobutton' ? 'radio' : this.question.controlType === 'textarea' ? 'textarea' : 'slider';
        let value = {
            key: this.question.key,
            label: this.question.label,
            type: type,
            isRequired: this.question.required,
            order: this.question.order,
            // options: this.question.controlType === 'radiobutton' ? this.question.options : []
        };
        if (this.question.controlType === 'radiobutton') {
            value['options'] = this.question['options'].map((op, index) => { return op.order ? op : { ...op, order: index + 1 }; });
        }
        if (this.question.controlType === 'slider') {
            value['steps'] = this.question['steps'].map((step, index) => { return step.order ? step : { ...step, order: index + 1 }; });
            // value['steps'] = this.question['steps'];
        }
        this.form.patchValue(value);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CreateUpdateQuestionComponent, deps: [{ token: i1$4.UntypedFormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CreateUpdateQuestionComponent, selector: "cnet-create-update-question", inputs: { isCreate: "isCreate", question: "question" }, outputs: { submitQuestion: "submitQuestion", cancel: "cancel", onDirty: "onDirty" }, ngImport: i0, template: "<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit()\" [class.form-padding]=\"!isCreate\">\n\n  <ng-container *ngIf=\"!isCreate\">\n\n    <div class=\"form-inputs\">\n\n      <cnet-form-field style=\"width: 100%;\">\n        <cnet-field-label cnetRequiredMark>{{'forms.question' | translate}}</cnet-field-label>\n        <input cnet-input id=\"label\" formControlName=\"label\" type=\"text\"\n          [placeholder]=\"'forms.questionPlaceholder' | translate\" />\n        <cnet-field-error>\n          <div *ngIf=\"form.controls.label.hasError('required')\">{{'forms.questionRequired' | translate}}</div>\n        </cnet-field-error>\n      </cnet-form-field>\n\n      <cnet-form-field style=\"width: 50%;\">\n        <cnet-field-label cnetRequiredMark>{{'forms.questionType' | translate}}</cnet-field-label>\n\n        <select cnet-input placeholder=\"select a type\" id=\"type\" name=\"type\" formControlName=\"type\">\n          <option value=\"\" disabled selected>{{'forms.select' | translate}}</option>\n          <option value=\"textarea\">Text Area</option>\n          <option value=\"radio\">Radio</option>\n          <option value=\"slider\">Slider</option>\n        </select>\n\n        <cnet-field-error>\n          <div *ngIf=\"form.controls.type.hasError('required')\">{{'forms.questionTypeRequired' | translate}}</div>\n        </cnet-field-error>\n      </cnet-form-field>\n\n      <cnet-form-field class=\"checkbox-control\" style=\"width: 40%;\">\n\n        <cnet-checkbox formControlName=\"isRequired\" id=\"checkbox\">{{'forms.isRequired' | translate}}</cnet-checkbox>\n\n        <cnet-field-error>\n          <div *ngIf=\"form.controls.isRequired.hasError('required')\">este campo \u00E9 obrigat\u00F3rio</div>\n        </cnet-field-error>\n      </cnet-form-field>\n\n      <div *ngIf=\"form.controls.options.enabled\" style=\"width: 100%;\">\n\n        <cnet-form-field class=\"checkbox-control\">\n          <cnet-field-label cnetRequiredMark>{{'forms.alternatives' | translate}}</cnet-field-label>\n        </cnet-form-field>\n\n        <cnet-dynamic-list formControlName=\"options\" type=\"radio\" id=\"options\">\n        </cnet-dynamic-list>\n\n      </div>\n\n      <div *ngIf=\"form.controls.steps.enabled\" style=\"width: 100%;\">\n        <cnet-form-field class=\"checkbox-control\">\n          <cnet-field-label cnetRequiredMark>{{'forms.alternatives' | translate}}</cnet-field-label>\n        </cnet-form-field>\n        <cnet-dynamic-list formControlName=\"steps\" type=\"slider\" id=\"steps\"></cnet-dynamic-list>\n      </div>\n\n    </div>\n\n    <div class=\"form-buttons\">\n\n      <button type=\"button\" (click)=\"onCancel()\" cnet-filled-button color=\"cancel\"\n        class=\"btn btn-cancel\">{{'buttons.cancel'| translate}}</button>\n\n      <button type=\"submit\" cnet-filled-button color=\"success\" class=\"btn btn-success\">{{'buttons.save'|\n        translate}}</button>\n    </div>\n\n  </ng-container>\n  <ng-container *ngIf=\"isCreate\">\n    <cnet-card>\n      <cnet-card-header>\n        <h3 cnet-card-title>{{'academic-calendar.new' | translate}}</h3>\n        <div cnet-card-actions>\n          <button cnet-icon-button cnet-modal-close type=\"button\">\n            <cnet-icon name=\"close\"></cnet-icon>\n          </button>\n        </div>\n      </cnet-card-header>\n\n\n      <div class=\"form-inputs\">\n\n        <cnet-form-field style=\"width: 100%;\">\n          <cnet-field-label cnetRequiredMark>{{'forms.question' | translate}}</cnet-field-label>\n          <input cnet-input id=\"label\" formControlName=\"label\" type=\"text\"\n            [placeholder]=\"'forms.questionPlaceholder' | translate\" />\n          <cnet-field-error>\n            <div *ngIf=\"form.controls.label.hasError('required')\">{{'forms.questionRequired' | translate}}</div>\n          </cnet-field-error>\n        </cnet-form-field>\n\n        <cnet-form-field style=\"width: 50%;\">\n          <cnet-field-label cnetRequiredMark>{{'forms.questionType' | translate}}</cnet-field-label>\n\n          <select cnet-input placeholder=\"select a type\" id=\"type\" name=\"type\" formControlName=\"type\">\n            <option value=\"\" disabled selected>{{'forms.select' | translate}}</option>\n            <option value=\"textarea\">Text Area</option>\n            <option value=\"radio\">Radio</option>\n            <option value=\"slider\">Slider</option>\n          </select>\n\n          <cnet-field-error>\n            <div *ngIf=\"form.controls.type.hasError('required')\">{{'forms.questionTypeRequired' | translate}}</div>\n          </cnet-field-error>\n        </cnet-form-field>\n\n        <cnet-form-field class=\"checkbox-control\" style=\"width: 40%;\">\n\n          <cnet-checkbox formControlName=\"isRequired\" id=\"checkbox\">{{'forms.isRequired' | translate}}</cnet-checkbox>\n\n          <cnet-field-error>\n            <div *ngIf=\"form.controls.isRequired.hasError('required')\">este campo \u00E9 obrigat\u00F3rio</div>\n          </cnet-field-error>\n        </cnet-form-field>\n\n        <div *ngIf=\"form.controls.options.enabled\" style=\"width: 100%;\">\n\n          <cnet-form-field class=\"checkbox-control\">\n            <cnet-field-label cnetRequiredMark>{{'forms.alternatives' | translate}}</cnet-field-label>\n          </cnet-form-field>\n\n          <cnet-dynamic-list formControlName=\"options\" type=\"radio\" id=\"options\">\n          </cnet-dynamic-list>\n\n        </div>\n\n        <div *ngIf=\"form.controls.steps.enabled\" style=\"width: 100%;\">\n          <cnet-form-field class=\"checkbox-control\">\n            <cnet-field-label cnetRequiredMark>{{'forms.alternatives' | translate}}</cnet-field-label>\n          </cnet-form-field>\n          <cnet-dynamic-list formControlName=\"steps\" type=\"slider\" id=\"steps\"></cnet-dynamic-list>\n        </div>\n\n      </div>\n\n      <footer cnet-card-footer>\n        <div class=\"form-group\" style=\" display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: flex-end;\">\n          <button type=\"button\" (click)=\"onCancel()\" cnet-filled-button color=\"cancel\"\n            class=\"btn btn-cancel\">{{'buttons.cancel'| translate}}</button>\n          <button type=\"submit\" cnet-filled-button color=\"success\" class=\"btn btn-success\">{{'buttons.save'|\n            translate}}</button>\n\n        </div>\n      </footer>\n    </cnet-card>\n  </ng-container>\n</form>\n<!-- <cnet-confirm-dialog></cnet-confirm-dialog> -->\n", styles: ["form{font-size:16px;width:100%;display:flex;flex-direction:column;justify-content:space-between}.form-padding{padding:20px 40px}.form-inputs{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;align-content:center}.form-buttons{display:flex;flex-direction:row;justify-content:flex-end;flex-wrap:wrap;align-items:center;align-content:center;margin-top:2rem}button{margin:5px;width:100px}cnet-form-field{margin:5px;width:49%}cnet-field-label{font-size:16px}.checkbox-control ::ng-deep .cnet-form-field-wrap{border:none}:host ::ng-deep .cnet-card{margin-bottom:0}cnet-dynamic-list{width:100%}@media (max-width: 1199.98px){cnet-form-field{width:100%}}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$4.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$4.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$4.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "component", type: CnetFormFieldComponent, selector: "cnet-form-field", inputs: ["hasMoreThanOneControl", "showLabel"], exportAs: ["cnetButton"] }, { kind: "directive", type: CnetFieldErrorDirective, selector: "cnet-field-error, [cnetFieldError], [cnet-field-error]", inputs: ["id"] }, { kind: "directive", type: CnetFieldLabelDirective, selector: "cnet-field-label, [cnetFieldLabel], [cnet-field-label]" }, { kind: "component", type: CnetCheckboxComponent, selector: "cnet-checkbox", inputs: ["id", "name", "checked", "value", "disabled", "color", "enableRiple"], outputs: ["change", "blur", "focus"], exportAs: ["cnetCheckbox"] }, { kind: "directive", type: CnetModalCloseDirective, selector: "[CnetModalClose], [cnet-modal-close]", exportAs: ["cnetModalClose"] }, { kind: "component", type: CnetCardComponent, selector: "cnet-card", exportAs: ["cnetCard"] }, { kind: "component", type: CardHeaderComponent, selector: "cnet-card-header, [cnet-card-header], [cnetCardHeader]", exportAs: ["cnetCardHeader"] }, { kind: "directive", type: CnetCardTitleDirective, selector: "cnet-card-title, [cnet-card-title], [cnetCardTitle]" }, { kind: "directive", type: CnetCardActionsDirective, selector: "cnet-card-actions, [cnet-card-actions], [cnetCardActions]" }, { kind: "component", type: CnetCardFooterComponent, selector: "cnet-card-footer, [cnet-card-footer], [cnetCardFooter]", exportAs: ["cnetCardFooter"] }, { kind: "directive", type: CnetInputDirective, selector: "cnet-input, [CnetInput], [cnet-input]", inputs: ["id", "required", "disabled", "value", "focused", "errorState"] }, { kind: "component", type: CnetDynamicListComponent, selector: "cnet-dynamic-list", inputs: ["type", "allowDuplicatedValues", "value", "invalid"] }, { kind: "directive", type: RequiredMarkDirective, selector: "[cnetRequiredMark]", inputs: ["show"] }, { kind: "pipe", type: i1$3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CreateUpdateQuestionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-create-update-question', template: "<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit()\" [class.form-padding]=\"!isCreate\">\n\n  <ng-container *ngIf=\"!isCreate\">\n\n    <div class=\"form-inputs\">\n\n      <cnet-form-field style=\"width: 100%;\">\n        <cnet-field-label cnetRequiredMark>{{'forms.question' | translate}}</cnet-field-label>\n        <input cnet-input id=\"label\" formControlName=\"label\" type=\"text\"\n          [placeholder]=\"'forms.questionPlaceholder' | translate\" />\n        <cnet-field-error>\n          <div *ngIf=\"form.controls.label.hasError('required')\">{{'forms.questionRequired' | translate}}</div>\n        </cnet-field-error>\n      </cnet-form-field>\n\n      <cnet-form-field style=\"width: 50%;\">\n        <cnet-field-label cnetRequiredMark>{{'forms.questionType' | translate}}</cnet-field-label>\n\n        <select cnet-input placeholder=\"select a type\" id=\"type\" name=\"type\" formControlName=\"type\">\n          <option value=\"\" disabled selected>{{'forms.select' | translate}}</option>\n          <option value=\"textarea\">Text Area</option>\n          <option value=\"radio\">Radio</option>\n          <option value=\"slider\">Slider</option>\n        </select>\n\n        <cnet-field-error>\n          <div *ngIf=\"form.controls.type.hasError('required')\">{{'forms.questionTypeRequired' | translate}}</div>\n        </cnet-field-error>\n      </cnet-form-field>\n\n      <cnet-form-field class=\"checkbox-control\" style=\"width: 40%;\">\n\n        <cnet-checkbox formControlName=\"isRequired\" id=\"checkbox\">{{'forms.isRequired' | translate}}</cnet-checkbox>\n\n        <cnet-field-error>\n          <div *ngIf=\"form.controls.isRequired.hasError('required')\">este campo \u00E9 obrigat\u00F3rio</div>\n        </cnet-field-error>\n      </cnet-form-field>\n\n      <div *ngIf=\"form.controls.options.enabled\" style=\"width: 100%;\">\n\n        <cnet-form-field class=\"checkbox-control\">\n          <cnet-field-label cnetRequiredMark>{{'forms.alternatives' | translate}}</cnet-field-label>\n        </cnet-form-field>\n\n        <cnet-dynamic-list formControlName=\"options\" type=\"radio\" id=\"options\">\n        </cnet-dynamic-list>\n\n      </div>\n\n      <div *ngIf=\"form.controls.steps.enabled\" style=\"width: 100%;\">\n        <cnet-form-field class=\"checkbox-control\">\n          <cnet-field-label cnetRequiredMark>{{'forms.alternatives' | translate}}</cnet-field-label>\n        </cnet-form-field>\n        <cnet-dynamic-list formControlName=\"steps\" type=\"slider\" id=\"steps\"></cnet-dynamic-list>\n      </div>\n\n    </div>\n\n    <div class=\"form-buttons\">\n\n      <button type=\"button\" (click)=\"onCancel()\" cnet-filled-button color=\"cancel\"\n        class=\"btn btn-cancel\">{{'buttons.cancel'| translate}}</button>\n\n      <button type=\"submit\" cnet-filled-button color=\"success\" class=\"btn btn-success\">{{'buttons.save'|\n        translate}}</button>\n    </div>\n\n  </ng-container>\n  <ng-container *ngIf=\"isCreate\">\n    <cnet-card>\n      <cnet-card-header>\n        <h3 cnet-card-title>{{'academic-calendar.new' | translate}}</h3>\n        <div cnet-card-actions>\n          <button cnet-icon-button cnet-modal-close type=\"button\">\n            <cnet-icon name=\"close\"></cnet-icon>\n          </button>\n        </div>\n      </cnet-card-header>\n\n\n      <div class=\"form-inputs\">\n\n        <cnet-form-field style=\"width: 100%;\">\n          <cnet-field-label cnetRequiredMark>{{'forms.question' | translate}}</cnet-field-label>\n          <input cnet-input id=\"label\" formControlName=\"label\" type=\"text\"\n            [placeholder]=\"'forms.questionPlaceholder' | translate\" />\n          <cnet-field-error>\n            <div *ngIf=\"form.controls.label.hasError('required')\">{{'forms.questionRequired' | translate}}</div>\n          </cnet-field-error>\n        </cnet-form-field>\n\n        <cnet-form-field style=\"width: 50%;\">\n          <cnet-field-label cnetRequiredMark>{{'forms.questionType' | translate}}</cnet-field-label>\n\n          <select cnet-input placeholder=\"select a type\" id=\"type\" name=\"type\" formControlName=\"type\">\n            <option value=\"\" disabled selected>{{'forms.select' | translate}}</option>\n            <option value=\"textarea\">Text Area</option>\n            <option value=\"radio\">Radio</option>\n            <option value=\"slider\">Slider</option>\n          </select>\n\n          <cnet-field-error>\n            <div *ngIf=\"form.controls.type.hasError('required')\">{{'forms.questionTypeRequired' | translate}}</div>\n          </cnet-field-error>\n        </cnet-form-field>\n\n        <cnet-form-field class=\"checkbox-control\" style=\"width: 40%;\">\n\n          <cnet-checkbox formControlName=\"isRequired\" id=\"checkbox\">{{'forms.isRequired' | translate}}</cnet-checkbox>\n\n          <cnet-field-error>\n            <div *ngIf=\"form.controls.isRequired.hasError('required')\">este campo \u00E9 obrigat\u00F3rio</div>\n          </cnet-field-error>\n        </cnet-form-field>\n\n        <div *ngIf=\"form.controls.options.enabled\" style=\"width: 100%;\">\n\n          <cnet-form-field class=\"checkbox-control\">\n            <cnet-field-label cnetRequiredMark>{{'forms.alternatives' | translate}}</cnet-field-label>\n          </cnet-form-field>\n\n          <cnet-dynamic-list formControlName=\"options\" type=\"radio\" id=\"options\">\n          </cnet-dynamic-list>\n\n        </div>\n\n        <div *ngIf=\"form.controls.steps.enabled\" style=\"width: 100%;\">\n          <cnet-form-field class=\"checkbox-control\">\n            <cnet-field-label cnetRequiredMark>{{'forms.alternatives' | translate}}</cnet-field-label>\n          </cnet-form-field>\n          <cnet-dynamic-list formControlName=\"steps\" type=\"slider\" id=\"steps\"></cnet-dynamic-list>\n        </div>\n\n      </div>\n\n      <footer cnet-card-footer>\n        <div class=\"form-group\" style=\" display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: flex-end;\">\n          <button type=\"button\" (click)=\"onCancel()\" cnet-filled-button color=\"cancel\"\n            class=\"btn btn-cancel\">{{'buttons.cancel'| translate}}</button>\n          <button type=\"submit\" cnet-filled-button color=\"success\" class=\"btn btn-success\">{{'buttons.save'|\n            translate}}</button>\n\n        </div>\n      </footer>\n    </cnet-card>\n  </ng-container>\n</form>\n<!-- <cnet-confirm-dialog></cnet-confirm-dialog> -->\n", styles: ["form{font-size:16px;width:100%;display:flex;flex-direction:column;justify-content:space-between}.form-padding{padding:20px 40px}.form-inputs{display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;align-content:center}.form-buttons{display:flex;flex-direction:row;justify-content:flex-end;flex-wrap:wrap;align-items:center;align-content:center;margin-top:2rem}button{margin:5px;width:100px}cnet-form-field{margin:5px;width:49%}cnet-field-label{font-size:16px}.checkbox-control ::ng-deep .cnet-form-field-wrap{border:none}:host ::ng-deep .cnet-card{margin-bottom:0}cnet-dynamic-list{width:100%}@media (max-width: 1199.98px){cnet-form-field{width:100%}}\n"] }]
        }], ctorParameters: () => [{ type: i1$4.UntypedFormBuilder }], propDecorators: { isCreate: [{
                type: Input
            }], question: [{
                type: Input
            }], submitQuestion: [{
                type: Output
            }], cancel: [{
                type: Output
            }], onDirty: [{
                type: Output
            }] } });

class ContratanetDynamicFormComponent {
    get disableForm() { return this._disableForm; }
    set disableForm(value) {
        this._disableForm = value;
        if (this.form) {
            if (value) {
                this.form.disable();
            }
            else {
                this.form.enable();
            }
        }
    }
    constructor(qcs, _cnetConfirmDialogService) {
        this.qcs = qcs;
        this._cnetConfirmDialogService = _cnetConfirmDialogService;
        this.questions = [];
        this.disableDragDrop = false;
        this.disableActionButtons = false;
        this.disableDynamicFormSaveBtn = false;
        this._disableForm = false;
        this.form = new UntypedFormGroup({});
        this.changeForm = new EventEmitter();
        this.payLoad = '';
        this.questionEdit = '';
        this.isLeftVisible = true;
        this.hasUpdateFormDirty = false;
    }
    ngOnInit() {
        this.questions.sort((a, b) => a.order - b.order);
        this.form = this.qcs.toFormGroup(this.questions);
        this.form?.valueChanges.subscribe(() => {
            this.changeForm.emit(this.form);
        });
        if (this._disableForm) {
            this.form.disable();
        }
    }
    onSubmit() {
        this.payLoad = JSON.stringify(this.form.getRawValue());
    }
    drop(event) {
        moveItemInArray(this.questions, event.previousIndex, event.currentIndex);
        this.questions.forEach((question, index) => {
            question.order = index;
        });
        this.changeForm.emit(this.form);
    }
    removeQuestion(questionKey) {
        this._cnetConfirmDialogService.confirm({
            message: 'Deseja prosseguir com a exclusão desta questão ?',
            acceptLabel: 'Sim',
            rejectLabel: 'Não',
            accept: () => {
                const removeIndex = this.questions.findIndex(question => question.key === questionKey);
                this.questions.splice(removeIndex, 1);
                this.form.removeControl(questionKey);
                this.questions.forEach((question, index) => {
                    question.order = index;
                });
            }
        });
    }
    editQuestion(questionKey) {
        if (!this.hasUpdateFormDirty) {
            this.questionEdit = questionKey;
        }
        else {
            this._cnetConfirmDialogService.confirm({
                message: 'Já existe uma edição em andamento, deseja cancelar ?',
                acceptLabel: 'Sim',
                rejectLabel: 'Não',
                accept: () => {
                    this.questionEdit = '';
                    this.hasUpdateFormDirty = false;
                    this.questionEdit = questionKey;
                }
            });
        }
    }
    confirmMessageCancelUpdate() {
        if (!this.hasUpdateFormDirty) {
            this.questionEdit = '';
        }
        else {
            this._cnetConfirmDialogService.confirm({
                message: 'Deseja realmente calncelar esta edição?',
                acceptLabel: 'Sim',
                rejectLabel: 'Não',
                accept: () => {
                    this.questionEdit = '';
                    this.hasUpdateFormDirty = false;
                }
            });
        }
    }
    confirmMessageSubmitUpdate(question) {
        if (!this.hasUpdateFormDirty) {
            this.questionEdit = '';
        }
        else {
            this._cnetConfirmDialogService.confirm({
                message: 'Deseja salvar as alterações?',
                accept: () => {
                    this.updateForm(question);
                    this.hasUpdateFormDirty = false;
                }
            });
        }
    }
    onSaveChanges() {
    }
    updateForm(question) {
        this.questionEdit = '';
        setTimeout(() => {
            const quest = this.questions.find(q => q.key === question.key);
            //update question
            const index = this.questions.findIndex(q => q.key === question.key);
            this.questions.splice(index, 1);
            // this.questions.push(radio)
            this.questions.push(question);
            // update form
            if (question.required) {
                this.form.controls[question.key].setValidators([Validators.required]);
            }
            else {
                this.form.controls[question.key].clearValidators();
            }
            this.form.controls[question.key].reset();
            this.questions.sort((a, b) => a.order - b.order);
            this.questions.forEach((question, index) => {
                question.order = index;
            });
        }, 200);
    }
    cancelUpdate() {
        this.questionEdit = '';
    }
    registerAsDirty(e) {
        this.hasUpdateFormDirty = e;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ContratanetDynamicFormComponent, deps: [{ token: QuestionControlService$1 }, { token: CnetConfirmDialogService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ContratanetDynamicFormComponent, selector: "cnet-cnet-cnet-dynamic-form", inputs: { questions: "questions", disableDragDrop: "disableDragDrop", disableActionButtons: "disableActionButtons", disableDynamicFormSaveBtn: "disableDynamicFormSaveBtn", disableForm: "disableForm" }, outputs: { changeForm: "changeForm" }, ngImport: i0, template: "<form (ngSubmit)=\"onSubmit()\" [formGroup]=\"form\" *ngIf=\"form\">\n  <div cdkDropList class=\"example-list\" (cdkDropListDropped)=\"drop($event)\">\n\n    <div *ngFor=\"let question of questions\" class=\"form-row\" cdkDrag cdkDragLockAxis=\"y\"\n      [cdkDragDisabled]=\"disableDragDrop\">\n\n      <cnet-slide-panel [activePane]=\"questionEdit !== question.key ? 'left' : 'right'\">\n\n        <div leftPane class=\"form-row\" style=\"width: 100%;\">\n          <div *ngIf=\"!disableDragDrop\">\n            <div class=\"dragArea\" cdkDragHandle>\n              <cnet-icon name=\"reorder\" label=\"Exclude\"></cnet-icon>\n            </div>\n          </div>\n\n          <div class=\"style-question\">\n            <cnet-form-question [question]=\"question\" [form]=\"form\"></cnet-form-question>\n          </div>\n          <div class=\"actionButtons\" *ngIf=\"!disableActionButtons\">\n            <button cnet-icon-button cnet-stroked-button aria-label=\"Edit\">\n              <cnet-icon name=\"edit\" label=\"Edit\" (click)=\"editQuestion(question.key)\"></cnet-icon>\n            </button>\n            <button cnet-icon-button cnet-stroked-button aria-label=\"Edit\">\n              <cnet-icon name=\"close\" label=\"Exclude\" (click)=\"removeQuestion(question.key)\"></cnet-icon>\n            </button>\n          </div>\n\n        </div>\n\n        <div rightPane class=\"form-row\" style=\"width: 100%;\">\n          <cnet-create-update-question [question]=\"question\" (submitQuestion)=\"confirmMessageSubmitUpdate($event)\"\n            (cancel)=\"confirmMessageCancelUpdate()\" (onDirty)=\"registerAsDirty($event)\"\n            *ngIf=\"questionEdit === question.key\">\n          </cnet-create-update-question>\n        </div>\n\n      </cnet-slide-panel>\n\n    </div>\n    <div class=\"form-row\" *ngIf=\"!disableDynamicFormSaveBtn\">\n      <button type=\"submit\" [disabled]=\"!form?.valid\">Save</button>\n    </div>\n  </div>\n</form>\n\n\n<div *ngIf=\"payLoad && !disableDynamicFormSaveBtn\" class=\"form-row\">\n  <strong>Saved the following values</strong><br>{{payLoad}}\n</div>\n\n<cnet-confirm-dialog></cnet-confirm-dialog>\n", styles: [".example-list{width:100%;max-width:100%;border:solid 1px #ccc;min-height:60px;display:block;background:#fff;border-radius:4px;overflow:hidden}.form-row{border-bottom:solid 1px #ccc;color:#000000de;display:flex;flex-direction:row;justify-content:space-between;box-sizing:border-box;background:#fff;font-size:14px;align-items:stretch}.form-row:hover .dragArea{color:var(--cnet--50, #fafafa);background-color:var(--cnet-primary-400, #95ca69)}.cdk-drag-preview{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.form-row:last-child{border:none}.example-list.cdk-drop-list-dragging .form-row:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}cnet-form-question{width:100%}.dragArea{cursor:grab;width:60px;touch-action:none;-webkit-user-drag:none;-webkit-tap-highlight-color:transparent;-webkit-user-select:none;user-select:none;display:flex;height:100%;flex-direction:row;align-content:center;justify-content:center;align-items:center;border-right:solid 1px #ccc}.form-row.cdk-drag-preview .dragArea{pointer-events:auto;cursor:grabbing;color:var(--cnet--50, #fafafa);background-color:var(--cnet-primary-400, #95ca69)}.actionButtons{display:flex;min-width:80px;flex-direction:row;align-content:flex-start;align-items:flex-start;margin:8px}.actionButtons button{border:none}cnet-create-update-question{width:100%;height:100%;display:flex;align-items:stretch}.style-question{padding:20px 40px;margin-right:auto;width:-webkit-fill-available}@media (max-width: 1199.98px){.form-row{flex-direction:column}.dragArea{border-right:0px;padding:12px;width:100%}.actionButtons{width:100%;justify-content:center}.style-question{padding:20px 40px;margin-right:auto;width:-webkit-fill-available}}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i5.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { kind: "directive", type: i5.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { kind: "directive", type: i5.CdkDragHandle, selector: "[cdkDragHandle]", inputs: ["cdkDragHandleDisabled"] }, { kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "component", type: SlidePanelComponent, selector: "cnet-slide-panel", inputs: ["activePane"] }, { kind: "component", type: CnetConfirmDialogComponent, selector: "cnet-confirm-dialog" }, { kind: "component", type: DynamicFormQuestionComponent, selector: "cnet-form-question", inputs: ["question", "form"] }, { kind: "component", type: CreateUpdateQuestionComponent, selector: "cnet-create-update-question", inputs: ["isCreate", "question"], outputs: ["submitQuestion", "cancel", "onDirty"] }], animations: [] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ContratanetDynamicFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-cnet-cnet-dynamic-form', animations: [], template: "<form (ngSubmit)=\"onSubmit()\" [formGroup]=\"form\" *ngIf=\"form\">\n  <div cdkDropList class=\"example-list\" (cdkDropListDropped)=\"drop($event)\">\n\n    <div *ngFor=\"let question of questions\" class=\"form-row\" cdkDrag cdkDragLockAxis=\"y\"\n      [cdkDragDisabled]=\"disableDragDrop\">\n\n      <cnet-slide-panel [activePane]=\"questionEdit !== question.key ? 'left' : 'right'\">\n\n        <div leftPane class=\"form-row\" style=\"width: 100%;\">\n          <div *ngIf=\"!disableDragDrop\">\n            <div class=\"dragArea\" cdkDragHandle>\n              <cnet-icon name=\"reorder\" label=\"Exclude\"></cnet-icon>\n            </div>\n          </div>\n\n          <div class=\"style-question\">\n            <cnet-form-question [question]=\"question\" [form]=\"form\"></cnet-form-question>\n          </div>\n          <div class=\"actionButtons\" *ngIf=\"!disableActionButtons\">\n            <button cnet-icon-button cnet-stroked-button aria-label=\"Edit\">\n              <cnet-icon name=\"edit\" label=\"Edit\" (click)=\"editQuestion(question.key)\"></cnet-icon>\n            </button>\n            <button cnet-icon-button cnet-stroked-button aria-label=\"Edit\">\n              <cnet-icon name=\"close\" label=\"Exclude\" (click)=\"removeQuestion(question.key)\"></cnet-icon>\n            </button>\n          </div>\n\n        </div>\n\n        <div rightPane class=\"form-row\" style=\"width: 100%;\">\n          <cnet-create-update-question [question]=\"question\" (submitQuestion)=\"confirmMessageSubmitUpdate($event)\"\n            (cancel)=\"confirmMessageCancelUpdate()\" (onDirty)=\"registerAsDirty($event)\"\n            *ngIf=\"questionEdit === question.key\">\n          </cnet-create-update-question>\n        </div>\n\n      </cnet-slide-panel>\n\n    </div>\n    <div class=\"form-row\" *ngIf=\"!disableDynamicFormSaveBtn\">\n      <button type=\"submit\" [disabled]=\"!form?.valid\">Save</button>\n    </div>\n  </div>\n</form>\n\n\n<div *ngIf=\"payLoad && !disableDynamicFormSaveBtn\" class=\"form-row\">\n  <strong>Saved the following values</strong><br>{{payLoad}}\n</div>\n\n<cnet-confirm-dialog></cnet-confirm-dialog>\n", styles: [".example-list{width:100%;max-width:100%;border:solid 1px #ccc;min-height:60px;display:block;background:#fff;border-radius:4px;overflow:hidden}.form-row{border-bottom:solid 1px #ccc;color:#000000de;display:flex;flex-direction:row;justify-content:space-between;box-sizing:border-box;background:#fff;font-size:14px;align-items:stretch}.form-row:hover .dragArea{color:var(--cnet--50, #fafafa);background-color:var(--cnet-primary-400, #95ca69)}.cdk-drag-preview{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-placeholder{opacity:0}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.form-row:last-child{border:none}.example-list.cdk-drop-list-dragging .form-row:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}cnet-form-question{width:100%}.dragArea{cursor:grab;width:60px;touch-action:none;-webkit-user-drag:none;-webkit-tap-highlight-color:transparent;-webkit-user-select:none;user-select:none;display:flex;height:100%;flex-direction:row;align-content:center;justify-content:center;align-items:center;border-right:solid 1px #ccc}.form-row.cdk-drag-preview .dragArea{pointer-events:auto;cursor:grabbing;color:var(--cnet--50, #fafafa);background-color:var(--cnet-primary-400, #95ca69)}.actionButtons{display:flex;min-width:80px;flex-direction:row;align-content:flex-start;align-items:flex-start;margin:8px}.actionButtons button{border:none}cnet-create-update-question{width:100%;height:100%;display:flex;align-items:stretch}.style-question{padding:20px 40px;margin-right:auto;width:-webkit-fill-available}@media (max-width: 1199.98px){.form-row{flex-direction:column}.dragArea{border-right:0px;padding:12px;width:100%}.actionButtons{width:100%;justify-content:center}.style-question{padding:20px 40px;margin-right:auto;width:-webkit-fill-available}}\n"] }]
        }], ctorParameters: () => [{ type: QuestionControlService$1 }, { type: CnetConfirmDialogService }], propDecorators: { questions: [{
                type: Input
            }], disableDragDrop: [{
                type: Input
            }], disableActionButtons: [{
                type: Input
            }], disableDynamicFormSaveBtn: [{
                type: Input
            }], disableForm: [{
                type: Input
            }], changeForm: [{
                type: Output
            }] } });

class RequiredMarkModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RequiredMarkModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: RequiredMarkModule, declarations: [RequiredMarkDirective], imports: [CommonModule], exports: [RequiredMarkDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RequiredMarkModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: RequiredMarkModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        RequiredMarkDirective
                    ],
                    exports: [
                        RequiredMarkDirective
                    ],
                    imports: [
                        CommonModule
                    ]
                }]
        }] });

/**
 * Component used to create options in the select component
 *
 * @export
 * class CnetSelectOptionComponent
 */
class CnetSelectOptionComponent {
    constructor(elementRef, _focusMonitor, cdr) {
        this.elementRef = elementRef;
        this._focusMonitor = _focusMonitor;
        this.cdr = cdr;
        /** @ignore */ this.keyStream = new Subject();
        /** @ignore */ this._selected = false;
        /** @ignore */ this._hidden = false;
        this.id = model('');
        this._focusMonitor.monitor(this.elementRef, true);
    }
    /**
     * Whether the control is disabled.
     *
     * @readonly
     * type {boolean}
     * @memberof CnetSelectOptionComponent
     */
    get disabled() { return this._disabled; }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * Whether the control is hidden.
     *
     * @readonly
     * type {boolean}
     * @memberof CnetSelectOptionComponent
     */
    get hidden() { return this._hidden; }
    set hidden(value) {
        this._hidden = coerceBooleanProperty(value);
    }
    /**
     * Whether the control is selected.
     *
     * @readonly
     * type {boolean}
     * @memberof CnetSelectOptionComponent
     */
    get selected() { return this._selected; }
    set selected(value) {
        this._selected = coerceBooleanProperty(value);
    }
    /**
     * Text displayed in the option list
     *
     * @readonly
     * type {string}
     * @memberof CnetSelectOptionComponent
     */
    get viewValue() { return this._viewValue; }
    set viewValue(viewValue) {
        this._viewValue = viewValue;
    }
    /**
     * Logical value for this option
     *
     * @readonly
     * type {string}
     * @memberof CnetSelectOptionComponent
     */
    get value() { return this._value; }
    set value(value) {
        if (!this.id()) {
            this.id.set(value);
        }
        this._value = value;
    }
    /** @ignore */
    onKeydown(event) {
        if (event.keyCode === DOWN_ARROW || event.keyCode === UP_ARROW || event.keyCode === ESCAPE
            || event.keyCode === LEFT_ARROW || event.keyCode === RIGHT_ARROW) {
            event.preventDefault();
            event.stopPropagation();
            this.keyStream.next(event.keyCode);
        }
        if (event.keyCode === SPACE || event.keyCode === ENTER) {
            event.preventDefault();
            event.stopPropagation();
            this.activateOption();
        }
    }
    /** @ignore */
    activateOption() {
        this.fatherComponent.onTouched();
        this.activeOptionStream.next(this);
    }
    /** @ignore */
    getHostElement() {
        return this.elementRef.nativeElement;
    }
    /** @ignore */
    ngOnDestroy() {
        this.keyStream.complete();
        this._focusMonitor.stopMonitoring(this.elementRef);
    }
    display() {
        this.hidden = false;
    }
    hide() {
        this.hidden = true;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSelectOptionComponent, deps: [{ token: i0.ElementRef }, { token: i1$2.FocusMonitor }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "17.3.12", type: CnetSelectOptionComponent, selector: "cnet-select-option", inputs: { id: { classPropertyName: "id", publicName: "id", isSignal: true, isRequired: false, transformFunction: null }, disabled: { classPropertyName: "disabled", publicName: "disabled", isSignal: false, isRequired: false, transformFunction: null }, hidden: { classPropertyName: "hidden", publicName: "hidden", isSignal: false, isRequired: false, transformFunction: null }, selected: { classPropertyName: "selected", publicName: "selected", isSignal: false, isRequired: false, transformFunction: null }, viewValue: { classPropertyName: "viewValue", publicName: "viewValue", isSignal: false, isRequired: false, transformFunction: null }, value: { classPropertyName: "value", publicName: "value", isSignal: false, isRequired: false, transformFunction: null }, template: { classPropertyName: "template", publicName: "template", isSignal: false, isRequired: false, transformFunction: null } }, outputs: { id: "idChange" }, host: { attributes: { "tabindex": "0", "role": "option" }, listeners: { "keydown": "onKeydown($event)", "click": "activateOption()" }, properties: { "attr.id": "id()", "class.cnet-select-option-selected": "selected", "attr.aria-selected": "selected", "attr.aria-hidden": "hidden", "class.cnet-select-option-hidden": "hidden", "hidden": "this.hidden" }, classAttribute: "cnet-select-option" }, exportAs: ["cnetSelectOption"], ngImport: i0, template: "<ng-template [ngIf]=\"!template\">{{viewValue}}</ng-template>\n<ng-template *ngTemplateOutlet=\"template; context: {$implicit: viewValue}\"></ng-template>\n\n<ng-content></ng-content>\n\n<div class=\"cnet-select-option-ripple\" cnetRipple [cnetRippleTrigger]=\"getHostElement()\">\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: CnetRippleDirective, selector: "[cnet-ripple], [cnetRipple]", inputs: ["cnetRippleColor", "cnetRippleUnbounded", "cnetRippleCentered", "cnetRippleRadius", "cnetRippleAnimation", "cnetRippleDisabled", "cnetRippleTrigger"], exportAs: ["cnetRipple"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSelectOptionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-select-option', exportAs: 'cnetSelectOption', host: {
                        class: 'cnet-select-option',
                        tabindex: '0',
                        role: 'option',
                        '[attr.id]': 'id()',
                        '[class.cnet-select-option-selected]': 'selected',
                        '[attr.aria-selected]': 'selected',
                        '[attr.aria-hidden]': 'hidden',
                        '[class.cnet-select-option-hidden]': 'hidden',
                    }, encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-template [ngIf]=\"!template\">{{viewValue}}</ng-template>\n<ng-template *ngTemplateOutlet=\"template; context: {$implicit: viewValue}\"></ng-template>\n\n<ng-content></ng-content>\n\n<div class=\"cnet-select-option-ripple\" cnetRipple [cnetRippleTrigger]=\"getHostElement()\">\n" }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$2.FocusMonitor }, { type: i0.ChangeDetectorRef }], propDecorators: { disabled: [{
                type: Input
            }], hidden: [{
                type: HostBinding,
                args: ['hidden']
            }, {
                type: Input
            }], selected: [{
                type: Input
            }], viewValue: [{
                type: Input
            }], value: [{
                type: Input
            }], template: [{
                type: Input
            }], onKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], activateOption: [{
                type: HostListener,
                args: ['click']
            }] } });

const selectAnimation = trigger('selectAnimation', [
    state('default', style({ transform: 'translateY(0)', opacity: 1 })),
    state('hide', style({ opacity: 0 })),
    transition('show => hide', animate('200ms ease-out')),
    transition('void => show', [style({ opacity: 0 }), animate('200ms')]),
]);

/** Select component is used to select values ​​in an overlay panel with a list of options. */
class CnetSelectComponent extends CnetInputDirective {
    /** Placeholder displayed when no value is selected */
    get placeholder() { return this._placeholder; }
    set placeholder(placeholder) {
        this._placeholder = placeholder;
    }
    /**
     * Placeholder displayed on filter when no value is imputed
     */
    get filterPlaceHolder() { return this._filterPlaceHolder; }
    set filterPlaceHolder(filterPlaceHolder) {
        this._filterPlaceHolder = filterPlaceHolder;
    }
    /** Whether the control is focused */
    get focused() { return this._focused; }
    set focused(value) { this._focused = coerceBooleanProperty(value); }
    /** Whether is possible to select multiple options */
    get multiple() { return this._multiple; }
    set multiple(value) { this._multiple = coerceBooleanProperty(value); }
    /** Whether it is possible to filter the options */
    get showFilter() { return this._showFilter; }
    set showFilter(value) { this._showFilter = coerceBooleanProperty(value); }
    /** Whether it is possible to filter the options */
    get showSelectAll() { return this._showSelectAll; }
    set showSelectAll(value) { this._showSelectAll = coerceBooleanProperty(value); }
    get showNotFoud() { return this._showNotFoud; }
    set showNotFoud(value) { this._showNotFoud = coerceBooleanProperty(value); }
    /** Whether tags should be displayed instead of text */
    get showTags() { return this._showTags; }
    set showTags(value) { this._showTags = coerceBooleanProperty(value); }
    get disabled() {
        if (this.ngControl && this.ngControl.disabled !== null) {
            return this.ngControl.disabled;
        }
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
        if (this.focused) {
            this.focused = false;
            this.stateChanges.next();
        }
    }
    constructor(ngControl, overlay, _focusMonitor, elementRef, cdr, normalizePipe, _document) {
        super(ngControl, elementRef);
        this.ngControl = ngControl;
        this.overlay = overlay;
        this._focusMonitor = _focusMonitor;
        this.elementRef = elementRef;
        this.cdr = cdr;
        this.normalizePipe = normalizePipe;
        this._document = _document;
        /** @ignore */ this._placeholder = '';
        /** @ignore */ this._filterPlaceHolder = '';
        /** @ignore */ this.activeOptionStream = new Subject();
        /** @ignore */ this._selected = [];
        /** @ignore */ this._focused = false;
        /** @ignore */ this._multiple = false;
        /** @ignore */ this._filterTerm = '';
        /** @ignore */ this._showFilter = false;
        /** @ignore */ this._showSelectAll = false;
        /** @ignore */ this._showNotFoud = false;
        /** @ignore */ this._showTags = false;
        /** Stream that emits the visibility of the menu. */
        this.visible = false;
        this.selectAllLabel = "Select All";
        this.noResultsFoundLabel = "No results found";
        this.change = new EventEmitter();
        // TODO:  AVALIAR A NECESSISADADE DESSE ATRIBUTO SE NO VIEWVALUE DA OPÇAO EU POSSO FAZER ISSO: [viewValue]="el.code +' - '+ el.name"
        this.searchAtribute = '';
        this.maxHeight = '300px';
        this.showSelectIndicator = true;
        /** @ignore */
        this.onChangeFn = (_) => { };
        /** @ignore */
        this.onTouchedFn = () => { };
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }
    ngOnDestroy() {
        this.hide();
    }
    ngAfterContentInit() {
        this._items.changes.pipe().subscribe(() => {
            this._selected = [];
            this.cdr.markForCheck();
            this._visibleItems = this.filterOptions();
            this.writeValue(this.value);
            this._items.map((item) => {
                if (!item.activeOptionStream) {
                    item.activeOptionStream = this.activeOptionStream;
                    item.fatherComponent = this;
                }
            });
        });
        this.activeOptionStream.subscribe(option => {
            this.setOption(option);
        });
        this._items.map((item) => {
            if (!item.activeOptionStream) {
                item.activeOptionStream = this.activeOptionStream;
                item.fatherComponent = this;
            }
        });
        this._visibleItems = this._items.toArray();
    }
    setOption(option, triggerOnChange = true) {
        if (option) {
            option.selected = !option.selected;
            if (this.multiple) {
                if (!this._selected.includes(option)) {
                    this._selected.push(option);
                }
                else {
                    this.removeOption(option);
                }
            }
            else {
                if (!this._selected.includes(option)) {
                    this.clearSelection();
                    this._selected = [option];
                }
                else {
                    this.removeOption(option);
                }
                this.hide();
            }
            const value = this._selected.map(item => item.value);
            // this.writeValue(this._multiple ? value : value[0]);
            this.value = this._multiple ? value : value[0];
            if (triggerOnChange) {
                this._focusMonitor.focusVia(this.elementRef, 'program');
                this.onChange();
            }
            else {
                this.cdr.markForCheck();
            }
            if (this._overlayRef) {
                this._overlayRef.updatePosition();
            }
        }
    }
    removeOption(option) {
        const index = this._selected.indexOf(option);
        if (index > -1) {
            this._selected.splice(index, 1);
            option.selected = false;
        }
    }
    checkAllItemsSelected() {
        if (this._items && this._items.length) {
            return this._items.filter(item => !item.hidden).length === this._selected?.length;
        }
    }
    toggleAllItems() {
        if (this.showSelectAll && this.multiple) {
            if (!this.checkAllItemsSelected()) {
                this.clearSelection();
            }
            this._selected = [];
            this._items.filter(i => !i.hidden).forEach(item => {
                item.selected = !item.selected;
                if (item.selected) {
                    this._selected.push(item);
                }
            });
            const value = this._selected.map(item => item.value);
            this.value = this._multiple ? value : value[0];
            this.onChange();
            this.cdr.markForCheck();
            setTimeout(() => {
                this._overlayRef.updatePosition();
            }, 80);
        }
    }
    clearSelection() {
        this._selected.forEach(option => {
            option.selected = false;
        });
        this._selected = [];
    }
    /** @ignore */
    writeValue(obj) {
        this.value = obj || typeof obj == "boolean" ? Array.isArray(obj) ? obj.length ? obj : null : obj : null;
        if (this.value || typeof this.value == "boolean") {
            setTimeout(() => {
                if (this._items && this._items.length > 0) {
                    const selectedAux = [...this._selected];
                    selectedAux.forEach(s => {
                        this.removeOption(s);
                    });
                    const items = this._items.filter(item => this.multiple ? JSON.stringify(obj).includes(JSON.stringify(item.value)) : JSON.stringify(obj) === JSON.stringify(item.value));
                    items.forEach(element => {
                        this.setOption(element, false);
                    });
                    this.cdr.markForCheck();
                }
            }, 5);
        }
        else {
            const selectedAux = [...this._selected];
            if (selectedAux && selectedAux.length) {
                selectedAux.forEach(s => {
                    this.removeOption(s);
                });
            }
            this.cdr.markForCheck();
        }
    }
    /** @ignore */
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    /** @ignore */
    registerOnTouched(fn) {
        this.onTouchedFn = fn;
    }
    /** @ignore */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        if (this.disabled) {
            this.elementRef.nativeElement.tabIndex = -1;
        }
        else {
            this.elementRef.nativeElement.tabIndex = 0;
        }
        this.cdr.markForCheck();
    }
    /** @ignore */
    onTouched() {
        this.onTouchedFn();
    }
    /** @ignore */
    onChange() {
        this.change.emit(this.value);
        this.onChangeFn(this.value);
        this.cdr.markForCheck();
    }
    /** @ignore */
    getViewValue() {
        const value = this._selected.map(option => option.viewValue);
        return this._multiple ? value : value[0];
    }
    /** Show the cnet-select panel */
    show() {
        if (!this.visible && !this.disabled) {
            this._overlayRef = this.overlay.create(this.getMenuOverlayConfig(this._selectContent));
            this.animationState = 'show';
            this._overlayRef.attach(this._contentTemplate);
            this.syncWidth();
            this._overlayRef.backdropClick().subscribe(() => this.hide());
            this.visible = true;
            if (this.showFilter) {
                setTimeout(() => {
                    this._focusMonitor.focusVia(this.filterInput, 'program');
                }, 10);
            }
            this._items.map((item, index) => {
                item.activeOptionStream = this.activeOptionStream;
                item.fatherComponent = this;
                this._itemKeySubscription = new Subscription();
                this._itemKeySubscription.add(item.keyStream.subscribe(key => {
                    switch (key) {
                        case RIGHT_ARROW:
                        case DOWN_ARROW:
                            this.focusNext(item);
                            break;
                        case LEFT_ARROW:
                        case UP_ARROW:
                            this.focusPrev(item);
                            break;
                        case ESCAPE:
                            this.hide();
                            break;
                        case 'CLICK':
                            this.hide();
                            break;
                    }
                }));
            });
            this._getOutsideClickStream().pipe(take$1(1)).subscribe(() => {
                this.hide();
            });
            setTimeout(() => {
                if (this._items.first) {
                    if (!this.showFilter) {
                        this._focusMonitor.focusVia(this._items.first.elementRef, 'program');
                    }
                }
            }, 300);
        }
        else {
            this.hide();
        }
    }
    _getOutsideClickStream() {
        return merge(fromEvent(this._document, 'click'), fromEvent(this._document, 'touchend'))
            .pipe(filter(event => {
            const clickTarget = event.target;
            return this.visible && clickTarget !== this.elementRef.nativeElement &&
                (!!this._overlayRef && !this._overlayRef.overlayElement.contains(clickTarget)) &&
                (!!this.elementRef.nativeElement && !this.elementRef.nativeElement.contains(clickTarget));
        }));
    }
    focusNext(option) {
        const nextOption = this._items.find((item, index) => {
            return index > this._items.toArray().indexOf(option) && !item.hidden;
        });
        if (nextOption) {
            this._focusMonitor.focusVia(nextOption.elementRef.nativeElement, 'keyboard');
        }
    }
    focusPrev(option) {
        const itemsReverse = this._items.toArray().reverse();
        const nextOption = itemsReverse.find((item, index) => {
            return index > itemsReverse.indexOf(option) && !item.hidden;
        });
        if (nextOption) {
            this._focusMonitor.focusVia(nextOption.elementRef.nativeElement, 'keyboard');
        }
    }
    /** Hide the cnet-select panel */
    hide() {
        this.visible = false;
        this.animationState = 'hide';
        this._filterTerm = '';
        this.onFilterInput();
        this.cdr.markForCheck();
        this._focusMonitor.stopMonitoring(this.elementRef);
    }
    /** @ignore */
    onKeydown(event) {
        if (event.keyCode === SPACE || event.keyCode === ENTER) {
            event.preventDefault();
            event.stopPropagation();
            this.show();
        }
    }
    /** @ignore */
    _onAnimationDone(event) {
        if (event.fromState === 'show' && event.toState === 'hide') {
            this._overlayRef.detach();
        }
    }
    /** @ignore */
    getMenuOverlayConfig(element) {
        const positionStrategy = this.overlay.position()
            .flexibleConnectedTo(element)
            .withPush(false)
            .withPositions([{
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top',
                offsetY: 4,
            }, {
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'bottom',
                offsetY: -4,
            }]);
        const scrollStrategy = this.overlay.scrollStrategies.reposition();
        // const scrollStrategy = this.overlay.scrollStrategies.block();
        const overlayConfig = new OverlayConfig({
            positionStrategy,
            scrollStrategy,
            hasBackdrop: false,
            minWidth: '300px',
        });
        if (this.maxHeight) {
            overlayConfig.maxHeight = this.maxHeight;
        }
        return overlayConfig;
    }
    /** @ignore */
    onWinResize() {
        this.syncWidth();
    }
    /** Sync the width of the panel in relation to the origin */
    syncWidth() {
        if (!this._overlayRef) {
            return;
        }
        const refRect = this._selectContent.nativeElement.getBoundingClientRect();
        this._overlayRef.updateSize({ width: refRect.width });
    }
    /** @ignore */
    changeFocus(focused) {
        this.focused = focused;
        this.stateChanges.next();
    }
    onFilterInput() {
        this._visibleItems = this.filterOptions();
    }
    filterOptions() {
        if (this.searchAtribute) {
            const filterTermNormalized = this._filterTerm ? this.normalizePipe.transform(this._filterTerm.toString().toLowerCase()) : '';
            return this._items.filter(option => {
                if (option.viewValue && option.value) {
                    if (this.normalizePipe.transform(option.viewValue[this.searchAtribute]?.toString().toLowerCase()).includes(filterTermNormalized)
                        || this.normalizePipe.transform(option.value[this.searchAtribute]?.toString().toLowerCase()).includes(filterTermNormalized)) {
                        option.display();
                        return true;
                    }
                    else {
                        option.hide();
                        return false;
                    }
                }
            });
        }
        return this._items.filter(option => {
            if (option.viewValue && option.value) {
                const filterTermNormalized = this._filterTerm ? this.normalizePipe.transform(this._filterTerm.toString().toLowerCase()) : '';
                if (this.normalizePipe.transform(option.viewValue?.toString().toLowerCase()).includes(filterTermNormalized)
                    || this.normalizePipe.transform(option.value?.toString().toLowerCase()).includes(filterTermNormalized)) {
                    option.display();
                    return true;
                }
                else {
                    option.hide();
                    return false;
                }
            }
        });
    }
    onTagClick(event, option) {
        event.stopPropagation();
        if (this.disabled) {
            return;
        }
        this.onTouched();
        this.activeOptionStream.next(option);
    }
    checkIfAllHidden() {
        if (this._items.length) {
            return this._items.toArray().every(item => item.hidden);
        }
        return true;
    }
    isValueNotEmpty() {
        return this.value ? true : this.value === false;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSelectComponent, deps: [{ token: i1$4.NgControl, optional: true, self: true }, { token: i1$5.Overlay }, { token: i1$2.FocusMonitor }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: NormalizeStringPipe }, { token: DOCUMENT, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetSelectComponent, selector: "cnet-select", inputs: { placeholder: "placeholder", filterPlaceHolder: "filterPlaceHolder", focused: "focused", multiple: "multiple", showFilter: ["show-filter", "showFilter"], showSelectAll: ["show-select-all", "showSelectAll"], showNotFoud: ["show-not-found", "showNotFoud"], selectAllLabel: "selectAllLabel", noResultsFoundLabel: "noResultsFoundLabel", showTags: ["show-tags", "showTags"], viewValueTpl: "viewValueTpl", searchAtribute: "searchAtribute", maxHeight: "maxHeight", disabled: "disabled", showSelectIndicator: "showSelectIndicator" }, outputs: { change: "change" }, host: { attributes: { "role": "listbox", "tabindex": "0" }, listeners: { "blur": "changeFocus(false)", "focus": "changeFocus(true)", "keydown": "onKeydown($event)", "window:resize": "onWinResize()" }, properties: { "class.cnet-select-multiple": "multiple" }, classAttribute: "cnet-select" }, providers: [
            {
                provide: CnetFormFieldControl,
                useExisting: CnetSelectComponent
            },
        ], queries: [{ propertyName: "_items", predicate: CnetSelectOptionComponent, descendants: true }], viewQueries: [{ propertyName: "_contentTemplate", first: true, predicate: CdkPortal, descendants: true }, { propertyName: "filterInput", first: true, predicate: ["filterInput"], descendants: true }, { propertyName: "_selectContent", first: true, predicate: ["selectContent"], descendants: true }], exportAs: ["cnetSelect"], usesInheritance: true, ngImport: i0, template: "<div class=\"cnet-select-content\" #selectContent (click)=\"show()\" [class.cnet-select-disabled]=\"disabled\">\n  <ng-container *ngIf=\"!isValueNotEmpty() || (multiple && !value.length) else elseTemplate\">\n    <div class=\"placeholder\">\n      {{placeholder}}\n    </div>\n  </ng-container>\n  <ng-template #elseTemplate>\n    <div class=\"cnet-select-value\">\n      <ng-container *ngIf=\"isValueNotEmpty() && !(multiple && showTags)\">\n\n        <ng-template [ngIf]=\"!viewValueTpl\">{{getViewValue()}}</ng-template>\n        <ng-template *ngTemplateOutlet=\"viewValueTpl; context: {$implicit: getViewValue()}\"></ng-template>\n\n      </ng-container>\n      <div class=\"cnet-select-tags\" *ngIf=\"value && showTags && multiple\">\n        <div class=\"cnet-select-tag\" *ngFor=\"let option of _selected\">\n\n          <ng-template [ngIf]=\"!viewValueTpl\">{{option.viewValue}}</ng-template>\n          <ng-template *ngTemplateOutlet=\"viewValueTpl; context: {$implicit: option.viewValue}\"></ng-template>\n\n          <div class=\"close\" (click)=\"onTagClick($event, option)\" *ngIf=\"!disabled\">\n            <cnet-icon name=\"close\"></cnet-icon>\n          </div>\n        </div>\n      </div>\n    </div>\n  </ng-template>\n  <cnet-icon class=\"cnet-select-indicator\" name=\"angle-down\" size=\"sm\" aria-hidden=\"true\"\n    *ngIf=\"!disabled && showSelectIndicator\"></cnet-icon>\n</div>\n\n<ng-template cdk-portal>\n  <div class=\"cnet-select-overlay-panel\" [@selectAnimation]=\"animationState\"\n    (@selectAnimation.done)=\"_onAnimationDone($event)\" #content>\n\n    <div cdkTrapFocus>\n      <div class=\"cnet-select-input-wrap\" *ngIf=\"showFilter\">\n        <input type=\"text\" #filterInput\n          [placeholder]=\"filterPlaceHolder ? filterPlaceHolder: 'Pesquisar' | translate\"\n          class=\"cnet-select-input\" (input)=\"onFilterInput()\" [(ngModel)]=\"_filterTerm\">\n      </div>\n\n\n      <div class=\"select-all-option\" *ngIf=\"showSelectAll && multiple && !checkIfAllHidden()\">\n\n        <cnet-checkbox [checked]=\"checkAllItemsSelected()\" [enableRiple]=\"false\" (change)=\"toggleAllItems()\"\n          class=\"select-all-checkbox\">\n          {{selectAllLabel}}\n        </cnet-checkbox>\n\n      </div>\n\n\n      <div class=\"no-selectable-option\" *ngIf=\"checkIfAllHidden() && showNotFoud\">\n        {{noResultsFoundLabel}}\n      </div>\n\n      <ng-content select=\"cnet-no-selectable-option, [cnet-no-selectable-option], [cnetNoSelectableOption]\">\n      </ng-content>\n\n      <ng-content></ng-content>\n\n    </div>\n  </div>\n</ng-template>\n", styles: [".cnet-select{display:flex;align-items:center;outline:none;width:100%}.cnet-select-content{display:flex;min-height:2.25rem;width:100%;justify-content:space-between;align-items:center;flex:auto;font-size:1rem;-webkit-user-select:none;user-select:none;cursor:pointer}.cnet-select-disabled{cursor:auto}.cnet-select-value{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cnet-select-tags{display:flex;flex-wrap:wrap;max-height:112px;overflow:auto}.cnet-select-tags .cnet-select-tag{display:flex;background-color:var(--cnet-primary-500, #82c14f);color:var(--cnet-primary-contrast-500, white);border-radius:.25rem;padding:0 .25rem;margin:.25rem .5rem .25rem 0}.cnet-select-tags .cnet-select-tag cnet-icon{margin-left:6px;margin-right:4px}.cnet-select-tags .cnet-select-tag cnet-icon i{font-size:.875rem}.cnet-select-input-wrap{width:100%;padding:.5rem}.cnet-select-input-wrap .cnet-select-input{width:100%;border:1px solid var(--cnet--300, #e0e0e0);outline:none;height:2rem;padding:0 .5rem}.cnet-select-overlay-panel{width:calc(100% + 2px);margin-top:1px;margin-left:-1px;transform-origin:left top;background:#fff;border-bottom-left-radius:.25rem;border-bottom-right-radius:.25rem;box-shadow:0 1px 4px -1px #0000001a,0 4px 5px #0000001a;overflow-y:auto}.cnet-select-option{position:relative;display:block;width:100%;margin:0;padding:.5rem .75rem;outline:none;cursor:pointer;-webkit-user-select:none;user-select:none}.cnet-select-option:hover:not(:disabled),.cnet-select-option:focus:not(:disabled):not(.cdk-program-focused){cursor:pointer;background-color:#0000000a}.cnet-select-option:disabled{color:#0000006b}.cnet-select-option.cnet-select-option-hidden{display:none}.cnet-select-option-selected{background-color:var(--cnet-primary-500, #82c14f);color:var(--cnet-primary-contrast-500, white)}.cnet-select-option-selected:hover:not(:disabled),.cnet-select-option-selected:focus:not(:disabled):not(.cdk-program-focused){background-color:var(--cnet-primary-600, #7abb48);color:var(--cnet-primary-contrast-600, white)}.cnet-select-option-ripple{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;overflow:hidden}.placeholder{opacity:.7}.select-all-option{position:relative;display:block;width:100%;margin:0;padding:.5rem .75rem;outline:none;cursor:pointer;-webkit-user-select:none;user-select:none}.no-selectable-option{position:relative;display:block;width:100%;margin:0;padding:.5rem .75rem;outline:none;-webkit-user-select:none;user-select:none}.select-all-checkbox .cnet-checkbox-label{margin:0;line-height:1.6}.select-all-checkbox .cnet-checkbox-label .cnet-checkbox-check{height:fit-content}.cdk-overlay-backdrop-select{background:transparent;position:absolute;inset:0}.cdk-overlay-backdrop-select.cdk-overlay-backdrop-showing{opacity:.48}.cnet-select-option-category{margin:.5rem 0rem .5rem .75rem;font-weight:700;border-bottom:1px solid #e0e0e0}\n"], dependencies: [{ kind: "directive", type: i1$2.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "directive", type: i2.TemplatePortalDirective, selector: "[cdk-portal], [portal]", exportAs: ["cdkPortal"] }, { kind: "directive", type: i1$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: CnetCheckboxComponent, selector: "cnet-checkbox", inputs: ["id", "name", "checked", "value", "disabled", "color", "enableRiple"], outputs: ["change", "blur", "focus"], exportAs: ["cnetCheckbox"] }, { kind: "pipe", type: i1$3.TranslatePipe, name: "translate" }], animations: [selectAnimation], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-select', exportAs: 'cnetSelect', host: {
                        class: 'cnet-select',
                        role: 'listbox',
                        tabindex: '0',
                        '(blur)': 'changeFocus(false)',
                        '(focus)': 'changeFocus(true)',
                        '[class.cnet-select-multiple]': 'multiple'
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, animations: [selectAnimation], providers: [
                        {
                            provide: CnetFormFieldControl,
                            useExisting: CnetSelectComponent
                        },
                    ], template: "<div class=\"cnet-select-content\" #selectContent (click)=\"show()\" [class.cnet-select-disabled]=\"disabled\">\n  <ng-container *ngIf=\"!isValueNotEmpty() || (multiple && !value.length) else elseTemplate\">\n    <div class=\"placeholder\">\n      {{placeholder}}\n    </div>\n  </ng-container>\n  <ng-template #elseTemplate>\n    <div class=\"cnet-select-value\">\n      <ng-container *ngIf=\"isValueNotEmpty() && !(multiple && showTags)\">\n\n        <ng-template [ngIf]=\"!viewValueTpl\">{{getViewValue()}}</ng-template>\n        <ng-template *ngTemplateOutlet=\"viewValueTpl; context: {$implicit: getViewValue()}\"></ng-template>\n\n      </ng-container>\n      <div class=\"cnet-select-tags\" *ngIf=\"value && showTags && multiple\">\n        <div class=\"cnet-select-tag\" *ngFor=\"let option of _selected\">\n\n          <ng-template [ngIf]=\"!viewValueTpl\">{{option.viewValue}}</ng-template>\n          <ng-template *ngTemplateOutlet=\"viewValueTpl; context: {$implicit: option.viewValue}\"></ng-template>\n\n          <div class=\"close\" (click)=\"onTagClick($event, option)\" *ngIf=\"!disabled\">\n            <cnet-icon name=\"close\"></cnet-icon>\n          </div>\n        </div>\n      </div>\n    </div>\n  </ng-template>\n  <cnet-icon class=\"cnet-select-indicator\" name=\"angle-down\" size=\"sm\" aria-hidden=\"true\"\n    *ngIf=\"!disabled && showSelectIndicator\"></cnet-icon>\n</div>\n\n<ng-template cdk-portal>\n  <div class=\"cnet-select-overlay-panel\" [@selectAnimation]=\"animationState\"\n    (@selectAnimation.done)=\"_onAnimationDone($event)\" #content>\n\n    <div cdkTrapFocus>\n      <div class=\"cnet-select-input-wrap\" *ngIf=\"showFilter\">\n        <input type=\"text\" #filterInput\n          [placeholder]=\"filterPlaceHolder ? filterPlaceHolder: 'Pesquisar' | translate\"\n          class=\"cnet-select-input\" (input)=\"onFilterInput()\" [(ngModel)]=\"_filterTerm\">\n      </div>\n\n\n      <div class=\"select-all-option\" *ngIf=\"showSelectAll && multiple && !checkIfAllHidden()\">\n\n        <cnet-checkbox [checked]=\"checkAllItemsSelected()\" [enableRiple]=\"false\" (change)=\"toggleAllItems()\"\n          class=\"select-all-checkbox\">\n          {{selectAllLabel}}\n        </cnet-checkbox>\n\n      </div>\n\n\n      <div class=\"no-selectable-option\" *ngIf=\"checkIfAllHidden() && showNotFoud\">\n        {{noResultsFoundLabel}}\n      </div>\n\n      <ng-content select=\"cnet-no-selectable-option, [cnet-no-selectable-option], [cnetNoSelectableOption]\">\n      </ng-content>\n\n      <ng-content></ng-content>\n\n    </div>\n  </div>\n</ng-template>\n", styles: [".cnet-select{display:flex;align-items:center;outline:none;width:100%}.cnet-select-content{display:flex;min-height:2.25rem;width:100%;justify-content:space-between;align-items:center;flex:auto;font-size:1rem;-webkit-user-select:none;user-select:none;cursor:pointer}.cnet-select-disabled{cursor:auto}.cnet-select-value{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.cnet-select-tags{display:flex;flex-wrap:wrap;max-height:112px;overflow:auto}.cnet-select-tags .cnet-select-tag{display:flex;background-color:var(--cnet-primary-500, #82c14f);color:var(--cnet-primary-contrast-500, white);border-radius:.25rem;padding:0 .25rem;margin:.25rem .5rem .25rem 0}.cnet-select-tags .cnet-select-tag cnet-icon{margin-left:6px;margin-right:4px}.cnet-select-tags .cnet-select-tag cnet-icon i{font-size:.875rem}.cnet-select-input-wrap{width:100%;padding:.5rem}.cnet-select-input-wrap .cnet-select-input{width:100%;border:1px solid var(--cnet--300, #e0e0e0);outline:none;height:2rem;padding:0 .5rem}.cnet-select-overlay-panel{width:calc(100% + 2px);margin-top:1px;margin-left:-1px;transform-origin:left top;background:#fff;border-bottom-left-radius:.25rem;border-bottom-right-radius:.25rem;box-shadow:0 1px 4px -1px #0000001a,0 4px 5px #0000001a;overflow-y:auto}.cnet-select-option{position:relative;display:block;width:100%;margin:0;padding:.5rem .75rem;outline:none;cursor:pointer;-webkit-user-select:none;user-select:none}.cnet-select-option:hover:not(:disabled),.cnet-select-option:focus:not(:disabled):not(.cdk-program-focused){cursor:pointer;background-color:#0000000a}.cnet-select-option:disabled{color:#0000006b}.cnet-select-option.cnet-select-option-hidden{display:none}.cnet-select-option-selected{background-color:var(--cnet-primary-500, #82c14f);color:var(--cnet-primary-contrast-500, white)}.cnet-select-option-selected:hover:not(:disabled),.cnet-select-option-selected:focus:not(:disabled):not(.cdk-program-focused){background-color:var(--cnet-primary-600, #7abb48);color:var(--cnet-primary-contrast-600, white)}.cnet-select-option-ripple{position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none;overflow:hidden}.placeholder{opacity:.7}.select-all-option{position:relative;display:block;width:100%;margin:0;padding:.5rem .75rem;outline:none;cursor:pointer;-webkit-user-select:none;user-select:none}.no-selectable-option{position:relative;display:block;width:100%;margin:0;padding:.5rem .75rem;outline:none;-webkit-user-select:none;user-select:none}.select-all-checkbox .cnet-checkbox-label{margin:0;line-height:1.6}.select-all-checkbox .cnet-checkbox-label .cnet-checkbox-check{height:fit-content}.cdk-overlay-backdrop-select{background:transparent;position:absolute;inset:0}.cdk-overlay-backdrop-select.cdk-overlay-backdrop-showing{opacity:.48}.cnet-select-option-category{margin:.5rem 0rem .5rem .75rem;font-weight:700;border-bottom:1px solid #e0e0e0}\n"] }]
        }], ctorParameters: () => [{ type: i1$4.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i1$5.Overlay }, { type: i1$2.FocusMonitor }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: NormalizeStringPipe }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [DOCUMENT]
                }] }], propDecorators: { _contentTemplate: [{
                type: ViewChild,
                args: [CdkPortal]
            }], filterInput: [{
                type: ViewChild,
                args: ['filterInput']
            }], _items: [{
                type: ContentChildren,
                args: [CnetSelectOptionComponent, { descendants: true }]
            }], _selectContent: [{
                type: ViewChild,
                args: ['selectContent']
            }], placeholder: [{
                type: Input
            }], filterPlaceHolder: [{
                type: Input
            }], focused: [{
                type: Input
            }], multiple: [{
                type: Input
            }], showFilter: [{
                type: Input,
                args: ['show-filter']
            }], showSelectAll: [{
                type: Input,
                args: ['show-select-all']
            }], showNotFoud: [{
                type: Input,
                args: ['show-not-found']
            }], selectAllLabel: [{
                type: Input
            }], noResultsFoundLabel: [{
                type: Input
            }], showTags: [{
                type: Input,
                args: ['show-tags']
            }], change: [{
                type: Output
            }], viewValueTpl: [{
                type: Input
            }], searchAtribute: [{
                type: Input
            }], maxHeight: [{
                type: Input
            }], disabled: [{
                type: Input
            }], showSelectIndicator: [{
                type: Input
            }], onKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], onWinResize: [{
                type: HostListener,
                args: ['window:resize']
            }] } });

class CnetNoSelectableOptionComponent {
    constructor() { }
    ngOnInit() {
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNoSelectableOptionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetNoSelectableOptionComponent, selector: "cnet-no-selectable-option, [cnet-no-selectable-option], [cnetNoSelectableOption]", ngImport: i0, template: `<ng-content></ng-content>`, isInline: true, styles: [":host{position:relative;display:block;width:100%;margin:0;padding:.5rem .75rem;outline:none;-webkit-user-select:none;user-select:none}\n"] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNoSelectableOptionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-no-selectable-option, [cnet-no-selectable-option], [cnetNoSelectableOption]', template: `<ng-content></ng-content>`, styles: [":host{position:relative;display:block;width:100%;margin:0;padding:.5rem .75rem;outline:none;-webkit-user-select:none;user-select:none}\n"] }]
        }], ctorParameters: () => [] });

class SelectOptionCategoryDirective {
    //must aply cnet-select-option-category css
    // on select if has this category put
    // .cnet-select-option{
    //   padding-left: 2rem;
    // }
    constructor() { }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectOptionCategoryDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: SelectOptionCategoryDirective, selector: "cnet-select-option-category, cnetSelectOptionCategory, [cnetSelectOptionCategory]", host: { attributes: { "role": "cnet-select-option-category" }, classAttribute: "cnet-select-option-category" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SelectOptionCategoryDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-select-option-category, cnetSelectOptionCategory, [cnetSelectOptionCategory]',
                    host: {
                        class: 'cnet-select-option-category',
                        role: 'cnet-select-option-category',
                    },
                }]
        }], ctorParameters: () => [] });

class CnetSelectModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetSelectModule, declarations: [CnetSelectComponent, CnetSelectOptionComponent, CnetNoSelectableOptionComponent, SelectOptionCategoryDirective], imports: [A11yModule,
            CommonModule,
            CnetRippleModule,
            CnetInputModule,
            CnetIconModule,
            OverlayModule,
            PortalModule,
            CnetIconModule,
            FormsModule,
            TranslateModule,
            NormalizeStringModule,
            CnetDividerModule,
            CnetCheckboxModule], exports: [CnetSelectComponent, CnetSelectOptionComponent, CnetNoSelectableOptionComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSelectModule, imports: [A11yModule,
            CommonModule,
            CnetRippleModule,
            CnetInputModule,
            CnetIconModule,
            OverlayModule,
            PortalModule,
            CnetIconModule,
            FormsModule,
            TranslateModule,
            NormalizeStringModule,
            CnetDividerModule,
            CnetCheckboxModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetSelectComponent, CnetSelectOptionComponent, CnetNoSelectableOptionComponent, SelectOptionCategoryDirective],
                    imports: [
                        A11yModule,
                        CommonModule,
                        CnetRippleModule,
                        CnetInputModule,
                        CnetIconModule,
                        OverlayModule,
                        PortalModule,
                        CnetIconModule,
                        FormsModule,
                        TranslateModule,
                        NormalizeStringModule,
                        CnetDividerModule,
                        CnetCheckboxModule
                    ],
                    exports: [CnetSelectComponent, CnetSelectOptionComponent, CnetNoSelectableOptionComponent]
                }]
        }] });

class ContratanetDynamicFormModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ContratanetDynamicFormModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ContratanetDynamicFormModule, declarations: [ContratanetDynamicFormComponent, DynamicFormQuestionComponent, CreateUpdateQuestionComponent], imports: [CommonModule,
            ReactiveFormsModule,
            CnetRadioModule,
            DragDropModule,
            CnetButtonModule,
            CnetIconModule,
            SlidePanelModule,
            CnetFormFieldModule,
            CnetCheckboxModule,
            CnetModalModule,
            CnetCardModule,
            CnetConfirmDialogModule,
            CnetInputModule,
            AscIIToCharModule,
            CnetSliderOldModule,
            CnetDynamicListModule,
            RequiredMarkModule,
            CnetSelectModule,
            TranslateModule], exports: [ContratanetDynamicFormComponent, CreateUpdateQuestionComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ContratanetDynamicFormModule, providers: [QuestionControlService$1], imports: [CommonModule,
            ReactiveFormsModule,
            CnetRadioModule,
            DragDropModule,
            CnetButtonModule,
            CnetIconModule,
            SlidePanelModule,
            CnetFormFieldModule,
            CnetCheckboxModule,
            CnetModalModule,
            CnetCardModule,
            CnetConfirmDialogModule,
            CnetInputModule,
            AscIIToCharModule,
            CnetSliderOldModule,
            CnetDynamicListModule,
            RequiredMarkModule,
            CnetSelectModule,
            TranslateModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ContratanetDynamicFormModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ContratanetDynamicFormComponent, DynamicFormQuestionComponent, CreateUpdateQuestionComponent],
                    exports: [ContratanetDynamicFormComponent, CreateUpdateQuestionComponent],
                    providers: [QuestionControlService$1],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        CnetRadioModule,
                        DragDropModule,
                        CnetButtonModule,
                        CnetIconModule,
                        SlidePanelModule,
                        CnetFormFieldModule,
                        CnetCheckboxModule,
                        CnetModalModule,
                        CnetCardModule,
                        CnetConfirmDialogModule,
                        CnetInputModule,
                        AscIIToCharModule,
                        CnetSliderOldModule,
                        CnetDynamicListModule,
                        RequiredMarkModule,
                        CnetSelectModule,
                        TranslateModule
                    ]
                }]
        }] });

class CurrencyModel {
    constructor(code, name, symbol) {
        this.code = '';
        this.name = '';
        this.symbol = '';
        code ? this.code = code : this.code = '';
        name ? this.name = name : this.name = '';
        symbol ? this.symbol = symbol : this.symbol = '';
    }
}

class CurrencyService {
    constructor() {
        this.translateService = inject(TranslateService);
    }
    getAvailableCurrencies() {
        const locations = this.translateService.getLangs();
        if (locations?.length) {
            const currencies = [...new Set(locations.map(location => { if (location) {
                    return JSON.stringify(new CurrencyModel(getLocaleCurrencyCode(location), getLocaleCurrencyName(location), getLocaleCurrencySymbol(location)));
                } }))];
            return currencies.map(currency => JSON.parse(currency));
        }
        return [];
    }
    getDefaultCurrencyCodeByLocale(localtion) {
        if (localtion) {
            return getLocaleCurrencyCode(localtion);
        }
    }
    getDefaultCurrencyCodeBySelectedLanguage() {
        const location = this.translateService?.currentLang;
        if (location) {
            return getLocaleCurrencyCode(location);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CurrencyService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CurrencyService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CurrencyService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class CurrencyDirective {
    constructor(control, el, renderer) {
        this.control = control;
        this.el = el;
        this.renderer = renderer;
        this.onChangeFn = (_) => { };
        this.translateService = inject(TranslateService);
        this.control && (this.control.valueAccessor = this);
        this.el.nativeElement.maxLength = 16;
        this.el.nativeElement.style.textAlign = 'right';
    }
    writeValue(value) {
        this._trueValue = value;
        this.addMask(value);
    }
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.renderer.setProperty(this.el.nativeElement, 'disabled', isDisabled);
    }
    addMask(value) {
        if (this.translateService?.currentLang) {
            if (value) {
                this._formattedValue = formatCurrency(value, this.translateService.currentLang, '');
            }
            else {
                this._trueValue = 0;
                this._formattedValue = formatCurrency(0, this.translateService.currentLang, '');
            }
        }
        this.el.nativeElement.value = this._formattedValue;
    }
    onChange() {
        this.addMask(this._trueValue);
        this.onChangeFn(this._trueValue ? this._trueValue : 0);
    }
    onBlur(input) {
        setTimeout(() => {
            if (input.value) {
                input.selectionEnd = input.selectionStart = input.value.length;
            }
            else {
                input.selectionEnd = input.selectionStart = 5;
            }
        });
    }
    onClick(input) {
        setTimeout(() => {
            if (input.value) {
                input.selectionEnd = input.selectionStart = input.value.length;
            }
            else {
                input.selectionEnd = input.selectionStart = 5;
            }
        });
    }
    onInput(value) {
        const auxValue = value.replace(/\D/g, '');
        const auxValueAsNumber = Number.parseInt(auxValue);
        const trueValueAsNumber = auxValueAsNumber / 100;
        this._trueValue = trueValueAsNumber ? trueValueAsNumber : 0;
        this.onChange();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CurrencyDirective, deps: [{ token: i1$4.NgControl, optional: true, self: true }, { token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CurrencyDirective, selector: "[cnetCurrency]", host: { listeners: { "blur": "onBlur($event.target)", "click": "onClick($event.target)", "input": "onInput($event.target.value)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CurrencyDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetCurrency]',
                }]
        }], ctorParameters: () => [{ type: i1$4.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }, { type: i0.ElementRef }, { type: i0.Renderer2 }], propDecorators: { onBlur: [{
                type: HostListener,
                args: ['blur', ['$event.target']]
            }], onClick: [{
                type: HostListener,
                args: ['click', ['$event.target']]
            }], onInput: [{
                type: HostListener,
                args: ['input', ['$event.target.value']]
            }] } });

class CurrencyComponent {
    constructor() {
        this.currencyService = inject(CurrencyService);
        this.currencyOptions = this.currencyService.getAvailableCurrencies();
        this.currencyOptionsDefault = this.currencyService.getDefaultCurrencyCodeBySelectedLanguage();
        this.currencyControl = new FormControl(this.currencyOptionsDefault, []);
        this.currencyControlId = `cnet-currency-${uuid.v4()}`;
        this.currencyAmountControl = new FormControl('', []);
        this.currencyAmountControlId = `cnet-currency-amount-${uuid.v4()}`;
        this.filterCurrencySelectPlaceHolder = '';
        this.inputLabel = '';
    }
    hasControlWithErrorState() {
        return (this.currencyControl.invalid && this.currencyControl.dirty) || (this.currencyAmountControl.invalid && this.currencyAmountControl.dirty);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CurrencyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CurrencyComponent, selector: "cnet-currency", inputs: { currencyOptions: "currencyOptions", currencyOptionsDefault: "currencyOptionsDefault", currencyControl: "currencyControl", currencyControlId: "currencyControlId", currencyAmountControl: "currencyAmountControl", currencyAmountControlId: "currencyAmountControlId", filterCurrencySelectPlaceHolder: "filterCurrencySelectPlaceHolder", inputLabel: "inputLabel" }, ngImport: i0, template: "<label class=\"cnet-field-label\" >\n  <ng-content select=\"cnet-field-label, [cnetFieldLabel], [cnet-field-label]\" ></ng-content>\n</label>\n<div class=\"controls\">\n\n\n  <cnet-form-field [showLabel]=\"false\" class=\"currency-input\">\n\n\n    <cnet-select cnet-input [id]=\"currencyControlId\" [formControl]=\"currencyControl\" [viewValueTpl]=\"labelTpl\"\n      show-filter [searchAtribute]=\"'Name'\" [filterPlaceHolder]=\"filterCurrencySelectPlaceHolder\">\n      <ng-template #labelTpl let-label>\n        <div>\n          {{label?.symbol}}\n        </div>\n      </ng-template>\n\n      <cnet-select-option *ngFor=\"let option of currencyOptions\" [value]=\"option.code\" [viewValue]=\"option\"\n        [template]=\"optionTpl\">\n        <ng-template #optionTpl let-option>\n          <div class=\"element-template\">\n            {{option.name}} - {{option.symbol}}\n          </div>\n        </ng-template>\n      </cnet-select-option>\n    </cnet-select>\n\n    <cnet-field-error>\n\n      <ng-content></ng-content>\n\n    </cnet-field-error>\n  </cnet-form-field>\n\n\n  <cnet-form-field style=\"height: fit-content;\" class=\"currency-amount-input\" [showLabel]=\"false\">\n\n    <input cnet-input cnetCurrency [id]=\"currencyAmountControlId\" [name]=\"currencyAmountControlId\"\n      [formControl]=\"currencyAmountControl\" class=\"ml-2\" />\n\n    <cnet-field-error>\n\n      <ng-content></ng-content>\n\n    </cnet-field-error>\n  </cnet-form-field>\n\n</div>\n\n<div class=\"cnet-field-error-div\" *ngIf=\"hasControlWithErrorState()\">\n  <ng-content select=\"cnet-field-error, [cnetFieldError], [cnet-field-error]\"></ng-content>\n</div>\n", styles: [":host::ng-deep .currency-input{width:150px}:host::ng-deep .currency-input .cnet-form-field-wrap{border-radius:.25rem 0 0 .25rem;border-right:none}:host::ng-deep .currency-amount-input .cnet-form-field-wrap{border-radius:0 .25rem .25rem 0}.controls{display:flex}.element-template{text-transform:capitalize}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "component", type: CnetSelectComponent, selector: "cnet-select", inputs: ["placeholder", "filterPlaceHolder", "focused", "multiple", "show-filter", "show-select-all", "show-not-found", "selectAllLabel", "noResultsFoundLabel", "show-tags", "viewValueTpl", "searchAtribute", "maxHeight", "disabled", "showSelectIndicator"], outputs: ["change"], exportAs: ["cnetSelect"] }, { kind: "component", type: CnetSelectOptionComponent, selector: "cnet-select-option", inputs: ["id", "disabled", "hidden", "selected", "viewValue", "value", "template"], outputs: ["idChange"], exportAs: ["cnetSelectOption"] }, { kind: "component", type: CnetFormFieldComponent, selector: "cnet-form-field", inputs: ["hasMoreThanOneControl", "showLabel"], exportAs: ["cnetButton"] }, { kind: "directive", type: CnetFieldErrorDirective, selector: "cnet-field-error, [cnetFieldError], [cnet-field-error]", inputs: ["id"] }, { kind: "directive", type: CnetInputDirective, selector: "cnet-input, [CnetInput], [cnet-input]", inputs: ["id", "required", "disabled", "value", "focused", "errorState"] }, { kind: "directive", type: CurrencyDirective, selector: "[cnetCurrency]" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CurrencyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-currency', template: "<label class=\"cnet-field-label\" >\n  <ng-content select=\"cnet-field-label, [cnetFieldLabel], [cnet-field-label]\" ></ng-content>\n</label>\n<div class=\"controls\">\n\n\n  <cnet-form-field [showLabel]=\"false\" class=\"currency-input\">\n\n\n    <cnet-select cnet-input [id]=\"currencyControlId\" [formControl]=\"currencyControl\" [viewValueTpl]=\"labelTpl\"\n      show-filter [searchAtribute]=\"'Name'\" [filterPlaceHolder]=\"filterCurrencySelectPlaceHolder\">\n      <ng-template #labelTpl let-label>\n        <div>\n          {{label?.symbol}}\n        </div>\n      </ng-template>\n\n      <cnet-select-option *ngFor=\"let option of currencyOptions\" [value]=\"option.code\" [viewValue]=\"option\"\n        [template]=\"optionTpl\">\n        <ng-template #optionTpl let-option>\n          <div class=\"element-template\">\n            {{option.name}} - {{option.symbol}}\n          </div>\n        </ng-template>\n      </cnet-select-option>\n    </cnet-select>\n\n    <cnet-field-error>\n\n      <ng-content></ng-content>\n\n    </cnet-field-error>\n  </cnet-form-field>\n\n\n  <cnet-form-field style=\"height: fit-content;\" class=\"currency-amount-input\" [showLabel]=\"false\">\n\n    <input cnet-input cnetCurrency [id]=\"currencyAmountControlId\" [name]=\"currencyAmountControlId\"\n      [formControl]=\"currencyAmountControl\" class=\"ml-2\" />\n\n    <cnet-field-error>\n\n      <ng-content></ng-content>\n\n    </cnet-field-error>\n  </cnet-form-field>\n\n</div>\n\n<div class=\"cnet-field-error-div\" *ngIf=\"hasControlWithErrorState()\">\n  <ng-content select=\"cnet-field-error, [cnetFieldError], [cnet-field-error]\"></ng-content>\n</div>\n", styles: [":host::ng-deep .currency-input{width:150px}:host::ng-deep .currency-input .cnet-form-field-wrap{border-radius:.25rem 0 0 .25rem;border-right:none}:host::ng-deep .currency-amount-input .cnet-form-field-wrap{border-radius:0 .25rem .25rem 0}.controls{display:flex}.element-template{text-transform:capitalize}\n"] }]
        }], propDecorators: { currencyOptions: [{
                type: Input
            }], currencyOptionsDefault: [{
                type: Input
            }], currencyControl: [{
                type: Input
            }], currencyControlId: [{
                type: Input
            }], currencyAmountControl: [{
                type: Input
            }], currencyAmountControlId: [{
                type: Input
            }], filterCurrencySelectPlaceHolder: [{
                type: Input
            }], inputLabel: [{
                type: Input
            }] } });

class CnetCurrencyModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCurrencyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetCurrencyModule, declarations: [CurrencyComponent,
            CurrencyDirective], imports: [CommonModule,
            ReactiveFormsModule,
            CnetSelectModule,
            CnetFormFieldModule,
            CnetInputModule], exports: [CurrencyComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCurrencyModule, imports: [CommonModule,
            ReactiveFormsModule,
            CnetSelectModule,
            CnetFormFieldModule,
            CnetInputModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCurrencyModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CurrencyComponent,
                        CurrencyDirective
                    ],
                    exports: [
                        CurrencyComponent
                    ],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        CnetSelectModule,
                        CnetFormFieldModule,
                        CnetInputModule
                    ]
                }]
        }] });

moment.locale('en-AE', {
    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
    },
    calendar: {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    },
    relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal: function (number) {
        var b = number % 10, output = ~~((number % 100) / 10) === 1
            ? 'th'
            : b === 1
                ? 'st'
                : b === 2
                    ? 'nd'
                    : b === 3
                        ? 'rd'
                        : 'th';
        return number + output;
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4, // The week that contains Jan 4th is the first week of the year.
    },
    monthsParseExact: true,
    weekdaysParseExact: true,
    meridiemParse: /PD|MD/,
    isPM: function (input) {
        return input.charAt(0) === 'M';
    },
    // In case the meridiem units are not separated around 12, then implement
    // this function (look at locale/id.js for an example).
    // meridiemHour : function (hour, meridiem) {
    //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
    // },
    meridiem: function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
});
let nextUniqueId$6 = 0;
const CNET_DATEPICKER_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CnetDatepickerInputDirective),
    multi: true
};
/** Directive for use datepicker input inside a form field */
class CnetDatepickerInputDirective {
    constructor(_elementRef, translateService, _injector) {
        this._elementRef = _elementRef;
        this.translateService = translateService;
        this._injector = _injector;
        /** @ignore */ this._id = `cnet-input-${nextUniqueId$6++}`;
        /** @ignore */ this._required = false;
        /** @ignore */ this._disabled = false;
        /** @ignore */ this._focused = false;
        /** @ignore */ this._errorState = false;
        /** Emits whenever the state of the control changes */
        this.stateChanges = new Subject();
        /** @ignore */ this.onTouchedCallback = () => { };
        /** @ignore */ this.onChangeCallback = () => { };
        this.cnetDatepickerInput = null;
        this._htmlInput = this._elementRef.nativeElement;
        translateService.onLangChange.subscribe(lang => {
            if (this._htmlInput.value) {
                this._htmlInput.value = this.formatValue(this.value);
            }
        });
    }
    /** @ignore */
    ngOnInit() {
        this._control = this._injector.get(NgControl);
        this._elementRef.nativeElement.autocomplete = "off";
    }
    /** @ignore */
    ngDoCheck() {
        if (this._control) {
            this.errorState = this._control.errors !== null && (!!this._control.touched || this._control.dirty);
        }
        this.stateChanges.next();
    }
    /** The element ID for this control */
    get id() { return this._id; }
    set id(value) { this._id = value; }
    /** Whether the control is required. */
    get required() { return this._required; }
    set required(value) { this._required = coerceBooleanProperty(value); }
    /** Whether the control is disabled. */
    get disabled() {
        if (this._control && this._control.disabled !== null) {
            return this._control.disabled;
        }
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
        if (this.focused) {
            this.focused = false;
            this.stateChanges.next();
        }
    }
    /** Whether the control is focused */
    get focused() { return this._focused; }
    set focused(value) { this._focused = coerceBooleanProperty(value); }
    /** Whether the control is in an error state. */
    get errorState() { return this._errorState; }
    set errorState(value) { this._errorState = coerceBooleanProperty(value); }
    /** Error id for aria-describedby */
    get describedby() {
        return this.error.id || null;
    }
    /** The value of the control */
    get value() {
        return this.innerValue;
    }
    set value(v) {
        let newValue = null;
        if (moment.isMoment(v)) {
            if (v !== this.innerValue) {
                this.innerValue = v;
            }
            if (this._htmlInput.value !== this.formatValue(v)) {
                this._htmlInput.value = this.formatValue(v);
            }
            newValue = v.toDate();
        }
        this.cnetDatepickerInput.updateDay(newValue);
        this.onChangeCallback(newValue);
        this.stateChanges.next();
    }
    /** @ignore */
    onChange(value) {
        if (value) {
            this.value = this.parseMoment(value) || moment();
        }
        else {
            this.value = null;
        }
    }
    /** @ignore */
    writeValue(value) {
        if (moment.isDate(value)) {
            value = moment(value);
        }
        this.value = value;
    }
    /** @ignore */
    registerOnChange(fn) {
        this.onChangeCallback = fn;
    }
    /** @ignore */
    registerOnTouched(fn) {
        this.onTouchedCallback = fn;
    }
    /** Returns a valid moment or null */
    parseMoment(value) {
        const date = moment(value, this.getCurrentLocaleDateFormat());
        return date.isValid() ? date : null;
    }
    /** Returns a date formatted according to the current locale */
    formatValue(value) {
        return value.format(this.getCurrentLocaleDateFormat());
    }
    /** Returns the date format of the current locale */
    getCurrentLocaleDateFormat() {
        return moment().locale(this.translateService.currentLang).creationData().locale.longDateFormat('L');
    }
    /** @ignore */
    _changeFocus(focused) {
        if (!focused) {
            this.onTouchedCallback();
        }
        this.focused = focused;
        this.stateChanges.next();
    }
    /** @ignore */
    inputClick() {
        this.cnetDatepickerInput?.show();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDatepickerInputDirective, deps: [{ token: i0.ElementRef }, { token: i1$3.TranslateService }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetDatepickerInputDirective, selector: "input[cnet-datepicker-input], input[cnetDatepickerInput]", inputs: { cnetDatepickerInput: "cnetDatepickerInput", id: "id", required: "required", disabled: "disabled", focused: "focused", errorState: "errorState" }, host: { listeners: { "blur": "_changeFocus(false)", "focus": "_changeFocus(true)", "change": "onChange($event.target.value)", "click": "inputClick()" }, properties: { "attr.id": "id", "attr.aria-invalid": "errorState", "attr.aria-required": "required", "attr.aria-describedby": "fadescribedby", "disabled": "disabled", "required": "required" }, classAttribute: "cnet-input cnet-datepicker-input" }, providers: [{ provide: CnetFormFieldControl, useExisting: CnetDatepickerInputDirective }, CNET_DATEPICKER_CONTROL_VALUE_ACCESSOR], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDatepickerInputDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'input[cnet-datepicker-input], input[cnetDatepickerInput]',
                    host: {
                        class: 'cnet-input cnet-datepicker-input',
                        '[attr.id]': 'id',
                        '[attr.aria-invalid]': 'errorState',
                        '[attr.aria-required]': 'required',
                        '[attr.aria-describedby]': 'fadescribedby',
                        '[disabled]': 'disabled',
                        '[required]': 'required',
                        '(blur)': '_changeFocus(false)',
                        '(focus)': '_changeFocus(true)',
                        '(change)': 'onChange($event.target.value)'
                    },
                    providers: [{ provide: CnetFormFieldControl, useExisting: CnetDatepickerInputDirective }, CNET_DATEPICKER_CONTROL_VALUE_ACCESSOR],
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$3.TranslateService }, { type: i0.Injector }], propDecorators: { cnetDatepickerInput: [{
                type: Input
            }], id: [{
                type: Input
            }], required: [{
                type: Input
            }], disabled: [{
                type: Input
            }], focused: [{
                type: Input
            }], errorState: [{
                type: Input
            }], inputClick: [{
                type: HostListener,
                args: ['click']
            }] } });

const datepickerAnimation = trigger('datepickerAnimation', [
    state('default', style({ transform: 'translateY(0)', opacity: 1 })),
    state('hide', style({ opacity: 0 })),
    transition('* => hide', animate('200ms ease-out')),
    transition('* => show', [style({ opacity: 0 }), animate('200ms')]),
]);

moment.locale('en-AE', {
    months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    longDateFormat: {
        LT: 'HH:mm',
        LTS: 'HH:mm:ss',
        L: 'DD/MM/YYYY',
        LL: 'D MMMM YYYY',
        LLL: 'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
    },
    calendar: {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    },
    relativeTime: {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    },
    dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
    ordinal: function (number) {
        var b = number % 10, output = ~~((number % 100) / 10) === 1
            ? 'th'
            : b === 1
                ? 'st'
                : b === 2
                    ? 'nd'
                    : b === 3
                        ? 'rd'
                        : 'th';
        return number + output;
    },
    week: {
        dow: 1, // Monday is the first day of the week.
        doy: 4, // The week that contains Jan 4th is the first week of the year.
    },
    monthsParseExact: true,
    weekdaysParseExact: true,
    meridiemParse: /PD|MD/,
    isPM: function (input) {
        return input.charAt(0) === 'M';
    },
    // In case the meridiem units are not separated around 12, then implement
    // this function (look at locale/id.js for an example).
    // meridiemHour : function (hour, meridiem) {
    //     return /* 0-23 hour, given meridiem token and hour 1-12 */ ;
    // },
    meridiem: function (hours, minutes, isLower) {
        return hours < 12 ? 'PD' : 'MD';
    },
});
let nextUniqueId$5 = 0;
/** The Cnet Datepicker provides a simple way to select a date */
class CnetDatepickerComponent {
    constructor(overlay, cdr, _focusMonitor, _document, formField, translateService, locale) {
        this.overlay = overlay;
        this.cdr = cdr;
        this._focusMonitor = _focusMonitor;
        this._document = _document;
        this.formField = formField;
        this.translateService = translateService;
        this.locale = locale;
        /** @ignore */ this.viewDate = moment();
        /** @ignore */ this.today = moment();
        /** @ignore */ this._viewMode = 'day';
        /** @ignore Maximum number of years displayed in the year view mode */
        this.yearsLimit = 24;
        /** If the date selection panel is visible */
        this.visible = false;
        this.viewDate.locale(this.translateService.currentLang);
        this.today.locale(this.translateService.currentLang);
        this.selected?.locale(this.translateService.currentLang);
        translateService.onLangChange.subscribe(lang => {
            this.viewDate.locale(lang.lang);
            this.today.locale(lang.lang);
            if (this.selected) {
                this.selected?.locale(lang.lang);
            }
        });
    }
    /** Datepicker view mode */
    get viewMode() { return this._viewMode; }
    set viewMode(value) {
        this._viewMode = value;
    }
    /** @ignore Updates view values */
    updateView() {
        this.weekDays = this.getWeekDays();
        this.monthDays = this.getMonthDays();
        this.yearMonths = this.getYears();
        this.cdr.markForCheck();
    }
    /** Displays the date selection panel if it is not visible */
    show() {
        if (!this.visible) {
            this.viewMode = 'day';
            this.updateView();
            const overalayConfig = this.getOverlayConfig();
            this._overlayRef = this.overlay.create(overalayConfig);
            this._overlayRef.attach(this._contentTemplate);
            this.animationState = 'show';
            this.visible = true;
            this._getOutsideClickStream().pipe(take$1(1)).subscribe(() => {
                this.hide();
            });
            setTimeout(() => {
                this._focusMonitor.focusVia(this._viewModeButton, 'program');
            }, 0);
        }
    }
    /** Hides the date selection panel */
    hide() {
        this.visible = false;
        this.animationState = 'hide';
        this.cdr.markForCheck();
    }
    /** @ignore */
    getOverlayConfig() {
        const positionStrategy = this.overlay.position()
            .flexibleConnectedTo(this.formField.content)
            .withPush(false)
            .withViewportMargin(0)
            .withFlexibleDimensions(false)
            .withPositions([{
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top'
            }, {
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'bottom'
            }]);
        const scrollStrategy = this.overlay.scrollStrategies.reposition();
        return new OverlayConfig({
            positionStrategy,
            scrollStrategy,
            hasBackdrop: false
        });
    }
    /** @ignore */
    _getOutsideClickStream() {
        return merge(fromEvent(this._document, 'click'), fromEvent(this._document, 'touchend'))
            .pipe(filter(event => {
            const clickTarget = event.target;
            return this.visible && clickTarget !== this.formField.content.nativeElement &&
                (!!this._overlayRef && !this._overlayRef.overlayElement.contains(clickTarget)) &&
                (!!this.formField.content.nativeElement && !this.formField.content.nativeElement.contains(clickTarget));
        }));
    }
    /** @ignore */
    _onAnimationDone(event) {
        if (event.fromState === 'show' && event.toState === 'hide') {
            this._overlayRef.detach();
        }
    }
    /** Go to the next page considering the current view mode */
    nextPage() {
        if (this.viewMode === 'day') {
            this.viewDate.add(1, 'month');
            this.monthDays = this.getMonthDays();
        }
        else if (this.viewMode === 'month') {
            this.viewDate.add(1, 'year');
            this.yearMonths = this.getYearMonths();
        }
        else {
            this.viewDate.add(this.yearsLimit * 1.5 + -1, 'years');
            this.years = this.getYears();
        }
    }
    /** @ignore */
    get nextPageLabel() {
        return 'Next ' + this.viewMode;
    }
    /** Go to the previous page considering the current view mode */
    previousPage() {
        if (this.viewMode === 'day') {
            this.viewDate.add(-1, 'month');
            this.monthDays = this.getMonthDays();
        }
        else if (this.viewMode === 'month') {
            this.viewDate.add(-1, 'year');
            this.monthDays = this.getMonthDays();
        }
        else {
            this.viewDate.add(this.yearsLimit * -0.5 + 1, 'years');
            this.years = this.getYears();
        }
    }
    /** @ignore */
    get previousPageLabel() {
        return 'Previous ' + this.viewMode;
    }
    /** @ignore */
    getWeekDays() {
        return Array.apply(0, Array(7)).map((_, i) => this.viewDate?.clone().isoWeekday(i).format('ddd'));
    }
    /** @ignore */
    getMonthDays() {
        if (!this.viewDate) {
            return [];
        }
        const startDate = this.viewDate?.clone().startOf('month').startOf('week');
        const totalDays = 42;
        return Array.apply(0, Array(totalDays)).map((_, i) => {
            return {
                moment: startDate.clone().add(i, 'day'),
                inMonth: startDate.clone().add(i, 'day').month() === this.viewDate?.clone().month()
            };
        });
    }
    /** @ignore */
    getYearMonths() {
        return Array.apply(0, Array(12)).map((_, i) => this.viewDate?.clone().month(i));
    }
    /** @ignore */
    getYears() {
        const firstYear = this.viewDate?.clone();
        return Array.apply(0, Array(this.yearsLimit)).map((_, i) => firstYear.clone().add(i, 'year'));
    }
    /** Go to the next view mode ('day', 'month' or 'year') */
    nextViewMode() {
        if (this.viewMode === 'day') {
            this.yearMonths = this.getYearMonths();
            this.viewMode = 'month';
        }
        else if (this.viewMode === 'month') {
            this.years = this.getYears();
            this.viewMode = 'year';
        }
        else {
            this.viewMode = 'day';
        }
    }
    /** @ignore */
    get nextViewModeLabel() {
        return 'Select ' + (this.viewMode === 'day' ? 'month' : this.viewMode === 'month' ? 'year' : 'day');
    }
    /** @ignore */
    changeViewDate(value) {
        if (value) {
            this.viewDate = value;
            if (this.viewMode === 'year') {
                this.yearMonths = this.getYearMonths();
                this.viewMode = 'month';
            }
            else {
                this.monthDays = this.getMonthDays();
                this.viewMode = 'day';
            }
        }
    }
    /** @ignore */
    selectDay(value) {
        this.selected = value;
        if (value) {
            this.formField.control.value = value;
            this.hide();
        }
    }
    /** @ignore */
    updateDay(value) {
        this.selected = value;
        if (value) {
            this.selected = moment(value);
            this.navigateToDate();
        }
        this.hide();
    }
    navigateToDate() {
        if (this.selected) {
            if (this.formField?.control?.value) {
                this.changeViewDate(this.formField.control.value.locale(this.translateService.currentLang));
            }
        }
        else {
            this.changeViewDate(moment().locale(this.translateService.currentLang));
        }
        this.cdr.markForCheck();
    }
    /** @ignore */
    getYearNavText() {
        const firstYear = parseInt(this.viewDate.format('YYYY'), 10);
        const finalYear = firstYear + this.yearsLimit - 1;
        return `${firstYear} - ${finalYear}`;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDatepickerComponent, deps: [{ token: i1$5.Overlay }, { token: i0.ChangeDetectorRef }, { token: i1$2.FocusMonitor }, { token: DOCUMENT, optional: true }, { token: CnetFormFieldComponent, optional: true }, { token: i1$3.TranslateService }, { token: LOCALE_ID }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetDatepickerComponent, selector: "cnet-datepicker", inputs: { viewMode: "viewMode" }, host: { classAttribute: "cnet-datepicker" }, viewQueries: [{ propertyName: "_contentTemplate", first: true, predicate: CdkPortal, descendants: true }, { propertyName: "_viewModeButton", first: true, predicate: ["viewModeButton"], descendants: true }], ngImport: i0, template: "<button cnet-icon-button class=\"cnet-datepicker-trigger\" size=\"small\" (click)=\"show()\" aria-label=\"Open Calendar\" type=\"button\"\n    [disabled]=\"formField?.control.disabled\">\n    <cnet-icon name=\"calendar\"></cnet-icon>\n</button>\n\n<ng-template cdk-portal>\n    <div class=\"cnet-datepicker-overlay-panel\" #content [@datepickerAnimation]=\"animationState\"\n        (@datepickerAnimation.done)=\"_onAnimationDone($event)\">\n\n        <div class=\"cnet-datepicker-panel-container\" cdkTrapFocus>\n            <div class=\"cnet-datepicker-nav\">\n                <div class=\"cnet-datepicker-nav-current\">\n                    <button cnet-button #viewModeButton size=\"small\" cdkFocusRegionStart cdkFocusInitial\n                        [attr.aria-label]=\"nextViewModeLabel\" (click)=\"nextViewMode(); $event.stopPropagation()\" type=\"button\">\n\n                        <span *ngIf=\"viewMode === 'day'\">{{viewDate.format('MMM YYYY')}}</span>\n                        <span *ngIf=\"viewMode === 'month'\">{{viewDate.format('YYYY')}}</span>\n                        <span *ngIf=\"viewMode === 'year'\">{{getYearNavText()}}</span>\n                        <cnet-icon name=\"angle-down\" size=\"sm\"></cnet-icon>\n                    </button>\n                </div>\n                <div class=\"cnet-datepicker-nav-wrap\">\n                    <div class=\"cnet-datepicker-nav-previous\">\n                        <button cnet-icon-button size=\"small\" [attr.aria-label]=\"previousPageLabel\"\n                            (click)=\"previousPage(); $event.stopPropagation()\" type=\"button\">\n                            <cnet-icon name=\"angle-left\"></cnet-icon>\n                        </button>\n                    </div>\n                    <div class=\"cnet-datepicker-nav-next\">\n                        <button cnet-icon-button size=\"small\" [attr.aria-label]=\"nextPageLabel\"\n                            (click)=\"nextPage(); $event.stopPropagation()\" type=\"button\">\n                            <cnet-icon name=\"angle-right\"></cnet-icon>\n                        </button>\n                    </div>\n                </div>\n            </div>\n            <cnet-divider></cnet-divider>\n\n            <div class=\"cnet-datepicker-container cnet-datepicker-days-container\" ng-container\n                *ngIf=\"viewMode == 'day'\">\n                <div class=\"cnet-datepicker-days-header\">\n                    <span *ngFor=\"let day of weekDays\">{{day}}</span>\n                </div>\n                <div class=\"cnet-datepicker-days-body\">\n                    <div class=\"cnet-datepicker-day\" *ngFor=\"let day of monthDays\" [ngClass]=\"{\n                            'cnet-datepicker-day-current': day.moment.isSame(today, 'day'),\n                            'cnet-datepicker-day-selected': selected && day.moment.isSame(selected, 'day'),\n                            'cnet-datepicker-day-disabled': !day.inMonth}\">\n\n                        <button cnetRipple [disabled]=\"!day.inMonth\" (click)=\"selectDay(day.moment)\"\n                            [attr.aria-label]=\"day.moment.format('MMM DD, YYYY')\" type=\"button\">{{day.moment.format('DD')}}</button>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"cnet-datepicker-container cnet-datepicker-months-container\" *ngIf=\"viewMode == 'month'\">\n                <div class=\"cnet-datepicker-month\" *ngFor=\"let month of yearMonths\">\n                    <button cnetRipple (click)=\"changeViewDate(month); $event.stopPropagation()\"\n                        [attr.aria-label]=\"month.format('MMM YYYY')\" type=\"button\">{{month.format('MMM')}}</button>\n                </div>\n            </div>\n\n            <div class=\"cnet-datepicker-container cnet-datepicker-years-container\" *ngIf=\"viewMode == 'year'\">\n                <div class=\"cnet-datepicker-year\" *ngFor=\"let year of years\">\n                    <button cnetRipple\n                        (click)=\"changeViewDate(year); $event.stopPropagation()\" type=\"button\">{{year.format('YYYY')}}</button>\n                </div>\n            </div>\n\n        </div>\n    </div>\n</ng-template>\n", styles: ["button.cnet-datepicker-trigger{margin-right:.1875rem}.cnet-datepicker-overlay-panel{border-radius:.25rem;box-shadow:0 0 1px 1px #0000000f,0 1px 4px -1px #0000001a,0 4px 5px #0000001a;background-color:#fff}.cnet-datepicker-panel-container{width:280px}.cnet-datepicker-nav{display:flex;justify-content:space-between;align-items:center;margin:.5rem}.cnet-datepicker-nav .cnet-datepicker-nav-wrap{display:flex}.cnet-datepicker-nav .cnet-datepicker-nav-previous{margin-right:.5rem}.cnet-datepicker-nav .cnet-datepicker-nav-current .cnet-button .cnet-button-wrapper{align-items:baseline}.cnet-datepicker-nav .cnet-datepicker-nav-current .cnet-button .cnet-icon{margin-left:.5rem}.cnet-datepicker-days-header{display:flex;align-items:center;flex-wrap:wrap;background-color:var(--cnet--100, #f5f5f5);padding:.25rem}.cnet-datepicker-days-header span{display:flex;justify-content:center;align-items:center;flex:14.28571%;color:#000000ab;height:1.5rem;font-size:.75rem}.cnet-datepicker-days-body{padding:.25rem;display:flex;flex-wrap:wrap}.cnet-datepicker-days-body .cnet-datepicker-day{flex:14.28571%}.cnet-datepicker-days-body .cnet-datepicker-day button{width:2rem}.cnet-datepicker-day,.cnet-datepicker-month,.cnet-datepicker-year{display:flex;justify-content:center;align-items:center}.cnet-datepicker-day button,.cnet-datepicker-month button,.cnet-datepicker-year button{border-radius:1rem;height:2rem;margin:.25rem 0;background:transparent;font-size:.875rem;outline:none;border:1px solid transparent;transition:background-color ease .3s,border-color ease .3s}.cnet-datepicker-day button:focus:not(:disabled),.cnet-datepicker-day button:hover:not(:disabled),.cnet-datepicker-month button:focus:not(:disabled),.cnet-datepicker-month button:hover:not(:disabled),.cnet-datepicker-year button:focus:not(:disabled),.cnet-datepicker-year button:hover:not(:disabled){cursor:pointer;border:1px solid var(--cnet-primary-500, #82c14f)}.cnet-datepicker-day-disabled button,.cnet-datepicker-month-disabled button,.cnet-datepicker-year-disabled button{opacity:.4}.cnet-datepicker-day-current button,.cnet-datepicker-month-current button,.cnet-datepicker-year-current button{background-color:var(--cnet--200, #eeeeee);color:var(--cnet--contrast-200, rgba(0, 0, 0, .85))}.cnet-datepicker-day-selected button,.cnet-datepicker-month-selected button,.cnet-datepicker-year-selected button{background-color:var(--cnet-primary-500, #82c14f);color:var(--cnet-primary-contrast-500, white)}.cnet-datepicker-years-container,.cnet-datepicker-months-container{display:flex;flex-wrap:wrap;justify-content:space-between;padding:.5rem}.cnet-datepicker-years-container .cnet-datepicker-year,.cnet-datepicker-years-container .cnet-datepicker-month,.cnet-datepicker-months-container .cnet-datepicker-year,.cnet-datepicker-months-container .cnet-datepicker-month{font-size:.75rem;width:25%}.cnet-datepicker-years-container .cnet-datepicker-year button,.cnet-datepicker-years-container .cnet-datepicker-month button,.cnet-datepicker-months-container .cnet-datepicker-year button,.cnet-datepicker-months-container .cnet-datepicker-month button{padding-top:.125rem;width:62px}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2.TemplatePortalDirective, selector: "[cdk-portal], [portal]", exportAs: ["cdkPortal"] }, { kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "component", type: CnetDividerComponent, selector: "cnet-divider, [cnet-divider], cnetDivider", inputs: ["vertical"], exportAs: ["cnetDivider"] }, { kind: "directive", type: CnetRippleDirective, selector: "[cnet-ripple], [cnetRipple]", inputs: ["cnetRippleColor", "cnetRippleUnbounded", "cnetRippleCentered", "cnetRippleRadius", "cnetRippleAnimation", "cnetRippleDisabled", "cnetRippleTrigger"], exportAs: ["cnetRipple"] }, { kind: "directive", type: i1$2.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }], animations: [datepickerAnimation], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDatepickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-datepicker', host: {
                        class: 'cnet-datepicker'
                    }, encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, animations: [datepickerAnimation], template: "<button cnet-icon-button class=\"cnet-datepicker-trigger\" size=\"small\" (click)=\"show()\" aria-label=\"Open Calendar\" type=\"button\"\n    [disabled]=\"formField?.control.disabled\">\n    <cnet-icon name=\"calendar\"></cnet-icon>\n</button>\n\n<ng-template cdk-portal>\n    <div class=\"cnet-datepicker-overlay-panel\" #content [@datepickerAnimation]=\"animationState\"\n        (@datepickerAnimation.done)=\"_onAnimationDone($event)\">\n\n        <div class=\"cnet-datepicker-panel-container\" cdkTrapFocus>\n            <div class=\"cnet-datepicker-nav\">\n                <div class=\"cnet-datepicker-nav-current\">\n                    <button cnet-button #viewModeButton size=\"small\" cdkFocusRegionStart cdkFocusInitial\n                        [attr.aria-label]=\"nextViewModeLabel\" (click)=\"nextViewMode(); $event.stopPropagation()\" type=\"button\">\n\n                        <span *ngIf=\"viewMode === 'day'\">{{viewDate.format('MMM YYYY')}}</span>\n                        <span *ngIf=\"viewMode === 'month'\">{{viewDate.format('YYYY')}}</span>\n                        <span *ngIf=\"viewMode === 'year'\">{{getYearNavText()}}</span>\n                        <cnet-icon name=\"angle-down\" size=\"sm\"></cnet-icon>\n                    </button>\n                </div>\n                <div class=\"cnet-datepicker-nav-wrap\">\n                    <div class=\"cnet-datepicker-nav-previous\">\n                        <button cnet-icon-button size=\"small\" [attr.aria-label]=\"previousPageLabel\"\n                            (click)=\"previousPage(); $event.stopPropagation()\" type=\"button\">\n                            <cnet-icon name=\"angle-left\"></cnet-icon>\n                        </button>\n                    </div>\n                    <div class=\"cnet-datepicker-nav-next\">\n                        <button cnet-icon-button size=\"small\" [attr.aria-label]=\"nextPageLabel\"\n                            (click)=\"nextPage(); $event.stopPropagation()\" type=\"button\">\n                            <cnet-icon name=\"angle-right\"></cnet-icon>\n                        </button>\n                    </div>\n                </div>\n            </div>\n            <cnet-divider></cnet-divider>\n\n            <div class=\"cnet-datepicker-container cnet-datepicker-days-container\" ng-container\n                *ngIf=\"viewMode == 'day'\">\n                <div class=\"cnet-datepicker-days-header\">\n                    <span *ngFor=\"let day of weekDays\">{{day}}</span>\n                </div>\n                <div class=\"cnet-datepicker-days-body\">\n                    <div class=\"cnet-datepicker-day\" *ngFor=\"let day of monthDays\" [ngClass]=\"{\n                            'cnet-datepicker-day-current': day.moment.isSame(today, 'day'),\n                            'cnet-datepicker-day-selected': selected && day.moment.isSame(selected, 'day'),\n                            'cnet-datepicker-day-disabled': !day.inMonth}\">\n\n                        <button cnetRipple [disabled]=\"!day.inMonth\" (click)=\"selectDay(day.moment)\"\n                            [attr.aria-label]=\"day.moment.format('MMM DD, YYYY')\" type=\"button\">{{day.moment.format('DD')}}</button>\n                    </div>\n                </div>\n            </div>\n\n            <div class=\"cnet-datepicker-container cnet-datepicker-months-container\" *ngIf=\"viewMode == 'month'\">\n                <div class=\"cnet-datepicker-month\" *ngFor=\"let month of yearMonths\">\n                    <button cnetRipple (click)=\"changeViewDate(month); $event.stopPropagation()\"\n                        [attr.aria-label]=\"month.format('MMM YYYY')\" type=\"button\">{{month.format('MMM')}}</button>\n                </div>\n            </div>\n\n            <div class=\"cnet-datepicker-container cnet-datepicker-years-container\" *ngIf=\"viewMode == 'year'\">\n                <div class=\"cnet-datepicker-year\" *ngFor=\"let year of years\">\n                    <button cnetRipple\n                        (click)=\"changeViewDate(year); $event.stopPropagation()\" type=\"button\">{{year.format('YYYY')}}</button>\n                </div>\n            </div>\n\n        </div>\n    </div>\n</ng-template>\n", styles: ["button.cnet-datepicker-trigger{margin-right:.1875rem}.cnet-datepicker-overlay-panel{border-radius:.25rem;box-shadow:0 0 1px 1px #0000000f,0 1px 4px -1px #0000001a,0 4px 5px #0000001a;background-color:#fff}.cnet-datepicker-panel-container{width:280px}.cnet-datepicker-nav{display:flex;justify-content:space-between;align-items:center;margin:.5rem}.cnet-datepicker-nav .cnet-datepicker-nav-wrap{display:flex}.cnet-datepicker-nav .cnet-datepicker-nav-previous{margin-right:.5rem}.cnet-datepicker-nav .cnet-datepicker-nav-current .cnet-button .cnet-button-wrapper{align-items:baseline}.cnet-datepicker-nav .cnet-datepicker-nav-current .cnet-button .cnet-icon{margin-left:.5rem}.cnet-datepicker-days-header{display:flex;align-items:center;flex-wrap:wrap;background-color:var(--cnet--100, #f5f5f5);padding:.25rem}.cnet-datepicker-days-header span{display:flex;justify-content:center;align-items:center;flex:14.28571%;color:#000000ab;height:1.5rem;font-size:.75rem}.cnet-datepicker-days-body{padding:.25rem;display:flex;flex-wrap:wrap}.cnet-datepicker-days-body .cnet-datepicker-day{flex:14.28571%}.cnet-datepicker-days-body .cnet-datepicker-day button{width:2rem}.cnet-datepicker-day,.cnet-datepicker-month,.cnet-datepicker-year{display:flex;justify-content:center;align-items:center}.cnet-datepicker-day button,.cnet-datepicker-month button,.cnet-datepicker-year button{border-radius:1rem;height:2rem;margin:.25rem 0;background:transparent;font-size:.875rem;outline:none;border:1px solid transparent;transition:background-color ease .3s,border-color ease .3s}.cnet-datepicker-day button:focus:not(:disabled),.cnet-datepicker-day button:hover:not(:disabled),.cnet-datepicker-month button:focus:not(:disabled),.cnet-datepicker-month button:hover:not(:disabled),.cnet-datepicker-year button:focus:not(:disabled),.cnet-datepicker-year button:hover:not(:disabled){cursor:pointer;border:1px solid var(--cnet-primary-500, #82c14f)}.cnet-datepicker-day-disabled button,.cnet-datepicker-month-disabled button,.cnet-datepicker-year-disabled button{opacity:.4}.cnet-datepicker-day-current button,.cnet-datepicker-month-current button,.cnet-datepicker-year-current button{background-color:var(--cnet--200, #eeeeee);color:var(--cnet--contrast-200, rgba(0, 0, 0, .85))}.cnet-datepicker-day-selected button,.cnet-datepicker-month-selected button,.cnet-datepicker-year-selected button{background-color:var(--cnet-primary-500, #82c14f);color:var(--cnet-primary-contrast-500, white)}.cnet-datepicker-years-container,.cnet-datepicker-months-container{display:flex;flex-wrap:wrap;justify-content:space-between;padding:.5rem}.cnet-datepicker-years-container .cnet-datepicker-year,.cnet-datepicker-years-container .cnet-datepicker-month,.cnet-datepicker-months-container .cnet-datepicker-year,.cnet-datepicker-months-container .cnet-datepicker-month{font-size:.75rem;width:25%}.cnet-datepicker-years-container .cnet-datepicker-year button,.cnet-datepicker-years-container .cnet-datepicker-month button,.cnet-datepicker-months-container .cnet-datepicker-year button,.cnet-datepicker-months-container .cnet-datepicker-month button{padding-top:.125rem;width:62px}\n"] }]
        }], ctorParameters: () => [{ type: i1$5.Overlay }, { type: i0.ChangeDetectorRef }, { type: i1$2.FocusMonitor }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: CnetFormFieldComponent, decorators: [{
                    type: Optional
                }] }, { type: i1$3.TranslateService }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [LOCALE_ID]
                }] }], propDecorators: { _contentTemplate: [{
                type: ViewChild,
                args: [CdkPortal]
            }], _viewModeButton: [{
                type: ViewChild,
                args: ['viewModeButton']
            }], viewMode: [{
                type: Input
            }] } });

class CnetI18nDatePipe extends DatePipe {
    constructor(locale, translate, cdr) {
        super(locale);
        this.cdr = cdr;
        this.previousParams = [];
        this.changeSubs = translate.onLangChange.subscribe(($event) => {
            this.llocale = $event.lang;
            this.cache = null;
            this.cdr.markForCheck();
        });
    }
    transform(value, format, timezone, locale) {
        const currentParams = [value, format, timezone, locale];
        locale = locale ? locale : this.llocale;
        this.cache = null;
        if (!this.cache || !_.isEmpty(_.difference(this.previousParams, currentParams))) {
            this.previousParams = currentParams;
            this.cache = super.transform(value, format, timezone, locale);
        }
        return this.cache;
    }
    ngOnDestroy() {
        this.changeSubs.unsubscribe();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetI18nDatePipe, deps: [{ token: LOCALE_ID }, { token: i1$3.TranslateService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetI18nDatePipe, name: "i18nDate", pure: false }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetI18nDatePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'i18nDate',
                    pure: false
                }]
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [LOCALE_ID]
                }] }, { type: i1$3.TranslateService }, { type: i0.ChangeDetectorRef }] });

class CnetDatepickerModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDatepickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetDatepickerModule, declarations: [CnetDatepickerComponent, CnetI18nDatePipe, CnetDatepickerInputDirective], imports: [CommonModule,
            ReactiveFormsModule,
            OverlayModule,
            PortalModule,
            CnetButtonModule,
            CnetIconModule,
            CnetDividerModule,
            CnetRippleModule,
            A11yModule,
            TranslateModule], exports: [CnetDatepickerComponent, CnetDatepickerInputDirective, CnetI18nDatePipe] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDatepickerModule, imports: [CommonModule,
            ReactiveFormsModule,
            OverlayModule,
            PortalModule,
            CnetButtonModule,
            CnetIconModule,
            CnetDividerModule,
            CnetRippleModule,
            A11yModule,
            TranslateModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDatepickerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetDatepickerComponent, CnetI18nDatePipe, CnetDatepickerInputDirective],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        OverlayModule,
                        PortalModule,
                        CnetButtonModule,
                        CnetIconModule,
                        CnetDividerModule,
                        CnetRippleModule,
                        A11yModule,
                        TranslateModule,
                    ],
                    exports: [CnetDatepickerComponent, CnetDatepickerInputDirective, CnetI18nDatePipe]
                }]
        }] });

/**
 * Component used to create dialogs
 *
 * @export
 * class CnetDialogComponent
 * implements {OnInit}
 */
class CnetDialogComponent {
    constructor(ref) {
        this.ref = ref;
    }
    /** @ignore */ close() {
        this.ref.close(null);
    }
    /** @ignore */ ngOnInit() {
        this.content = this.ref.content;
        if (typeof this.content === 'string') {
            this.contentType = 'string';
        }
        else if (this.content instanceof TemplateRef) {
            this.contentType = 'template';
            this.context = {
                close: this.ref.close.bind(this.ref)
            };
        }
        else {
            this.contentType = 'component';
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDialogComponent, deps: [{ token: CnetDialogRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetDialogComponent, selector: "ng-component", host: { attributes: { "role": "dialog" }, classAttribute: "cnet-dialog" }, ngImport: i0, template: "<div class=\"modal-content\" cdkTrapFocus [cdkTrapFocusAutoCapture]=\"true\" [@fade]>\n    <ng-container [ngSwitch]=\"contentType\">\n\n        <ng-container *ngSwitchCase=\"'string'\">\n            <div [innerHTML]=\"content\"></div>\n        </ng-container>\n\n        <ng-container *ngSwitchCase=\"'template'\">\n            <ng-container *ngTemplateOutlet=\"content; context: context\"></ng-container>\n        </ng-container>\n\n        <ng-container *ngSwitchCase=\"'component'\">\n            <ng-container *ngComponentOutlet=\"content\"></ng-container>\n        </ng-container>\n\n    </ng-container>\n    <div></div>\n</div>\n", styles: [".modal-content{max-width:calc(100vw - 1rem);min-width:50vw;margin:16px}@media (max-width: 767.98px){.modal-content{width:100vw;margin:0}}\n"], dependencies: [{ kind: "directive", type: i1.NgComponentOutlet, selector: "[ngComponentOutlet]", inputs: ["ngComponentOutlet", "ngComponentOutletInputs", "ngComponentOutletInjector", "ngComponentOutletContent", "ngComponentOutletNgModule", "ngComponentOutletNgModuleFactory"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$2.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }], animations: [
            trigger('fade', [
                transition(':enter', [
                    style({ transform: 'translateY(-50px) scale(.8)', opacity: '0' }),
                    animate(200)
                ]),
            ])
        ], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDialogComponent, decorators: [{
            type: Component,
            args: [{ host: {
                        class: 'cnet-dialog',
                        role: 'dialog'
                    }, encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, animations: [
                        trigger('fade', [
                            transition(':enter', [
                                style({ transform: 'translateY(-50px) scale(.8)', opacity: '0' }),
                                animate(200)
                            ]),
                        ])
                    ], template: "<div class=\"modal-content\" cdkTrapFocus [cdkTrapFocusAutoCapture]=\"true\" [@fade]>\n    <ng-container [ngSwitch]=\"contentType\">\n\n        <ng-container *ngSwitchCase=\"'string'\">\n            <div [innerHTML]=\"content\"></div>\n        </ng-container>\n\n        <ng-container *ngSwitchCase=\"'template'\">\n            <ng-container *ngTemplateOutlet=\"content; context: context\"></ng-container>\n        </ng-container>\n\n        <ng-container *ngSwitchCase=\"'component'\">\n            <ng-container *ngComponentOutlet=\"content\"></ng-container>\n        </ng-container>\n\n    </ng-container>\n    <div></div>\n</div>\n", styles: [".modal-content{max-width:calc(100vw - 1rem);min-width:50vw;margin:16px}@media (max-width: 767.98px){.modal-content{width:100vw;margin:0}}\n"] }]
        }], ctorParameters: () => [{ type: CnetDialogRef }] });

class CnetDialogModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDialogModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetDialogModule, declarations: [CnetDialogComponent], imports: [CommonModule,
            OverlayModule,
            A11yModule], exports: [CnetDialogComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDialogModule, imports: [CommonModule,
            OverlayModule,
            A11yModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDialogModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnetDialogComponent
                    ],
                    imports: [
                        CommonModule,
                        OverlayModule,
                        A11yModule
                    ],
                    exports: [
                        CnetDialogComponent
                    ]
                }]
        }] });

class ClickOutsideDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.cnetClickOutside = new EventEmitter();
    }
    onClick(target) {
        const clickedInside = this.elementRef.nativeElement.contains(target);
        if (!clickedInside) {
            this.cnetClickOutside.emit();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClickOutsideDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: ClickOutsideDirective, selector: "[cnetClickOutside]", outputs: { cnetClickOutside: "cnetClickOutside" }, host: { listeners: { "document:click": "onClick($event.target)" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClickOutsideDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetClickOutside]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { cnetClickOutside: [{
                type: Output
            }], onClick: [{
                type: HostListener,
                args: ['document:click', ['$event.target']]
            }] } });

class ClickOutsideModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClickOutsideModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: ClickOutsideModule, declarations: [ClickOutsideDirective], imports: [CommonModule], exports: [ClickOutsideDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClickOutsideModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ClickOutsideModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ClickOutsideDirective
                    ],
                    exports: [
                        ClickOutsideDirective
                    ],
                    imports: [
                        CommonModule
                    ]
                }]
        }] });

let CnetFile$1 = class CnetFile {
    constructor(name, attachmentUri, filepath, file) {
        this.name = name;
        this.attachmentUri = attachmentUri;
        this.filePath = filepath;
        this.file = file;
    }
};

class FileUploadService {
    constructor(http) {
        this.http = http;
    }
    getFile(url) {
        return this.http.get(url);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileUploadService, deps: [{ token: i1$7.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileUploadService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileUploadService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$7.HttpClient }] });

class CnetListComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetListComponent, selector: "cnet-list, [cnet-list], cnetList", host: { classAttribute: "cnet-list" }, exportAs: ["cnetList"], ngImport: i0, template: "<ng-content></ng-content>", styles: [".cnet-list{display:flex;flex-direction:column;overflow:hidden;border-radius:.25rem;background-color:#fff}.cnet-list-item{text-decoration:none;color:#000000d9;cursor:pointer}.cnet-list-item:hover{background-color:#0000000a}.cnet-list-item.disabled-ripple,.cnet-list-item.disable-hover{cursor:auto}.cnet-list-item.disable-hover:hover{background-color:transparent}.cnet-list-container{display:flex;padding:1rem}.cnet-list-avatar{display:block;overflow:hidden;border-radius:.25rem;margin-right:1rem;height:3rem;min-width:3rem;width:3rem;background-size:cover}.cnet-list-item-content{width:100%;min-width:0;display:flex;flex-direction:column;justify-content:center}.cnet-list-title{font-size:1rem;font-weight:700}.cnet-list-title,.cnet-list-description{margin:0}.cnet-list-ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-list, [cnet-list], cnetList', exportAs: 'cnetList', host: {
                        class: 'cnet-list'
                    }, encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content></ng-content>", styles: [".cnet-list{display:flex;flex-direction:column;overflow:hidden;border-radius:.25rem;background-color:#fff}.cnet-list-item{text-decoration:none;color:#000000d9;cursor:pointer}.cnet-list-item:hover{background-color:#0000000a}.cnet-list-item.disabled-ripple,.cnet-list-item.disable-hover{cursor:auto}.cnet-list-item.disable-hover:hover{background-color:transparent}.cnet-list-container{display:flex;padding:1rem}.cnet-list-avatar{display:block;overflow:hidden;border-radius:.25rem;margin-right:1rem;height:3rem;min-width:3rem;width:3rem;background-size:cover}.cnet-list-item-content{width:100%;min-width:0;display:flex;flex-direction:column;justify-content:center}.cnet-list-title{font-size:1rem;font-weight:700}.cnet-list-title,.cnet-list-description{margin:0}.cnet-list-ellipsis{white-space:nowrap;overflow:hidden;text-overflow:ellipsis}\n"] }]
        }] });

class CnetListSelectDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetListSelectDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetListSelectDirective, selector: "cnet-list-select, [cnet-list-select], [cnetListSelect]", host: { classAttribute: "cnet-list-select" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetListSelectDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-list-select, [cnet-list-select], [cnetListSelect]',
                    host: {
                        class: 'cnet-list-select'
                    }
                }]
        }] });
class CnetListAvatarDirective {
    get avatarSrc() { return this._avatarSrc; }
    set avatarSrc(value) {
        this._avatarSrc = `url(${value})`;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetListAvatarDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetListAvatarDirective, selector: "cnet-list-avatar, [cnet-list-avatar], [cnetListAvatar]", inputs: { avatarSrc: ["avatar-src", "avatarSrc"] }, host: { attributes: { "role": "img" }, properties: { "style.backgroundImage": "this.avatarSrc" }, classAttribute: "cnet-list-avatar" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetListAvatarDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-list-avatar, [cnet-list-avatar], [cnetListAvatar]',
                    host: {
                        role: 'img',
                        class: 'cnet-list-avatar'
                    }
                }]
        }], propDecorators: { avatarSrc: [{
                type: HostBinding,
                args: ['style.backgroundImage']
            }, {
                type: Input,
                args: ['avatar-src']
            }] } });
class CnetListTitleDirective {
    get ellipsis() { return this._ellipsis; }
    set ellipsis(value) {
        this._ellipsis = coerceBooleanProperty(value);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetListTitleDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetListTitleDirective, selector: "cnet-list-title, [cnet-list-title], [cnetListTitle]", inputs: { ellipsis: "ellipsis" }, host: { properties: { "class.cnet-list-ellipsis": "ellipsis" }, classAttribute: "cnet-list-title" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetListTitleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-list-title, [cnet-list-title], [cnetListTitle]',
                    host: {
                        class: 'cnet-list-title',
                        '[class.cnet-list-ellipsis]': 'ellipsis'
                    }
                }]
        }], propDecorators: { ellipsis: [{
                type: Input
            }] } });
class CnetListDescriptionDirective {
    get ellipsis() { return this._ellipsis; }
    set ellipsis(value) {
        this._ellipsis = coerceBooleanProperty(value);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetListDescriptionDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetListDescriptionDirective, selector: "cnet-list-description, [cnet-list-description], [cnetListDescription]", inputs: { ellipsis: "ellipsis" }, host: { properties: { "class.cnet-list-ellipsis": "ellipsis" }, classAttribute: "cnet-list-description" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetListDescriptionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-list-description, [cnet-list-description], [cnetListDescription]',
                    host: {
                        class: 'cnet-list-description',
                        '[class.cnet-list-ellipsis]': 'ellipsis'
                    }
                }]
        }], propDecorators: { ellipsis: [{
                type: Input
            }] } });
class CnetListItemComponent {
    get disableRipple() { return this._disableRipple; }
    set disableRipple(value) {
        this._disableRipple = coerceBooleanProperty(value);
    }
    get disableHover() { return this._disableHover; }
    set disableHover(value) {
        this._disableHover = coerceBooleanProperty(value);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetListItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetListItemComponent, selector: "cnet-list-item, [cnet-list-item], cnetListItem", inputs: { disableRipple: ["disable-ripple", "disableRipple"], disableHover: ["disable-hover", "disableHover"] }, host: { properties: { "class.disabled-ripple": "disableRipple", "class.disable-hover": "disableHover" }, classAttribute: "cnet-list-item" }, exportAs: ["cnetListItem"], ngImport: i0, template: "<div class=\"cnet-list-container\" cnetRipple [cnetRippleDisabled]=\"disableRipple\" [class.disable-hover]=\"disableHover\">\n    <ng-content select=\"cnet-list-select, [cnet-list-select], [cnetListSelect]\"></ng-content>\n    <ng-content select=\"cnet-list-avatar, [cnet-list-avatar], [cnetListAvatar]\"></ng-content>\n\n    <div class=\"cnet-list-item-content\">\n        <div class=\"cnet-list-title\">\n            <ng-content select=\"[cnet-list-title], [cnet-list-title], [cnetListTitle]\"></ng-content>\n        </div>\n        <div class=\"cnet-list-content\">\n            <ng-content select=\"cnet-list-description, [cnet-list-description], [cnetListDescription]\"></ng-content>\n        </div>\n    </div>\n\n    <ng-content></ng-content>\n</div>\n", dependencies: [{ kind: "directive", type: CnetRippleDirective, selector: "[cnet-ripple], [cnetRipple]", inputs: ["cnetRippleColor", "cnetRippleUnbounded", "cnetRippleCentered", "cnetRippleRadius", "cnetRippleAnimation", "cnetRippleDisabled", "cnetRippleTrigger"], exportAs: ["cnetRipple"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetListItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-list-item, [cnet-list-item], cnetListItem', exportAs: 'cnetListItem', host: {
                        class: 'cnet-list-item',
                        '[class.disabled-ripple]': 'disableRipple',
                        '[class.disable-hover]': 'disableHover'
                    }, encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"cnet-list-container\" cnetRipple [cnetRippleDisabled]=\"disableRipple\" [class.disable-hover]=\"disableHover\">\n    <ng-content select=\"cnet-list-select, [cnet-list-select], [cnetListSelect]\"></ng-content>\n    <ng-content select=\"cnet-list-avatar, [cnet-list-avatar], [cnetListAvatar]\"></ng-content>\n\n    <div class=\"cnet-list-item-content\">\n        <div class=\"cnet-list-title\">\n            <ng-content select=\"[cnet-list-title], [cnet-list-title], [cnetListTitle]\"></ng-content>\n        </div>\n        <div class=\"cnet-list-content\">\n            <ng-content select=\"cnet-list-description, [cnet-list-description], [cnetListDescription]\"></ng-content>\n        </div>\n    </div>\n\n    <ng-content></ng-content>\n</div>\n" }]
        }], propDecorators: { disableRipple: [{
                type: Input,
                args: ['disable-ripple']
            }], disableHover: [{
                type: Input,
                args: ['disable-hover']
            }] } });

class FileDropZoneDirective {
    constructor() {
        this.disabled = false;
        this.onFileDropped = new EventEmitter();
        this.opacity = '1';
        this.fileDropedClass = false;
    }
    onDragOver(evt) {
        if (!this.disabled) {
            evt.preventDefault();
            evt.stopPropagation();
            this.opacity = '0.8';
            this.fileDropedClass = true;
        }
    }
    onDragLeave(evt) {
        if (!this.disabled) {
            evt.preventDefault();
            evt.stopPropagation();
            this.opacity = '1';
            this.fileDropedClass = false;
        }
    }
    ondrop(evt) {
        if (!this.disabled) {
            evt.preventDefault();
            evt.stopPropagation();
            this.opacity = '1';
            this.fileDropedClass = false;
            const files = evt.dataTransfer.files;
            if (files.length > 0) {
                this.onFileDropped.emit(files);
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileDropZoneDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: FileDropZoneDirective, selector: "[cnetFileDropZone]", inputs: { disabled: "disabled" }, outputs: { onFileDropped: "onFileDropped" }, host: { listeners: { "dragover": "onDragOver($event)", "dragleave": "onDragLeave($event)", "drop": "ondrop($event)" }, properties: { "style.opacity": "this.opacity", "class.file-droped": "this.fileDropedClass" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileDropZoneDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetFileDropZone]'
                }]
        }], propDecorators: { disabled: [{
                type: Input
            }], onFileDropped: [{
                type: Output
            }], opacity: [{
                type: HostBinding,
                args: ['style.opacity']
            }], fileDropedClass: [{
                type: HostBinding,
                args: ['class.file-droped']
            }], onDragOver: [{
                type: HostListener,
                args: ['dragover', ['$event']]
            }], onDragLeave: [{
                type: HostListener,
                args: ['dragleave', ['$event']]
            }], ondrop: [{
                type: HostListener,
                args: ['drop', ['$event']]
            }] } });

const FILEUPLOADER_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CnetFileUploadComponent),
    multi: true
};
class CnetFileUploadComponent {
    /** @ignore */
    onChange() {
        this.onChangeFn(this.value);
    }
    /**
       * Value for the file upload
       *
       * @readonly
       * type {boolean}
       * @memberof CnetFileUploadComponent
       */
    get value() { return this._value; }
    set value(value) {
        if (value || value?.length) {
            this._value = value instanceof Array ? value : [value];
            // this.allFiles = this.value.map(val => new CnetFile(val, val,this.attachmentUri, null));
            this.allFiles = this.value;
        }
        else {
            this._value = [];
        }
        this.onChange();
        this.onTouchedFn();
    }
    constructor(host, fileUploadService) {
        this.host = host;
        this.fileUploadService = fileUploadService;
        this.file = null;
        this.allFiles = [];
        this.multiple = false;
        this.maxFileSize = 15;
        this.attachmentUri = '';
        this.accept = '*';
        this.sizeFileErrorMessage = 'Cada arquivo inserido deve ser menor que {size}mb';
        this.typeFileErrorMessage = 'Tipo de arquivo inválido';
        this.multipleFilesErrorMessage = 'Não é possível anexar mais do que um único arquivo.';
        this.pickFileButtonLabel = 'escolha um arquivo...';
        this.dropFileLabel = 'Arraste um arquivo aqui';
        this.noFilesLabel = 'Nenhum arquivo anexado.';
        this.deleteFileButtonLabel = 'Excluir';
        this.visualizeFileButtonLabel = 'Visualizar';
        this.showVisualizeBtn = true;
        this.onUpload = new EventEmitter();
        this.onRemoveFile = new EventEmitter();
        this.disabled = false;
        this.multipleFilesError = false;
        this.sizeFileError = false;
        this.typeFileError = false;
        /** @ignore */
        this.onChangeFn = (_) => { };
        /** @ignore */
        this.onTouchedFn = () => { };
        /** @ignore */ this._value = [];
    }
    ngOnInit() {
    }
    clickForUpload() {
        this.fileInput.nativeElement.value = '';
        this.fileInput.nativeElement.click();
    }
    writeValue(value) {
        if (!value) {
            this.host.nativeElement.value = '';
            this.allFiles = [];
        }
        this.value = value;
    }
    /**
     * Registers a callback function is called by the forms API on functions disable and enable.
     *
     * param {*} fn
     * @memberof CnetFileUploadComponent
     */
    setDisabledState(idDisabled) {
        this.disabled = idDisabled;
    }
    /**
     * Registers a callback function that is called when the control's value changes in the UI.
     *
     * param {*} fn
     * @memberof CnetFileUploadComponent
     */
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    registerOnTouched(fn) {
    }
    updateValue() {
        this.value = this.allFiles;
    }
    droppedFiles(allFiles) {
        const filesArray = Array.from(allFiles);
        this.sizeFileError = false;
        this.typeFileError = false;
        this.multipleFilesError = false;
        if (!this.multiple) {
            this.removeFiles();
        }
        this.veryfyIfHasFileWithDifferentType(filesArray);
        if (!this.typeFileError) {
            this.veryfyIfHasFileBiggerThanMaxFileSize(filesArray);
            if (!this.sizeFileError) {
                this.verifyIfHasMultipleFiles(filesArray);
            }
        }
    }
    veryfyIfHasFileBiggerThanMaxFileSize(filesArray) {
        this.sizeFileError = filesArray.some(file => file.size > (this.maxFileSize * 1048576));
    }
    veryfyIfHasFileWithDifferentType(filesArray) {
        if (this.accept === '*') {
            this.typeFileError = false;
        }
        else {
            this.typeFileError = filesArray.some(file => !this.verifyAccept(file.type));
        }
    }
    verifyAccept(type) {
        let typeRegex = new RegExp(this.accept.replace(/\*/g, '.\*').replace(/\,/g, '|'));
        return typeRegex.test(type);
    }
    verifyIfHasMultipleFiles(filesArray) {
        if (this.multiple) {
            this.upload(filesArray);
        }
        else {
            if (filesArray.length > 1 || this.allFiles.length > 0) {
                this.multipleFilesError = true;
            }
            else {
                this.upload(filesArray);
            }
        }
    }
    upload(filesArray) {
        this.multipleFilesError = false;
        filesArray.forEach(file => {
            this.allFiles.push(new CnetFile$1(file.name, '', '', file));
        });
        this.updateValue();
        this.onUpload.emit(filesArray);
    }
    onFileChanged(event) {
        if (!this.disabled) {
            const files = event.target.files;
            if (files.length > 0) {
                this.droppedFiles(files);
            }
        }
    }
    removeFiles() {
        this.allFiles.forEach((file, index) => this.removeFile(index));
    }
    removeFile(i) {
        if (!this.disabled) {
            this.onRemoveFile.emit(this.allFiles[i]);
            this.allFiles.splice(i, 1);
            this.updateValue();
        }
    }
    visualizeFile(i) {
        if (!this.disabled) {
            if (this.allFiles[i].attachmentUri) {
                window.open(this.allFiles[i].attachmentUri, '_blank').focus();
            }
            else {
                const fileURL = URL.createObjectURL(this.allFiles[i].file);
                window.open(fileURL);
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFileUploadComponent, deps: [{ token: i0.ElementRef }, { token: FileUploadService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetFileUploadComponent, selector: "cnet-file-upload", inputs: { progress: "progress", multiple: "multiple", maxFileSize: "maxFileSize", attachmentUri: "attachmentUri", accept: "accept", sizeFileErrorMessage: "sizeFileErrorMessage", typeFileErrorMessage: "typeFileErrorMessage", multipleFilesErrorMessage: "multipleFilesErrorMessage", pickFileButtonLabel: "pickFileButtonLabel", dropFileLabel: "dropFileLabel", noFilesLabel: "noFilesLabel", deleteFileButtonLabel: "deleteFileButtonLabel", visualizeFileButtonLabel: "visualizeFileButtonLabel", showVisualizeBtn: "showVisualizeBtn", value: "value" }, outputs: { onUpload: "onUpload", onRemoveFile: "onRemoveFile" }, providers: [FILEUPLOADER_VALUE_ACCESSOR], viewQueries: [{ propertyName: "fileInput", first: true, predicate: ["fileInput"], descendants: true }], ngImport: i0, template: "<input type=\"file\" (change)=\"onFileChanged($event)\" [accept]=\"accept\"  #fileInput>\n<cnet-card>\n  <header cnet-card-header class=\"dropzone file-not-droped\" cnetFileDropZone (onFileDropped)=\"droppedFiles($event)\"\n    [disabled]=\"disabled\" (click)=\"!disabled && clickForUpload()\" [class.card-disabled]=\"disabled\">\n    <div cnet-card-title class=\"file-upload-header\">\n      <button cnet-filled-button size=\"small\" color=\"primary\"> {{ pickFileButtonLabel | translate}} </button>\n      <label>{{dropFileLabel | translate}}</label>\n    </div>\n  </header>\n\n  <cnet-card-content class=\"cnet-card-content\">\n\n    <ng-container *ngIf=\"!(value && value.length); else elseTemplate\">\n      <label>{{noFilesLabel | translate}}</label>\n    </ng-container>\n\n    <ng-template #elseTemplate>\n\n      <cnet-list class=\"file-list\">\n        <cnet-list-item *ngFor=\"let file; let i = index of allFiles\">\n          <h3 cnet-list-title [ellipsis]=\"false\">{{file.name}}</h3>\n          <div class=\"btns-action\">\n            <button cnet-button size=\"small\" color=\"cancel\" (click)=\"visualizeFile(i)\" *ngIf=\"showVisualizeBtn\">\n              <cnet-icon [size]=\"2\" [id]=\"'btn'+file.name+'visualize'\" style=\"padding-right: 4px;\" name=\"eye\"\n                label=\"eye\">\n              </cnet-icon>\n              <ng-container *ngIf=\"visualizeFileButtonLabel\">\n                {{ visualizeFileButtonLabel | translate}}\n              </ng-container>\n            </button>\n            <button cnet-button size=\"small\" color=\"cancel\" (click)=\"removeFile(i)\">\n              <cnet-icon [size]=\"2\" [id]=\"'btn'+file.name+'remove'\" style=\"padding-right: 4px;\" name=\"trash\"\n                label=\"trash\">\n              </cnet-icon>\n              <ng-container *ngIf=\"deleteFileButtonLabel\">\n                {{ deleteFileButtonLabel | translate}}\n              </ng-container>\n            </button>\n          </div>\n          <!-- <app-progress [progress]=\"progress\"></app-progress> -->\n        </cnet-list-item>\n      </cnet-list>\n\n    </ng-template>\n\n  </cnet-card-content>\n</cnet-card>\n\n<div *ngIf=\"multipleFilesError\" class=\"cnet-error\">\n  {{multipleFilesErrorMessage | translate}}\n</div>\n<div *ngIf=\"sizeFileError\" class=\"cnet-error\">\n    {{ sizeFileErrorMessage | translate:{size: maxFileSize } }}\n</div>\n<div *ngIf=\"typeFileError\" class=\"cnet-error\">\n    {{ typeFileErrorMessage | translate }}\n</div>\n", styles: [".card-disabled .file-upload-header{opacity:.7}.cnet-card-header{padding:.5rem .75rem!important;border:2px solid var(--cnet--300, #e0e0e0)!important}.dropzone{background-color:var(--cnet--100, #f5f5f5)}::ng-deep .file-list .card-disabled .cnet-list-container{opacity:.7}::ng-deep .file-list .cnet-list-container{display:flex;flex-wrap:wrap;flex-direction:row;align-content:center;justify-content:space-between;align-items:center;width:100%;padding:0!important}h3{padding:.5rem}.btns-action button{margin:2px;padding:.5rem}.file-upload-header{display:flex;justify-content:space-between;align-content:center;align-items:center;flex-wrap:wrap}input{display:none}.file-droped{border:dashed 2px var(--cnet-primary-800, #65ab36)!important}.cnet-error{color:var(--cnet-danger-500, #ee4446);display:block;font-size:.8rem}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CnetListComponent, selector: "cnet-list, [cnet-list], cnetList", exportAs: ["cnetList"] }, { kind: "component", type: CnetListItemComponent, selector: "cnet-list-item, [cnet-list-item], cnetListItem", inputs: ["disable-ripple", "disable-hover"], exportAs: ["cnetListItem"] }, { kind: "directive", type: CnetListTitleDirective, selector: "cnet-list-title, [cnet-list-title], [cnetListTitle]", inputs: ["ellipsis"] }, { kind: "component", type: CnetCardComponent, selector: "cnet-card", exportAs: ["cnetCard"] }, { kind: "component", type: CardHeaderComponent, selector: "cnet-card-header, [cnet-card-header], [cnetCardHeader]", exportAs: ["cnetCardHeader"] }, { kind: "directive", type: CnetCardTitleDirective, selector: "cnet-card-title, [cnet-card-title], [cnetCardTitle]" }, { kind: "directive", type: CnetCardContentDirective, selector: "cnet-card-content, [cnet-card-content], [cnetCardContent]" }, { kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "directive", type: FileDropZoneDirective, selector: "[cnetFileDropZone]", inputs: ["disabled"], outputs: ["onFileDropped"] }, { kind: "pipe", type: i1$3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFileUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-file-upload', providers: [FILEUPLOADER_VALUE_ACCESSOR], template: "<input type=\"file\" (change)=\"onFileChanged($event)\" [accept]=\"accept\"  #fileInput>\n<cnet-card>\n  <header cnet-card-header class=\"dropzone file-not-droped\" cnetFileDropZone (onFileDropped)=\"droppedFiles($event)\"\n    [disabled]=\"disabled\" (click)=\"!disabled && clickForUpload()\" [class.card-disabled]=\"disabled\">\n    <div cnet-card-title class=\"file-upload-header\">\n      <button cnet-filled-button size=\"small\" color=\"primary\"> {{ pickFileButtonLabel | translate}} </button>\n      <label>{{dropFileLabel | translate}}</label>\n    </div>\n  </header>\n\n  <cnet-card-content class=\"cnet-card-content\">\n\n    <ng-container *ngIf=\"!(value && value.length); else elseTemplate\">\n      <label>{{noFilesLabel | translate}}</label>\n    </ng-container>\n\n    <ng-template #elseTemplate>\n\n      <cnet-list class=\"file-list\">\n        <cnet-list-item *ngFor=\"let file; let i = index of allFiles\">\n          <h3 cnet-list-title [ellipsis]=\"false\">{{file.name}}</h3>\n          <div class=\"btns-action\">\n            <button cnet-button size=\"small\" color=\"cancel\" (click)=\"visualizeFile(i)\" *ngIf=\"showVisualizeBtn\">\n              <cnet-icon [size]=\"2\" [id]=\"'btn'+file.name+'visualize'\" style=\"padding-right: 4px;\" name=\"eye\"\n                label=\"eye\">\n              </cnet-icon>\n              <ng-container *ngIf=\"visualizeFileButtonLabel\">\n                {{ visualizeFileButtonLabel | translate}}\n              </ng-container>\n            </button>\n            <button cnet-button size=\"small\" color=\"cancel\" (click)=\"removeFile(i)\">\n              <cnet-icon [size]=\"2\" [id]=\"'btn'+file.name+'remove'\" style=\"padding-right: 4px;\" name=\"trash\"\n                label=\"trash\">\n              </cnet-icon>\n              <ng-container *ngIf=\"deleteFileButtonLabel\">\n                {{ deleteFileButtonLabel | translate}}\n              </ng-container>\n            </button>\n          </div>\n          <!-- <app-progress [progress]=\"progress\"></app-progress> -->\n        </cnet-list-item>\n      </cnet-list>\n\n    </ng-template>\n\n  </cnet-card-content>\n</cnet-card>\n\n<div *ngIf=\"multipleFilesError\" class=\"cnet-error\">\n  {{multipleFilesErrorMessage | translate}}\n</div>\n<div *ngIf=\"sizeFileError\" class=\"cnet-error\">\n    {{ sizeFileErrorMessage | translate:{size: maxFileSize } }}\n</div>\n<div *ngIf=\"typeFileError\" class=\"cnet-error\">\n    {{ typeFileErrorMessage | translate }}\n</div>\n", styles: [".card-disabled .file-upload-header{opacity:.7}.cnet-card-header{padding:.5rem .75rem!important;border:2px solid var(--cnet--300, #e0e0e0)!important}.dropzone{background-color:var(--cnet--100, #f5f5f5)}::ng-deep .file-list .card-disabled .cnet-list-container{opacity:.7}::ng-deep .file-list .cnet-list-container{display:flex;flex-wrap:wrap;flex-direction:row;align-content:center;justify-content:space-between;align-items:center;width:100%;padding:0!important}h3{padding:.5rem}.btns-action button{margin:2px;padding:.5rem}.file-upload-header{display:flex;justify-content:space-between;align-content:center;align-items:center;flex-wrap:wrap}input{display:none}.file-droped{border:dashed 2px var(--cnet-primary-800, #65ab36)!important}.cnet-error{color:var(--cnet-danger-500, #ee4446);display:block;font-size:.8rem}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: FileUploadService }], propDecorators: { progress: [{
                type: Input
            }], multiple: [{
                type: Input
            }], maxFileSize: [{
                type: Input
            }], attachmentUri: [{
                type: Input
            }], accept: [{
                type: Input
            }], sizeFileErrorMessage: [{
                type: Input
            }], typeFileErrorMessage: [{
                type: Input
            }], multipleFilesErrorMessage: [{
                type: Input
            }], pickFileButtonLabel: [{
                type: Input
            }], dropFileLabel: [{
                type: Input
            }], noFilesLabel: [{
                type: Input
            }], deleteFileButtonLabel: [{
                type: Input
            }], visualizeFileButtonLabel: [{
                type: Input
            }], showVisualizeBtn: [{
                type: Input
            }], onUpload: [{
                type: Output
            }], onRemoveFile: [{
                type: Output
            }], fileInput: [{
                type: ViewChild,
                args: ['fileInput']
            }], value: [{
                type: Input
            }] } });

class CnetListModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetListModule, declarations: [CnetListComponent,
            CnetListItemComponent,
            CnetListAvatarDirective,
            CnetListTitleDirective,
            CnetListDescriptionDirective], imports: [CommonModule,
            CnetRippleModule], exports: [CnetListComponent,
            CnetListItemComponent,
            CnetListAvatarDirective,
            CnetListTitleDirective,
            CnetListDescriptionDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetListModule, imports: [CommonModule,
            CnetRippleModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetListModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnetListComponent,
                        CnetListItemComponent,
                        CnetListAvatarDirective,
                        CnetListTitleDirective,
                        CnetListDescriptionDirective
                    ],
                    imports: [
                        CommonModule,
                        CnetRippleModule
                    ],
                    exports: [
                        CnetListComponent,
                        CnetListItemComponent,
                        CnetListAvatarDirective,
                        CnetListTitleDirective,
                        CnetListDescriptionDirective
                    ]
                }]
        }] });

class CnetFileUploadModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFileUploadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetFileUploadModule, declarations: [CnetFileUploadComponent, FileDropZoneDirective], imports: [CommonModule,
            CnetListModule,
            CnetDividerModule,
            CnetCardModule,
            CnetButtonModule,
            TranslateModule,
            CnetIconModule,
            CnetFormFieldModule], exports: [CnetFileUploadComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFileUploadModule, imports: [CommonModule,
            CnetListModule,
            CnetDividerModule,
            CnetCardModule,
            CnetButtonModule,
            TranslateModule,
            CnetIconModule,
            CnetFormFieldModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFileUploadModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetFileUploadComponent, FileDropZoneDirective],
                    imports: [
                        CommonModule,
                        CnetListModule,
                        CnetDividerModule,
                        CnetCardModule,
                        CnetButtonModule,
                        TranslateModule,
                        CnetIconModule,
                        CnetFormFieldModule
                    ],
                    exports: [CnetFileUploadComponent],
                }]
        }] });

/**
 * Directive to create trigger elements to open the cnet-menu
 *
 * @export
 * class CnetMenuTriggerDirective
 */
class CnetMenuTriggerDirective {
    /**
     * The cnet-menu instance
     *
     * type {CnetMenuComponent}
     * @memberof CnetMenuTriggerDirective
     */
    get menu() { return this.menu; }
    set menu(value) {
        this._menu = value;
    }
    constructor(_element) {
        this._element = _element;
    }
    /**
     * Creates the cnet-menu panel connected to this element
     *
     * @memberof CnetMenuTriggerDirective
     */
    showMenu() {
        this._menu.show(this._element);
    }
    onResize(event) {
        this._menu.hide();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetMenuTriggerDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetMenuTriggerDirective, selector: "[CnetMenuTrigger], [cnet-menu-trigger]", inputs: { menu: ["cnet-menu-trigger", "menu"] }, host: { listeners: { "click": "showMenu()", "window:resize": "onResize($event)" } }, exportAs: ["cnetMenuTrigger"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetMenuTriggerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[CnetMenuTrigger], [cnet-menu-trigger]',
                    exportAs: 'cnetMenuTrigger'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { menu: [{
                type: Input,
                args: ['cnet-menu-trigger']
            }], showMenu: [{
                type: HostListener,
                args: ['click']
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });

/**
 * An item of Cnet Menu Component
 *
 * @export
 * class CnetMenuItemComponent
 */
class CnetMenuItemComponent {
    constructor(elementRef, _focusMonitor) {
        this.elementRef = elementRef;
        this._focusMonitor = _focusMonitor;
        /** @ignore */ this.keyStream = new Subject();
        this._focusMonitor.monitor(this.elementRef, true);
    }
    get disabled() { return this._disabled; }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
        if (value) {
            this.elementRef.nativeElement.disabled = true;
        }
    }
    /** @ignore */
    onKeydown(event) {
        if (event.keyCode == DOWN_ARROW || event.keyCode == UP_ARROW || event.keyCode == ESCAPE
            || event.keyCode == LEFT_ARROW || event.keyCode == RIGHT_ARROW) {
            event.preventDefault();
            event.stopPropagation();
            this.keyStream.next(event.keyCode);
        }
    }
    /** @ignore */
    showMenu(event) {
        this.keyStream.next('CLICK');
    }
    /** @ignore */
    getHostElement() {
        return this.elementRef.nativeElement;
    }
    /** @ignore */
    ngOnDestroy() {
        this.keyStream.complete();
        this._focusMonitor.stopMonitoring(this.elementRef);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetMenuItemComponent, deps: [{ token: i0.ElementRef }, { token: i1$2.FocusMonitor }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetMenuItemComponent, selector: "cnet-menu-item, [CnetMenuItem], [cnet-menu-item]", inputs: { disabled: "disabled" }, host: { attributes: { "role": "button", "tabindex": "0" }, listeners: { "keydown": "onKeydown($event)", "click": "showMenu($event)" }, classAttribute: "cnet-menu-item" }, exportAs: ["cnetMenuItem"], ngImport: i0, template: "<ng-content></ng-content>\n<div class=\"cnet-menu-item-ripple\"\n  cnetRipple\n  [cnetRippleTrigger]=\"getHostElement()\"\n  [cnetRippleDisabled]=\"disabled\"\n  [attr.disabled]=\"true\">\n</div>\n", dependencies: [{ kind: "directive", type: CnetRippleDirective, selector: "[cnet-ripple], [cnetRipple]", inputs: ["cnetRippleColor", "cnetRippleUnbounded", "cnetRippleCentered", "cnetRippleRadius", "cnetRippleAnimation", "cnetRippleDisabled", "cnetRippleTrigger"], exportAs: ["cnetRipple"] }], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetMenuItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-menu-item, [CnetMenuItem], [cnet-menu-item]', exportAs: 'cnetMenuItem', host: {
                        class: 'cnet-menu-item',
                        role: 'button',
                        'tabindex': '0'
                    }, encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.Default, template: "<ng-content></ng-content>\n<div class=\"cnet-menu-item-ripple\"\n  cnetRipple\n  [cnetRippleTrigger]=\"getHostElement()\"\n  [cnetRippleDisabled]=\"disabled\"\n  [attr.disabled]=\"true\">\n</div>\n" }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$2.FocusMonitor }], propDecorators: { disabled: [{
                type: Input
            }], onKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], showMenu: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

const menuAnimation = trigger('menuAnimation', [
    state('default', style({ transform: 'translateY(0)', opacity: 1 })),
    state('hide', style({ opacity: 0 })),
    state('hideBottomSheet', style({ transform: 'translateY(100%)', opacity: 0 })),
    transition('show => hide', animate('200ms ease-out')),
    transition('showBottomSheet => hideBottomSheet', animate('200ms ease-out')),
    transition('void => showBottomSheet', [style({ transform: 'translateY(100%)' }), animate('200ms')]),
    transition('void => show', [style({ opacity: 0 }), animate('200ms')]),
]);

/** The Cnet Menu Component is used to create a panel containing a list of options */
class CnetMenuComponent {
    /** The cnet-menu instance */
    get bottomSheet() { return this._bottomSheet; }
    set bottomSheet(value) {
        this._bottomSheet = coerceBooleanProperty(value);
    }
    /** The cnet-menu instance */
    get isOverlay() { return this._isOverlay; }
    set isOverlay(value) {
        this._isOverlay = coerceBooleanProperty(value);
    }
    /** The cnet-menu instance */
    get removeOnScroll() { return this._removeOnScroll; }
    set removeOnScroll(value) {
        this._removeOnScroll = coerceBooleanProperty(value);
    }
    constructor(overlay, _focusMonitor, elementRef) {
        this.overlay = overlay;
        this._focusMonitor = _focusMonitor;
        this.elementRef = elementRef;
        /** Stream that emits the visibility of the menu. */
        this.visible = new BehaviorSubject(false);
        this._removeOnScroll = false;
        this.isMobile = false;
        this.markedBootonByUser = false;
        this.markedOverlayByUser = false;
    }
    ngOnInit() {
        this.markedBootonByUser = this.bottomSheet;
        this.markedOverlayByUser = this.isOverlay;
        this.resolveResize(window.innerWidth);
    }
    /** Show the cnet-metnu panel */
    show(element) {
        if (!this.bottomSheet) {
            this._overlayRef = this.overlay.create(this.getMenuOverlayConfig(element));
            this.animationState = 'show';
        }
        else {
            this._overlayRef = this.overlay.create(this.geBottomSheetOverlayConfig());
            this.animationState = 'showBottomSheet';
        }
        this._overlayRef.attach(this._contentTemplate);
        this._overlayRef.backdropClick().subscribe(() => this.hide());
        this.visible.next(true);
        this._items.map((item, index) => {
            this._itemKeySubscription = new Subscription();
            this._itemKeySubscription.add(item.keyStream.subscribe(key => {
                switch (key) {
                    case RIGHT_ARROW:
                    case DOWN_ARROW:
                        if (this._items.length > index + 1) {
                            this._focusedItem = this._items.toArray()[index + 1];
                        }
                        else {
                            this._focusedItem = this._items.first;
                        }
                        this._focusMonitor.focusVia(this._focusedItem.elementRef, 'keyboard');
                        break;
                    case LEFT_ARROW:
                    case UP_ARROW:
                        if (index > 0) {
                            this._focusedItem = this._items.toArray()[index - 1];
                        }
                        else {
                            this._focusedItem = this._items.last;
                        }
                        this._focusMonitor.focusVia(this._focusedItem.elementRef, 'keyboard');
                        break;
                    case ESCAPE:
                        this.hide();
                        break;
                    case 'CLICK':
                        this.hide();
                        break;
                }
            }));
        });
        if (this._items.first) {
            this._focusMonitor.focusVia(this._items.first.elementRef, 'program');
        }
    }
    /** Hide the cnet-metnu panel */
    hide() {
        if (this.visible.getValue()) {
            this.visible.next(false);
            if (!this.bottomSheet) {
                this.animationState = 'hide';
            }
            else {
                this.animationState = 'hideBottomSheet';
            }
            if (this._itemKeySubscription) {
                this._itemKeySubscription.unsubscribe();
            }
        }
    }
    /** @ignore */
    _onAnimationDone(event) {
        if (event.fromState === 'show' && event.toState === 'hide'
            || event.fromState === 'showBottomSheet' && event.toState === 'hideBottomSheet') {
            this._overlayRef.detach();
        }
    }
    /** @ignore */
    getMenuOverlayConfig(element) {
        const positionStrategy = this.overlay.position()
            .flexibleConnectedTo(element)
            .withPush(false)
            .withPositions([{
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top'
            }, {
                originX: 'end',
                originY: 'bottom',
                overlayX: 'end',
                overlayY: 'top'
            }, {
                originX: 'end',
                originY: 'top',
                overlayX: 'end',
                overlayY: 'bottom'
            },
            {
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'bottom'
            }]);
        const scrollStrategy = this.removeOnScroll ? this.overlay.scrollStrategies.close() : this.overlay.scrollStrategies.reposition();
        return new OverlayConfig({
            positionStrategy,
            scrollStrategy,
            hasBackdrop: true,
            backdropClass: 'cdk-overlay-transparent-backdrop'
        });
    }
    /** @ignore */
    geBottomSheetOverlayConfig() {
        const positionStrategy = this.overlay.position()
            .global()
            .centerHorizontally()
            .bottom();
        const scrollStrategy = this.removeOnScroll ? this.overlay.scrollStrategies.close() : this.overlay.scrollStrategies.reposition();
        return new OverlayConfig({
            positionStrategy,
            scrollStrategy,
            hasBackdrop: true,
            backdropClass: 'cdk-overlay-backdrop'
        });
    }
    /** @ignore */
    ngOnDestroy() {
        if (this._itemKeySubscription) {
            this._itemKeySubscription.unsubscribe();
        }
        this._focusMonitor.stopMonitoring(this.elementRef);
    }
    resolveResize(innerWidth) {
        if (!this.markedBootonByUser && !this.markedOverlayByUser) {
            if (innerWidth <= 992) {
                this.isMobile = true;
            }
            else {
                this.isMobile = false;
            }
            this.bottomSheet = this.isMobile;
        }
    }
    onResize(event) {
        this.resolveResize(event.target.innerWidth);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetMenuComponent, deps: [{ token: i1$5.Overlay }, { token: i1$2.FocusMonitor }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetMenuComponent, selector: "cnet-menu", inputs: { bottomSheet: ["cnet-bottom-sheet", "bottomSheet"], isOverlay: ["cnet-overlay", "isOverlay"], removeOnScroll: ["cnet-remove-on-scroll", "removeOnScroll"] }, host: { listeners: { "window:resize": "onResize($event)" } }, queries: [{ propertyName: "_items", predicate: CnetMenuItemComponent }], viewQueries: [{ propertyName: "_contentTemplate", first: true, predicate: CdkPortal, descendants: true }], exportAs: ["cnetMenu"], ngImport: i0, template: "<ng-template cdk-portal>\n    <div [ngClass]=\"{'cnet-menu-content': !bottomSheet, 'cnet-bottom-sheet-content': bottomSheet}\" #content\n        [@menuAnimation]=\"animationState\"\n        (@menuAnimation.done)=\"_onAnimationDone($event)\">\n        \n        <div cdkTrapFocus>\n            <ng-content></ng-content>\n        </div>\n    </div>\n</ng-template>", styles: [".cnet-menu-content,.cnet-bottom-sheet-content{display:flex;flex-direction:column;overflow:auto;background:#fff;-webkit-user-select:none;user-select:none}.cnet-menu-content{min-width:7.5rem;border-radius:.25rem;box-shadow:0 1px 4px -1px #0000001a,0 4px 5px #0000001a;transform-origin:left top}.cnet-bottom-sheet-content{min-width:20rem;max-width:42.5rem;margin:0 auto;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.cnet-menu-item{display:block;width:100%;min-height:2.5rem;position:relative;text-transform:uppercase;padding:.75rem 1rem;overflow:hidden;background-color:transparent;border:0;color:#000000d9;font-size:.875rem;font-weight:400;text-align:inherit;white-space:normal;outline:none}.cnet-menu-item:hover:not(:disabled),.cnet-menu-item:focus:not(:disabled):not(.cdk-program-focused){cursor:pointer;background-color:#0000000a}.cnet-menu-item:disabled{color:#0000006b}.cnet-menu-item-ripple{content:\"\";position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none}.cnet-menu-item-description{display:block;font-size:.875rem;text-transform:none;color:#000000ab;white-space:normal}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i2.TemplatePortalDirective, selector: "[cdk-portal], [portal]", exportAs: ["cdkPortal"] }, { kind: "directive", type: i1$2.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }], animations: [menuAnimation], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetMenuComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-menu', exportAs: 'cnetMenu', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.Default, animations: [menuAnimation], template: "<ng-template cdk-portal>\n    <div [ngClass]=\"{'cnet-menu-content': !bottomSheet, 'cnet-bottom-sheet-content': bottomSheet}\" #content\n        [@menuAnimation]=\"animationState\"\n        (@menuAnimation.done)=\"_onAnimationDone($event)\">\n        \n        <div cdkTrapFocus>\n            <ng-content></ng-content>\n        </div>\n    </div>\n</ng-template>", styles: [".cnet-menu-content,.cnet-bottom-sheet-content{display:flex;flex-direction:column;overflow:auto;background:#fff;-webkit-user-select:none;user-select:none}.cnet-menu-content{min-width:7.5rem;border-radius:.25rem;box-shadow:0 1px 4px -1px #0000001a,0 4px 5px #0000001a;transform-origin:left top}.cnet-bottom-sheet-content{min-width:20rem;max-width:42.5rem;margin:0 auto;border-top-left-radius:.25rem;border-top-right-radius:.25rem}.cnet-menu-item{display:block;width:100%;min-height:2.5rem;position:relative;text-transform:uppercase;padding:.75rem 1rem;overflow:hidden;background-color:transparent;border:0;color:#000000d9;font-size:.875rem;font-weight:400;text-align:inherit;white-space:normal;outline:none}.cnet-menu-item:hover:not(:disabled),.cnet-menu-item:focus:not(:disabled):not(.cdk-program-focused){cursor:pointer;background-color:#0000000a}.cnet-menu-item:disabled{color:#0000006b}.cnet-menu-item-ripple{content:\"\";position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none}.cnet-menu-item-description{display:block;font-size:.875rem;text-transform:none;color:#000000ab;white-space:normal}\n"] }]
        }], ctorParameters: () => [{ type: i1$5.Overlay }, { type: i1$2.FocusMonitor }, { type: i0.ElementRef }], propDecorators: { _contentTemplate: [{
                type: ViewChild,
                args: [CdkPortal]
            }], _items: [{
                type: ContentChildren,
                args: [CnetMenuItemComponent]
            }], bottomSheet: [{
                type: Input,
                args: ['cnet-bottom-sheet']
            }], isOverlay: [{
                type: Input,
                args: ['cnet-overlay']
            }], removeOnScroll: [{
                type: Input,
                args: ['cnet-remove-on-scroll']
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });

class CnetMenuModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetMenuModule, declarations: [CnetMenuComponent,
            CnetMenuTriggerDirective,
            CnetMenuItemComponent], imports: [CommonModule,
            OverlayModule,
            PortalModule,
            CnetRippleModule,
            A11yModule], exports: [CnetMenuComponent,
            CnetMenuTriggerDirective,
            CnetMenuItemComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetMenuModule, imports: [CommonModule,
            OverlayModule,
            PortalModule,
            CnetRippleModule,
            A11yModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnetMenuComponent,
                        CnetMenuTriggerDirective,
                        CnetMenuItemComponent
                    ],
                    imports: [
                        CommonModule,
                        OverlayModule,
                        PortalModule,
                        CnetRippleModule,
                        A11yModule
                    ],
                    exports: [
                        CnetMenuComponent,
                        CnetMenuTriggerDirective,
                        CnetMenuItemComponent
                    ]
                }]
        }] });

var enumQuestionTypeCode;
(function (enumQuestionTypeCode) {
    enumQuestionTypeCode["Text"] = "Text";
    enumQuestionTypeCode["Descriptive"] = "Descriptive";
    enumQuestionTypeCode["SingleSelect"] = "SingleSelect";
    enumQuestionTypeCode["MultiSelect"] = "MultiSelect";
    enumQuestionTypeCode["Slider"] = "Slider";
    enumQuestionTypeCode["Attachment"] = "Attachment";
    enumQuestionTypeCode["Number"] = "Number";
    enumQuestionTypeCode["InputSwitch"] = "InputSwitch";
})(enumQuestionTypeCode || (enumQuestionTypeCode = {}));
var enumQuestionTypeCodeTranslate;
(function (enumQuestionTypeCodeTranslate) {
    enumQuestionTypeCodeTranslate["Texto"] = "Text";
    enumQuestionTypeCodeTranslate["Descritiva"] = "Descriptive";
    enumQuestionTypeCodeTranslate["Select Simples"] = "SingleSelect";
    enumQuestionTypeCodeTranslate["Select Multiplo"] = "MultiSelect";
    enumQuestionTypeCodeTranslate["Slider"] = "Slider";
    enumQuestionTypeCodeTranslate["Anexo"] = "Attachment";
    enumQuestionTypeCodeTranslate["Num\u00E9rico"] = "Number";
    enumQuestionTypeCodeTranslate["Input Switch"] = "InputSwitch";
})(enumQuestionTypeCodeTranslate || (enumQuestionTypeCodeTranslate = {}));
var enumQuestionTypeCodeTranslated;
(function (enumQuestionTypeCodeTranslated) {
    enumQuestionTypeCodeTranslated["Text"] = "Texto";
    enumQuestionTypeCodeTranslated["Descriptive"] = "Descritiva";
    enumQuestionTypeCodeTranslated["SingleSelect"] = "Select Simples";
    enumQuestionTypeCodeTranslated["MultiSelect"] = "Select Multiplo";
    enumQuestionTypeCodeTranslated["Slider"] = "Slider";
    enumQuestionTypeCodeTranslated["Attachment"] = "Anexo";
    enumQuestionTypeCodeTranslated["Number"] = "Num\u00E9rico";
    enumQuestionTypeCodeTranslated["InputSwitch"] = "Input Switch";
})(enumQuestionTypeCodeTranslated || (enumQuestionTypeCodeTranslated = {}));
function enumQuestionsTypeAsArray() {
    const internshipTypes = enumQuestionTypeCodeTranslate;
    return Object.keys(internshipTypes).map(type => { return { label: type, value: enumQuestionTypeCodeTranslate[type] }; });
}
function enumSpecificQuestionsTypeAsArray(value) {
    return value.map(type => { return { label: enumQuestionTypeCodeTranslated[type], value: type }; });
}

class CnetCreateUpdateQuestionComponent {
    constructor(formBuilder) {
        this.formBuilder = formBuilder;
        this.showQuestionsNumber = true;
        this.form = null;
        this.onDirty = new EventEmitter();
        this.submitQuestion = new EventEmitter();
        this.cancel = new EventEmitter();
        this.delete = new EventEmitter();
    }
    ngOnInit() {
        if (this.question) {
            if (this.question.questionTypeCode === enumQuestionTypeCode.SingleSelect
                || this.question.questionTypeCode === enumQuestionTypeCode.MultiSelect
                || this.question.questionTypeCode === enumQuestionTypeCode.Slider) {
                this.question.options = this.question.options.sort((a, b) => a.order - b.order);
            }
            this.createForm();
        }
        else {
            console.error('Não é possivel editar um question vazio');
        }
    }
    createForm() {
        this.form = null;
        this.form = this.formBuilder.group({
            code: ['',
                Validators.compose([
                    Validators.required
                ])],
            statement: ['',
                Validators.compose([
                    Validators.required
                ])],
            description: ['',
                Validators.compose([])],
            required: [false,
                Validators.compose([])],
            options: [[],
                Validators.compose([
                    Validators.required,
                    Validators.minLength(2)
                ])],
        });
        // TODO: conferir se sempre está vindo o code e o questionTypeCode
        this.form.patchValue(this.question);
        this.form.controls.options.disable();
        if (this.question.questionTypeCode === enumQuestionTypeCode.SingleSelect
            || this.question.questionTypeCode === enumQuestionTypeCode.MultiSelect
            || this.question.questionTypeCode === enumQuestionTypeCode.Slider) {
            const optionsListAux = this.question.options.sort((a, b) => a.order - b.order).map(op => { return { label: op.text, order: op.order }; });
            this.form.controls.options.enable();
            this.form.controls.options.setValue(optionsListAux);
        }
        this.form.valueChanges.subscribe(value => {
            // caso o usuário comece a digitar ele emite q está dirty
            this.onDirty.emit(this.form.dirty);
        });
    }
    onSubmit() {
        if (this.form.invalid) {
            this.checkFormValidations();
            return;
        }
        let questionAux = { ...this.question };
        questionAux.statement = this.form.value.statement;
        questionAux.description = this.form.value.description;
        questionAux.required = this.form.value.required;
        if (this.question.questionTypeCode === enumQuestionTypeCode.SingleSelect
            || this.question.questionTypeCode === enumQuestionTypeCode.MultiSelect
            || this.question.questionTypeCode === enumQuestionTypeCode.Slider) {
            questionAux.options = this.form.value.options.map(op => { return { text: op.label, order: op.order }; });
        }
        this.submitQuestion.emit(questionAux);
    }
    checkFormValidations() {
        this.form.markAllAsTouched();
        this.form.updateValueAndValidity();
        if (this.form.controls.options.enabled) {
            this.form.controls.options.updateValueAndValidity();
        }
    }
    onCancel() {
        this.cancel.emit(this.question.code);
    }
    deleteQuestion() {
        this.delete.emit(this.question.code);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCreateUpdateQuestionComponent, deps: [{ token: i1$4.UntypedFormBuilder }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetCreateUpdateQuestionComponent, selector: "cnet-create-update-question", inputs: { question: "question", showQuestionsNumber: "showQuestionsNumber" }, outputs: { onDirty: "onDirty", submitQuestion: "submitQuestion", cancel: "cancel", delete: "delete" }, ngImport: i0, template: "<!--  -->\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit()\" *ngIf=\"form\">\n\n  <cnet-card>\n    <header cnet-card-header>\n      <div cnet-card-actions>\n        <button cnet-button type=\"button\" aria-label=\"delete\" (click)=\"deleteQuestion()\">\n          <cnet-icon name=\"trash-alt\" label=\"delete\"></cnet-icon>\n          <div style=\"margin-top: 4px;\">\n            {{'Excluir' | translate}}\n          </div>\n        </button>\n      </div>\n    </header>\n\n    <cnet-card-content>\n\n      <cnet-form-field class=\"question-statement\">\n        <!-- <cnet-field-label cnetRequiredMark>{{'forms.question' | translate}}</cnet-field-label> -->\n        <!-- cnetRequiredMark -->\n        <cnet-field-label *ngIf=\"showQuestionsNumber\">{{question?.order }}.</cnet-field-label>\n        <input cnet-input id=\"statement\" formControlName=\"statement\" type=\"text\" style=\"width: 95%;\"\n          [placeholder]=\"'Digite a pergunta' | translate\" />\n        <!-- <textarea cnet-input id=\"statement\" formControlName=\"statement\" type=\"text\" style=\"width: 95%;\"\n          [placeholder]=\"'Digite a pergunta' | translate\" oninput='this.style.height = \"\";this.style.height = this.scrollHeight + \"px !important\"'>\n          </textarea> -->\n        <cnet-field-error>\n          <p>\n            <label class=\"errorMessage\" *ngIf=\"form.controls.statement.hasError('required')\">\n              {{'Este campo \u00E9 obrigat\u00F3rio.' | translate }} </label>\n          </p>\n        </cnet-field-error>\n      </cnet-form-field>\n\n      <cnet-form-field class=\"question-description\" [class.padding-left-24]=\"showQuestionsNumber\">\n        <!-- <cnet-field-label cnetRequiredMark>{{'Descri\u00E7\u00E3o' | translate}}</cnet-field-label> -->\n        <input cnet-input id=\"description\" formControlName=\"description\" type=\"text\"\n          [placeholder]=\"'Digite uma descri\u00E7\u00E3o' | translate\" />\n      </cnet-form-field>\n\n\n      <div *ngIf=\"form?.controls?.options?.enabled\" class=\"question-options\" [class.padding-left-28]=\"showQuestionsNumber\">\n        <cnet-dynamic-list formControlName=\"options\" type=\"radio\" id=\"options\" [allowDuplicatedValues]=\"false\">\n        </cnet-dynamic-list>\n      </div>\n\n\n      <cnet-form-field class=\"checkbox-control question-required\"  [class.padding-left-28]=\"showQuestionsNumber\">\n\n        <cnet-checkbox id=\"required\" formControlName=\"required\" id=\"checkbox\">{{'Campo obrigat\u00F3rio' | translate}}\n        </cnet-checkbox>\n\n      </cnet-form-field>\n    </cnet-card-content>\n\n    <footer cnet-card-footer>\n      <div cnet-card-actions class=\"form-buttons\">\n\n        <button type=\"button\" (click)=\"onCancel()\" cnet-filled-button color=\"cancel\" class=\"btn btn-cancel\"\n          size=\"small\">{{'Cancelar'| translate}}</button>\n\n        <button type=\"submit\" cnet-filled-button color=\"success\" class=\"btn btn-success\" size=\"small\">{{'Salvar'|\n          translate}}</button>\n      </div>\n\n    </footer>\n  </cnet-card>\n\n</form>\n", styles: ["cnet-card header{padding:.2rem 1rem}.errorMessage{color:var(--cnet-danger-500, #ee4446)}.question-required{width:40%;display:flex}cnet-field-label{font-size:1.125rem}.cnet-card .cnet-card-footer{border-top:1px solid #bdbdbd}.cnet-card{background:#fafafa}.cnet-card .cnet-card-header{border:none;border-top:5px solid var(--cnet-primary-500, #82c14f)}.padding-left-8{padding-left:8px}.checkbox-control ::ng-deep .cnet-form-field-wrap{border:none;background:transparent}.question-statement ::ng-deep .cnet-field-error-div{grid-column:2/3;align-self:center}.question-statement{width:100%;display:grid;grid-template-columns:0fr 1fr}.question-statement cnet-field-label{margin-right:8px}.padding-left-24{padding-left:24px}.question-description{width:100%;display:flex}.padding-left-28{padding-left:28px}.question-options{width:50%}.form-buttons{display:flex;justify-content:flex-end}@media (max-width: 992px){.question-description{padding-left:0}.question-options{padding-left:0;width:60%}.question-required{width:100%;padding-left:0}}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1$4.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "component", type: CnetFormFieldComponent, selector: "cnet-form-field", inputs: ["hasMoreThanOneControl", "showLabel"], exportAs: ["cnetButton"] }, { kind: "directive", type: CnetFieldErrorDirective, selector: "cnet-field-error, [cnetFieldError], [cnet-field-error]", inputs: ["id"] }, { kind: "directive", type: CnetFieldLabelDirective, selector: "cnet-field-label, [cnetFieldLabel], [cnet-field-label]" }, { kind: "component", type: CnetCardComponent, selector: "cnet-card", exportAs: ["cnetCard"] }, { kind: "component", type: CardHeaderComponent, selector: "cnet-card-header, [cnet-card-header], [cnetCardHeader]", exportAs: ["cnetCardHeader"] }, { kind: "directive", type: CnetCardContentDirective, selector: "cnet-card-content, [cnet-card-content], [cnetCardContent]" }, { kind: "directive", type: CnetCardActionsDirective, selector: "cnet-card-actions, [cnet-card-actions], [cnetCardActions]" }, { kind: "component", type: CnetCardFooterComponent, selector: "cnet-card-footer, [cnet-card-footer], [cnetCardFooter]", exportAs: ["cnetCardFooter"] }, { kind: "directive", type: CnetInputDirective, selector: "cnet-input, [CnetInput], [cnet-input]", inputs: ["id", "required", "disabled", "value", "focused", "errorState"] }, { kind: "component", type: CnetCheckboxComponent, selector: "cnet-checkbox", inputs: ["id", "name", "checked", "value", "disabled", "color", "enableRiple"], outputs: ["change", "blur", "focus"], exportAs: ["cnetCheckbox"] }, { kind: "component", type: CnetDynamicListComponent, selector: "cnet-dynamic-list", inputs: ["type", "allowDuplicatedValues", "value", "invalid"] }, { kind: "pipe", type: i1$3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCreateUpdateQuestionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-create-update-question', template: "<!--  -->\n<form [formGroup]=\"form\" (ngSubmit)=\"onSubmit()\" *ngIf=\"form\">\n\n  <cnet-card>\n    <header cnet-card-header>\n      <div cnet-card-actions>\n        <button cnet-button type=\"button\" aria-label=\"delete\" (click)=\"deleteQuestion()\">\n          <cnet-icon name=\"trash-alt\" label=\"delete\"></cnet-icon>\n          <div style=\"margin-top: 4px;\">\n            {{'Excluir' | translate}}\n          </div>\n        </button>\n      </div>\n    </header>\n\n    <cnet-card-content>\n\n      <cnet-form-field class=\"question-statement\">\n        <!-- <cnet-field-label cnetRequiredMark>{{'forms.question' | translate}}</cnet-field-label> -->\n        <!-- cnetRequiredMark -->\n        <cnet-field-label *ngIf=\"showQuestionsNumber\">{{question?.order }}.</cnet-field-label>\n        <input cnet-input id=\"statement\" formControlName=\"statement\" type=\"text\" style=\"width: 95%;\"\n          [placeholder]=\"'Digite a pergunta' | translate\" />\n        <!-- <textarea cnet-input id=\"statement\" formControlName=\"statement\" type=\"text\" style=\"width: 95%;\"\n          [placeholder]=\"'Digite a pergunta' | translate\" oninput='this.style.height = \"\";this.style.height = this.scrollHeight + \"px !important\"'>\n          </textarea> -->\n        <cnet-field-error>\n          <p>\n            <label class=\"errorMessage\" *ngIf=\"form.controls.statement.hasError('required')\">\n              {{'Este campo \u00E9 obrigat\u00F3rio.' | translate }} </label>\n          </p>\n        </cnet-field-error>\n      </cnet-form-field>\n\n      <cnet-form-field class=\"question-description\" [class.padding-left-24]=\"showQuestionsNumber\">\n        <!-- <cnet-field-label cnetRequiredMark>{{'Descri\u00E7\u00E3o' | translate}}</cnet-field-label> -->\n        <input cnet-input id=\"description\" formControlName=\"description\" type=\"text\"\n          [placeholder]=\"'Digite uma descri\u00E7\u00E3o' | translate\" />\n      </cnet-form-field>\n\n\n      <div *ngIf=\"form?.controls?.options?.enabled\" class=\"question-options\" [class.padding-left-28]=\"showQuestionsNumber\">\n        <cnet-dynamic-list formControlName=\"options\" type=\"radio\" id=\"options\" [allowDuplicatedValues]=\"false\">\n        </cnet-dynamic-list>\n      </div>\n\n\n      <cnet-form-field class=\"checkbox-control question-required\"  [class.padding-left-28]=\"showQuestionsNumber\">\n\n        <cnet-checkbox id=\"required\" formControlName=\"required\" id=\"checkbox\">{{'Campo obrigat\u00F3rio' | translate}}\n        </cnet-checkbox>\n\n      </cnet-form-field>\n    </cnet-card-content>\n\n    <footer cnet-card-footer>\n      <div cnet-card-actions class=\"form-buttons\">\n\n        <button type=\"button\" (click)=\"onCancel()\" cnet-filled-button color=\"cancel\" class=\"btn btn-cancel\"\n          size=\"small\">{{'Cancelar'| translate}}</button>\n\n        <button type=\"submit\" cnet-filled-button color=\"success\" class=\"btn btn-success\" size=\"small\">{{'Salvar'|\n          translate}}</button>\n      </div>\n\n    </footer>\n  </cnet-card>\n\n</form>\n", styles: ["cnet-card header{padding:.2rem 1rem}.errorMessage{color:var(--cnet-danger-500, #ee4446)}.question-required{width:40%;display:flex}cnet-field-label{font-size:1.125rem}.cnet-card .cnet-card-footer{border-top:1px solid #bdbdbd}.cnet-card{background:#fafafa}.cnet-card .cnet-card-header{border:none;border-top:5px solid var(--cnet-primary-500, #82c14f)}.padding-left-8{padding-left:8px}.checkbox-control ::ng-deep .cnet-form-field-wrap{border:none;background:transparent}.question-statement ::ng-deep .cnet-field-error-div{grid-column:2/3;align-self:center}.question-statement{width:100%;display:grid;grid-template-columns:0fr 1fr}.question-statement cnet-field-label{margin-right:8px}.padding-left-24{padding-left:24px}.question-description{width:100%;display:flex}.padding-left-28{padding-left:28px}.question-options{width:50%}.form-buttons{display:flex;justify-content:flex-end}@media (max-width: 992px){.question-description{padding-left:0}.question-options{padding-left:0;width:60%}.question-required{width:100%;padding-left:0}}\n"] }]
        }], ctorParameters: () => [{ type: i1$4.UntypedFormBuilder }], propDecorators: { question: [{
                type: Input
            }], showQuestionsNumber: [{
                type: Input
            }], onDirty: [{
                type: Output
            }], submitQuestion: [{
                type: Output
            }], cancel: [{
                type: Output
            }], delete: [{
                type: Output
            }] } });

var enumArrayOptionDefault;
(function (enumArrayOptionDefault) {
    enumArrayOptionDefault["text"] = "text";
    enumArrayOptionDefault["order"] = "order";
})(enumArrayOptionDefault || (enumArrayOptionDefault = {}));

let nextUniqueId$4 = 0;
/**
 * Directive for use inputs inside a form field
 *
 * @export
 * class CnetInputDirective
 */
class CnetInputForInputSwitchDirective {
    constructor(ngControl, elementRef) {
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        /** @ignore */ this._id = `cnet-input-switch-${nextUniqueId$4++}`;
        /** @ignore */ this._required = false;
        /** @ignore */ this._disabled = false;
        /** @ignore */ this._focused = false;
        /** @ignore */ this._errorState = false;
        /**
         * Emits whenever the state of the control changes
         *
         * type {Observable<void>}
         * @memberof CnetInputDirective
         */
        this.stateChanges = new Subject();
        this._valueAcessor = this.elementRef.nativeElement;
    }
    /**
    * The element ID for this control.
    *
    * type {string}
    * @memberof CnetInputDirective
    */
    get id() { return this._id; }
    set id(value) { this._id = value; }
    /**
     * Whether the control is required.
     *
     * type {boolean}
     * @memberof CnetInputDirective
     */
    get required() { return this._required; }
    set required(value) { this._required = coerceBooleanProperty(value); }
    /**
     * Whether the control is disabled.
     *
     * type {boolean}
     * @memberof CnetInputDirective
     */
    get disabled() {
        if (this.ngControl && this.ngControl.disabled !== null) {
            return this.ngControl.disabled;
        }
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
        if (this.focused) {
            this.focused = false;
            this.stateChanges.next();
        }
    }
    /**
     * The value of the control
     *
     * type {(T | null)}
     * @memberof CnetInputDirective
     */
    get value() { return this._valueAcessor.value; }
    set value(value) {
        if (value !== this._valueAcessor.value) {
            this._valueAcessor.value = value;
            this.stateChanges.next();
        }
    }
    /**
     * Whether the control is focused
     *
     * type {boolean}
     * @memberof CnetInputDirective
     */
    get focused() { return this._focused; }
    set focused(value) { this._focused = coerceBooleanProperty(value); }
    /**
     * Whether the control is in an error state.
     *
     * type {boolean}
     * @memberof CnetInputDirective
     */
    get errorState() { return this._errorState; }
    set errorState(value) { this._errorState = coerceBooleanProperty(value); }
    /**
     * Error id for aria-describedby
     *
     * @readonly
     * type {string}
     * @memberof CnetInputDirective
     */
    get describedby() {
        return this.error?.id || null;
    }
    /** @ignore */
    ngDoCheck() {
        if (this.ngControl) {
            this.errorState = this.ngControl.errors !== null && (!!this.ngControl.touched || this.ngControl.dirty);
        }
        this.stateChanges.next();
    }
    /** @ignore */
    changeFocus(focused) {
        this.focused = focused;
        this.stateChanges.next();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetInputForInputSwitchDirective, deps: [{ token: i1$4.NgControl, optional: true, self: true }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetInputForInputSwitchDirective, selector: "cnet-input-switch, [cneInputSwitch], [cnet-input-switch]", inputs: { id: "id", required: "required", disabled: "disabled", value: "value", focused: "focused", errorState: "errorState" }, host: { listeners: { "blur": "changeFocus(false)", "focus": "changeFocus(true)" }, properties: { "attr.id": "id", "attr.aria-invalid": "errorState", "attr.aria-required": "required", "attr.aria-describedby": "describedby" }, classAttribute: "cnet-input-switch" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetInputForInputSwitchDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-input-switch, [cneInputSwitch], [cnet-input-switch]',
                    host: {
                        class: 'cnet-input-switch',
                        '[attr.id]': 'id',
                        '[attr.aria-invalid]': 'errorState',
                        '[attr.aria-required]': 'required',
                        '[attr.aria-describedby]': 'describedby',
                        '(blur)': 'changeFocus(false)',
                        '(focus)': 'changeFocus(true)'
                    },
                }]
        }], ctorParameters: () => [{ type: i1$4.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ElementRef }], propDecorators: { id: [{
                type: Input
            }], required: [{
                type: Input
            }], disabled: [{
                type: Input
            }], value: [{
                type: Input
            }], focused: [{
                type: Input
            }], errorState: [{
                type: Input
            }] } });

class CnetInputSwitchComponent extends CnetInputForInputSwitchDirective {
    /**
     * Value for the input switch
     * @readonly
     * type {boolean}
     * @memberof CnetInputSwitchComponent
     */
    get value() { return this._value; }
    set value(value) {
        this._value = value;
        this._checked = coerceBooleanProperty(value);
    }
    /**
      * Whether this checkbox is checked
      *
      * @readonly
      * type {boolean}
      * @memberof CnetCheckboxComponent
      */
    get checked() { return this._checked; }
    set checked(value) {
        value = coerceBooleanProperty(value);
        this.control.setValue(value);
    }
    /**
     * Whether this input switch is disabled
     *
     * @readonly
     * type boolean
     * @memberof CnetInputSwitchComponent
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
        if (value) {
            if (!this.control.disabled) {
                this.control.disable();
            }
        }
        else {
            if (!this.control.enabled) {
                this.control.enable();
            }
        }
    }
    get color() { return this._color; }
    set color(value) { this._color = value ? value : 'primary'; }
    constructor(ngControl, elementRef, injector) {
        super(ngControl, elementRef);
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.injector = injector;
        /** @ignore */ this._disabled = false;
        /** @ignore */ this._value = false;
        /** @ignore */ this.cdr = inject(ChangeDetectorRef);
        /** @ignore */ this._checked = false;
        this.control = new FormControl(false, []);
        this._color = 'primary';
        this.destroyed = new Subject();
        /** @ignore */
        this.onChangeFn = (_) => { };
        /** @ignore */
        this.onTouchedFn = () => { };
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }
    ngOnInit() {
        this.setComponentControl();
    }
    setComponentControl() {
        if (this.ngControl) {
            const injectedControl = this.ngControl;
            switch (injectedControl.constructor) {
                case NgModel: {
                    const { control, update } = injectedControl;
                    this.control = control;
                    this.control.valueChanges
                        .pipe(tap((value) => update.emit(value)), takeUntil$1(this.destroyed))
                        .subscribe();
                    break;
                }
                case FormControlName: {
                    this.control = this.injector.get(FormGroupDirective).getControl(injectedControl);
                    break;
                }
                default: {
                    this.control = injectedControl.form;
                    break;
                }
            }
        }
        if (this.disabled) {
            this.control.disable();
        }
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
    /**
     *  control value acessor functions
     */
    writeValue(obj) {
        this.value = obj ? obj : false;
        this.cdr.markForCheck();
    }
    /** @ignore */
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    onChange() {
        this.onChangeFn(this.value);
        this.cdr.markForCheck();
    }
    registerOnTouched(fn) {
        this.onTouchedFn = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        if (this.disabled) {
            this.elementRef.nativeElement.tabIndex = -1;
            // this.inputSwitchControl.disable()
        }
        else {
            this.elementRef.nativeElement.tabIndex = 0;
            // this.inputSwitchControl.enable()
        }
        this.cdr.markForCheck();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetInputSwitchComponent, deps: [{ token: i1$4.NgControl, optional: true, self: true }, { token: i0.ElementRef }, { token: Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetInputSwitchComponent, selector: "cnet-input-switch", inputs: { value: "value", checked: "checked", disabled: "disabled", color: "color" }, host: { attributes: { "tabindex": "-1", "role": "input" }, properties: { "attr.id": "id", "attr.value": "value", "attr.name": "name", "class.cnet-input-switch-disabled": "disabled", "class.cnet-color-primary": "color == \"primary\"", "class.cnet-color-secondary": "color == \"secondary\"", "class.cnet-color-danger": "color == \"danger\"", "class.cnet-color-success": "color == \"success\"", "class.cnet-color-cancel": "color == \"cancel\"" }, classAttribute: "cnet-input-switch" }, providers: [{ provide: CnetFormFieldControl, useExisting: CnetInputSwitchComponent }], exportAs: ["cnetInputSwitch"], usesInheritance: true, ngImport: i0, template: "<label class=\"switch\">\n  <input type=\"checkbox\" [formControl]=\"control\">\n  <span class=\"slider round\"></span>\n</label>\n", styles: [".switch{position:relative;display:inline-block;width:60px;height:34px}.switch input{opacity:0;width:0;height:0}.slider{position:absolute;cursor:pointer;inset:0;background-color:#ccc;-webkit-transition:.4s;transition:.4s;box-shadow:inset 0 2px 5px #0000001a;border:1px solid #ccc}.cnet-input-switch.ng-invalid.ng-dirty .slider{border-color:var(--cnet-danger-500, #ee4446)}.slider:before{position:absolute;content:\"\";height:26px;width:26px;left:3px;bottom:3px;background-color:#fff;-webkit-transition:.4s;transition:.4s;box-shadow:0 -4px 4px -4px #0000001a,0 4px 5px #0000001a}.cnet-color-primary input:checked+.slider{background-color:var(--cnet-primary-500, #82c14f)}.cnet-color-secondary input:checked+.slider{background-color:var(--cnet-secondary-500, #3d4155)}.cnet-color-danger input:checked+.slider{background-color:var(--cnet-danger-500, #ee4446)}.cnet-color-success input:checked+.slider{background-color:var(--cnet-success-500, #47ba65)}.cnet-color-cancel input:checked+.slider{background-color:var(--cnet-cancel-500, #9e9e9e)}input:checked+.slider{box-shadow:inset 0 2px 5px #0000001a}input:focus+.slider{border:1px solid;box-shadow:inset 0 2px 5px #0000001a}input:checked+.slider:before{-webkit-transform:translateX(26px);-ms-transform:translateX(26px);transform:translate(26px);box-shadow:0 -4px 4px -4px #0000001a,0 4px 5px #0000001a}.slider.round{border-radius:34px}.slider.round:before{border-radius:50%}\n"], dependencies: [{ kind: "directive", type: i1$4.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetInputSwitchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-input-switch', exportAs: 'cnetInputSwitch', host: {
                        class: 'cnet-input-switch',
                        tabindex: '-1',
                        role: 'input',
                        '[attr.id]': 'id',
                        '[attr.value]': 'value',
                        '[attr.name]': 'name',
                        '[class.cnet-input-switch-disabled]': 'disabled',
                        '[class.cnet-color-primary]': 'color == "primary"',
                        '[class.cnet-color-secondary]': 'color == "secondary"',
                        '[class.cnet-color-danger]': 'color == "danger"',
                        '[class.cnet-color-success]': 'color == "success"',
                        '[class.cnet-color-cancel]': 'color == "cancel"',
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, providers: [{ provide: CnetFormFieldControl, useExisting: CnetInputSwitchComponent }], template: "<label class=\"switch\">\n  <input type=\"checkbox\" [formControl]=\"control\">\n  <span class=\"slider round\"></span>\n</label>\n", styles: [".switch{position:relative;display:inline-block;width:60px;height:34px}.switch input{opacity:0;width:0;height:0}.slider{position:absolute;cursor:pointer;inset:0;background-color:#ccc;-webkit-transition:.4s;transition:.4s;box-shadow:inset 0 2px 5px #0000001a;border:1px solid #ccc}.cnet-input-switch.ng-invalid.ng-dirty .slider{border-color:var(--cnet-danger-500, #ee4446)}.slider:before{position:absolute;content:\"\";height:26px;width:26px;left:3px;bottom:3px;background-color:#fff;-webkit-transition:.4s;transition:.4s;box-shadow:0 -4px 4px -4px #0000001a,0 4px 5px #0000001a}.cnet-color-primary input:checked+.slider{background-color:var(--cnet-primary-500, #82c14f)}.cnet-color-secondary input:checked+.slider{background-color:var(--cnet-secondary-500, #3d4155)}.cnet-color-danger input:checked+.slider{background-color:var(--cnet-danger-500, #ee4446)}.cnet-color-success input:checked+.slider{background-color:var(--cnet-success-500, #47ba65)}.cnet-color-cancel input:checked+.slider{background-color:var(--cnet-cancel-500, #9e9e9e)}input:checked+.slider{box-shadow:inset 0 2px 5px #0000001a}input:focus+.slider{border:1px solid;box-shadow:inset 0 2px 5px #0000001a}input:checked+.slider:before{-webkit-transform:translateX(26px);-ms-transform:translateX(26px);transform:translate(26px);box-shadow:0 -4px 4px -4px #0000001a,0 4px 5px #0000001a}.slider.round{border-radius:34px}.slider.round:before{border-radius:50%}\n"] }]
        }], ctorParameters: () => [{ type: i1$4.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ElementRef }, { type: i0.Injector, decorators: [{
                    type: Inject,
                    args: [Injector]
                }] }], propDecorators: { value: [{
                type: Input
            }], checked: [{
                type: Input
            }], disabled: [{
                type: Input,
                args: ['disabled']
            }], color: [{
                type: Input
            }] } });

class CnetDynamicFormQuestionComponent {
    constructor() {
        this.showQuestionsNumber = true;
        this.hasExternalTemplate = false;
        this.labelButtonExternalTemplate = '';
        this.iconButtonExternalTemplate = '';
        this.useDefaultLabel = false;
        this.onUpload = new EventEmitter();
        this.onRemoveFileFromAnswer = new EventEmitter();
        this.onOpenTemplate = new EventEmitter();
        this.hasQuestionReset = false;
        this.labelButtonReset = 'Reset';
        this.iconButtonReset = '';
        this.hasQuestionIndividualSave = false;
        this.labelButtonIndividualSave = 'Salvar';
        this.iconButtonIndividualSave = '';
        this.questionResetEvent = new EventEmitter();
        this.questionIndividualSaveEvent = new EventEmitter();
        this.enumInternshipType = enumQuestionTypeCode;
    }
    get isValid() { return this.form?.controls[this.question?.code].valid; }
    get isDirty() { return this.form?.controls[this.question?.code].dirty; }
    get isDisabled() { return this.form?.controls[this.question?.code].disabled; }
    onUploadFile(files) {
        this.onUpload.emit({ questionCode: this.question.code, files: files });
    }
    onRemoveFile(file) {
        this.onRemoveFileFromAnswer.emit({ questionCode: this.question.code, file: file });
    }
    ngOnInit() {
        if (this.question?.questionTypeCode === enumQuestionTypeCode.MultiSelect || this.question?.questionTypeCode === enumQuestionTypeCode.SingleSelect || this.question?.questionTypeCode === enumQuestionTypeCode.Slider) {
            if (!this.question['optionValue']) {
                this.question['optionValue'] = enumArrayOptionDefault.text;
            }
            if (!this.question['optionLabel']) {
                this.question['optionLabel'] = enumArrayOptionDefault.text;
            }
            this.question.options = this.question.options.sort((a, b) => a.order - b.order);
        }
    }
    clickopenTemplate() {
        this.onOpenTemplate.emit(this.question.code);
    }
    clickIndividualSave() {
        this.questionIndividualSaveEvent.emit(this.question.code);
    }
    clickResetQuestion() {
        // estudar se uso o reset do angular 14 q volta pro valor inicial ou se vale a pena criar mais um paramtro para valor default
        // this.form.controls[this.question?.code].reset();
        this.questionResetEvent.emit(this.question.code);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDynamicFormQuestionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetDynamicFormQuestionComponent, selector: "cnet-dynamic-form-question", inputs: { question: "question", form: "form", showQuestionsNumber: "showQuestionsNumber", hasExternalTemplate: "hasExternalTemplate", labelButtonExternalTemplate: "labelButtonExternalTemplate", iconButtonExternalTemplate: "iconButtonExternalTemplate", useDefaultLabel: "useDefaultLabel", hasQuestionReset: "hasQuestionReset", labelButtonReset: "labelButtonReset", iconButtonReset: "iconButtonReset", hasQuestionIndividualSave: "hasQuestionIndividualSave", labelButtonIndividualSave: "labelButtonIndividualSave", iconButtonIndividualSave: "iconButtonIndividualSave" }, outputs: { onUpload: "onUpload", onRemoveFileFromAnswer: "onRemoveFileFromAnswer", onOpenTemplate: "onOpenTemplate", questionResetEvent: "questionResetEvent", questionIndividualSaveEvent: "questionIndividualSaveEvent" }, ngImport: i0, template: "<div class=\"container\">\n\n  <div [formGroup]=\"form\">\n    <ng-container *ngIf=\"!useDefaultLabel\">\n\n      <div class=\"statement-header\">\n        <label [attr.for]=\"question?.code\" class=\"statement\" cnetRequiredMark [show]=\"question?.required\">\n          <ng-container *ngIf=\"showQuestionsNumber\">{{question?.order}}.</ng-container>\n          {{question?.statement}}\n        </label>\n        <div>\n\n          <button cnet-button type=\"button\" aria-label=\"option\" (click)=\"clickIndividualSave()\"\n            *ngIf=\"hasQuestionIndividualSave\">\n            <cnet-icon *ngIf=\"iconButtonIndividualSave\" [name]=\"iconButtonIndividualSave\" label=\"option\"></cnet-icon>\n            <div style=\"margin-top: 4px;\">\n              {{labelButtonIndividualSave | translate}}\n            </div>\n          </button>\n\n          <button cnet-button type=\"button\" aria-label=\"option\" (click)=\"clickResetQuestion()\" *ngIf=\"hasQuestionReset\">\n            <cnet-icon *ngIf=\"iconButtonReset\" [name]=\"iconButtonReset\" label=\"option\"></cnet-icon>\n            <div style=\"margin-top: 4px;\">\n              {{labelButtonReset | translate}}\n            </div>\n          </button>\n\n          <button cnet-button type=\"button\" aria-label=\"option\" (click)=\"clickopenTemplate()\"\n            *ngIf=\"hasExternalTemplate\">\n            <cnet-icon *ngIf=\"iconButtonExternalTemplate\" [name]=\"iconButtonExternalTemplate\"\n              label=\"option\"></cnet-icon>\n            <div style=\"margin-top: 4px;\">\n              {{labelButtonExternalTemplate | translate}}\n            </div>\n          </button>\n        </div>\n      </div>\n\n      <p *ngIf=\"question?.description\">\n        <label [attr.for]=\"question?.code\" [class.margin-left-20]=\"showQuestionsNumber\" class=\"description\">\n          {{question?.description}}\n        </label>\n      </p>\n\n    </ng-container>\n\n    <div [ngSwitch]=\"question?.questionTypeCode\" [class.margin-left-20]=\"showQuestionsNumber\" class=\"input-container\">\n\n      <div *ngSwitchCase=\"enumInternshipType.Descriptive\">\n\n        <cnet-form-field class=\"col-12 p-0 mb-0\" style=\"padding: 0; margin-bottom: 0.1rem;\">\n          <cnet-field-label cnetRequiredMark [show]=\"question?.required\"\n            *ngIf=\"useDefaultLabel\">{{question?.statement}}</cnet-field-label>\n\n          <textarea cnet-input [formControlName]=\"question?.code\" [id]=\"question?.code\" wrap=\"hard\"\n            [maxlength]=\"question['maxLength']\"></textarea>\n        </cnet-form-field>\n        <p class=\"carcter-counting\">{{form.value[question?.code].length}} {{'caracteres' | translate}}</p>\n      </div>\n\n      <div *ngSwitchCase=\"enumInternshipType.Text\">\n        <cnet-form-field class=\"col-12 p-0 mb-0\" style=\"padding: 0; margin-bottom: 0.1rem;\">\n          <cnet-field-label cnetRequiredMark [show]=\"question?.required\"\n            *ngIf=\"useDefaultLabel\">{{question?.statement}}</cnet-field-label>\n          <input cnet-input [formControlName]=\"question?.code\" [id]=\"question?.code\" wrap=\"hard\"\n            [maxlength]=\"question['maxLength']\">\n        </cnet-form-field>\n      </div>\n\n      <div *ngSwitchCase=\"enumInternshipType.Number\">\n        <cnet-form-field class=\"col-12 p-0 mb-0\" style=\"padding: 0; margin-bottom: 0.1rem;\">\n          <cnet-field-label cnetRequiredMark [show]=\"question?.required\"\n            *ngIf=\"useDefaultLabel\">{{question?.statement}}</cnet-field-label>\n          <input cnet-input [formControlName]=\"question?.code\" type=\"number\" inputmode=\"numeric\"\n            [min]=\"question['minValue']\" [max]=\"question['maxValue']\" [step]=\"question['step']\" />\n        </cnet-form-field>\n      </div>\n\n      <div *ngSwitchCase=\"enumInternshipType.InputSwitch\">\n        <cnet-form-field class=\"col-12 p-0 mb-0\" style=\"padding: 0; margin-bottom: 0.1rem;\">\n          <cnet-field-label cnetRequiredMark [show]=\"question?.required\"\n            *ngIf=\"useDefaultLabel\">{{question?.statement}}</cnet-field-label>\n          <cnet-input-switch [formControlName]=\"question?.code\" [color]=\"question['color']\"></cnet-input-switch>\n        </cnet-form-field>\n      </div>\n\n      <ng-container *ngSwitchCase=\"enumInternshipType.SingleSelect\">\n\n        <label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"useDefaultLabel\">{{question?.statement}}</label>\n\n        <cnet-radio-group [formControlName]=\"question?.code\" aria-labelledby=\"group-label\" [color]=\"question['color']\"\n          [id]=\"question?.code\">\n          <cnet-radio *ngFor=\"let item of question['options']; let i = index \" [value]=\"item[question['optionValue']]\">\n            <div class=\"select-label\">\n              <ng-container *ngIf=\"showQuestionsNumber\">{{ i+65 | ascIIToChar }} - </ng-container>\n              {{ item[question['optionLabel']] }}\n            </div>\n          </cnet-radio>\n        </cnet-radio-group>\n\n      </ng-container>\n\n\n      <ng-container *ngSwitchCase=\"enumInternshipType.MultiSelect\">\n\n        <label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"useDefaultLabel\">{{question?.statement}}</label>\n\n        <cnet-checkbox-group [formControlName]=\"question?.code\" aria-labelledby=\"group-label\"\n          [color]=\"question['color']\" [id]=\"question?.code\">\n          <cnet-checkbox *ngFor=\"let item of question['options']; let i = index \"\n            [value]=\"item[question['optionValue']]\">\n            <div class=\"select-label\">\n              <ng-container *ngIf=\"showQuestionsNumber\">{{ i+65 | ascIIToChar }} - </ng-container>\n              {{ item[question['optionLabel']] }}\n            </div>\n          </cnet-checkbox>\n        </cnet-checkbox-group>\n      </ng-container>\n\n      <ng-container *ngSwitchCase=\"enumInternshipType.Slider\">\n\n        <label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"useDefaultLabel\">{{question?.statement}}</label>\n\n        <cnet-slider-old [id]=\"question?.code\" [formControlName]=\"question?.code\"\n          [steps]=\"question['options']\"></cnet-slider-old>\n      </ng-container>\n\n\n\n      <ng-container *ngSwitchCase=\"enumInternshipType.Attachment\">\n\n        <label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"useDefaultLabel\">{{question?.statement}}</label>\n\n        <cnet-file-upload [formControl]=\"form.controls[question?.code]\" [attachmentUri]=\"question['attachmentUri']\"\n          [id]=\"question?.code\" [maxFileSize]=\"5\" (onUpload)=\"onUploadFile($event)\"\n          (onRemoveFile)=\"onRemoveFile($event)\">\n        </cnet-file-upload>\n      </ng-container>\n\n\n      <label class=\"errorMessage\"\n        *ngIf=\"isDirty && !isValid && !isDisabled && form.controls[question?.code].hasError('min')\">\n        {{'O valor n\u00E3o deve ser menor que {minVal}' |translate:{minVal:question['minValue']} }}\n      </label>\n      <label class=\"errorMessage\"\n        *ngIf=\"isDirty && !isValid && !isDisabled && form.controls[question?.code].hasError('max')\">\n        {{'O valor n\u00E3o deve ultrapassar {maxVal}' |translate:{maxVal:question['maxValue']} }}\n      </label>\n      <label class=\"errorMessage\"\n        *ngIf=\"isDirty && !isValid && !isDisabled && form.controls[question?.code].hasError('required')\">\n        {{'O campo {campo} \u00E9 obrigat\u00F3rio.' |translate:{campo:question?.statement} }}\n      </label>\n    </div>\n\n  </div>\n\n</div>\n", styles: [".statement-header{display:flex;align-content:center;align-items:center;justify-content:space-between}.container{width:100%;height:100%;padding:1rem}.statement{font-size:1.125rem;white-space:break-spaces}.description{font-size:1rem;white-space:break-spaces}.margin-left-20{margin-left:20px}.input-container{margin:.5rem 0 1rem 0rem!important}.question{display:flex;width:100%;align-items:flex-start}textarea{width:100%;padding:8px 24px;border-color:#ccc;line-height:inherit;font-size:16px;border-radius:5px;resize:vertical}textarea:focus-visible{border-color:#ccc}cnet-radio{width:100%;font-size:1rem}.cnet-checkbox-group{flex-direction:column}.carcter-counting{display:flex;width:100%;justify-content:flex-end;margin-bottom:0}.errorMessage{color:var(--cnet-danger-500, #ee4446)}.select-label{font-size:1rem;font-weight:700}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$4.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i1$4.MinValidator, selector: "input[type=number][min][formControlName],input[type=number][min][formControl],input[type=number][min][ngModel]", inputs: ["min"] }, { kind: "directive", type: i1$4.MaxValidator, selector: "input[type=number][max][formControlName],input[type=number][max][formControl],input[type=number][max][ngModel]", inputs: ["max"] }, { kind: "directive", type: i1$4.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "component", type: CnetFormFieldComponent, selector: "cnet-form-field", inputs: ["hasMoreThanOneControl", "showLabel"], exportAs: ["cnetButton"] }, { kind: "directive", type: CnetFieldLabelDirective, selector: "cnet-field-label, [cnetFieldLabel], [cnet-field-label]" }, { kind: "directive", type: RequiredMarkDirective, selector: "[cnetRequiredMark]", inputs: ["show"] }, { kind: "component", type: CnetRadioComponent, selector: "cnet-radio", inputs: ["id", "name", "checked", "value", "disabled", "enableUncheck"], outputs: ["change", "blur", "focus"], exportAs: ["cnetRadio"] }, { kind: "component", type: CnetRadioGroupComponent, selector: "cnet-radio-group", inputs: ["id", "name", "value", "disabled", "color"], exportAs: ["cnetRadioGroup"] }, { kind: "directive", type: CnetInputDirective, selector: "cnet-input, [CnetInput], [cnet-input]", inputs: ["id", "required", "disabled", "value", "focused", "errorState"] }, { kind: "component", type: CnetCheckboxComponent, selector: "cnet-checkbox", inputs: ["id", "name", "checked", "value", "disabled", "color", "enableRiple"], outputs: ["change", "blur", "focus"], exportAs: ["cnetCheckbox"] }, { kind: "component", type: CnetCheckboxGroupComponent, selector: "cnet-checkbox-group", inputs: ["id", "name", "value", "disabled", "color"], exportAs: ["cnetCheckboxGroup"] }, { kind: "component", type: CnetSliderOldComponent, selector: "cnet-slider-old", inputs: ["value", "id", "focused", "disabled", "steps"] }, { kind: "component", type: CnetFileUploadComponent, selector: "cnet-file-upload", inputs: ["progress", "multiple", "maxFileSize", "attachmentUri", "accept", "sizeFileErrorMessage", "typeFileErrorMessage", "multipleFilesErrorMessage", "pickFileButtonLabel", "dropFileLabel", "noFilesLabel", "deleteFileButtonLabel", "visualizeFileButtonLabel", "showVisualizeBtn", "value"], outputs: ["onUpload", "onRemoveFile"] }, { kind: "component", type: CnetInputSwitchComponent, selector: "cnet-input-switch", inputs: ["value", "checked", "disabled", "color"], exportAs: ["cnetInputSwitch"] }, { kind: "directive", type: CnetInputForInputSwitchDirective, selector: "cnet-input-switch, [cneInputSwitch], [cnet-input-switch]", inputs: ["id", "required", "disabled", "value", "focused", "errorState"] }, { kind: "pipe", type: i1$3.TranslatePipe, name: "translate" }, { kind: "pipe", type: AscIIToCharPipe, name: "ascIIToChar" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDynamicFormQuestionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-dynamic-form-question', template: "<div class=\"container\">\n\n  <div [formGroup]=\"form\">\n    <ng-container *ngIf=\"!useDefaultLabel\">\n\n      <div class=\"statement-header\">\n        <label [attr.for]=\"question?.code\" class=\"statement\" cnetRequiredMark [show]=\"question?.required\">\n          <ng-container *ngIf=\"showQuestionsNumber\">{{question?.order}}.</ng-container>\n          {{question?.statement}}\n        </label>\n        <div>\n\n          <button cnet-button type=\"button\" aria-label=\"option\" (click)=\"clickIndividualSave()\"\n            *ngIf=\"hasQuestionIndividualSave\">\n            <cnet-icon *ngIf=\"iconButtonIndividualSave\" [name]=\"iconButtonIndividualSave\" label=\"option\"></cnet-icon>\n            <div style=\"margin-top: 4px;\">\n              {{labelButtonIndividualSave | translate}}\n            </div>\n          </button>\n\n          <button cnet-button type=\"button\" aria-label=\"option\" (click)=\"clickResetQuestion()\" *ngIf=\"hasQuestionReset\">\n            <cnet-icon *ngIf=\"iconButtonReset\" [name]=\"iconButtonReset\" label=\"option\"></cnet-icon>\n            <div style=\"margin-top: 4px;\">\n              {{labelButtonReset | translate}}\n            </div>\n          </button>\n\n          <button cnet-button type=\"button\" aria-label=\"option\" (click)=\"clickopenTemplate()\"\n            *ngIf=\"hasExternalTemplate\">\n            <cnet-icon *ngIf=\"iconButtonExternalTemplate\" [name]=\"iconButtonExternalTemplate\"\n              label=\"option\"></cnet-icon>\n            <div style=\"margin-top: 4px;\">\n              {{labelButtonExternalTemplate | translate}}\n            </div>\n          </button>\n        </div>\n      </div>\n\n      <p *ngIf=\"question?.description\">\n        <label [attr.for]=\"question?.code\" [class.margin-left-20]=\"showQuestionsNumber\" class=\"description\">\n          {{question?.description}}\n        </label>\n      </p>\n\n    </ng-container>\n\n    <div [ngSwitch]=\"question?.questionTypeCode\" [class.margin-left-20]=\"showQuestionsNumber\" class=\"input-container\">\n\n      <div *ngSwitchCase=\"enumInternshipType.Descriptive\">\n\n        <cnet-form-field class=\"col-12 p-0 mb-0\" style=\"padding: 0; margin-bottom: 0.1rem;\">\n          <cnet-field-label cnetRequiredMark [show]=\"question?.required\"\n            *ngIf=\"useDefaultLabel\">{{question?.statement}}</cnet-field-label>\n\n          <textarea cnet-input [formControlName]=\"question?.code\" [id]=\"question?.code\" wrap=\"hard\"\n            [maxlength]=\"question['maxLength']\"></textarea>\n        </cnet-form-field>\n        <p class=\"carcter-counting\">{{form.value[question?.code].length}} {{'caracteres' | translate}}</p>\n      </div>\n\n      <div *ngSwitchCase=\"enumInternshipType.Text\">\n        <cnet-form-field class=\"col-12 p-0 mb-0\" style=\"padding: 0; margin-bottom: 0.1rem;\">\n          <cnet-field-label cnetRequiredMark [show]=\"question?.required\"\n            *ngIf=\"useDefaultLabel\">{{question?.statement}}</cnet-field-label>\n          <input cnet-input [formControlName]=\"question?.code\" [id]=\"question?.code\" wrap=\"hard\"\n            [maxlength]=\"question['maxLength']\">\n        </cnet-form-field>\n      </div>\n\n      <div *ngSwitchCase=\"enumInternshipType.Number\">\n        <cnet-form-field class=\"col-12 p-0 mb-0\" style=\"padding: 0; margin-bottom: 0.1rem;\">\n          <cnet-field-label cnetRequiredMark [show]=\"question?.required\"\n            *ngIf=\"useDefaultLabel\">{{question?.statement}}</cnet-field-label>\n          <input cnet-input [formControlName]=\"question?.code\" type=\"number\" inputmode=\"numeric\"\n            [min]=\"question['minValue']\" [max]=\"question['maxValue']\" [step]=\"question['step']\" />\n        </cnet-form-field>\n      </div>\n\n      <div *ngSwitchCase=\"enumInternshipType.InputSwitch\">\n        <cnet-form-field class=\"col-12 p-0 mb-0\" style=\"padding: 0; margin-bottom: 0.1rem;\">\n          <cnet-field-label cnetRequiredMark [show]=\"question?.required\"\n            *ngIf=\"useDefaultLabel\">{{question?.statement}}</cnet-field-label>\n          <cnet-input-switch [formControlName]=\"question?.code\" [color]=\"question['color']\"></cnet-input-switch>\n        </cnet-form-field>\n      </div>\n\n      <ng-container *ngSwitchCase=\"enumInternshipType.SingleSelect\">\n\n        <label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"useDefaultLabel\">{{question?.statement}}</label>\n\n        <cnet-radio-group [formControlName]=\"question?.code\" aria-labelledby=\"group-label\" [color]=\"question['color']\"\n          [id]=\"question?.code\">\n          <cnet-radio *ngFor=\"let item of question['options']; let i = index \" [value]=\"item[question['optionValue']]\">\n            <div class=\"select-label\">\n              <ng-container *ngIf=\"showQuestionsNumber\">{{ i+65 | ascIIToChar }} - </ng-container>\n              {{ item[question['optionLabel']] }}\n            </div>\n          </cnet-radio>\n        </cnet-radio-group>\n\n      </ng-container>\n\n\n      <ng-container *ngSwitchCase=\"enumInternshipType.MultiSelect\">\n\n        <label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"useDefaultLabel\">{{question?.statement}}</label>\n\n        <cnet-checkbox-group [formControlName]=\"question?.code\" aria-labelledby=\"group-label\"\n          [color]=\"question['color']\" [id]=\"question?.code\">\n          <cnet-checkbox *ngFor=\"let item of question['options']; let i = index \"\n            [value]=\"item[question['optionValue']]\">\n            <div class=\"select-label\">\n              <ng-container *ngIf=\"showQuestionsNumber\">{{ i+65 | ascIIToChar }} - </ng-container>\n              {{ item[question['optionLabel']] }}\n            </div>\n          </cnet-checkbox>\n        </cnet-checkbox-group>\n      </ng-container>\n\n      <ng-container *ngSwitchCase=\"enumInternshipType.Slider\">\n\n        <label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"useDefaultLabel\">{{question?.statement}}</label>\n\n        <cnet-slider-old [id]=\"question?.code\" [formControlName]=\"question?.code\"\n          [steps]=\"question['options']\"></cnet-slider-old>\n      </ng-container>\n\n\n\n      <ng-container *ngSwitchCase=\"enumInternshipType.Attachment\">\n\n        <label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"useDefaultLabel\">{{question?.statement}}</label>\n\n        <cnet-file-upload [formControl]=\"form.controls[question?.code]\" [attachmentUri]=\"question['attachmentUri']\"\n          [id]=\"question?.code\" [maxFileSize]=\"5\" (onUpload)=\"onUploadFile($event)\"\n          (onRemoveFile)=\"onRemoveFile($event)\">\n        </cnet-file-upload>\n      </ng-container>\n\n\n      <label class=\"errorMessage\"\n        *ngIf=\"isDirty && !isValid && !isDisabled && form.controls[question?.code].hasError('min')\">\n        {{'O valor n\u00E3o deve ser menor que {minVal}' |translate:{minVal:question['minValue']} }}\n      </label>\n      <label class=\"errorMessage\"\n        *ngIf=\"isDirty && !isValid && !isDisabled && form.controls[question?.code].hasError('max')\">\n        {{'O valor n\u00E3o deve ultrapassar {maxVal}' |translate:{maxVal:question['maxValue']} }}\n      </label>\n      <label class=\"errorMessage\"\n        *ngIf=\"isDirty && !isValid && !isDisabled && form.controls[question?.code].hasError('required')\">\n        {{'O campo {campo} \u00E9 obrigat\u00F3rio.' |translate:{campo:question?.statement} }}\n      </label>\n    </div>\n\n  </div>\n\n</div>\n", styles: [".statement-header{display:flex;align-content:center;align-items:center;justify-content:space-between}.container{width:100%;height:100%;padding:1rem}.statement{font-size:1.125rem;white-space:break-spaces}.description{font-size:1rem;white-space:break-spaces}.margin-left-20{margin-left:20px}.input-container{margin:.5rem 0 1rem 0rem!important}.question{display:flex;width:100%;align-items:flex-start}textarea{width:100%;padding:8px 24px;border-color:#ccc;line-height:inherit;font-size:16px;border-radius:5px;resize:vertical}textarea:focus-visible{border-color:#ccc}cnet-radio{width:100%;font-size:1rem}.cnet-checkbox-group{flex-direction:column}.carcter-counting{display:flex;width:100%;justify-content:flex-end;margin-bottom:0}.errorMessage{color:var(--cnet-danger-500, #ee4446)}.select-label{font-size:1rem;font-weight:700}\n"] }]
        }], propDecorators: { question: [{
                type: Input
            }], form: [{
                type: Input
            }], showQuestionsNumber: [{
                type: Input
            }], hasExternalTemplate: [{
                type: Input
            }], labelButtonExternalTemplate: [{
                type: Input
            }], iconButtonExternalTemplate: [{
                type: Input
            }], useDefaultLabel: [{
                type: Input
            }], onUpload: [{
                type: Output
            }], onRemoveFileFromAnswer: [{
                type: Output
            }], onOpenTemplate: [{
                type: Output
            }], hasQuestionReset: [{
                type: Input
            }], labelButtonReset: [{
                type: Input
            }], iconButtonReset: [{
                type: Input
            }], hasQuestionIndividualSave: [{
                type: Input
            }], labelButtonIndividualSave: [{
                type: Input
            }], iconButtonIndividualSave: [{
                type: Input
            }], questionResetEvent: [{
                type: Output
            }], questionIndividualSaveEvent: [{
                type: Output
            }] } });

const updateQuestionToggleAnimation = trigger('toggleToUpdateQuestion', [
    transition(':enter', [
        style({ opacity: 0, transform: 'translateY(10px)' }),
        animate('500ms', style({ opacity: 1, transform: 'translateY(0)' })),
    ]),
]);

class QuestionBase {
    constructor(options = {}) {
        this.translateStatement = false;
        this.answerValue = options.answerValue;
        this.code = options.code || '';
        this.statement = options.statement || '';
        this.description = options.description || '';
        this.questionTypeCode = options.questionTypeCode || '';
        this.order = options.order === undefined ? 1 : options.order;
        this.required = !!options.required;
        this.evaluationConfigCode = options.evaluationConfigCode || '',
            this.translateStatement = options['translateStatement'] ? options['translateStatement'] : false;
    }
}

class AttachmentQuestion extends QuestionBase {
    constructor(options = {}) {
        super(options);
        this.questionTypeCode = enumQuestionTypeCode.Attachment;
        this.attachmentUri = options['attachmentUri'] || '';
        this.maxFileSize = options['maxFileSize'] || 5;
        this.sizeFileErrorMessage = options['sizeFileErrorMessage'] || 'Cada arquivo inserido deve ser menor que {size}mb';
        this.multipleFilesErrorMessage = options['multipleFilesErrorMessage'] || 'Não é possível anexar mais do que um único arquivo.';
        this.pickFileButtonLabel = options['pickFileButtonLabel'] || 'escolha um arquivo...';
        this.dropFileLabel = options['dropFileLabel'] || 'Arraste um arquivo aqui';
        this.noFilesLabel = options['noFilesLabel'] || 'Nenhum arquivo anexado.';
        this.deleteFileButtonLabel = options['deleteFileButtonLabel'] || 'Excluir';
        this.visualizeFileButtonLabel = options['visualizeFileButtonLabel'] || 'Visualizar';
        this.showVisualizeBtn = options['showVisualizeBtn'] || false;
    }
}

class DescriptiveQuestion extends QuestionBase {
    constructor(options = {}) {
        super(options);
        this.questionTypeCode = enumQuestionTypeCode.Descriptive;
        this.rows = 1;
        this.maxLength = 2048;
        this.type = options['type'] || '';
        this.rows = options['rows'] || 1;
        this.maxLength = options['maxLength'] || 2048;
    }
}

/**
 * Caso de radio Button
 */
class MultiSelectQuestion extends QuestionBase {
    constructor(options = {}) {
        super(options);
        this.questionTypeCode = enumQuestionTypeCode.MultiSelect;
        this.color = 'primary';
        this.optionLabel = enumArrayOptionDefault.text;
        this.optionValue = enumArrayOptionDefault.text;
        this.translateOption = false;
        this.color = options['color'] || 'primary';
        this.optionLabel = options['optionLabel'] || enumArrayOptionDefault.text;
        this.optionValue = options['optionValue'] || enumArrayOptionDefault.text;
        this.translateOption = options['translateOption'] ? options['translateOption'] : false;
        this.options = options['options'] || [];
    }
}

/**
 * Caso de radio Button
 */
class SingleSelectQuestion extends QuestionBase {
    constructor(options = {}) {
        super(options);
        this.questionTypeCode = enumQuestionTypeCode.SingleSelect;
        this.color = 'primary';
        this.optionLabel = enumArrayOptionDefault.text;
        this.optionValue = enumArrayOptionDefault.text;
        this.translateOption = false;
        this.color = options['color'] || 'primary';
        this.optionLabel = options['optionLabel'] || enumArrayOptionDefault.text;
        this.optionValue = options['optionValue'] || enumArrayOptionDefault.text;
        this.translateOption = options['translateOption'] ? options['translateOption'] : false;
        this.options = options['options'] || [];
    }
}

class SliderQuestion extends QuestionBase {
    constructor(options = {}) {
        super(options);
        this.questionTypeCode = enumQuestionTypeCode.Slider;
        // this.steps = this.options.map(op => { return { id: op.text, value: op.order, legend: '' } })
        // this.options = options['steps'];
        this.options = options['options'] || [];
    }
}

var enumOperations;
(function (enumOperations) {
    enumOperations["create"] = "create";
    enumOperations["edit"] = "edit";
})(enumOperations || (enumOperations = {}));

class NumberQuestion extends QuestionBase {
    constructor(options = {}) {
        super(options);
        this.questionTypeCode = enumQuestionTypeCode.Number;
        this.minValue = null;
        this.maxValue = null;
        this.minValue = options['minValue'];
        this.maxValue = options['maxValue'];
        this.step = options['step'] || 1;
    }
}

class TextQuestion extends QuestionBase {
    constructor(options = {}) {
        super(options);
        this.questionTypeCode = enumQuestionTypeCode.Text;
        this.maxLength = 255;
        this.maxLength = options['maxLength'] || 255;
    }
}

class InputSwitchQuestion extends QuestionBase {
    constructor(options = {}) {
        super(options);
        this.questionTypeCode = enumQuestionTypeCode.InputSwitch;
        this.color = null;
        this.color = options['color'] || null;
    }
}

class QuestionControlService {
    constructor() { }
    toFormGroup(questions) {
        const group = {};
        if (Array.isArray(questions) && questions.length) {
            questions.forEach(question => {
                if (question.questionTypeCode === enumQuestionTypeCode.Attachment) {
                    let valueAux = question.answerValue;
                    if (question.answerValue) {
                        const splitString = question.answerValue.split('/');
                        const name = splitString[splitString.length - 1].substr(splitString[splitString.length - 1].split('_')[0].length + 1);
                        valueAux = [new CnetFile$1(name, question['attachmentUri'], question.answerValue, null)];
                    }
                    group[question.code] = question.required ? new FormControl(valueAux || '', Validators.required)
                        : new FormControl(valueAux || '');
                }
                else if (question.questionTypeCode === enumQuestionTypeCode.Number) {
                    const control = new FormControl(question.answerValue);
                    if (question['minValue']) {
                        control.setValidators(Validators.min(question['minValue']));
                    }
                    if (question['maxValue']) {
                        control.setValidators(Validators.max(question['maxValue']));
                    }
                    if (question.required) {
                        control.setValidators(Validators.required);
                    }
                    group[question.code] = control;
                }
                else {
                    group[question.code] = question.required ? new FormControl(question.answerValue || '', Validators.required)
                        : new FormControl(question.answerValue || '');
                }
            });
            return new FormGroup(group);
        }
        else {
            console.error('must be a array of QuestionBase');
            return null;
        }
    }
    getNewUUID() {
        return uuid.v4();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: QuestionControlService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: QuestionControlService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: QuestionControlService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

/**
 * Service to control the dialogue with the user
 *
 * @export
 * class CnetDialogService
 */
class CnetDialogService {
    constructor(overlay, injector) {
        this.overlay = overlay;
        this.injector = injector;
    }
    /**
     * Open a component, template, or text dialog
     *
     * @template R
     * @template T
     * param {(TemplateRef<any> | Type<any>)} content
     * param {T} data
     * param {boolean} [closable=false]
     * @returns {CnetDialogRef<R>}
     * @memberof CnetDialogService
     */
    open(content, data, closable = false) {
        this.close();
        const positionStrategy = this.overlay.position().global().centerHorizontally().centerVertically();
        const configs = new OverlayConfig({
            hasBackdrop: true,
            panelClass: ['cnet-dialog-pane'],
            backdropClass: 'cnet-dialog-backdrop',
            positionStrategy
        });
        this.overlayRef = this.overlay.create(configs);
        this.dialogRef = new CnetDialogRef(this.overlayRef, content, data, closable);
        const injector = this.createInjector(this.dialogRef, this.injector);
        this.overlayRef.attach(new ComponentPortal(CnetDialogComponent, null, injector));
        return this.dialogRef;
    }
    createInjector(ref, inj) {
        const injectorTokens = new WeakMap([[CnetDialogRef, ref]]);
        return new PortalInjector(inj, injectorTokens);
    }
    close() {
        if (this.dialogRef && this.overlayRef) {
            this.overlayRef.dispose();
            this.dialogRef = null;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDialogService, deps: [{ token: i1$5.Overlay }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDialogService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDialogService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$5.Overlay }, { type: i0.Injector }] });

class ExternalTemplateContainerComponent {
    constructor() {
        this.closingExternalTemplateEvent = new EventEmitter();
    }
    closeExternalTemplate() {
        this.closingExternalTemplateEvent.emit(true);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExternalTemplateContainerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ExternalTemplateContainerComponent, selector: "cnet-external-template-container", inputs: { question: "question", showQuestionsNumber: "showQuestionsNumber" }, outputs: { closingExternalTemplateEvent: "closingExternalTemplateEvent" }, host: { classAttribute: "cnet-external-template-container" }, ngImport: i0, template: "<div class=\"container\">\n  <div class=\"statement-header\">\n    <ng-container *ngIf=\"question?.required else elseTemplate\">\n      <label [attr.for]=\"question?.code\" class=\"statement\" cnetRequiredMark>\n        <ng-container *ngIf=\"showQuestionsNumber\">{{question?.order}}.</ng-container>\n        {{question?.statement}}\n      </label>\n\n    </ng-container>\n    <ng-template #elseTemplate>\n      <label [attr.for]=\"question?.code\" class=\"statement\">\n        <ng-container *ngIf=\"showQuestionsNumber\">{{question?.order}}.</ng-container>\n        {{question?.statement}}\n      </label>\n    </ng-template>\n\n    <div>\n      <button cnet-button type=\"button\" aria-label=\"option\" (click)=\"closeExternalTemplate()\">\n        <cnet-icon name=\"undo\" label=\"option\"></cnet-icon>\n        <div style=\"margin-top: 4px;\">\n          {{'Voltar' | translate}}\n        </div>\n      </button>\n    </div>\n  </div>\n\n  <p>\n    <label [attr.for]=\"question?.code\" [class.margin-left-20]=\"showQuestionsNumber\" class=\"description\" *ngIf=\"question?.description\">\n      {{question?.description}}\n    </label>\n  </p>\n\n  <ng-content></ng-content>\n</div>\n", styles: [".statement-header{display:flex;align-content:center;align-items:center;justify-content:space-between}.container{width:100%;height:100%;padding:1rem;margin-bottom:1rem}.statement{font-size:1.125rem;white-space:break-spaces}.description{font-size:1rem;white-space:break-spaces}.margin-left-20{margin-left:20px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "directive", type: RequiredMarkDirective, selector: "[cnetRequiredMark]", inputs: ["show"] }, { kind: "pipe", type: i1$3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExternalTemplateContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-external-template-container', host: {
                        class: 'cnet-external-template-container'
                    }, template: "<div class=\"container\">\n  <div class=\"statement-header\">\n    <ng-container *ngIf=\"question?.required else elseTemplate\">\n      <label [attr.for]=\"question?.code\" class=\"statement\" cnetRequiredMark>\n        <ng-container *ngIf=\"showQuestionsNumber\">{{question?.order}}.</ng-container>\n        {{question?.statement}}\n      </label>\n\n    </ng-container>\n    <ng-template #elseTemplate>\n      <label [attr.for]=\"question?.code\" class=\"statement\">\n        <ng-container *ngIf=\"showQuestionsNumber\">{{question?.order}}.</ng-container>\n        {{question?.statement}}\n      </label>\n    </ng-template>\n\n    <div>\n      <button cnet-button type=\"button\" aria-label=\"option\" (click)=\"closeExternalTemplate()\">\n        <cnet-icon name=\"undo\" label=\"option\"></cnet-icon>\n        <div style=\"margin-top: 4px;\">\n          {{'Voltar' | translate}}\n        </div>\n      </button>\n    </div>\n  </div>\n\n  <p>\n    <label [attr.for]=\"question?.code\" [class.margin-left-20]=\"showQuestionsNumber\" class=\"description\" *ngIf=\"question?.description\">\n      {{question?.description}}\n    </label>\n  </p>\n\n  <ng-content></ng-content>\n</div>\n", styles: [".statement-header{display:flex;align-content:center;align-items:center;justify-content:space-between}.container{width:100%;height:100%;padding:1rem;margin-bottom:1rem}.statement{font-size:1.125rem;white-space:break-spaces}.description{font-size:1rem;white-space:break-spaces}.margin-left-20{margin-left:20px}\n"] }]
        }], propDecorators: { question: [{
                type: Input
            }], showQuestionsNumber: [{
                type: Input
            }], closingExternalTemplateEvent: [{
                type: Output
            }] } });

// TODO: melhorar essa descrição
/** Cnet Dynamic form is a component that display a form based on input json  */
class CnetDynamicFormComponent {
    get questions() {
        return this._questions;
    }
    ;
    set questions(questions) {
        this._questions = questions;
        if (questions && questions.length) {
            this.initForm();
        }
    }
    ;
    /** disable form */
    get disableForm() { return this._disableForm; }
    set disableForm(value) {
        this._disableForm = value;
        if (this.form) {
            if (value) {
                this.form.disable();
            }
            else {
                this.form.enable();
            }
        }
    }
    get questionsTypesAllowed() { return this._questionsTypesAllowed; }
    set questionsTypesAllowed(value) {
        this._questionsTypesAllowed = value;
        if (value) {
            this.updateCreateOptions(value);
        }
    }
    constructor(questionControlService, dialogService) {
        this.questionControlService = questionControlService;
        this.dialogService = dialogService;
        /** Input JSON who contains all the questions definitions of the form */
        // @Input() questions: QuestionBase<any>[] | null = [];
        this._questions = [];
        /** @ignore */ this._disableForm = false;
        this.createOptions = enumQuestionsTypeAsArray();
        this._questionsTypesAllowed = [];
        this.form = new UntypedFormGroup({});
        this.showTemplateCode = '';
        this.externalTemplate = null;
        this.showQuestionsNumber = true;
        this.showDivider = false;
        this.labelButtonExternalTemplate = '';
        this.iconButtonExternalTemplate = '';
        this.hasQuestionReset = false;
        this.labelButtonReset = 'Reset';
        this.iconButtonReset = '';
        this.hasQuestionIndividualSave = false;
        this.labelButtonIndividualSave = 'Salvar';
        this.iconButtonIndividualSave = '';
        this.useDefaultLabel = '';
        this.questionResetEvent = new EventEmitter();
        this.questionIndividualSaveEvent = new EventEmitter();
        this.showExternalTemplateEvent = new EventEmitter();
        this.changeForm = new EventEmitter();
        this.createQuestion = new EventEmitter();
        this.updateQuestion = new EventEmitter();
        this.deleteQuestion = new EventEmitter();
        this.changeQuestions = new EventEmitter();
        this.onUploadFileAsAnswer = new EventEmitter();
        this.onRemoveFileFromAnswer = new EventEmitter();
        this.closingExternalTemplateEvent = new EventEmitter();
        this.payLoad = '';
        this.questionEdit = '';
        this.isLeftVisible = true;
        this.isUpdateFormDirty = false;
        this.isMobile = false;
        this.operation = '';
        this.beeingDragged = false;
        this.enumOperations = enumOperations;
    }
    ngOnInit() {
        this.initForm();
    }
    updateCreateOptions(options) {
        this.createOptions = enumSpecificQuestionsTypeAsArray(options);
    }
    initForm() {
        this.questions.sort((a, b) => a.order - b.order);
        if (this.questions && this.questions.length) {
            this.form = this.questionControlService.toFormGroup(this.questions);
            if (this.form) {
                this.changeForm.emit(this.form);
            }
            if (this.mode === 'update') {
                this.form.disable();
            }
            if (this._disableForm) {
                this.form.disable();
            }
            this.resolveResize(window.innerWidth);
        }
    }
    updateForm() {
        this.form = new FormGroup({});
        this.form = this.questionControlService.toFormGroup(this.questions);
        if (this.mode === 'update') {
            this.form.disable();
        }
    }
    onSubmit() {
        this.payLoad = JSON.stringify(this.form.getRawValue());
    }
    drop(event) {
        this.beeingDragged = false;
        moveItemInArray(this.questions, event.previousIndex, event.currentIndex);
        this.questions.forEach((question, index) => {
            question.order = index + 1;
        });
        this.changeForm.emit(this.form);
        this.changeQuestions.emit(this.questions);
        const aux = this.questions[event.currentIndex];
        setTimeout(() => {
            document.getElementById(`${aux.code}_div`).scrollIntoView();
        }, 10);
    }
    editQuestion(questionCode) {
        if (this.mode === 'update') {
            if (this.operation === enumOperations.create) {
                this.confirmDialogReference = this.dialogService.open(ConfirmDialogComponent, { message: 'Existem alterações não salvas que serão perdidas caso você prossiga com a edição de uma outra questão. Deseja continuar?' });
                this.confirmDialogReference.afterClosed.subscribe(res => {
                    if (res.data) {
                        const edit = this.questionEdit;
                        this.removeQuestion(edit.code);
                        this.operation = enumOperations.edit;
                        this.questionEdit = this.questions.find(question => question.code === questionCode);
                    }
                });
            }
            else {
                if (this.createUpdateQuestion?.form.invalid || this.createUpdateQuestion?.form.dirty) {
                    this.confirmDialogReference = this.dialogService.open(ConfirmDialogComponent, { message: 'Existem alterações não salvas que serão perdidas caso você prossiga com a edição de uma outra questão. Deseja continuar?' });
                    this.confirmDialogReference.afterClosed.subscribe(res => {
                        if (res.data) {
                            this.operation = enumOperations.edit;
                            this.questionEdit = this.questions.find(question => question.code === questionCode);
                        }
                    });
                }
                else {
                    this.operation = enumOperations.edit;
                    this.questionEdit = this.questions.find(question => question.code === questionCode);
                }
            }
        }
    }
    addNewQuestion(questionTypeCode) {
        if (this.mode === 'update') {
            // posso add uma nova questão se, não existir nenhum questionEdit (o q significa q não existe nenhuma question sendo editada no momento)
            // ou se o componente createUpdateQuestion estiver com formuario valido ( o q significa que a opção q está sendo editada já esta salva e nao apresenta inconsistencias)
            if (!this.questionEdit) {
                this.addQuestion(questionTypeCode);
            }
            else {
                if (this.createUpdateQuestion?.form.invalid || this.createUpdateQuestion?.form.dirty) {
                    this.confirmDialogReference = this.dialogService.open(ConfirmDialogComponent, { message: 'Existem alterações não salvas que serão perdidas caso você prossiga com a criação de uma nova questão. Deseja continuar?' });
                    this.confirmDialogReference.afterClosed.subscribe(res => {
                        if (res.data) {
                            const edit = this.questionEdit;
                            if (this.operation === enumOperations.create) {
                                this.removeQuestion(edit?.code);
                            }
                            this.questionEdit = null;
                            this.addNewQuestion(questionTypeCode);
                        }
                    });
                }
                else {
                    this.addQuestion(questionTypeCode);
                }
            }
        }
    }
    addQuestion(questionTypeCode) {
        this.operation = enumOperations.create;
        let newQuestion = null;
        switch (questionTypeCode) {
            case enumQuestionTypeCode.Descriptive:
                newQuestion = this.createNewDescriptiveQuestion();
                break;
            case enumQuestionTypeCode.Text:
                newQuestion = this.createNewTextQuestion();
                break;
            case enumQuestionTypeCode.SingleSelect:
                newQuestion = this.createNewSingleSelectQuestion();
                break;
            case enumQuestionTypeCode.Slider:
                newQuestion = this.createNewSliderQuestion();
                break;
            case enumQuestionTypeCode.MultiSelect:
                newQuestion = this.createNewMultiSelectQuestion();
                break;
            case enumQuestionTypeCode.Attachment:
                newQuestion = this.createNewAttachmentQuestion();
                break;
            case enumQuestionTypeCode.Number:
                newQuestion = this.createNewNumberQuestion();
                break;
            case enumQuestionTypeCode.InputSwitch:
                newQuestion = this.createNewInputSwitchQuestion();
                break;
        }
        if (newQuestion) {
            if (this.questionEdit) {
                newQuestion.order = this.questionEdit.order + 1;
                this.questions.splice(newQuestion.order - 1, 0, newQuestion);
                this.updateQuestionsOrder();
            }
            else {
                this.questions.push(newQuestion);
            }
            this.questionEdit = newQuestion;
            this.updateForm();
            setTimeout(() => {
                document.getElementById(`${newQuestion.code}_div`)?.scrollIntoView();
            });
        }
    }
    createNewInputSwitchQuestion() {
        return new InputSwitchQuestion({
            code: this.questionControlService.getNewUUID(),
            statement: '',
            required: false,
            order: this.questions.length + 1
        });
    }
    createNewDescriptiveQuestion() {
        return new DescriptiveQuestion({
            code: this.questionControlService.getNewUUID(),
            statement: '',
            required: false,
            type: 'textarea',
            order: this.questions.length + 1
        });
    }
    createNewTextQuestion() {
        return new TextQuestion({
            code: this.questionControlService.getNewUUID(),
            statement: '',
            required: false,
            order: this.questions.length + 1
        });
    }
    createNewNumberQuestion() {
        return new NumberQuestion({
            code: this.questionControlService.getNewUUID(),
            statement: '',
            required: false,
            order: this.questions.length + 1
        });
    }
    createNewAttachmentQuestion() {
        return new AttachmentQuestion({
            code: this.questionControlService.getNewUUID(),
            statement: '',
            required: false,
            order: this.questions.length + 1
        });
    }
    createNewSingleSelectQuestion() {
        return new SingleSelectQuestion({
            code: this.questionControlService.getNewUUID(),
            statement: '',
            required: false,
            order: this.questions.length + 1
        });
    }
    createNewMultiSelectQuestion() {
        return new MultiSelectQuestion({
            code: this.questionControlService.getNewUUID(),
            statement: '',
            required: false,
            order: this.questions.length + 1
        });
    }
    createNewSliderQuestion() {
        return new SliderQuestion({
            code: this.questionControlService.getNewUUID(),
            statement: '',
            required: false,
            order: this.questions.length + 1
        });
    }
    clickOutsideQuestion(questionCode) {
        if (this.questionEdit && this.questionEdit?.code && this.questionEdit?.code === questionCode) {
            this.questionEdit = null;
        }
    }
    resolveResize(innerWidth) {
        this.isMobile = innerWidth <= 992;
    }
    registerEditQuestionAsDirty(e) {
        this.isUpdateFormDirty = e;
    }
    confirmQuestionUpdate(question) {
        if (!this.isUpdateFormDirty && this.operation === enumOperations.edit) {
            // this.questionEdit = '';
            return;
        }
        if (this.operation === enumOperations.edit) {
            this.confirmDialogReference = this.dialogService.open(ConfirmDialogComponent, {
                message: 'Foram feitas alterações nesta questão, deseja salvar essas alterações?'
            });
            this.confirmDialogReference.afterClosed.subscribe(res => {
                if (res.data) {
                    this.saveQuestion(question);
                }
            });
        }
        else {
            this.saveQuestion(question);
        }
    }
    saveQuestion(question) {
        this.isUpdateFormDirty = false;
        this.questionEdit = null;
        const indexEditedQuestion = this.questions.findIndex(q => q.code === question.code);
        this.questions[indexEditedQuestion] = question;
        this.updateForm();
        this.changeForm.emit(this.form);
        if (this.operation === enumOperations.create) {
            this.createQuestion.emit(question);
        }
        else if (this.operation === enumOperations.edit) {
            this.updateQuestion.emit(question);
        }
        this.operation = '';
    }
    confirmDeleteQuestion(questionCode) {
        if (this.operation === enumOperations.create) {
            this.confirmCancelQuestionUpdate(questionCode);
        }
        else {
            this.confirmDialogReference = this.dialogService.open(ConfirmDialogComponent, { message: 'Deseja prosseguir com a exclusão desta questão?' });
            this.confirmDialogReference.afterClosed.subscribe(res => {
                if (res.data) {
                    this.removeQuestion(questionCode);
                    this.deleteQuestion.emit(questionCode);
                    this.changeForm.emit(this.form);
                    this.operation = '';
                }
            });
        }
    }
    confirmCancelQuestionUpdate(questionCode) {
        if (!this.isUpdateFormDirty && (this.operation === enumOperations.edit || this.operation === enumOperations.create)) {
            if (this.operation === enumOperations.create) {
                const indexRemoveQuestion = this.questions.findIndex(q => q.code === questionCode);
                this.questions.splice(indexRemoveQuestion, 1);
            }
            this.questionEdit = '';
            this.operation = '';
            return;
        }
        this.confirmDialogReference = this.dialogService.open(ConfirmDialogComponent, {
            message: 'Existem alterações não salvas que serão perdidas caso você prossiga com o cancelamento dessa questão. Deseja continuar?'
        });
        this.confirmDialogReference.afterClosed.subscribe(res => {
            if (res.data) {
                if (this.operation === enumOperations.create) {
                    this.removeQuestion(questionCode);
                }
                this.isUpdateFormDirty = false;
                this.questionEdit = null;
                this.operation = '';
            }
        });
    }
    removeQuestion(questionCode) {
        const indexRemoveQuestion = this.questions.findIndex(q => q.code === questionCode);
        this.questions.splice(indexRemoveQuestion, 1);
        this.updateQuestionsOrder();
        this.form.removeControl(questionCode);
    }
    updateQuestionsOrder() {
        this.questions.forEach((question, index) => {
            question.order = index + 1;
        });
    }
    mouseDownDragHadle() {
        if (!this.beeingDragged) {
            this.beeingDragged = true;
        }
    }
    onUploadFile(files) {
        this.onUploadFileAsAnswer.emit(files);
    }
    onRemoveFile(fileRemoveInfo) {
        this.onRemoveFileFromAnswer.emit(fileRemoveInfo);
    }
    clickIndividualSave(code) {
        this.questionIndividualSaveEvent.emit(code);
    }
    clickResetQuestion(code) {
        this.questionResetEvent.emit(code);
    }
    openTemplate(code) {
        this.showExternalTemplateEvent.emit(code);
        this.showTemplateCode = code;
    }
    closeExternalTemplate() {
        this.showTemplateCode = null;
        this.closingExternalTemplateEvent.emit(true);
    }
    onResize(event) {
        this.resolveResize(event.target.innerWidth);
    }
    mouseUp(event) {
        if (this.beeingDragged) {
            this.beeingDragged = false;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDynamicFormComponent, deps: [{ token: QuestionControlService }, { token: CnetDialogService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetDynamicFormComponent, selector: "cnet-dynamic-form", inputs: { questions: "questions", mode: "mode", disableForm: "disableForm", questionsTypesAllowed: "questionsTypesAllowed", externalTemplate: "externalTemplate", showQuestionsNumber: "showQuestionsNumber", showDivider: "showDivider", labelButtonExternalTemplate: "labelButtonExternalTemplate", iconButtonExternalTemplate: "iconButtonExternalTemplate", hasQuestionReset: "hasQuestionReset", labelButtonReset: "labelButtonReset", iconButtonReset: "iconButtonReset", hasQuestionIndividualSave: "hasQuestionIndividualSave", labelButtonIndividualSave: "labelButtonIndividualSave", iconButtonIndividualSave: "iconButtonIndividualSave", useDefaultLabel: "useDefaultLabel" }, outputs: { questionResetEvent: "questionResetEvent", questionIndividualSaveEvent: "questionIndividualSaveEvent", showExternalTemplateEvent: "showExternalTemplateEvent", changeForm: "changeForm", createQuestion: "createQuestion", updateQuestion: "updateQuestion", deleteQuestion: "deleteQuestion", changeQuestions: "changeQuestions", onUploadFileAsAnswer: "onUploadFileAsAnswer", onRemoveFileFromAnswer: "onRemoveFileFromAnswer", closingExternalTemplateEvent: "closingExternalTemplateEvent" }, host: { listeners: { "window:resize": "onResize($event)", "window:mouseup": "mouseUp($event)" } }, viewQueries: [{ propertyName: "createUpdateQuestion", first: true, predicate: CnetCreateUpdateQuestionComponent, descendants: true }], ngImport: i0, template: "<div class=\"container\">\n  <form (ngSubmit)=\"onSubmit()\" [formGroup]=\"form\" *ngIf=\"form\">\n    <div cdkDropList class=\"question-list\" (cdkDropListDropped)=\"drop($event)\" [cdkDropListDisabled]=\"mode==='answer'\">\n      <div *ngFor=\"let question of questions\" class=\"form-row\" [id]=\"question.code+'_div'\" cdkDrag\n        [cdkDragDisabled]=\"!!questionEdit && question.code === questionEdit?.code\">\n\n        <div class=\"question-cdk-drag-placeholder\" *cdkDragPlaceholder></div>\n\n        <div *cdkDragPreview>\n\n          <ng-container *ngIf=\"question?.required; else statmentElse\">\n            <label [attr.for]=\"question?.code\" cnetRequiredMark>\n              <ng-container *ngIf=\"showQuestionsNumber\">{{question?.order}}.</ng-container>\n              {{question?.statement}}\n            </label>\n\n          </ng-container>\n          <ng-template #statmentElse>\n            <label [attr.for]=\"question?.code\">\n              <ng-container *ngIf=\"showQuestionsNumber\">{{question?.order}}.</ng-container>\n              {{question?.statement}}\n            </label>\n\n          </ng-template>\n\n\n        </div>\n\n        <ng-container *ngIf=\"beeingDragged; else tempalteNotDragged\">\n\n          <div class=\"card-not-beeing-dragged\">\n            <ng-container *ngIf=\"question?.required else elseTemplatedragged\">\n\n              <label [attr.for]=\"question?.code\" cnetRequiredMark>\n                <ng-container *ngIf=\"showQuestionsNumber\">{{question?.order}}.</ng-container>\n                {{question?.statement}}\n              </label>\n            </ng-container>\n            <ng-template #elseTemplatedragged>\n              <label [attr.for]=\"question?.code\">\n                <ng-container *ngIf=\"showQuestionsNumber\">{{question?.order}}.</ng-container>\n                {{question?.statement}}\n              </label>\n\n            </ng-template>\n\n\n          </div>\n\n        </ng-container>\n\n        <ng-template #tempalteNotDragged>\n\n          <div [hidden]=\"questionEdit && question.code === questionEdit?.code\">\n            <div *ngIf=\"mode==='update'\">\n              <div class=\"dragArea\" cdkDragHandle (mousedown)=\"mouseDownDragHadle()\">\n                <cnet-icon name=\"reorder\" label=\"reorder\"></cnet-icon>\n              </div>\n            </div>\n\n            <div class=\"style-question\" (click)=\"editQuestion(question?.code)\"\n              [class.style-question-answer]=\"mode === 'answer'\">\n\n              <span @toggleToUpdateQuestion\n                *ngIf=\"externalTemplate && showTemplateCode && showTemplateCode === question.code; else elseTemplate\">\n                <cnet-external-template-container [question]=\"question\" [showQuestionsNumber]=\"showQuestionsNumber\"\n                  (closingExternalTemplateEvent)=\"closeExternalTemplate()\">\n                  <ng-container *ngTemplateOutlet=\"externalTemplate; context: {code: showTemplateCode}\"></ng-container>\n                </cnet-external-template-container>\n              </span>\n              <ng-template #elseTemplate>\n                <span @toggleToUpdateQuestion>\n\n                  <cnet-dynamic-form-question *ngIf=\"!(questionEdit && question.code === questionEdit?.code)\"\n                    [question]=\"question\" [form]=\"form\" [showQuestionsNumber]=\"showQuestionsNumber\"\n                    [hasExternalTemplate]=\"externalTemplate\" [labelButtonExternalTemplate]=\"labelButtonExternalTemplate\"\n                    [iconButtonExternalTemplate]=\"iconButtonExternalTemplate\" (onUpload)=\"onUploadFile($event)\"\n                    (onRemoveFileFromAnswer)=\"onRemoveFile($event)\" (onOpenTemplate)=\"openTemplate($event)\"\n                    [hasQuestionReset]=\"hasQuestionReset\" [labelButtonReset]=\"labelButtonReset\"\n                    [iconButtonReset]=\"iconButtonReset\" [hasQuestionIndividualSave]=\"hasQuestionIndividualSave\"\n                    [labelButtonIndividualSave]=\"labelButtonIndividualSave\"\n                    [iconButtonIndividualSave]=\"iconButtonIndividualSave\"\n                    [useDefaultLabel]=\"useDefaultLabel\"\n                    (questionResetEvent)=\"clickResetQuestion($event)\"\n                    (questionIndividualSaveEvent)=\"clickIndividualSave($event)\"\n                    ></cnet-dynamic-form-question>\n                </span>\n              </ng-template>\n\n            </div>\n          </div>\n\n          <div *ngIf=\"questionEdit && question.code === questionEdit?.code && mode==='update'\" @toggleToUpdateQuestion>\n\n            <cnet-create-update-question cdkDragDisabled [question]=\"questionEdit\"\n              [showQuestionsNumber]=\"showQuestionsNumber\" (onDirty)=\"registerEditQuestionAsDirty($event)\"\n              (submitQuestion)=\"confirmQuestionUpdate($event)\" (cancel)=\"confirmCancelQuestionUpdate($event)\"\n              (delete)=\"confirmDeleteQuestion($event)\">\n            </cnet-create-update-question>\n\n            <button type=\"button\" cnet-filled-button color=\"success\" class=\"btn btn-success\" [cnet-menu-trigger]=\"menu\">\n              <cnet-icon name=\"plus\"></cnet-icon>\n              <div style=\"margin-top: 4px;\">\n                {{'Inserir novo'|translate}}\n              </div>\n            </button>\n          </div>\n\n        </ng-template>\n\n\n        <cnet-divider *ngIf=\"showDivider\"></cnet-divider>\n      </div>\n\n    </div>\n  </form>\n\n  <div *ngIf=\"mode==='update' && (this.operation !== enumOperations.edit && this.operation !== enumOperations.create);\">\n    <button type=\"button\" cnet-filled-button color=\"success\" class=\"btn btn-success\" [cnet-menu-trigger]=\"menu\">\n      <cnet-icon name=\"plus\"></cnet-icon>\n      <div style=\"margin-top: 4px;\">\n        {{'Nova quest\u00E3o'|translate}}\n      </div>\n    </button>\n  </div>\n  <cnet-menu #menu [cnet-bottom-sheet]=\"isMobile\">\n    <button cnet-menu-item *ngFor=\"let option of createOptions\" (click)=\"addNewQuestion(option.value)\">{{option.label\n      | translate}}</button>\n  </cnet-menu>\n\n</div>\n", styles: [".container{background:#fff;padding:20px}.form-row{margin-top:24px;height:auto}.form-row:hover .dragArea{color:var(--cnet--50, #fafafa);background-color:var(--cnet-primary-400, #95ca69)}.form-row:hover .style-question{background:var(--cnet--200, #eeeeee)}.form-row:hover .style-question-answer{background:transparent}.form-row.cdk-drag-preview .dragArea{pointer-events:auto;cursor:grabbing;color:var(--cnet--50, #fafafa);background-color:var(--cnet-primary-400, #95ca69)}.dragArea{display:flex;flex-direction:row;align-items:center;justify-content:center;padding:8px;cursor:grab;touch-action:none;-webkit-user-drag:none;-webkit-tap-highlight-color:transparent;-webkit-user-select:none;user-select:none}.cdk-drag-preview{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.question-list:last-child{margin-bottom:40px}.cdk-drag-preview{width:50%;background-color:#fff;cursor:grabbing;margin:0;padding:12px;position:absolute;left:0;box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-preview label{font-size:1.125rem}.question-cdk-drag-placeholder{margin-top:24px;background:#ccc;border:dotted 3px #999;min-height:60px;transition:transform .25s cubic-bezier(0,0,.2,1)}.question-list.cdk-drop-list-dragging .form-row:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.card-not-beeing-dragged{width:100%;height:60px;background-color:#fff;padding:12px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.card-not-beeing-dragged label{font-size:1.125rem}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i1$4.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i5.CdkDropList, selector: "[cdkDropList], cdk-drop-list", inputs: ["cdkDropListConnectedTo", "cdkDropListData", "cdkDropListOrientation", "id", "cdkDropListLockAxis", "cdkDropListDisabled", "cdkDropListSortingDisabled", "cdkDropListEnterPredicate", "cdkDropListSortPredicate", "cdkDropListAutoScrollDisabled", "cdkDropListAutoScrollStep"], outputs: ["cdkDropListDropped", "cdkDropListEntered", "cdkDropListExited", "cdkDropListSorted"], exportAs: ["cdkDropList"] }, { kind: "directive", type: i5.CdkDrag, selector: "[cdkDrag]", inputs: ["cdkDragData", "cdkDragLockAxis", "cdkDragRootElement", "cdkDragBoundary", "cdkDragStartDelay", "cdkDragFreeDragPosition", "cdkDragDisabled", "cdkDragConstrainPosition", "cdkDragPreviewClass", "cdkDragPreviewContainer"], outputs: ["cdkDragStarted", "cdkDragReleased", "cdkDragEnded", "cdkDragEntered", "cdkDragExited", "cdkDragDropped", "cdkDragMoved"], exportAs: ["cdkDrag"] }, { kind: "directive", type: i5.CdkDragHandle, selector: "[cdkDragHandle]", inputs: ["cdkDragHandleDisabled"] }, { kind: "directive", type: i5.CdkDragPreview, selector: "ng-template[cdkDragPreview]", inputs: ["data", "matchSize"] }, { kind: "directive", type: i5.CdkDragPlaceholder, selector: "ng-template[cdkDragPlaceholder]", inputs: ["data"] }, { kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "directive", type: RequiredMarkDirective, selector: "[cnetRequiredMark]", inputs: ["show"] }, { kind: "component", type: CnetMenuComponent, selector: "cnet-menu", inputs: ["cnet-bottom-sheet", "cnet-overlay", "cnet-remove-on-scroll"], exportAs: ["cnetMenu"] }, { kind: "directive", type: CnetMenuTriggerDirective, selector: "[CnetMenuTrigger], [cnet-menu-trigger]", inputs: ["cnet-menu-trigger"], exportAs: ["cnetMenuTrigger"] }, { kind: "component", type: CnetMenuItemComponent, selector: "cnet-menu-item, [CnetMenuItem], [cnet-menu-item]", inputs: ["disabled"], exportAs: ["cnetMenuItem"] }, { kind: "component", type: CnetDividerComponent, selector: "cnet-divider, [cnet-divider], cnetDivider", inputs: ["vertical"], exportAs: ["cnetDivider"] }, { kind: "component", type: CnetDynamicFormQuestionComponent, selector: "cnet-dynamic-form-question", inputs: ["question", "form", "showQuestionsNumber", "hasExternalTemplate", "labelButtonExternalTemplate", "iconButtonExternalTemplate", "useDefaultLabel", "hasQuestionReset", "labelButtonReset", "iconButtonReset", "hasQuestionIndividualSave", "labelButtonIndividualSave", "iconButtonIndividualSave"], outputs: ["onUpload", "onRemoveFileFromAnswer", "onOpenTemplate", "questionResetEvent", "questionIndividualSaveEvent"] }, { kind: "component", type: CnetCreateUpdateQuestionComponent, selector: "cnet-create-update-question", inputs: ["question", "showQuestionsNumber"], outputs: ["onDirty", "submitQuestion", "cancel", "delete"] }, { kind: "component", type: ExternalTemplateContainerComponent, selector: "cnet-external-template-container", inputs: ["question", "showQuestionsNumber"], outputs: ["closingExternalTemplateEvent"] }, { kind: "pipe", type: i1$3.TranslatePipe, name: "translate" }], animations: [updateQuestionToggleAnimation] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDynamicFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-dynamic-form', animations: [updateQuestionToggleAnimation], template: "<div class=\"container\">\n  <form (ngSubmit)=\"onSubmit()\" [formGroup]=\"form\" *ngIf=\"form\">\n    <div cdkDropList class=\"question-list\" (cdkDropListDropped)=\"drop($event)\" [cdkDropListDisabled]=\"mode==='answer'\">\n      <div *ngFor=\"let question of questions\" class=\"form-row\" [id]=\"question.code+'_div'\" cdkDrag\n        [cdkDragDisabled]=\"!!questionEdit && question.code === questionEdit?.code\">\n\n        <div class=\"question-cdk-drag-placeholder\" *cdkDragPlaceholder></div>\n\n        <div *cdkDragPreview>\n\n          <ng-container *ngIf=\"question?.required; else statmentElse\">\n            <label [attr.for]=\"question?.code\" cnetRequiredMark>\n              <ng-container *ngIf=\"showQuestionsNumber\">{{question?.order}}.</ng-container>\n              {{question?.statement}}\n            </label>\n\n          </ng-container>\n          <ng-template #statmentElse>\n            <label [attr.for]=\"question?.code\">\n              <ng-container *ngIf=\"showQuestionsNumber\">{{question?.order}}.</ng-container>\n              {{question?.statement}}\n            </label>\n\n          </ng-template>\n\n\n        </div>\n\n        <ng-container *ngIf=\"beeingDragged; else tempalteNotDragged\">\n\n          <div class=\"card-not-beeing-dragged\">\n            <ng-container *ngIf=\"question?.required else elseTemplatedragged\">\n\n              <label [attr.for]=\"question?.code\" cnetRequiredMark>\n                <ng-container *ngIf=\"showQuestionsNumber\">{{question?.order}}.</ng-container>\n                {{question?.statement}}\n              </label>\n            </ng-container>\n            <ng-template #elseTemplatedragged>\n              <label [attr.for]=\"question?.code\">\n                <ng-container *ngIf=\"showQuestionsNumber\">{{question?.order}}.</ng-container>\n                {{question?.statement}}\n              </label>\n\n            </ng-template>\n\n\n          </div>\n\n        </ng-container>\n\n        <ng-template #tempalteNotDragged>\n\n          <div [hidden]=\"questionEdit && question.code === questionEdit?.code\">\n            <div *ngIf=\"mode==='update'\">\n              <div class=\"dragArea\" cdkDragHandle (mousedown)=\"mouseDownDragHadle()\">\n                <cnet-icon name=\"reorder\" label=\"reorder\"></cnet-icon>\n              </div>\n            </div>\n\n            <div class=\"style-question\" (click)=\"editQuestion(question?.code)\"\n              [class.style-question-answer]=\"mode === 'answer'\">\n\n              <span @toggleToUpdateQuestion\n                *ngIf=\"externalTemplate && showTemplateCode && showTemplateCode === question.code; else elseTemplate\">\n                <cnet-external-template-container [question]=\"question\" [showQuestionsNumber]=\"showQuestionsNumber\"\n                  (closingExternalTemplateEvent)=\"closeExternalTemplate()\">\n                  <ng-container *ngTemplateOutlet=\"externalTemplate; context: {code: showTemplateCode}\"></ng-container>\n                </cnet-external-template-container>\n              </span>\n              <ng-template #elseTemplate>\n                <span @toggleToUpdateQuestion>\n\n                  <cnet-dynamic-form-question *ngIf=\"!(questionEdit && question.code === questionEdit?.code)\"\n                    [question]=\"question\" [form]=\"form\" [showQuestionsNumber]=\"showQuestionsNumber\"\n                    [hasExternalTemplate]=\"externalTemplate\" [labelButtonExternalTemplate]=\"labelButtonExternalTemplate\"\n                    [iconButtonExternalTemplate]=\"iconButtonExternalTemplate\" (onUpload)=\"onUploadFile($event)\"\n                    (onRemoveFileFromAnswer)=\"onRemoveFile($event)\" (onOpenTemplate)=\"openTemplate($event)\"\n                    [hasQuestionReset]=\"hasQuestionReset\" [labelButtonReset]=\"labelButtonReset\"\n                    [iconButtonReset]=\"iconButtonReset\" [hasQuestionIndividualSave]=\"hasQuestionIndividualSave\"\n                    [labelButtonIndividualSave]=\"labelButtonIndividualSave\"\n                    [iconButtonIndividualSave]=\"iconButtonIndividualSave\"\n                    [useDefaultLabel]=\"useDefaultLabel\"\n                    (questionResetEvent)=\"clickResetQuestion($event)\"\n                    (questionIndividualSaveEvent)=\"clickIndividualSave($event)\"\n                    ></cnet-dynamic-form-question>\n                </span>\n              </ng-template>\n\n            </div>\n          </div>\n\n          <div *ngIf=\"questionEdit && question.code === questionEdit?.code && mode==='update'\" @toggleToUpdateQuestion>\n\n            <cnet-create-update-question cdkDragDisabled [question]=\"questionEdit\"\n              [showQuestionsNumber]=\"showQuestionsNumber\" (onDirty)=\"registerEditQuestionAsDirty($event)\"\n              (submitQuestion)=\"confirmQuestionUpdate($event)\" (cancel)=\"confirmCancelQuestionUpdate($event)\"\n              (delete)=\"confirmDeleteQuestion($event)\">\n            </cnet-create-update-question>\n\n            <button type=\"button\" cnet-filled-button color=\"success\" class=\"btn btn-success\" [cnet-menu-trigger]=\"menu\">\n              <cnet-icon name=\"plus\"></cnet-icon>\n              <div style=\"margin-top: 4px;\">\n                {{'Inserir novo'|translate}}\n              </div>\n            </button>\n          </div>\n\n        </ng-template>\n\n\n        <cnet-divider *ngIf=\"showDivider\"></cnet-divider>\n      </div>\n\n    </div>\n  </form>\n\n  <div *ngIf=\"mode==='update' && (this.operation !== enumOperations.edit && this.operation !== enumOperations.create);\">\n    <button type=\"button\" cnet-filled-button color=\"success\" class=\"btn btn-success\" [cnet-menu-trigger]=\"menu\">\n      <cnet-icon name=\"plus\"></cnet-icon>\n      <div style=\"margin-top: 4px;\">\n        {{'Nova quest\u00E3o'|translate}}\n      </div>\n    </button>\n  </div>\n  <cnet-menu #menu [cnet-bottom-sheet]=\"isMobile\">\n    <button cnet-menu-item *ngFor=\"let option of createOptions\" (click)=\"addNewQuestion(option.value)\">{{option.label\n      | translate}}</button>\n  </cnet-menu>\n\n</div>\n", styles: [".container{background:#fff;padding:20px}.form-row{margin-top:24px;height:auto}.form-row:hover .dragArea{color:var(--cnet--50, #fafafa);background-color:var(--cnet-primary-400, #95ca69)}.form-row:hover .style-question{background:var(--cnet--200, #eeeeee)}.form-row:hover .style-question-answer{background:transparent}.form-row.cdk-drag-preview .dragArea{pointer-events:auto;cursor:grabbing;color:var(--cnet--50, #fafafa);background-color:var(--cnet-primary-400, #95ca69)}.dragArea{display:flex;flex-direction:row;align-items:center;justify-content:center;padding:8px;cursor:grab;touch-action:none;-webkit-user-drag:none;-webkit-tap-highlight-color:transparent;-webkit-user-select:none;user-select:none}.cdk-drag-preview{box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-animating{transition:transform .25s cubic-bezier(0,0,.2,1)}.question-list:last-child{margin-bottom:40px}.cdk-drag-preview{width:50%;background-color:#fff;cursor:grabbing;margin:0;padding:12px;position:absolute;left:0;box-sizing:border-box;border-radius:4px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.cdk-drag-preview label{font-size:1.125rem}.question-cdk-drag-placeholder{margin-top:24px;background:#ccc;border:dotted 3px #999;min-height:60px;transition:transform .25s cubic-bezier(0,0,.2,1)}.question-list.cdk-drop-list-dragging .form-row:not(.cdk-drag-placeholder){transition:transform .25s cubic-bezier(0,0,.2,1)}.card-not-beeing-dragged{width:100%;height:60px;background-color:#fff;padding:12px;box-shadow:0 5px 5px -3px #0003,0 8px 10px 1px #00000024,0 3px 14px 2px #0000001f}.card-not-beeing-dragged label{font-size:1.125rem}\n"] }]
        }], ctorParameters: () => [{ type: QuestionControlService }, { type: CnetDialogService }], propDecorators: { questions: [{
                type: Input
            }], mode: [{
                type: Input
            }], disableForm: [{
                type: Input
            }], questionsTypesAllowed: [{
                type: Input
            }], externalTemplate: [{
                type: Input
            }], showQuestionsNumber: [{
                type: Input
            }], showDivider: [{
                type: Input
            }], labelButtonExternalTemplate: [{
                type: Input
            }], iconButtonExternalTemplate: [{
                type: Input
            }], hasQuestionReset: [{
                type: Input
            }], labelButtonReset: [{
                type: Input
            }], iconButtonReset: [{
                type: Input
            }], hasQuestionIndividualSave: [{
                type: Input
            }], labelButtonIndividualSave: [{
                type: Input
            }], iconButtonIndividualSave: [{
                type: Input
            }], useDefaultLabel: [{
                type: Input
            }], questionResetEvent: [{
                type: Output
            }], questionIndividualSaveEvent: [{
                type: Output
            }], showExternalTemplateEvent: [{
                type: Output
            }], changeForm: [{
                type: Output
            }], createQuestion: [{
                type: Output
            }], updateQuestion: [{
                type: Output
            }], deleteQuestion: [{
                type: Output
            }], changeQuestions: [{
                type: Output
            }], onUploadFileAsAnswer: [{
                type: Output
            }], onRemoveFileFromAnswer: [{
                type: Output
            }], closingExternalTemplateEvent: [{
                type: Output
            }], createUpdateQuestion: [{
                type: ViewChild,
                args: [CnetCreateUpdateQuestionComponent]
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }], mouseUp: [{
                type: HostListener,
                args: ['window:mouseup', ['$event']]
            }] } });

class CnetInputSwitchModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetInputSwitchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetInputSwitchModule, declarations: [CnetInputSwitchComponent, CnetInputForInputSwitchDirective], imports: [CommonModule,
            ReactiveFormsModule], exports: [CnetInputSwitchComponent, CnetInputForInputSwitchDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetInputSwitchModule, imports: [CommonModule,
            ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetInputSwitchModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetInputSwitchComponent, CnetInputForInputSwitchDirective],
                    exports: [CnetInputSwitchComponent, CnetInputForInputSwitchDirective],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule
                    ]
                }]
        }] });

class CnetDynamicFormModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDynamicFormModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetDynamicFormModule, declarations: [CnetDynamicFormComponent,
            CnetDynamicFormQuestionComponent,
            CnetCreateUpdateQuestionComponent,
            ExternalTemplateContainerComponent], imports: [CommonModule,
            ReactiveFormsModule,
            DragDropModule,
            CnetButtonModule,
            CnetIconModule,
            CnetFormFieldModule,
            CnetCardModule,
            RequiredMarkModule,
            TranslateModule,
            CnetRadioModule,
            AscIIToCharModule,
            CnetMenuModule,
            CnetInputModule,
            CnetCheckboxModule,
            ClickOutsideModule,
            ConfirmDialogModule,
            CnetDynamicListModule,
            CnetSliderOldModule,
            CnetFileUploadModule,
            CnetDividerModule,
            CnetInputSwitchModule], exports: [CnetDynamicFormComponent,
            CnetCreateUpdateQuestionComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDynamicFormModule, imports: [CommonModule,
            ReactiveFormsModule,
            DragDropModule,
            CnetButtonModule,
            CnetIconModule,
            CnetFormFieldModule,
            CnetCardModule,
            RequiredMarkModule,
            TranslateModule,
            CnetRadioModule,
            AscIIToCharModule,
            CnetMenuModule,
            CnetInputModule,
            CnetCheckboxModule,
            ClickOutsideModule,
            ConfirmDialogModule,
            CnetDynamicListModule,
            CnetSliderOldModule,
            CnetFileUploadModule,
            CnetDividerModule,
            CnetInputSwitchModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetDynamicFormModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnetDynamicFormComponent,
                        CnetDynamicFormQuestionComponent,
                        CnetCreateUpdateQuestionComponent,
                        ExternalTemplateContainerComponent,
                    ],
                    exports: [
                        CnetDynamicFormComponent,
                        CnetCreateUpdateQuestionComponent,
                    ],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        DragDropModule,
                        CnetButtonModule,
                        CnetIconModule,
                        CnetFormFieldModule,
                        CnetCardModule,
                        RequiredMarkModule,
                        TranslateModule,
                        CnetRadioModule,
                        AscIIToCharModule,
                        CnetMenuModule,
                        CnetInputModule,
                        CnetCheckboxModule,
                        ClickOutsideModule,
                        ConfirmDialogModule,
                        CnetDynamicListModule,
                        CnetSliderOldModule,
                        CnetFileUploadModule,
                        CnetDividerModule,
                        CnetInputSwitchModule
                    ]
                }]
        }] });

/**
 * Pipe utilizado para retonar uma url higienizada pelo angular. esta higienização serve para proteger
 * de Cross-site Scripting (XSS)
 */
class SanitizerUrlPipe {
    constructor(_sanitizer) {
        this._sanitizer = _sanitizer;
    }
    transform(url, type) {
        if (url) {
            switch (type) {
                case 'html':
                    return this._sanitizer.bypassSecurityTrustHtml(url);
                case 'style':
                    return this._sanitizer.bypassSecurityTrustStyle(url);
                case 'script':
                    return this._sanitizer.bypassSecurityTrustScript(url);
                case 'url':
                    return this._sanitizer.bypassSecurityTrustResourceUrl(url);
                case 'resourceUrl':
                    return this._sanitizer.bypassSecurityTrustResourceUrl(url);
                default:
                    return this._sanitizer.bypassSecurityTrustHtml(url);
            }
        }
        else {
            return this._sanitizer.bypassSecurityTrustResourceUrl('');
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SanitizerUrlPipe, deps: [{ token: i1$8.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: SanitizerUrlPipe, name: "sanitizerUrl", pure: false }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SanitizerUrlPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'sanitizerUrl',
                    pure: false
                }]
        }], ctorParameters: () => [{ type: i1$8.DomSanitizer }] });

class SanitizerUrlModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SanitizerUrlModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: SanitizerUrlModule, declarations: [SanitizerUrlPipe], imports: [CommonModule], exports: [SanitizerUrlPipe] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SanitizerUrlModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SanitizerUrlModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SanitizerUrlPipe],
                    exports: [SanitizerUrlPipe],
                    imports: [
                        CommonModule
                    ]
                }]
        }] });

const IMAGE_CROPPER_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CnetImageCropperComponent),
    multi: true
};
class CnetImageCropperComponent {
    /** @ignore */
    onChange() {
        this.onChangeFn(this.value);
    }
    /**
      * Value for the file upload
      *
      * @readonly
      * type {boolean}
      * @memberof CnetFileUploadComponent
      */
    get value() { return this._value; }
    set value(value) {
        this._value = value;
        if (value) {
            if (typeof value === "string") {
                this.srcUrl = value;
            }
            else if (value instanceof File) {
                this.srcUrl = URL.createObjectURL(value);
            }
            else {
                this.srcUrl = null;
                this._value = null;
            }
        }
        else {
            this.srcUrl = null;
            this._value = null;
        }
        this.onChange();
        this.onTouchedFn();
    }
    /// ================================= <END VALUE ACCESSOR> ====================
    constructor(overlayService) {
        this.overlayService = overlayService;
        this.defaultAvatar = "./assets/images/default_company_logo.png";
        this.minHeight = 200;
        this.minWidth = 200;
        this.cropperMinHeight = 200;
        this.cropperMinWidth = 200;
        this.resizeToWidth = 200;
        this.outputFormat = 'png';
        this.imageDimensionMessageError = "O tamanho da imagem deve ser no mínimo de 200px X 200px";
        this.changeImageLabel = "Alterar imagem";
        this.cropperImageDialogHeader = "Recortar a foto";
        this.croppedImageVisualizeLabel = "Visualizar";
        this.saveButtonLabel = "Salvar";
        this.cancelButtonLabel = "Cancelar";
        this.accept = 'image/*';
        this.removeImage = new EventEmitter();
        //==========================================================================
        this.showDeleteButton = false;
        this.zoom = 0;
        this.zoonSliderOptions = {
            floor: 0,
            ceil: 100,
            vertical: true,
            animateOnMove: true,
            hidePointerLabels: true,
            translate: (value, label) => {
                switch (label) {
                    case LabelType.Floor:
                        return '<i class="las la-search-minus fa-lg" ng-reflect-ng-class="las la-search-minus,fa-lg"></i>';
                    case LabelType.Ceil:
                        return '<i class="las la-search-plus fa-lg" ng-reflect-ng-class="las la-search-plus,fa-lg"></i>';
                    default:
                        return '' + value;
                }
            }
        };
        this.rotationSliderOptions = {
            floor: 0,
            ceil: 180,
            animateOnMove: true,
            translate: (value, label) => {
                // switch (label) {
                //   case LabelType.Floor:
                //     return  value + '°' + '<i class="las la-search-plus fa-lg" ng-reflect-ng-class="las la-search-plus,fa-lg"></i>';
                //   case LabelType.Ceil:
                //     return value + '°' + '<img src="./assets/images/round-arrow-right.svg" />';
                //   default:
                //     return value + '°';
                //   }
                return value + '°';
            }
        };
        this.test = '40vw';
        this.showImageDimensionError = false;
        this.srcUrl = '';
        this.isMobile = false;
        // ================================================================
        this.croppedImage = '';
        this.imageChangedEvent = '';
        this.canvasRotation = 0;
        this.rotation = 0;
        this.scale = 1;
        this.showCropper = false;
        this.containWithinAspectRatio = false;
        this.transform = {};
        this.originalImageWidth = 0;
        this.originalImageHeight = 0;
        /// ================================= <VALUE ACCESSOR> ====================
        this.disabled = false;
        /** @ignore */
        this.onChangeFn = (_) => { };
        /** @ignore */
        this.onTouchedFn = () => { };
        this.resolveResize(window.innerWidth);
    }
    fileChangeEvent(fileEvent) {
        let img = new Image();
        img.src = URL.createObjectURL(fileEvent.target.files[0]);
        img.onload = (event) => {
            let loadedImage = event.currentTarget;
            this.originalImageWidth = loadedImage.width;
            this.originalImageHeight = loadedImage.height;
            this.showImageDimensionError = this.originalImageWidth < 200 || this.originalImageHeight < 200;
            if (!this.showImageDimensionError) {
                this.openDialogFromTemplate(this.templateDialog, fileEvent);
            }
        };
    }
    imageCropped(event) {
        this.croppedImage = event.base64;
    }
    imageLoaded() {
        this.showCropper = true;
        this.test = '39vw';
        setTimeout(() => {
            this.test = `100%`;
        }, 180);
    }
    cropperReady(sourceImageDimensions) {
    }
    loadImageFailed() {
        console.log('Load failed');
    }
    reset() {
        this.canvasRotation = 0;
        this.flipAfterRotate();
    }
    flipAfterRotate() {
        const flippedH = this.transform.flipH;
        const flippedV = this.transform.flipV;
        this.transform = {
            ...this.transform,
            flipH: flippedV,
            flipV: flippedH
        };
    }
    resetImage() {
        this.scale = 1;
        this.rotation = 0;
        this.canvasRotation = 0;
        this.transform = {};
    }
    toggleContainWithinAspectRatio() {
        this.containWithinAspectRatio = !this.containWithinAspectRatio;
    }
    updateRotation() {
        this.transform = {
            ...this.transform,
            rotate: this.rotation
        };
    }
    updateZoom() {
        this.scale = 1 + this.zoom / 10;
        this.transform = {
            ...this.transform,
            scale: this.scale
        };
    }
    openDialogFromTemplate(content, event) {
        this.zoom = 0;
        this.rotation = 0;
        this.croppedImage = null;
        this.imageChangedEvent = event;
        this.resetImage();
        this.reset();
        const ref = this.overlayService.open(content, null, true);
        ref.afterClosed.subscribe(res => {
            this.fileInput.nativeElement.value = "";
            if (res.data && res.data === 'save') {
                this.saveChanges();
            }
        });
    }
    resetToDefault() {
        this.removeImage.emit(this.croppedImage);
        // this.croppedImage = '';
        // this.fileInput.nativeElement.value = "";
        // this.srcUrl = '';
    }
    saveChanges() {
        const blob = base64ToFile(this.croppedImage);
        this.value = new File([blob], "avatar");
    }
    //================================================ value acessor functions ================================
    writeValue(value) {
        this.value = value;
    }
    /**
       * Registers a callback function is called by the forms API on functions disable and enable.
       *
       * param {*} fn
       * @memberof CnetFileUploadComponent
       */
    setDisabledState(idDisabled) {
        // TODO: AVALIAR O Q DEVE ACONTECER QUANDO ESTIVER DESABILITADO
        this.disabled = idDisabled;
    }
    /**
       * Registers a callback function that is called when the control's value changes in the UI.
       *
       * param {*} fn
       * @memberof CnetFileUploadComponent
       */
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    registerOnTouched(fn) {
    }
    onResize(event) {
        this.resolveResize(event.target.innerWidth);
    }
    resolveResize(innerWidth) {
        if (innerWidth <= 992) {
            this.isMobile = true;
            this.zoonSliderOptions = {
                floor: 0,
                ceil: 100,
                animateOnMove: true,
                hidePointerLabels: true,
                translate: (value, label) => {
                    switch (label) {
                        case LabelType.Floor:
                            return '<i class="las la-search-minus fa-lg" ng-reflect-ng-class="las la-search-minus,fa-lg"></i>';
                        case LabelType.Ceil:
                            return '<i class="las la-search-plus fa-lg" ng-reflect-ng-class="las la-search-plus,fa-lg"></i>';
                        default:
                            return '' + value;
                    }
                }
            };
        }
        else {
            this.isMobile = false;
            this.zoonSliderOptions = {
                floor: 0,
                ceil: 100,
                vertical: true,
                animateOnMove: true,
                hidePointerLabels: true,
                translate: (value, label) => {
                    switch (label) {
                        case LabelType.Floor:
                            return '<i class="las la-search-minus fa-lg" ng-reflect-ng-class="las la-search-minus,fa-lg"></i>';
                        case LabelType.Ceil:
                            return '<i class="las la-search-plus fa-lg" ng-reflect-ng-class="las la-search-plus,fa-lg"></i>';
                        default:
                            return '' + value;
                    }
                }
            };
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetImageCropperComponent, deps: [{ token: CnetDialogService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetImageCropperComponent, selector: "cnet-image-cropper", inputs: { defaultAvatar: "defaultAvatar", minHeight: "minHeight", minWidth: "minWidth", cropperMinHeight: "cropperMinHeight", cropperMinWidth: "cropperMinWidth", resizeToWidth: "resizeToWidth", outputFormat: "outputFormat", imageDimensionMessageError: "imageDimensionMessageError", changeImageLabel: "changeImageLabel", cropperImageDialogHeader: "cropperImageDialogHeader", croppedImageVisualizeLabel: "croppedImageVisualizeLabel", saveButtonLabel: "saveButtonLabel", cancelButtonLabel: "cancelButtonLabel", accept: "accept", value: "value" }, outputs: { removeImage: "removeImage" }, host: { listeners: { "window:resize": "onResize($event)" } }, providers: [IMAGE_CROPPER_VALUE_ACCESSOR], viewQueries: [{ propertyName: "templateDialog", first: true, predicate: ["tpl"], descendants: true }, { propertyName: "fileInput", first: true, predicate: ["fileInput"], descendants: true }, { propertyName: "rotationSlider", first: true, predicate: ["rotationSlider"], descendants: true }], ngImport: i0, template: "<div>\n  <div class=\"img-container\" (mouseenter)=\"showDeleteButton = !showDeleteButton\"\n    (mouseleave)=\"showDeleteButton = !showDeleteButton\">\n\n    <ng-container *ngIf=\"srcUrl; else elseTemplate\">\n      <img [src]=\"srcUrl | sanitizerUrl:'url'\" class=\"image\" />\n\n    </ng-container>\n    <ng-template #elseTemplate>\n\n      <img [src]=\"defaultAvatar\" class=\"img-default\" />\n    </ng-template>\n\n    <div class=\"overlay\">\n\n      <ng-container *ngIf=\"showDeleteButton\">\n        <div class=\"div-button-delete\">\n\n          <button cnet-icon-button cnet-stroked-button [size]=\"'small'\" type=\"button\" (click)=\"resetToDefault()\">\n            <cnet-icon name=\"times\"></cnet-icon>\n          </button>\n        </div>\n        <p class=\"p-change-image\" (click)=\"fileInput.click()\">\n          {{changeImageLabel}}\n        </p>\n\n      </ng-container>\n\n    </div>\n  </div>\n  <div *ngIf=\"showImageDimensionError\" class=\"cnet-error\">\n    {{ imageDimensionMessageError }}\n  </div>\n</div>\n\n\n<input type=\"file\" (change)=\"fileChangeEvent($event)\" class=\"file-input\" #fileInput [accept]=\"accept\" />\n\n\n<ng-template #tpl let-close=\"close\">\n  <div style=\"overflow-y: initial !important\">\n\n  </div>\n  <cnet-card style=\"max-height: 90vh; overflow-y: auto;\">\n    <header cnet-card-header>\n      <h2 cnet-card-title> {{ cropperImageDialogHeader }} </h2>\n      <div cnet-card-actions>\n        <button cnet-icon-button cnet-stroked-button [size]=\"'small'\" type=\"button\" (click)=\"close(null)\">\n          <cnet-icon name=\"times\"></cnet-icon>\n        </button>\n      </div>\n    </header>\n\n    <cnet-card-content>\n      <div style=\"min-width: 40vw;\">\n        <div class=\"image-cropper-container\">\n          <div>\n\n            <image-cropper [imageChangedEvent]=\"imageChangedEvent\" [maintainAspectRatio]=\"true\"\n              [containWithinAspectRatio]=\"containWithinAspectRatio\" [aspectRatio]=\"1 / 1\"\n              [resizeToWidth]=\"resizeToWidth\" [cropperMinWidth]=\"cropperMinWidth\" [cropperMinHeight]=\"cropperMinHeight\"\n              [onlyScaleDown]=\"false\" [roundCropper]=\"false\" [canvasRotation]=\"canvasRotation\" [transform]=\"transform\"\n              [alignImage]=\"'left'\" [style.display]=\"showCropper ? null : 'none'\" [format]=\"outputFormat\"\n              (imageCropped)=\"imageCropped($event)\" (imageLoaded)=\"imageLoaded()\" (cropperReady)=\"cropperReady($event)\"\n              (loadImageFailed)=\"loadImageFailed()\"></image-cropper>\n\n            <div class=\"custom-slider\" [style.width]=\"test\">\n              <ngx-slider #rotationSlider [(value)]=\"rotation\" [options]=\"rotationSliderOptions\"\n                (valueChange)=\"updateRotation()\"></ngx-slider>\n            </div>\n            <div class=\"custom-slider\" style=\"width: 100%; margin-top: 1.5rem;\" *ngIf=\"isMobile\" [style.width]=\"test\">\n              <ngx-slider [(value)]=\"zoom\" [options]=\"zoonSliderOptions\" (valueChange)=\"updateZoom()\"></ngx-slider>\n            </div>\n          </div>\n\n          <div class=\"custom-slider custom-slider-zoom\" *ngIf=\"!isMobile\">\n            <ngx-slider [(value)]=\"zoom\" [options]=\"zoonSliderOptions\" (valueChange)=\"updateZoom()\" [style.height]=\"test\"></ngx-slider>\n          </div>\n        </div>\n\n\n        <div class=\"show-final-result\">\n          <h2>\n            {{ croppedImageVisualizeLabel }}\n          </h2>\n\n          <img [src]=\"croppedImage\" [style.border]=\"croppedImage ? '1px solid black' : 'none'\" />\n        </div>\n      </div>\n    </cnet-card-content>\n\n    <footer cnet-card-footer>\n      <div cnet-card-actions class=\"actions-buttons\">\n        <button cnet-filled-button color=\"primary\" (click)=\"close('save')\"> {{ saveButtonLabel }} </button>\n        <button cnet-filled-button (click)=\"close(null)\"> {{ cancelButtonLabel }} </button>\n      </div>\n    </footer>\n\n  </cnet-card>\n\n</ng-template>\n", styles: [".img-default{min-width:200px;min-height:200px;width:200px}.img-container{position:relative;width:fit-content}.overlay{display:flex;flex-direction:column;justify-content:space-between;position:absolute;left:0;top:0;height:100%;width:100%}.overlay:hover{background-color:#0000000a}.actions-buttons{display:flex;justify-content:flex-end}.div-button-delete{width:100%;display:flex;flex-direction:row;justify-content:flex-end}.div-button-delete .cnet-button.cnet-button-small{background-color:var(--cnet-default-500, #9e9e9e);color:var(--cnet-default-contrast-500, white);border:0;border-radius:0 0 0 3px!important;border-color:transparent}h2{margin:.5rem 0 1rem}.show-final-result{display:flex;flex-direction:column;align-items:center}.p-change-image{background:var(--cnet-primary-500, #82c14f);color:var(--cnet-primary-contrast-500, white);margin:0;display:flex;justify-content:center}.p-change-image:hover{cursor:pointer;text-decoration:underline}.image-cropper-container{justify-content:center;display:flex;flex-direction:row}.custom-slider-zoom{height:auto;padding:7px 2rem 3rem 1rem}.file-input{display:none}.cnet-card .cnet-card-header{flex-direction:row!important}.image{width:200px;height:200px}.custom-slider .ngx-slider-span.ngx-slider-bubble.ngx-slider-limit.ngx-slider-floor{size:30px}.custom-slider .ngx-slider .ngx-slider-bar{background:#ccc;height:4px}.ngx-slider.animate .ngx-slider-selection{height:6px;margin-top:-1px}.custom-slider .ngx-slider .ngx-slider-selection{background:var(--cnet-primary-500, #82c14f)}.custom-slider .ngx-slider .ngx-slider-pointer:active{cursor:grabbing}.custom-slider .ngx-slider .ngx-slider-pointer{cursor:grab;width:20px;height:20px;top:-8px;bottom:0;background-color:var(--cnet-primary-500, #82c14f)}.custom-slider .ngx-slider.vertical .ngx-slider-pointer{left:-8px!important}.custom-slider .ngx-slider .ngx-slider-pointer:after{display:none}.custom-slider .ngx-slider .ngx-slider-bubble{bottom:14px}.custom-slider .ngx-slider .ngx-slider-bubble i{font-size:30px}.custom-slider .ngx-slider .ngx-slider-limit{font-weight:700;color:var(--cnet-primary-500, #82c14f)}.custom-slider .ngx-slider .ngx-slider-tick{width:2px;height:12px;margin-left:4px;border-radius:0;background:var(--cnet-primary-500, #82c14f);top:-1px}.custom-slider .ngx-slider .ngx-slider-tick-legend{font-size:12px}.custom-slider .ngx-slider .ngx-slider-tick.ngx-slider-selected{background:var(--cnet-primary-500, #82c14f)}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i3.ImageCropperComponent, selector: "image-cropper", inputs: ["imageChangedEvent", "imageURL", "imageBase64", "imageFile", "imageAltText", "format", "transform", "maintainAspectRatio", "aspectRatio", "resetCropOnAspectRatioChange", "resizeToWidth", "resizeToHeight", "cropperMinWidth", "cropperMinHeight", "cropperMaxHeight", "cropperMaxWidth", "cropperStaticWidth", "cropperStaticHeight", "canvasRotation", "initialStepSize", "roundCropper", "onlyScaleDown", "imageQuality", "autoCrop", "backgroundColor", "containWithinAspectRatio", "hideResizeSquares", "allowMoveImage", "cropper", "alignImage", "disabled", "hidden"], outputs: ["imageCropped", "startCropImage", "imageLoaded", "cropperReady", "loadImageFailed", "transformChange"] }, { kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "component", type: i1$6.SliderComponent, selector: "ngx-slider", inputs: ["value", "highValue", "options", "manualRefresh", "triggerFocus"], outputs: ["valueChange", "highValueChange", "userChangeStart", "userChange", "userChangeEnd"] }, { kind: "component", type: CnetCardComponent, selector: "cnet-card", exportAs: ["cnetCard"] }, { kind: "component", type: CardHeaderComponent, selector: "cnet-card-header, [cnet-card-header], [cnetCardHeader]", exportAs: ["cnetCardHeader"] }, { kind: "directive", type: CnetCardTitleDirective, selector: "cnet-card-title, [cnet-card-title], [cnetCardTitle]" }, { kind: "directive", type: CnetCardContentDirective, selector: "cnet-card-content, [cnet-card-content], [cnetCardContent]" }, { kind: "directive", type: CnetCardActionsDirective, selector: "cnet-card-actions, [cnet-card-actions], [cnetCardActions]" }, { kind: "component", type: CnetCardFooterComponent, selector: "cnet-card-footer, [cnet-card-footer], [cnetCardFooter]", exportAs: ["cnetCardFooter"] }, { kind: "pipe", type: SanitizerUrlPipe, name: "sanitizerUrl" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetImageCropperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-image-cropper', encapsulation: ViewEncapsulation.None, providers: [IMAGE_CROPPER_VALUE_ACCESSOR], template: "<div>\n  <div class=\"img-container\" (mouseenter)=\"showDeleteButton = !showDeleteButton\"\n    (mouseleave)=\"showDeleteButton = !showDeleteButton\">\n\n    <ng-container *ngIf=\"srcUrl; else elseTemplate\">\n      <img [src]=\"srcUrl | sanitizerUrl:'url'\" class=\"image\" />\n\n    </ng-container>\n    <ng-template #elseTemplate>\n\n      <img [src]=\"defaultAvatar\" class=\"img-default\" />\n    </ng-template>\n\n    <div class=\"overlay\">\n\n      <ng-container *ngIf=\"showDeleteButton\">\n        <div class=\"div-button-delete\">\n\n          <button cnet-icon-button cnet-stroked-button [size]=\"'small'\" type=\"button\" (click)=\"resetToDefault()\">\n            <cnet-icon name=\"times\"></cnet-icon>\n          </button>\n        </div>\n        <p class=\"p-change-image\" (click)=\"fileInput.click()\">\n          {{changeImageLabel}}\n        </p>\n\n      </ng-container>\n\n    </div>\n  </div>\n  <div *ngIf=\"showImageDimensionError\" class=\"cnet-error\">\n    {{ imageDimensionMessageError }}\n  </div>\n</div>\n\n\n<input type=\"file\" (change)=\"fileChangeEvent($event)\" class=\"file-input\" #fileInput [accept]=\"accept\" />\n\n\n<ng-template #tpl let-close=\"close\">\n  <div style=\"overflow-y: initial !important\">\n\n  </div>\n  <cnet-card style=\"max-height: 90vh; overflow-y: auto;\">\n    <header cnet-card-header>\n      <h2 cnet-card-title> {{ cropperImageDialogHeader }} </h2>\n      <div cnet-card-actions>\n        <button cnet-icon-button cnet-stroked-button [size]=\"'small'\" type=\"button\" (click)=\"close(null)\">\n          <cnet-icon name=\"times\"></cnet-icon>\n        </button>\n      </div>\n    </header>\n\n    <cnet-card-content>\n      <div style=\"min-width: 40vw;\">\n        <div class=\"image-cropper-container\">\n          <div>\n\n            <image-cropper [imageChangedEvent]=\"imageChangedEvent\" [maintainAspectRatio]=\"true\"\n              [containWithinAspectRatio]=\"containWithinAspectRatio\" [aspectRatio]=\"1 / 1\"\n              [resizeToWidth]=\"resizeToWidth\" [cropperMinWidth]=\"cropperMinWidth\" [cropperMinHeight]=\"cropperMinHeight\"\n              [onlyScaleDown]=\"false\" [roundCropper]=\"false\" [canvasRotation]=\"canvasRotation\" [transform]=\"transform\"\n              [alignImage]=\"'left'\" [style.display]=\"showCropper ? null : 'none'\" [format]=\"outputFormat\"\n              (imageCropped)=\"imageCropped($event)\" (imageLoaded)=\"imageLoaded()\" (cropperReady)=\"cropperReady($event)\"\n              (loadImageFailed)=\"loadImageFailed()\"></image-cropper>\n\n            <div class=\"custom-slider\" [style.width]=\"test\">\n              <ngx-slider #rotationSlider [(value)]=\"rotation\" [options]=\"rotationSliderOptions\"\n                (valueChange)=\"updateRotation()\"></ngx-slider>\n            </div>\n            <div class=\"custom-slider\" style=\"width: 100%; margin-top: 1.5rem;\" *ngIf=\"isMobile\" [style.width]=\"test\">\n              <ngx-slider [(value)]=\"zoom\" [options]=\"zoonSliderOptions\" (valueChange)=\"updateZoom()\"></ngx-slider>\n            </div>\n          </div>\n\n          <div class=\"custom-slider custom-slider-zoom\" *ngIf=\"!isMobile\">\n            <ngx-slider [(value)]=\"zoom\" [options]=\"zoonSliderOptions\" (valueChange)=\"updateZoom()\" [style.height]=\"test\"></ngx-slider>\n          </div>\n        </div>\n\n\n        <div class=\"show-final-result\">\n          <h2>\n            {{ croppedImageVisualizeLabel }}\n          </h2>\n\n          <img [src]=\"croppedImage\" [style.border]=\"croppedImage ? '1px solid black' : 'none'\" />\n        </div>\n      </div>\n    </cnet-card-content>\n\n    <footer cnet-card-footer>\n      <div cnet-card-actions class=\"actions-buttons\">\n        <button cnet-filled-button color=\"primary\" (click)=\"close('save')\"> {{ saveButtonLabel }} </button>\n        <button cnet-filled-button (click)=\"close(null)\"> {{ cancelButtonLabel }} </button>\n      </div>\n    </footer>\n\n  </cnet-card>\n\n</ng-template>\n", styles: [".img-default{min-width:200px;min-height:200px;width:200px}.img-container{position:relative;width:fit-content}.overlay{display:flex;flex-direction:column;justify-content:space-between;position:absolute;left:0;top:0;height:100%;width:100%}.overlay:hover{background-color:#0000000a}.actions-buttons{display:flex;justify-content:flex-end}.div-button-delete{width:100%;display:flex;flex-direction:row;justify-content:flex-end}.div-button-delete .cnet-button.cnet-button-small{background-color:var(--cnet-default-500, #9e9e9e);color:var(--cnet-default-contrast-500, white);border:0;border-radius:0 0 0 3px!important;border-color:transparent}h2{margin:.5rem 0 1rem}.show-final-result{display:flex;flex-direction:column;align-items:center}.p-change-image{background:var(--cnet-primary-500, #82c14f);color:var(--cnet-primary-contrast-500, white);margin:0;display:flex;justify-content:center}.p-change-image:hover{cursor:pointer;text-decoration:underline}.image-cropper-container{justify-content:center;display:flex;flex-direction:row}.custom-slider-zoom{height:auto;padding:7px 2rem 3rem 1rem}.file-input{display:none}.cnet-card .cnet-card-header{flex-direction:row!important}.image{width:200px;height:200px}.custom-slider .ngx-slider-span.ngx-slider-bubble.ngx-slider-limit.ngx-slider-floor{size:30px}.custom-slider .ngx-slider .ngx-slider-bar{background:#ccc;height:4px}.ngx-slider.animate .ngx-slider-selection{height:6px;margin-top:-1px}.custom-slider .ngx-slider .ngx-slider-selection{background:var(--cnet-primary-500, #82c14f)}.custom-slider .ngx-slider .ngx-slider-pointer:active{cursor:grabbing}.custom-slider .ngx-slider .ngx-slider-pointer{cursor:grab;width:20px;height:20px;top:-8px;bottom:0;background-color:var(--cnet-primary-500, #82c14f)}.custom-slider .ngx-slider.vertical .ngx-slider-pointer{left:-8px!important}.custom-slider .ngx-slider .ngx-slider-pointer:after{display:none}.custom-slider .ngx-slider .ngx-slider-bubble{bottom:14px}.custom-slider .ngx-slider .ngx-slider-bubble i{font-size:30px}.custom-slider .ngx-slider .ngx-slider-limit{font-weight:700;color:var(--cnet-primary-500, #82c14f)}.custom-slider .ngx-slider .ngx-slider-tick{width:2px;height:12px;margin-left:4px;border-radius:0;background:var(--cnet-primary-500, #82c14f);top:-1px}.custom-slider .ngx-slider .ngx-slider-tick-legend{font-size:12px}.custom-slider .ngx-slider .ngx-slider-tick.ngx-slider-selected{background:var(--cnet-primary-500, #82c14f)}\n"] }]
        }], ctorParameters: () => [{ type: CnetDialogService }], propDecorators: { defaultAvatar: [{
                type: Input
            }], minHeight: [{
                type: Input
            }], minWidth: [{
                type: Input
            }], cropperMinHeight: [{
                type: Input
            }], cropperMinWidth: [{
                type: Input
            }], resizeToWidth: [{
                type: Input
            }], outputFormat: [{
                type: Input
            }], imageDimensionMessageError: [{
                type: Input
            }], changeImageLabel: [{
                type: Input
            }], cropperImageDialogHeader: [{
                type: Input
            }], croppedImageVisualizeLabel: [{
                type: Input
            }], saveButtonLabel: [{
                type: Input
            }], cancelButtonLabel: [{
                type: Input
            }], accept: [{
                type: Input
            }], removeImage: [{
                type: Output
            }], templateDialog: [{
                type: ViewChild,
                args: ['tpl']
            }], fileInput: [{
                type: ViewChild,
                args: ['fileInput']
            }], rotationSlider: [{
                type: ViewChild,
                args: ['rotationSlider']
            }], value: [{
                type: Input
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });

class CnetImageCropperModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetImageCropperModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetImageCropperModule, declarations: [CnetImageCropperComponent], imports: [CommonModule,
            ImageCropperModule,
            FormsModule,
            CnetButtonModule,
            CnetIconModule,
            TranslateModule,
            NgxSliderModule,
            CnetCardModule,
            SanitizerUrlModule], exports: [CnetImageCropperComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetImageCropperModule, imports: [CommonModule,
            ImageCropperModule,
            FormsModule,
            CnetButtonModule,
            CnetIconModule,
            TranslateModule,
            NgxSliderModule,
            CnetCardModule,
            SanitizerUrlModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetImageCropperModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnetImageCropperComponent,
                    ],
                    exports: [
                        CnetImageCropperComponent
                    ],
                    imports: [
                        CommonModule,
                        ImageCropperModule,
                        FormsModule,
                        CnetButtonModule,
                        CnetIconModule,
                        TranslateModule,
                        NgxSliderModule,
                        CnetCardModule,
                        SanitizerUrlModule
                    ]
                }]
        }] });

class FileUploadDropZoneDirective {
    constructor() {
        this.disabled = false;
        this.onFileDropped = new EventEmitter();
        this.opacity = '1';
        this.fileDropedClass = false;
    }
    onDragOver(evt) {
        if (!this.disabled) {
            evt.preventDefault();
            evt.stopPropagation();
            this.opacity = '0.8';
            this.fileDropedClass = true;
        }
    }
    onDragLeave(evt) {
        if (!this.disabled) {
            evt.preventDefault();
            evt.stopPropagation();
            this.opacity = '1';
            this.fileDropedClass = false;
        }
    }
    ondrop(evt) {
        if (!this.disabled) {
            evt.preventDefault();
            evt.stopPropagation();
            this.opacity = '1';
            this.fileDropedClass = false;
            const files = evt.dataTransfer.files;
            if (files.length > 0) {
                this.onFileDropped.emit(files);
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileUploadDropZoneDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: FileUploadDropZoneDirective, selector: "[cnetFileDropZone]", inputs: { disabled: "disabled" }, outputs: { onFileDropped: "onFileDropped" }, host: { listeners: { "dragover": "onDragOver($event)", "dragleave": "onDragLeave($event)", "drop": "ondrop($event)" }, properties: { "style.opacity": "this.opacity", "class.file-droped": "this.fileDropedClass" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileUploadDropZoneDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetFileDropZone]'
                }]
        }], propDecorators: { disabled: [{
                type: Input
            }], onFileDropped: [{
                type: Output
            }], opacity: [{
                type: HostBinding,
                args: ['style.opacity']
            }], fileDropedClass: [{
                type: HostBinding,
                args: ['class.file-droped']
            }], onDragOver: [{
                type: HostListener,
                args: ['dragover', ['$event']]
            }], onDragLeave: [{
                type: HostListener,
                args: ['dragleave', ['$event']]
            }], ondrop: [{
                type: HostListener,
                args: ['drop', ['$event']]
            }] } });

class CnetFileDropZoneModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFileDropZoneModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetFileDropZoneModule, declarations: [FileUploadDropZoneDirective], imports: [CommonModule], exports: [FileUploadDropZoneDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFileDropZoneModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFileDropZoneModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        FileUploadDropZoneDirective
                    ],
                    exports: [
                        FileUploadDropZoneDirective
                    ],
                    imports: [
                        CommonModule
                    ],
                }]
        }] });

/**
 * Cnet Toolbar is a container for header contens.
 *
 * @export
 * class CnetToolbarComponent
 */
class CnetToolbarComponent {
    constructor() {
        /** @ignore */ this._color = "primary";
    }
    /**
     * The color for the Toolbar
     *
     * type {CnetColorPalette}
     * @memberof CnetToolbarComponent
     */
    get color() { return this._color; }
    set color(value) { this._color = value; }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetToolbarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetToolbarComponent, selector: "cnet-toolbar, [cnet-toolbar], [cnetToolbar]", inputs: { color: "color" }, host: { properties: { "class.cnet-color-primary": "color == \"primary\"", "class.cnet-color-secondary": "color == \"secondary\"", "class.cnet-color-danger": "color == \"danger\"", "class.cnet-color-cancel": "color == \"cancel\"", "class.cnet-color-default": "color == \"default\"" }, classAttribute: "cnet-toolbar" }, exportAs: ["cnet-toolbar"], ngImport: i0, template: "<ng-content></ng-content>", styles: [".cnet-toolbar{display:flex;align-items:center;min-height:3.75rem;padding:.75rem 1rem}.cnet-toolbar.cnet-color-primary{color:var(--cnet-primary-contrast-500, white);background-color:var(--cnet-primary-500, #82c14f)}.cnet-toolbar.cnet-color-secondary{color:var(--cnet-secondary-contrast-500, white);background-color:var(--cnet-secondary-500, #3d4155)}.cnet-toolbar.cnet-color-danger{color:var(--cnet-danger-contrast-500, white);background-color:var(--cnet-danger-500, #ee4446)}.cnet-toolbar.cnet-color-cancel{color:var(--cnet-cancel-contrast-200, rgba(0, 0, 0, .85));background-color:var(--cnet-cancel-200, #eeeeee)}.cnet-toolbar.cnet-color-default{color:var(--cnet-default-contrast-500, white);background-color:var(--cnet-default-500, #9e9e9e)}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetToolbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-toolbar, [cnet-toolbar], [cnetToolbar]', exportAs: 'cnet-toolbar', host: {
                        class: 'cnet-toolbar',
                        '[class.cnet-color-primary]': 'color == "primary"',
                        '[class.cnet-color-secondary]': 'color == "secondary"',
                        '[class.cnet-color-danger]': 'color == "danger"',
                        '[class.cnet-color-cancel]': 'color == "cancel"',
                        '[class.cnet-color-default]': 'color == "default"',
                    }, encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-content></ng-content>", styles: [".cnet-toolbar{display:flex;align-items:center;min-height:3.75rem;padding:.75rem 1rem}.cnet-toolbar.cnet-color-primary{color:var(--cnet-primary-contrast-500, white);background-color:var(--cnet-primary-500, #82c14f)}.cnet-toolbar.cnet-color-secondary{color:var(--cnet-secondary-contrast-500, white);background-color:var(--cnet-secondary-500, #3d4155)}.cnet-toolbar.cnet-color-danger{color:var(--cnet-danger-contrast-500, white);background-color:var(--cnet-danger-500, #ee4446)}.cnet-toolbar.cnet-color-cancel{color:var(--cnet-cancel-contrast-200, rgba(0, 0, 0, .85));background-color:var(--cnet-cancel-200, #eeeeee)}.cnet-toolbar.cnet-color-default{color:var(--cnet-default-contrast-500, white);background-color:var(--cnet-default-500, #9e9e9e)}\n"] }]
        }], propDecorators: { color: [{
                type: Input
            }] } });

class CnetToolbarModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetToolbarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetToolbarModule, declarations: [CnetToolbarComponent], imports: [CommonModule], exports: [CnetToolbarComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetToolbarModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetToolbarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetToolbarComponent],
                    imports: [
                        CommonModule
                    ],
                    exports: [CnetToolbarComponent]
                }]
        }] });

let nextUniqueId$3 = 0;
/**
 * Directive for use inputs inside a form field
 *
 * @export
 * class CnetInputDirective
 */
class CnetInputForUploadDirective {
    constructor(ngControl, elementRef) {
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        /** @ignore */ this._id = `cnet-input-upload-${nextUniqueId$3++}`;
        /** @ignore */ this._required = false;
        /** @ignore */ this._disabled = false;
        /** @ignore */ this._focused = false;
        /** @ignore */ this._errorState = false;
        /**
         * Emits whenever the state of the control changes
         *
         * type {Observable<void>}
         * @memberof CnetInputDirective
         */
        this.stateChanges = new Subject();
        this._valueAcessor = this.elementRef.nativeElement;
    }
    /**
    * The element ID for this control.
    *
    * type {string}
    * @memberof CnetInputDirective
    */
    get id() { return this._id; }
    set id(value) { this._id = value; }
    /**
     * Whether the control is required.
     *
     * type {boolean}
     * @memberof CnetInputDirective
     */
    get required() { return this._required; }
    set required(value) { this._required = coerceBooleanProperty(value); }
    /**
     * Whether the control is disabled.
     *
     * type {boolean}
     * @memberof CnetInputDirective
     */
    get disabled() {
        if (this.ngControl && this.ngControl.disabled !== null) {
            return this.ngControl.disabled;
        }
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
        if (this.focused) {
            this.focused = false;
            this.stateChanges.next();
        }
    }
    /**
     * The value of the control
     *
     * type {(T | null)}
     * @memberof CnetInputDirective
     */
    get value() { return this._valueAcessor.value; }
    set value(value) {
        if (value !== this._valueAcessor.value) {
            this._valueAcessor.value = value;
            this.stateChanges.next();
        }
    }
    /**
     * Whether the control is focused
     *
     * type {boolean}
     * @memberof CnetInputDirective
     */
    get focused() { return this._focused; }
    set focused(value) { this._focused = coerceBooleanProperty(value); }
    /**
     * Whether the control is in an error state.
     *
     * type {boolean}
     * @memberof CnetInputDirective
     */
    get errorState() { return this._errorState; }
    set errorState(value) { this._errorState = coerceBooleanProperty(value); }
    /**
     * Error id for aria-describedby
     *
     * @readonly
     * type {string}
     * @memberof CnetInputDirective
     */
    get describedby() {
        return this.error?.id || null;
    }
    /** @ignore */
    ngDoCheck() {
        if (this.ngControl) {
            this.errorState = this.ngControl.errors !== null && (!!this.ngControl.touched || this.ngControl.dirty);
        }
        this.stateChanges.next();
    }
    /** @ignore */
    changeFocus(focused) {
        this.focused = focused;
        this.stateChanges.next();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetInputForUploadDirective, deps: [{ token: i1$4.NgControl, optional: true, self: true }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetInputForUploadDirective, selector: "cnet-upload, [cnetUpload], [cnet-upload]", inputs: { id: "id", required: "required", disabled: "disabled", value: "value", focused: "focused", errorState: "errorState" }, host: { listeners: { "blur": "changeFocus(false)", "focus": "changeFocus(true)" }, properties: { "attr.id": "id", "attr.aria-invalid": "errorState", "attr.aria-required": "required", "attr.aria-describedby": "describedby" }, classAttribute: "cnet-input-upload" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetInputForUploadDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-upload, [cnetUpload], [cnet-upload]',
                    host: {
                        class: 'cnet-input-upload',
                        '[attr.id]': 'id',
                        '[attr.aria-invalid]': 'errorState',
                        '[attr.aria-required]': 'required',
                        '[attr.aria-describedby]': 'describedby',
                        '(blur)': 'changeFocus(false)',
                        '(focus)': 'changeFocus(true)'
                    },
                }]
        }], ctorParameters: () => [{ type: i1$4.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ElementRef }], propDecorators: { id: [{
                type: Input
            }], required: [{
                type: Input
            }], disabled: [{
                type: Input
            }], value: [{
                type: Input
            }], focused: [{
                type: Input
            }], errorState: [{
                type: Input
            }] } });

class CnetFile {
    constructor(name, attachmentUri, filepath, file, code) {
        this.code = uuid.v4();
        this.name = name;
        this.attachmentUri = attachmentUri;
        this.filePath = filepath;
        this.file = file;
        if (code) {
            this.code = code;
        }
    }
}

class UploadService {
    constructor() { }
    isFileTypeValid(acceptTypes, file) {
        if (acceptTypes !== '*' && file) {
            let typeRegex = new RegExp(acceptTypes.replace(/\*/g, '.\*').replace(/\,/g, '|'));
            return typeRegex.test(file.type) || acceptTypes.toLowerCase().includes(this.getFileExtension(file).toLowerCase());
        }
        return true;
    }
    fileTypeValidation(acceptTypes) {
        return (control) => {
            if (control.value && Array.isArray(control.value)) {
                const filesNamesWithTypeError = [];
                const FilesWithTypeError = control.value.filter((file, index) => {
                    if (typeof file === 'string') {
                        return false;
                    }
                    else if (file.file) {
                        const hasFileTypeInvalid = !this.isFileTypeValid(acceptTypes, file.file);
                        if (hasFileTypeInvalid) {
                            filesNamesWithTypeError.push(this.getFileName(file));
                        }
                        return hasFileTypeInvalid;
                    }
                    else if (file instanceof File) {
                        const hasFileTypeInvalid = !this.isFileTypeValid(acceptTypes, file);
                        if (hasFileTypeInvalid) {
                            filesNamesWithTypeError.push(this.getFileName(file));
                        }
                        return hasFileTypeInvalid;
                    }
                });
                if (FilesWithTypeError && FilesWithTypeError.length) {
                    return { invalidType: { valid: false, filesWithErrors: filesNamesWithTypeError, acceptTypes: acceptTypes } };
                }
            }
            return null;
        };
    }
    fileSizeValidation(maxFileSize) {
        return (control) => {
            if (control.value && Array.isArray(control.value)) {
                const filesIndexWithSizeError = [];
                const filesNamesWithSizeError = [];
                const FilesWithSizeError = control.value.filter((file, index) => {
                    if (typeof file === 'string') {
                        return false;
                    }
                    else if (file.file) {
                        const hasError = file.file.size > (maxFileSize * 1048576);
                        if (hasError) {
                            filesIndexWithSizeError.push(index);
                            filesNamesWithSizeError.push(this.getFileName(file));
                        }
                        return hasError;
                    }
                    else {
                        const hasError = file.size > (maxFileSize * 1048576);
                        if (hasError) {
                            filesIndexWithSizeError.push(index);
                            filesNamesWithSizeError.push(this.getFileName(file));
                        }
                        return hasError;
                    }
                });
                if (FilesWithSizeError && FilesWithSizeError.length) {
                    return { invalidSize: { valid: false, filesWithErrors: filesNamesWithSizeError, maxFileSize: maxFileSize } };
                }
            }
            return null;
        };
    }
    getFileName(file) {
        if (typeof file === 'string') {
            const nameAux = file.substring(0, file.indexOf('?')).split('/');
            return nameAux[nameAux.length - 1].split('.')[0];
        }
        else if (file instanceof File) {
            return file.name;
        }
        else if (file.file || file.filePath) {
            return file.name;
        }
        return '';
    }
    getFileExtension(file) {
        return '.' + file.name.split('.').pop();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: UploadService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: UploadService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: UploadService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [] });

class FileComponent {
    constructor() {
        this.file = null;
        this.maxFileSize = 15;
        this.showDeleteBtn = true;
        this.deleteFileButtonLabel = '';
        this.openFileButtonLabel = '';
        this.newUploadFileButtonLabel = '';
        this.sizeFileErrorMessage = 'Tamanho do arquivo incompatível';
        this.typeFileErrorMessage = 'Tipo do arquivo incompatível';
        this.removeFile = new EventEmitter();
        this.newUploadFile = new EventEmitter();
        this.fileSizeError = new EventEmitter();
        this.isImage = false;
        this.imgHeight = 'auto';
        this.imgWidth = 'auto';
    }
    newUpload() {
        this.newUploadFile.emit(true);
    }
    remove(e) {
        e.stopPropagation();
        this.removeFile.emit(this.file);
    }
    isFileBiggerThanMaxFileSize() {
        const isError = this.file.file && this.file.file.size > (this.maxFileSize * 1048576);
        if (isError) {
            this.fileSizeError.emit(this.file);
        }
        return isError;
    }
    isFileTypeValid() {
        if (this.accept !== '*' && this.file.file) {
            let typeRegex = new RegExp(this.accept.replace(/\*/g, '.\*').replace(/\,/g, '|'));
            return typeRegex.test(this.file.file.type) || this.accept.toLowerCase().includes(this.getFileExtension(this.file.file).toLowerCase());
        }
        return true;
    }
    getFileExtension(file) {
        return '.' + file.name.split('.').pop();
    }
    openFile(e) {
        e.stopPropagation();
        window.open(`${this.getUrlFromFile()}`, '_blank');
    }
    getUrlFromFile() {
        return this.file.filePath ? this.file.filePath : URL.createObjectURL(this.file.file);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: FileComponent, selector: "cnet-file", inputs: { file: "file", maxFileSize: "maxFileSize", showDeleteBtn: "showDeleteBtn", deleteFileButtonLabel: "deleteFileButtonLabel", openFileButtonLabel: "openFileButtonLabel", newUploadFileButtonLabel: "newUploadFileButtonLabel", showVisualizeBtn: "showVisualizeBtn", accept: "accept", showFileTypeError: "showFileTypeError", showFileSizeError: "showFileSizeError", multiple: "multiple", sizeFileErrorMessage: "sizeFileErrorMessage", typeFileErrorMessage: "typeFileErrorMessage", isImage: "isImage", imgHeight: "imgHeight", imgWidth: "imgWidth" }, outputs: { removeFile: "removeFile", newUploadFile: "newUploadFile", fileSizeError: "fileSizeError" }, host: { attributes: { "role": "cnetFile" }, properties: { "class.cnet-file-error": "isFileBiggerThanMaxFileSize() || !isFileTypeValid()" }, classAttribute: "cnet-file" }, ngImport: i0, template: "<div class=\"file-content\">\n\n  <div class=\"file-label\">\n    {{file?.name}}\n  </div>\n  <div class=\"file-actions\">\n\n    <button cnet-button size=\"small\" color=\"cancel\" type=\"button\" *ngIf=\"!multiple\">\n      <cnet-icon [size]=\"2\" [id]=\"'btn'+file.name+'newUpload'\" style=\"padding-right: 4px;\" name=\"file-upload\" label=\"file-upload\">\n      </cnet-icon>\n      <ng-container *ngIf=\"newUploadFileButtonLabel\">\n        {{newUploadFileButtonLabel}}\n      </ng-container>\n    </button>\n    <button cnet-button size=\"small\" color=\"cancel\" (click)=\"openFile($event)\" type=\"button\" *ngIf=\"showVisualizeBtn\">\n      <cnet-icon [size]=\"2\" [id]=\"'btn'+file.name+'eye'\" style=\"padding-right: 4px;\" name=\"eye\" label=\"eye\">\n      </cnet-icon>\n      <ng-container *ngIf=\"openFileButtonLabel\">\n        {{ openFileButtonLabel}}\n      </ng-container>\n    </button>\n\n    <button cnet-button size=\"small\" color=\"cancel\" (click)=\"remove($event)\" type=\"button\" *ngIf=\"showDeleteBtn\">\n      <cnet-icon [size]=\"2\" [id]=\"'btn'+file.name+'remove'\" style=\"padding-right: 4px;\" name=\"trash\" label=\"trash\">\n      </cnet-icon>\n      <ng-container *ngIf=\"deleteFileButtonLabel\">\n        {{ deleteFileButtonLabel}}\n      </ng-container>\n    </button>\n\n  </div>\n\n</div>\n<div class=\"file-content-error\" *ngIf=\"showFileSizeError && isFileBiggerThanMaxFileSize()\">\n  {{sizeFileErrorMessage}}\n</div>\n<div class=\"file-content-error\" *ngIf=\"showFileTypeError && !isFileTypeValid()\">\n  {{typeFileErrorMessage}}\n</div>\n", styles: [":host{width:100%}:host.cnet-file-error .file-content{border-color:red}.file-content{border:1px solid #bdbdbd;padding:.5rem;display:flex;justify-content:space-between;align-items:center}.file-content-error{color:var(--cnet-danger-500, #ee4446);display:block;margin-top:.25rem;font-size:.8rem}.file-label{min-width:300px;text-transform:uppercase;padding-right:.5rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.file-actions{display:flex;flex-direction:row;align-items:center;gap:.5rem;padding-left:.5rem}.file-actions button{padding:0;min-width:fit-content}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: FileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-file', host: {
                        class: 'cnet-file',
                        role: 'cnetFile',
                        '[class.cnet-file-error]': 'isFileBiggerThanMaxFileSize() || !isFileTypeValid()',
                    }, template: "<div class=\"file-content\">\n\n  <div class=\"file-label\">\n    {{file?.name}}\n  </div>\n  <div class=\"file-actions\">\n\n    <button cnet-button size=\"small\" color=\"cancel\" type=\"button\" *ngIf=\"!multiple\">\n      <cnet-icon [size]=\"2\" [id]=\"'btn'+file.name+'newUpload'\" style=\"padding-right: 4px;\" name=\"file-upload\" label=\"file-upload\">\n      </cnet-icon>\n      <ng-container *ngIf=\"newUploadFileButtonLabel\">\n        {{newUploadFileButtonLabel}}\n      </ng-container>\n    </button>\n    <button cnet-button size=\"small\" color=\"cancel\" (click)=\"openFile($event)\" type=\"button\" *ngIf=\"showVisualizeBtn\">\n      <cnet-icon [size]=\"2\" [id]=\"'btn'+file.name+'eye'\" style=\"padding-right: 4px;\" name=\"eye\" label=\"eye\">\n      </cnet-icon>\n      <ng-container *ngIf=\"openFileButtonLabel\">\n        {{ openFileButtonLabel}}\n      </ng-container>\n    </button>\n\n    <button cnet-button size=\"small\" color=\"cancel\" (click)=\"remove($event)\" type=\"button\" *ngIf=\"showDeleteBtn\">\n      <cnet-icon [size]=\"2\" [id]=\"'btn'+file.name+'remove'\" style=\"padding-right: 4px;\" name=\"trash\" label=\"trash\">\n      </cnet-icon>\n      <ng-container *ngIf=\"deleteFileButtonLabel\">\n        {{ deleteFileButtonLabel}}\n      </ng-container>\n    </button>\n\n  </div>\n\n</div>\n<div class=\"file-content-error\" *ngIf=\"showFileSizeError && isFileBiggerThanMaxFileSize()\">\n  {{sizeFileErrorMessage}}\n</div>\n<div class=\"file-content-error\" *ngIf=\"showFileTypeError && !isFileTypeValid()\">\n  {{typeFileErrorMessage}}\n</div>\n", styles: [":host{width:100%}:host.cnet-file-error .file-content{border-color:red}.file-content{border:1px solid #bdbdbd;padding:.5rem;display:flex;justify-content:space-between;align-items:center}.file-content-error{color:var(--cnet-danger-500, #ee4446);display:block;margin-top:.25rem;font-size:.8rem}.file-label{min-width:300px;text-transform:uppercase;padding-right:.5rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.file-actions{display:flex;flex-direction:row;align-items:center;gap:.5rem;padding-left:.5rem}.file-actions button{padding:0;min-width:fit-content}\n"] }]
        }], ctorParameters: () => [], propDecorators: { file: [{
                type: Input
            }], maxFileSize: [{
                type: Input
            }], showDeleteBtn: [{
                type: Input
            }], deleteFileButtonLabel: [{
                type: Input
            }], openFileButtonLabel: [{
                type: Input
            }], newUploadFileButtonLabel: [{
                type: Input
            }], showVisualizeBtn: [{
                type: Input
            }], accept: [{
                type: Input
            }], showFileTypeError: [{
                type: Input
            }], showFileSizeError: [{
                type: Input
            }], multiple: [{
                type: Input
            }], sizeFileErrorMessage: [{
                type: Input
            }], typeFileErrorMessage: [{
                type: Input
            }], removeFile: [{
                type: Output
            }], newUploadFile: [{
                type: Output
            }], fileSizeError: [{
                type: Output
            }], isImage: [{
                type: Input
            }], imgHeight: [{
                type: Input
            }], imgWidth: [{
                type: Input
            }] } });

class CnetUploadComponent extends CnetInputForUploadDirective {
    get value() { return this._value; }
    set value(value) {
        this._value = value;
    }
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
        if (this._disabled) {
            // this.setDisabledState(this._disabled)
        }
    }
    get multiple() { return this._multiple; }
    set multiple(value) {
        this._multiple = coerceBooleanProperty(value);
    }
    constructor(ngControl, elementRef, uploadValidatorsService) {
        super(ngControl, elementRef);
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.uploadValidatorsService = uploadValidatorsService;
        /** @ignore */ this._disabled = false;
        /** @ignore */ this._multiple = false;
        /** @ignore */ this._value = [];
        /** @ignore */ this.cdr = inject(ChangeDetectorRef);
        this.accept = '*';
        this.maxFileSize = 15;
        this.showDefaultPlaceholder = true;
        this.placeholder = 'Selecione um arquivo ou';
        this.btnChooseFileLabel = 'Selecione um arquivo';
        this.showDeleteBtn = true;
        this.deleteFileButtonLabel = '';
        this.newUploadFileButtonLabel = '';
        this.openFileButtonLabel = '';
        this.showVisualizeBtn = true;
        this.showFileTypeError = true;
        this.showFileSizeError = true;
        this.sizeFileErrorMessage = 'Tamanho do arquivo incompatível';
        this.typeFileErrorMessage = 'Tipo do arquivo incompatível';
        this.handleRemove = false;
        this.removeFile = new EventEmitter();
        /** @ignore */
        this.onChangeFn = (_) => { };
        /** @ignore */
        this.onTouchedFn = () => { };
        this.files$ = new BehaviorSubject([]);
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }
    writeValue(obj) {
        if (!(obj && obj.length)) {
            this.value = [];
            this.updateFiles$([]);
        }
        else {
            if (this.multiple) {
                this.value = obj instanceof Array ? this.value.concat(obj) : this.value.concat([obj]);
            }
            else {
                if (obj instanceof Array && obj.length > 1) {
                    this.value = [obj[0]];
                }
                else {
                    this.value = obj instanceof Array ? obj : [obj];
                }
            }
            this.updateFiles$(this.value);
        }
        this.onTouchedFn();
        this.onChange();
    }
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    /** @ignore */
    onChange() {
        this.onChangeFn(this.value);
    }
    registerOnTouched(fn) {
        this.onTouchedFn = fn;
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        if (this.disabled) {
            this.elementRef.nativeElement.tabIndex = -1;
        }
        else {
            this.elementRef.nativeElement.tabIndex = 0;
        }
        this.cdr.markForCheck();
    }
    get invalid() {
        return this.ngControl ? this.ngControl.invalid : false;
    }
    get showError() {
        if (!this.ngControl) {
            return false;
        }
        const { dirty, touched } = this.ngControl;
        return this.invalid ? (dirty || touched) : false;
    }
    ngOnInit() {
        this.ngControl.control.setValidators(this.ngControl.control.validator ? [this.ngControl.control.validator, this.uploadValidatorsService.fileSizeValidation(this.maxFileSize)] : this.uploadValidatorsService.fileSizeValidation(this.maxFileSize));
        this.ngControl.control.addValidators(this.uploadValidatorsService.fileTypeValidation(this.accept));
        this.ngControl.control.updateValueAndValidity();
    }
    onFileChanged(event) {
        if (!this.disabled) {
            const files = event.target.files;
            if (files.length > 0) {
                this.droppedFiles(files);
            }
        }
    }
    clickForUpload() {
        this.fileInput.nativeElement.value = '';
        this.fileInput.nativeElement.click();
    }
    removeFiles() {
    }
    updateFiles$(allFiles) {
        const files = allFiles.map((file, index) => {
            if (file instanceof CnetFile) {
                file.code = index;
                return file;
            }
            if (file instanceof File) {
                return new CnetFile(file.name, '', '', file, `${index}`);
            }
            if (typeof file === 'string') {
                return new CnetFile(this.uploadValidatorsService.getFileName(file), file, file, null, `${index}`);
            }
        });
        this.files$.next(files);
    }
    droppedFiles(allFiles) {
        if (!this.disabled) {
            // const filesArray = Array.from(allFiles).filter(file => this.verifyAccept(file.type));
            const filesArray = Array.from(allFiles);
            //remove all files that not accept
            this.writeValue(filesArray);
        }
    }
    verifyAccept(type) {
        if (this.accept === '*') {
            return true;
        }
        let typeRegex = new RegExp(this.accept.replace(/\*/g, '.\*').replace(/\,/g, '|'));
        return typeRegex.test(type);
    }
    deleteFile(file) {
        if (!this.handleRemove) {
            if (Number.parseInt(file.code) < this.value.length) {
                let files = [...this.value];
                files.splice(Number.parseInt(file.code), 1);
                if (files.length) {
                    this.value = [];
                }
                this.writeValue(files);
            }
        }
        this.removeFile.emit(file);
    }
    cleanAllErros() {
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetUploadComponent, deps: [{ token: i1$4.NgControl, optional: true, self: true }, { token: i0.ElementRef }, { token: UploadService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetUploadComponent, selector: "cnet-upload", inputs: { value: "value", accept: "accept", disabled: "disabled", multiple: "multiple", maxFileSize: "maxFileSize", showDefaultPlaceholder: "showDefaultPlaceholder", placeholder: "placeholder", btnChooseFileLabel: "btnChooseFileLabel", showDeleteBtn: "showDeleteBtn", deleteFileButtonLabel: "deleteFileButtonLabel", newUploadFileButtonLabel: "newUploadFileButtonLabel", openFileButtonLabel: "openFileButtonLabel", showVisualizeBtn: "showVisualizeBtn", showFileTypeError: "showFileTypeError", showFileSizeError: "showFileSizeError", sizeFileErrorMessage: "sizeFileErrorMessage", typeFileErrorMessage: "typeFileErrorMessage", handleRemove: "handleRemove" }, outputs: { removeFile: "removeFile" }, host: { attributes: { "role": "upload", "tabindex": "0" }, properties: { "class.cnet-upload-multiple": "multiple", "class.cnet-upload-single": "!multiple", "attr.id": "id", "attr.value": "value", "attr.name": "name", "class.cnet-upload-disabled": "disabled" }, classAttribute: "cnet-upload" }, providers: [{ provide: CnetFormFieldControl, useExisting: CnetUploadComponent }], viewQueries: [{ propertyName: "fileInput", first: true, predicate: ["fileInput"], descendants: true }], exportAs: ["cnetUpload"], usesInheritance: true, ngImport: i0, template: "<input type=\"file\" (change)=\"onFileChanged($event)\" [accept]=\"accept\" [multiple]=\"multiple\" #fileInput [hidden]=\"true\">\n\n<div class=\"content\" cnetFileDropZone (onFileDropped)=\"droppedFiles($event)\" (click)=\"clickForUpload()\">\n  <ng-container *ngIf=\"files$ | async as files; else emptyContentTemplate\">\n\n    <ng-container *ngIf=\"files.length else emptyContentTemplate\">\n      <div class=\"file-list-content\">\n\n\n        <ng-container *ngFor=\"let file of files\">\n          <cnet-file [file]=\"file\" (removeFile)=\"deleteFile(file)\" [accept]=\"accept\" [maxFileSize]=\"maxFileSize\"\n            [showDeleteBtn]=\"showDeleteBtn\" [deleteFileButtonLabel]=\"deleteFileButtonLabel\" [newUploadFileButtonLabel]=\"newUploadFileButtonLabel\" [openFileButtonLabel]=\"openFileButtonLabel\"\n            [showVisualizeBtn]=\"showVisualizeBtn\" [showFileTypeError]=\"showFileTypeError\"\n            [showFileSizeError]=\"showFileSizeError\" [sizeFileErrorMessage]=\"sizeFileErrorMessage\"\n            [typeFileErrorMessage]=\"typeFileErrorMessage\" (newUploadFile)=\"clickForUpload()\" [multiple]=\"multiple\"></cnet-file>\n        </ng-container>\n\n        <button cnet-filled-button size=\"small\" color=\"primary\" *ngIf=\"multiple\"\n          type=\"button\">\n          {{btnChooseFileLabel}}\n          <cnet-icon [size]=\"2\" style=\"padding-left: 4px;\" name=\"plus-circle\" label=\"plus-circle\">\n          </cnet-icon>\n        </button>\n      </div>\n    </ng-container>\n\n\n  </ng-container>\n\n  <ng-template #emptyContentTemplate>\n\n    <div class=\"empty-content\">\n\n      <ng-container *ngIf=\"showDefaultPlaceholder; else customInputTpl\">\n\n        <div>\n          <cnet-icon [size]=\"4\" name=\"file-upload\" label=\"file-upload\" class=\"file-upload-icon\">\n          </cnet-icon>\n        </div>\n\n        <div class=\"choose-file-label\">\n          {{placeholder}}\n        </div>\n        <button cnet-filled-button size=\"small\" color=\"primary\" type=\"button\">\n          {{btnChooseFileLabel}}\n          <cnet-icon [size]=\"2\" style=\"padding-left: 4px;\" name=\"plus-circle\" label=\"plus-circle\">\n          </cnet-icon>\n        </button>\n\n      </ng-container>\n      <ng-template #customInputTpl>\n        <ng-content select=\"cnet-upload-label, [cnet-upload-label], [cnetUploadLabel]\"></ng-content>\n      </ng-template>\n\n    </div>\n  </ng-template>\n</div>\n", styles: [".host:hover{cursor:pointer}.cnet-upload{width:100%}.content{margin:0;transform:translateZ(0)}.content:hover{cursor:pointer}.empty-content{padding:1rem;display:flex;flex-direction:column;align-items:center;gap:1rem}.cnet-upload-single .file-list-content{margin:0rem}.file-list-content{margin:.5rem;display:flex;flex-direction:column;gap:1rem}.dropzone{background-color:var(--cnet--100, #f5f5f5)}.choose-file-label{font-weight:400;font-size:1.125rem;color:#000000ab;text-transform:uppercase}.choose-file-label div{width:100%;display:flex;justify-content:center}.file-upload-icon{color:#000000ab}.file-droped{z-index:50;border:dashed 2px var(--cnet-primary-800, #65ab36)!important}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "directive", type: FileUploadDropZoneDirective, selector: "[cnetFileDropZone]", inputs: ["disabled"], outputs: ["onFileDropped"] }, { kind: "component", type: FileComponent, selector: "cnet-file", inputs: ["file", "maxFileSize", "showDeleteBtn", "deleteFileButtonLabel", "openFileButtonLabel", "newUploadFileButtonLabel", "showVisualizeBtn", "accept", "showFileTypeError", "showFileSizeError", "multiple", "sizeFileErrorMessage", "typeFileErrorMessage", "isImage", "imgHeight", "imgWidth"], outputs: ["removeFile", "newUploadFile", "fileSizeError"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-upload', exportAs: 'cnetUpload', host: {
                        class: 'cnet-upload',
                        '[class.cnet-upload-multiple]': 'multiple',
                        '[class.cnet-upload-single]': '!multiple',
                        role: 'upload',
                        tabindex: '0',
                        '[attr.id]': 'id',
                        '[attr.value]': 'value',
                        '[attr.name]': 'name',
                        '[class.cnet-upload-disabled]': 'disabled',
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, providers: [{ provide: CnetFormFieldControl, useExisting: CnetUploadComponent }], template: "<input type=\"file\" (change)=\"onFileChanged($event)\" [accept]=\"accept\" [multiple]=\"multiple\" #fileInput [hidden]=\"true\">\n\n<div class=\"content\" cnetFileDropZone (onFileDropped)=\"droppedFiles($event)\" (click)=\"clickForUpload()\">\n  <ng-container *ngIf=\"files$ | async as files; else emptyContentTemplate\">\n\n    <ng-container *ngIf=\"files.length else emptyContentTemplate\">\n      <div class=\"file-list-content\">\n\n\n        <ng-container *ngFor=\"let file of files\">\n          <cnet-file [file]=\"file\" (removeFile)=\"deleteFile(file)\" [accept]=\"accept\" [maxFileSize]=\"maxFileSize\"\n            [showDeleteBtn]=\"showDeleteBtn\" [deleteFileButtonLabel]=\"deleteFileButtonLabel\" [newUploadFileButtonLabel]=\"newUploadFileButtonLabel\" [openFileButtonLabel]=\"openFileButtonLabel\"\n            [showVisualizeBtn]=\"showVisualizeBtn\" [showFileTypeError]=\"showFileTypeError\"\n            [showFileSizeError]=\"showFileSizeError\" [sizeFileErrorMessage]=\"sizeFileErrorMessage\"\n            [typeFileErrorMessage]=\"typeFileErrorMessage\" (newUploadFile)=\"clickForUpload()\" [multiple]=\"multiple\"></cnet-file>\n        </ng-container>\n\n        <button cnet-filled-button size=\"small\" color=\"primary\" *ngIf=\"multiple\"\n          type=\"button\">\n          {{btnChooseFileLabel}}\n          <cnet-icon [size]=\"2\" style=\"padding-left: 4px;\" name=\"plus-circle\" label=\"plus-circle\">\n          </cnet-icon>\n        </button>\n      </div>\n    </ng-container>\n\n\n  </ng-container>\n\n  <ng-template #emptyContentTemplate>\n\n    <div class=\"empty-content\">\n\n      <ng-container *ngIf=\"showDefaultPlaceholder; else customInputTpl\">\n\n        <div>\n          <cnet-icon [size]=\"4\" name=\"file-upload\" label=\"file-upload\" class=\"file-upload-icon\">\n          </cnet-icon>\n        </div>\n\n        <div class=\"choose-file-label\">\n          {{placeholder}}\n        </div>\n        <button cnet-filled-button size=\"small\" color=\"primary\" type=\"button\">\n          {{btnChooseFileLabel}}\n          <cnet-icon [size]=\"2\" style=\"padding-left: 4px;\" name=\"plus-circle\" label=\"plus-circle\">\n          </cnet-icon>\n        </button>\n\n      </ng-container>\n      <ng-template #customInputTpl>\n        <ng-content select=\"cnet-upload-label, [cnet-upload-label], [cnetUploadLabel]\"></ng-content>\n      </ng-template>\n\n    </div>\n  </ng-template>\n</div>\n", styles: [".host:hover{cursor:pointer}.cnet-upload{width:100%}.content{margin:0;transform:translateZ(0)}.content:hover{cursor:pointer}.empty-content{padding:1rem;display:flex;flex-direction:column;align-items:center;gap:1rem}.cnet-upload-single .file-list-content{margin:0rem}.file-list-content{margin:.5rem;display:flex;flex-direction:column;gap:1rem}.dropzone{background-color:var(--cnet--100, #f5f5f5)}.choose-file-label{font-weight:400;font-size:1.125rem;color:#000000ab;text-transform:uppercase}.choose-file-label div{width:100%;display:flex;justify-content:center}.file-upload-icon{color:#000000ab}.file-droped{z-index:50;border:dashed 2px var(--cnet-primary-800, #65ab36)!important}\n"] }]
        }], ctorParameters: () => [{ type: i1$4.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }, { type: i0.ElementRef }, { type: UploadService }], propDecorators: { value: [{
                type: Input
            }], accept: [{
                type: Input
            }], disabled: [{
                type: Input,
                args: ['disabled']
            }], multiple: [{
                type: Input,
                args: ['multiple']
            }], maxFileSize: [{
                type: Input
            }], showDefaultPlaceholder: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], btnChooseFileLabel: [{
                type: Input
            }], showDeleteBtn: [{
                type: Input
            }], deleteFileButtonLabel: [{
                type: Input
            }], newUploadFileButtonLabel: [{
                type: Input
            }], openFileButtonLabel: [{
                type: Input
            }], showVisualizeBtn: [{
                type: Input
            }], showFileTypeError: [{
                type: Input
            }], showFileSizeError: [{
                type: Input
            }], sizeFileErrorMessage: [{
                type: Input
            }], typeFileErrorMessage: [{
                type: Input
            }], handleRemove: [{
                type: Input
            }], removeFile: [{
                type: Output
            }], fileInput: [{
                type: ViewChild,
                args: ['fileInput']
            }] } });

class CnetUploadLabelDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetUploadLabelDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetUploadLabelDirective, selector: "cnet-upload-label, [cnet-upload-label], [cnetUploadLabel]", host: { classAttribute: "cnet-upload-label" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetUploadLabelDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-upload-label, [cnet-upload-label], [cnetUploadLabel]',
                    host: { class: 'cnet-upload-label' }
                }]
        }] });

class CnetUploadModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetUploadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetUploadModule, declarations: [CnetUploadComponent,
            FileComponent,
            CnetInputForUploadDirective,
            CnetUploadLabelDirective], imports: [CommonModule,
            CnetButtonModule,
            CnetIconModule,
            CnetInputModule,
            CnetFileDropZoneModule], exports: [CnetUploadComponent,
            FileComponent,
            CnetInputForUploadDirective,
            CnetUploadLabelDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetUploadModule, imports: [CommonModule,
            CnetButtonModule,
            CnetIconModule,
            CnetInputModule,
            CnetFileDropZoneModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetUploadModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnetUploadComponent,
                        FileComponent,
                        CnetInputForUploadDirective,
                        CnetUploadLabelDirective
                    ],
                    exports: [
                        CnetUploadComponent,
                        FileComponent,
                        CnetInputForUploadDirective,
                        CnetUploadLabelDirective
                    ],
                    imports: [
                        CommonModule,
                        CnetButtonModule,
                        CnetIconModule,
                        CnetInputModule,
                        CnetFileDropZoneModule
                    ]
                }]
        }] });

class ImageFileComponent extends FileComponent {
    constructor() {
        super();
        /** @ignore */ this.cdr = inject(ChangeDetectorRef);
        this.imgHeight = null;
        this.imgWidth = null;
        this.maxHeight = null;
        this.maxWidth = null;
        this.imageRatio = null;
        this.showImageSizeError = true;
        this.hasImageSizeError = false;
        this.imageSizeErrorMessage = 'A imagem possui tamanho incompatível';
        this.showImageRatioError = true;
        this.hasImageRatioError = false;
        this.imageRatioMessage = 'A imagem possui aspect ratiio incompatível';
        this.imageWidthHeightError = new EventEmitter();
        this.imageRatioError = new EventEmitter();
    }
    ngOnChanges() {
        if (this.showImageSizeError) {
            this.isImageSizeValid().pipe(tap$1(error => {
                this.hasImageSizeError = error;
            })).subscribe();
        }
    }
    isImageSizeValid() {
        if (!(this.file && this.file.file) || !(this.imgWidth || this.imgHeight)) {
            return of(false);
        }
        if (!(this.maxWidth || this.maxHeight || this.imageRatio)) {
            return of(false);
        }
        const reader = new FileReader();
        reader.readAsDataURL(this.file.file);
        return new Observable((observer) => {
            reader.onload = (event) => {
                const result = event.target?.result;
                if (!result) {
                    observer.next(true);
                    observer.complete();
                    return;
                }
                const image = new Image();
                image.src = result;
                image.onload = () => {
                    let hasHeightError = this.maxHeight ? image.height > this.maxHeight : false;
                    let hasWidthError = this.maxWidth ? image.width > this.maxWidth : false;
                    if (hasHeightError || hasWidthError) {
                        this.imageWidthHeightError.emit(this.file);
                    }
                    const imageRatio = this.getAspectRatio(image.width, image.height);
                    if (this.imageRatio && !this.imageRatio.includes(imageRatio)) {
                        this.imageRatioError.emit(this.file);
                    }
                    observer.next(true);
                    observer.complete();
                    this.cdr.markForCheck();
                };
            };
        });
    }
    getAspectRatio(width, height) {
        const calculate = (a, b) => b === 0 ? a : calculate(b, a % b);
        return `${width / calculate(width, height)}:${height / calculate(width, height)}`;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ImageFileComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ImageFileComponent, selector: "cnet-image-file", inputs: { imgHeight: "imgHeight", imgWidth: "imgWidth", maxHeight: "maxHeight", maxWidth: "maxWidth", imageRatio: "imageRatio", showImageSizeError: "showImageSizeError", hasImageSizeError: "hasImageSizeError", imageSizeErrorMessage: "imageSizeErrorMessage", showImageRatioError: "showImageRatioError", hasImageRatioError: "hasImageRatioError", imageRatioMessage: "imageRatioMessage" }, outputs: { imageWidthHeightError: "imageWidthHeightError", imageRatioError: "imageRatioError" }, host: { attributes: { "role": "cnetImageFile" }, properties: { "class.cnet-file-error": "isFileBiggerThanMaxFileSize() || !isFileTypeValid() || !hasImageSizeError" }, classAttribute: "cnet-image-file" }, usesInheritance: true, usesOnChanges: true, ngImport: i0, template: "<div class=\"file-content\">\n  <div [class.justify-content-end]=\"!file?.name\" class=\"file-actions\"  >\n    {{file?.name}}\n    <div>\n      <button cnet-button size=\"small\" color=\"cancel\" (click)=\"newUpload()\" type=\"button\" *ngIf=\"!multiple\">\n        <cnet-icon [size]=\"2\" [id]=\"'btn'+file.name+'newUpload'\" style=\"padding-right: 4px;\" name=\"file-upload\"\n          label=\"file-upload\">\n        </cnet-icon>\n        <ng-container *ngIf=\"newUploadFileButtonLabel\">\n          {{newUploadFileButtonLabel}}\n        </ng-container>\n      </button>\n      <button cnet-button size=\"small\" color=\"cancel\" (click)=\"remove($event)\" type=\"button\">\n        <cnet-icon [size]=\"2\" [id]=\"'btn'+file.name+'remove'\" style=\"padding-right: 4px;\" name=\"trash\" label=\"trash\">\n        </cnet-icon>\n        <ng-container *ngIf=\"deleteFileButtonLabel\">\n          {{ deleteFileButtonLabel}}\n        </ng-container>\n      </button>\n    </div>\n  </div>\n\n  <div class=\"image-content\">\n    <img [src]=\"getUrlFromFile() | sanitizerUrl:'url'\"\n      [ngStyle]=\"{'height': imgHeight? imgHeight+'px': 'auto', 'width': imgWidth? imgWidth+'px': 'auto'}\" class=\"image\" />\n  </div>\n\n  <div class=\"file-content-error\" *ngIf=\"showFileSizeError && isFileBiggerThanMaxFileSize()\">\n    {{sizeFileErrorMessage}}\n  </div>\n  <div class=\"file-content-error\" *ngIf=\"showFileTypeError && !isFileTypeValid()\">\n    {{typeFileErrorMessage}}\n  </div>\n  <ng-container *ngIf=\"showImageSizeError\">\n    <div class=\"file-content-error\" *ngIf=\"hasImageSizeError\">\n      {{imageSizeErrorMessage}}\n    </div>\n  </ng-container>\n  <ng-container *ngIf=\"showImageRatioError\">\n    <div class=\"file-content-error\" *ngIf=\"hasImageRatioError\">\n      {{imageRatioMessage}}\n    </div>\n  </ng-container>\n\n</div>\n", styles: [":host{width:100%}:host.cnet-file-error .file-content{border-color:red}.file-actions.justify-content-end{justify-content:flex-end}.file-content{padding:.5rem;display:flex;flex-direction:column;align-items:flex-start;width:100%}.file-content-error{color:var(--cnet-danger-500, #ee4446);display:block;margin-top:.25rem;font-size:.875rem;padding-left:.5rem}.file-label{min-width:300px;text-transform:uppercase;padding-right:.5rem}.file-actions{display:flex;flex-direction:row;align-items:center;gap:.5rem;padding-left:.5rem;justify-content:space-between;border-bottom:1px solid #bdbdbd;margin-bottom:1rem;width:100%}.file-actions button{padding:0;min-width:fit-content}img{margin:1rem}.image-content{width:100%;height:100%}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "pipe", type: SanitizerUrlPipe, name: "sanitizerUrl" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ImageFileComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-image-file', host: {
                        class: 'cnet-image-file',
                        role: 'cnetImageFile',
                        '[class.cnet-file-error]': 'isFileBiggerThanMaxFileSize() || !isFileTypeValid() || !hasImageSizeError',
                    }, template: "<div class=\"file-content\">\n  <div [class.justify-content-end]=\"!file?.name\" class=\"file-actions\"  >\n    {{file?.name}}\n    <div>\n      <button cnet-button size=\"small\" color=\"cancel\" (click)=\"newUpload()\" type=\"button\" *ngIf=\"!multiple\">\n        <cnet-icon [size]=\"2\" [id]=\"'btn'+file.name+'newUpload'\" style=\"padding-right: 4px;\" name=\"file-upload\"\n          label=\"file-upload\">\n        </cnet-icon>\n        <ng-container *ngIf=\"newUploadFileButtonLabel\">\n          {{newUploadFileButtonLabel}}\n        </ng-container>\n      </button>\n      <button cnet-button size=\"small\" color=\"cancel\" (click)=\"remove($event)\" type=\"button\">\n        <cnet-icon [size]=\"2\" [id]=\"'btn'+file.name+'remove'\" style=\"padding-right: 4px;\" name=\"trash\" label=\"trash\">\n        </cnet-icon>\n        <ng-container *ngIf=\"deleteFileButtonLabel\">\n          {{ deleteFileButtonLabel}}\n        </ng-container>\n      </button>\n    </div>\n  </div>\n\n  <div class=\"image-content\">\n    <img [src]=\"getUrlFromFile() | sanitizerUrl:'url'\"\n      [ngStyle]=\"{'height': imgHeight? imgHeight+'px': 'auto', 'width': imgWidth? imgWidth+'px': 'auto'}\" class=\"image\" />\n  </div>\n\n  <div class=\"file-content-error\" *ngIf=\"showFileSizeError && isFileBiggerThanMaxFileSize()\">\n    {{sizeFileErrorMessage}}\n  </div>\n  <div class=\"file-content-error\" *ngIf=\"showFileTypeError && !isFileTypeValid()\">\n    {{typeFileErrorMessage}}\n  </div>\n  <ng-container *ngIf=\"showImageSizeError\">\n    <div class=\"file-content-error\" *ngIf=\"hasImageSizeError\">\n      {{imageSizeErrorMessage}}\n    </div>\n  </ng-container>\n  <ng-container *ngIf=\"showImageRatioError\">\n    <div class=\"file-content-error\" *ngIf=\"hasImageRatioError\">\n      {{imageRatioMessage}}\n    </div>\n  </ng-container>\n\n</div>\n", styles: [":host{width:100%}:host.cnet-file-error .file-content{border-color:red}.file-actions.justify-content-end{justify-content:flex-end}.file-content{padding:.5rem;display:flex;flex-direction:column;align-items:flex-start;width:100%}.file-content-error{color:var(--cnet-danger-500, #ee4446);display:block;margin-top:.25rem;font-size:.875rem;padding-left:.5rem}.file-label{min-width:300px;text-transform:uppercase;padding-right:.5rem}.file-actions{display:flex;flex-direction:row;align-items:center;gap:.5rem;padding-left:.5rem;justify-content:space-between;border-bottom:1px solid #bdbdbd;margin-bottom:1rem;width:100%}.file-actions button{padding:0;min-width:fit-content}img{margin:1rem}.image-content{width:100%;height:100%}\n"] }]
        }], ctorParameters: () => [], propDecorators: { imgHeight: [{
                type: Input
            }], imgWidth: [{
                type: Input
            }], maxHeight: [{
                type: Input
            }], maxWidth: [{
                type: Input
            }], imageRatio: [{
                type: Input
            }], showImageSizeError: [{
                type: Input
            }], hasImageSizeError: [{
                type: Input
            }], imageSizeErrorMessage: [{
                type: Input
            }], showImageRatioError: [{
                type: Input
            }], hasImageRatioError: [{
                type: Input
            }], imageRatioMessage: [{
                type: Input
            }], imageWidthHeightError: [{
                type: Output
            }], imageRatioError: [{
                type: Output
            }] } });

class CnetImageUploadComponent extends CnetUploadComponent {
    constructor(ngControl, elementRef, uploadValidatorsService) {
        super(ngControl, elementRef, uploadValidatorsService);
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.uploadValidatorsService = uploadValidatorsService;
        this.imgHeight = null;
        this.imgWidth = null;
        this.maxHeight = null;
        this.maxWidth = null;
        this.imageRatio = null;
        this.showImageSizeError = true;
        this.showImageRatioError = true;
        this.imageSizeErrorMessage = 'A imagem possui tamanho incompatível';
        this.imageRatioMessage = 'A imagem possui aspect ratiio incompatível';
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }
    ngOnInit() {
        super.ngOnInit();
    }
    imageWidthHeightError(file) {
        this.ngControl.control.setErrors({ 'imageWidthHeightError': true });
    }
    imageRatioError(file) {
        this.ngControl.control.setErrors({ 'imageRatioError': true });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetImageUploadComponent, deps: [{ token: i1$4.NgControl, optional: true, self: true }, { token: i0.ElementRef }, { token: UploadService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetImageUploadComponent, selector: "cnet-image-upload", inputs: { imgHeight: "imgHeight", imgWidth: "imgWidth", maxHeight: "maxHeight", maxWidth: "maxWidth", imageRatio: "imageRatio", showImageSizeError: "showImageSizeError", showImageRatioError: "showImageRatioError", imageSizeErrorMessage: "imageSizeErrorMessage", imageRatioMessage: "imageRatioMessage" }, host: { attributes: { "role": "upload", "tabindex": "0" }, properties: { "class.cnet-image-upload-image": "isImage", "class.cnet-image-upload-multiple": "multiple", "class.cnet-image-upload-single": "!multiple", "attr.id": "id", "attr.value": "value", "attr.name": "name", "class.cnet-image-upload-disabled": "disabled" }, classAttribute: "cnet-image-upload" }, providers: [{ provide: CnetFormFieldControl, useExisting: CnetImageUploadComponent }], viewQueries: [{ propertyName: "fileInput", first: true, predicate: ["fileInput"], descendants: true }], exportAs: ["cnetImageUpload"], usesInheritance: true, ngImport: i0, template: "<input type=\"file\" (change)=\"onFileChanged($event)\" [accept]=\"accept\" [multiple]=\"multiple\" #fileInput [hidden]=\"true\">\n<div class=\"content\" cnetFileDropZone (onFileDropped)=\"droppedFiles($event)\">\n  <ng-container *ngIf=\"files$ | async as files; else emptyContentTemplate\">\n\n    <ng-container *ngIf=\"files.length else emptyContentTemplate\">\n      <div class=\"file-list-content\">\n\n\n        <ng-container *ngFor=\"let file of files\">\n          <cnet-image-file [file]=\"file\" (removeFile)=\"deleteFile(file)\" [accept]=\"accept\" [maxFileSize]=\"maxFileSize\"\n            [deleteFileButtonLabel]=\"deleteFileButtonLabel\" [newUploadFileButtonLabel]=\"newUploadFileButtonLabel\"\n            [openFileButtonLabel]=\"openFileButtonLabel\" [showVisualizeBtn]=\"showVisualizeBtn\"\n            [showFileTypeError]=\"showFileTypeError\" [showFileSizeError]=\"showFileSizeError\"\n            [sizeFileErrorMessage]=\"sizeFileErrorMessage\" [typeFileErrorMessage]=\"typeFileErrorMessage\"\n            [imgWidth]=\"imgWidth\" [imgHeight]=\"imgHeight\" (newUploadFile)=\"clickForUpload()\"\n            [multiple]=\"multiple\" (imageWidthHeightError)=\"imageWidthHeightError($event)\"\n            [showImageRatioError]=\"showImageRatioError\" [showImageSizeError]=\"showImageSizeError\"\n            [imageSizeErrorMessage]=\"imageSizeErrorMessage\" [imageRatioMessage]=\"imageRatioMessage\"\n            [maxHeight]=\"maxHeight\" [maxWidth]=\"maxWidth\" [imageRatio]=\"imageRatio\" (imageRatioError)=\"imageRatioError($event)\"></cnet-image-file>\n\n        </ng-container>\n\n        <button cnet-filled-button size=\"small\" color=\"primary\" (click)=\"clickForUpload()\" *ngIf=\"multiple\"\n          type=\"button\">\n          {{btnChooseFileLabel}}\n          <cnet-icon [size]=\"2\" style=\"padding-left: 4px;\" name=\"plus-circle\" label=\"plus-circle\">\n          </cnet-icon>\n        </button>\n      </div>\n    </ng-container>\n\n\n  </ng-container>\n\n  <ng-template #emptyContentTemplate>\n\n    <div class=\"empty-content\" (click)=\"clickForUpload()\">\n\n      <ng-container *ngIf=\"showDefaultPlaceholder; else customInputTpl\">\n\n        <div>\n          <cnet-icon [size]=\"4\" name=\"file-upload\" label=\"file-upload\" class=\"file-upload-icon\">\n          </cnet-icon>\n        </div>\n\n        <div class=\"choose-file-label\">\n          {{placeholder}}\n        </div>\n        <button cnet-filled-button size=\"small\" color=\"primary\" type=\"button\">\n          {{btnChooseFileLabel}}\n          <cnet-icon [size]=\"2\" style=\"padding-left: 4px;\" name=\"plus-circle\" label=\"plus-circle\">\n          </cnet-icon>\n        </button>\n\n      </ng-container>\n      <ng-template #customInputTpl>\n        <ng-content select=\"cnet-upload-label, [cnet-upload-label], [cnetUploadLabel]\"></ng-content>\n      </ng-template>\n\n    </div>\n\n  </ng-template>\n</div>\n", styles: [".cnet-upload{width:100%}.content{margin:0;transform:translateZ(0)}.cnet-upload-image .empty-content{flex-direction:row;padding:.5rem}.cnet-upload-image .choose-file-label{font-size:1rem}.empty-content{padding:1rem;display:flex;flex-direction:column;align-items:center;gap:1rem}.cnet-upload-single .file-list-content{margin:0rem}.file-list-content{margin:.5rem;display:flex;flex-direction:column;gap:1rem}.dropzone{background-color:var(--cnet--100, #f5f5f5)}.choose-file-label{font-weight:400;font-size:1.125rem;color:#000000ab;text-transform:uppercase}.choose-file-label div{width:100%;display:flex;justify-content:center}.file-upload-icon{color:#000000ab}.file-droped{z-index:50;border:dashed 2px var(--cnet-primary-800, #65ab36)!important}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "directive", type: FileUploadDropZoneDirective, selector: "[cnetFileDropZone]", inputs: ["disabled"], outputs: ["onFileDropped"] }, { kind: "component", type: ImageFileComponent, selector: "cnet-image-file", inputs: ["imgHeight", "imgWidth", "maxHeight", "maxWidth", "imageRatio", "showImageSizeError", "hasImageSizeError", "imageSizeErrorMessage", "showImageRatioError", "hasImageRatioError", "imageRatioMessage"], outputs: ["imageWidthHeightError", "imageRatioError"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetImageUploadComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-image-upload', exportAs: 'cnetImageUpload', host: {
                        class: 'cnet-image-upload',
                        '[class.cnet-image-upload-image]': 'isImage',
                        '[class.cnet-image-upload-multiple]': 'multiple',
                        '[class.cnet-image-upload-single]': '!multiple',
                        role: 'upload',
                        tabindex: '0',
                        '[attr.id]': 'id',
                        '[attr.value]': 'value',
                        '[attr.name]': 'name',
                        '[class.cnet-image-upload-disabled]': 'disabled',
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, providers: [{ provide: CnetFormFieldControl, useExisting: CnetImageUploadComponent }], template: "<input type=\"file\" (change)=\"onFileChanged($event)\" [accept]=\"accept\" [multiple]=\"multiple\" #fileInput [hidden]=\"true\">\n<div class=\"content\" cnetFileDropZone (onFileDropped)=\"droppedFiles($event)\">\n  <ng-container *ngIf=\"files$ | async as files; else emptyContentTemplate\">\n\n    <ng-container *ngIf=\"files.length else emptyContentTemplate\">\n      <div class=\"file-list-content\">\n\n\n        <ng-container *ngFor=\"let file of files\">\n          <cnet-image-file [file]=\"file\" (removeFile)=\"deleteFile(file)\" [accept]=\"accept\" [maxFileSize]=\"maxFileSize\"\n            [deleteFileButtonLabel]=\"deleteFileButtonLabel\" [newUploadFileButtonLabel]=\"newUploadFileButtonLabel\"\n            [openFileButtonLabel]=\"openFileButtonLabel\" [showVisualizeBtn]=\"showVisualizeBtn\"\n            [showFileTypeError]=\"showFileTypeError\" [showFileSizeError]=\"showFileSizeError\"\n            [sizeFileErrorMessage]=\"sizeFileErrorMessage\" [typeFileErrorMessage]=\"typeFileErrorMessage\"\n            [imgWidth]=\"imgWidth\" [imgHeight]=\"imgHeight\" (newUploadFile)=\"clickForUpload()\"\n            [multiple]=\"multiple\" (imageWidthHeightError)=\"imageWidthHeightError($event)\"\n            [showImageRatioError]=\"showImageRatioError\" [showImageSizeError]=\"showImageSizeError\"\n            [imageSizeErrorMessage]=\"imageSizeErrorMessage\" [imageRatioMessage]=\"imageRatioMessage\"\n            [maxHeight]=\"maxHeight\" [maxWidth]=\"maxWidth\" [imageRatio]=\"imageRatio\" (imageRatioError)=\"imageRatioError($event)\"></cnet-image-file>\n\n        </ng-container>\n\n        <button cnet-filled-button size=\"small\" color=\"primary\" (click)=\"clickForUpload()\" *ngIf=\"multiple\"\n          type=\"button\">\n          {{btnChooseFileLabel}}\n          <cnet-icon [size]=\"2\" style=\"padding-left: 4px;\" name=\"plus-circle\" label=\"plus-circle\">\n          </cnet-icon>\n        </button>\n      </div>\n    </ng-container>\n\n\n  </ng-container>\n\n  <ng-template #emptyContentTemplate>\n\n    <div class=\"empty-content\" (click)=\"clickForUpload()\">\n\n      <ng-container *ngIf=\"showDefaultPlaceholder; else customInputTpl\">\n\n        <div>\n          <cnet-icon [size]=\"4\" name=\"file-upload\" label=\"file-upload\" class=\"file-upload-icon\">\n          </cnet-icon>\n        </div>\n\n        <div class=\"choose-file-label\">\n          {{placeholder}}\n        </div>\n        <button cnet-filled-button size=\"small\" color=\"primary\" type=\"button\">\n          {{btnChooseFileLabel}}\n          <cnet-icon [size]=\"2\" style=\"padding-left: 4px;\" name=\"plus-circle\" label=\"plus-circle\">\n          </cnet-icon>\n        </button>\n\n      </ng-container>\n      <ng-template #customInputTpl>\n        <ng-content select=\"cnet-upload-label, [cnet-upload-label], [cnetUploadLabel]\"></ng-content>\n      </ng-template>\n\n    </div>\n\n  </ng-template>\n</div>\n", styles: [".cnet-upload{width:100%}.content{margin:0;transform:translateZ(0)}.cnet-upload-image .empty-content{flex-direction:row;padding:.5rem}.cnet-upload-image .choose-file-label{font-size:1rem}.empty-content{padding:1rem;display:flex;flex-direction:column;align-items:center;gap:1rem}.cnet-upload-single .file-list-content{margin:0rem}.file-list-content{margin:.5rem;display:flex;flex-direction:column;gap:1rem}.dropzone{background-color:var(--cnet--100, #f5f5f5)}.choose-file-label{font-weight:400;font-size:1.125rem;color:#000000ab;text-transform:uppercase}.choose-file-label div{width:100%;display:flex;justify-content:center}.file-upload-icon{color:#000000ab}.file-droped{z-index:50;border:dashed 2px var(--cnet-primary-800, #65ab36)!important}\n"] }]
        }], ctorParameters: () => [{ type: i1$4.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }, { type: i0.ElementRef }, { type: UploadService }], propDecorators: { imgHeight: [{
                type: Input
            }], imgWidth: [{
                type: Input
            }], maxHeight: [{
                type: Input
            }], maxWidth: [{
                type: Input
            }], imageRatio: [{
                type: Input
            }], showImageSizeError: [{
                type: Input
            }], showImageRatioError: [{
                type: Input
            }], imageSizeErrorMessage: [{
                type: Input
            }], imageRatioMessage: [{
                type: Input
            }], fileInput: [{
                type: ViewChild,
                args: ['fileInput']
            }] } });

class CnetImageUploadModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetImageUploadModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetImageUploadModule, declarations: [CnetImageUploadComponent,
            ImageFileComponent], imports: [CommonModule,
            CnetButtonModule,
            CnetIconModule,
            CnetInputModule,
            SanitizerUrlModule,
            CnetToolbarModule,
            CnetFileDropZoneModule], exports: [CnetImageUploadComponent,
            ImageFileComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetImageUploadModule, imports: [CommonModule,
            CnetButtonModule,
            CnetIconModule,
            CnetInputModule,
            SanitizerUrlModule,
            CnetToolbarModule,
            CnetFileDropZoneModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetImageUploadModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnetImageUploadComponent,
                        ImageFileComponent,
                    ],
                    exports: [
                        CnetImageUploadComponent,
                        ImageFileComponent,
                    ],
                    imports: [
                        CommonModule,
                        CnetButtonModule,
                        CnetIconModule,
                        CnetInputModule,
                        SanitizerUrlModule,
                        CnetToolbarModule,
                        CnetFileDropZoneModule
                    ]
                }]
        }] });

let nextUniqueId$2 = 0;
/**
 * CnetNavbarItem represents each of the CnetNavbar items.
 *
 * @export
 * class CnetNavbarItem
 */
class CnetNavbarItemComponent {
    /**
     * The id for the navigation item
     *
     * @readonly
     * type {string}
     * @memberof CnetNavbarItem
     */
    get id() { return this._id; }
    set id(value) {
        this._id = value;
    }
    /**
     * Whether the navigation is active.
     *
     * @readonly
     * type {boolean}
     * @memberof CnetNavbarItem
     */
    get activated() { return this._activated; }
    set activated(value) {
        this._activated = coerceBooleanProperty(value);
    }
    /**
     * Whether the navigation is disabled.
     *
     * @readonly
     * type {boolean}
     * @memberof CnetNavbarItem
     */
    get disabled() { return this._disabled; }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    constructor(_elementRef, _focusMonitor) {
        this._elementRef = _elementRef;
        this._focusMonitor = _focusMonitor;
        /** @ignore */ this._id = `cnet-navbar-item-${nextUniqueId$2++}`;
        /**
         * Emits when the item is activated
         *
         * @memberof CnetNavbarItem
         */
        this.activateStream = new EventEmitter();
        this._focusMonitor.monitor(this._elementRef, true);
    }
    ngOnDestroy() {
        this._focusMonitor.stopMonitoring(this._elementRef);
    }
    focus(origin = 'program', options) {
        this._focusMonitor.focusVia(this._getHostElement(), origin, options);
    }
    /**
     * Activate this navigation item
     *
     * @memberof CnetNavbarItem
     */
    activateItem(event) {
        if (!this.disabled) {
            this.activateStream.emit(this.id);
        }
    }
    _getHostElement() {
        return this._elementRef.nativeElement;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNavbarItemComponent, deps: [{ token: i0.ElementRef }, { token: i1$2.FocusMonitor }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetNavbarItemComponent, selector: "a[cnetNavbarItem], a[cnet-navbar-item], button[cnetNavbarItem], button[cnet-navbar-item]", inputs: { id: ["cnetNavbarItemId", "id"], activated: ["cnetNavbarItemActive", "activated"], disabled: "disabled" }, outputs: { activateStream: "activateStream" }, host: { listeners: { "click": "activateItem($event)" }, properties: { "class.cnet-navbar-item-active": "activated" }, classAttribute: "cnet-navbar-item" }, exportAs: ["cnetNavbarItem"], ngImport: i0, template: "<ng-content></ng-content>\n\n<span cnetRipple\n  class=\"cnet-navbar-item-ripple\"\n  [cnetRippleTrigger]=\"_getHostElement()\"\n  [cnetRippleDisabled]=\"disabled\">\n</span>", dependencies: [{ kind: "directive", type: CnetRippleDirective, selector: "[cnet-ripple], [cnetRipple]", inputs: ["cnetRippleColor", "cnetRippleUnbounded", "cnetRippleCentered", "cnetRippleRadius", "cnetRippleAnimation", "cnetRippleDisabled", "cnetRippleTrigger"], exportAs: ["cnetRipple"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNavbarItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'a[cnetNavbarItem], a[cnet-navbar-item], button[cnetNavbarItem], button[cnet-navbar-item]', exportAs: 'cnetNavbarItem', host: {
                        class: 'cnet-navbar-item',
                        '[class.cnet-navbar-item-active]': 'activated'
                    }, template: "<ng-content></ng-content>\n\n<span cnetRipple\n  class=\"cnet-navbar-item-ripple\"\n  [cnetRippleTrigger]=\"_getHostElement()\"\n  [cnetRippleDisabled]=\"disabled\">\n</span>" }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$2.FocusMonitor }], propDecorators: { activateStream: [{
                type: Output
            }], id: [{
                type: Input,
                args: ['cnetNavbarItemId']
            }], activated: [{
                type: Input,
                args: ['cnetNavbarItemActive']
            }], disabled: [{
                type: Input
            }], activateItem: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

/**
 * Cnet Navbar is used to create a list of navigable items
 *
 * @export
 * class CnetNavbarComponent
 * implements {AfterViewInit}
 */
class CnetNavbarComponent {
    constructor() {
        /** @ignore */ this._subscriptionList = [];
        /**
         * Stream that emits whenever the active item are changed.
         *
         * type {BehaviorSubject<string>}
         * @memberof CnetNavbarComponent
         */
        this.activeItem = new BehaviorSubject(null);
    }
    /** @ignore */
    ngAfterViewInit() {
        this._items.forEach(item => {
            let sub = item.activateStream.subscribe(id => {
                if (id !== this._active) {
                    this.changeActiveItem(id);
                }
            });
            this._subscriptionList.push(sub);
        });
    }
    /**
     * Change the active item based on the item ID
     *
     * param {string} id
     * @memberof CnetNavbarComponent
     */
    changeActiveItem(id) {
        this._active = id;
        this._items.forEach(item => {
            item.activated = item.id == this._active ? true : false;
        });
        this.activeItem.next(id);
    }
    /** @ignore */
    ngOnDestroy() {
        this._subscriptionList.forEach(subscription => {
            subscription.unsubscribe();
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNavbarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetNavbarComponent, selector: "cnet-navbar", host: { attributes: { "role": "navigation" }, classAttribute: "cnet-navbar" }, queries: [{ propertyName: "_items", predicate: CnetNavbarItemComponent }], exportAs: ["cnetNavbar"], ngImport: i0, template: "<ng-content></ng-content>", styles: [".cnet-navbar{display:flex;border-bottom:2px solid #e0e0e0}.cnet-navbar-item{padding:.75rem 1rem;border:none;border-radius:0;background-color:transparent;text-transform:uppercase;font-size:.875rem;color:#000000ab;-ms-flex-pack:center;justify-content:center;cursor:pointer;margin-bottom:-2px;border-bottom-style:solid;border-bottom-width:2px;border-bottom-color:transparent;-webkit-user-select:none;user-select:none;transition:color ease-in .2s,border-bottom-color ease-in .3s;position:relative;overflow:hidden;text-decoration:none}.cnet-navbar-item:hover:not(:disabled),.cnet-navbar-item:focus:not(:disabled){color:var(--cnet-primary-500, #82c14f)}.cnet-navbar-item:disabled{color:#0000006b}.cnet-navbar-item-ripple{content:\"\";position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none}.cnet-navbar-item-active{color:var(--cnet-primary-500, #82c14f);border-bottom-color:var(--cnet-primary-500, #82c14f)}\n"], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNavbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-navbar', exportAs: 'cnetNavbar', host: {
                        class: 'cnet-navbar',
                        role: 'navigation'
                    }, changeDetection: ChangeDetectionStrategy.Default, encapsulation: ViewEncapsulation.None, template: "<ng-content></ng-content>", styles: [".cnet-navbar{display:flex;border-bottom:2px solid #e0e0e0}.cnet-navbar-item{padding:.75rem 1rem;border:none;border-radius:0;background-color:transparent;text-transform:uppercase;font-size:.875rem;color:#000000ab;-ms-flex-pack:center;justify-content:center;cursor:pointer;margin-bottom:-2px;border-bottom-style:solid;border-bottom-width:2px;border-bottom-color:transparent;-webkit-user-select:none;user-select:none;transition:color ease-in .2s,border-bottom-color ease-in .3s;position:relative;overflow:hidden;text-decoration:none}.cnet-navbar-item:hover:not(:disabled),.cnet-navbar-item:focus:not(:disabled){color:var(--cnet-primary-500, #82c14f)}.cnet-navbar-item:disabled{color:#0000006b}.cnet-navbar-item-ripple{content:\"\";position:absolute;left:0;top:0;width:100%;height:100%;pointer-events:none}.cnet-navbar-item-active{color:var(--cnet-primary-500, #82c14f);border-bottom-color:var(--cnet-primary-500, #82c14f)}\n"] }]
        }], propDecorators: { _items: [{
                type: ContentChildren,
                args: [CnetNavbarItemComponent]
            }] } });

class CnetNavbarModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNavbarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetNavbarModule, declarations: [CnetNavbarComponent, CnetNavbarItemComponent], imports: [CommonModule,
            CnetRippleModule,
            CnetRippleModule], exports: [CnetNavbarComponent, CnetNavbarItemComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNavbarModule, imports: [CommonModule,
            CnetRippleModule,
            CnetRippleModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNavbarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetNavbarComponent, CnetNavbarItemComponent],
                    imports: [
                        CommonModule,
                        CnetRippleModule,
                        CnetRippleModule
                    ],
                    exports: [CnetNavbarComponent, CnetNavbarItemComponent]
                }]
        }] });

let nextUniqueId$1 = 0;
class CnetSidenavItemDirective {
    get id() { return this._id; }
    set id(value) {
        this._id = value;
    }
    get activated() { return this._activated; }
    set activated(value) {
        this._activated = coerceBooleanProperty(value);
    }
    get disabled() { return this._disabled; }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    get color() { return this._color; }
    set color(value) { this._color = value; }
    constructor(_elementRef, _focusMonitor) {
        this._elementRef = _elementRef;
        this._focusMonitor = _focusMonitor;
        /** @ignore */ this._id = `cnet-sidebar-item-${nextUniqueId$1++}`;
        this.manual = false;
        this._color = 'primary';
        this.activateStream = new EventEmitter();
        this._focusMonitor.monitor(this._elementRef, true);
    }
    ngOnDestroy() {
        this._focusMonitor.stopMonitoring(this._elementRef);
    }
    /**
     * Activate this navigation item
     *
     * @memberof CnetNavbarItem
     */
    activateItem(event) {
        if (!this.disabled && !this.manual) {
            this.activateStream.emit(this.id);
        }
    }
    _getHostElement() {
        return this._elementRef.nativeElement;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSidenavItemDirective, deps: [{ token: i0.ElementRef }, { token: i1$2.FocusMonitor }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetSidenavItemDirective, selector: "[cnetSidenavItem], cnet-sidenav-item, [cnet-sidenav-item]", inputs: { id: ["cnetSideNavItemId", "id"], activated: ["cnetSideNavItemActive", "activated"], disabled: "disabled", manual: "manual", color: "color" }, outputs: { activateStream: "activateStream" }, host: { listeners: { "click": "activateItem($event)" }, properties: { "class.cnet-sidenav-item-activated": "activated", "class.cnet-sidenav-item-disabled": "disabled", "class.cnet-color-success": "color == \"success\"", "class.cnet-color-cancel": "color == \"cancel\"", "class.cnet-color-primary": "color == \"primary\"", "class.cnet-color-secondary": "color == \"secondary\"", "class.cnet-color-danger": "color == \"danger\"" }, classAttribute: "cnet-sidenav-item" }, exportAs: ["cnetSidenavItem"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSidenavItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetSidenavItem], cnet-sidenav-item, [cnet-sidenav-item]',
                    exportAs: 'cnetSidenavItem',
                    host: {
                        class: 'cnet-sidenav-item',
                        '[class.cnet-sidenav-item-activated]': 'activated',
                        '[class.cnet-sidenav-item-disabled]': 'disabled',
                        '[class.cnet-color-success]': 'color == "success"',
                        '[class.cnet-color-cancel]': 'color == "cancel"',
                        '[class.cnet-color-primary]': 'color == "primary"',
                        '[class.cnet-color-secondary]': 'color == "secondary"',
                        '[class.cnet-color-danger]': 'color == "danger"',
                    },
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$2.FocusMonitor }], propDecorators: { id: [{
                type: Input,
                args: ['cnetSideNavItemId']
            }], activated: [{
                type: Input,
                args: ['cnetSideNavItemActive']
            }], disabled: [{
                type: Input
            }], manual: [{
                type: Input
            }], color: [{
                type: Input
            }], activateStream: [{
                type: Output
            }], activateItem: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
/**
 * Animations used by the Material drawers.
 * @docs-private
 */
const matDrawerAnimations = {
    /** Animation that slides a drawer in and out. */
    transformDrawer: trigger('transform', [
        // We remove the `transform` here completely, rather than setting it to zero, because:
        // 1. Having a transform can cause elements with ripples or an animated
        //    transform to shift around in Chrome with an RTL layout (see #10023).
        // 2. 3d transforms causes text to appear blurry on IE and Edge.
        state('open, open-instant', style({
            'transform': 'none',
            'visibility': 'visible',
        })),
        state('void', style({
            // Avoids the shadow showing up when closed in SSR.
            'box-shadow': 'none',
            'visibility': 'hidden',
        })),
        transition('void => open-instant', animate('0ms')),
        transition('void <=> open, open-instant => void', animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)')),
    ]),
};

class PageSidenavComponent {
    get position() {
        return this._position;
    }
    set position(value) {
        // Make sure we have a valid value.
        value = value === 'end' ? 'end' : 'start';
        if (value !== this._position) {
            // Static inputs in Ivy are set before the element is in the DOM.
            // if (this._isAttached) {
            //   this._updatePositionInParent(value);
            // }
            this._position = value;
            // this.onPositionChanged.emit();
        }
    }
    /** Mode of the drawer; one of 'over', 'push' or 'side'. */
    get mode() {
        return this._mode;
    }
    set mode(value) {
        this._mode = value;
        // this._updateFocusTrapState();
        // this._modeChanged.next();
    }
    get opened() {
        return this._opened;
    }
    set opened(value) {
        this.toggle(coerceBooleanProperty(value));
    }
    constructor(_elementRef, cdr, _container) {
        this._elementRef = _elementRef;
        this.cdr = cdr;
        this._container = _container;
        this._animationState = 'void';
        this._animationStarted = new Subject();
        /** Emits whenever the drawer is done animating. */
        this._animationEnd = new Subject();
        this._enableAnimations = false;
        this._position = 'start';
        this._mode = 'side';
        this._opened = false;
        /** @ignore */ this._subscriptionList = [];
        this.activeItem = new BehaviorSubject(null);
        this.openedChange = 
        // Note this has to be async in order to avoid some issues with two-bindings (see #8872).
        new EventEmitter(/* isAsync */ true);
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        this._items.changes.pipe(tap$1(items => {
            this.updateSubscriptions();
        })).subscribe();
        this.updateSubscriptions();
    }
    updateSubscriptions() {
        if (this._subscriptionList?.length) {
            this._subscriptionList.forEach(s => s.unsubscribe());
            this._subscriptionList = [];
        }
        this._items.forEach(item => {
            let sub = item.activateStream.subscribe(id => {
                if (id !== this._active) {
                    this.changeActiveItem(id);
                }
            });
            this._subscriptionList.push(sub);
        });
        setTimeout(() => {
            const activatedItem = this._items.find(item => item.activated);
            if (activatedItem) {
                this.changeActiveItem(activatedItem.id);
            }
        }, 5);
    }
    _getWidth() {
        return this._elementRef.nativeElement ? this._elementRef.nativeElement.offsetWidth || 0 : 0;
    }
    toggle(isOpen = !this.opened, openedVia) {
        // If the focus is currently inside the drawer content and we are closing the drawer,
        // restore the focus to the initially focused element (when the drawer opened).
        // if (isOpen && openedVia) {
        //   this._openedVia = openedVia;
        // }
        const result = this._setOpen(isOpen);
        // if (!isOpen) {
        //   this._openedVia = null;
        // }
        return result;
    }
    /**
     * Toggles the opened state of the drawer.
     * @param isOpen Whether the drawer should open or close.
     * @param restoreFocus Whether focus should be restored on close.
     * @param focusOrigin Origin to use when restoring focus.
     */
    _setOpen(isOpen) {
        this._opened = isOpen;
        if (isOpen) {
            this._animationState = this._enableAnimations ? 'open' : 'open-instant';
        }
        else {
            this._animationState = 'void';
            // if (restoreFocus) {
            //   this._restoreFocus(focusOrigin);
            // }
        }
        // this._updateFocusTrapState();
        return new Promise(resolve => {
            this.openedChange.pipe(take$1(1)).subscribe(open => resolve(open ? 'open' : 'close'));
        });
    }
    // /**
    //  * Open the drawer.
    //  * @param openedVia Whether the drawer was opened by a key press, mouse click or programmatically.
    //  * Used for focus management after the sidenav is closed.
    //  */
    // open(openedVia?: FocusOrigin): Promise<MatDrawerToggleResult> {
    //   return this.toggle(true, openedVia);
    // }
    // /** Close the drawer. */
    // close(): Promise<MatDrawerToggleResult> {
    //   return this.toggle(false);
    // }
    // /**
    //  * Toggle this drawer.
    //  * @param isOpen Whether the drawer should be open.
    //  * @param openedVia Whether the drawer was opened by a key press, mouse click or programmatically.
    //  * Used for focus management after the sidenav is closed.
    //  */
    // toggle(isOpen: boolean = !this.opened, openedVia?: FocusOrigin): Promise<MatDrawerToggleResult> {
    //   // If the focus is currently inside the drawer content and we are closing the drawer,
    //   // restore the focus to the initially focused element (when the drawer opened).
    //   if (isOpen && openedVia) {
    //     this._openedVia = openedVia;
    //   }
    //   const result = this._setOpen(
    //     isOpen,
    //     /* restoreFocus */ !isOpen && this._isFocusWithinDrawer(),
    //     this._openedVia || 'program',
    //   );
    //   if (!isOpen) {
    //     this._openedVia = null;
    //   }
    //   return result;
    // }
    changeActiveItem(id) {
        this._active = id;
        this._items.forEach(item => {
            item.activated = item.id == this._active ? true : false;
        });
        this.activeItem.next(id);
        this.cdr.detectChanges();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageSidenavComponent, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: MAT_DRAWER_CONTAINER, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PageSidenavComponent, selector: "cnet-page-sidenav, [cnet-page-sidenav], [cnetPageSidenav]", inputs: { position: "position", mode: "mode", opened: "opened" }, outputs: { openedChange: "openedChange" }, host: { attributes: { "tabIndex": "-1" }, listeners: { "@transform.start": "_animationStarted.next($event)", "@transform.done": "_animationEnd.next($event)" }, properties: { "attr.align": "null", "class.cnet-page-sidenav-end": "position === \"end\"", "class.cnet-page-sidenav-over": "mode === \"over\"", "class.cnet-page-sidenav-push": "mode === \"push\"", "class.cnet-page-sidenav-side": "mode === \"side\"", "class.cnet-page-sidenav-opened": "opened", "@transform": "_animationState" }, classAttribute: "cnet-drawer cnet-page-sidenav" }, queries: [{ propertyName: "_items", predicate: i0.forwardRef(() => CnetSidenavItemDirective), descendants: true }], exportAs: ["cnetPageSidenav"], ngImport: i0, template: "<div class=\"cnet-page-sidenav-inner-container\" cdkScrollable #content>\n  <ng-content></ng-content>\n</div>\n", styles: [".cnet-sidenav-item.cnet-sidenav-item-disabled,.cnet-sidenav-item.cnet-sidenav-item-disabled:hover{background:var(--cnet--200, #eeeeee);color:var(--cnet--500, #9e9e9e)}.cnet-sidenav-item.cnet-sidenav-item-activated{color:currentColor}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-success{background-color:var(--cnet-success-500, #47ba65)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-cancel{background-color:var(--cnet-cancel-500, #9e9e9e)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-primary{background-color:var(--cnet-primary-500, #82c14f)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-secondary{background-color:var(--cnet-secondary-500, #3d4155)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-danger{background-color:var(--cnet-danger-500, #ee4446)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-success{color:var(--cnet-success-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-cancel{color:var(--cnet-cancel-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-primary{color:var(--cnet-primary-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-secondary{color:var(--cnet-secondary-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-danger{color:var(--cnet-danger-contrast-500, white)}.mat-drawer-content{position:relative;z-index:1;display:block;height:100%;overflow:auto}.mat-drawer-transition .mat-drawer-content{transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:transform,margin-left,margin-right}.cnet-page-side-nav-container{position:relative;z-index:1;box-sizing:border-box;-webkit-overflow-scrolling:touch;display:block;overflow:hidden;height:100%}.cnet-page-side-nav-container.mat-drawer-container-explicit-backdrop .mat-drawer-side{z-index:3}.cnet-page-side-nav-container.ng-animate-disabled .mat-drawer-backdrop,.cnet-page-side-nav-container.ng-animate-disabled .mat-drawer-content,.ng-animate-disabled .cnet-page-side-nav-container .mat-drawer-backdrop,.ng-animate-disabled .cnet-page-side-nav-container .mat-drawer-content{transition:none}.cnet-page-sidenav-inner-container{width:100%;height:100%;overflow:auto;-webkit-overflow-scrolling:touch}.cnet-drawer{position:relative;z-index:4;display:block;position:absolute;top:0;bottom:0;z-index:3;outline:0;box-sizing:border-box;overflow-y:auto;transform:translate3d(-100%,0,0)}.cnet-drawer.cnet-page-sidenav-end{border-left:1px solid #eeeeee;border-right:none}.cnet-drawer:not(.cnet-page-sidenav-end){border-right:1px solid #eeeeee}.cnet-drawer.cnet-page-sidenav-end{right:0;transform:translate3d(100%,0,0)}\n"], animations: [matDrawerAnimations.transformDrawer], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageSidenavComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-page-sidenav, [cnet-page-sidenav], [cnetPageSidenav]', exportAs: 'cnetPageSidenav', animations: [matDrawerAnimations.transformDrawer], host: {
                        'class': 'cnet-drawer cnet-page-sidenav',
                        'tabIndex': '-1',
                        // must prevent the browser from aligning text based on value
                        '[attr.align]': 'null',
                        '[class.cnet-page-sidenav-end]': 'position === "end"',
                        '[class.cnet-page-sidenav-over]': 'mode === "over"',
                        '[class.cnet-page-sidenav-push]': 'mode === "push"',
                        '[class.cnet-page-sidenav-side]': 'mode === "side"',
                        '[class.cnet-page-sidenav-opened]': 'opened',
                        '[@transform]': '_animationState',
                        '(@transform.start)': '_animationStarted.next($event)',
                        '(@transform.done)': '_animationEnd.next($event)',
                        // '[class.mat-sidenav-fixed]': 'fixedInViewport',
                        // '[style.top.px]': 'fixedInViewport ? fixedTopGap : null',
                        // '[style.bottom.px]': 'fixedInViewport ? fixedBottomGap : null',
                        // 'ngSkipHydration': '',
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<div class=\"cnet-page-sidenav-inner-container\" cdkScrollable #content>\n  <ng-content></ng-content>\n</div>\n", styles: [".cnet-sidenav-item.cnet-sidenav-item-disabled,.cnet-sidenav-item.cnet-sidenav-item-disabled:hover{background:var(--cnet--200, #eeeeee);color:var(--cnet--500, #9e9e9e)}.cnet-sidenav-item.cnet-sidenav-item-activated{color:currentColor}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-success{background-color:var(--cnet-success-500, #47ba65)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-cancel{background-color:var(--cnet-cancel-500, #9e9e9e)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-primary{background-color:var(--cnet-primary-500, #82c14f)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-secondary{background-color:var(--cnet-secondary-500, #3d4155)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-danger{background-color:var(--cnet-danger-500, #ee4446)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-success{color:var(--cnet-success-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-cancel{color:var(--cnet-cancel-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-primary{color:var(--cnet-primary-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-secondary{color:var(--cnet-secondary-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-danger{color:var(--cnet-danger-contrast-500, white)}.mat-drawer-content{position:relative;z-index:1;display:block;height:100%;overflow:auto}.mat-drawer-transition .mat-drawer-content{transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:transform,margin-left,margin-right}.cnet-page-side-nav-container{position:relative;z-index:1;box-sizing:border-box;-webkit-overflow-scrolling:touch;display:block;overflow:hidden;height:100%}.cnet-page-side-nav-container.mat-drawer-container-explicit-backdrop .mat-drawer-side{z-index:3}.cnet-page-side-nav-container.ng-animate-disabled .mat-drawer-backdrop,.cnet-page-side-nav-container.ng-animate-disabled .mat-drawer-content,.ng-animate-disabled .cnet-page-side-nav-container .mat-drawer-backdrop,.ng-animate-disabled .cnet-page-side-nav-container .mat-drawer-content{transition:none}.cnet-page-sidenav-inner-container{width:100%;height:100%;overflow:auto;-webkit-overflow-scrolling:touch}.cnet-drawer{position:relative;z-index:4;display:block;position:absolute;top:0;bottom:0;z-index:3;outline:0;box-sizing:border-box;overflow-y:auto;transform:translate3d(-100%,0,0)}.cnet-drawer.cnet-page-sidenav-end{border-left:1px solid #eeeeee;border-right:none}.cnet-drawer:not(.cnet-page-sidenav-end){border-right:1px solid #eeeeee}.cnet-drawer.cnet-page-sidenav-end{right:0;transform:translate3d(100%,0,0)}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: PageSideNavContainerComponent, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [MAT_DRAWER_CONTAINER]
                }] }], propDecorators: { position: [{
                type: Input
            }], mode: [{
                type: Input
            }], opened: [{
                type: Input
            }], _items: [{
                type: ContentChildren,
                args: [forwardRef(() => CnetSidenavItemDirective), { descendants: true }]
            }], openedChange: [{
                type: Output
            }] } });

const MAT_DRAWER_CONTAINER = new InjectionToken('MAT_DRAWER_CONTAINER');
class PageSideNavContainerComponent {
    // private _left: PageSidenavComponent | null;
    // private _right: PageSidenavComponent | null;
    constructor(_ngZone, _element, _changeDetectorRef, viewportRuler, _animationMode) {
        this._ngZone = _ngZone;
        this._element = _element;
        this._changeDetectorRef = _changeDetectorRef;
        this._animationMode = _animationMode;
        this._drawers = new QueryList();
        this._contentMargins = { left: null, right: null };
        this._contentMarginChanges = new Subject();
        this._destroyed = new Subject();
        this._doCheckSubject = new Subject();
        viewportRuler
            .change()
            .pipe(takeUntil(this._destroyed))
            .subscribe(() => this.updateContentMargins());
    }
    ngAfterContentInit() {
        this._allSidenavs.changes
            .pipe(startWith(this._allSidenavs), takeUntil(this._destroyed))
            .subscribe((drawer) => {
            this._drawers.reset(drawer.filter(item => !item._container || item._container === this));
            this._drawers.notifyOnChanges();
        });
        this._drawers.changes.pipe(startWith(null), debounceTime(20)).subscribe(() => {
            this._start = this._end = null;
            this._allSidenavs.forEach(drawer => {
                this._watchDrawerToggle(drawer);
                if (drawer.position == 'end') {
                    this._end = drawer;
                }
                else {
                    this._start = drawer;
                }
            });
            this._drawers.forEach((drawer) => {
                this._watchDrawerToggle(drawer);
                // this._watchDrawerPosition(drawer);
                // this._watchDrawerMode(drawer);
            });
            this.updateContentMargins();
            this._changeDetectorRef.markForCheck();
        });
        // this._allSidenavs.changes.pipe(startWith(null)).subscribe(() => {
        //   this._start = this._end = null;
        //   this._allSidenavs.forEach(drawer => {
        //     this._watchDrawerToggle(drawer);
        //     if (drawer.position == 'end') {
        //       this._end = drawer;
        //     } else {
        //       this._start = drawer;
        //     }
        //   });
        //   this.updateContentMargins();
        // })
        this._ngZone.runOutsideAngular(() => {
            this._doCheckSubject
                .pipe(debounceTime(10), // Arbitrary debounce time, less than a frame at 60fps
            takeUntil(this._destroyed))
                .subscribe(() => this.updateContentMargins());
        });
    }
    updateContentMargins() {
        // 1. For drawers in `over` mode, they don't affect the content.
        // 2. For drawers in `side` mode they should shrink the content. We do this by adding to the
        //    left margin (for left drawer) or right margin (for right the drawer).
        // 3. For drawers in `push` mode the should shift the content without resizing it. We do this by
        //    adding to the left or right margin and simultaneously subtracting the same amount of
        //    margin from the other side.
        let left = 0;
        let right = 0;
        if (this._start && this._start.opened) {
            if (this._start.mode == 'side') {
                left += this._start._getWidth();
            }
            else if (this._start.mode == 'push') {
                const width = this._start._getWidth();
                left += width;
                right -= width;
            }
        }
        if (this._end && this._end.opened) {
            if (this._end.mode == 'side') {
                right += this._end._getWidth();
            }
            else if (this._end.mode == 'push') {
                const width = this._end._getWidth();
                right += width;
                left -= width;
            }
        }
        // If either `right` or `left` is zero, don't set a style to the element. This
        // allows users to specify a custom size via CSS class in SSR scenarios where the
        // measured widths will always be zero. Note that we reset to `null` here, rather
        // than below, in order to ensure that the types in the `if` below are consistent.
        left = left || null;
        right = right || null;
        if (left !== this._contentMargins.left || right !== this._contentMargins.right) {
            this._contentMargins = { left, right };
            // Pull back into the NgZone since in some cases we could be outside. We need to be careful
            // to do it only when something changed, otherwise we can end up hitting the zone too often.
            this._ngZone.run(() => this._contentMarginChanges.next(this._contentMargins));
        }
    }
    ngOnDestroy() {
        this._contentMarginChanges.complete();
        // // this._doCheckSubject.complete();
        // // this._drawers.destroy();
        // this._allSidenavs.destroy();
        this._destroyed.next();
        this._destroyed.complete();
    }
    _watchDrawerToggle(drawer) {
        drawer._animationStarted
            .pipe(filter((event) => event.fromState !== event.toState), takeUntil(this._allSidenavs.changes))
            .subscribe((event) => {
            // Set the transition class on the container so that the animations occur. This should not
            // be set initially because animations should only be triggered via a change in state.
            if (event.toState !== 'open-instant' && this._animationMode !== 'NoopAnimations') {
                this._element.nativeElement.classList.add('mat-drawer-transition');
            }
            this.updateContentMargins();
            this._changeDetectorRef.markForCheck();
        });
        // if (drawer.mode !== 'side') {
        //   drawer.openedChange
        //     .pipe(takeUntil(this._allSidenavs.changes))
        //     .subscribe(() => this._setContainerClass(drawer.opened));
        // }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageSideNavContainerComponent, deps: [{ token: i0.NgZone }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }, { token: i1$9.ViewportRuler }, { token: ANIMATION_MODULE_TYPE$1, optional: true }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PageSideNavContainerComponent, selector: "cnet-page-side-nav-container", host: { classAttribute: "cnet-page-side-nav-container" }, providers: [
            {
                provide: MAT_DRAWER_CONTAINER,
                useExisting: PageSideNavContainerComponent,
            },
        ], queries: [{ propertyName: "_allSidenavs", predicate: PageSidenavComponent, descendants: true }], exportAs: ["pageSideNavContainerComponent"], ngImport: i0, template: "<!-- <div class=\"mat-drawer-backdrop\" (click)=\"_onBackdropClicked()\" *ngIf=\"hasBackdrop\"\n     [class.mat-drawer-shown]=\"_isShowingBackdrop()\"></div>\n\n<ng-content select=\"mat-sidenav\"></ng-content>\n\n<ng-content select=\"mat-sidenav-content\">\n</ng-content>\n<mat-sidenav-content *ngIf=\"!_content\">\n  <ng-content></ng-content>\n</mat-sidenav-content> -->\n<ng-content select=\"cnet-page-sidenav, [cnet-page-sidenav], [cnetPageSidenav]\"></ng-content>\n\n<ng-content select=\"cnet-page-sidenav-content, [cnet-page-sidenav-content], [cnetPageSidenavContent]\"></ng-content>\n\n<!-- <cnet-page-sidenav-content *ngIf=\"!_content\">\n  <ng-content></ng-content>\n</cnet-page-sidenav-content> -->\n", styles: [".cnet-sidenav-item.cnet-sidenav-item-disabled,.cnet-sidenav-item.cnet-sidenav-item-disabled:hover{background:var(--cnet--200, #eeeeee);color:var(--cnet--500, #9e9e9e)}.cnet-sidenav-item.cnet-sidenav-item-activated{color:currentColor}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-success{background-color:var(--cnet-success-500, #47ba65)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-cancel{background-color:var(--cnet-cancel-500, #9e9e9e)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-primary{background-color:var(--cnet-primary-500, #82c14f)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-secondary{background-color:var(--cnet-secondary-500, #3d4155)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-danger{background-color:var(--cnet-danger-500, #ee4446)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-success{color:var(--cnet-success-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-cancel{color:var(--cnet-cancel-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-primary{color:var(--cnet-primary-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-secondary{color:var(--cnet-secondary-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-danger{color:var(--cnet-danger-contrast-500, white)}.mat-drawer-content{position:relative;z-index:1;display:block;height:100%;overflow:auto}.mat-drawer-transition .mat-drawer-content{transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:transform,margin-left,margin-right}.cnet-page-side-nav-container{position:relative;z-index:1;box-sizing:border-box;-webkit-overflow-scrolling:touch;display:block;overflow:hidden;height:100%}.cnet-page-side-nav-container.mat-drawer-container-explicit-backdrop .mat-drawer-side{z-index:3}.cnet-page-side-nav-container.ng-animate-disabled .mat-drawer-backdrop,.cnet-page-side-nav-container.ng-animate-disabled .mat-drawer-content,.ng-animate-disabled .cnet-page-side-nav-container .mat-drawer-backdrop,.ng-animate-disabled .cnet-page-side-nav-container .mat-drawer-content{transition:none}.cnet-page-sidenav-inner-container{width:100%;height:100%;overflow:auto;-webkit-overflow-scrolling:touch}.cnet-drawer{position:relative;z-index:4;display:block;position:absolute;top:0;bottom:0;z-index:3;outline:0;box-sizing:border-box;overflow-y:auto;transform:translate3d(-100%,0,0)}.cnet-drawer.cnet-page-sidenav-end{border-left:1px solid #eeeeee;border-right:none}.cnet-drawer:not(.cnet-page-sidenav-end){border-right:1px solid #eeeeee}.cnet-drawer.cnet-page-sidenav-end{right:0;transform:translate3d(100%,0,0)}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageSideNavContainerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-page-side-nav-container', exportAs: 'pageSideNavContainerComponent', host: {
                        // 'class': 'mat-drawer-container mat-sidenav-container',
                        // '[class.mat-drawer-container-explicit-backdrop]': '_backdropOverride',
                        // 'ngSkipHydration': '',
                        'class': 'cnet-page-side-nav-container',
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, providers: [
                        {
                            provide: MAT_DRAWER_CONTAINER,
                            useExisting: PageSideNavContainerComponent,
                        },
                    ], template: "<!-- <div class=\"mat-drawer-backdrop\" (click)=\"_onBackdropClicked()\" *ngIf=\"hasBackdrop\"\n     [class.mat-drawer-shown]=\"_isShowingBackdrop()\"></div>\n\n<ng-content select=\"mat-sidenav\"></ng-content>\n\n<ng-content select=\"mat-sidenav-content\">\n</ng-content>\n<mat-sidenav-content *ngIf=\"!_content\">\n  <ng-content></ng-content>\n</mat-sidenav-content> -->\n<ng-content select=\"cnet-page-sidenav, [cnet-page-sidenav], [cnetPageSidenav]\"></ng-content>\n\n<ng-content select=\"cnet-page-sidenav-content, [cnet-page-sidenav-content], [cnetPageSidenavContent]\"></ng-content>\n\n<!-- <cnet-page-sidenav-content *ngIf=\"!_content\">\n  <ng-content></ng-content>\n</cnet-page-sidenav-content> -->\n", styles: [".cnet-sidenav-item.cnet-sidenav-item-disabled,.cnet-sidenav-item.cnet-sidenav-item-disabled:hover{background:var(--cnet--200, #eeeeee);color:var(--cnet--500, #9e9e9e)}.cnet-sidenav-item.cnet-sidenav-item-activated{color:currentColor}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-success{background-color:var(--cnet-success-500, #47ba65)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-cancel{background-color:var(--cnet-cancel-500, #9e9e9e)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-primary{background-color:var(--cnet-primary-500, #82c14f)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-secondary{background-color:var(--cnet-secondary-500, #3d4155)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-danger{background-color:var(--cnet-danger-500, #ee4446)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-success{color:var(--cnet-success-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-cancel{color:var(--cnet-cancel-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-primary{color:var(--cnet-primary-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-secondary{color:var(--cnet-secondary-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-danger{color:var(--cnet-danger-contrast-500, white)}.mat-drawer-content{position:relative;z-index:1;display:block;height:100%;overflow:auto}.mat-drawer-transition .mat-drawer-content{transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:transform,margin-left,margin-right}.cnet-page-side-nav-container{position:relative;z-index:1;box-sizing:border-box;-webkit-overflow-scrolling:touch;display:block;overflow:hidden;height:100%}.cnet-page-side-nav-container.mat-drawer-container-explicit-backdrop .mat-drawer-side{z-index:3}.cnet-page-side-nav-container.ng-animate-disabled .mat-drawer-backdrop,.cnet-page-side-nav-container.ng-animate-disabled .mat-drawer-content,.ng-animate-disabled .cnet-page-side-nav-container .mat-drawer-backdrop,.ng-animate-disabled .cnet-page-side-nav-container .mat-drawer-content{transition:none}.cnet-page-sidenav-inner-container{width:100%;height:100%;overflow:auto;-webkit-overflow-scrolling:touch}.cnet-drawer{position:relative;z-index:4;display:block;position:absolute;top:0;bottom:0;z-index:3;outline:0;box-sizing:border-box;overflow-y:auto;transform:translate3d(-100%,0,0)}.cnet-drawer.cnet-page-sidenav-end{border-left:1px solid #eeeeee;border-right:none}.cnet-drawer:not(.cnet-page-sidenav-end){border-right:1px solid #eeeeee}.cnet-drawer.cnet-page-sidenav-end{right:0;transform:translate3d(100%,0,0)}\n"] }]
        }], ctorParameters: () => [{ type: i0.NgZone }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }, { type: i1$9.ViewportRuler }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [ANIMATION_MODULE_TYPE$1]
                }] }], propDecorators: { _allSidenavs: [{
                type: ContentChildren,
                args: [PageSidenavComponent, { descendants: true, }]
            }] } });

class PageSidenavContentComponent {
    constructor(_container, _changeDetectorRef) {
        this._container = _container;
        this._changeDetectorRef = _changeDetectorRef;
    }
    ngOnInit() {
    }
    ngAfterContentInit() {
        this._container._contentMarginChanges.subscribe(() => {
            this._changeDetectorRef.markForCheck();
        });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageSidenavContentComponent, deps: [{ token: forwardRef(() => PageSideNavContainerComponent) }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: PageSidenavContentComponent, selector: "cnet-page-sidenav-content, [cnet-page-sidenav-content], [cnetPageSidenavContent]", host: { properties: { "style.margin-left.px": "_container._contentMargins.left", "style.margin-right.px": "_container._contentMargins.right" }, classAttribute: "mat-drawer-content cnet-page-sidenav-content" }, ngImport: i0, template: "<ng-content></ng-content>\n", styles: [".cnet-sidenav-item.cnet-sidenav-item-disabled,.cnet-sidenav-item.cnet-sidenav-item-disabled:hover{background:var(--cnet--200, #eeeeee);color:var(--cnet--500, #9e9e9e)}.cnet-sidenav-item.cnet-sidenav-item-activated{color:currentColor}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-success{background-color:var(--cnet-success-500, #47ba65)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-cancel{background-color:var(--cnet-cancel-500, #9e9e9e)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-primary{background-color:var(--cnet-primary-500, #82c14f)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-secondary{background-color:var(--cnet-secondary-500, #3d4155)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-danger{background-color:var(--cnet-danger-500, #ee4446)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-success{color:var(--cnet-success-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-cancel{color:var(--cnet-cancel-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-primary{color:var(--cnet-primary-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-secondary{color:var(--cnet-secondary-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-danger{color:var(--cnet-danger-contrast-500, white)}.mat-drawer-content{position:relative;z-index:1;display:block;height:100%;overflow:auto}.mat-drawer-transition .mat-drawer-content{transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:transform,margin-left,margin-right}.cnet-page-side-nav-container{position:relative;z-index:1;box-sizing:border-box;-webkit-overflow-scrolling:touch;display:block;overflow:hidden;height:100%}.cnet-page-side-nav-container.mat-drawer-container-explicit-backdrop .mat-drawer-side{z-index:3}.cnet-page-side-nav-container.ng-animate-disabled .mat-drawer-backdrop,.cnet-page-side-nav-container.ng-animate-disabled .mat-drawer-content,.ng-animate-disabled .cnet-page-side-nav-container .mat-drawer-backdrop,.ng-animate-disabled .cnet-page-side-nav-container .mat-drawer-content{transition:none}.cnet-page-sidenav-inner-container{width:100%;height:100%;overflow:auto;-webkit-overflow-scrolling:touch}.cnet-drawer{position:relative;z-index:4;display:block;position:absolute;top:0;bottom:0;z-index:3;outline:0;box-sizing:border-box;overflow-y:auto;transform:translate3d(-100%,0,0)}.cnet-drawer.cnet-page-sidenav-end{border-left:1px solid #eeeeee;border-right:none}.cnet-drawer:not(.cnet-page-sidenav-end){border-right:1px solid #eeeeee}.cnet-drawer.cnet-page-sidenav-end{right:0;transform:translate3d(100%,0,0)}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageSidenavContentComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-page-sidenav-content, [cnet-page-sidenav-content], [cnetPageSidenavContent]', host: {
                        'class': 'mat-drawer-content cnet-page-sidenav-content',
                        '[style.margin-left.px]': '_container._contentMargins.left',
                        '[style.margin-right.px]': '_container._contentMargins.right',
                        // 'ngSkipHydration': '',
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<ng-content></ng-content>\n", styles: [".cnet-sidenav-item.cnet-sidenav-item-disabled,.cnet-sidenav-item.cnet-sidenav-item-disabled:hover{background:var(--cnet--200, #eeeeee);color:var(--cnet--500, #9e9e9e)}.cnet-sidenav-item.cnet-sidenav-item-activated{color:currentColor}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-success{background-color:var(--cnet-success-500, #47ba65)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-cancel{background-color:var(--cnet-cancel-500, #9e9e9e)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-primary{background-color:var(--cnet-primary-500, #82c14f)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-secondary{background-color:var(--cnet-secondary-500, #3d4155)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-danger{background-color:var(--cnet-danger-500, #ee4446)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-success{color:var(--cnet-success-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-cancel{color:var(--cnet-cancel-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-primary{color:var(--cnet-primary-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-secondary{color:var(--cnet-secondary-contrast-500, white)}.cnet-sidenav-item.cnet-sidenav-item-activated.cnet-color-danger{color:var(--cnet-danger-contrast-500, white)}.mat-drawer-content{position:relative;z-index:1;display:block;height:100%;overflow:auto}.mat-drawer-transition .mat-drawer-content{transition-duration:.4s;transition-timing-function:cubic-bezier(.25,.8,.25,1);transition-property:transform,margin-left,margin-right}.cnet-page-side-nav-container{position:relative;z-index:1;box-sizing:border-box;-webkit-overflow-scrolling:touch;display:block;overflow:hidden;height:100%}.cnet-page-side-nav-container.mat-drawer-container-explicit-backdrop .mat-drawer-side{z-index:3}.cnet-page-side-nav-container.ng-animate-disabled .mat-drawer-backdrop,.cnet-page-side-nav-container.ng-animate-disabled .mat-drawer-content,.ng-animate-disabled .cnet-page-side-nav-container .mat-drawer-backdrop,.ng-animate-disabled .cnet-page-side-nav-container .mat-drawer-content{transition:none}.cnet-page-sidenav-inner-container{width:100%;height:100%;overflow:auto;-webkit-overflow-scrolling:touch}.cnet-drawer{position:relative;z-index:4;display:block;position:absolute;top:0;bottom:0;z-index:3;outline:0;box-sizing:border-box;overflow-y:auto;transform:translate3d(-100%,0,0)}.cnet-drawer.cnet-page-sidenav-end{border-left:1px solid #eeeeee;border-right:none}.cnet-drawer:not(.cnet-page-sidenav-end){border-right:1px solid #eeeeee}.cnet-drawer.cnet-page-sidenav-end{right:0;transform:translate3d(100%,0,0)}\n"] }]
        }], ctorParameters: () => [{ type: PageSideNavContainerComponent, decorators: [{
                    type: Inject,
                    args: [forwardRef(() => PageSideNavContainerComponent)]
                }] }, { type: i0.ChangeDetectorRef }] });

class PageSideNavContainerModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageSideNavContainerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: PageSideNavContainerModule, declarations: [PageSideNavContainerComponent,
            PageSidenavComponent,
            PageSidenavContentComponent,
            CnetSidenavItemDirective], imports: [CommonModule], exports: [PageSideNavContainerComponent,
            PageSidenavComponent,
            PageSidenavContentComponent,
            CnetSidenavItemDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageSideNavContainerModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PageSideNavContainerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        PageSideNavContainerComponent,
                        PageSidenavComponent,
                        PageSidenavContentComponent,
                        CnetSidenavItemDirective,
                    ],
                    exports: [
                        PageSideNavContainerComponent,
                        PageSidenavComponent,
                        PageSidenavContentComponent,
                        CnetSidenavItemDirective,
                    ],
                    imports: [
                        CommonModule
                    ]
                }]
        }] });

/** Cnet Pagination is a component that displays a list of page numbers */
class CnetPaginationComponent {
    /** Number of offset items */
    get offset() { return this._offset; }
    set offset(value) { this._offset = coerceNumberProperty(value); }
    /** Max items per page */
    get limit() { return this._limit; }
    set limit(value) { this._limit = coerceNumberProperty(value); }
    /** Total number of items */
    get size() { return this._size; }
    set size(value) { this._size = coerceNumberProperty(value); }
    /** Visible pages range */
    get range() { return this._range; }
    set range(value) { this._range = coerceNumberProperty(value); }
    constructor(breakpointObserver, cdr) {
        this.breakpointObserver = breakpointObserver;
        this.cdr = cdr;
        /** @ignore */ this._offset = 0;
        /** @ignore */ this._limit = 5;
        /** @ignore */ this._size = 2;
        /** @ignore */ this._range = 2;
        /** @ignore */ this.breakpointXS = false;
        /** Emits the number of offset items when changing pages */
        this.pageChange = new EventEmitter();
    }
    /** @ignore */
    ngOnInit() {
        this.genPages(this.offset, this.limit, this.size);
        this.breakpointObserver
            .observe([Breakpoints.XSmall])
            .subscribe((state) => {
            this.breakpointXS = state.matches ? true : false;
            this.genPages(this.offset, this.limit, this.size);
            this.cdr.detectChanges();
        });
    }
    /** @ignore */
    ngOnChanges() {
        this.genPages(this.offset, this.limit, this.size);
    }
    /** @ignore */
    genPages(offset, limit, size) {
        this.currentPage = this.getCurrentPage(offset, limit);
        this.totalPages = this.getTotalPages(limit, size);
        const nRange = this.breakpointXS ? 1 : this.range;
        this.pages = range(-nRange, nRange * 2 + 1)
            .pipe(map(nOffset => this.currentPage + nOffset))
            .pipe(filter(page => this.isValidPageNumber(page, this.totalPages)))
            .pipe(toArray());
    }
    /** @ignore */
    isValidPageNumber(page, totalPages) {
        return page > 0 && page <= totalPages;
    }
    /** @ignore */
    getCurrentPage(offset, limit) {
        return Math.floor(offset / limit) + 1;
    }
    /** @ignore */
    getTotalPages(limit, size) {
        return Math.ceil(Math.max(size, 1) / Math.max(limit, 1));
    }
    selectPage(page) {
        if (this.isValidPageNumber(page, this.totalPages)) {
            this.pageChange.emit((page - 1) * this.limit);
        }
    }
    /** @ignore */
    cancelEvent(event) {
        event.preventDefault();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetPaginationComponent, deps: [{ token: i1$a.BreakpointObserver }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetPaginationComponent, selector: "cnet-pagination, [cnet-pagination], cnetPagination", inputs: { offset: "offset", limit: "limit", size: "size", range: "range" }, outputs: { pageChange: "pageChange" }, host: { attributes: { "role": "navigation" }, classAttribute: "cnet-pagination" }, exportAs: ["cnetPagination"], usesOnChanges: true, ngImport: i0, template: "<ul class=\"cnet-pagination-list\">\n    <li (click)=\"cancelEvent($event); selectPage(1);\" [attr.aria-disabled]=\"currentPage == 1\" [class.cnet-pagination-disabled]=\"currentPage == 1\">\n        <a class=\"cnet-pagination-list-item\" href=\"\" [attr.aria-label]=\"'ir para a primeira p\u00E1gina' | translate\"><cnet-icon name=\"angle-double-left\" size=\"sm\" aria-hidden=\"true\"></cnet-icon></a>\n    </li>\n    <li class=\"disabled\" (click)=\"cancelEvent($event)\" *ngIf=\"(currentPage - (this.breakpointXS ? 1 : range)) > 1\" tabindex=\"-1\">\n        <div class=\"cnet-pagination-list-item cnet-pagination-overflow-indicator\">\n            <cnet-icon name=\"ellipsis-h\" size=\"sm\" aria-hidden=\"true\" ></cnet-icon>\n        </div>\n    </li>\n    <li *ngFor=\"let page of pages | async\" [class.cnet-pagination-active]=\"page == currentPage\">\n        <a class=\"cnet-pagination-list-item\" href=\"\" (click)=\"cancelEvent($event); selectPage(page);\" [attr.aria-label]=\"'ir para p\u00E1gina {0}' | translate: {'0': page}\">\n            {{page}}\n        </a>\n    </li>\n    <li class=\"disabled\" (click)=\"cancelEvent($event)\" *ngIf=\"(currentPage + range) < totalPages\" tabindex=\"-1\">\n        <div class=\"cnet-pagination-list-item cnet-pagination-overflow-indicator\">\n            <cnet-icon name=\"ellipsis-h\" size=\"sm\" aria-hidden=\"true\" ></cnet-icon>\n        </div>\n    </li>\n    <li (click)=\"cancelEvent($event); selectPage(totalPages);\" [attr.aria-disabled]=\"currentPage == totalPages\" [class.cnet-pagination-disabled]=\"currentPage == totalPages\">\n        <a class=\"cnet-pagination-list-item\" href=\"\" [attr.aria-label]=\"'ir para a \u00FAltima p\u00E1gina' | translate\"><cnet-icon name=\"angle-double-right\" size=\"sm\" aria-hidden=\"true\"></cnet-icon></a>\n    </li>\n</ul>\n", styles: [".cnet-pagination-list{display:flex;align-items:center;list-style-type:none;padding:0}.cnet-pagination-list li{margin:0 .25rem 0 0;outline:none}.cnet-pagination-list li:not(.cnet-pagination-disabled){cursor:pointer}.cnet-pagination-list .cnet-pagination-list-item{display:flex;align-items:center;justify-content:center;position:relative;min-width:38px;height:38px;padding:.5rem;border:1px solid #dbe3ea;border-radius:.25rem;text-align:center;background-color:var(--cnet-primary-contrast-500, white);color:var(--cnet-primary-500, #82c14f);text-decoration:none;-webkit-user-select:none;user-select:none}.cnet-pagination-list .cnet-pagination-overflow-indicator{cursor:initial}.cnet-pagination-list .cnet-pagination-active a{background-color:var(--cnet-primary-500, #82c14f);color:var(--cnet-primary-contrast-500, white)}.cnet-pagination-list .cnet-pagination-disabled{opacity:.5}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1$3.TranslatePipe, name: "translate" }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetPaginationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-pagination, [cnet-pagination], cnetPagination', exportAs: 'cnetPagination', host: {
                        class: 'cnet-pagination',
                        role: 'navigation',
                    }, encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<ul class=\"cnet-pagination-list\">\n    <li (click)=\"cancelEvent($event); selectPage(1);\" [attr.aria-disabled]=\"currentPage == 1\" [class.cnet-pagination-disabled]=\"currentPage == 1\">\n        <a class=\"cnet-pagination-list-item\" href=\"\" [attr.aria-label]=\"'ir para a primeira p\u00E1gina' | translate\"><cnet-icon name=\"angle-double-left\" size=\"sm\" aria-hidden=\"true\"></cnet-icon></a>\n    </li>\n    <li class=\"disabled\" (click)=\"cancelEvent($event)\" *ngIf=\"(currentPage - (this.breakpointXS ? 1 : range)) > 1\" tabindex=\"-1\">\n        <div class=\"cnet-pagination-list-item cnet-pagination-overflow-indicator\">\n            <cnet-icon name=\"ellipsis-h\" size=\"sm\" aria-hidden=\"true\" ></cnet-icon>\n        </div>\n    </li>\n    <li *ngFor=\"let page of pages | async\" [class.cnet-pagination-active]=\"page == currentPage\">\n        <a class=\"cnet-pagination-list-item\" href=\"\" (click)=\"cancelEvent($event); selectPage(page);\" [attr.aria-label]=\"'ir para p\u00E1gina {0}' | translate: {'0': page}\">\n            {{page}}\n        </a>\n    </li>\n    <li class=\"disabled\" (click)=\"cancelEvent($event)\" *ngIf=\"(currentPage + range) < totalPages\" tabindex=\"-1\">\n        <div class=\"cnet-pagination-list-item cnet-pagination-overflow-indicator\">\n            <cnet-icon name=\"ellipsis-h\" size=\"sm\" aria-hidden=\"true\" ></cnet-icon>\n        </div>\n    </li>\n    <li (click)=\"cancelEvent($event); selectPage(totalPages);\" [attr.aria-disabled]=\"currentPage == totalPages\" [class.cnet-pagination-disabled]=\"currentPage == totalPages\">\n        <a class=\"cnet-pagination-list-item\" href=\"\" [attr.aria-label]=\"'ir para a \u00FAltima p\u00E1gina' | translate\"><cnet-icon name=\"angle-double-right\" size=\"sm\" aria-hidden=\"true\"></cnet-icon></a>\n    </li>\n</ul>\n", styles: [".cnet-pagination-list{display:flex;align-items:center;list-style-type:none;padding:0}.cnet-pagination-list li{margin:0 .25rem 0 0;outline:none}.cnet-pagination-list li:not(.cnet-pagination-disabled){cursor:pointer}.cnet-pagination-list .cnet-pagination-list-item{display:flex;align-items:center;justify-content:center;position:relative;min-width:38px;height:38px;padding:.5rem;border:1px solid #dbe3ea;border-radius:.25rem;text-align:center;background-color:var(--cnet-primary-contrast-500, white);color:var(--cnet-primary-500, #82c14f);text-decoration:none;-webkit-user-select:none;user-select:none}.cnet-pagination-list .cnet-pagination-overflow-indicator{cursor:initial}.cnet-pagination-list .cnet-pagination-active a{background-color:var(--cnet-primary-500, #82c14f);color:var(--cnet-primary-contrast-500, white)}.cnet-pagination-list .cnet-pagination-disabled{opacity:.5}\n"] }]
        }], ctorParameters: () => [{ type: i1$a.BreakpointObserver }, { type: i0.ChangeDetectorRef }], propDecorators: { pageChange: [{
                type: Output
            }], offset: [{
                type: Input
            }], limit: [{
                type: Input
            }], size: [{
                type: Input
            }], range: [{
                type: Input
            }] } });

class CnetPaginationModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetPaginationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetPaginationModule, declarations: [CnetPaginationComponent], imports: [CommonModule,
            CnetIconModule,
            TranslateModule], exports: [CnetPaginationComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetPaginationModule, imports: [CommonModule,
            CnetIconModule,
            TranslateModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetPaginationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetPaginationComponent],
                    imports: [
                        CommonModule,
                        CnetIconModule,
                        TranslateModule
                    ],
                    exports: [CnetPaginationComponent],
                }]
        }] });

const panelToggleAnimation = trigger('toggle', [
    state('true', style({ height: '*', paddingBottom: '*', visibility: 'visible' })),
    state('false', style({ height: '{{height}}', paddingBottom: '0', visibility: '{{visibility}}' }), { params: { height: '0', visibility: 'hidden' } }),
    transition('false <=> true', animate('250ms ease-out'))
]);

/** Cnet Panel is a collapsible custom panel.
 *
 * @export
 * class CnetPanelComponent
*/
class CnetPanelComponent {
    get open() {
        return this._open;
    }
    ;
    set open(open) {
        this._open = open;
        if (open) {
            setTimeout(() => {
                this.trigger();
            }, 50);
        }
    }
    ;
    set previewHeight(height) {
        if (height) {
            this._previewHeight = `${height}`;
        }
        else {
            this._previewHeight = `0`;
        }
    }
    get previewHeight() {
        return this._previewHeight;
    }
    constructor(cdr) {
        this.cdr = cdr;
        /** Emits when the panel is clicked. */
        this.toggleEmitter = new EventEmitter();
        /** Whether the panel is expanded. */
        this.expanded = false;
        this._open = false;
        this.showMask = false;
        this._previewHeight = "0";
    }
    ngOnInit() {
    }
    /** @ignore */
    onToggle() {
        this.toggleEmitter.next(this);
    }
    /** @ignore */
    toggle() {
        this.expanded = !this.expanded;
    }
    /** @ignore */
    closePanel() {
        this.expanded = false;
        this.cdr.markForCheck();
    }
    /** @ignore */
    openPanel() {
        this.closePanel();
        this.toggle();
    }
    /** @ignore */
    onKeyUp(event) {
        if (event.keyCode === SPACE || event.keyCode === ENTER) {
            event.preventDefault();
            this.trigger();
        }
    }
    trigger() {
        this.toggle();
        this.onToggle();
        this.cdr.detectChanges();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetPanelComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetPanelComponent, selector: "cnet-panel, [cnet-panel], [cnetPanel]", inputs: { color: "color", open: "open", showMask: "showMask", previewHeight: "previewHeight" }, outputs: { toggleEmitter: "toggleEmitter" }, host: { properties: { "class.cnet-panel-expanded": "expanded", "class.cnet-panel-primary": "color == \"primary\"", "class.cnet-panel-secondary": "color == \"secondary\"", "class.cnet-panel-danger": "color == \"danger\"", "class.cnet-panel-cancel": "color == \"cancel\"", "class.cnet-panel-default": "color == null" }, classAttribute: "cnet-panel" }, viewQueries: [{ propertyName: "panelContent", first: true, predicate: ["panelContent"], descendants: true }], exportAs: ["cnetPanel"], ngImport: i0, template: "<div role=\"button\" tabindex=\"0\" cnetRipple cdkMonitorElementFocus [attr.aria-expanded]=\"expanded\" (click)=\"trigger()\"\n  (keydown)=\"onKeyUp($event)\">\n  <ng-content select=\"cnet-panel-header, [cnet-panel-header], [cnetPanelHeader]\"></ng-content>\n</div>\n\n<div role=\"region\" class=\"cnet-panel-content\"\n  [@toggle]=\"{value:expanded, params:{height:previewHeight, visibility: previewHeight !== '0' ?'visible':'hidden'}}\"\n  [class.cnet-panel-content-visible]=\"previewHeight !== '0' && !expanded\" [class.cnet-panel-mask]=\"showMask\"\n  [style.height]=\"previewHeight\">\n    <ng-content></ng-content>\n  <!-- </div> -->\n</div>\n<div role=\"button\" tabindex=\"0\" cnetRipple cdkMonitorElementFocus [attr.aria-expanded]=\"expanded\" (click)=\"trigger()\"\n  (keydown)=\"onKeyUp($event)\">\n  <ng-content select=\"cnet-panel-footer, [cnet-panel-footer], [cnetPanelFooter]\"></ng-content>\n</div>\n", styles: [".cnet-panel-mask:after{position:absolute;bottom:0;height:90%;width:100%;content:\"\";background:linear-gradient(to top,#fff 20%,#fff0 80%);pointer-events:none;transition:.25s ease-out}.cnet-panel-content-visible{visibility:visible!important}.cnet-panel{display:flex;flex-direction:column;overflow:hidden;margin:4px 0}.cnet-panel-header,.cnet-panel-footer{display:flex;align-items:center;justify-content:space-between;padding:.25rem 0;border-radius:.25rem;cursor:pointer;transition:background-color ease .2s}.cnet-panel-content{padding:1rem;color:#000000d9}.cnet-panel-indicator{display:inline-flex;transition:transform ease-in-out .3s}.cnet-panel-panel-expanded .cnet-panel-indicator{transform:rotate(180deg)}.cnet-panel-primary .cnet-panel-header{padding:.5rem .75rem;background-color:var(--cnet-primary-500, #82c14f);color:var(--cnet-primary-contrast-500, white)}.cnet-panel-primary .cnet-panel-header:hover{background-color:var(--cnet-primary-600, #7abb48)}.cnet-panel-primary .cnet-panel-footer{padding:.5rem .75rem;background-color:var(--cnet-primary-500, #82c14f);color:var(--cnet-primary-contrast-500, white)}.cnet-panel-primary .cnet-panel-footer:hover{background-color:var(--cnet-primary-600, #7abb48)}.cnet-panel-secondary{color:var(--cnet-secondary-contrast-500, white)}.cnet-panel-secondary .cnet-panel-header{padding:.5rem .75rem;background-color:var(--cnet-secondary-500, #3d4155)}.cnet-panel-secondary .cnet-panel-header:hover{background-color:var(--cnet-secondary-600, #373b4e)}.cnet-panel-secondary .cnet-panel-footer{padding:.5rem .75rem;background-color:var(--cnet-secondary-500, #3d4155)}.cnet-panel-secondary .cnet-panel-footer:hover{background-color:var(--cnet-secondary-600, #373b4e)}.cnet-panel-danger .cnet-panel-header{padding:.5rem .75rem;background-color:var(--cnet-danger-500, #ee4446);color:var(--cnet-danger-contrast-500, white)}.cnet-panel-danger .cnet-panel-header:hover{background-color:var(--cnet-danger-600, #ec3e3f)}.cnet-panel-danger .cnet-panel-footer{padding:.5rem .75rem;background-color:var(--cnet-danger-500, #ee4446);color:var(--cnet-danger-contrast-500, white)}.cnet-panel-danger .cnet-panel-footer:hover{background-color:var(--cnet-danger-600, #ec3e3f)}.cnet-panel-cancel .cnet-panel-header{padding:.5rem .75rem;background-color:var(--cnet-cancel-500, #9e9e9e);color:var(--cnet-cancel-contrast-500, white)}.cnet-panel-cancel .cnet-panel-header:hover{background-color:var(--cnet-cancel-200, #eeeeee)}.cnet-panel-cancel .cnet-panel-footer{padding:.5rem .75rem;background-color:var(--cnet-cancel-50, #fafafa);color:var(--cnet-cancel-contrast-50, rgba(0, 0, 0, .85))}.cnet-panel-cancel .cnet-panel-footer:hover{background-color:var(--cnet-cancel-200, #eeeeee)}.cnet-panel-default .cnet-panel-header{padding:.5rem .75rem;background-color:var(--cnet-default-200, #eeeeee);color:var(--cnet-default-contrast-200, rgba(0, 0, 0, .85))}.cnet-panel-default .cnet-panel-header:hover{background-color:var(--cnet-default-300, #e0e0e0)}.cnet-panel-default .cnet-panel-footer{padding:.5rem .75rem;background-color:var(--cnet-default-200, #eeeeee);color:var(--cnet-default-contrast-200, rgba(0, 0, 0, .85))}.cnet-panel-default .cnet-panel-footer:hover{background-color:var(--cnet-default-300, #e0e0e0)}\n"], dependencies: [{ kind: "directive", type: CnetRippleDirective, selector: "[cnet-ripple], [cnetRipple]", inputs: ["cnetRippleColor", "cnetRippleUnbounded", "cnetRippleCentered", "cnetRippleRadius", "cnetRippleAnimation", "cnetRippleDisabled", "cnetRippleTrigger"], exportAs: ["cnetRipple"] }, { kind: "directive", type: i1$2.CdkMonitorFocus, selector: "[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]", outputs: ["cdkFocusChange"], exportAs: ["cdkMonitorFocus"] }], animations: [panelToggleAnimation], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-panel, [cnet-panel], [cnetPanel]', exportAs: 'cnetPanel', host: {
                        class: 'cnet-panel',
                        '[class.cnet-panel-expanded]': 'expanded',
                        '[class.cnet-panel-primary]': 'color == "primary"',
                        '[class.cnet-panel-secondary]': 'color == "secondary"',
                        '[class.cnet-panel-danger]': 'color == "danger"',
                        '[class.cnet-panel-cancel]': 'color == "cancel"',
                        '[class.cnet-panel-default]': 'color == null'
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, animations: [panelToggleAnimation], template: "<div role=\"button\" tabindex=\"0\" cnetRipple cdkMonitorElementFocus [attr.aria-expanded]=\"expanded\" (click)=\"trigger()\"\n  (keydown)=\"onKeyUp($event)\">\n  <ng-content select=\"cnet-panel-header, [cnet-panel-header], [cnetPanelHeader]\"></ng-content>\n</div>\n\n<div role=\"region\" class=\"cnet-panel-content\"\n  [@toggle]=\"{value:expanded, params:{height:previewHeight, visibility: previewHeight !== '0' ?'visible':'hidden'}}\"\n  [class.cnet-panel-content-visible]=\"previewHeight !== '0' && !expanded\" [class.cnet-panel-mask]=\"showMask\"\n  [style.height]=\"previewHeight\">\n    <ng-content></ng-content>\n  <!-- </div> -->\n</div>\n<div role=\"button\" tabindex=\"0\" cnetRipple cdkMonitorElementFocus [attr.aria-expanded]=\"expanded\" (click)=\"trigger()\"\n  (keydown)=\"onKeyUp($event)\">\n  <ng-content select=\"cnet-panel-footer, [cnet-panel-footer], [cnetPanelFooter]\"></ng-content>\n</div>\n", styles: [".cnet-panel-mask:after{position:absolute;bottom:0;height:90%;width:100%;content:\"\";background:linear-gradient(to top,#fff 20%,#fff0 80%);pointer-events:none;transition:.25s ease-out}.cnet-panel-content-visible{visibility:visible!important}.cnet-panel{display:flex;flex-direction:column;overflow:hidden;margin:4px 0}.cnet-panel-header,.cnet-panel-footer{display:flex;align-items:center;justify-content:space-between;padding:.25rem 0;border-radius:.25rem;cursor:pointer;transition:background-color ease .2s}.cnet-panel-content{padding:1rem;color:#000000d9}.cnet-panel-indicator{display:inline-flex;transition:transform ease-in-out .3s}.cnet-panel-panel-expanded .cnet-panel-indicator{transform:rotate(180deg)}.cnet-panel-primary .cnet-panel-header{padding:.5rem .75rem;background-color:var(--cnet-primary-500, #82c14f);color:var(--cnet-primary-contrast-500, white)}.cnet-panel-primary .cnet-panel-header:hover{background-color:var(--cnet-primary-600, #7abb48)}.cnet-panel-primary .cnet-panel-footer{padding:.5rem .75rem;background-color:var(--cnet-primary-500, #82c14f);color:var(--cnet-primary-contrast-500, white)}.cnet-panel-primary .cnet-panel-footer:hover{background-color:var(--cnet-primary-600, #7abb48)}.cnet-panel-secondary{color:var(--cnet-secondary-contrast-500, white)}.cnet-panel-secondary .cnet-panel-header{padding:.5rem .75rem;background-color:var(--cnet-secondary-500, #3d4155)}.cnet-panel-secondary .cnet-panel-header:hover{background-color:var(--cnet-secondary-600, #373b4e)}.cnet-panel-secondary .cnet-panel-footer{padding:.5rem .75rem;background-color:var(--cnet-secondary-500, #3d4155)}.cnet-panel-secondary .cnet-panel-footer:hover{background-color:var(--cnet-secondary-600, #373b4e)}.cnet-panel-danger .cnet-panel-header{padding:.5rem .75rem;background-color:var(--cnet-danger-500, #ee4446);color:var(--cnet-danger-contrast-500, white)}.cnet-panel-danger .cnet-panel-header:hover{background-color:var(--cnet-danger-600, #ec3e3f)}.cnet-panel-danger .cnet-panel-footer{padding:.5rem .75rem;background-color:var(--cnet-danger-500, #ee4446);color:var(--cnet-danger-contrast-500, white)}.cnet-panel-danger .cnet-panel-footer:hover{background-color:var(--cnet-danger-600, #ec3e3f)}.cnet-panel-cancel .cnet-panel-header{padding:.5rem .75rem;background-color:var(--cnet-cancel-500, #9e9e9e);color:var(--cnet-cancel-contrast-500, white)}.cnet-panel-cancel .cnet-panel-header:hover{background-color:var(--cnet-cancel-200, #eeeeee)}.cnet-panel-cancel .cnet-panel-footer{padding:.5rem .75rem;background-color:var(--cnet-cancel-50, #fafafa);color:var(--cnet-cancel-contrast-50, rgba(0, 0, 0, .85))}.cnet-panel-cancel .cnet-panel-footer:hover{background-color:var(--cnet-cancel-200, #eeeeee)}.cnet-panel-default .cnet-panel-header{padding:.5rem .75rem;background-color:var(--cnet-default-200, #eeeeee);color:var(--cnet-default-contrast-200, rgba(0, 0, 0, .85))}.cnet-panel-default .cnet-panel-header:hover{background-color:var(--cnet-default-300, #e0e0e0)}.cnet-panel-default .cnet-panel-footer{padding:.5rem .75rem;background-color:var(--cnet-default-200, #eeeeee);color:var(--cnet-default-contrast-200, rgba(0, 0, 0, .85))}.cnet-panel-default .cnet-panel-footer:hover{background-color:var(--cnet-default-300, #e0e0e0)}\n"] }]
        }], ctorParameters: () => [{ type: i0.ChangeDetectorRef }], propDecorators: { color: [{
                type: Input
            }], toggleEmitter: [{
                type: Output
            }], open: [{
                type: Input
            }], panelContent: [{
                type: ViewChild,
                args: ['panelContent']
            }], showMask: [{
                type: Input
            }], previewHeight: [{
                type: Input
            }] } });

class CnetPanelTriggerDirective {
    /**
     * The cnet-panel instance
     *
     * type {CnetPanelComponent}
     * @memberof CnetPanelTriggerDirective
     */
    get panel() { return this._panel; }
    set panel(value) {
        this._panel = value;
    }
    /**
     * Toogle related panel
     *
     * @memberof CnetPanelTriggerDirective
     */
    tooglePanel() {
        this._panel.trigger();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetPanelTriggerDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetPanelTriggerDirective, selector: "[cnetPanelTrigger],[cnet-panel-trigger]", inputs: { panel: ["cnet-panel-trigger", "panel"] }, host: { listeners: { "click": "tooglePanel($event)" } }, exportAs: ["cnetPanelTrigger"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetPanelTriggerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetPanelTrigger],[cnet-panel-trigger]',
                    exportAs: 'cnetPanelTrigger'
                }]
        }], propDecorators: { panel: [{
                type: Input,
                args: ['cnet-panel-trigger']
            }], tooglePanel: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

/** The CnetPanelHeader is a header for panels. */
class CnetHeaderPanelComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetHeaderPanelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetHeaderPanelComponent, selector: "cnet-panel-header, [cnet-panel-header], [cnetPanelHeader]", host: { classAttribute: "cnet-panel-header" }, exportAs: ["cnetPanelHeader"], ngImport: i0, template: "<div class=\"cnet-header-content\">\n    <ng-content></ng-content>\n</div>\n<span class=\"cnet-indicator\" aria-hidden=\"true\">\n    <cnet-icon name=\"angle-down\" size=\"sm\"></cnet-icon>\n</span>\n", dependencies: [{ kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetHeaderPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-panel-header, [cnet-panel-header], [cnetPanelHeader]', exportAs: 'cnetPanelHeader', host: {
                        class: 'cnet-panel-header'
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<div class=\"cnet-header-content\">\n    <ng-content></ng-content>\n</div>\n<span class=\"cnet-indicator\" aria-hidden=\"true\">\n    <cnet-icon name=\"angle-down\" size=\"sm\"></cnet-icon>\n</span>\n" }]
        }] });

/** The CnetPanelHeader is a header for panels. */
class CnetFooterPanelComponent {
    constructor() {
        this.showIcon = false;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFooterPanelComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetFooterPanelComponent, selector: "cnet-panel-footer, [cnet-panel-footer], [cnetPanelFooter]", inputs: { showIcon: "showIcon" }, host: { classAttribute: "cnet-panel-footer" }, exportAs: ["cnetPanelFooter"], ngImport: i0, template: "<div class=\"cnet-footer-content\">\n    <ng-content></ng-content>\n</div>\n<span class=\"cnet-indicator\" aria-hidden=\"true\" *ngIf=\"showIcon\">\n    <cnet-icon name=\"angle-up\" size=\"sm\"></cnet-icon>\n</span>\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFooterPanelComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-panel-footer, [cnet-panel-footer], [cnetPanelFooter]', exportAs: 'cnetPanelFooter', host: {
                        class: 'cnet-panel-footer'
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<div class=\"cnet-footer-content\">\n    <ng-content></ng-content>\n</div>\n<span class=\"cnet-indicator\" aria-hidden=\"true\" *ngIf=\"showIcon\">\n    <cnet-icon name=\"angle-up\" size=\"sm\"></cnet-icon>\n</span>\n" }]
        }], propDecorators: { showIcon: [{
                type: Input
            }] } });

class CnetPanelModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetPanelModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetPanelModule, declarations: [CnetPanelComponent,
            CnetHeaderPanelComponent,
            CnetFooterPanelComponent,
            CnetPanelTriggerDirective], imports: [CommonModule,
            CnetDividerModule,
            CnetIconModule,
            CnetRippleModule,
            A11yModule], exports: [CnetPanelComponent,
            CnetHeaderPanelComponent,
            CnetFooterPanelComponent,
            CnetPanelTriggerDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetPanelModule, imports: [CommonModule,
            CnetDividerModule,
            CnetIconModule,
            CnetRippleModule,
            A11yModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetPanelModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnetPanelComponent,
                        CnetHeaderPanelComponent,
                        CnetFooterPanelComponent,
                        CnetPanelTriggerDirective
                    ],
                    exports: [
                        CnetPanelComponent,
                        CnetHeaderPanelComponent,
                        CnetFooterPanelComponent,
                        CnetPanelTriggerDirective
                    ],
                    imports: [
                        CommonModule,
                        CnetDividerModule,
                        CnetIconModule,
                        CnetRippleModule,
                        A11yModule
                    ]
                }]
        }] });

class PhoneNumberMaskDirective {
    constructor(control, el, renderer) {
        this.control = control;
        this.el = el;
        this.renderer = renderer;
        this.phoneNumberUtil = PhoneNumberUtil.getInstance();
        this.onChangeFn = (_) => { };
        this.control && (this.control.valueAccessor = this);
    }
    ngOnInit() {
        this.control.control.addAsyncValidators(this.isValidNumberValidation());
        this.control.control.updateValueAndValidity();
    }
    ngOnChanges(changes) {
        const { country, } = changes;
        setTimeout(() => {
            this.addMask(this._trueValue);
        }, 0);
    }
    writeValue(value) {
        this._trueValue = value;
        this.addMask(value);
    }
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled) {
        this.renderer.setProperty(this.el.nativeElement, 'disabled', isDisabled);
    }
    addMask(value) {
        if (value) {
            const auxValue = value.toString().replace(/\D/g, '');
            if (auxValue && this.country?.Code && this.countryCode) {
                const stringPhone = auxValue + '';
                try {
                    const phoneNumber = this.phoneNumberUtil.parse('+' + this.countryCode + stringPhone);
                    const isPossible = this.phoneNumberUtil.isPossibleNumber(phoneNumber);
                    if (isPossible) {
                        if (phoneNumber) {
                            this._formattedValue = this.phoneNumberUtil.format(phoneNumber, PhoneNumberFormat.NATIONAL);
                            this._trueValue = this.phoneNumberUtil.format(phoneNumber, PhoneNumberFormat.NATIONAL).replace(' ', '');
                            this.el.nativeElement.value = this._formattedValue;
                        }
                    }
                    else {
                        this._trueValue = auxValue;
                        this.el.nativeElement.value = auxValue.toString();
                    }
                    this.onChange();
                }
                catch (error) {
                    this.el.nativeElement.value = value.toString();
                    return;
                }
            }
            else {
                this.el.nativeElement.value = value.toString();
            }
        }
        else {
            this._trueValue = value;
            // this.el.nativeElement.value = "";
            this.onChange();
        }
    }
    isValidNumberValidation() {
        return (control) => {
            return this.isValidNumber(control.value).pipe(delay(300));
        };
    }
    isValidNumber(value) {
        if (this.country?.Code && this.countryCode && value) {
            const stringPhone = value + '';
            const phoneNumber = this.phoneNumberUtil.parse('+' + this.countryCode + stringPhone);
            const isPossible = this.phoneNumberUtil.isPossibleNumber(phoneNumber);
            if (isPossible) {
                const isValidNumber = this.phoneNumberUtil.isValidNumberForRegion(phoneNumber, this.country.Code);
                return isValidNumber ? of(null) : of({ invalidNumber: true });
            }
            return of({ invalidNumber: true });
        }
        return of(null);
    }
    onInput(value) {
        if (this.onChange) {
            this.addMask(value);
        }
        if (this.onTouched) {
            this.onTouched();
        }
    }
    onChange() {
        this.onChangeFn(this._trueValue ? this._trueValue.toString() : null);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PhoneNumberMaskDirective, deps: [{ token: i1$4.NgControl, optional: true, self: true }, { token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: PhoneNumberMaskDirective, selector: "[cnetPhoneMask]", inputs: { country: ["cnetPhoneMask", "country"], countryCode: ["cnetCountryCode", "countryCode"] }, host: { listeners: { "input": "onInput($event.target.value)" } }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PhoneNumberMaskDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetPhoneMask]',
                }]
        }], ctorParameters: () => [{ type: i1$4.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }, { type: i0.ElementRef }, { type: i0.Renderer2 }], propDecorators: { country: [{
                type: Input,
                args: ['cnetPhoneMask']
            }], countryCode: [{
                type: Input,
                args: ['cnetCountryCode']
            }], onInput: [{
                type: HostListener,
                args: ['input', ['$event.target.value']]
            }] } });

const countries = [
    {
        "Code": "AF",
        "Name": "Afeganistão",
        "Phone": 93,
        "Continent": "Asia",
        "Capital": "Kabul",
        "Currency": "AFN",
        "Languages": "ps,uz,tk"
    },
    {
        "Code": "ZA",
        "Name": "África do Sul",
        "Phone": 27,
        "Continent": "Africa",
        "Capital": "Pretoria",
        "Currency": "ZAR",
        "Languages": "af,en,nr,st,ss,tn,ts,ve,xh,zu",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "AL",
        "Name": "Albânia",
        "Phone": 355,
        "Continent": "Europe",
        "Capital": "Tirana",
        "Currency": "ALL",
        "Languages": "sq"
    },
    {
        "Code": "DE",
        "Name": "Alemanha",
        "Phone": 49,
        "Continent": "Europe",
        "Capital": "Berlin",
        "Currency": "EUR",
        "Languages": "de",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "AD",
        "Name": "Andorra",
        "Phone": 376,
        "Continent": "Europe",
        "Capital": "Andorra la Vella",
        "Currency": "EUR",
        "Languages": "ca",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "AO",
        "Name": "Angola",
        "Phone": 244,
        "Continent": "Africa",
        "Capital": "Luanda",
        "Currency": "AOA",
        "Languages": "pt"
    },
    {
        "Code": "AG",
        "Name": "Antiga e Barbuda",
        "Phone": 1268,
        "Continent": "North America",
        "Capital": "Saint John's",
        "Currency": "XCD",
        "Languages": "en"
    },
    {
        "Code": "SA",
        "Name": "Arábia Saudita",
        "Phone": 966,
        "Continent": "Asia",
        "Capital": "Riyadh",
        "Currency": "SAR",
        "Languages": "ar"
    },
    {
        "Code": "DZ",
        "Name": "Argélia",
        "Phone": 213,
        "Continent": "Africa",
        "Capital": "Algiers",
        "Currency": "DZD",
        "Languages": "ar"
    },
    {
        "Code": "AR",
        "Name": "Argentina",
        "Phone": 54,
        "Continent": "South America",
        "Capital": "Buenos Aires",
        "Currency": "ARS",
        "Languages": "es,gn",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "AM",
        "Name": "Arménia",
        "Phone": 374,
        "Continent": "Asia",
        "Capital": "Yerevan",
        "Currency": "AMD",
        "Languages": "hy,ru"
    },
    {
        "Code": "AU",
        "Name": "Austrália",
        "Phone": 61,
        "Continent": "Oceania",
        "Capital": "Canberra",
        "Currency": "AUD",
        "Languages": "en",
        "PhoneFormat": "(00) 0000 0000"
    },
    {
        "Code": "AT",
        "Name": "Áustria",
        "Phone": 43,
        "Continent": "Europe",
        "Capital": "Vienna",
        "Currency": "EUR",
        "Languages": "de",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "AZ",
        "Name": "Azerbaijão",
        "Phone": 994,
        "Continent": "Asia",
        "Capital": "Baku",
        "Currency": "AZN",
        "Languages": "az"
    },
    {
        "Code": "BS",
        "Name": "Bahamas",
        "Phone": 1242,
        "Continent": "North America",
        "Capital": "Nassau",
        "Currency": "BSD",
        "Languages": "en"
    },
    {
        "Code": "BD",
        "Name": "Bangladexe",
        "Phone": 880,
        "Continent": "Asia",
        "Capital": "Dhaka",
        "Currency": "BDT",
        "Languages": "bn",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "BB",
        "Name": "Barbados",
        "Phone": 1246,
        "Continent": "North America",
        "Capital": "Bridgetown",
        "Currency": "BBD",
        "Languages": "en"
    },
    {
        "Code": "BH",
        "Name": "Barém",
        "Phone": 973,
        "Continent": "Asia",
        "Capital": "Manama",
        "Currency": "BHD",
        "Languages": "ar"
    },
    {
        "Code": "BE",
        "Name": "Bélgica",
        "Phone": 32,
        "Continent": "Europe",
        "Capital": "Brussels",
        "Currency": "EUR",
        "Languages": "nl,fr,de",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "BZ",
        "Name": "Belize",
        "Phone": 501,
        "Continent": "North America",
        "Capital": "Belmopan",
        "Currency": "BZD",
        "Languages": "en,es"
    },
    {
        "Code": "BJ",
        "Name": "Benim",
        "Phone": 229,
        "Continent": "Africa",
        "Capital": "Porto-Novo",
        "Currency": "XOF",
        "Languages": "fr"
    },
    {
        "Code": "BY",
        "Name": "Bielorrússia",
        "Phone": 375,
        "Continent": "Europe",
        "Capital": "Minsk",
        "Currency": "BYN",
        "Languages": "be,ru"
    },
    {
        "Code": "BO",
        "Name": "Bolívia",
        "Phone": 591,
        "Continent": "South America",
        "Capital": "Sucre",
        "Currency": "BOB,BOV",
        "Languages": "es,ay,qu"
    },
    {
        "Code": "BA",
        "Name": "Bósnia e Herzegovina",
        "Phone": 387,
        "Continent": "Europe",
        "Capital": "Sarajevo",
        "Currency": "BAM",
        "Languages": "bs,hr,sr"
    },
    {
        "Code": "BW",
        "Name": "Botsuana",
        "Phone": 267,
        "Continent": "Africa",
        "Capital": "Gaborone",
        "Currency": "BWP",
        "Languages": "en,tn"
    },
    {
        "Code": "BR",
        "Name": "Brasil",
        "Phone": 55,
        "Continent": "South America",
        "Capital": "Brasília",
        "Currency": "BRL",
        "Languages": "pt",
        "PhoneFormat": "(00) 0 0000-0000",
        "FiscalCodeNaturalMask": "000.000.000-00",
        "FiscalCodeLegalMask": "00.000.000/0000-00",
        "ZipCodeMask": "00000-000",
        "HasIntegrationAddress": "viaCep",
        "Protocol": "0{9}",
    },
    {
        "Code": "BN",
        "Name": "Brunei",
        "Phone": 673,
        "Continent": "Asia",
        "Capital": "Bandar Seri Begawan",
        "Currency": "BND",
        "Languages": "ms"
    },
    {
        "Code": "BG",
        "Name": "Bulgária",
        "Phone": 359,
        "Continent": "Europe",
        "Capital": "Sofia",
        "Currency": "BGN",
        "Languages": "bg",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "BF",
        "Name": "Burquina Faso",
        "Phone": 226,
        "Continent": "Africa",
        "Capital": "Ouagadougou",
        "Currency": "XOF",
        "Languages": "fr,ff"
    },
    {
        "Code": "BI",
        "Name": "Burúndi",
        "Phone": 257,
        "Continent": "Africa",
        "Capital": "Bujumbura",
        "Currency": "BIF",
        "Languages": "fr,rn"
    },
    {
        "Code": "BT",
        "Name": "Butão",
        "Phone": 975,
        "Continent": "Asia",
        "Capital": "Thimphu",
        "Currency": "BTN,INR",
        "Languages": "dz"
    },
    {
        "Code": "CV",
        "Name": "Cabo Verde",
        "Phone": 238,
        "Continent": "Africa",
        "Capital": "Praia",
        "Currency": "CVE",
        "Languages": "pt"
    },
    {
        "Code": "CM",
        "Name": "Camarões",
        "Phone": 237,
        "Continent": "Africa",
        "Capital": "Yaoundé",
        "Currency": "XAF",
        "Languages": "en,fr"
    },
    {
        "Code": "KH",
        "Name": "Camboja",
        "Phone": 855,
        "Continent": "Asia",
        "Capital": "Phnom Penh",
        "Currency": "KHR",
        "Languages": "km"
    },
    {
        "Code": "CA",
        "Name": "Canadá",
        "Phone": 1,
        "Continent": "North America",
        "Capital": "Ottawa",
        "Currency": "CAD",
        "Languages": "en,fr",
        "PhoneFormat": "(000) 000-0000",
        "SpecialIcon": "usa-ca",
        "AreaCodes": [227, 235, 274, 283, 324, 327, 353, 382, 428, 436, 624, 645, 679, 686, 730, 738, 821, 879, 924, 975],
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "QA",
        "Name": "Catar",
        "Phone": 974,
        "Continent": "Asia",
        "Capital": "Doha",
        "Currency": "QAR",
        "Languages": "ar"
    },
    {
        "Code": "KZ",
        "Name": "Cazaquistão",
        "Phone": 76,
        "Continent": "Asia",
        "Capital": "Astana",
        "Currency": "KZT",
        "Languages": "kk,ru"
    },
    {
        "Code": "KZ",
        "Name": "Cazaquistão",
        "Phone": 77,
        "Continent": "Asia",
        "Capital": "Astana",
        "Currency": "KZT",
        "Languages": "kk,ru"
    },
    {
        "Code": "TD",
        "Name": "Chade",
        "Phone": 235,
        "Continent": "Africa",
        "Capital": "N'Djamena",
        "Currency": "XAF",
        "Languages": "fr,ar"
    },
    {
        "Code": "CL",
        "Name": "Chile",
        "Phone": 56,
        "Continent": "South America",
        "Capital": "Santiago",
        "Currency": "CLF,CLP",
        "Languages": "es"
    },
    {
        "Code": "CN",
        "Name": "China",
        "Phone": 86,
        "Continent": "Asia",
        "Capital": "Beijing",
        "Currency": "CNY",
        "Languages": "zh",
        "PhoneFormat": "000 0000 0000"
    },
    {
        "Code": "CY",
        "Name": "Chipre",
        "Phone": 357,
        "Continent": "Europe",
        "Capital": "Nicosia",
        "Currency": "EUR",
        "Languages": "el,tr,hy"
    },
    {
        "Code": "CO",
        "Name": "Colômbia",
        "Phone": 57,
        "Continent": "South America",
        "Capital": "Bogotá",
        "Currency": "COP",
        "Languages": "es"
    },
    {
        "Code": "KM",
        "Name": "Comores",
        "Phone": 269,
        "Continent": "Africa",
        "Capital": "Moroni",
        "Currency": "KMF",
        "Languages": "ar,fr"
    },
    {
        "Code": "CG",
        "Name": "Congo-Brazzaville",
        "Phone": 242,
        "Continent": "Africa",
        "Capital": "Brazzaville",
        "Currency": "XAF",
        "Languages": "fr,ln"
    },
    {
        "Code": "KP",
        "Name": "Coreia do Norte",
        "Phone": 850,
        "Continent": "Asia",
        "Capital": "Pyongyang",
        "Currency": "KPW",
        "Languages": "ko"
    },
    {
        "Code": "KR",
        "Name": "Coreia do Sul",
        "Phone": 82,
        "Continent": "Asia",
        "Capital": "Seoul",
        "Currency": "KRW",
        "Languages": "ko"
    },
    {
        "Code": "CI",
        "Name": "Costa do Marfim",
        "Phone": 225,
        "Continent": "Africa",
        "Capital": "Yamoussoukro",
        "Currency": "XOF",
        "Languages": "fr"
    },
    {
        "Code": "CR",
        "Name": "Costa Rica",
        "Phone": 506,
        "Continent": "North America",
        "Capital": "San José",
        "Currency": "CRC",
        "Languages": "es"
    },
    {
        "Code": "HR",
        "Name": "Croácia",
        "Phone": 385,
        "Continent": "Europe",
        "Capital": "Zagreb",
        "Currency": "HRK",
        "Languages": "hr",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "KW",
        "Name": "Cuaite",
        "Phone": 965,
        "Continent": "Asia",
        "Capital": "Kuwait City",
        "Currency": "KWD",
        "Languages": "ar"
    },
    {
        "Code": "CU",
        "Name": "Cuba",
        "Phone": 53,
        "Continent": "North America",
        "Capital": "Havana",
        "Currency": "CUC,CUP",
        "Languages": "es"
    },
    {
        "Code": "DK",
        "Name": "Dinamarca",
        "Phone": 45,
        "Continent": "Europe",
        "Capital": "Copenhagen",
        "Currency": "DKK",
        "Languages": "da",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "DM",
        "Name": "Dominica",
        "Phone": 1767,
        "Continent": "North America",
        "Capital": "Roseau",
        "Currency": "XCD",
        "Languages": "en"
    },
    {
        "Code": "EG",
        "Name": "Egito",
        "Phone": 20,
        "Continent": "Africa",
        "Capital": "Cairo",
        "Currency": "EGP",
        "Languages": "ar"
    },
    {
        "Code": "AE",
        "Name": "Emirados Árabes Unidos",
        "Phone": 971,
        "Continent": "Asia",
        "Capital": "Abu Dhabi",
        "Currency": "AED",
        "Languages": "ar"
    },
    {
        "Code": "EC",
        "Name": "Equador",
        "Phone": 593,
        "Continent": "South America",
        "Capital": "Quito",
        "Currency": "USD",
        "Languages": "es"
    },
    {
        "Code": "ER",
        "Name": "Eritreia",
        "Phone": 291,
        "Continent": "Africa",
        "Capital": "Asmara",
        "Currency": "ERN",
        "Languages": "ti,ar,en"
    },
    {
        "Code": "SK",
        "Name": "Eslováquia",
        "Phone": 421,
        "Continent": "Europe",
        "Capital": "Bratislava",
        "Currency": "EUR",
        "Languages": "sk",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "SI",
        "Name": "Eslovénia",
        "Phone": 386,
        "Continent": "Europe",
        "Capital": "Ljubljana",
        "Currency": "EUR",
        "Languages": "sl",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "ES",
        "Name": "Espanha",
        "Phone": 34,
        "Continent": "Europe",
        "Capital": "Madrid",
        "Currency": "EUR",
        "Languages": "es,eu,ca,gl,oc",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "PS",
        "Name": "Estado da Palestina",
        "Phone": 970,
        "Continent": "Asia",
        "Capital": "Ramallah",
        "Currency": "ILS",
        "Languages": "ar"
    },
    {
        "Code": "US",
        "Name": "Estados Unidos",
        "Phone": 1,
        "Continent": "North America",
        "Capital": "Washington D.C.",
        "Currency": "USD,USN,USS",
        "Languages": "en",
        "PhoneFormat": "(000) 000-0000",
        "SpecialIcon": "usa-ca",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "EE",
        "Name": "Estónia",
        "Phone": 372,
        "Continent": "Europe",
        "Capital": "Tallinn",
        "Currency": "EUR",
        "Languages": "et"
    },
    {
        "Code": "ET",
        "Name": "Etiópia",
        "Phone": 251,
        "Continent": "Africa",
        "Capital": "Addis Ababa",
        "Currency": "ETB",
        "Languages": "am"
    },
    {
        "Code": "FJ",
        "Name": "Fiji",
        "Phone": 679,
        "Continent": "Oceania",
        "Capital": "Suva",
        "Currency": "FJD",
        "Languages": "en,fj,hi,ur"
    },
    {
        "Code": "PH",
        "Name": "Filipinas",
        "Phone": 63,
        "Continent": "Asia",
        "Capital": "Manila",
        "Currency": "PHP",
        "Languages": "en",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "FI",
        "Name": "Finlândia",
        "Phone": 358,
        "Continent": "Europe",
        "Capital": "Helsinki",
        "Currency": "EUR",
        "Languages": "fi,sv",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "FR",
        "Name": "França",
        "Phone": 33,
        "Continent": "Europe",
        "Capital": "Paris",
        "Currency": "EUR",
        "Languages": "fr",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "GA",
        "Name": "Gabão",
        "Phone": 241,
        "Continent": "Africa",
        "Capital": "Libreville",
        "Currency": "XAF",
        "Languages": "fr"
    },
    {
        "Code": "GM",
        "Name": "Gâmbia",
        "Phone": 220,
        "Continent": "Africa",
        "Capital": "Banjul",
        "Currency": "GMD",
        "Languages": "en"
    },
    {
        "Code": "GH",
        "Name": "Gana",
        "Phone": 233,
        "Continent": "Africa",
        "Capital": "Accra",
        "Currency": "GHS",
        "Languages": "en"
    },
    {
        "Code": "GE",
        "Name": "Geórgia",
        "Phone": 995,
        "Continent": "Asia",
        "Capital": "Tbilisi",
        "Currency": "GEL",
        "Languages": "ka"
    },
    {
        "Code": "GD",
        "Name": "Granada",
        "Phone": 1473,
        "Continent": "North America",
        "Capital": "St. George's",
        "Currency": "XCD",
        "Languages": "en"
    },
    {
        "Code": "GR",
        "Name": "Grécia",
        "Phone": 30,
        "Continent": "Europe",
        "Capital": "Athens",
        "Currency": "EUR",
        "Languages": "el"
    },
    {
        "Code": "GT",
        "Name": "Guatemala",
        "Phone": 502,
        "Continent": "North America",
        "Capital": "Guatemala City",
        "Currency": "GTQ",
        "Languages": "es",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "GY",
        "Name": "Guiana",
        "Phone": 592,
        "Continent": "South America",
        "Capital": "Georgetown",
        "Currency": "GYD",
        "Languages": "en",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "GN",
        "Name": "Guiné",
        "Phone": 224,
        "Continent": "Africa",
        "Capital": "Conakry",
        "Currency": "GNF",
        "Languages": "fr,ff"
    },
    {
        "Code": "GQ",
        "Name": "Guiné Equatorial",
        "Phone": 240,
        "Continent": "Africa",
        "Capital": "Malabo",
        "Currency": "XAF",
        "Languages": "es,fr"
    },
    {
        "Code": "GW",
        "Name": "Guiné-Bissau",
        "Phone": 245,
        "Continent": "Africa",
        "Capital": "Bissau",
        "Currency": "XOF",
        "Languages": "pt"
    },
    {
        "Code": "HT",
        "Name": "Haiti",
        "Phone": 509,
        "Continent": "North America",
        "Capital": "Port-au-Prince",
        "Currency": "HTG,USD",
        "Languages": "fr,ht"
    },
    {
        "Code": "HN",
        "Name": "Honduras",
        "Phone": 504,
        "Continent": "North America",
        "Capital": "Tegucigalpa",
        "Currency": "HNL",
        "Languages": "es"
    },
    {
        "Code": "HU",
        "Name": "Hungria",
        "Phone": 36,
        "Continent": "Europe",
        "Capital": "Budapest",
        "Currency": "HUF",
        "Languages": "hu",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "YE",
        "Name": "Iémen",
        "Phone": 967,
        "Continent": "Asia",
        "Capital": "Sana'a",
        "Currency": "YER",
        "Languages": "ar"
    },
    {
        "Code": "MH",
        "Name": "Ilhas Marechal",
        "Phone": 692,
        "Continent": "Oceania",
        "Capital": "Majuro",
        "Currency": "USD",
        "Languages": "en,mh",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "IN",
        "Name": "Índia",
        "Phone": 91,
        "Continent": "Asia",
        "Capital": "New Delhi",
        "Currency": "INR",
        "Languages": "hi,en",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "ID",
        "Name": "Indonésia",
        "Phone": 62,
        "Continent": "Asia",
        "Capital": "Jakarta",
        "Currency": "IDR",
        "Languages": "id"
    },
    {
        "Code": "IR",
        "Name": "Irão",
        "Phone": 98,
        "Continent": "Asia",
        "Capital": "Tehran",
        "Currency": "IRR",
        "Languages": "fa"
    },
    {
        "Code": "IQ",
        "Name": "Iraque",
        "Phone": 964,
        "Continent": "Asia",
        "Capital": "Baghdad",
        "Currency": "IQD",
        "Languages": "ar,ku"
    },
    {
        "Code": "IE",
        "Name": "Irlanda",
        "Phone": 353,
        "Continent": "Europe",
        "Capital": "Dublin",
        "Currency": "EUR",
        "Languages": "ga,en"
    },
    {
        "Code": "IS",
        "Name": "Islândia",
        "Phone": 354,
        "Continent": "Europe",
        "Capital": "Reykjavik",
        "Currency": "ISK",
        "Languages": "is",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "IL",
        "Name": "Israel",
        "Phone": 972,
        "Continent": "Asia",
        "Capital": "Jerusalem",
        "Currency": "ILS",
        "Languages": "he,ar"
    },
    {
        "Code": "IT",
        "Name": "Itália",
        "Phone": 39,
        "Continent": "Europe",
        "Capital": "Rome",
        "Currency": "EUR",
        "Languages": "it",
        "PhoneFormat": "00 0000 0000",
        "FiscalCodeNaturalMask": "SSSSSS00S00S000S",
        "FiscalCodeLegalMask": "00000000000",
        "ZipCodeMask": "00000",
        "HasIntegrationAddress": "zippopotam",
        "Protocol": "00000/0000",
        "PrefixProtocol": "N "
    },
    {
        "Code": "JM",
        "Name": "Jamaica",
        "Phone": 1876,
        "Continent": "North America",
        "Capital": "Kingston",
        "Currency": "JMD",
        "Languages": "en"
    },
    {
        "Code": "JP",
        "Name": "Japão",
        "Phone": 81,
        "Continent": "Asia",
        "Capital": "Tokyo",
        "Currency": "JPY",
        "Languages": "ja",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "DJ",
        "Name": "Jibuti",
        "Phone": 253,
        "Continent": "Africa",
        "Capital": "Djibouti",
        "Currency": "DJF",
        "Languages": "fr,ar"
    },
    {
        "Code": "JO",
        "Name": "Jordânia",
        "Phone": 962,
        "Continent": "Asia",
        "Capital": "Amman",
        "Currency": "JOD",
        "Languages": "ar"
    },
    {
        "Code": "LA",
        "Name": "Laus",
        "Phone": 856,
        "Continent": "Asia",
        "Capital": "Vientiane",
        "Currency": "LAK",
        "Languages": "lo"
    },
    {
        "Code": "LS",
        "Name": "Lesoto",
        "Phone": 266,
        "Continent": "Africa",
        "Capital": "Maseru",
        "Currency": "LSL,ZAR",
        "Languages": "en,st"
    },
    {
        "Code": "LV",
        "Name": "Letónia",
        "Phone": 371,
        "Continent": "Europe",
        "Capital": "Riga",
        "Currency": "EUR",
        "Languages": "lv"
    },
    {
        "Code": "LB",
        "Name": "Líbano",
        "Phone": 961,
        "Continent": "Asia",
        "Capital": "Beirut",
        "Currency": "LBP",
        "Languages": "ar,fr"
    },
    {
        "Code": "LR",
        "Name": "Libéria",
        "Phone": 231,
        "Continent": "Africa",
        "Capital": "Monrovia",
        "Currency": "LRD",
        "Languages": "en"
    },
    {
        "Code": "LY",
        "Name": "Líbia",
        "Phone": 218,
        "Continent": "Africa",
        "Capital": "Tripoli",
        "Currency": "LYD",
        "Languages": "ar"
    },
    {
        "Code": "LI",
        "Name": "Listenstaine",
        "Phone": 423,
        "Continent": "Europe",
        "Capital": "Vaduz",
        "Currency": "CHF",
        "Languages": "de",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "LT",
        "Name": "Lituânia",
        "Phone": 370,
        "Continent": "Europe",
        "Capital": "Vilnius",
        "Currency": "EUR",
        "Languages": "lt",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "LU",
        "Name": "Luxemburgo",
        "Phone": 352,
        "Continent": "Europe",
        "Capital": "Luxembourg",
        "Currency": "EUR",
        "Languages": "fr,de,lb",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "MK",
        "Name": "Macedónia",
        "Phone": 389,
        "Continent": "Europe",
        "Capital": "Skopje",
        "Currency": "MKD",
        "Languages": "mk",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "MG",
        "Name": "Madagáscar",
        "Phone": 261,
        "Continent": "Africa",
        "Capital": "Antananarivo",
        "Currency": "MGA",
        "Languages": "fr,mg"
    },
    {
        "Code": "MY",
        "Name": "Malásia",
        "Phone": 60,
        "Continent": "Asia",
        "Capital": "Kuala Lumpur",
        "Currency": "MYR",
        "Languages": "ms",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "MW",
        "Name": "Maláui",
        "Phone": 265,
        "Continent": "Africa",
        "Capital": "Lilongwe",
        "Currency": "MWK",
        "Languages": "en,ny"
    },
    {
        "Code": "MV",
        "Name": "Maldivas",
        "Phone": 960,
        "Continent": "Asia",
        "Capital": "Malé",
        "Currency": "MVR",
        "Languages": "dv"
    },
    {
        "Code": "ML",
        "Name": "Mali",
        "Phone": 223,
        "Continent": "Africa",
        "Capital": "Bamako",
        "Currency": "XOF",
        "Languages": "fr"
    },
    {
        "Code": "MT",
        "Name": "Malta",
        "Phone": 356,
        "Continent": "Europe",
        "Capital": "Valletta",
        "Currency": "EUR",
        "Languages": "mt,en"
    },
    {
        "Code": "MA",
        "Name": "Marrocos",
        "Phone": 212,
        "Continent": "Africa",
        "Capital": "Rabat",
        "Currency": "MAD",
        "Languages": "ar"
    },
    {
        "Code": "MU",
        "Name": "Maurícia",
        "Phone": 230,
        "Continent": "Africa",
        "Capital": "Port Louis",
        "Currency": "MUR",
        "Languages": "en"
    },
    {
        "Code": "MR",
        "Name": "Mauritânia",
        "Phone": 222,
        "Continent": "Africa",
        "Capital": "Nouakchott",
        "Currency": "MRU",
        "Languages": "ar"
    },
    {
        "Code": "MX",
        "Name": "México",
        "Phone": 52,
        "Continent": "North America",
        "Capital": "Mexico City",
        "Currency": "MXN",
        "Languages": "es",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "MM",
        "Name": "Mianmar",
        "Phone": 95,
        "Continent": "Asia",
        "Capital": "Naypyidaw",
        "Currency": "MMK",
        "Languages": "my"
    },
    {
        "Code": "FM",
        "Name": "Micronésia",
        "Phone": 691,
        "Continent": "Oceania",
        "Capital": "Palikir",
        "Currency": "USD",
        "Languages": "en"
    },
    {
        "Code": "MZ",
        "Name": "Moçambique",
        "Phone": 258,
        "Continent": "Africa",
        "Capital": "Maputo",
        "Currency": "MZN",
        "Languages": "pt"
    },
    {
        "Code": "MD",
        "Name": "Moldávia",
        "Phone": 373,
        "Continent": "Europe",
        "Capital": "Chișinău",
        "Currency": "MDL",
        "Languages": "ro",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "MC",
        "Name": "Mónaco",
        "Phone": 377,
        "Continent": "Europe",
        "Capital": "Monaco",
        "Currency": "EUR",
        "Languages": "fr",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "MN",
        "Name": "Mongólia",
        "Phone": 976,
        "Continent": "Asia",
        "Capital": "Ulan Bator",
        "Currency": "MNT",
        "Languages": "mn"
    },
    {
        "Code": "ME",
        "Name": "Montenegro",
        "Phone": 382,
        "Continent": "Europe",
        "Capital": "Podgorica",
        "Currency": "EUR",
        "Languages": "sr,bs,sq,hr"
    },
    {
        "Code": "NA",
        "Name": "Namíbia",
        "Phone": 264,
        "Continent": "Africa",
        "Capital": "Windhoek",
        "Currency": "NAD,ZAR",
        "Languages": "en,af"
    },
    {
        "Code": "NR",
        "Name": "Nauru",
        "Phone": 674,
        "Continent": "Oceania",
        "Capital": "Yaren",
        "Currency": "AUD",
        "Languages": "en,na"
    },
    {
        "Code": "NP",
        "Name": "Nepal",
        "Phone": 977,
        "Continent": "Asia",
        "Capital": "Kathmandu",
        "Currency": "NPR",
        "Languages": "ne"
    },
    {
        "Code": "NI",
        "Name": "Nicarágua",
        "Phone": 505,
        "Continent": "North America",
        "Capital": "Managua",
        "Currency": "NIO",
        "Languages": "es"
    },
    {
        "Code": "NE",
        "Name": "Níger",
        "Phone": 227,
        "Continent": "Africa",
        "Capital": "Niamey",
        "Currency": "XOF",
        "Languages": "fr"
    },
    {
        "Code": "NG",
        "Name": "Nigéria",
        "Phone": 234,
        "Continent": "Africa",
        "Capital": "Abuja",
        "Currency": "NGN",
        "Languages": "en"
    },
    {
        "Code": "NO",
        "Name": "Noruega",
        "Phone": 47,
        "Continent": "Europe",
        "Capital": "Oslo",
        "Currency": "NOK",
        "Languages": "no,nb,nn",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "NZ",
        "Name": "Nova Zelândia",
        "Phone": 64,
        "Continent": "Oceania",
        "Capital": "Wellington",
        "Currency": "NZD",
        "Languages": "en,mi",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "OM",
        "Name": "Omã",
        "Phone": 968,
        "Continent": "Asia",
        "Capital": "Muscat",
        "Currency": "OMR",
        "Languages": "ar"
    },
    {
        "Code": "NL",
        "Name": "Países Baixos",
        "Phone": 31,
        "Continent": "Europe",
        "Capital": "Amsterdam",
        "Currency": "EUR",
        "Languages": "nl",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "PW",
        "Name": "Palau",
        "Phone": 680,
        "Continent": "Oceania",
        "Capital": "Ngerulmud",
        "Currency": "USD",
        "Languages": "en"
    },
    {
        "Code": "PA",
        "Name": "Panamá",
        "Phone": 507,
        "Continent": "North America",
        "Capital": "Panama City",
        "Currency": "PAB,USD",
        "Languages": "es"
    },
    {
        "Code": "PG",
        "Name": "Papua Nova Guiné",
        "Phone": 675,
        "Continent": "Oceania",
        "Capital": "Port Moresby",
        "Currency": "PGK",
        "Languages": "en"
    },
    {
        "Code": "PK",
        "Name": "Paquistão",
        "Phone": 92,
        "Continent": "Asia",
        "Capital": "Islamabad",
        "Currency": "PKR",
        "Languages": "en,ur",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "PY",
        "Name": "Paraguai",
        "Phone": 595,
        "Continent": "South America",
        "Capital": "Asunción",
        "Currency": "PYG",
        "Languages": "es,gn"
    },
    {
        "Code": "PE",
        "Name": "Peru",
        "Phone": 51,
        "Continent": "South America",
        "Capital": "Lima",
        "Currency": "PEN",
        "Languages": "es"
    },
    {
        "Code": "PL",
        "Name": "Polónia",
        "Phone": 48,
        "Continent": "Europe",
        "Capital": "Warsaw",
        "Currency": "PLN",
        "Languages": "pl",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "PT",
        "Name": "Portugal",
        "Phone": 351,
        "Continent": "Europe",
        "Capital": "Lisbon",
        "Currency": "EUR",
        "Languages": "pt",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "KE",
        "Name": "Quénia",
        "Phone": 254,
        "Continent": "Africa",
        "Capital": "Nairobi",
        "Currency": "KES",
        "Languages": "en,sw"
    },
    {
        "Code": "KG",
        "Name": "Quirguistão",
        "Phone": 996,
        "Continent": "Asia",
        "Capital": "Bishkek",
        "Currency": "KGS",
        "Languages": "ky,ru"
    },
    {
        "Code": "KI",
        "Name": "Quiribáti",
        "Phone": 686,
        "Continent": "Oceania",
        "Capital": "South Tarawa",
        "Currency": "AUD",
        "Languages": "en"
    },
    {
        "Code": "GB",
        "Name": "Reino Unido",
        "Phone": 44,
        "Continent": "Europe",
        "Capital": "London",
        "Currency": "GBP",
        "Languages": "en",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "CF",
        "Name": "República Centro-Africana",
        "Phone": 236,
        "Continent": "Africa",
        "Capital": "Bangui",
        "Currency": "XAF",
        "Languages": "fr,sg"
    },
    {
        "Code": "CZ",
        "Name": "República Checa",
        "Phone": 420,
        "Continent": "Europe",
        "Capital": "Prague",
        "Currency": "CZK",
        "Languages": "cs,sk",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "CD",
        "Name": "República Democrática do Congo",
        "Phone": 243,
        "Continent": "Africa",
        "Capital": "Kinshasa",
        "Currency": "CDF",
        "Languages": "fr,ln,kg,sw,lu"
    },
    {
        "Code": "DO",
        "Name": "República Dominicana",
        "Phone": 1809,
        "Continent": "North America",
        "Capital": "Santo Domingo",
        "Currency": "DOP",
        "Languages": "es",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "DO",
        "Name": "República Dominicana",
        "Phone": 1829,
        "Continent": "North America",
        "Capital": "Santo Domingo",
        "Currency": "DOP",
        "Languages": "es"
    },
    {
        "Code": "DO",
        "Name": "República Dominicana",
        "Phone": 1849,
        "Continent": "North America",
        "Capital": "Santo Domingo",
        "Currency": "DOP",
        "Languages": "es"
    },
    {
        "Code": "RO",
        "Name": "Roménia",
        "Phone": 40,
        "Continent": "Europe",
        "Capital": "Bucharest",
        "Currency": "RON",
        "Languages": "ro"
    },
    {
        "Code": "RW",
        "Name": "Ruanda",
        "Phone": 250,
        "Continent": "Africa",
        "Capital": "Kigali",
        "Currency": "RWF",
        "Languages": "rw,en,fr"
    },
    {
        "Code": "RU",
        "Name": "Rússia",
        "Phone": 7,
        "Continent": "Europe",
        "Capital": "Moscow",
        "Currency": "RUB",
        "Languages": "ru",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "SB",
        "Name": "Salomão",
        "Phone": 677,
        "Continent": "Oceania",
        "Capital": "Honiara",
        "Currency": "SBD",
        "Languages": "en"
    },
    {
        "Code": "SV",
        "Name": "Salvador",
        "Phone": 503,
        "Continent": "North America",
        "Capital": "San Salvador",
        "Currency": "SVC,USD",
        "Languages": "es"
    },
    {
        "Code": "WS",
        "Name": "Samoa",
        "Phone": 685,
        "Continent": "Oceania",
        "Capital": "Apia",
        "Currency": "WST",
        "Languages": "sm,en"
    },
    {
        "Code": "LC",
        "Name": "Santa Lúcia",
        "Phone": 1758,
        "Continent": "North America",
        "Capital": "Castries",
        "Currency": "XCD",
        "Languages": "en"
    },
    {
        "Code": "KN",
        "Name": "São Cristóvão e Neves",
        "Phone": 1869,
        "Continent": "North America",
        "Capital": "Basseterre",
        "Currency": "XCD",
        "Languages": "en"
    },
    {
        "Code": "SM",
        "Name": "São Marinho",
        "Phone": 378,
        "Continent": "Europe",
        "Capital": "City of San Marino",
        "Currency": "EUR",
        "Languages": "it",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "ST",
        "Name": "São Tomé e Príncipe",
        "Phone": 239,
        "Continent": "Africa",
        "Capital": "São Tomé",
        "Currency": "STN",
        "Languages": "pt"
    },
    {
        "Code": "VC",
        "Name": "São Vicente e Granadinas",
        "Phone": 1784,
        "Continent": "North America",
        "Capital": "Kingstown",
        "Currency": "XCD",
        "Languages": "en"
    },
    {
        "Code": "SC",
        "Name": "Seicheles",
        "Phone": 248,
        "Continent": "Africa",
        "Capital": "Victoria",
        "Currency": "SCR",
        "Languages": "fr,en"
    },
    {
        "Code": "SN",
        "Name": "Senegal",
        "Phone": 221,
        "Continent": "Africa",
        "Capital": "Dakar",
        "Currency": "XOF",
        "Languages": "fr"
    },
    {
        "Code": "SL",
        "Name": "Serra Leoa",
        "Phone": 232,
        "Continent": "Africa",
        "Capital": "Freetown",
        "Currency": "SLL",
        "Languages": "en"
    },
    {
        "Code": "RS",
        "Name": "Sérvia",
        "Phone": 381,
        "Continent": "Europe",
        "Capital": "Belgrade",
        "Currency": "RSD",
        "Languages": "sr"
    },
    {
        "Code": "SG",
        "Name": "Singapura",
        "Phone": 65,
        "Continent": "Asia",
        "Capital": "Singapore",
        "Currency": "SGD",
        "Languages": "en,ms,ta,zh"
    },
    {
        "Code": "SY",
        "Name": "Síria",
        "Phone": 963,
        "Continent": "Asia",
        "Capital": "Damascus",
        "Currency": "SYP",
        "Languages": "ar"
    },
    {
        "Code": "SO",
        "Name": "Somália",
        "Phone": 252,
        "Continent": "Africa",
        "Capital": "Mogadishu",
        "Currency": "SOS",
        "Languages": "so,ar"
    },
    {
        "Code": "LK",
        "Name": "Sri Lanca",
        "Phone": 94,
        "Continent": "Asia",
        "Capital": "Colombo",
        "Currency": "LKR",
        "Languages": "si,ta",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "SZ",
        "Name": "Suazilândia",
        "Phone": 268,
        "Continent": "Africa",
        "Capital": "Lobamba",
        "Currency": "SZL",
        "Languages": "en,ss"
    },
    {
        "Code": "SD",
        "Name": "Sudão",
        "Phone": 249,
        "Continent": "Africa",
        "Capital": "Khartoum",
        "Currency": "SDG",
        "Languages": "ar,en"
    },
    {
        "Code": "SS",
        "Name": "Sudão do Sul",
        "Phone": 211,
        "Continent": "Africa",
        "Capital": "Juba",
        "Currency": "SSP",
        "Languages": "en"
    },
    {
        "Code": "SE",
        "Name": "Suécia",
        "Phone": 46,
        "Continent": "Europe",
        "Capital": "Stockholm",
        "Currency": "SEK",
        "Languages": "sv",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "CH",
        "Name": "Suíça",
        "Phone": 41,
        "Continent": "Europe",
        "Capital": "Bern",
        "Currency": "CHE,CHF,CHW",
        "Languages": "de,fr,it",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "SR",
        "Name": "Suriname",
        "Phone": 597,
        "Continent": "South America",
        "Capital": "Paramaribo",
        "Currency": "SRD",
        "Languages": "nl"
    },
    {
        "Code": "TH",
        "Name": "Tailândia",
        "Phone": 66,
        "Continent": "Asia",
        "Capital": "Bangkok",
        "Currency": "THB",
        "Languages": "th",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "TW",
        "Name": "Taiuã",
        "Phone": 886,
        "Continent": "Asia",
        "Capital": "Taipei",
        "Currency": "TWD",
        "Languages": "zh"
    },
    {
        "Code": "TJ",
        "Name": "Tajiquistão",
        "Phone": 992,
        "Continent": "Asia",
        "Capital": "Dushanbe",
        "Currency": "TJS",
        "Languages": "tg,ru"
    },
    {
        "Code": "TZ",
        "Name": "Tanzânia",
        "Phone": 255,
        "Continent": "Africa",
        "Capital": "Dodoma",
        "Currency": "TZS",
        "Languages": "sw,en"
    },
    {
        "Code": "TL",
        "Name": "Timor-Leste",
        "Phone": 670,
        "Continent": "Oceania",
        "Capital": "Dili",
        "Currency": "USD",
        "Languages": "pt"
    },
    {
        "Code": "TG",
        "Name": "Togo",
        "Phone": 228,
        "Continent": "Africa",
        "Capital": "Lomé",
        "Currency": "XOF",
        "Languages": "fr"
    },
    {
        "Code": "TO",
        "Name": "Tonga",
        "Phone": 676,
        "Continent": "Oceania",
        "Capital": "Nuku'alofa",
        "Currency": "TOP",
        "Languages": "en,to"
    },
    {
        "Code": "TT",
        "Name": "Trindade e Tobago",
        "Phone": 1868,
        "Continent": "North America",
        "Capital": "Port of Spain",
        "Currency": "TTD",
        "Languages": "en"
    },
    {
        "Code": "TN",
        "Name": "Tunísia",
        "Phone": 216,
        "Continent": "Africa",
        "Capital": "Tunis",
        "Currency": "TND",
        "Languages": "ar"
    },
    {
        "Code": "TM",
        "Name": "Turcomenistão",
        "Phone": 993,
        "Continent": "Asia",
        "Capital": "Ashgabat",
        "Currency": "TMT",
        "Languages": "tk,ru"
    },
    {
        "Code": "TR",
        "Name": "Turquia",
        "Phone": 90,
        "Continent": "Asia",
        "Capital": "Ankara",
        "Currency": "TRY",
        "Languages": "tr",
        "HasIntegrationAddress": "zippopotam"
    },
    {
        "Code": "TV",
        "Name": "Tuvalu",
        "Phone": 688,
        "Continent": "Oceania",
        "Capital": "Funafuti",
        "Currency": "AUD",
        "Languages": "en"
    },
    {
        "Code": "UA",
        "Name": "Ucrânia",
        "Phone": 380,
        "Continent": "Europe",
        "Capital": "Kyiv",
        "Currency": "UAH",
        "Languages": "uk"
    },
    {
        "Code": "UG",
        "Name": "Uganda",
        "Phone": 256,
        "Continent": "Africa",
        "Capital": "Kampala",
        "Currency": "UGX",
        "Languages": "en,sw"
    },
    {
        "Code": "UY",
        "Name": "Uruguai",
        "Phone": 598,
        "Continent": "South America",
        "Capital": "Montevideo",
        "Currency": "UYI,UYU",
        "Languages": "es"
    },
    {
        "Code": "UZ",
        "Name": "Usbequistão",
        "Phone": 998,
        "Continent": "Asia",
        "Capital": "Tashkent",
        "Currency": "UZS",
        "Languages": "uz,ru"
    },
    {
        "Code": "VU",
        "Name": "Vanuatu",
        "Phone": 678,
        "Continent": "Oceania",
        "Capital": "Port Vila",
        "Currency": "VUV",
        "Languages": "bi,en,fr"
    },
    {
        "Code": "VE",
        "Name": "Venezuela",
        "Phone": 58,
        "Continent": "South America",
        "Capital": "Caracas",
        "Currency": "VES",
        "Languages": "es"
    },
    {
        "Code": "VN",
        "Name": "Vietname",
        "Phone": 84,
        "Continent": "Asia",
        "Capital": "Hanoi",
        "Currency": "VND",
        "Languages": "vi"
    },
    {
        "Code": "ZM",
        "Name": "Zâmbia",
        "Phone": 260,
        "Continent": "Africa",
        "Capital": "Lusaka",
        "Currency": "ZMW",
        "Languages": "en"
    },
    {
        "Code": "ZW",
        "Name": "Zimbábue",
        "Phone": 263,
        "Continent": "Africa",
        "Capital": "Harare",
        "Currency": "USD,ZAR,BWP,GBP,AUD,CNY,INR,JPY",
        "Languages": "en,sn,nd"
    }
];

class CnetPhoneNumberComponent {
    constructor() {
        this.countries = countries;
        this.phoneNumberControl = new FormControl('', [Validators.required]);
        this.inputLabel = 'Telefone';
        this.country = null;
        // country = '';
        this.subscription = new Subscription();
    }
    get firstCountryCode() { return this._firstCountryCode; }
    ;
    set firstCountryCode(firstCountryCode) {
        this._firstCountryCode = firstCountryCode;
        const countryIndex = this.countries.findIndex(country => country.Phone === this._firstCountryCode);
        if (countryIndex) {
            const country = this.countries.splice(countryIndex, 1);
            this.countries.unshift(country[0]);
        }
    }
    ;
    set phoneCountryCodeControl(control) {
        if (control) {
            this._phoneCountryCodeControl = control;
            const country = countries.find(c => c.Phone === control.value);
            if (country) {
                // this.country = country.Code;
                this.country = country;
            }
        }
        else {
            this._phoneCountryCodeControl = new FormControl(null, [Validators.required]);
        }
    }
    get phoneCountryCodeControl() {
        return this._phoneCountryCodeControl;
    }
    ngOnInit() {
        this.subscribePhoneCountryCodeControl();
    }
    subscribePhoneCountryCodeControl() {
        this.subscription.add(this.phoneCountryCodeControl?.valueChanges.subscribe(countryPhoneCode => {
            const country = countries.find(c => c.Phone === countryPhoneCode);
            if (country) {
                this.country = country;
            }
            else {
                this.phoneNumberControl.reset();
            }
        }));
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    isControlsRequired() {
        return this.phoneCountryCodeControl.hasValidator(Validators.required) || this.phoneNumberControl.hasValidator(Validators.required);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetPhoneNumberComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetPhoneNumberComponent, selector: "cnet-phone-number", inputs: { phoneNumberControl: "phoneNumberControl", firstCountryCode: "firstCountryCode", phoneCountryCodeControl: "phoneCountryCodeControl", filterPlaceHolder: "filterPlaceHolder", inputLabel: "inputLabel" }, ngImport: i0, template: "<cnet-form-field [hasMoreThanOneControl]=\"true\" style=\"height: fit-content;\">\n  <cnet-field-label cnetRequiredMark [show]=\"isControlsRequired()\">\n    {{inputLabel}}\n  </cnet-field-label>\n\n  <cnet-select #select [viewValueTpl]=\"labelTpl\" [formControl]=\"phoneCountryCodeControl\" show-filter\n    [searchAtribute]=\"'Name'\" [filterPlaceHolder]=\"filterPlaceHolder\" id=\"phoneCountryCode\"  [maxHeight]=\"'500px'\" class=\"country-select\">\n\n    <ng-template #labelTpl let-label>\n      <div *ngIf=\"label\">\n        <span class=\"fi\" [class]=\"label.SpecialIcon ? 'fi-'+ label.SpecialIcon :'fi-'+ label.Code.toLowerCase()\"></span>\n        {{label.Name | translate}}\n      </div>\n    </ng-template>\n\n    <cnet-select-option *ngFor=\"let el of countries\" [value]=\"el.Phone\" [viewValue]=\"el\" [template]=\"optionTpl\">\n      <ng-template #optionTpl let-option>\n        <div class=\"element-template\">\n\n          <span *ngIf=\"option\" class=\"fi\"\n            [class]=\"option.SpecialIcon ? 'fi-'+ option.SpecialIcon :'fi-'+ option.Code.toLowerCase()\"></span>\n          {{option.Name | translate}} {{' ' + '(+'+option.Phone+')'}}\n        </div>\n      </ng-template>\n\n    </cnet-select-option>\n  </cnet-select>\n\n  <div style=\"margin-left:8px\">\n    {{ phoneCountryCodeControl?.value ? '+'+phoneCountryCodeControl?.value: '' }}\n  </div>\n\n  <input cnet-input id=\"phoneNumber\" name=\"phoneNumber\" [formControl]=\"phoneNumberControl\" type=\"text\"\n    [cnetPhoneMask]=\"country\" [cnetCountryCode]=\"phoneCountryCodeControl?.value\">\n\n  <cnet-field-error>\n\n    <ng-content></ng-content>\n\n  </cnet-field-error>\n</cnet-form-field>\n", styles: [":host::ng-deep .cnet-select{width:fit-content;border-right:1px solid #e0e0e0;flex:none}:host::ng-deep .cnet-select .cnet-select-content{width:80px;flex:none}.country-select{width:fit-content!important;border-right:solid 1px #e0e0e0!important;flex:none!important}.cdk-overlay-container .cdk-overlay-connected-position-bounding-box .cdk-overlay-pane{width:fit-content!important}.fi-usa-ca{background-image:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"1200\" height=\"600\" viewBox=\"0 0 124800 62400\" fill=\"%23fff\">%0A%09<title>Hybrid flag of Canada and the United States</title>%0A%09<defs>%0A%09%09<pattern patternUnits=\"userSpaceOnUse\" width=\"494\" height=\"420\" id=\"s\">%0A%09%09%09<path fill=\"%23fff\" d=\"m247 90 70.5 217.1-184.6-134.2h228.2L176.5 307.1z\"/>%0A%09%09</pattern>%0A%09</defs>%0A%09<g transform=\"scale(16)\">%0A%09%09<path d=\"m0 0h7800v3900H0z\"/>%0A%09%09<path stroke=\"%23b22234\" stroke-width=\"7800\" stroke-dasharray=\"300\" d=\"m3900 0v3900\"/>%0A%09%09<path fill=\"%233c3b6e\" d=\"m0 0h2964v2100H0z\"/>%0A%09%09<g fill=\"url(%23s)\">%0A%09%09%09<path d=\"m0 0h2964v2100H0z\"/>%0A%09%09%09<path transform=\"translate(247,210)\" d=\"m0 0h2470v1680H0z\"/>%0A%09%09</g>%0A%09</g>%0A%09<g transform=\"scale(13)\">%0A%09%09<path d=\"m7200 1200 1800 1800-1800 1800H2400l-500-400 500-800 1200-600h1200l1192-1196z\"/>%0A%09%09<path fill=\"%23f00\" d=\"m9600 0v4800H7200V1200zM2400 3600v1200H0zm2310 830 45-863a95 95 0 0 0-111-98l-859 151 116-320a65 65 0 0 0-20-73l-281-227 2392-1196a65 65 0 0 0 66 26l542-115-186 572a65 65 0 0 0 34 79l212 99-941 762a65 65 0 0 0-20 73l116 320-859-151a95 95 0 0 0-111 98l45 863z\"/>%0A%09</g>%0A</svg>%0A');background-repeat:no-repeat}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: CnetInputDirective, selector: "cnet-input, [CnetInput], [cnet-input]", inputs: ["id", "required", "disabled", "value", "focused", "errorState"] }, { kind: "component", type: CnetSelectComponent, selector: "cnet-select", inputs: ["placeholder", "filterPlaceHolder", "focused", "multiple", "show-filter", "show-select-all", "show-not-found", "selectAllLabel", "noResultsFoundLabel", "show-tags", "viewValueTpl", "searchAtribute", "maxHeight", "disabled", "showSelectIndicator"], outputs: ["change"], exportAs: ["cnetSelect"] }, { kind: "component", type: CnetSelectOptionComponent, selector: "cnet-select-option", inputs: ["id", "disabled", "hidden", "selected", "viewValue", "value", "template"], outputs: ["idChange"], exportAs: ["cnetSelectOption"] }, { kind: "component", type: CnetFormFieldComponent, selector: "cnet-form-field", inputs: ["hasMoreThanOneControl", "showLabel"], exportAs: ["cnetButton"] }, { kind: "directive", type: CnetFieldErrorDirective, selector: "cnet-field-error, [cnetFieldError], [cnet-field-error]", inputs: ["id"] }, { kind: "directive", type: CnetFieldLabelDirective, selector: "cnet-field-label, [cnetFieldLabel], [cnet-field-label]" }, { kind: "directive", type: i1$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: RequiredMarkDirective, selector: "[cnetRequiredMark]", inputs: ["show"] }, { kind: "directive", type: PhoneNumberMaskDirective, selector: "[cnetPhoneMask]", inputs: ["cnetPhoneMask", "cnetCountryCode"] }, { kind: "pipe", type: i1$3.TranslatePipe, name: "translate" }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetPhoneNumberComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-phone-number', template: "<cnet-form-field [hasMoreThanOneControl]=\"true\" style=\"height: fit-content;\">\n  <cnet-field-label cnetRequiredMark [show]=\"isControlsRequired()\">\n    {{inputLabel}}\n  </cnet-field-label>\n\n  <cnet-select #select [viewValueTpl]=\"labelTpl\" [formControl]=\"phoneCountryCodeControl\" show-filter\n    [searchAtribute]=\"'Name'\" [filterPlaceHolder]=\"filterPlaceHolder\" id=\"phoneCountryCode\"  [maxHeight]=\"'500px'\" class=\"country-select\">\n\n    <ng-template #labelTpl let-label>\n      <div *ngIf=\"label\">\n        <span class=\"fi\" [class]=\"label.SpecialIcon ? 'fi-'+ label.SpecialIcon :'fi-'+ label.Code.toLowerCase()\"></span>\n        {{label.Name | translate}}\n      </div>\n    </ng-template>\n\n    <cnet-select-option *ngFor=\"let el of countries\" [value]=\"el.Phone\" [viewValue]=\"el\" [template]=\"optionTpl\">\n      <ng-template #optionTpl let-option>\n        <div class=\"element-template\">\n\n          <span *ngIf=\"option\" class=\"fi\"\n            [class]=\"option.SpecialIcon ? 'fi-'+ option.SpecialIcon :'fi-'+ option.Code.toLowerCase()\"></span>\n          {{option.Name | translate}} {{' ' + '(+'+option.Phone+')'}}\n        </div>\n      </ng-template>\n\n    </cnet-select-option>\n  </cnet-select>\n\n  <div style=\"margin-left:8px\">\n    {{ phoneCountryCodeControl?.value ? '+'+phoneCountryCodeControl?.value: '' }}\n  </div>\n\n  <input cnet-input id=\"phoneNumber\" name=\"phoneNumber\" [formControl]=\"phoneNumberControl\" type=\"text\"\n    [cnetPhoneMask]=\"country\" [cnetCountryCode]=\"phoneCountryCodeControl?.value\">\n\n  <cnet-field-error>\n\n    <ng-content></ng-content>\n\n  </cnet-field-error>\n</cnet-form-field>\n", styles: [":host::ng-deep .cnet-select{width:fit-content;border-right:1px solid #e0e0e0;flex:none}:host::ng-deep .cnet-select .cnet-select-content{width:80px;flex:none}.country-select{width:fit-content!important;border-right:solid 1px #e0e0e0!important;flex:none!important}.cdk-overlay-container .cdk-overlay-connected-position-bounding-box .cdk-overlay-pane{width:fit-content!important}.fi-usa-ca{background-image:url('data:image/svg+xml,<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"1200\" height=\"600\" viewBox=\"0 0 124800 62400\" fill=\"%23fff\">%0A%09<title>Hybrid flag of Canada and the United States</title>%0A%09<defs>%0A%09%09<pattern patternUnits=\"userSpaceOnUse\" width=\"494\" height=\"420\" id=\"s\">%0A%09%09%09<path fill=\"%23fff\" d=\"m247 90 70.5 217.1-184.6-134.2h228.2L176.5 307.1z\"/>%0A%09%09</pattern>%0A%09</defs>%0A%09<g transform=\"scale(16)\">%0A%09%09<path d=\"m0 0h7800v3900H0z\"/>%0A%09%09<path stroke=\"%23b22234\" stroke-width=\"7800\" stroke-dasharray=\"300\" d=\"m3900 0v3900\"/>%0A%09%09<path fill=\"%233c3b6e\" d=\"m0 0h2964v2100H0z\"/>%0A%09%09<g fill=\"url(%23s)\">%0A%09%09%09<path d=\"m0 0h2964v2100H0z\"/>%0A%09%09%09<path transform=\"translate(247,210)\" d=\"m0 0h2470v1680H0z\"/>%0A%09%09</g>%0A%09</g>%0A%09<g transform=\"scale(13)\">%0A%09%09<path d=\"m7200 1200 1800 1800-1800 1800H2400l-500-400 500-800 1200-600h1200l1192-1196z\"/>%0A%09%09<path fill=\"%23f00\" d=\"m9600 0v4800H7200V1200zM2400 3600v1200H0zm2310 830 45-863a95 95 0 0 0-111-98l-859 151 116-320a65 65 0 0 0-20-73l-281-227 2392-1196a65 65 0 0 0 66 26l542-115-186 572a65 65 0 0 0 34 79l212 99-941 762a65 65 0 0 0-20 73l116 320-859-151a95 95 0 0 0-111 98l45 863z\"/>%0A%09</g>%0A</svg>%0A');background-repeat:no-repeat}\n"] }]
        }], propDecorators: { phoneNumberControl: [{
                type: Input
            }], firstCountryCode: [{
                type: Input
            }], phoneCountryCodeControl: [{
                type: Input
            }], filterPlaceHolder: [{
                type: Input
            }], inputLabel: [{
                type: Input
            }] } });

class PhoneMaskPipe {
    transform(value, zoneCode) {
        // transform(value: number | string, zoneCode: CountryCode): unknown {
        // if (value) {
        //   const stringPhone = value + '';
        //   if (zoneCode && validatePhoneNumberLength(stringPhone, zoneCode) === undefined) {
        //     const phoneNumber = parsePhoneNumber(stringPhone, zoneCode);
        //     if (phoneNumber) {
        //       const formatted = phoneNumber.formatNational();
        //       // const formatted = phoneNumber.formatInternational();
        //       // const formatted = `+${phoneNumber.countryCallingCode} ${phoneNumber.formatNational()}`;
        //       return formatted;
        //     }
        //   } else {
        //     return value;
        //   }
        // }
        return '';
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PhoneMaskPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe }); }
    /** @nocollapse */ static { this.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: PhoneMaskPipe, name: "phoneMask" }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: PhoneMaskPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'phoneMask'
                }]
        }] });

class CnetPhoneNumberModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetPhoneNumberModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetPhoneNumberModule, declarations: [CnetPhoneNumberComponent, PhoneMaskPipe, PhoneNumberMaskDirective], imports: [CommonModule,
            CnetInputModule,
            CnetSelectModule,
            CnetFormFieldModule,
            ReactiveFormsModule,
            TranslateModule,
            NgxMaskDirective,
            NgxMaskPipe,
            RequiredMarkModule], exports: [CnetPhoneNumberComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetPhoneNumberModule, providers: [provideNgxMask()], imports: [CommonModule,
            CnetInputModule,
            CnetSelectModule,
            CnetFormFieldModule,
            ReactiveFormsModule,
            TranslateModule,
            RequiredMarkModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetPhoneNumberModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetPhoneNumberComponent, PhoneMaskPipe, PhoneNumberMaskDirective],
                    exports: [CnetPhoneNumberComponent],
                    imports: [
                        CommonModule,
                        CnetInputModule,
                        CnetSelectModule,
                        CnetFormFieldModule,
                        ReactiveFormsModule,
                        TranslateModule,
                        NgxMaskDirective,
                        NgxMaskPipe,
                        RequiredMarkModule
                    ],
                    providers: [provideNgxMask()]
                }]
        }] });

class CnetProgressDotsComponent {
    constructor() {
        this._size = 10;
    }
    get size() { return this._size; }
    set size(value) {
        this._size = coerceNumberProperty(value);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetProgressDotsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetProgressDotsComponent, selector: "cnet-progress-dots", inputs: { color: "color", size: "size" }, host: { attributes: { "role": "progressbar", "aria-live": "assertive", "aria-busy": "true" }, properties: { "style.height.px": "size", "attr.color": "color" }, classAttribute: "cnet-progress-dots" }, exportAs: ["cnetProgressDots"], ngImport: i0, template: "<i class=\"dot\" [style.width.px]=\"size\" [style.height.px]=\"size\" [style.marginLeft.px]=\"size / 2.5\" [style.marginRight.px]=\"size / 2.5\"></i>\n<i class=\"dot\" [style.width.px]=\"size\" [style.height.px]=\"size\" [style.marginLeft.px]=\"size / 2.5\" [style.marginRight.px]=\"size / 2.5\"></i>\n<i class=\"dot\" [style.width.px]=\"size\" [style.height.px]=\"size\" [style.marginLeft.px]=\"size / 2.5\" [style.marginRight.px]=\"size / 2.5\"></i>\n", styles: [".cnet-progress-dots{display:inline-flex;align-items:center}.cnet-progress-dots[color=primary] .dot{background-color:var(--cnet-primary-500, #82c14f)}.cnet-progress-dots[color=secondary] .dot{background-color:var(--cnet-secondary-500, #3d4155)}.cnet-progress-dots[color=danger] .dot{background-color:var(--cnet-danger-500, #ee4446)}.cnet-progress-dots .dot{background-color:currentColor;border-radius:100%;display:inline-block;animation:sk-bouncedelay 1.4s infinite ease-in-out both}.cnet-progress-dots .dot:nth-child(1){animation-delay:-.32s}.cnet-progress-dots .dot:nth-child(2){animation-delay:-.16s}@keyframes sk-bouncedelay{0%,80%,to{transform:scale(0)}40%{transform:scale(1)}}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetProgressDotsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-progress-dots', exportAs: 'cnetProgressDots', host: {
                        class: 'cnet-progress-dots',
                        role: 'progressbar',
                        'aria-live': 'assertive',
                        'aria-busy': 'true',
                        '[style.height.px]': 'size',
                        '[attr.color]': 'color'
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<i class=\"dot\" [style.width.px]=\"size\" [style.height.px]=\"size\" [style.marginLeft.px]=\"size / 2.5\" [style.marginRight.px]=\"size / 2.5\"></i>\n<i class=\"dot\" [style.width.px]=\"size\" [style.height.px]=\"size\" [style.marginLeft.px]=\"size / 2.5\" [style.marginRight.px]=\"size / 2.5\"></i>\n<i class=\"dot\" [style.width.px]=\"size\" [style.height.px]=\"size\" [style.marginLeft.px]=\"size / 2.5\" [style.marginRight.px]=\"size / 2.5\"></i>\n", styles: [".cnet-progress-dots{display:inline-flex;align-items:center}.cnet-progress-dots[color=primary] .dot{background-color:var(--cnet-primary-500, #82c14f)}.cnet-progress-dots[color=secondary] .dot{background-color:var(--cnet-secondary-500, #3d4155)}.cnet-progress-dots[color=danger] .dot{background-color:var(--cnet-danger-500, #ee4446)}.cnet-progress-dots .dot{background-color:currentColor;border-radius:100%;display:inline-block;animation:sk-bouncedelay 1.4s infinite ease-in-out both}.cnet-progress-dots .dot:nth-child(1){animation-delay:-.32s}.cnet-progress-dots .dot:nth-child(2){animation-delay:-.16s}@keyframes sk-bouncedelay{0%,80%,to{transform:scale(0)}40%{transform:scale(1)}}\n"] }]
        }], propDecorators: { color: [{
                type: Input
            }], size: [{
                type: Input
            }] } });

class CnetProgressSpinnerComponent {
    constructor() {
        this._diameter = 60;
        this._strokeWidth = 4;
        this.mode = 'indeterminate';
    }
    get diameter() { return this._diameter; }
    set diameter(value) {
        this._diameter = coerceNumberProperty(value);
    }
    get strokeWidth() { return this._strokeWidth; }
    set strokeWidth(value) {
        this._strokeWidth = Math.max(1, Math.min(this._diameter / 2, coerceNumberProperty(value)));
    }
    get value() { return this._value; }
    set value(value) {
        this._value = Math.max(0, Math.min(100, coerceNumberProperty(value)));
    }
    get _circleRadius() {
        return (this.diameter - this.strokeWidth) / 2;
    }
    get _circleStrokeWidth() {
        return this.strokeWidth / this.diameter * 100;
    }
    get _strokeCircumference() {
        return 2 * Math.PI * this._circleRadius;
    }
    get _strokeDashOffset() {
        if (this.mode === 'determinate') {
            return this._strokeCircumference * (100 - this.value) / 100;
        }
        else {
            return this._strokeCircumference * 0.25;
        }
    }
    get _viewBox() {
        const viewBox = this._circleRadius * 2 + this.strokeWidth;
        return `0 0 ${viewBox} ${viewBox}`;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetProgressSpinnerComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetProgressSpinnerComponent, selector: "cnet-progress-spinner", inputs: { mode: "mode", color: "color", diameter: "diameter", strokeWidth: "strokeWidth", value: "value" }, host: { attributes: { "role": "progressbar" }, properties: { "attr.mode": "mode", "attr.color": "color", "attr.aria-valuemin": "mode === \"determinate\" ? 0 : null", "attr.aria-valuemax": "mode === \"determinate\" ? 100 : null", "attr.aria-valuenow": "mode === \"determinate\" ? value : null" }, classAttribute: "cnet-progress-spinner" }, exportAs: ["cnetProgressSpinner"], ngImport: i0, template: "<svg\n  [style.width.px]=\"diameter\"\n  [style.height.px]=\"diameter\"\n  [attr.viewBox]=\"_viewBox\"\n  preserveAspectRatio=\"xMidYMid meet\"\n  focusable=\"false\">\n\n  <circle\n    cx=\"50%\"\n    cy=\"50%\"\n    [attr.r]=\"_circleRadius\"\n    [style.stroke-dashoffset.px]=\"_strokeDashOffset\"\n    [style.stroke-dasharray.px]=\"_strokeCircumference\"\n    [style.stroke-width.%]=\"_circleStrokeWidth\"/>\n</svg>\n", styles: [".cnet-progress-spinner{display:inline-flex;overflow:hidden}.cnet-progress-spinner[mode=indeterminate] svg{animation:cnet-spinner-rotate 1.6s linear infinite}.cnet-progress-spinner[mode=indeterminate] circle{animation:cnet-spinner-stroke-offset 1.6s infinite linear}.cnet-progress-spinner[color=primary] circle{stroke:var(--cnet-primary-500, #82c14f)}.cnet-progress-spinner[color=secondary] circle{stroke:var(--cnet-secondary-500, #3d4155)}.cnet-progress-spinner[color=danger] circle{stroke:var(--cnet-danger-500, #ee4446)}.cnet-progress-spinner svg{transform:rotate(-90deg);transform-origin:center;overflow:visible}.cnet-progress-spinner circle{fill:transparent;transition-property:stroke;transform-origin:center;transition:stroke-dashoffset 225ms linear;stroke:currentColor}@keyframes cnet-spinner-rotate{0%{transform:rotate(0)}50%{transform:rotate(260deg)}to{transform:rotate(360deg)}}@keyframes cnet-spinner-stroke-offset{0%{stroke-dashoffset:10%;transform:rotate(0)}50%{stroke-dashoffset:118%;transform:rotate(0)}to{stroke-dashoffset:10%;transform:rotate(0)}}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetProgressSpinnerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-progress-spinner', exportAs: 'cnetProgressSpinner', host: {
                        class: 'cnet-progress-spinner',
                        role: 'progressbar',
                        '[attr.mode]': 'mode',
                        '[attr.color]': 'color',
                        '[attr.aria-valuemin]': 'mode === "determinate" ? 0 : null',
                        '[attr.aria-valuemax]': 'mode === "determinate" ? 100 : null',
                        '[attr.aria-valuenow]': 'mode === "determinate" ? value : null',
                    }, encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<svg\n  [style.width.px]=\"diameter\"\n  [style.height.px]=\"diameter\"\n  [attr.viewBox]=\"_viewBox\"\n  preserveAspectRatio=\"xMidYMid meet\"\n  focusable=\"false\">\n\n  <circle\n    cx=\"50%\"\n    cy=\"50%\"\n    [attr.r]=\"_circleRadius\"\n    [style.stroke-dashoffset.px]=\"_strokeDashOffset\"\n    [style.stroke-dasharray.px]=\"_strokeCircumference\"\n    [style.stroke-width.%]=\"_circleStrokeWidth\"/>\n</svg>\n", styles: [".cnet-progress-spinner{display:inline-flex;overflow:hidden}.cnet-progress-spinner[mode=indeterminate] svg{animation:cnet-spinner-rotate 1.6s linear infinite}.cnet-progress-spinner[mode=indeterminate] circle{animation:cnet-spinner-stroke-offset 1.6s infinite linear}.cnet-progress-spinner[color=primary] circle{stroke:var(--cnet-primary-500, #82c14f)}.cnet-progress-spinner[color=secondary] circle{stroke:var(--cnet-secondary-500, #3d4155)}.cnet-progress-spinner[color=danger] circle{stroke:var(--cnet-danger-500, #ee4446)}.cnet-progress-spinner svg{transform:rotate(-90deg);transform-origin:center;overflow:visible}.cnet-progress-spinner circle{fill:transparent;transition-property:stroke;transform-origin:center;transition:stroke-dashoffset 225ms linear;stroke:currentColor}@keyframes cnet-spinner-rotate{0%{transform:rotate(0)}50%{transform:rotate(260deg)}to{transform:rotate(360deg)}}@keyframes cnet-spinner-stroke-offset{0%{stroke-dashoffset:10%;transform:rotate(0)}50%{stroke-dashoffset:118%;transform:rotate(0)}to{stroke-dashoffset:10%;transform:rotate(0)}}\n"] }]
        }], propDecorators: { mode: [{
                type: Input
            }], color: [{
                type: Input
            }], diameter: [{
                type: Input
            }], strokeWidth: [{
                type: Input
            }], value: [{
                type: Input
            }] } });

class ProgressBarComponent {
    constructor() {
        this.mode = 'indeterminate';
        this.color = input('primary');
        this.value = input(0);
        this.trueValue = computed(() => Math.max(0, Math.min(100, coerceNumberProperty(this.value()))));
        this.percent = computed(() => Math.round(+this.trueValue() * 100) / 100);
        this.width = computed(() => this.percent() ? (this.percent() + '%') : '100%');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ProgressBarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.1.0", version: "17.3.12", type: ProgressBarComponent, isStandalone: true, selector: "cnet-progress-bar", inputs: { color: { classPropertyName: "color", publicName: "color", isSignal: true, isRequired: false, transformFunction: null }, value: { classPropertyName: "value", publicName: "value", isSignal: true, isRequired: false, transformFunction: null } }, host: { attributes: { "role": "progressbar" }, properties: { "attr.mode": "mode", "attr.color": "color()", "attr.aria-valuemin": "mode === \"determinate\" ? 0 : null", "attr.aria-valuemax": "mode === \"determinate\" ? 100 : null", "attr.aria-valuenow": "mode === \"determinate\" ? value : null" }, classAttribute: "cnet-progress-bar" }, exportAs: ["cnetProgressBarComponent"], ngImport: i0, template: "<div class=\"progress-outer\">\n  <div class=\"progress-inner\" [class.loading]=\"!percent()\" [style.width]=\"width()\">\n  </div>\n</div>\n", styles: [".cnet-progress-bar[color=primary] .progress-inner{background-color:var(--cnet-primary-500, #82c14f)}.cnet-progress-bar[color=secondary] .progress-inner{background-color:var(--cnet-secondary-500, #3d4155)}.cnet-progress-bar[color=danger] .progress-inner,.cnet-progress-bar[color=success] .progress-inner{background-color:var(--cnet-danger-500, #ee4446)}.cnet-progress-bar .progress-outer{width:100%;margin:10px 0;background-color:#f4f4f4;border:1px solid #dcdcdc;color:#fff;text-align:center;overflow:hidden}.cnet-progress-bar .progress-inner{height:5px;white-space:nowrap;overflow:hidden;padding:0}.loading{width:100%;animation:indeterminateAnimation 1s infinite linear;transform-origin:0% 50%}@keyframes indeterminateAnimation{0%{transform:translate(0) scaleX(0)}40%{transform:translate(0) scaleX(.4)}to{transform:translate(100%) scaleX(.5)}}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ProgressBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-progress-bar', exportAs: 'cnetProgressBarComponent', host: {
                        class: 'cnet-progress-bar',
                        role: 'progressbar',
                        '[attr.mode]': 'mode',
                        '[attr.color]': 'color()',
                        '[attr.aria-valuemin]': 'mode === "determinate" ? 0 : null',
                        '[attr.aria-valuemax]': 'mode === "determinate" ? 100 : null',
                        '[attr.aria-valuenow]': 'mode === "determinate" ? value : null',
                    }, standalone: true, imports: [], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<div class=\"progress-outer\">\n  <div class=\"progress-inner\" [class.loading]=\"!percent()\" [style.width]=\"width()\">\n  </div>\n</div>\n", styles: [".cnet-progress-bar[color=primary] .progress-inner{background-color:var(--cnet-primary-500, #82c14f)}.cnet-progress-bar[color=secondary] .progress-inner{background-color:var(--cnet-secondary-500, #3d4155)}.cnet-progress-bar[color=danger] .progress-inner,.cnet-progress-bar[color=success] .progress-inner{background-color:var(--cnet-danger-500, #ee4446)}.cnet-progress-bar .progress-outer{width:100%;margin:10px 0;background-color:#f4f4f4;border:1px solid #dcdcdc;color:#fff;text-align:center;overflow:hidden}.cnet-progress-bar .progress-inner{height:5px;white-space:nowrap;overflow:hidden;padding:0}.loading{width:100%;animation:indeterminateAnimation 1s infinite linear;transform-origin:0% 50%}@keyframes indeterminateAnimation{0%{transform:translate(0) scaleX(0)}40%{transform:translate(0) scaleX(.4)}to{transform:translate(100%) scaleX(.5)}}\n"] }]
        }] });

class CnetProgressModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetProgressModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetProgressModule, declarations: [CnetProgressSpinnerComponent,
            CnetProgressDotsComponent], imports: [CommonModule,
            ProgressBarComponent], exports: [CnetProgressSpinnerComponent,
            CnetProgressDotsComponent,
            ProgressBarComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetProgressModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetProgressModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnetProgressSpinnerComponent,
                        CnetProgressDotsComponent,
                    ],
                    imports: [
                        CommonModule,
                        ProgressBarComponent
                    ],
                    exports: [
                        CnetProgressSpinnerComponent,
                        CnetProgressDotsComponent,
                        ProgressBarComponent
                    ],
                }]
        }] });

class ScrollToTopComponent {
    constructor() {
        this.topPosToStartShowing = 0;
        this.document = inject(DOCUMENT);
        this.viewport = inject(ViewportScroller);
        this._destroyed = new Subject();
        this.color = 'primary';
        this._anchor = null;
        this.showScroll$ = fromEvent(this.document, 'scroll').pipe(takeUntil$1(this._destroyed), map$1(() => this.viewport.getScrollPosition()?.[1] > this.topPosToStartShowing));
        this.scrollToTop = new EventEmitter();
    }
    set anchor(anchor) {
        this._anchor = anchor;
        if (anchor) {
            this.topPosToStartShowing = this.anchor.offsetTop;
        }
    }
    get anchor() { return this._anchor; }
    onScrollToTop() {
        if (this.anchor) {
            window.scrollTo({ top: this.topPosToStartShowing - 5, left: 0, behavior: "smooth" });
            // this.viewport.scrollToPosition([0, this.anchor.offsetTop]);
        }
        else {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }
    }
    ngOnDestroy() {
        this._destroyed.next();
        this._destroyed.complete();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ScrollToTopComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ScrollToTopComponent, isStandalone: true, selector: "cnet-scroll-to-top", inputs: { topPosToStartShowing: "topPosToStartShowing", color: "color", anchor: "anchor" }, outputs: { scrollToTop: "scrollToTop" }, host: { classAttribute: "cnet-scroll-to-top" }, ngImport: i0, template: "<button cnet-button [color]=\"color\" (click)=\"onScrollToTop()\" *ngIf=\"showScroll$ | async\">\n  <cnet-icon  [color]=\"color\" label=\"Deletar\" name=\"angle-up\"></cnet-icon>\n</button>\n", styles: [":host{position:fixed;float:right;cursor:pointer;right:14px;bottom:14px;z-index:100;opacity:.75;scroll-behavior:smooth}:host button{background-color:#fff;border-radius:50%;height:50px;width:50px;padding:0;box-shadow:0 2px 4px 1px #00000040;border:none;min-width:auto}html{scroll-behavior:smooth}:host:hover{opacity:1}.scroll-icon{display:flex;justify-content:center;align-items:center}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "ngmodule", type: CnetIconModule }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "ngmodule", type: CnetButtonModule }, { kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ScrollToTopComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-scroll-to-top', standalone: true, imports: [CommonModule, CnetIconModule, CnetButtonModule], host: {
                        class: 'cnet-scroll-to-top'
                    }, template: "<button cnet-button [color]=\"color\" (click)=\"onScrollToTop()\" *ngIf=\"showScroll$ | async\">\n  <cnet-icon  [color]=\"color\" label=\"Deletar\" name=\"angle-up\"></cnet-icon>\n</button>\n", styles: [":host{position:fixed;float:right;cursor:pointer;right:14px;bottom:14px;z-index:100;opacity:.75;scroll-behavior:smooth}:host button{background-color:#fff;border-radius:50%;height:50px;width:50px;padding:0;box-shadow:0 2px 4px 1px #00000040;border:none;min-width:auto}html{scroll-behavior:smooth}:host:hover{opacity:1}.scroll-icon{display:flex;justify-content:center;align-items:center}\n"] }]
        }], propDecorators: { topPosToStartShowing: [{
                type: Input
            }], color: [{
                type: Input
            }], anchor: [{
                type: Input
            }], scrollToTop: [{
                type: Output
            }] } });

const sidenavAnimation = trigger('sidenavAnimation', [
    state('enter', style({ transform: 'translateX(0)', opacity: 1, width: '100%' })),
    state('void', style({ transform: `translateX({{shift}})`, opacity: 0 }), { params: { shift: '-32px' } }),
    transition('* => void', animate('200ms ease-out')),
    transition('void => *', [style({ opacity: 0 }), animate('200ms')]),
]);

/**
 * Cnet Sidenav is a component created to facilitate the creation of sidenavs
 *
 * @export
 * class CnetSidenavComponent
 * implements {OnInit}
 */
class CnetSidenavComponent {
    /**
    * Whether the sidenav will be closed when clicking on the backdrop
    *
    * type {boolean}
    * @memberof CnetSidenavComponent
    */
    get backdropClose() { return this._backdropClose; }
    set backdropClose(value) { this._backdropClose = coerceBooleanProperty(value); }
    get animationStartPosition() {
        return this._animationStartPosition;
    }
    set animationStartPosition(pos) {
        if (pos) {
            this._animationStartPosition = pos;
            this._shift = this._animationStartPosition === 'left' ? '-32px' : '32';
        }
        else {
            this._animationStartPosition = 'left';
        }
    }
    constructor(overlay, cdr) {
        this.overlay = overlay;
        this.cdr = cdr;
        /** @ignore */ this._backdropClose = false;
        /** @ignore */ this.animationState = 'void';
        /**
         * Stream that emits the visibility of the sidenav.
         *
         * type {BehaviorSubject<boolean>}
         * @memberof CnetSidenavComponent
         */
        this.visibleStream = new BehaviorSubject(false);
        this.hasBackdrop = true;
        this.width = '100%';
        this.opened = false;
    }
    /** @ignore */
    getOverlayConfig() {
        let positionStrategy = null;
        if (this.elementRef) {
            positionStrategy = this.overlay.position().flexibleConnectedTo(this.elementRef)
                .withPositions([
                {
                    originX: 'start',
                    originY: 'bottom',
                    overlayX: 'start',
                    overlayY: 'top'
                }
            ]).withPush(false);
        }
        else {
            this.overlay.position().global();
        }
        // const scrollStrategy = this.overlay.scrollStrategies.noop();
        const scrollStrategy = this.overlay.scrollStrategies.block();
        return new OverlayConfig({
            positionStrategy,
            scrollStrategy,
            hasBackdrop: this.hasBackdrop,
            height: '100%',
            width: this.width,
        });
    }
    /**
     * Displays the sidenav content
     *
     * @memberof CnetSidenavComponent
     */
    show() {
        this.opened = true;
        this._overlayRef = this.overlay.create(this.getOverlayConfig());
        this._overlayRef.attach(this._contentTemplate);
        if (this._backdropClose) {
            this._overlayRef.backdropClick().subscribe(() => this.hide());
        }
        this.animationState = 'enter';
        this.visibleStream.next(true);
    }
    /**
     * Hides sidenav content
     *
     * @memberof CnetSidenavComponent
     */
    hide() {
        this.opened = false;
        this.animationState = 'void';
        this.cdr.detectChanges();
    }
    /** @ignore */
    _onAnimationDone(event) {
        if (event.fromState === 'enter' && event.toState === 'void') {
            this._overlayRef.detach();
            this.visibleStream.next(false);
        }
    }
    onResize() {
        this.hide();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSidenavComponent, deps: [{ token: i1$5.Overlay }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetSidenavComponent, selector: "cnet-sidenav", inputs: { backdropClose: ["backdrop-close", "backdropClose"], elementRef: "elementRef", hasBackdrop: "hasBackdrop", width: "width", animationStartPosition: "animationStartPosition" }, host: { attributes: { "role": "dialog" }, listeners: { "window:resize": "onResize()" }, classAttribute: "cnet-sidenav" }, viewQueries: [{ propertyName: "_contentTemplate", first: true, predicate: CdkPortal, descendants: true }], exportAs: ["cnetSidenav"], ngImport: i0, template: "<ng-template cdk-portal>\n  <div [@sidenavAnimation]=\"{value:animationState, params:{shift: _shift}}\" (@sidenavAnimation.done)=\"_onAnimationDone($event)\" >\n    <div cdkTrapFocus style=\"height: 100%; width: 100%;\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i2.TemplatePortalDirective, selector: "[cdk-portal], [portal]", exportAs: ["cdkPortal"] }, { kind: "directive", type: i1$2.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }], animations: [sidenavAnimation], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSidenavComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-sidenav', exportAs: 'cnetSidenav', host: {
                        class: 'cnet-sidenav',
                        role: 'dialog'
                    }, encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, animations: [sidenavAnimation], template: "<ng-template cdk-portal>\n  <div [@sidenavAnimation]=\"{value:animationState, params:{shift: _shift}}\" (@sidenavAnimation.done)=\"_onAnimationDone($event)\" >\n    <div cdkTrapFocus style=\"height: 100%; width: 100%;\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</ng-template>\n" }]
        }], ctorParameters: () => [{ type: i1$5.Overlay }, { type: i0.ChangeDetectorRef }], propDecorators: { _contentTemplate: [{
                type: ViewChild,
                args: [CdkPortal]
            }], backdropClose: [{
                type: Input,
                args: ['backdrop-close']
            }], elementRef: [{
                type: Input
            }], hasBackdrop: [{
                type: Input
            }], width: [{
                type: Input
            }], animationStartPosition: [{
                type: Input
            }], onResize: [{
                type: HostListener,
                args: ['window:resize']
            }] } });

/**
 * Directive to create elements to close the cnet-sidenav
 *
 * @export
 * class CnetSidenavCloseDirective
 */
class CnetSidenavCloseDirective {
    constructor(_sidenavComponent) {
        this._sidenavComponent = _sidenavComponent;
    }
    /**
     * Hides the modal
     *
     * @memberof CnetModalCloseDirective
     */
    hideModal() {
        this._sidenavComponent.hide();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSidenavCloseDirective, deps: [{ token: CnetSidenavComponent, optional: true }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetSidenavCloseDirective, selector: "[CnetSidenavClose], [cnet-sidenav-close]", host: { listeners: { "click": "hideModal()" } }, exportAs: ["cnetSidenavClose"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSidenavCloseDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[CnetSidenavClose], [cnet-sidenav-close]',
                    exportAs: 'cnetSidenavClose'
                }]
        }], ctorParameters: () => [{ type: CnetSidenavComponent, decorators: [{
                    type: Optional
                }] }], propDecorators: { hideModal: [{
                type: HostListener,
                args: ['click']
            }] } });

/**
 * Directive to create trigger elements to open the cnet-sidenav
 *
 * @export
 * class CnetSidenavTriggerDirective
 */
class CnetSidenavTriggerDirective {
    /**
     * The cnet-sidenav instance
     *
     * type {CnetSidenavComponent}
     * @memberof CnetSidenavTriggerDirective
     */
    get sidenav() { return this.sidenav; }
    set sidenav(value) {
        this._sidenav = value;
    }
    /**
     * Creates the cnet-sidenav panel connected to this element
     *
     * @memberof CnetSidenavTriggerDirective
     */
    showSidenav() {
        if (!this._sidenav.opened) {
            this._sidenav.show();
        }
        else {
            this._sidenav.hide();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSidenavTriggerDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetSidenavTriggerDirective, selector: "[CnetSidenavTrigger], [cnet-sidenav-trigger]", inputs: { sidenav: ["cnet-sidenav-trigger", "sidenav"] }, host: { listeners: { "click": "showSidenav($event)" } }, exportAs: ["cnetSidenavTrigger"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSidenavTriggerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[CnetSidenavTrigger], [cnet-sidenav-trigger]',
                    exportAs: 'cnetSidenavTrigger'
                }]
        }], propDecorators: { sidenav: [{
                type: Input,
                args: ['cnet-sidenav-trigger']
            }], showSidenav: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class CnetSidenavModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSidenavModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetSidenavModule, declarations: [CnetSidenavComponent,
            CnetSidenavTriggerDirective,
            CnetSidenavCloseDirective], imports: [CommonModule,
            OverlayModule,
            PortalModule,
            A11yModule], exports: [CnetSidenavComponent,
            CnetSidenavTriggerDirective,
            CnetSidenavCloseDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSidenavModule, imports: [CommonModule,
            OverlayModule,
            PortalModule,
            A11yModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSidenavModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnetSidenavComponent,
                        CnetSidenavTriggerDirective,
                        CnetSidenavCloseDirective
                    ],
                    imports: [
                        CommonModule,
                        OverlayModule,
                        PortalModule,
                        A11yModule
                    ],
                    exports: [
                        CnetSidenavComponent,
                        CnetSidenavTriggerDirective,
                        CnetSidenavCloseDirective,
                    ]
                }]
        }] });

class SimpleDynamicFormService {
    constructor(questionControlService) {
        this.questionControlService = questionControlService;
        this.questions = [];
        this.form = new UntypedFormGroup({});
        this.form$ = new Subject();
    }
    updateQuestions(questions) {
        this.questions = questions;
        if (questions && questions.length) {
            this.form = this.questionControlService.toFormGroup(this.questions);
            this.form$.next(this.form);
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SimpleDynamicFormService, deps: [{ token: QuestionControlService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SimpleDynamicFormService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: SimpleDynamicFormService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: QuestionControlService }] });

class CnetSimpleDynamicFormComponent {
    get questions() {
        return this._questions;
    }
    ;
    set questions(questions) {
        this._questions = questions;
        this.simpleDynamicFormService.updateQuestions(questions);
    }
    ;
    /** disable form */
    get disableForm() { return this._disableForm; }
    set disableForm(value) {
        this._disableForm = value;
        if (this.form) {
            if (value) {
                this.form.disable();
            }
            else {
                this.form.enable();
            }
        }
    }
    get form() {
        return this.simpleDynamicFormService.form;
    }
    constructor(simpleDynamicFormService) {
        this.simpleDynamicFormService = simpleDynamicFormService;
        this._questions = [];
        /** @ignore */ this._disableForm = false;
        this.changeForm = new EventEmitter();
        this.formObservable$ = this.simpleDynamicFormService.form$.subscribe(form => {
            this.changeForm.emit(form);
        });
    }
    ngOnInit() {
    }
    ngAfterContentInit() {
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSimpleDynamicFormComponent, deps: [{ token: SimpleDynamicFormService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetSimpleDynamicFormComponent, selector: "cnet-simple-dynamic-form", inputs: { questions: "questions", disableForm: "disableForm" }, outputs: { changeForm: "changeForm" }, host: { classAttribute: "cnet-simple-dynamic-form" }, exportAs: ["cnetSimpleDynamicForm"], ngImport: i0, template: "<form [formGroup]=\"form\">\n  <div class=\"dynamic-form-container\">\n\n    <ng-content></ng-content>\n\n  </div>\n\n</form>\n", styles: [""], dependencies: [{ kind: "directive", type: i1$4.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSimpleDynamicFormComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-simple-dynamic-form', exportAs: 'cnetSimpleDynamicForm', host: {
                        class: 'cnet-simple-dynamic-form'
                    }, template: "<form [formGroup]=\"form\">\n  <div class=\"dynamic-form-container\">\n\n    <ng-content></ng-content>\n\n  </div>\n\n</form>\n" }]
        }], ctorParameters: () => [{ type: SimpleDynamicFormService }], propDecorators: { questions: [{
                type: Input
            }], disableForm: [{
                type: Input
            }], changeForm: [{
                type: Output
            }] } });

class CnetSimpleFormQuestionComponent {
    get form() {
        return this.simpleDynamicFormService.form;
    }
    ;
    get isValid() { return this.form?.controls[this.question?.code]?.valid; }
    get isDirty() { return this.form?.controls[this.question?.code]?.dirty; }
    get isDisabled() { return this.form?.controls[this.question?.code]?.disabled; }
    constructor(simpleDynamicFormService) {
        this.simpleDynamicFormService = simpleDynamicFormService;
        this.showQuetionStatement = true;
        this.onUpload = new EventEmitter();
        this.onRemoveFileFromAnswer = new EventEmitter();
        this.enumQuestionType = enumQuestionTypeCode;
    }
    ngOnInit() {
        if (this.question?.questionTypeCode === enumQuestionTypeCode.MultiSelect || this.question?.questionTypeCode === enumQuestionTypeCode.SingleSelect || this.question?.questionTypeCode === enumQuestionTypeCode.Slider) {
            if (!this.question['optionValue']) {
                this.question['optionValue'] = enumArrayOptionDefault.text;
            }
            if (!this.question['optionLabel']) {
                this.question['optionLabel'] = enumArrayOptionDefault.text;
            }
        }
    }
    onUploadFile(files) {
        this.onUpload.emit({ questionCode: this.question.code, files: files });
    }
    onRemoveFile(file) {
        this.onRemoveFileFromAnswer.emit({ questionCode: this.question.code, file: file });
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSimpleFormQuestionComponent, deps: [{ token: SimpleDynamicFormService }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetSimpleFormQuestionComponent, selector: "cnet-simple-form-question", inputs: { question: "question", form: "form", showQuetionStatement: "showQuetionStatement" }, outputs: { onUpload: "onUpload", onRemoveFileFromAnswer: "onRemoveFileFromAnswer" }, host: { classAttribute: "cnet-simple-form-question" }, exportAs: ["cnetSimpleFormQuestion"], ngImport: i0, template: "<div class=\"dynamic-question-container\">\n\n  <div [ngSwitch]=\"question?.questionTypeCode\">\n\n    <ng-template #translateStatementTpl>\n      {{question?.statement | translate}}\n    </ng-template>\n\n    <form [formGroup]=\"form\" *ngIf=\"form\">\n\n      <div *ngSwitchCase=\"enumQuestionType.Descriptive\">\n\n        <cnet-form-field>\n\n          <cnet-field-label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"showQuetionStatement\">\n\n            <ng-container *ngIf=\"!question.translateStatement; else translateStatementTpl\">\n              {{question?.statement }}\n            </ng-container>\n\n          </cnet-field-label>\n\n          <textarea cnet-input [formControlName]=\"question?.code\" [id]=\"question?.code\" wrap=\"hard\"\n            [maxlength]=\"question['maxLength']\"></textarea>\n\n        </cnet-form-field>\n\n        <cnet-field-description>\n          <div class=\"carcter-counting\">\n            {{form.value[question?.code].length}} {{'caracteres' | translate}}\n          </div>\n        </cnet-field-description>\n      </div>\n\n      <div *ngSwitchCase=\"enumQuestionType.Text\">\n        <cnet-form-field>\n          <cnet-field-label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"showQuetionStatement\">\n            <ng-container *ngIf=\"!question.translateStatement; else translateStatementTpl\">\n              {{question?.statement }}\n            </ng-container>\n          </cnet-field-label>\n          <input cnet-input [formControlName]=\"question?.code\" [id]=\"question?.code\" wrap=\"hard\"\n            [maxlength]=\"question['maxLength']\">\n        </cnet-form-field>\n      </div>\n\n      <div *ngSwitchCase=\"enumQuestionType.Number\">\n        <cnet-form-field>\n          <cnet-field-label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"showQuetionStatement\">\n            <ng-container *ngIf=\"!question.translateStatement; else translateStatementTpl\">\n              {{question?.statement }}\n            </ng-container>\n          </cnet-field-label>\n          <input cnet-input [formControlName]=\"question?.code\" type=\"number\" inputmode=\"numeric\"\n            [min]=\"question['minValue']\" [max]=\"question['maxValue']\" [step]=\"question['step']\" />\n        </cnet-form-field>\n      </div>\n\n      <div *ngSwitchCase=\"enumQuestionType.InputSwitch\">\n        <cnet-form-field>\n          <cnet-field-label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"showQuetionStatement\">\n            <ng-container *ngIf=\"!question.translateStatement; else translateStatementTpl\">\n              {{question?.statement }}\n            </ng-container>\n          </cnet-field-label>\n          <cnet-input-switch [formControlName]=\"question?.code\" [color]=\"question['color']\"></cnet-input-switch>\n        </cnet-form-field>\n      </div>\n\n      <ng-container *ngSwitchCase=\"enumQuestionType.SingleSelect\">\n\n        <label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"showQuetionStatement\">\n          <ng-container *ngIf=\"!question.translateStatement; else translateStatementTpl\">\n            {{question?.statement }}\n          </ng-container>\n        </label>\n\n        <cnet-radio-group [formControlName]=\"question?.code\" aria-labelledby=\"group-label\" [color]=\"question['color']\"\n          [id]=\"question?.code\">\n          <cnet-radio *ngFor=\"let item of question['options'];\" [value]=\"item[question['optionValue']]\">\n            <div class=\"select-label\">\n              <ng-container *ngIf=\"!question['translateOption']; else translateSingleSelectOption\">\n                {{ item[question['optionLabel']]}}\n              </ng-container>\n              <ng-template #translateSingleSelectOption>\n                {{ item[question['optionLabel']] | translate}}\n              </ng-template>\n            </div>\n          </cnet-radio>\n        </cnet-radio-group>\n\n      </ng-container>\n\n\n      <ng-container *ngSwitchCase=\"enumQuestionType.MultiSelect\">\n\n        <label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"showQuetionStatement\">\n          <ng-container *ngIf=\"!question.translateStatement; else translateStatementTpl\">\n            {{question?.statement }}\n          </ng-container>\n        </label>\n\n        <cnet-checkbox-group [formControlName]=\"question?.code\" aria-labelledby=\"group-label\"\n          [color]=\"question['color']\" [id]=\"question?.code\">\n          <cnet-checkbox *ngFor=\"let item of question['options']; let i = index \"\n            [value]=\"item[question['optionValue']]\">\n            <div class=\"select-label\">\n              <ng-container *ngIf=\"!question['translateOption']; else translateMultiSelectOption\">\n                {{ item[question['optionLabel']]}}\n              </ng-container>\n              <ng-template #translateMultiSelectOption>\n                {{ item[question['optionLabel']] | translate}}\n              </ng-template>\n            </div>\n          </cnet-checkbox>\n        </cnet-checkbox-group>\n      </ng-container>\n\n      <ng-container *ngSwitchCase=\"enumQuestionType.Slider\">\n\n        <label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"showQuetionStatement\">\n          <ng-container *ngIf=\"!question.translateStatement; else translateStatementTpl\">\n            {{question?.statement }}\n          </ng-container>\n        </label>\n\n        <cnet-slider-old [id]=\"question?.code\" [formControlName]=\"question?.code\"\n          [steps]=\"question['options']\"></cnet-slider-old>\n      </ng-container>\n\n      <ng-container *ngSwitchCase=\"enumQuestionType.Attachment\">\n\n        <label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"showQuetionStatement\">\n          <ng-container *ngIf=\"!question.translateStatement; else translateStatementTpl\">\n            {{question?.statement }}\n          </ng-container>\n        </label>\n\n        <cnet-file-upload [formControl]=\"form.controls[question?.code]\" [attachmentUri]=\"question['attachmentUri']\"\n          [id]=\"question?.code\" [maxFileSize]=\"5\" (onUpload)=\"onUploadFile($event)\"\n          (onRemoveFile)=\"onRemoveFile($event)\">\n        </cnet-file-upload>\n      </ng-container>\n\n      <label class=\"cnet-field-error\"\n        [class.error-text-field]=\"question?.questionTypeCode === enumQuestionType.Descriptive\"\n        *ngIf=\"isDirty && !isValid && !isDisabled && form.controls[question?.code].hasError('min')\">\n\n\n        <ng-container *ngIf=\"!question['translateStatement']; else minErrorStatementTranslatedTpl\">\n          {{'O campo {0} deve conter no m\u00EDnimo de {1} caracteres.' |translate:{'0':question['statement'] | translate,\n          '1':question['minValue']} }}\n\n        </ng-container>\n        <ng-template #minErrorStatementTranslatedTpl>\n          {{'O campo {0} deve conter no m\u00EDnimo de {1} caracteres.' |translate:{'0':question['statement'] | translate,\n          '1':question['minValue']} }}\n        </ng-template>\n\n\n\n      </label>\n      <label class=\"cnet-field-error\"\n        [class.error-text-field]=\"question?.questionTypeCode === enumQuestionType.Descriptive\"\n        *ngIf=\"isDirty && !isValid && !isDisabled && form.controls[question?.code].hasError('max')\">\n\n\n        <ng-container *ngIf=\"!question['translateStatement']; else maxErrorStatementTranslatedTpl\">\n          {{'O campo {0} deve conter no m\u00E1ximo de {1} caracteres.' |translate:{'0':question['statement'],\n          '1':question['maxValue']} }}\n\n        </ng-container>\n        <ng-template #maxErrorStatementTranslatedTpl>\n          {{'O campo {0} deve conter no m\u00E1ximo de {1} caracteres.' |translate:{'0':question['statement'] | translate,\n          '1':question['maxValue']} }}\n        </ng-template>\n\n\n      </label>\n      <label class=\"cnet-field-error\"\n        [class.error-text-field]=\"question?.questionTypeCode === enumQuestionType.Descriptive\"\n        *ngIf=\"isDirty && !isValid && !isDisabled && form.controls[question?.code].hasError('required')\">\n\n        <ng-container *ngIf=\"!question['translateStatement']; else requiredErrorStatementTranslatedTpl\">\n          {{'O campo {0} \u00E9 obrigat\u00F3rio.' |translate:{'0':question?.statement} }}\n        </ng-container>\n        <ng-template #requiredErrorStatementTranslatedTpl>\n          {{'O campo {0} \u00E9 obrigat\u00F3rio.' |translate:{'0':question?.statement | translate} }}\n        </ng-template>\n\n\n      </label>\n    </form>\n\n    <ng-content\n      select=\"cnet-container-external-template, [cnet-container-external-template], [ContainerExternalTemplateComponent]\">\n    </ng-content>\n\n\n  </div>\n\n</div>\n", styles: [".carcter-counting{width:100%;display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:right}.cnet-checkbox-group,.cnet-radio-group{flex-direction:column;margin-bottom:1.5rem}.cnet-radio-group cnet-radio.label.cnet-radio-label{font-weight:700}.cnet-field-error{color:var(--cnet-danger-500, #ee4446);font-weight:400;margin-bottom:1rem}.cnet-field-error.error-text-field{margin-top:-20px}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "directive", type: i1$4.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i1$4.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$4.NumberValueAccessor, selector: "input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]" }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i1$4.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i1$4.MinValidator, selector: "input[type=number][min][formControlName],input[type=number][min][formControl],input[type=number][min][ngModel]", inputs: ["min"] }, { kind: "directive", type: i1$4.MaxValidator, selector: "input[type=number][max][formControlName],input[type=number][max][formControl],input[type=number][max][ngModel]", inputs: ["max"] }, { kind: "directive", type: i1$4.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i1$4.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { kind: "component", type: CnetFormFieldComponent, selector: "cnet-form-field", inputs: ["hasMoreThanOneControl", "showLabel"], exportAs: ["cnetButton"] }, { kind: "directive", type: CnetFieldDescriptionDirective, selector: "cnet-field-description, [cnetFieldDescription], [cnet-field-description]" }, { kind: "directive", type: CnetFieldLabelDirective, selector: "cnet-field-label, [cnetFieldLabel], [cnet-field-label]" }, { kind: "directive", type: RequiredMarkDirective, selector: "[cnetRequiredMark]", inputs: ["show"] }, { kind: "component", type: CnetRadioComponent, selector: "cnet-radio", inputs: ["id", "name", "checked", "value", "disabled", "enableUncheck"], outputs: ["change", "blur", "focus"], exportAs: ["cnetRadio"] }, { kind: "component", type: CnetRadioGroupComponent, selector: "cnet-radio-group", inputs: ["id", "name", "value", "disabled", "color"], exportAs: ["cnetRadioGroup"] }, { kind: "directive", type: CnetInputDirective, selector: "cnet-input, [CnetInput], [cnet-input]", inputs: ["id", "required", "disabled", "value", "focused", "errorState"] }, { kind: "component", type: CnetCheckboxComponent, selector: "cnet-checkbox", inputs: ["id", "name", "checked", "value", "disabled", "color", "enableRiple"], outputs: ["change", "blur", "focus"], exportAs: ["cnetCheckbox"] }, { kind: "component", type: CnetCheckboxGroupComponent, selector: "cnet-checkbox-group", inputs: ["id", "name", "value", "disabled", "color"], exportAs: ["cnetCheckboxGroup"] }, { kind: "component", type: CnetSliderOldComponent, selector: "cnet-slider-old", inputs: ["value", "id", "focused", "disabled", "steps"] }, { kind: "component", type: CnetFileUploadComponent, selector: "cnet-file-upload", inputs: ["progress", "multiple", "maxFileSize", "attachmentUri", "accept", "sizeFileErrorMessage", "typeFileErrorMessage", "multipleFilesErrorMessage", "pickFileButtonLabel", "dropFileLabel", "noFilesLabel", "deleteFileButtonLabel", "visualizeFileButtonLabel", "showVisualizeBtn", "value"], outputs: ["onUpload", "onRemoveFile"] }, { kind: "component", type: CnetInputSwitchComponent, selector: "cnet-input-switch", inputs: ["value", "checked", "disabled", "color"], exportAs: ["cnetInputSwitch"] }, { kind: "directive", type: CnetInputForInputSwitchDirective, selector: "cnet-input-switch, [cneInputSwitch], [cnet-input-switch]", inputs: ["id", "required", "disabled", "value", "focused", "errorState"] }, { kind: "pipe", type: i1$3.TranslatePipe, name: "translate" }], encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSimpleFormQuestionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-simple-form-question', exportAs: 'cnetSimpleFormQuestion', host: {
                        class: 'cnet-simple-form-question'
                    }, encapsulation: ViewEncapsulation.None, template: "<div class=\"dynamic-question-container\">\n\n  <div [ngSwitch]=\"question?.questionTypeCode\">\n\n    <ng-template #translateStatementTpl>\n      {{question?.statement | translate}}\n    </ng-template>\n\n    <form [formGroup]=\"form\" *ngIf=\"form\">\n\n      <div *ngSwitchCase=\"enumQuestionType.Descriptive\">\n\n        <cnet-form-field>\n\n          <cnet-field-label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"showQuetionStatement\">\n\n            <ng-container *ngIf=\"!question.translateStatement; else translateStatementTpl\">\n              {{question?.statement }}\n            </ng-container>\n\n          </cnet-field-label>\n\n          <textarea cnet-input [formControlName]=\"question?.code\" [id]=\"question?.code\" wrap=\"hard\"\n            [maxlength]=\"question['maxLength']\"></textarea>\n\n        </cnet-form-field>\n\n        <cnet-field-description>\n          <div class=\"carcter-counting\">\n            {{form.value[question?.code].length}} {{'caracteres' | translate}}\n          </div>\n        </cnet-field-description>\n      </div>\n\n      <div *ngSwitchCase=\"enumQuestionType.Text\">\n        <cnet-form-field>\n          <cnet-field-label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"showQuetionStatement\">\n            <ng-container *ngIf=\"!question.translateStatement; else translateStatementTpl\">\n              {{question?.statement }}\n            </ng-container>\n          </cnet-field-label>\n          <input cnet-input [formControlName]=\"question?.code\" [id]=\"question?.code\" wrap=\"hard\"\n            [maxlength]=\"question['maxLength']\">\n        </cnet-form-field>\n      </div>\n\n      <div *ngSwitchCase=\"enumQuestionType.Number\">\n        <cnet-form-field>\n          <cnet-field-label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"showQuetionStatement\">\n            <ng-container *ngIf=\"!question.translateStatement; else translateStatementTpl\">\n              {{question?.statement }}\n            </ng-container>\n          </cnet-field-label>\n          <input cnet-input [formControlName]=\"question?.code\" type=\"number\" inputmode=\"numeric\"\n            [min]=\"question['minValue']\" [max]=\"question['maxValue']\" [step]=\"question['step']\" />\n        </cnet-form-field>\n      </div>\n\n      <div *ngSwitchCase=\"enumQuestionType.InputSwitch\">\n        <cnet-form-field>\n          <cnet-field-label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"showQuetionStatement\">\n            <ng-container *ngIf=\"!question.translateStatement; else translateStatementTpl\">\n              {{question?.statement }}\n            </ng-container>\n          </cnet-field-label>\n          <cnet-input-switch [formControlName]=\"question?.code\" [color]=\"question['color']\"></cnet-input-switch>\n        </cnet-form-field>\n      </div>\n\n      <ng-container *ngSwitchCase=\"enumQuestionType.SingleSelect\">\n\n        <label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"showQuetionStatement\">\n          <ng-container *ngIf=\"!question.translateStatement; else translateStatementTpl\">\n            {{question?.statement }}\n          </ng-container>\n        </label>\n\n        <cnet-radio-group [formControlName]=\"question?.code\" aria-labelledby=\"group-label\" [color]=\"question['color']\"\n          [id]=\"question?.code\">\n          <cnet-radio *ngFor=\"let item of question['options'];\" [value]=\"item[question['optionValue']]\">\n            <div class=\"select-label\">\n              <ng-container *ngIf=\"!question['translateOption']; else translateSingleSelectOption\">\n                {{ item[question['optionLabel']]}}\n              </ng-container>\n              <ng-template #translateSingleSelectOption>\n                {{ item[question['optionLabel']] | translate}}\n              </ng-template>\n            </div>\n          </cnet-radio>\n        </cnet-radio-group>\n\n      </ng-container>\n\n\n      <ng-container *ngSwitchCase=\"enumQuestionType.MultiSelect\">\n\n        <label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"showQuetionStatement\">\n          <ng-container *ngIf=\"!question.translateStatement; else translateStatementTpl\">\n            {{question?.statement }}\n          </ng-container>\n        </label>\n\n        <cnet-checkbox-group [formControlName]=\"question?.code\" aria-labelledby=\"group-label\"\n          [color]=\"question['color']\" [id]=\"question?.code\">\n          <cnet-checkbox *ngFor=\"let item of question['options']; let i = index \"\n            [value]=\"item[question['optionValue']]\">\n            <div class=\"select-label\">\n              <ng-container *ngIf=\"!question['translateOption']; else translateMultiSelectOption\">\n                {{ item[question['optionLabel']]}}\n              </ng-container>\n              <ng-template #translateMultiSelectOption>\n                {{ item[question['optionLabel']] | translate}}\n              </ng-template>\n            </div>\n          </cnet-checkbox>\n        </cnet-checkbox-group>\n      </ng-container>\n\n      <ng-container *ngSwitchCase=\"enumQuestionType.Slider\">\n\n        <label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"showQuetionStatement\">\n          <ng-container *ngIf=\"!question.translateStatement; else translateStatementTpl\">\n            {{question?.statement }}\n          </ng-container>\n        </label>\n\n        <cnet-slider-old [id]=\"question?.code\" [formControlName]=\"question?.code\"\n          [steps]=\"question['options']\"></cnet-slider-old>\n      </ng-container>\n\n      <ng-container *ngSwitchCase=\"enumQuestionType.Attachment\">\n\n        <label cnetRequiredMark [show]=\"question?.required\" *ngIf=\"showQuetionStatement\">\n          <ng-container *ngIf=\"!question.translateStatement; else translateStatementTpl\">\n            {{question?.statement }}\n          </ng-container>\n        </label>\n\n        <cnet-file-upload [formControl]=\"form.controls[question?.code]\" [attachmentUri]=\"question['attachmentUri']\"\n          [id]=\"question?.code\" [maxFileSize]=\"5\" (onUpload)=\"onUploadFile($event)\"\n          (onRemoveFile)=\"onRemoveFile($event)\">\n        </cnet-file-upload>\n      </ng-container>\n\n      <label class=\"cnet-field-error\"\n        [class.error-text-field]=\"question?.questionTypeCode === enumQuestionType.Descriptive\"\n        *ngIf=\"isDirty && !isValid && !isDisabled && form.controls[question?.code].hasError('min')\">\n\n\n        <ng-container *ngIf=\"!question['translateStatement']; else minErrorStatementTranslatedTpl\">\n          {{'O campo {0} deve conter no m\u00EDnimo de {1} caracteres.' |translate:{'0':question['statement'] | translate,\n          '1':question['minValue']} }}\n\n        </ng-container>\n        <ng-template #minErrorStatementTranslatedTpl>\n          {{'O campo {0} deve conter no m\u00EDnimo de {1} caracteres.' |translate:{'0':question['statement'] | translate,\n          '1':question['minValue']} }}\n        </ng-template>\n\n\n\n      </label>\n      <label class=\"cnet-field-error\"\n        [class.error-text-field]=\"question?.questionTypeCode === enumQuestionType.Descriptive\"\n        *ngIf=\"isDirty && !isValid && !isDisabled && form.controls[question?.code].hasError('max')\">\n\n\n        <ng-container *ngIf=\"!question['translateStatement']; else maxErrorStatementTranslatedTpl\">\n          {{'O campo {0} deve conter no m\u00E1ximo de {1} caracteres.' |translate:{'0':question['statement'],\n          '1':question['maxValue']} }}\n\n        </ng-container>\n        <ng-template #maxErrorStatementTranslatedTpl>\n          {{'O campo {0} deve conter no m\u00E1ximo de {1} caracteres.' |translate:{'0':question['statement'] | translate,\n          '1':question['maxValue']} }}\n        </ng-template>\n\n\n      </label>\n      <label class=\"cnet-field-error\"\n        [class.error-text-field]=\"question?.questionTypeCode === enumQuestionType.Descriptive\"\n        *ngIf=\"isDirty && !isValid && !isDisabled && form.controls[question?.code].hasError('required')\">\n\n        <ng-container *ngIf=\"!question['translateStatement']; else requiredErrorStatementTranslatedTpl\">\n          {{'O campo {0} \u00E9 obrigat\u00F3rio.' |translate:{'0':question?.statement} }}\n        </ng-container>\n        <ng-template #requiredErrorStatementTranslatedTpl>\n          {{'O campo {0} \u00E9 obrigat\u00F3rio.' |translate:{'0':question?.statement | translate} }}\n        </ng-template>\n\n\n      </label>\n    </form>\n\n    <ng-content\n      select=\"cnet-container-external-template, [cnet-container-external-template], [ContainerExternalTemplateComponent]\">\n    </ng-content>\n\n\n  </div>\n\n</div>\n", styles: [".carcter-counting{width:100%;display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:right}.cnet-checkbox-group,.cnet-radio-group{flex-direction:column;margin-bottom:1.5rem}.cnet-radio-group cnet-radio.label.cnet-radio-label{font-weight:700}.cnet-field-error{color:var(--cnet-danger-500, #ee4446);font-weight:400;margin-bottom:1rem}.cnet-field-error.error-text-field{margin-top:-20px}\n"] }]
        }], ctorParameters: () => [{ type: SimpleDynamicFormService }], propDecorators: { question: [{
                type: Input
            }], form: [{
                type: Input
            }], showQuetionStatement: [{
                type: Input
            }], onUpload: [{
                type: Output
            }], onRemoveFileFromAnswer: [{
                type: Output
            }] } });

class ContainerExternalTemplateComponent {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ContainerExternalTemplateComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: ContainerExternalTemplateComponent, selector: "cnet-container-external-template, [cnet-container-external-template], [ContainerExternalTemplateComponent]", host: { classAttribute: "cnet-container-external-template" }, exportAs: ["cnet-container-external-template"], ngImport: i0, template: "<ng-content></ng-content>\n", styles: [""], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ContainerExternalTemplateComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-container-external-template, [cnet-container-external-template], [ContainerExternalTemplateComponent]', exportAs: 'cnet-container-external-template', host: {
                        class: 'cnet-container-external-template'
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, template: "<ng-content></ng-content>\n" }]
        }] });

class CnetSimpleDynamicFormModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSimpleDynamicFormModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetSimpleDynamicFormModule, declarations: [CnetSimpleDynamicFormComponent,
            CnetSimpleFormQuestionComponent,
            ContainerExternalTemplateComponent], imports: [CommonModule,
            ReactiveFormsModule,
            CnetButtonModule,
            CnetIconModule,
            CnetFormFieldModule,
            RequiredMarkModule,
            CnetRadioModule,
            CnetInputModule,
            CnetCheckboxModule,
            CnetSliderOldModule,
            CnetFileUploadModule,
            TranslateModule,
            CnetPanelModule,
            CnetInputSwitchModule], exports: [CnetSimpleDynamicFormComponent,
            CnetSimpleFormQuestionComponent,
            ContainerExternalTemplateComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSimpleDynamicFormModule, imports: [CommonModule,
            ReactiveFormsModule,
            CnetButtonModule,
            CnetIconModule,
            CnetFormFieldModule,
            RequiredMarkModule,
            CnetRadioModule,
            CnetInputModule,
            CnetCheckboxModule,
            CnetSliderOldModule,
            CnetFileUploadModule,
            TranslateModule,
            CnetPanelModule,
            CnetInputSwitchModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSimpleDynamicFormModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnetSimpleDynamicFormComponent,
                        CnetSimpleFormQuestionComponent,
                        ContainerExternalTemplateComponent
                    ],
                    exports: [
                        CnetSimpleDynamicFormComponent,
                        CnetSimpleFormQuestionComponent,
                        ContainerExternalTemplateComponent
                    ],
                    imports: [
                        CommonModule,
                        ReactiveFormsModule,
                        CnetButtonModule,
                        CnetIconModule,
                        CnetFormFieldModule,
                        RequiredMarkModule,
                        CnetRadioModule,
                        CnetInputModule,
                        CnetCheckboxModule,
                        CnetSliderOldModule,
                        CnetFileUploadModule,
                        TranslateModule,
                        CnetPanelModule,
                        CnetInputSwitchModule
                    ]
                }]
        }] });

let nextUniqueId = 0;
/**
 * Directive for use inputs inside a form field
 *
 * @export
 * class CnetInputDirective
 */
class CnetInputForSliderDirective {
    constructor(ngControl, elementRef) {
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        /** @ignore */ this._id = `cnet-input-switch-${nextUniqueId++}`;
        /** @ignore */ this._required = false;
        /** @ignore */ this._disabled = false;
        /** @ignore */ this._focused = false;
        /** @ignore */ this._errorState = false;
        /** @ignore */ this.cdr = inject(ChangeDetectorRef);
        this.destroyed = new Subject();
        /**
         * Emits whenever the state of the control changes
         *
         * type {Observable<void>}
         * @memberof CnetInputDirective
         */
        this.stateChanges = new Subject();
        this._valueAcessor = this.elementRef.nativeElement;
    }
    /**
    * The element ID for this control.
    *
    * type {string}
    * @memberof CnetInputDirective
    */
    get id() { return this._id; }
    set id(value) { this._id = value; }
    /**
     * Whether the control is required.
     *
     * type {boolean}
     * @memberof CnetInputDirective
     */
    get required() { return this._required; }
    set required(value) { this._required = coerceBooleanProperty(value); }
    // /**
    //  * Whether the control is disabled.
    //  *
    //  * type {boolean}
    //  * @memberof CnetInputDirective
    //  */
    // @Input()
    // get disabled(): boolean {
    //   if (this.ngControl && this.ngControl.disabled !== null) {
    //     return this.ngControl.disabled;
    //   }
    //   return this._disabled;
    // }
    // set disabled(value: boolean) {
    //   this._disabled = coerceBooleanProperty(value);
    /**
   * Whether this input switch is disabled
   *
   * @readonly
   * type boolean
   * @memberof CnetInputSwitchComponent
   */
    get disabled() {
        return this._disabled;
    }
    set disabled(value) {
        this._disabled = coerceBooleanProperty(value);
    }
    /**
     * The value of the control
     *
     * type {(T | null)}
     * @memberof CnetInputDirective
     */
    get value() { return this._valueAcessor.value; }
    set value(value) {
        if (value !== this._valueAcessor.value) {
            this._valueAcessor.value = value;
            this.stateChanges.next();
        }
    }
    /**
     * Whether the control is focused
     *
     * type {boolean}
     * @memberof CnetInputDirective
     */
    get focused() { return this._focused; }
    set focused(value) { this._focused = coerceBooleanProperty(value); }
    /**
     * Whether the control is in an error state.
     *
     * type {boolean}
     * @memberof CnetInputDirective
     */
    get errorState() { return this._errorState; }
    set errorState(value) { this._errorState = coerceBooleanProperty(value); }
    /**
     * Error id for aria-describedby
     *
     * @readonly
     * type {string}
     * @memberof CnetInputDirective
     */
    get describedby() {
        return this.error?.id || null;
    }
    /** @ignore */
    ngDoCheck() {
        if (this.ngControl) {
            this.errorState = this.ngControl.errors !== null && (!!this.ngControl.touched || this.ngControl.dirty);
        }
        this.stateChanges.next();
    }
    /** @ignore */
    changeFocus(focused) {
        this.focused = focused;
        this.stateChanges.next();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetInputForSliderDirective, deps: [{ token: i1$4.NgControl, optional: true, self: true }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetInputForSliderDirective, selector: "cnet-input, [CnetInput], [cnet-input]", inputs: { id: "id", required: "required", disabled: "disabled", value: "value", focused: "focused", errorState: "errorState" }, host: { listeners: { "blur": "changeFocus(false)", "focus": "changeFocus(true)" }, properties: { "attr.id": "id", "attr.aria-invalid": "errorState", "attr.aria-required": "required", "attr.aria-describedby": "describedby" }, classAttribute: "cnet-slider" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetInputForSliderDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-input, [CnetInput], [cnet-input]',
                    host: {
                        class: 'cnet-slider',
                        '[attr.id]': 'id',
                        '[attr.aria-invalid]': 'errorState',
                        '[attr.aria-required]': 'required',
                        '[attr.aria-describedby]': 'describedby',
                        '(blur)': 'changeFocus(false)',
                        '(focus)': 'changeFocus(true)'
                    },
                }]
        }], ctorParameters: () => [{ type: i1$4.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ElementRef }], propDecorators: { id: [{
                type: Input
            }], required: [{
                type: Input
            }], disabled: [{
                type: Input,
                args: ['disabled']
            }], value: [{
                type: Input
            }], focused: [{
                type: Input
            }], errorState: [{
                type: Input
            }] } });

class CnetSliderComponent extends CnetInputForSliderDirective {
    /**
    * Value for the input switch
    * @readonly
    * type {boolean}
    * @memberof CnetInputSwitchComponent
    */
    get value() { return this._value; }
    set value(value) {
        this._value = value;
    }
    constructor(ngControl, elementRef, injector) {
        super(ngControl, elementRef);
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.injector = injector;
        /** @ignore */ this._value = null; // A principio number | Array<number> | obj (talvez tenha q definir esse obj)
        this.control = new FormControl(0, []);
        this.manualRefresh = new EventEmitter();
        /** @ignore */
        this.onChangeFn = (_) => { };
        /** @ignore */
        this.onTouchedFn = () => { };
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }
    ngOnInit() {
        this.setComponentControl();
        setTimeout(() => {
            this.cdr.markForCheck();
        }, 5);
    }
    refresh() {
        this.manualRefresh.emit();
    }
    setComponentControl() {
        if (this.ngControl) {
            const injectedControl = this.ngControl;
            switch (injectedControl.constructor) {
                case NgModel: {
                    const { control, update } = injectedControl;
                    this.control = control;
                    this.control.valueChanges
                        .pipe(tap((value) => update.emit(value)), takeUntil$1(this.destroyed))
                        .subscribe();
                    break;
                }
                case FormControlName: {
                    this.control = this.injector.get(FormGroupDirective).getControl(injectedControl);
                    break;
                }
                default: {
                    this.control = injectedControl.form;
                    break;
                }
            }
        }
    }
    ngOnDestroy() {
        this.destroyed.next();
        this.destroyed.complete();
    }
    writeValue(obj) {
        this.value = obj;
        this.cdr.markForCheck();
    }
    onChange() {
        this.onChangeFn(this.value);
        this.cdr.markForCheck();
    }
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
        if (this.disabled) {
            this.elementRef.nativeElement.tabIndex = -1;
        }
        else {
            this.elementRef.nativeElement.tabIndex = 0;
        }
        this.cdr.markForCheck();
    }
    /** @ignore */
    registerOnChange(fn) {
        this.onChangeFn = fn;
    }
    registerOnTouched(fn) {
        this.onTouchedFn = fn;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSliderComponent, deps: [{ token: i1$4.NgControl, optional: true, self: true }, { token: i0.ElementRef }, { token: Injector }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetSliderComponent, selector: "cnet-slider", inputs: { value: "value", options: "options" }, host: { attributes: { "tabindex": "-1", "role": "input" }, properties: { "attr.id": "id", "attr.value": "value", "attr.name": "name", "class.cnet-slidedr-disabled": "disabled" }, classAttribute: "cnet-slider" }, providers: [{ provide: CnetFormFieldControl, useExisting: CnetSliderComponent }], exportAs: ["cnetSlider"], usesInheritance: true, ngImport: i0, template: "<div class=\"custom-slider\">\n  <ngx-slider  [formControl]=\"control\" [options]=\"options\" [manualRefresh]=\"manualRefresh\"></ngx-slider>\n</div>\n", styles: [".custom-slider{margin-bottom:1rem}.custom-slider .ngx-slider .ngx-slider-bar{background:#ccc;height:4px}.ngx-slider.animate .ngx-slider-selection{height:6px;margin-top:-1px}.custom-slider .ngx-slider .ngx-slider-selection{background:var(--cnet-primary-500, #82c14f)}.custom-slider .ngx-slider .ngx-slider-pointer:active{cursor:grabbing}.custom-slider .ngx-slider .ngx-slider-pointer{cursor:grab;width:20px;height:20px;top:-8px;bottom:0;background-color:var(--cnet-primary-500, #82c14f)}.custom-slider .ngx-slider .ngx-slider-pointer:after{display:none}.custom-slider .ngx-slider .ngx-slider-bubble{bottom:14px}.custom-slider .ngx-slider .ngx-slider-limit{font-weight:700;color:var(--cnet-primary-500, #82c14f)}.custom-slider .ngx-slider .ngx-slider-tick{width:2px;height:12px;margin-left:16px;border-radius:0;background:var(--cnet-primary-500, #82c14f);top:-1px}.custom-slider .ngx-slider .ngx-slider-tick-legend{font-size:.875rem}.custom-slider .ngx-slider .ngx-slider-tick.ngx-slider-selected{background:var(--cnet-primary-500, #82c14f)}\n"], dependencies: [{ kind: "component", type: i1$6.SliderComponent, selector: "ngx-slider", inputs: ["value", "highValue", "options", "manualRefresh", "triggerFocus"], outputs: ["valueChange", "highValueChange", "userChangeStart", "userChange", "userChangeEnd"] }, { kind: "directive", type: i1$4.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$4.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSliderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-slider', exportAs: 'cnetSlider', host: {
                        class: 'cnet-slider',
                        tabindex: '-1',
                        role: 'input',
                        '[attr.id]': 'id',
                        '[attr.value]': 'value',
                        '[attr.name]': 'name',
                        '[class.cnet-slidedr-disabled]': 'disabled',
                        // '[class.cnet-color-primary]': 'color == "primary"',
                        // '[class.cnet-color-secondary]': 'color == "secondary"',
                        // '[class.cnet-color-danger]': 'color == "danger"',
                        // '[class.cnet-color-success]': 'color == "success"',
                        // '[class.cnet-color-cancel]': 'color == "cancel"',
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, providers: [{ provide: CnetFormFieldControl, useExisting: CnetSliderComponent }], template: "<div class=\"custom-slider\">\n  <ngx-slider  [formControl]=\"control\" [options]=\"options\" [manualRefresh]=\"manualRefresh\"></ngx-slider>\n</div>\n", styles: [".custom-slider{margin-bottom:1rem}.custom-slider .ngx-slider .ngx-slider-bar{background:#ccc;height:4px}.ngx-slider.animate .ngx-slider-selection{height:6px;margin-top:-1px}.custom-slider .ngx-slider .ngx-slider-selection{background:var(--cnet-primary-500, #82c14f)}.custom-slider .ngx-slider .ngx-slider-pointer:active{cursor:grabbing}.custom-slider .ngx-slider .ngx-slider-pointer{cursor:grab;width:20px;height:20px;top:-8px;bottom:0;background-color:var(--cnet-primary-500, #82c14f)}.custom-slider .ngx-slider .ngx-slider-pointer:after{display:none}.custom-slider .ngx-slider .ngx-slider-bubble{bottom:14px}.custom-slider .ngx-slider .ngx-slider-limit{font-weight:700;color:var(--cnet-primary-500, #82c14f)}.custom-slider .ngx-slider .ngx-slider-tick{width:2px;height:12px;margin-left:16px;border-radius:0;background:var(--cnet-primary-500, #82c14f);top:-1px}.custom-slider .ngx-slider .ngx-slider-tick-legend{font-size:.875rem}.custom-slider .ngx-slider .ngx-slider-tick.ngx-slider-selected{background:var(--cnet-primary-500, #82c14f)}\n"] }]
        }], ctorParameters: () => [{ type: i1$4.NgControl, decorators: [{
                    type: Optional
                }, {
                    type: Self
                }] }, { type: i0.ElementRef }, { type: i0.Injector, decorators: [{
                    type: Inject,
                    args: [Injector]
                }] }], propDecorators: { value: [{
                type: Input
            }], options: [{
                type: Input
            }] } });

class CnetSliderModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSliderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetSliderModule, declarations: [CnetSliderComponent], imports: [CommonModule,
            NgxSliderModule,
            ReactiveFormsModule], exports: [CnetSliderComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSliderModule, imports: [CommonModule,
            NgxSliderModule,
            ReactiveFormsModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetSliderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetSliderComponent],
                    exports: [CnetSliderComponent],
                    imports: [
                        CommonModule,
                        NgxSliderModule,
                        ReactiveFormsModule
                    ]
                }]
        }] });

class CnetSliderOptions extends Options {
}

/**
 * Directive for creating buttons that advance to the next step
 *
 * @export
 * class CnetNextStepDirective
 * extends {CdkStepperNext}
 */
class CnetNextStepDirective extends CdkStepperNext {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNextStepDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetNextStepDirective, selector: "[cnetNextStep]", usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNextStepDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetNextStep]'
                }]
        }] });
/**
 * Directive for creating buttons that return to the previous step
 *
 * @export
 * class CnetPreviousStepDirective
 * extends {CdkStepperPrevious}
 */
class CnetPreviousStepDirective extends CdkStepperPrevious {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetPreviousStepDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetPreviousStepDirective, selector: "[cnetPreviousStep]", usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetPreviousStepDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetPreviousStep]'
                }]
        }] });
/**
 * Directive representing the step header
 *
 * @export
 * class CnetStepHeaderDirective
 * extends {CdkStepHeader}
 */
class CnetStepHeaderDirective extends CdkStepHeader {
    constructor(_focusMonitor, _elementRef) {
        super(_elementRef);
        this._focusMonitor = _focusMonitor;
        _focusMonitor.monitor(_elementRef, true);
    }
    /** Focuses the step header. */
    focus() {
        this._focusMonitor.focusVia(this._elementRef, 'program');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetStepHeaderDirective, deps: [{ token: i1$2.FocusMonitor }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetStepHeaderDirective, selector: "[cnetStepHeader]", usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetStepHeaderDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetStepHeader]'
                }]
        }], ctorParameters: () => [{ type: i1$2.FocusMonitor }, { type: i0.ElementRef }] });
/**
 * Component that represents each step
 *
 * @export
 * class CnetStepComponent
 * extends {CdkStep}
 */
class CnetStepComponent extends CdkStep {
    /**
     * Complete this step
     *
     * @memberof CnetStepComponent
     */
    completeStep() {
        this.completed = true;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetStepComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetStepComponent, selector: "cnet-step, [cnet-step], [cnetStep]", host: { attributes: { "role": "tabpanel" }, classAttribute: "cnet-step" }, providers: [
            { provide: CdkStep, useExisting: CnetStepComponent },
        ], exportAs: ["cnetStep"], usesInheritance: true, ngImport: i0, template: "<ng-template><ng-content></ng-content></ng-template>\n", changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetStepComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-step, [cnet-step], [cnetStep]', exportAs: 'cnetStep', host: {
                        class: 'cnet-step',
                        role: 'tabpanel',
                    }, providers: [
                        { provide: CdkStep, useExisting: CnetStepComponent },
                    ], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<ng-template><ng-content></ng-content></ng-template>\n" }]
        }] });

/**
 * The Stepper component provides an experience based on numbered steps. The steps can be linear or not.
 *
 * @export
 * class CnetStepperComponent
 * extends {CdkStepper}
 */
class CnetStepperComponent extends CdkStepper {
    constructor() {
        super(...arguments);
        this.optionalLabel = "Optional";
        this.disableClickStep = false;
    }
    /**
    * The index of the selected step.
    * Default: 0
    *
    * type {number}
    * @memberof CnetStepperComponent
    */
    set selectedStepIndex(index) {
        this.selectedIndex = index;
    }
    get selectedStepIndex() {
        return this.selectedIndex;
    }
    /**
    * Whether the validity of previous steps should be checked or not.
    * Default: true
    *
    * type {boolean}
    * @memberof CnetStepperComponent
    */
    set linearStepper(value) {
        this.linear = value;
    }
    get linearStepper() {
        return this.linear;
    }
    set stepperOrientation(value) {
        this._stepperOrientation = value;
        this.orientation = value ? value : 'vertical';
    }
    get stepperOrientation() {
        return this._stepperOrientation;
    }
    /**
     * Open a step based on index
     *
     * param index
     * @memberof CnetStepperComponent
     */
    openStep(index) {
        if (!this.disableClickStep) {
            this.selectedIndex = index;
        }
    }
    /**
     * Handle keystroke events to allow steps to be opened from the keyboard
     *
     * @ignore
     * param event
     * param i
     * @memberof CnetStepperComponent
     */
    onKeyDown(event, i) {
        if (event.keyCode == SPACE || event.keyCode == ENTER) {
            event.preventDefault();
            this.openStep(i);
        }
    }
    ngOnInit() {
        this.onResize({ target: { innerWidth: window.innerWidth } });
    }
    onResize(size) {
        if (size.target.innerWidth <= 992) {
            this.orientation = 'vertical';
        }
        else if (this.stepperOrientation !== 'vertical') {
            this.orientation = 'horizontal';
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetStepperComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetStepperComponent, selector: "cnet-stepper, [cnet-stepper], [cnetStepper]", inputs: { selectedStepIndex: "selectedStepIndex", linearStepper: "linearStepper", stepperOrientation: "stepperOrientation", optionalLabel: "optionalLabel", disableClickStep: "disableClickStep" }, host: { attributes: { "role": "tablist" }, listeners: { "window:resize": "onResize($event)" }, classAttribute: "cnet-stepper" }, providers: [{ provide: CdkStepper, useExisting: CnetStepperComponent }], viewQueries: [{ propertyName: "_stepHeader", predicate: CnetStepHeaderDirective, descendants: true }], exportAs: ["cnetStepper"], usesInheritance: true, ngImport: i0, template: "<div [class.cnet-stepper-horizontal-orientation]=\"orientation === 'horizontal'\" >\n\n    <div *ngFor=\"let step of steps; let i = index;\"\n    class=\"cnet-step-container\" [ngClass]=\"{'cnet-step-last': steps.length - 1 == i,\n                    'cnet-step-active': selected === step,\n                    'cnet-step-completed': step.completed}\" [class.cnet-stepper-horizontal]=\"orientation === 'horizontal'\">\n      <div class=\"cnet-step-header\" [class.cursor-auto]=\"disableClickStep\" role=\"tab\" tabindex=\"0\" [attr.aria-posinset]=\"(i + 1)\"\n        [attr.aria-setsize]=\"steps.length\" [attr.aria-selected]=\"selected === step\"\n        [attr.aria-required]=\"!step.optional\" cnetStepHeader\n         cnetRipple cdkMonitorElementFocus\n        (keydown)=\"onKeyDown($event, i)\" (click)=\"openStep(i)\">\n        <div class=\"cnet-step-indicator\">\n          <span *ngIf=\"!step.completed\">{{i + 1}}</span>\n          <cnet-icon *ngIf=\"step.completed\" aria-hidden=\"true\" name=\"check\" size=\"1\"></cnet-icon>\n        </div>\n        <div class=\"cnet-step-header-content\">\n          <div class=\"cnet-step-label\" *ngIf=\"step.label\">{{step.label}}</div>\n          <div class=\"cnet-step-optional\" *ngIf=\"step.optional\">{{optionalLabel}}</div>\n        </div>\n      </div>\n      <div *ngIf=\"orientation !== 'horizontal'\" class=\"cnet-step-content\" cdkMonitorElementFocus [@transition]=\"selected === step\"\n        [attr.tabindex]=\"selected === step ? 0 : null\" [attr.aria-expanded]=\"selected === step\">\n        <ng-container [ngTemplateOutlet]=\"step.content\"></ng-container>\n      </div>\n    </div>\n  </div>\n\n  <!-- TODO: PENSAR EM UMA ANIMA\u00C7\u00C3O  -->\n  <div *ngIf=\"orientation === 'horizontal'\" class=\"cnet-step-content\" [class.cnet-margin-1]=\"orientation === 'horizontal'\" style=\"flex:1\" cdkMonitorElementFocus>\n    <ng-container [ngTemplateOutlet]=\"selected?.content\"></ng-container>\n  </div>\n", styles: [".cnet-stepper-horizontal-orientation{display:flex;flex-direction:row;justify-content:space-between;padding:0 1.25rem .5rem;margin-bottom:1rem}.cnet-stepper-horizontal{flex:1;min-width:15rem;border-bottom:solid 2px #e6e6e6}.cnet-step-active.cnet-stepper-horizontal{border-bottom:solid 2px var(--cnet-primary-500, #82c14f)!important}.cnet-step-container{position:relative}.cnet-step-container:not(.cnet-stepper-horizontal):before{content:\"\";display:block;width:1px;height:calc(100% - 40px);background-color:#e6e6e6;position:absolute;left:25px;top:55px}.cnet-step-last.cnet-step-container:not(.cnet-stepper-horizontal){border-bottom:1px solid #e6e6e6;overflow:hidden}.cnet-step-active .cnet-step-label{font-weight:700}.cnet-step-active .cnet-step-indicator,.cnet-step-completed .cnet-step-indicator{background-color:var(--cnet-primary-500, #82c14f);color:var(--cnet-primary-contrast-500, white)}.cnet-step-header{display:flex;align-items:center;border-radius:.25rem;padding:1.375rem .75rem;cursor:pointer;transition:background-color ease-in .2s}.cnet-step-header:hover{background-color:#0000000a}.cursor-auto{cursor:auto}.cnet-step-indicator{display:flex;justify-content:center;align-items:center;height:1.625rem;width:1.625rem;background-color:var(--cnet--500, #9e9e9e);color:var(--cnet--contrast-500, white);border-radius:50%;vertical-align:baseline;line-height:1;font-size:.875rem;margin-right:.5rem}.cnet-step-header-content{position:relative}.cnet-step-header-content .cnet-step-optional{position:absolute;font-size:12px;color:#000000ab}.cnet-step-label{transition:color ease-in .3s}.cnet-step-content{overflow:hidden;padding:.5rem 0;margin-left:2.875rem}.cnet-margin-1{margin:0 1rem}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "directive", type: CnetRippleDirective, selector: "[cnet-ripple], [cnetRipple]", inputs: ["cnetRippleColor", "cnetRippleUnbounded", "cnetRippleCentered", "cnetRippleRadius", "cnetRippleAnimation", "cnetRippleDisabled", "cnetRippleTrigger"], exportAs: ["cnetRipple"] }, { kind: "directive", type: i1$2.CdkMonitorFocus, selector: "[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]", outputs: ["cdkFocusChange"], exportAs: ["cdkMonitorFocus"] }, { kind: "directive", type: CnetStepHeaderDirective, selector: "[cnetStepHeader]" }], animations: [stepTransitionAnimation], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetStepperComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-stepper, [cnet-stepper], [cnetStepper]', exportAs: 'cnetStepper', host: {
                        class: 'cnet-stepper',
                        'role': 'tablist'
                    }, providers: [{ provide: CdkStepper, useExisting: CnetStepperComponent }], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, animations: [stepTransitionAnimation], template: "<div [class.cnet-stepper-horizontal-orientation]=\"orientation === 'horizontal'\" >\n\n    <div *ngFor=\"let step of steps; let i = index;\"\n    class=\"cnet-step-container\" [ngClass]=\"{'cnet-step-last': steps.length - 1 == i,\n                    'cnet-step-active': selected === step,\n                    'cnet-step-completed': step.completed}\" [class.cnet-stepper-horizontal]=\"orientation === 'horizontal'\">\n      <div class=\"cnet-step-header\" [class.cursor-auto]=\"disableClickStep\" role=\"tab\" tabindex=\"0\" [attr.aria-posinset]=\"(i + 1)\"\n        [attr.aria-setsize]=\"steps.length\" [attr.aria-selected]=\"selected === step\"\n        [attr.aria-required]=\"!step.optional\" cnetStepHeader\n         cnetRipple cdkMonitorElementFocus\n        (keydown)=\"onKeyDown($event, i)\" (click)=\"openStep(i)\">\n        <div class=\"cnet-step-indicator\">\n          <span *ngIf=\"!step.completed\">{{i + 1}}</span>\n          <cnet-icon *ngIf=\"step.completed\" aria-hidden=\"true\" name=\"check\" size=\"1\"></cnet-icon>\n        </div>\n        <div class=\"cnet-step-header-content\">\n          <div class=\"cnet-step-label\" *ngIf=\"step.label\">{{step.label}}</div>\n          <div class=\"cnet-step-optional\" *ngIf=\"step.optional\">{{optionalLabel}}</div>\n        </div>\n      </div>\n      <div *ngIf=\"orientation !== 'horizontal'\" class=\"cnet-step-content\" cdkMonitorElementFocus [@transition]=\"selected === step\"\n        [attr.tabindex]=\"selected === step ? 0 : null\" [attr.aria-expanded]=\"selected === step\">\n        <ng-container [ngTemplateOutlet]=\"step.content\"></ng-container>\n      </div>\n    </div>\n  </div>\n\n  <!-- TODO: PENSAR EM UMA ANIMA\u00C7\u00C3O  -->\n  <div *ngIf=\"orientation === 'horizontal'\" class=\"cnet-step-content\" [class.cnet-margin-1]=\"orientation === 'horizontal'\" style=\"flex:1\" cdkMonitorElementFocus>\n    <ng-container [ngTemplateOutlet]=\"selected?.content\"></ng-container>\n  </div>\n", styles: [".cnet-stepper-horizontal-orientation{display:flex;flex-direction:row;justify-content:space-between;padding:0 1.25rem .5rem;margin-bottom:1rem}.cnet-stepper-horizontal{flex:1;min-width:15rem;border-bottom:solid 2px #e6e6e6}.cnet-step-active.cnet-stepper-horizontal{border-bottom:solid 2px var(--cnet-primary-500, #82c14f)!important}.cnet-step-container{position:relative}.cnet-step-container:not(.cnet-stepper-horizontal):before{content:\"\";display:block;width:1px;height:calc(100% - 40px);background-color:#e6e6e6;position:absolute;left:25px;top:55px}.cnet-step-last.cnet-step-container:not(.cnet-stepper-horizontal){border-bottom:1px solid #e6e6e6;overflow:hidden}.cnet-step-active .cnet-step-label{font-weight:700}.cnet-step-active .cnet-step-indicator,.cnet-step-completed .cnet-step-indicator{background-color:var(--cnet-primary-500, #82c14f);color:var(--cnet-primary-contrast-500, white)}.cnet-step-header{display:flex;align-items:center;border-radius:.25rem;padding:1.375rem .75rem;cursor:pointer;transition:background-color ease-in .2s}.cnet-step-header:hover{background-color:#0000000a}.cursor-auto{cursor:auto}.cnet-step-indicator{display:flex;justify-content:center;align-items:center;height:1.625rem;width:1.625rem;background-color:var(--cnet--500, #9e9e9e);color:var(--cnet--contrast-500, white);border-radius:50%;vertical-align:baseline;line-height:1;font-size:.875rem;margin-right:.5rem}.cnet-step-header-content{position:relative}.cnet-step-header-content .cnet-step-optional{position:absolute;font-size:12px;color:#000000ab}.cnet-step-label{transition:color ease-in .3s}.cnet-step-content{overflow:hidden;padding:.5rem 0;margin-left:2.875rem}.cnet-margin-1{margin:0 1rem}\n"] }]
        }], propDecorators: { _stepHeader: [{
                type: ViewChildren,
                args: [CnetStepHeaderDirective]
            }], selectedStepIndex: [{
                type: Input
            }], linearStepper: [{
                type: Input
            }], stepperOrientation: [{
                type: Input
            }], optionalLabel: [{
                type: Input
            }], disableClickStep: [{
                type: Input
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });

class CnetStepperModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetStepperModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetStepperModule, declarations: [CnetStepperComponent,
            CnetStepComponent,
            CnetNextStepDirective,
            CnetPreviousStepDirective,
            CnetStepHeaderDirective], imports: [CommonModule,
            CdkStepperModule,
            CnetIconModule,
            CnetRippleModule,
            A11yModule], exports: [CnetStepperComponent,
            CdkStepperModule,
            CnetStepComponent,
            CnetNextStepDirective,
            CnetPreviousStepDirective,
            CnetStepHeaderDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetStepperModule, imports: [CommonModule,
            CdkStepperModule,
            CnetIconModule,
            CnetRippleModule,
            A11yModule, CdkStepperModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetStepperModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnetStepperComponent,
                        CnetStepComponent,
                        CnetNextStepDirective,
                        CnetPreviousStepDirective,
                        CnetStepHeaderDirective
                    ],
                    imports: [
                        CommonModule,
                        CdkStepperModule,
                        CnetIconModule,
                        CnetRippleModule,
                        A11yModule
                    ],
                    exports: [
                        CnetStepperComponent,
                        CdkStepperModule,
                        CnetStepComponent,
                        CnetNextStepDirective,
                        CnetPreviousStepDirective,
                        CnetStepHeaderDirective
                    ]
                }]
        }] });

/**
 * Enables the recycle view repeater strategy, which reduces rendering latency. Not compatible with
 * tables that animate rows.
 */
class CnetRecycleRowsDirective {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetRecycleRowsDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetRecycleRowsDirective, selector: "cnet-table[recycleRows], table[cnet-table][recycleRows]", providers: [{ provide: _VIEW_REPEATER_STRATEGY, useClass: _RecycleViewRepeaterStrategy }], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetRecycleRowsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-table[recycleRows], table[cnet-table][recycleRows]',
                    providers: [{ provide: _VIEW_REPEATER_STRATEGY, useClass: _RecycleViewRepeaterStrategy }],
                }]
        }] });
class CnetTableComponent extends CdkTable {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTableComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "17.0.0", version: "17.3.12", type: CnetTableComponent, selector: "cnet-table, table[cnet-table]", host: { classAttribute: "cnet-table" }, providers: [
            { provide: CdkTable, useExisting: CnetTableComponent },
            { provide: CDK_TABLE, useExisting: CnetTableComponent },
            { provide: _VIEW_REPEATER_STRATEGY, useClass: _DisposeViewRepeaterStrategy },
            { provide: _COALESCED_STYLE_SCHEDULER, useClass: _CoalescedStyleScheduler },
        ], usesInheritance: true, ngImport: i0, template: "\n  <ng-content select=\"caption\"/>\n  <ng-content select=\"colgroup, col\"/>\n\n  <!--\n    Unprojected content throws a hydration error so we need this to capture it.\n    It gets removed on the client so it doesn't affect the layout.\n  -->\n  @if (_isServer) {\n    <ng-content/>\n  }\n\n  @if (_isNativeHtmlTable) {\n    <thead role=\"rowgroup\">\n      <ng-container headerRowOutlet/>\n    </thead>\n    <tbody role=\"rowgroup\">\n      <ng-container rowOutlet/>\n      <ng-container noDataRowOutlet/>\n    </tbody>\n    <tfoot role=\"rowgroup\">\n      <ng-container footerRowOutlet/>\n    </tfoot>\n  } @else {\n    <ng-container headerRowOutlet/>\n    <ng-container rowOutlet/>\n    <ng-container noDataRowOutlet/>\n    <ng-container footerRowOutlet/>\n  }\n", isInline: true, styles: [".cnet-table{width:100%;max-width:100%;margin-bottom:1rem;border-spacing:0}.cnet-button-toggle-checked{font-weight:700}.cnet-button-toggle-checked.cnet-color-success{background-color:var(--cnet-success-500, #47ba65)}.cnet-button-toggle-checked.cnet-color-cancel{background-color:var(--cnet-cancel-500, #9e9e9e)}.cnet-button-toggle-checked.cnet-color-primary{background-color:var(--cnet-primary-500, #82c14f)}.cnet-button-toggle-checked.cnet-color-secondary{background-color:var(--cnet-secondary-500, #3d4155)}.cnet-button-toggle-checked.cnet-color-danger{background-color:var(--cnet-danger-500, #ee4446)}.cnet-button-toggle-checked.cnet-color-success{color:var(--cnet-success-contrast-500, white)}.cnet-button-toggle-checked.cnet-color-cancel{color:var(--cnet-cancel-contrast-500, white)}.cnet-button-toggle-checked.cnet-color-primary{color:var(--cnet-primary-contrast-500, white)}.cnet-button-toggle-checked.cnet-color-secondary{color:var(--cnet-secondary-contrast-500, white)}.cnet-button-toggle-checked.cnet-color-danger{color:var(--cnet-danger-contrast-500, white)}.cnet-button-toggle-checked:hover{transition:background-color ease .3s,color ease .3s}.cnet-button-toggle-checked:hover.cnet-color-success{background-color:var(--cnet-success-300, #7ecf93)}.cnet-button-toggle-checked:hover.cnet-color-cancel{background-color:var(--cnet-cancel-300, #e0e0e0)}.cnet-button-toggle-checked:hover.cnet-color-primary{background-color:var(--cnet-primary-300, #a8d484)}.cnet-button-toggle-checked:hover.cnet-color-secondary{background-color:var(--cnet-secondary-300, #777a88)}.cnet-button-toggle-checked:hover.cnet-color-danger{background-color:var(--cnet-danger-300, #f37c7e)}.cnet-button-toggle-checked:hover.cnet-color-success{color:var(--cnet-success-contrast-300, rgba(0, 0, 0, .85))}.cnet-button-toggle-checked:hover.cnet-color-cancel{color:var(--cnet-cancel-contrast-300, rgba(0, 0, 0, .85))}.cnet-button-toggle-checked:hover.cnet-color-primary{color:var(--cnet-primary-contrast-300, rgba(0, 0, 0, .85))}.cnet-button-toggle-checked:hover.cnet-color-secondary{color:var(--cnet-secondary-contrast-300, white)}.cnet-button-toggle-checked:hover.cnet-color-danger{color:var(--cnet-danger-contrast-300, rgba(0, 0, 0, .85))}.cnet-row:hover{background-color:#00000005}.cnet-row .cnet-cell,.cnet-row .cnet-header-cell,.cnet-header-row .cnet-cell,.cnet-header-row .cnet-header-cell{border-bottom:1px solid #e6e6e6}.cnet-cell,.cnet-header-cell,.cnet-footer-cell{padding:.75rem}.cnet-footer-cell{border-top:1px solid #e6e6e6;font-weight:700}.td-mobile{display:flex;flex-wrap:wrap}@media (max-width: 1199.98px){.cnet-table,tbody,tfoot,.cnet-cell,.cnet-row{display:block;width:100%}.cnet-row{background-color:#fff;border:1px solid #e6e6e6;margin-bottom:1rem;border-radius:.25rem}.cnet-row .cnet-cell:last-child{border-width:0}.cnet-row .cnet-cell:before{content:var(--datath);display:block;margin-right:.25rem;font-weight:700}.cnet-header-row{display:none}.cnet-footer-row{width:100%;display:flex;justify-content:space-between;background-color:#fff;border:1px solid #e6e6e6;border-radius:.25rem}.cnet-footer-cell{border-width:0}}@media (min-width: 768px){.cnet-cell-left{text-align:left}.cnet-cell-center{text-align:center}.cnet-cell-right{text-align:left}}\n"], dependencies: [{ kind: "directive", type: i1$b.DataRowOutlet, selector: "[rowOutlet]" }, { kind: "directive", type: i1$b.HeaderRowOutlet, selector: "[headerRowOutlet]" }, { kind: "directive", type: i1$b.FooterRowOutlet, selector: "[footerRowOutlet]" }, { kind: "directive", type: i1$b.NoDataRowOutlet, selector: "[noDataRowOutlet]" }], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-table, table[cnet-table]', template: CDK_TABLE_TEMPLATE, host: {
                        class: 'cnet-table',
                    }, providers: [
                        { provide: CdkTable, useExisting: CnetTableComponent },
                        { provide: CDK_TABLE, useExisting: CnetTableComponent },
                        { provide: _VIEW_REPEATER_STRATEGY, useClass: _DisposeViewRepeaterStrategy },
                        { provide: _COALESCED_STYLE_SCHEDULER, useClass: _CoalescedStyleScheduler },
                    ], encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.Default, styles: [".cnet-table{width:100%;max-width:100%;margin-bottom:1rem;border-spacing:0}.cnet-button-toggle-checked{font-weight:700}.cnet-button-toggle-checked.cnet-color-success{background-color:var(--cnet-success-500, #47ba65)}.cnet-button-toggle-checked.cnet-color-cancel{background-color:var(--cnet-cancel-500, #9e9e9e)}.cnet-button-toggle-checked.cnet-color-primary{background-color:var(--cnet-primary-500, #82c14f)}.cnet-button-toggle-checked.cnet-color-secondary{background-color:var(--cnet-secondary-500, #3d4155)}.cnet-button-toggle-checked.cnet-color-danger{background-color:var(--cnet-danger-500, #ee4446)}.cnet-button-toggle-checked.cnet-color-success{color:var(--cnet-success-contrast-500, white)}.cnet-button-toggle-checked.cnet-color-cancel{color:var(--cnet-cancel-contrast-500, white)}.cnet-button-toggle-checked.cnet-color-primary{color:var(--cnet-primary-contrast-500, white)}.cnet-button-toggle-checked.cnet-color-secondary{color:var(--cnet-secondary-contrast-500, white)}.cnet-button-toggle-checked.cnet-color-danger{color:var(--cnet-danger-contrast-500, white)}.cnet-button-toggle-checked:hover{transition:background-color ease .3s,color ease .3s}.cnet-button-toggle-checked:hover.cnet-color-success{background-color:var(--cnet-success-300, #7ecf93)}.cnet-button-toggle-checked:hover.cnet-color-cancel{background-color:var(--cnet-cancel-300, #e0e0e0)}.cnet-button-toggle-checked:hover.cnet-color-primary{background-color:var(--cnet-primary-300, #a8d484)}.cnet-button-toggle-checked:hover.cnet-color-secondary{background-color:var(--cnet-secondary-300, #777a88)}.cnet-button-toggle-checked:hover.cnet-color-danger{background-color:var(--cnet-danger-300, #f37c7e)}.cnet-button-toggle-checked:hover.cnet-color-success{color:var(--cnet-success-contrast-300, rgba(0, 0, 0, .85))}.cnet-button-toggle-checked:hover.cnet-color-cancel{color:var(--cnet-cancel-contrast-300, rgba(0, 0, 0, .85))}.cnet-button-toggle-checked:hover.cnet-color-primary{color:var(--cnet-primary-contrast-300, rgba(0, 0, 0, .85))}.cnet-button-toggle-checked:hover.cnet-color-secondary{color:var(--cnet-secondary-contrast-300, white)}.cnet-button-toggle-checked:hover.cnet-color-danger{color:var(--cnet-danger-contrast-300, rgba(0, 0, 0, .85))}.cnet-row:hover{background-color:#00000005}.cnet-row .cnet-cell,.cnet-row .cnet-header-cell,.cnet-header-row .cnet-cell,.cnet-header-row .cnet-header-cell{border-bottom:1px solid #e6e6e6}.cnet-cell,.cnet-header-cell,.cnet-footer-cell{padding:.75rem}.cnet-footer-cell{border-top:1px solid #e6e6e6;font-weight:700}.td-mobile{display:flex;flex-wrap:wrap}@media (max-width: 1199.98px){.cnet-table,tbody,tfoot,.cnet-cell,.cnet-row{display:block;width:100%}.cnet-row{background-color:#fff;border:1px solid #e6e6e6;margin-bottom:1rem;border-radius:.25rem}.cnet-row .cnet-cell:last-child{border-width:0}.cnet-row .cnet-cell:before{content:var(--datath);display:block;margin-right:.25rem;font-weight:700}.cnet-header-row{display:none}.cnet-footer-row{width:100%;display:flex;justify-content:space-between;background-color:#fff;border:1px solid #e6e6e6;border-radius:.25rem}.cnet-footer-cell{border-width:0}}@media (min-width: 768px){.cnet-cell-left{text-align:left}.cnet-cell-center{text-align:center}.cnet-cell-right{text-align:left}}\n"] }]
        }] });

class CnetRowDefDirective extends CdkRowDef {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetRowDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetRowDefDirective, selector: "[cnetRowDef]", inputs: { columns: ["cnetRowDefColumns", "columns"], when: ["cnetRowDefWhen", "when"] }, providers: [{ provide: CdkRowDef, useExisting: CnetRowDefDirective }], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetRowDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetRowDef]',
                    providers: [{ provide: CdkRowDef, useExisting: CnetRowDefDirective }],
                    inputs: ['columns: cnetRowDefColumns', 'when: cnetRowDefWhen'],
                }]
        }], propDecorators: { columns: [{
                type: Input,
                args: ['cnetRowDefColumns']
            }] } });
class CnetRowComponent extends CdkRow {
    constructor() {
        super(...arguments);
        this.checked = false;
        this.color = null;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetRowComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetRowComponent, selector: "cnet-row, tr[cnet-row]", inputs: { checked: "checked", color: "color" }, host: { attributes: { "role": "row" }, properties: { "class.cnet-button-toggle-checked": "checked", "class.cnet-color-success": "color == \"success\"", "class.cnet-color-cancel": "color == \"cancel\"", "class.cnet-color-primary": "color == \"primary\"", "class.cnet-color-secondary": "color == \"secondary\"", "class.cnet-color-danger": "color == \"danger\"" }, classAttribute: "cnet-row" }, providers: [{ provide: CdkRow, useExisting: CnetRowComponent }], exportAs: ["cnetRow"], usesInheritance: true, ngImport: i0, template: "<ng-container cdkCellOutlet></ng-container>", isInline: true, styles: [".cnet-table{width:100%;max-width:100%;margin-bottom:1rem;border-spacing:0}.cnet-button-toggle-checked{font-weight:700}.cnet-button-toggle-checked.cnet-color-success{background-color:var(--cnet-success-500, #47ba65)}.cnet-button-toggle-checked.cnet-color-cancel{background-color:var(--cnet-cancel-500, #9e9e9e)}.cnet-button-toggle-checked.cnet-color-primary{background-color:var(--cnet-primary-500, #82c14f)}.cnet-button-toggle-checked.cnet-color-secondary{background-color:var(--cnet-secondary-500, #3d4155)}.cnet-button-toggle-checked.cnet-color-danger{background-color:var(--cnet-danger-500, #ee4446)}.cnet-button-toggle-checked.cnet-color-success{color:var(--cnet-success-contrast-500, white)}.cnet-button-toggle-checked.cnet-color-cancel{color:var(--cnet-cancel-contrast-500, white)}.cnet-button-toggle-checked.cnet-color-primary{color:var(--cnet-primary-contrast-500, white)}.cnet-button-toggle-checked.cnet-color-secondary{color:var(--cnet-secondary-contrast-500, white)}.cnet-button-toggle-checked.cnet-color-danger{color:var(--cnet-danger-contrast-500, white)}.cnet-button-toggle-checked:hover{transition:background-color ease .3s,color ease .3s}.cnet-button-toggle-checked:hover.cnet-color-success{background-color:var(--cnet-success-300, #7ecf93)}.cnet-button-toggle-checked:hover.cnet-color-cancel{background-color:var(--cnet-cancel-300, #e0e0e0)}.cnet-button-toggle-checked:hover.cnet-color-primary{background-color:var(--cnet-primary-300, #a8d484)}.cnet-button-toggle-checked:hover.cnet-color-secondary{background-color:var(--cnet-secondary-300, #777a88)}.cnet-button-toggle-checked:hover.cnet-color-danger{background-color:var(--cnet-danger-300, #f37c7e)}.cnet-button-toggle-checked:hover.cnet-color-success{color:var(--cnet-success-contrast-300, rgba(0, 0, 0, .85))}.cnet-button-toggle-checked:hover.cnet-color-cancel{color:var(--cnet-cancel-contrast-300, rgba(0, 0, 0, .85))}.cnet-button-toggle-checked:hover.cnet-color-primary{color:var(--cnet-primary-contrast-300, rgba(0, 0, 0, .85))}.cnet-button-toggle-checked:hover.cnet-color-secondary{color:var(--cnet-secondary-contrast-300, white)}.cnet-button-toggle-checked:hover.cnet-color-danger{color:var(--cnet-danger-contrast-300, rgba(0, 0, 0, .85))}.cnet-row:hover{background-color:#00000005}.cnet-row .cnet-cell,.cnet-row .cnet-header-cell,.cnet-header-row .cnet-cell,.cnet-header-row .cnet-header-cell{border-bottom:1px solid #e6e6e6}.cnet-cell,.cnet-header-cell,.cnet-footer-cell{padding:.75rem}.cnet-footer-cell{border-top:1px solid #e6e6e6;font-weight:700}.td-mobile{display:flex;flex-wrap:wrap}@media (max-width: 1199.98px){.cnet-table,tbody,tfoot,.cnet-cell,.cnet-row{display:block;width:100%}.cnet-row{background-color:#fff;border:1px solid #e6e6e6;margin-bottom:1rem;border-radius:.25rem}.cnet-row .cnet-cell:last-child{border-width:0}.cnet-row .cnet-cell:before{content:var(--datath);display:block;margin-right:.25rem;font-weight:700}.cnet-header-row{display:none}.cnet-footer-row{width:100%;display:flex;justify-content:space-between;background-color:#fff;border:1px solid #e6e6e6;border-radius:.25rem}.cnet-footer-cell{border-width:0}}@media (min-width: 768px){.cnet-cell-left{text-align:left}.cnet-cell-center{text-align:center}.cnet-cell-right{text-align:left}}\n"], dependencies: [{ kind: "directive", type: i1$b.CdkCellOutlet, selector: "[cdkCellOutlet]" }], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetRowComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-row, tr[cnet-row]', exportAs: 'cnetRow', host: {
                        class: 'cnet-row',
                        '[class.cnet-button-toggle-checked]': 'checked',
                        '[class.cnet-color-success]': 'color == "success"',
                        '[class.cnet-color-cancel]': 'color == "cancel"',
                        '[class.cnet-color-primary]': 'color == "primary"',
                        '[class.cnet-color-secondary]': 'color == "secondary"',
                        '[class.cnet-color-danger]': 'color == "danger"',
                        role: 'row',
                    }, template: CDK_ROW_TEMPLATE, changeDetection: ChangeDetectionStrategy.Default, encapsulation: ViewEncapsulation.None, providers: [{ provide: CdkRow, useExisting: CnetRowComponent }], styles: [".cnet-table{width:100%;max-width:100%;margin-bottom:1rem;border-spacing:0}.cnet-button-toggle-checked{font-weight:700}.cnet-button-toggle-checked.cnet-color-success{background-color:var(--cnet-success-500, #47ba65)}.cnet-button-toggle-checked.cnet-color-cancel{background-color:var(--cnet-cancel-500, #9e9e9e)}.cnet-button-toggle-checked.cnet-color-primary{background-color:var(--cnet-primary-500, #82c14f)}.cnet-button-toggle-checked.cnet-color-secondary{background-color:var(--cnet-secondary-500, #3d4155)}.cnet-button-toggle-checked.cnet-color-danger{background-color:var(--cnet-danger-500, #ee4446)}.cnet-button-toggle-checked.cnet-color-success{color:var(--cnet-success-contrast-500, white)}.cnet-button-toggle-checked.cnet-color-cancel{color:var(--cnet-cancel-contrast-500, white)}.cnet-button-toggle-checked.cnet-color-primary{color:var(--cnet-primary-contrast-500, white)}.cnet-button-toggle-checked.cnet-color-secondary{color:var(--cnet-secondary-contrast-500, white)}.cnet-button-toggle-checked.cnet-color-danger{color:var(--cnet-danger-contrast-500, white)}.cnet-button-toggle-checked:hover{transition:background-color ease .3s,color ease .3s}.cnet-button-toggle-checked:hover.cnet-color-success{background-color:var(--cnet-success-300, #7ecf93)}.cnet-button-toggle-checked:hover.cnet-color-cancel{background-color:var(--cnet-cancel-300, #e0e0e0)}.cnet-button-toggle-checked:hover.cnet-color-primary{background-color:var(--cnet-primary-300, #a8d484)}.cnet-button-toggle-checked:hover.cnet-color-secondary{background-color:var(--cnet-secondary-300, #777a88)}.cnet-button-toggle-checked:hover.cnet-color-danger{background-color:var(--cnet-danger-300, #f37c7e)}.cnet-button-toggle-checked:hover.cnet-color-success{color:var(--cnet-success-contrast-300, rgba(0, 0, 0, .85))}.cnet-button-toggle-checked:hover.cnet-color-cancel{color:var(--cnet-cancel-contrast-300, rgba(0, 0, 0, .85))}.cnet-button-toggle-checked:hover.cnet-color-primary{color:var(--cnet-primary-contrast-300, rgba(0, 0, 0, .85))}.cnet-button-toggle-checked:hover.cnet-color-secondary{color:var(--cnet-secondary-contrast-300, white)}.cnet-button-toggle-checked:hover.cnet-color-danger{color:var(--cnet-danger-contrast-300, rgba(0, 0, 0, .85))}.cnet-row:hover{background-color:#00000005}.cnet-row .cnet-cell,.cnet-row .cnet-header-cell,.cnet-header-row .cnet-cell,.cnet-header-row .cnet-header-cell{border-bottom:1px solid #e6e6e6}.cnet-cell,.cnet-header-cell,.cnet-footer-cell{padding:.75rem}.cnet-footer-cell{border-top:1px solid #e6e6e6;font-weight:700}.td-mobile{display:flex;flex-wrap:wrap}@media (max-width: 1199.98px){.cnet-table,tbody,tfoot,.cnet-cell,.cnet-row{display:block;width:100%}.cnet-row{background-color:#fff;border:1px solid #e6e6e6;margin-bottom:1rem;border-radius:.25rem}.cnet-row .cnet-cell:last-child{border-width:0}.cnet-row .cnet-cell:before{content:var(--datath);display:block;margin-right:.25rem;font-weight:700}.cnet-header-row{display:none}.cnet-footer-row{width:100%;display:flex;justify-content:space-between;background-color:#fff;border:1px solid #e6e6e6;border-radius:.25rem}.cnet-footer-cell{border-width:0}}@media (min-width: 768px){.cnet-cell-left{text-align:left}.cnet-cell-center{text-align:center}.cnet-cell-right{text-align:left}}\n"] }]
        }], propDecorators: { checked: [{
                type: Input
            }], color: [{
                type: Input
            }] } });
class CnetFooterRowDefDirective extends CdkFooterRowDef {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFooterRowDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetFooterRowDefDirective, selector: "[cnetFooterRowDef]", inputs: { columns: ["cnetFooterRowDef", "columns"] }, providers: [{ provide: CdkFooterRowDef, useExisting: CnetFooterRowDefDirective }], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFooterRowDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetFooterRowDef]',
                    providers: [{ provide: CdkFooterRowDef, useExisting: CnetFooterRowDefDirective }],
                }]
        }], propDecorators: { columns: [{
                type: Input,
                args: ['cnetFooterRowDef']
            }] } });
class CnetFooterRowComponent extends CdkFooterRow {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFooterRowComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetFooterRowComponent, selector: "cnet-footer-row, tr[cnet-footer-row]", host: { attributes: { "role": "row" }, classAttribute: "cnet-footer-row" }, providers: [{ provide: CdkFooterRow, useExisting: CnetFooterRowComponent }], exportAs: ["cnetFooterRow"], usesInheritance: true, ngImport: i0, template: "<ng-container cdkCellOutlet></ng-container>", isInline: true, dependencies: [{ kind: "directive", type: i1$b.CdkCellOutlet, selector: "[cdkCellOutlet]" }], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFooterRowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'cnet-footer-row, tr[cnet-footer-row]',
                    exportAs: 'cnetFooterRow',
                    host: {
                        class: 'cnet-footer-row',
                        role: 'row',
                    },
                    template: CDK_ROW_TEMPLATE,
                    changeDetection: ChangeDetectionStrategy.Default,
                    encapsulation: ViewEncapsulation.None,
                    providers: [{ provide: CdkFooterRow, useExisting: CnetFooterRowComponent }],
                }]
        }] });
class CnetHeaderRowDefDirective extends CdkHeaderRowDef {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetHeaderRowDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetHeaderRowDefDirective, selector: "[cnetHeaderRowDef]", inputs: { columns: ["cnetHeaderRowDef", "columns"] }, providers: [{ provide: CdkHeaderRowDef, useExisting: CnetHeaderRowDefDirective }], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetHeaderRowDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetHeaderRowDef]',
                    providers: [{ provide: CdkHeaderRowDef, useExisting: CnetHeaderRowDefDirective }],
                }]
        }], propDecorators: { columns: [{
                type: Input,
                args: ['cnetHeaderRowDef']
            }] } });
class CnetHeaderRowComponent extends CdkHeaderRow {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetHeaderRowComponent, deps: null, target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetHeaderRowComponent, selector: "cnet-header-row, tr[cnet-header-row]", host: { attributes: { "role": "row" }, classAttribute: "cnet-header-row" }, providers: [{ provide: CdkHeaderRow, useExisting: CnetHeaderRowComponent }], exportAs: ["cnetHeaderRow"], usesInheritance: true, ngImport: i0, template: "<ng-container cdkCellOutlet></ng-container>", isInline: true, dependencies: [{ kind: "directive", type: i1$b.CdkCellOutlet, selector: "[cdkCellOutlet]" }], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetHeaderRowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'cnet-header-row, tr[cnet-header-row]',
                    exportAs: 'cnetHeaderRow',
                    host: {
                        class: 'cnet-header-row',
                        role: 'row',
                    },
                    template: CDK_ROW_TEMPLATE,
                    changeDetection: ChangeDetectionStrategy.Default,
                    encapsulation: ViewEncapsulation.None,
                    providers: [{ provide: CdkHeaderRow, useExisting: CnetHeaderRowComponent }],
                }]
        }] });

class CnetCellDefDirective extends CdkCellDef {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCellDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetCellDefDirective, selector: "[cnetCellDef]", providers: [{ provide: CdkCellDef, useExisting: CnetCellDefDirective }], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCellDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetCellDef]',
                    providers: [{ provide: CdkCellDef, useExisting: CnetCellDefDirective }]
                }]
        }] });
class CnetCellDirective extends CdkCell {
    get datath() {
        return this._datath;
    }
    set datath(datath) {
        this._datath = datath;
        this.checkIfMobile();
    }
    constructor(columnDef, elementRef) {
        super(columnDef, elementRef);
        this.elementRef2 = inject(ElementRef);
        this.renderer = inject(Renderer2);
        elementRef.nativeElement.classList.add(`cnet-column-${columnDef.cssClassFriendlyName}`);
        this.windowScreenSize = window.innerWidth;
    }
    onResize(event) {
        this.windowScreenSize = event.target.innerWidth;
        this.checkIfMobile();
    }
    checkIfMobile() {
        if (this.datath) {
            if (this.windowScreenSize <= 1024) {
                if (!(this.elementRef2.nativeElement.firstChild && this.elementRef2.nativeElement.firstChild.id === 'header-collumn-mobile')) {
                    const child = document.createElement('div');
                    child.id = 'header-collumn-mobile';
                    child.style.margin = '0px 4px 0px 0px';
                    child.style.fontWeight = 'bold';
                    child.appendChild(document.createTextNode(`${this.datath} : `));
                    this.renderer.insertBefore(this.elementRef2.nativeElement, child, this.elementRef2.nativeElement.firstChild);
                    this.elementRef2.nativeElement.classList.add(`td-mobile`);
                }
                else {
                    // update datath
                    this.elementRef2.nativeElement.firstChild.innerText = `${this.datath} : `;
                }
            }
            else {
                if (this.elementRef2.nativeElement.firstChild && this.elementRef2.nativeElement.firstChild.id === 'header-collumn-mobile') {
                    this.elementRef2.nativeElement.classList.remove(`td-mobile`);
                    this.renderer.removeChild(this.elementRef2.nativeElement, this.elementRef2.nativeElement.firstChild);
                }
            }
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCellDirective, deps: [{ token: i1$b.CdkColumnDef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetCellDirective, selector: "cnet-cell, [cnetCell], td[cnet-cell]", inputs: { datath: "datath" }, host: { attributes: { "role": "gridcell" }, listeners: { "window:resize": "onResize($event)" }, classAttribute: "cnet-cell" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetCellDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-cell, [cnetCell], td[cnet-cell]',
                    host: {
                        class: 'cnet-cell',
                        role: 'gridcell',
                    },
                }]
        }], ctorParameters: () => [{ type: i1$b.CdkColumnDef }, { type: i0.ElementRef }], propDecorators: { datath: [{
                type: Input
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });
class CnetColumnDefDirective extends CdkColumnDef {
    // @Input('matColumnDef')
    get name() {
        return this._name;
    }
    set name(name) {
        this._setNameInput(name);
    }
    /**
     * Add "mat-column-" prefix in addition to "cdk-column-" prefix.
     * In the future, this will only add "mat-column-" and columnCssClassName
     * will change from type string[] to string.
     * @docs-private
     */
    _updateColumnCssClassName() {
        super._updateColumnCssClassName();
        this._columnCssClassName.push(`mat-column-${this.cssClassFriendlyName}`);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetColumnDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetColumnDefDirective, selector: "[cnetColumnDef]", inputs: { name: ["cnetColumnDef", "name"] }, providers: [
            { provide: CdkColumnDef, useExisting: CnetColumnDefDirective },
            { provide: 'MAT_SORT_HEADER_COLUMN_DEF', useExisting: CnetColumnDefDirective }
        ], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetColumnDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetColumnDef]',
                    providers: [
                        { provide: CdkColumnDef, useExisting: CnetColumnDefDirective },
                        { provide: 'MAT_SORT_HEADER_COLUMN_DEF', useExisting: CnetColumnDefDirective }
                    ],
                }]
        }], propDecorators: { name: [{
                type: Input,
                args: ['cnetColumnDef']
            }] } });
class CnetHeaderCellDefDirective extends CdkHeaderCellDef {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetHeaderCellDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetHeaderCellDefDirective, selector: "[cnetHeaderCellDef]", providers: [{ provide: CdkHeaderCellDef, useExisting: CnetHeaderCellDefDirective }], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetHeaderCellDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetHeaderCellDef]',
                    providers: [{ provide: CdkHeaderCellDef, useExisting: CnetHeaderCellDefDirective }]
                }]
        }] });
class CnetHeaderCellDirective extends CdkHeaderCell {
    constructor(columnDef, elementRef) {
        super(columnDef, elementRef);
        elementRef.nativeElement.classList.add(`cnet-column-${columnDef.cssClassFriendlyName}`);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetHeaderCellDirective, deps: [{ token: i1$b.CdkColumnDef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetHeaderCellDirective, selector: "cnet-header-cell, [cnetHeaderCell], th[cnet-header-cell]", host: { attributes: { "role": "columnheader" }, classAttribute: "cnet-header-cell" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetHeaderCellDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-header-cell, [cnetHeaderCell], th[cnet-header-cell]',
                    host: {
                        class: 'cnet-header-cell',
                        role: 'columnheader',
                    },
                }]
        }], ctorParameters: () => [{ type: i1$b.CdkColumnDef }, { type: i0.ElementRef }] });
class CnetFooterCellDefDirective extends CdkFooterCellDef {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFooterCellDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetFooterCellDefDirective, selector: "[cnetFooterCellDef]", providers: [{ provide: CdkFooterCellDef, useExisting: CnetFooterCellDefDirective }], usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFooterCellDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetFooterCellDef]',
                    providers: [{ provide: CdkFooterCellDef, useExisting: CnetFooterCellDefDirective }]
                }]
        }] });
class CnetFooterCellDirective extends CdkFooterCell {
    constructor(columnDef, elementRef) {
        super(columnDef, elementRef);
        elementRef.nativeElement.classList.add(`cnet-column-${columnDef.cssClassFriendlyName}`);
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFooterCellDirective, deps: [{ token: i1$b.CdkColumnDef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetFooterCellDirective, selector: "cnet-footer-cell, [cnetFooterCell], td[cnet-footer-cell]", host: { attributes: { "role": "gridcell" }, classAttribute: "cnet-footer-cell" }, usesInheritance: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetFooterCellDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'cnet-footer-cell, [cnetFooterCell], td[cnet-footer-cell]',
                    host: {
                        class: 'cnet-footer-cell',
                        role: 'gridcell',
                    },
                }]
        }], ctorParameters: () => [{ type: i1$b.CdkColumnDef }, { type: i0.ElementRef }] });

const fadeInAnimation$1 = [
    style({ height: '0px', margin: '0', paddingTop: '0', paddingBottom: '0', visibility: 'hidden', position: 'relative', top: '-41px', opacity: 0, display: 'block', lineHeight: '0' }),
    animate('150ms ease-out', style({ height: '*', margin: '*', paddingTop: '0.75rem', paddingBottom: '0.75rem', visibility: 'visible', position: 'relative', top: '0', opacity: 1, display: 'table-cell', lineHeight: '1.5' })),
];
const fadeOutAnimation$1 = [
    style({ height: '*', margin: '*', paddingTop: '0.75rem', paddingBottom: '0.75rem', visibility: 'visible', position: 'relative', top: '0', opacity: 1, display: 'table-cell', lineHeight: '1.5' }),
    animate('150ms ease-out', style({ height: '0px', margin: '0', paddingTop: '0', paddingBottom: '0', visibility: 'hidden', position: 'relative', top: '-41px', opacity: 0, display: 'block', lineHeight: '0' })),
];
class ExpandRowDirective {
    constructor(elementRef, animationBuilder, cdr) {
        this.elementRef = elementRef;
        this.animationBuilder = animationBuilder;
        this.cdr = cdr;
        this._expanded = false;
    }
    ngOnChanges(changes) {
        if (!changes.expanded.firstChange && changes.expanded.previousValue !== changes.expanded.currentValue) {
            const metadata = this.expanded ? fadeInAnimation$1 : fadeOutAnimation$1;
            this.playAnimation(this.expanded, metadata);
        }
    }
    ngOnInit() {
        this.elementRef.nativeElement.style.height = '0';
        this.elementRef.nativeElement.style.margin = '0';
        this.elementRef.nativeElement.style.paddingTop = '0';
        this.elementRef.nativeElement.style.paddingBottom = '0';
        this.elementRef.nativeElement.style.visibility = 'hidden';
        this.elementRef.nativeElement.style.position = 'relative';
        this.elementRef.nativeElement.style.top = '-41px';
        this.elementRef.nativeElement.style.opacity = '0';
        this.elementRef.nativeElement.style.lineHeight = '0';
        this.elementRef.nativeElement.style.display = 'block';
    }
    playAnimation(expanded, metadata) {
        if (this.player) {
            this.player.destroy();
        }
        const factory = this.animationBuilder.build(metadata);
        this.player = factory.create(this.elementRef.nativeElement);
        this.player.play();
        this.player.onDone(() => {
            this.cdr.detectChanges();
        });
        this.cdr.detectChanges();
    }
    ngOnDestroy() {
        if (this.player) {
            this.player.destroy();
        }
    }
    getCollapseAnimation() {
        return [style({ height: '0px', minHeight: '0' }), animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')];
    }
    getExpandAnimation() {
        return [style({ height: '*' }), animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')];
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExpandRowDirective, deps: [{ token: i0.ElementRef }, { token: i1$c.AnimationBuilder }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: ExpandRowDirective, selector: "[expandRow]", inputs: { expanded: "expanded" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: ExpandRowDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[expandRow]',
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$c.AnimationBuilder }, { type: i0.ChangeDetectorRef }], propDecorators: { expanded: [{
                type: Input
            }] } });

const fadeInAnimation = [
    style({ height: '0px', minHeight: '0', visibility: 'hidden' }),
    animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ height: '*', visibility: 'visible' })),
];
const fadeOutAnimation = [
    style({ height: '*', visibility: 'visible' }),
    animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ height: '0px', minHeight: '0', visibility: 'hidden' })),
];
class CdkDetailRowDirective {
    get expended() {
        return this.opened;
    }
    set cdkDetailRow(value) {
        if (value !== this.row) {
            this.row = value;
            // this.render();
        }
    }
    set template(value) {
        if (value !== this.tRef) {
            this.tRef = value;
            // this.render();
        }
    }
    constructor(vcRef, animationBuilder, elementRef, cdr) {
        this.vcRef = vcRef;
        this.animationBuilder = animationBuilder;
        this.elementRef = elementRef;
        this.cdr = cdr;
    }
    onClick() {
        this.toggle();
    }
    toggle() {
        if (this.opened) {
            this.playAnimation(this.opened, fadeInAnimation);
            this.vcRef.clear();
            this.embebedView = null;
        }
        else {
            this.playAnimation(this.opened, fadeOutAnimation);
            this.render();
        }
        this.opened = this.vcRef.length > 0;
    }
    render() {
        this.vcRef.clear();
        if (this.tRef && this.row) {
            this.embebedView = this.vcRef.createEmbeddedView(this.tRef, { $implicit: this.row });
        }
    }
    playAnimation(expanded, metadata) {
        if (this.embebedView) {
            if (this.player) {
                this.player.destroy();
            }
            const factory = this.animationBuilder.build(metadata);
            // this.player = factory.create(this.elementRef.nativeElement);
            // this.player = factory.create(this.template.elementRef.nativeElement);
            // this.player = factory.create(this.vcRef.element.nativeElement);
            this.player = factory.create(this.embebedView.rootNodes[0]);
            this.player.play();
            this.player.onDone(() => {
                this.cdr.detectChanges();
            });
            this.cdr.detectChanges();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CdkDetailRowDirective, deps: [{ token: i0.ViewContainerRef }, { token: i1$c.AnimationBuilder }, { token: i0.ElementRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CdkDetailRowDirective, selector: "[cdkDetailRow]", inputs: { cdkDetailRow: "cdkDetailRow", template: ["cdkDetailRowTpl", "template"] }, host: { listeners: { "click": "onClick()" }, properties: { "class.expanded": "this.expended" } }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CdkDetailRowDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cdkDetailRow]'
                }]
        }], ctorParameters: () => [{ type: i0.ViewContainerRef }, { type: i1$c.AnimationBuilder }, { type: i0.ElementRef }, { type: i0.ChangeDetectorRef }], propDecorators: { expended: [{
                type: HostBinding,
                args: ['class.expanded']
            }], cdkDetailRow: [{
                type: Input
            }], template: [{
                type: Input,
                args: ['cdkDetailRowTpl']
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

const declarations = [
    CnetTableComponent,
    CnetRowDefDirective,
    CnetRowComponent,
    CnetFooterRowDefDirective,
    CnetFooterRowComponent,
    CnetHeaderRowDefDirective,
    CnetHeaderRowComponent,
    CnetCellDefDirective,
    CnetCellDirective,
    CnetColumnDefDirective,
    CnetHeaderCellDefDirective,
    CnetHeaderCellDirective,
    CnetFooterCellDefDirective,
    CnetFooterCellDirective,
    CnetRecycleRowsDirective,
    ExpandRowDirective,
    CdkDetailRowDirective
];
class CnetTableModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetTableModule, declarations: [CnetTableComponent,
            CnetRowDefDirective,
            CnetRowComponent,
            CnetFooterRowDefDirective,
            CnetFooterRowComponent,
            CnetHeaderRowDefDirective,
            CnetHeaderRowComponent,
            CnetCellDefDirective,
            CnetCellDirective,
            CnetColumnDefDirective,
            CnetHeaderCellDefDirective,
            CnetHeaderCellDirective,
            CnetFooterCellDefDirective,
            CnetFooterCellDirective,
            CnetRecycleRowsDirective,
            ExpandRowDirective,
            CdkDetailRowDirective], imports: [CommonModule,
            CdkTableModule], exports: [CdkTableModule, CnetTableComponent,
            CnetRowDefDirective,
            CnetRowComponent,
            CnetFooterRowDefDirective,
            CnetFooterRowComponent,
            CnetHeaderRowDefDirective,
            CnetHeaderRowComponent,
            CnetCellDefDirective,
            CnetCellDirective,
            CnetColumnDefDirective,
            CnetHeaderCellDefDirective,
            CnetHeaderCellDirective,
            CnetFooterCellDefDirective,
            CnetFooterCellDirective,
            CnetRecycleRowsDirective,
            ExpandRowDirective,
            CdkDetailRowDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTableModule, imports: [CommonModule,
            CdkTableModule, CdkTableModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTableModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        ...declarations
                    ],
                    imports: [
                        CommonModule,
                        CdkTableModule,
                    ],
                    exports: [
                        CdkTableModule,
                        ...declarations
                    ]
                }]
        }] });

class CnetTabHeaderDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    get id() { return this._id; }
    set id(value) {
        this._id = value;
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTabHeaderDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetTabHeaderDirective, selector: "[cnetTabHeader], [cnet-tab-header]", inputs: { id: "id" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTabHeaderDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetTabHeader], [cnet-tab-header]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { id: [{
                type: Input
            }] } });

class CnetTabComponent {
    get tabGroupInstance() { return this._tabGroupInstance; }
    set tabGroupInstance(value) {
        this._tabGroupInstance = value;
    }
    get active() { return this._active; }
    set active(value) {
        setTimeout(() => {
            this._active = coerceBooleanProperty(value);
            if (coerceBooleanProperty(value)) {
                this._tabGroupInstance.selectTabFromTab(this);
            }
        });
    }
    constructor(_elementRef, _focusMonitor) {
        this._elementRef = _elementRef;
        this._focusMonitor = _focusMonitor;
        // private _title: string = '';
        this._title = '';
        this._active = false;
        this.routerLink = '';
        this.selectedTab = new EventEmitter();
        this._focusMonitor.monitor(this._elementRef, true);
    }
    ngOnDestroy() {
        this._focusMonitor.stopMonitoring(this._elementRef);
    }
    focus(origin = 'program', options) {
        this._focusMonitor.focusVia(this._elementRef.nativeElement, origin, options);
    }
    get title() { return this._title; }
    set title(value) {
        this._title = value;
    }
    isTitleString() {
        return typeof this.title === 'string';
    }
    get id() { return this._id; }
    set id(value) {
        this._id = value;
    }
    get getToggleDrawer() {
        return this.active ? 'show' : 'hide';
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTabComponent, deps: [{ token: i0.ElementRef }, { token: i1$2.FocusMonitor }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetTabComponent, selector: "cnet-tab, [cnet-tab], [cnetTab]", inputs: { tabGroupInstance: "tabGroupInstance", active: "active", routerLink: "routerLink", title: ["tab-title", "title"] }, outputs: { selectedTab: "selectedTab" }, host: { attributes: { "role": "tabpanel", "tabindex": "0" }, properties: { "attr.cdkMonitorElementFocus": "true", "hidden": "!active", "class.cnet-tab-hidden": "!active", "attr.aria-label": "title", "@fadeIn": "this.getToggleDrawer" }, classAttribute: "cnet-tab" }, exportAs: ["cnetTab"], ngImport: i0, template: "<ng-content></ng-content>", animations: [
            trigger('fadeIn', [
                state('hide', style({
                    opacity: 0
                })),
                state('show', style({
                    opacity: 1
                })),
                transition('hide=>show', animate('400ms'))
            ]),
        ], changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTabComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-tab, [cnet-tab], [cnetTab]', exportAs: 'cnetTab', host: {
                        class: 'cnet-tab',
                        role: 'tabpanel',
                        tabindex: '0',
                        '[attr.cdkMonitorElementFocus]': 'true',
                        '[hidden]': '!active',
                        '[class.cnet-tab-hidden]': '!active',
                        '[attr.aria-label]': 'title',
                    }, changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, animations: [
                        trigger('fadeIn', [
                            state('hide', style({
                                opacity: 0
                            })),
                            state('show', style({
                                opacity: 1
                            })),
                            transition('hide=>show', animate('400ms'))
                        ]),
                    ], template: "<ng-content></ng-content>" }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i1$2.FocusMonitor }], propDecorators: { tabGroupInstance: [{
                type: Input
            }], active: [{
                type: Input
            }], routerLink: [{
                type: Input
            }], selectedTab: [{
                type: Output
            }], title: [{
                type: Input,
                args: ['tab-title']
            }], getToggleDrawer: [{
                type: HostBinding,
                args: ['@fadeIn']
            }] } });

class CnetTabGroupComponent {
    constructor(_router, _activatedRoute) {
        this._router = _router;
        this._activatedRoute = _activatedRoute;
    }
    ngAfterViewInit() {
        //Called after every check of the component's or directive's content.
        //Add 'implements AfterContentChecked' to the class.
        this.tabs.map((tab, index) => { tab.id = index; tab.tabGroupInstance = this; });
        setTimeout(() => {
            if (this.tabs.length >= 1) {
                // serch if has some tab alredy activated. If dosen't them set the first tab as the activated one
                if (!this.tabs.toArray().some(tab => tab.active === true)) {
                    this.tabs.first.active = true;
                }
            }
        }, 200);
        this.tabs.notifyOnChanges = () => {
            this.tabs.map((tab, index) => tab.id = index);
            if (this.tabs.length >= 1) {
                this.tabs.first.active = true;
            }
        };
    }
    ngAfterContentChecked() {
        this.tabs.map((tab, index) => { tab.id = index; tab.tabGroupInstance = this; });
    }
    selectTab(tab) {
        this.tabs.map(tab => tab.active = false);
        tab.active = true;
        if (this.tabsHeader) {
            let activeHeader = this.tabsHeader.toArray().find(header => header.id == tab.id);
            tab.selectedTab.emit(tab);
            if (activeHeader) {
                activeHeader.elementRef.nativeElement.focus();
            }
        }
        // if has routerLink
        if (tab.routerLink) {
            this._router.navigate([tab.routerLink], { relativeTo: this._activatedRoute });
        }
    }
    selectTabFromTab(tab) {
        this.tabs.map(tabAux => { if (tabAux.id !== tab.id) {
            tabAux.active = false;
        } });
        if (this.tabsHeader) {
            let activeHeader = this.tabsHeader.toArray().find(header => header.id == tab.id);
            if (activeHeader) {
                activeHeader.elementRef.nativeElement.focus();
            }
        }
    }
    selectFirstTab() {
        this.selectTab(this.tabs.first);
    }
    selectLastTab() {
        this.selectTab(this.tabs.last);
    }
    onKeyUp(event) {
        let active = this.tabs.find(tab => tab.active);
        switch (event.keyCode) {
            case RIGHT_ARROW:
                let next = active === this.tabs.last ? this.tabs.first : this.tabs.toArray()[active.id + 1];
                this.selectTab(next);
                break;
            case LEFT_ARROW:
                let previous = active === this.tabs.first ? this.tabs.last : this.tabs.toArray()[active.id - 1];
                this.selectTab(previous);
                break;
            case HOME:
                let first = this.tabs.first;
                this.selectTab(first);
                break;
            case END:
                let last = this.tabs.last;
                this.selectTab(last);
                break;
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTabGroupComponent, deps: [{ token: i1$d.Router }, { token: i1$d.ActivatedRoute }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetTabGroupComponent, selector: "cnet-tab-group, [cnet-tab-group], cnetTabGroup", host: { classAttribute: "cnet-tab-group" }, queries: [{ propertyName: "tabs", predicate: CnetTabComponent }], viewQueries: [{ propertyName: "tabsHeader", predicate: CnetTabHeaderDirective, descendants: true }], exportAs: ["cnetTabGroup"], ngImport: i0, template: "<div class=\"cnet-tab-header\" role=\"tablist\">\n  <button type=\"button\" cnet-tab-header cdkMonitorElementFocus *ngFor=\"let tab of tabs\" class=\"cnet-tab-title\" role=\"tab\" cnetRipple\n    (keyup)=\"onKeyUp($event)\" (click)=\"selectTab(tab)\" [id]=\"tab.id\" [attr.tabindex]=\"tab.active ? 0 : -1\"\n    [attr.aria-selected]=\"tab.active\" [class.cnet-tab-title-active]=\"tab.active\">\n\n    <ng-container *ngIf=\"tab.isTitleString(); else elseHasTemplate\">\n      {{tab.title}}\n    </ng-container>\n    <ng-template #elseHasTemplate>\n      <ng-template *ngTemplateOutlet=\"tab.title\"></ng-template>\n    </ng-template>\n\n\n  </button>\n</div>\n<div class=\"cnet-tab-body\">\n  <ng-content></ng-content>\n</div>\n", styles: [".cnet-tab-header{display:flex;border-bottom:2px solid #e0e0e0}.cnet-tab-title{padding:.75rem 1rem;border:none;border-radius:0;background-color:transparent;text-transform:uppercase;font-size:.875rem;color:#000000ab;-ms-flex-pack:center;justify-content:center;cursor:pointer;margin-bottom:-2px;border-bottom-style:solid;border-bottom-width:2px;border-bottom-color:transparent;-webkit-user-select:none;user-select:none;transition:color ease-in .2s,border-bottom-color ease-in .3s}.cnet-tab-title:hover,.cnet-tab-title:focus{color:var(--cnet-primary-500, #82c14f)}.cnet-tab-title-active{color:var(--cnet-primary-500, #82c14f);border-bottom-color:var(--cnet-primary-500, #82c14f)}.cnet-tab-body{position:relative;display:block}.cnet-tab{display:block;padding:1rem}.cnet-tab.cnet-tab-hidden{display:none}.cnet-tab p{margin:0}@media (max-width: 575.98px){.cnet-tab-header{flex-direction:column;border-bottom:none}}\n"], dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: CnetRippleDirective, selector: "[cnet-ripple], [cnetRipple]", inputs: ["cnetRippleColor", "cnetRippleUnbounded", "cnetRippleCentered", "cnetRippleRadius", "cnetRippleAnimation", "cnetRippleDisabled", "cnetRippleTrigger"], exportAs: ["cnetRipple"] }, { kind: "directive", type: i1$2.CdkMonitorFocus, selector: "[cdkMonitorElementFocus], [cdkMonitorSubtreeFocus]", outputs: ["cdkFocusChange"], exportAs: ["cdkMonitorFocus"] }, { kind: "directive", type: CnetTabHeaderDirective, selector: "[cnetTabHeader], [cnet-tab-header]", inputs: ["id"] }], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTabGroupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-tab-group, [cnet-tab-group], cnetTabGroup', exportAs: 'cnetTabGroup', host: {
                        class: 'cnet-tab-group'
                    }, changeDetection: ChangeDetectionStrategy.Default, encapsulation: ViewEncapsulation.None, template: "<div class=\"cnet-tab-header\" role=\"tablist\">\n  <button type=\"button\" cnet-tab-header cdkMonitorElementFocus *ngFor=\"let tab of tabs\" class=\"cnet-tab-title\" role=\"tab\" cnetRipple\n    (keyup)=\"onKeyUp($event)\" (click)=\"selectTab(tab)\" [id]=\"tab.id\" [attr.tabindex]=\"tab.active ? 0 : -1\"\n    [attr.aria-selected]=\"tab.active\" [class.cnet-tab-title-active]=\"tab.active\">\n\n    <ng-container *ngIf=\"tab.isTitleString(); else elseHasTemplate\">\n      {{tab.title}}\n    </ng-container>\n    <ng-template #elseHasTemplate>\n      <ng-template *ngTemplateOutlet=\"tab.title\"></ng-template>\n    </ng-template>\n\n\n  </button>\n</div>\n<div class=\"cnet-tab-body\">\n  <ng-content></ng-content>\n</div>\n", styles: [".cnet-tab-header{display:flex;border-bottom:2px solid #e0e0e0}.cnet-tab-title{padding:.75rem 1rem;border:none;border-radius:0;background-color:transparent;text-transform:uppercase;font-size:.875rem;color:#000000ab;-ms-flex-pack:center;justify-content:center;cursor:pointer;margin-bottom:-2px;border-bottom-style:solid;border-bottom-width:2px;border-bottom-color:transparent;-webkit-user-select:none;user-select:none;transition:color ease-in .2s,border-bottom-color ease-in .3s}.cnet-tab-title:hover,.cnet-tab-title:focus{color:var(--cnet-primary-500, #82c14f)}.cnet-tab-title-active{color:var(--cnet-primary-500, #82c14f);border-bottom-color:var(--cnet-primary-500, #82c14f)}.cnet-tab-body{position:relative;display:block}.cnet-tab{display:block;padding:1rem}.cnet-tab.cnet-tab-hidden{display:none}.cnet-tab p{margin:0}@media (max-width: 575.98px){.cnet-tab-header{flex-direction:column;border-bottom:none}}\n"] }]
        }], ctorParameters: () => [{ type: i1$d.Router }, { type: i1$d.ActivatedRoute }], propDecorators: { tabs: [{
                type: ContentChildren,
                args: [CnetTabComponent]
            }], tabsHeader: [{
                type: ViewChildren,
                args: [CnetTabHeaderDirective]
            }] } });

class CnetTabsModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTabsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetTabsModule, declarations: [CnetTabGroupComponent, CnetTabComponent, CnetTabHeaderDirective], imports: [CommonModule,
            CnetRippleModule,
            A11yModule], exports: [CnetTabGroupComponent, CnetTabComponent, CnetTabHeaderDirective, CdkMonitorFocus, A11yModule] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTabsModule, imports: [CommonModule,
            CnetRippleModule,
            A11yModule, A11yModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetTabsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetTabGroupComponent, CnetTabComponent, CnetTabHeaderDirective],
                    imports: [
                        CommonModule,
                        CnetRippleModule,
                        A11yModule,
                    ],
                    exports: [CnetTabGroupComponent, CnetTabComponent, CnetTabHeaderDirective, CdkMonitorFocus, A11yModule],
                }]
        }] });

const toasterAnimations = trigger('fadeAnimation', [
    state('default', style({ opacity: 1 })),
    transition('void => *', [style({ opacity: 0 }), animate('350ms')]),
    transition('default => closing', animate('350ms', style({ opacity: 0 }))),
]);

class CnetToasterRef {
    constructor(overlay, content, time, type, id) {
        this.overlay = overlay;
        this.content = content;
        this.time = time;
        this.type = type;
        this.id = id;
        this.visible = 'true';
    }
    close() {
        this.overlay.dispose();
    }
    isVisible() {
        return this.overlay && !!this.overlay.overlayElement;
    }
    getPosition() {
        return this.overlay.overlayElement.getBoundingClientRect();
    }
}

class CnetToasterComponent {
    constructor(ref, cdr) {
        this.ref = ref;
        this.cdr = cdr;
        this.animationState = 'default';
        this.type = 'default';
        this.id = 'toaster';
    }
    ngOnInit() {
        this.content = this.ref.content;
        this.type = this.ref.type ? this.ref.type : 'default';
        this.id = this.ref.id ? this.ref.id : 'toaster';
        this.intervalId = setTimeout(() => {
            this.animationState = 'closing';
            this.cdr.detectChanges();
        }, this.ref.time);
    }
    ngOnDestroy() {
        clearTimeout(this.intervalId);
    }
    close() {
        this.ref.close();
    }
    closeHandler() {
        this.animationState = 'closing';
    }
    onFadeFinished(event) {
        if (event.toState === 'closing') {
            this.close();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetToasterComponent, deps: [{ token: CnetToasterRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetToasterComponent, selector: "ng-component", host: { attributes: { "role": "alert" }, classAttribute: "cnet-toaster" }, ngImport: i0, template: "<div [id]=\"id\" class=\"toaster-container\" [ngClass]=\"{'background-toaster-success': type === 'success', 'background-toaster-danger': type === 'danger', 'background-toaster-info': type === 'info'}\" [@fadeAnimation]=\"animationState\" (@fadeAnimation.done)=\"onFadeFinished($event)\">\n    <div class=\"toaster-content\" >\n        <span [innerHTML]=\"content\"></span>\n    </div>\n    <button cnet-icon-button [attr.aria-label]=\"'fechar' | translate\" class=\"toaster-close\" (click)=\"closeHandler()\">\n        <cnet-icon name=\"close\" aria-hidden=\"true\"></cnet-icon>\n    </button>\n</div>\n", styles: [".cnet-toaster{display:block}.toaster-container{display:flex;justify-content:space-between;margin:1rem 1rem 0;align-items:center;box-shadow:0 2px 5px #00000042;background-color:#333;color:#fff;border-radius:.25rem;min-width:288px}.toaster-content{display:flex;justify-content:space-between;align-items:center;flex:1;padding:.75rem}.toaster-close{margin-right:.5rem;color:#ffffffab;transform:color ease-in .4s;flex-shrink:0}.toaster-close:hover{color:#fff}.background-toaster-success{background-color:#529e26}.background-toaster-danger{background-color:#e93537}.background-toaster-info{background-color:#2e9cc8}@media (min-width: 768px){.toaster-container{min-width:400px}}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "component", type: CnetButtonComponent, selector: "button[cnet-button], button[cnet-filled-button], button[cnet-stroked-button], button[cnet-icon-button],\n  a[cnet-button], a[cnet-filled-button], a[cnet-stroked-button], a[cnet-icon-button]", inputs: ["disabled", "size", "color"], exportAs: ["cnetButton"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "pipe", type: i1$3.TranslatePipe, name: "translate" }], animations: [toasterAnimations], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetToasterComponent, decorators: [{
            type: Component,
            args: [{ host: {
                        class: 'cnet-toaster',
                        role: 'alert'
                    }, encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.Default, animations: [toasterAnimations], template: "<div [id]=\"id\" class=\"toaster-container\" [ngClass]=\"{'background-toaster-success': type === 'success', 'background-toaster-danger': type === 'danger', 'background-toaster-info': type === 'info'}\" [@fadeAnimation]=\"animationState\" (@fadeAnimation.done)=\"onFadeFinished($event)\">\n    <div class=\"toaster-content\" >\n        <span [innerHTML]=\"content\"></span>\n    </div>\n    <button cnet-icon-button [attr.aria-label]=\"'fechar' | translate\" class=\"toaster-close\" (click)=\"closeHandler()\">\n        <cnet-icon name=\"close\" aria-hidden=\"true\"></cnet-icon>\n    </button>\n</div>\n", styles: [".cnet-toaster{display:block}.toaster-container{display:flex;justify-content:space-between;margin:1rem 1rem 0;align-items:center;box-shadow:0 2px 5px #00000042;background-color:#333;color:#fff;border-radius:.25rem;min-width:288px}.toaster-content{display:flex;justify-content:space-between;align-items:center;flex:1;padding:.75rem}.toaster-close{margin-right:.5rem;color:#ffffffab;transform:color ease-in .4s;flex-shrink:0}.toaster-close:hover{color:#fff}.background-toaster-success{background-color:#529e26}.background-toaster-danger{background-color:#e93537}.background-toaster-info{background-color:#2e9cc8}@media (min-width: 768px){.toaster-container{min-width:400px}}\n"] }]
        }], ctorParameters: () => [{ type: CnetToasterRef }, { type: i0.ChangeDetectorRef }] });

class CnetToasterService {
    constructor(overlay, injector) {
        this.overlay = overlay;
        this.injector = injector;
        this.listToasters = new Array();
    }
    open(content, time = 5000, type, id) {
        const positionStrategy = this.getPositionStrategy();
        const overlayRef = this.overlay.create({ positionStrategy });
        const toasterRef = new CnetToasterRef(overlayRef, content, time, type, id);
        this.lastToaster = toasterRef;
        this.listToasters.push(toasterRef);
        const injector = this.createInjector(toasterRef, this.injector);
        overlayRef.attach(new ComponentPortal(CnetToasterComponent, null, injector));
        return toasterRef;
    }
    createInjector(ref, inj) {
        const injectorTokens = new WeakMap([[CnetToasterRef, ref]]);
        return new PortalInjector(inj, injectorTokens);
    }
    getPositionStrategy() {
        return this.overlay.position()
            .global()
            .right()
            .top(this.getPosition());
    }
    getPosition() {
        const lastToastIsVisible = this.lastToaster && this.lastToaster.isVisible();
        const position = lastToastIsVisible ? this.lastToaster.getPosition().bottom : 0;
        return position + 'px';
    }
    clear() {
        if (this.lastToaster) {
            this.lastToaster.close();
            this.listToasters.pop();
            this.lastToaster = this.listToasters[this.listToasters.length - 1];
        }
    }
    clearAll() {
        if (this.lastToaster && this.listToasters.length) {
            this.listToasters.forEach(toaster => toaster.close());
            this.listToasters = new Array();
        }
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetToasterService, deps: [{ token: i1$5.Overlay }, { token: i0.Injector }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetToasterService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetToasterService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1$5.Overlay }, { type: i0.Injector }] });

class CnetToasterModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetToasterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetToasterModule, declarations: [CnetToasterComponent], imports: [CommonModule,
            OverlayModule,
            A11yModule,
            CnetButtonModule,
            CnetIconModule,
            TranslateModule], exports: [CnetToasterComponent] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetToasterModule, imports: [CommonModule,
            OverlayModule,
            A11yModule,
            CnetButtonModule,
            CnetIconModule,
            TranslateModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetToasterModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CnetToasterComponent
                    ],
                    imports: [
                        CommonModule,
                        OverlayModule,
                        A11yModule,
                        CnetButtonModule,
                        CnetIconModule,
                        TranslateModule
                    ],
                    exports: [
                        CnetToasterComponent
                    ]
                }]
        }] });

class HighlightDirective {
    constructor(el) {
        this.el = el;
        this.customClass = "";
    }
    ngOnChanges(changes) {
        if (changes.searchTerm) {
            this.highlightText();
        }
    }
    highlightText() {
        const element = this.el.nativeElement;
        const text = element.textContent;
        if (!this.searchTerm) {
            element.innerHTML = text;
            return;
        }
        const normalizedText = text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); // Normalize text to remove accents
        const normalizedSearchTerm = this.searchTerm.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); // Normalize search term to remove accents
        const regex = new RegExp(this.escapeRegExp(normalizedSearchTerm), 'gi');
        const frag = document.createDocumentFragment(); // Create a document fragment to hold the new nodes
        let lastIndex = 0;
        let match;
        while ((match = regex.exec(normalizedText)) !== null) {
            const matchedIndex = match.index;
            const unmatchedPart = text.substring(lastIndex, matchedIndex);
            const matchedPart = text.substring(matchedIndex, match.index + match[0].length);
            frag.appendChild(document.createTextNode(unmatchedPart)); // Append unmatched text
            const span = document.createElement('mark');
            span.classList.add('highlight');
            if (this.customClass) {
                span.classList.add(this.customClass);
            }
            span.textContent = matchedPart; // Append matched text wrapped in a span element
            frag.appendChild(span);
            lastIndex = match.index + match[0].length;
        }
        const remainingText = text.substring(lastIndex); // Append remaining unmatched text
        frag.appendChild(document.createTextNode(remainingText));
        // Clear the current content and append the fragment
        element.innerHTML = '';
        element.appendChild(frag);
    }
    escapeRegExp(string) {
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HighlightDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: HighlightDirective, selector: "[cnetHighlight]", inputs: { searchTerm: ["cnetHighlight", "searchTerm"], customClass: "customClass" }, usesOnChanges: true, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HighlightDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[cnetHighlight]'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { searchTerm: [{
                type: Input,
                args: ["cnetHighlight"]
            }], customClass: [{
                type: Input
            }] } });

class HighlightModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HighlightModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: HighlightModule, declarations: [HighlightDirective], imports: [CommonModule], exports: [HighlightDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HighlightModule, imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: HighlightModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        HighlightDirective
                    ],
                    exports: [
                        HighlightDirective
                    ],
                    imports: [
                        CommonModule
                    ]
                }]
        }] });

const modules = [
    CnetButtonModule,
    CnetProgressModule,
    CnetIconModule,
    CnetAlertModule,
    CnetCardModule,
    CnetTableModule,
    CnetBadgeModule,
    CnetListModule,
    CnetDividerModule,
    CnetTabsModule,
    CnetStepperModule,
    CnetAccordionModule,
    CnetFormFieldModule,
    CnetInputModule,
    CnetRadioModule,
    CnetCheckboxModule,
    CnetAvatarModule,
    CnetTooltipModule,
    CnetNavbarModule,
    CnetMenuModule,
    CnetToolbarModule,
    CnetToasterModule,
    CnetDialogModule,
    CnetActionsGroupModule,
    CnetSelectModule,
    CnetCurrencyModule,
    CnetModalModule,
    CnetDatepickerModule,
    CnetPaginationModule,
    ContratanetDynamicFormModule,
    CnetSidenavModule,
    CnetSliderOldModule,
    AscIIToCharModule,
    NormalizeStringModule,
    SanitizerUrlModule,
    RequiredMarkModule,
    CnetPanelModule,
    ConfirmDialogModule,
    CnetDynamicFormModule,
    CnetFileUploadModule,
    CnetImageCropperModule,
    CnetPhoneNumberModule,
    CnetSimpleDynamicFormModule,
    CnetButtonToggleModule,
    PageSideNavContainerModule,
    CnetAutocompleteModule,
    CnetUploadModule,
    CnetChipsModule,
    CnetImageUploadModule,
    CnetClipboardModule,
    HighlightModule,
    CnetFileDropZoneModule,
    CnetInputSwitchModule,
    CnetSliderModule,
    ScrollToTopComponent,
    MatTableModule,
    MatSidenavModule,
    MatIconModule,
    NgxMaskDirective,
    NgxMaskPipe,
    CnetOffcanvasComponent,
    CardSelectModule,
    CnetRippleModule
];
class CnetNgxUiModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNgxUiModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetNgxUiModule, imports: [CnetButtonModule,
            CnetProgressModule,
            CnetIconModule,
            CnetAlertModule,
            CnetCardModule,
            CnetTableModule,
            CnetBadgeModule,
            CnetListModule,
            CnetDividerModule,
            CnetTabsModule,
            CnetStepperModule,
            CnetAccordionModule,
            CnetFormFieldModule,
            CnetInputModule,
            CnetRadioModule,
            CnetCheckboxModule,
            CnetAvatarModule,
            CnetTooltipModule,
            CnetNavbarModule,
            CnetMenuModule,
            CnetToolbarModule,
            CnetToasterModule,
            CnetDialogModule,
            CnetActionsGroupModule,
            CnetSelectModule,
            CnetCurrencyModule,
            CnetModalModule,
            CnetDatepickerModule,
            CnetPaginationModule,
            ContratanetDynamicFormModule,
            CnetSidenavModule,
            CnetSliderOldModule,
            AscIIToCharModule,
            NormalizeStringModule,
            SanitizerUrlModule,
            RequiredMarkModule,
            CnetPanelModule,
            ConfirmDialogModule,
            CnetDynamicFormModule,
            CnetFileUploadModule,
            CnetImageCropperModule,
            CnetPhoneNumberModule,
            CnetSimpleDynamicFormModule,
            CnetButtonToggleModule,
            PageSideNavContainerModule,
            CnetAutocompleteModule,
            CnetUploadModule,
            CnetChipsModule,
            CnetImageUploadModule,
            CnetClipboardModule,
            HighlightModule,
            CnetFileDropZoneModule,
            CnetInputSwitchModule,
            CnetSliderModule,
            ScrollToTopComponent,
            MatTableModule,
            MatSidenavModule,
            MatIconModule,
            NgxMaskDirective,
            NgxMaskPipe,
            CnetOffcanvasComponent,
            CardSelectModule,
            CnetRippleModule], exports: [CnetButtonModule,
            CnetProgressModule,
            CnetIconModule,
            CnetAlertModule,
            CnetCardModule,
            CnetTableModule,
            CnetBadgeModule,
            CnetListModule,
            CnetDividerModule,
            CnetTabsModule,
            CnetStepperModule,
            CnetAccordionModule,
            CnetFormFieldModule,
            CnetInputModule,
            CnetRadioModule,
            CnetCheckboxModule,
            CnetAvatarModule,
            CnetTooltipModule,
            CnetNavbarModule,
            CnetMenuModule,
            CnetToolbarModule,
            CnetToasterModule,
            CnetDialogModule,
            CnetActionsGroupModule,
            CnetSelectModule,
            CnetCurrencyModule,
            CnetModalModule,
            CnetDatepickerModule,
            CnetPaginationModule,
            ContratanetDynamicFormModule,
            CnetSidenavModule,
            CnetSliderOldModule,
            AscIIToCharModule,
            NormalizeStringModule,
            SanitizerUrlModule,
            RequiredMarkModule,
            CnetPanelModule,
            ConfirmDialogModule,
            CnetDynamicFormModule,
            CnetFileUploadModule,
            CnetImageCropperModule,
            CnetPhoneNumberModule,
            CnetSimpleDynamicFormModule,
            CnetButtonToggleModule,
            PageSideNavContainerModule,
            CnetAutocompleteModule,
            CnetUploadModule,
            CnetChipsModule,
            CnetImageUploadModule,
            CnetClipboardModule,
            HighlightModule,
            CnetFileDropZoneModule,
            CnetInputSwitchModule,
            CnetSliderModule,
            ScrollToTopComponent,
            MatTableModule,
            MatSidenavModule,
            MatIconModule,
            NgxMaskDirective,
            NgxMaskPipe,
            CnetOffcanvasComponent,
            CardSelectModule,
            CnetRippleModule] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNgxUiModule, providers: [provideNgxMask()], imports: [CnetButtonModule,
            CnetProgressModule,
            CnetIconModule,
            CnetAlertModule,
            CnetCardModule,
            CnetTableModule,
            CnetBadgeModule,
            CnetListModule,
            CnetDividerModule,
            CnetTabsModule,
            CnetStepperModule,
            CnetAccordionModule,
            CnetFormFieldModule,
            CnetInputModule,
            CnetRadioModule,
            CnetCheckboxModule,
            CnetAvatarModule,
            CnetTooltipModule,
            CnetNavbarModule,
            CnetMenuModule,
            CnetToolbarModule,
            CnetToasterModule,
            CnetDialogModule,
            CnetActionsGroupModule,
            CnetSelectModule,
            CnetCurrencyModule,
            CnetModalModule,
            CnetDatepickerModule,
            CnetPaginationModule,
            ContratanetDynamicFormModule,
            CnetSidenavModule,
            CnetSliderOldModule,
            AscIIToCharModule,
            NormalizeStringModule,
            SanitizerUrlModule,
            RequiredMarkModule,
            CnetPanelModule,
            ConfirmDialogModule,
            CnetDynamicFormModule,
            CnetFileUploadModule,
            CnetImageCropperModule,
            CnetPhoneNumberModule,
            CnetSimpleDynamicFormModule,
            CnetButtonToggleModule,
            PageSideNavContainerModule,
            CnetAutocompleteModule,
            CnetUploadModule,
            CnetChipsModule,
            CnetImageUploadModule,
            CnetClipboardModule,
            HighlightModule,
            CnetFileDropZoneModule,
            CnetInputSwitchModule,
            CnetSliderModule,
            ScrollToTopComponent,
            MatTableModule,
            MatSidenavModule,
            MatIconModule,
            CnetOffcanvasComponent,
            CardSelectModule,
            CnetRippleModule,
            CnetButtonModule,
            CnetProgressModule,
            CnetIconModule,
            CnetAlertModule,
            CnetCardModule,
            CnetTableModule,
            CnetBadgeModule,
            CnetListModule,
            CnetDividerModule,
            CnetTabsModule,
            CnetStepperModule,
            CnetAccordionModule,
            CnetFormFieldModule,
            CnetInputModule,
            CnetRadioModule,
            CnetCheckboxModule,
            CnetAvatarModule,
            CnetTooltipModule,
            CnetNavbarModule,
            CnetMenuModule,
            CnetToolbarModule,
            CnetToasterModule,
            CnetDialogModule,
            CnetActionsGroupModule,
            CnetSelectModule,
            CnetCurrencyModule,
            CnetModalModule,
            CnetDatepickerModule,
            CnetPaginationModule,
            ContratanetDynamicFormModule,
            CnetSidenavModule,
            CnetSliderOldModule,
            AscIIToCharModule,
            NormalizeStringModule,
            SanitizerUrlModule,
            RequiredMarkModule,
            CnetPanelModule,
            ConfirmDialogModule,
            CnetDynamicFormModule,
            CnetFileUploadModule,
            CnetImageCropperModule,
            CnetPhoneNumberModule,
            CnetSimpleDynamicFormModule,
            CnetButtonToggleModule,
            PageSideNavContainerModule,
            CnetAutocompleteModule,
            CnetUploadModule,
            CnetChipsModule,
            CnetImageUploadModule,
            CnetClipboardModule,
            HighlightModule,
            CnetFileDropZoneModule,
            CnetInputSwitchModule,
            CnetSliderModule,
            MatTableModule,
            MatSidenavModule,
            MatIconModule,
            CardSelectModule,
            CnetRippleModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNgxUiModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [...modules],
                    exports: [...modules],
                    declarations: [],
                    providers: [provideNgxMask()]
                }]
        }] });

class CnetNotificationsBellComponent {
    constructor() {
        this.size = 0;
    }
    ngOnInit() { }
    openNotifications(element) {
        this.menu.show(element);
    }
    hide() {
        this.menu.hide();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNotificationsBellComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    /** @nocollapse */ static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.12", type: CnetNotificationsBellComponent, selector: "cnet-notifications-bell", inputs: { size: "size" }, viewQueries: [{ propertyName: "menu", first: true, predicate: ["cnetMenuTeste"], descendants: true }], exportAs: ["cnetNotification"], ngImport: i0, template: "<button type=\"button\" class=\"icon-button\">\n  <cnet-icon cnet-button name=\"bell-o\" size=\"2\">\n  </cnet-icon>\n  <span class=\"icon-button_badge\" *ngIf=\"size > 0\">{{size}}</span>\n</button>\n\n<cnet-menu #cnetMenuTeste class=\"menu-notifications\" cnet-remove-on-scroll>\n  <ng-content></ng-content>\n</cnet-menu>\n", styles: [".icon-button{position:relative;display:flex;align-items:center;justify-content:center;color:#fff;outline:0;background:transparent;border:0px}.icon-button:hover{cursor:pointer}.icon-button:active{background:#ccc}.icon-button_badge{display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;width:22px;height:22px;line-height:21px;text-align:center;border-radius:50%;position:absolute;top:-4px;right:calc(100% - 45px);background-color:#f12f38;color:#fff;font-size:10px;box-sizing:border-box}.menu-notifications{max-width:550px;margin-top:16px}.icon-button:active{background:transparent}.cnet-menu-content .menu-notifications{margin-top:51px;max-width:550px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: CnetIconComponent, selector: "cnet-icon", inputs: ["name", "label", "size", "color"], exportAs: ["cnetIcon"] }, { kind: "component", type: CnetMenuComponent, selector: "cnet-menu", inputs: ["cnet-bottom-sheet", "cnet-overlay", "cnet-remove-on-scroll"], exportAs: ["cnetMenu"] }], changeDetection: i0.ChangeDetectionStrategy.Default, encapsulation: i0.ViewEncapsulation.None }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNotificationsBellComponent, decorators: [{
            type: Component,
            args: [{ selector: 'cnet-notifications-bell', exportAs: 'cnetNotification', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.Default, template: "<button type=\"button\" class=\"icon-button\">\n  <cnet-icon cnet-button name=\"bell-o\" size=\"2\">\n  </cnet-icon>\n  <span class=\"icon-button_badge\" *ngIf=\"size > 0\">{{size}}</span>\n</button>\n\n<cnet-menu #cnetMenuTeste class=\"menu-notifications\" cnet-remove-on-scroll>\n  <ng-content></ng-content>\n</cnet-menu>\n", styles: [".icon-button{position:relative;display:flex;align-items:center;justify-content:center;color:#fff;outline:0;background:transparent;border:0px}.icon-button:hover{cursor:pointer}.icon-button:active{background:#ccc}.icon-button_badge{display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-align:center;align-items:center;width:22px;height:22px;line-height:21px;text-align:center;border-radius:50%;position:absolute;top:-4px;right:calc(100% - 45px);background-color:#f12f38;color:#fff;font-size:10px;box-sizing:border-box}.menu-notifications{max-width:550px;margin-top:16px}.icon-button:active{background:transparent}.cnet-menu-content .menu-notifications{margin-top:51px;max-width:550px}\n"] }]
        }], ctorParameters: () => [], propDecorators: { menu: [{
                type: ViewChild,
                args: ['cnetMenuTeste']
            }], size: [{
                type: Input
            }] } });

/**
 * Directive to create trigger elements to open the cnet-menu
 *
 * @export
 * class CnetNotificationsTriggerDirective
 */
class CnetNotificationsTriggerDirective {
    /**
     * The cnet-menu instance
     *
     * type {CnetNotificationsBellComponent}
     * @memberof CnetNotificationsTriggerDirective
     */
    get menu() { return this.menu; }
    set menu(value) {
        this._menu = value;
    }
    constructor(_element) {
        this._element = _element;
    }
    /**
     * Creates the cnet-menu panel connected to this element
     *
     * @memberof CnetNotificationsTriggerDirective
     */
    showMenu(event) {
        this._menu.openNotifications(event.srcElement);
    }
    onResize(event) {
        this._menu?.hide();
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNotificationsTriggerDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    /** @nocollapse */ static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CnetNotificationsTriggerDirective, selector: "[CnetNotificationsTrigger], [cnet-notifications-trigger]", inputs: { menu: ["cnet-notifications-trigger", "menu"] }, host: { listeners: { "click": "showMenu($event)", "window:resize": "onResize($event)" } }, exportAs: ["CnetNotificationsTrigger"], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNotificationsTriggerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[CnetNotificationsTrigger], [cnet-notifications-trigger]',
                    exportAs: 'CnetNotificationsTrigger'
                }]
        }], ctorParameters: () => [{ type: i0.ElementRef }], propDecorators: { menu: [{
                type: Input,
                args: ['cnet-notifications-trigger']
            }], showMenu: [{
                type: HostListener,
                args: ['click', ['$event']]
            }], onResize: [{
                type: HostListener,
                args: ['window:resize', ['$event']]
            }] } });

class CnetNotificationsBellModule {
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNotificationsBellModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    /** @nocollapse */ static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CnetNotificationsBellModule, declarations: [CnetNotificationsBellComponent, CnetNotificationsTriggerDirective], imports: [CommonModule,
            CnetIconModule,
            CnetMenuModule,
            TranslateModule], exports: [CnetNotificationsBellComponent, CnetNotificationsTriggerDirective] }); }
    /** @nocollapse */ static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNotificationsBellModule, imports: [CommonModule,
            CnetIconModule,
            CnetMenuModule,
            TranslateModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CnetNotificationsBellModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CnetNotificationsBellComponent, CnetNotificationsTriggerDirective],
                    imports: [
                        CommonModule,
                        CnetIconModule,
                        CnetMenuModule,
                        TranslateModule
                    ],
                    exports: [CnetNotificationsBellComponent, CnetNotificationsTriggerDirective],
                }]
        }] });

class NotificationModel {
}

class Country {
}

/*
 * Public API Surface of cnet-ngx-ui
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AscIIToCharModule, AscIIToCharPipe, BadgeListEllipsisComponent, CNET_CARD_SELECT_GROUP, CNET_DATEPICKER_CONTROL_VALUE_ACCESSOR, CNET_RIPPLE_GLOBAL_OPTIONS, CardHeaderComponent, CardSelectComponent, CardSelectFooterDirective, CardSelectFooterItemDirective, CardSelectModule, CdkDetailRowDirective, ClickOutsideDirective, ClickOutsideModule, ClipboardComponent, CnetAccordionComponent, CnetAccordionMode, CnetAccordionModule, CnetAccordionPanelComponent, CnetAccordionPanelHeaderComponent, CnetActionsGroupDirective, CnetActionsGroupModule, CnetAlertComponent, CnetAlertMessageDirective, CnetAlertModule, CnetAlertTitleDirective, CnetAlertType, CnetAutocompleteComponent, CnetAutocompleteContentDirective, CnetAutocompleteDirective, CnetAutocompleteFilterPipe, CnetAutocompleteModule, CnetAutocompleteOptionComponent, CnetAvatarComponent, CnetAvatarModule, CnetBadgeDirective, CnetBadgeModule, CnetButtonComponent, CnetButtonModule, CnetButtonSize, CnetButtonToggleComponent, CnetButtonToggleGroupComponent, CnetButtonToggleModule, CnetCardActionsDirective, CnetCardComponent, CnetCardContentDirective, CnetCardFooterComponent, CnetCardModule, CnetCardSelectSubtitleDirective, CnetCardSelectTitleDirective, CnetCardSubtitleDirective, CnetCardTitleDirective, CnetCellDefDirective, CnetCellDirective, CnetCheckboxComponent, CnetCheckboxGroupComponent, CnetCheckboxModule, CnetChipsComponent, CnetChipsModule, CnetClipboardDirective, CnetClipboardModule, CnetClipboardService, CnetColumnDefDirective, CnetConfirmDialogComponent, CnetConfirmDialogModule, CnetConfirmDialogService, CnetCreateUpdateQuestionComponent, CnetCurrencyModule, CnetDatepickerComponent, CnetDatepickerInputDirective, CnetDatepickerModule, CnetDialogComponent, CnetDialogModule, CnetDialogRef, CnetDialogService, CnetDividerComponent, CnetDividerModule, CnetDynamicFormComponent, CnetDynamicFormModule, CnetDynamicFormQuestionComponent, CnetDynamicListComponent, CnetDynamicListModule, CnetFieldDescriptionDirective, CnetFieldErrorDirective, CnetFieldLabelDirective, CnetFieldPrefixDirective, CnetFieldSuffixDirective, CnetFileDropZoneModule, CnetFileUploadComponent, CnetFileUploadModule, CnetFooterCellDefDirective, CnetFooterCellDirective, CnetFooterPanelComponent, CnetFooterRowComponent, CnetFooterRowDefDirective, CnetFormFieldComponent, CnetFormFieldModule, CnetHeaderCellDefDirective, CnetHeaderCellDirective, CnetHeaderPanelComponent, CnetHeaderRowComponent, CnetHeaderRowDefDirective, CnetI18nDatePipe, CnetIconComponent, CnetIconModule, CnetImageCropperComponent, CnetImageCropperModule, CnetImageUploadComponent, CnetImageUploadModule, CnetInputDirective, CnetInputForInputSwitchDirective, CnetInputForSliderDirective, CnetInputForUploadDirective, CnetInputModule, CnetInputSwitchComponent, CnetInputSwitchModule, CnetListAvatarDirective, CnetListComponent, CnetListDescriptionDirective, CnetListItemComponent, CnetListModule, CnetListSelectDirective, CnetListTitleDirective, CnetMenuComponent, CnetMenuItemComponent, CnetMenuModule, CnetMenuTriggerDirective, CnetModalCloseDirective, CnetModalComponent, CnetModalModule, CnetModalTriggerDirective, CnetNavbarComponent, CnetNavbarItemComponent, CnetNavbarModule, CnetNextStepDirective, CnetNgxUiModule, CnetNoSelectableOptionComponent, CnetNotificationsBellComponent, CnetNotificationsBellModule, CnetNotificationsTriggerDirective, CnetOffcanvas, CnetOffcanvasComponent, CnetOffcanvasRef, CnetOffcanvasService, CnetPaginationComponent, CnetPaginationModule, CnetPanelComponent, CnetPanelModule, CnetPanelTriggerDirective, CnetPhoneNumberComponent, CnetPhoneNumberModule, CnetPreviousStepDirective, CnetProgressDotsComponent, CnetProgressModule, CnetProgressSpinnerComponent, CnetRadioComponent, CnetRadioGroupComponent, CnetRadioModule, CnetRecycleRowsDirective, CnetRippleDirective, CnetRippleModule, CnetRowComponent, CnetRowDefDirective, CnetSelectComponent, CnetSelectModule, CnetSelectOptionComponent, CnetSidenavCloseDirective, CnetSidenavComponent, CnetSidenavItemDirective, CnetSidenavModule, CnetSidenavTriggerDirective, CnetSimpleDynamicFormComponent, CnetSimpleDynamicFormModule, CnetSimpleFormQuestionComponent, CnetSliderComponent, CnetSliderModule, CnetSliderOldComponent, CnetSliderOldModule, CnetSliderOptions, CnetStepComponent, CnetStepHeaderDirective, CnetStepperComponent, CnetStepperModule, CnetTabComponent, CnetTabGroupComponent, CnetTabHeaderDirective, CnetTableComponent, CnetTableModule, CnetTabsModule, CnetToasterComponent, CnetToasterModule, CnetToasterService, CnetToolbarComponent, CnetToolbarModule, CnetTooltipComponent, CnetTooltipDirective, CnetTooltipModule, CnetUploadComponent, CnetUploadLabelDirective, CnetUploadModule, ConfirmDialogComponent, ConfirmDialogModule, ContainerExternalTemplateComponent, ContratanetDynamicFormComponent, ContratanetDynamicFormModule, Country, CreateUpdateQuestionComponent, CurrencyComponent, CurrencyDirective, CurrencyModel, CurrencyService, DescriptiveQuestion, DynamicFormQuestionComponent, ExpandRowDirective, ExternalTemplateContainerComponent, FileComponent, FileDropZoneDirective, FileUploadDropZoneDirective, HighlightDirective, HighlightModule, HighlighterPipe, ImageFileComponent, MAT_DRAWER_CONTAINER, MultiSelectQuestion, NormalizeStringModule, NormalizeStringPipe, NotificationModel, OptionComponent, OptionModule, PageSideNavContainerComponent, PageSideNavContainerModule, PageSidenavComponent, PageSidenavContentComponent, PhoneMaskPipe, PhoneNumberMaskDirective, ProgressBarComponent, QuestionBase, QuestionBaseOld, RadiobuttonQuestion, RequiredMarkDirective, RequiredMarkModule, RippleAnimationConfig, RippleConfig, RippleRef, RippleRenderer, RippleTarget, SanitizerUrlModule, SanitizerUrlPipe, ScrollToTopComponent, SelectCardGroupDirective, SelectOptionCategoryDirective, SingleSelectQuestion, SlidePanelComponent, SlidePanelModule, SliderQuestion, TextareaQuestion, UploadService, accordionToggleAnimation, countries, defaultRippleAnimationConfig, enumArrayOptionDefault, enumQuestionTypeCode, enumQuestionTypeCodeTranslate, enumQuestionTypeCodeTranslated, enumQuestionsTypeAsArray, enumSpecificQuestionsTypeAsArray, overlayClickOutside, stepTransitionAnimation };
